(function() {
  'use strict';

  angular
    .module('nocAngular', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ngRoute', 'ui.bootstrap', 'ui.select','toastr', 'datatables','angular-ladda','angularUtils.directives.dirPagination','cgBusy','chart.js','xeditable','monospaced.elastic','angular-underscore','localytics.directives','angularjs-datetime-picker','ngFileSaver','dndLists']);

})();

(function() {
	'use strict';

	angular
			.module('nocAngular')
			.service('navItems', navItems);

	/** @ngInject */
	function navItems(user, $cookies, $location, $timeout) {

		// So, this exists to filter the menus based on access level and license

		// $log.log(user.data)

		var navItems = {};
		var user_data1 = user

		function init() {
			navItems.leftNavigationItems = []
			// Right Nav Does not Support Flyouts, Supports FA Icons, Functions
			navItems.rightNavigationItems = []
		}

		navItems.rebuild = function() {
			init()
			// Dashboard Access
			navItems.leftNavigationItems.push(
				{"name":"Dashboard", "link":"/"}
			)

			if(user_data1.data.technical_view == "1" || user_data1.data.technical_admin == "1" || user_data1.data.admin == "1"){
				navItems.leftNavigationItems.push(
						{"name":"Support", "link":"#", "subNav":[
							{"name":"Quantum Site Status", "link":"quantumStatus"},
							{"name":"Tickets", "link":"supportTicket"},
							{"name":"Critical Alerts", "link":"critAlerts"}
						]
					}
				)
			}

			if(user_data1.data.estimates == "1" || user_data1.data.estimate_admin == "1" || user_data1.data.admin == "1"){
				navItems.leftNavigationItems.push(
						{"name":"Sales", "link":"#", "subNav":[
							{"name":"Estimator", "link":"estimatorHome"}
						]
					}
				)
			}

			if(user_data1.data.install == "1" || user_data1.data.install_admin == "1" || user_data1.data.admin == "1"){
				navItems.leftNavigationItems.push(
						{"name":"Install", "link":"#", "subNav":[
							{"name":"Install Offers", "link":"installQuoteStart"}
						]
					}
				)
			}

			if(user_data1.data.install_admin == "1" || user_data1.data.admin == "1" || user_data1.data.technical_view == "1"){
				navItems.leftNavigationItems.push(
						{"name":"Third Parties","link":"#","subNav":[
							{"name":"Companies", "link":"subContractorList"},
							{"name":"Users", "link":"subContractorUser"}
						]
					}
				)
			}

			if(user_data1.data.inventory == "1" || user_data1.data.inventory_admin == "1" || user_data1.data.admin == "1"){
				navItems.leftNavigationItems.push(
						{"name":"Inventory", "link":"#", "subNav":[
							{"name":"Receive Goods", "link":"receiveProduct"},
							{"name":"Build Requests", "link":"buildRequests"},
							{"name":"Pick Lists", "link":"buildPickList"},
							{"name":"Product Pricing", "link":"productPricing"}
							// {"name":"Open Order Product Allocation", "link":"openOrderProductAllocation"}
						]
					}
				)
			}

			if(user_data1.data.production == "1" || user_data1.data.production_admin == "1" || user_data1.data.admin == "1"){
				navItems.leftNavigationItems.push(
						{"name":"Production", "link":"#", "subNav":[
							{"name":"Build Requests", "link":"buildOverview"},
							// {"name":"Test Ready Devices", "link":"buildOverview"},
							{"name":"View Test Results", "link":"quantumHardwareTest"},
							// {"name":"Pre Assembly", "link":"#", "flyout":[
							// 	{"name":"DCS Board Test", "link":"boardTest/dcs"},
							// 	{"name":"Pull Cord Board Test", "link":"boardTest/pc/-1"}
							// ]},
							// {"name":"DCS Testing (Version 10)", "link":"#", "flyout":[
							// 	{"name":"DCS (TONTEC) Door Control Test", "link":"productTest/dcs-tontec"},
							// 	{"name":"DCS IO Repeater Test", "link":"productTest/io"},
							// 	{"name":"DCS QSM (System Monitor) Test", "link":"productTest/qsm"},
							// 	{"name":"DCS Enrollment Station Test", "link":"productTest/est"},
							// 	{"name":"DCS (NEOSEC) Door Control Test", "link":"productTest/dcs-neosec"},
							// 	{"name":"DCS (NEOSEC(2)) Door Control Test", "link":"productTest/dcs-neosec2"},
							// 	{"name":"DCS (NEOSEC(3)) Door Control Test", "link":"productTest/dcs-neosec3"},
							// 	{"name":"DCS (NEOSEC(2)) No Screen Test", "link":"productTest/dcs-neo-no-screen"},
							// 	{"name":"DCS Enrollment Station w/Reader Test", "link":"productTest/est-reader"},
							// 	{"name":"Text to Speech Test", "link":"productTest/tts"}
							// ]},
							// {"name":"DCS Testing PI4", "link":"#", "flyout":[
							// 	{"name":"DCS NEOSEC", "link":"productTest/dcs-pi4"},
							// 	{"name":"DCS IO Repeater", "link":"productTest/io-pi4"},
							// 	{"name":"DCS QSM (System Monitor) Test", "link":"productTest/qsm-pi4"},
							// 	{"name":"DCS Enrollment Station Test", "link":"productTest/est-pi4"},
							// 	{"name":"DCS No Screen Test", "link":"productTest/dcs-neo-no-screen-pi4"},
							// 	{"name":"DCS Enrollment Station w/Reader Test", "link":"productTest/est-reader-pi4"},
							// 	{"name":"Text to Speech Test", "link":"productTest/tts-pi4"}
							// ]},
							// {"name":"Other Tests","link":"#","flyout":[
							// 	// {"name":"Stand Alone DCS", "link":"productTest/sad"},
							// 	// {"name":"BLE - WIFI Bridge", "link":"productTest/bridge"},
							// 	{"name":"Pull Cord Test", "link":"productTest/pullCord"}
							// ]},
							{"name":"Internal Tag Reader", "link":"internalTagReader"}
						]
					}
				)
			}

			// navItems.leftNavigationItems.push(
			// 	{"name":"Tasks/Requests", "link":"tasks"}
			// )

			if(user_data1.data.production == "1" || user_data1.data.production_admin == "1" || user_data1.data.inventory == "1" || user_data1.data.inventory_admin == "1" || user_data1.data.technical_view == "1" || user_data1.data.technical_admin == "1" || user_data1.data.admin == "1"){
				navItems.leftNavigationItems.push(
						{"name":"RMA Tools", "link":"#", "subNav":[
							{"name":"Customer RMA", "link":"#","flyout":[
								{"name":"Create RMA","link":"rmaCustomerCreate"},
								{"name":"Search Existing RMA","link":"rmaCustomerSearch/-1"}
							]},
							{"name":"RMA Product Test","link":"#","flyout":[
								{"name":"Pull Cords","link":"rmaPCTest"},
								{"name":"DCS Equipment","link":"rmaDCSTest"}
							]}
						]
					}
				)
			}

			var report_list = []
			var available_reports =  [
				{"name":"Support Reports", "link":"report-technical-landing"},
				{"name":"Sales Reports", "link":"report-sales-landing"},
				{"name":"Procurement Reports", "link":"report-procurement-landing"}
				// {"name":"Install Reports", "link":"report-install-landing"}
			]
			angular.forEach(available_reports,function(element){
				if(user_data1.data.admin == 1){
					report_list.push(element)
				}else if(user_data1.data.technical_view == "1" || user_data1.data.technical_admin == "1" || user_data1.data.production == "1" || user_data1.data.production_admin == "1" || user_data1.data.inventory == "1" || user_data1.data.inventory_admin == "1" || user_data1.data.estimate_admin == "1"){
					if(user_data1.data.technical_view == "1" || user_data1.data.technical_admin == "1"){
						if(element.name == "Support Reports"){
							report_list.push(element)
						}
					}
					if(user_data1.data.production == "1" || user_data1.data.production_admin == "1" || user_data1.data.inventory == "1" || user_data1.data.inventory_admin == "1"){
						if(element.name == "Procurement Reports"){
							report_list.push(element)
						}
					}
					if(user_data1.data.estimate_admin == "1"){
						if(element.name == "Sales Reports"){
							report_list.push(element)
						}
					}
				}
			})
			if(report_list.length > 0){
				navItems.leftNavigationItems.push(
						{"name":"Reports", "link":"#", "subNav":report_list
					}
				)
			}
						

			if(user_data1.data.admin == "1" && user_data1.data.pw_change_required == false){
				navItems.rightNavigationItems.push(
					{"icon":"fa fa-gear", "link":"#","subNav":[
						{"name":"Build Administration", "link":"adminBuild"},
						{"name":"Product Administration", "link":"adminProduct"},
						{"name":"Estimator Administration", "link":"adminEstimator"},
						// {"name":"RMA Administration", "link":"adminRMA"},
						{"name":"User Administration", "link":"adminUser"},
						{"name":"Sales Administration", "link":"adminSales"},
						{"name":"Support Administration", "link":"adminSupport"},
						{"name":"Issue Administration", "link":"adminIssues"},
						{"name":"Misc Settings", "link":"adminSettings"}
					]}
				)
			}
			// Normal User Menu
			navItems.rightNavigationItems.push(
				{"name":user.data.user_full_name, "link":"#", "subNav":[
					{"name":"Change Password", "link":"changePassword"},
					{"name":"Logout", "link":"", "function":function(){
						user.data = {"authKey":null}
						$cookies.remove('user')
						$location.path("/#/login");
					}}
				]}
			)

			if(user.data.pw_change_required){
				navItems.leftNavigationItems = []
			}
		//
		}

		// Run on page load - build navigation if cookie set and no login function runs

		if (user_data1.data) {
			// navItems.rebuild()
			$timeout(navItems.rebuild, 0)
		}
		return navItems

	}

})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .directive('quantumNavbar', quantumNavbar);

  /** @ngInject */
  function quantumNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveNavbar/navbar.html',
      scope: {},
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($log, user, navItems) {
      var vm = this;
      vm.navItems = navItems
      vm.isCollapsed = false;
    }
  }

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('tasksController', tasksController);

	// /** @ngInject */
	function tasksController($log, toastr, noc,user,$location,$routeParams,$timeout,utils) {
		var vm = this;

		var task_id = $routeParams.id;
		vm.patchTimeouts = {};
		vm.availableUsers = [];

		vm.currentPage = 1
		vm.sort_by = "user_full_name"
		vm.sort_order = "ASC"
		vm.searchFor = "user_full_name"
		vm.searchVal = ""
		vm.num_results = 15

		vm.comment_open=false

		vm.formatDate = function(timestamp){
			return utils.toLocalTime(timestamp, 'MMM d, y h:mm:ss a');
		}

		vm.utils = utils

		//
		//CHECKS FOR USER ACTIONS - PERMISSIONS BELOW 
		//
		vm.access_check = function(){
			if (user.data.admin == 1){
				return true
			}else{
				return false
			}

		}

		vm.admin_check = function(){
			if (user.data.admin == 1 || user.data.install_admin == 1){
				return true
			}else{
				return false
			}

		}

		function check_user_availability(array, obj, key) {
			for (var i = 0; i < array.length; i++) {
				if (array[i]['user'][key] === obj['user'][key]) {
					return true; // Found it
				}
			}
			return false; // Not found
		}

		vm.user_check = function(my_id){
			return user.data.user_id === my_id
		}

		vm.user_in_approval = function(){
			var seen = false
			angular.forEach(vm.approvers,function(obj){
				if (obj.user.id == user.data.user_id){
					seen = true
				}
			});
			return seen
		}

		vm.expand_comment_press = function(v){
			$log.log(v)
			if(v == 'y'){
				vm.expand_comments=true
			}else{
				vm.expand_comments=false
			}
		}

		// STATUS DISABLED RULES
		vm.can_update_status = function() {
			if(!vm.admin_check()){
				return false;
			}
			//if status is completed or denied, cannot update
			//elif status is open or approved
			if (vm.submissionObj.status.id === 4 || vm.submissionObj.status.id === 5) {
				return false;
			}else if(vm.submissionObj.status.id === 1 || vm.submissionObj.status.id === 3) {
				return true;
			}
			
			if((!vm.approvers || !vm.approvers.length) && vm.submissionObj.status.id !== 1){
				return false;
			}

			// Return true only if *all* approvers have approved
			if(vm.submissionObj.status.id !== 1){
				var allApproved = vm.approvers.every(function(obj) {
					return obj.approved;
				});
				return allApproved;
			}
			return true
		};

		vm.general_input_disable = function(){
			//Once Completed or closed don't allow edits to data
			if (vm.submissionObj.status.id === 4 || vm.submissionObj.status.id === 5) {
				return true;
			}
			if(vm.admin_check()){
				return false;
			}
		}

		//
		//LOAD OPTIONS, FILL SELECT OPTIONS IF NEEDED
		//
		vm.refreshAvailableUsers = function() {
			// angular.forEach(element => {
			angular.forEach(vm.users,function(user){
				var team_name = "None"
				if (user.team){
					team_name = user.team.name
				}
				var obj = {"approved":false,"user":{"id":user.user_id,"name":user.user_full_name,"team":team_name}}
				var available = check_user_availability(vm.approvers,obj,"id")
				if(!available){
					vm.availableUsers.push(obj)
				}
				
			});
		};

		noc.userInfo.get({"third_party/id":0,"active":true,"system_user":false,"page_size":100}).$promise
		.then(function(data){
			vm.users = data.data
		})

		vm.get_user = function(){
			vm.submissionObj.created_by.id = user.data.user_id
			return user.data.user_full_name
		}

		// Originial build, will auto open ecr, but future, open modal, choose a from different task types
		vm.new = function(){
			$location.path("/tasks-ecr");
		}

		
		function load_options(){
			noc.status.get({"category/id":1}).$promise
			.then(function(data){
				vm.status_options = data.data
			})
			.catch(function(err){
				toastr.warning("Failed to load status options")
				$log.log(err)
			})

			noc.type.get({"category/id":1}).$promise
			.then(function(data){
				vm.types = data.data
			})
			.catch(function(err){
				toastr.warning("Failed to load types")
				$log.log(err)
			})

			noc.priority.get({"category/id":1}).$promise
			.then(function(data){
				vm.priorities = data.data
			})
			.catch(function(err){
				toastr.warning("Failed to load priorities")
				$log.log(err)
			})
		}

		//
		//DEFAULT OBJECTS
		//

		vm.defaultObj={	"id":null,
						"component":null,
						"cost_considerations":null,
						"description":null,
						"disposition_of_stock":null,
						"distributor":null,
						"due_date":null,
						"impact_of_deliverables":null,
						"status":{"id":1},
						"type":{"id":null},
						"priority":{"id":2},
						"created_by":{"id":null},
						"module":null,
						"name":null,
						"next_action":null,
						"owner":null,
						"qa_required":false,
						"reason":null
					}
		vm.submissionObj={	"id":null,
							"component":null,
							"cost_considerations":null,
							"description":null,
							"disposition_of_stock":null,
							"distributor":null,
							"due_date":null,
							"impact_of_deliverables":null,
							"status":{"id":1,"name":"Open"},
							"type":{"id":null},
							"priority":{"id":2},
							"created_by":{"id":null},
							"module":null,
							"name":null,
							"next_action":null,
							"owner":null,
							"qa_required":false,
							"reason":null
						}


		// LOAD INIT TABLE
		function load_data(){
			var obj = {}
			if(vm.searchVal != ""){
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			vm.populatePromise = noc.tasks.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.searchVal = ""
			vm.sort_order = "ASC"
			vm.searchFor = "user_full_name"
			vm.sort_by = "user_full_name"
			vm.num_results = 15
			load_data()
		}

		vm.load_audit = function(){
			vm.audit_promise = noc.audit_log.get({"entity_type":"task","id":vm.submissionObj.id}).$promise
			.then(function(data){
				vm.audit_data = data.data
			})
		}

		vm.load_task = function(t_id){
			noc.tasks.get({"id":t_id}).$promise
			.then(function(data){
				vm.submissionObj = data
				noc.tasks.get({"id":vm.submissionObj.id,"route":"approving-user"}).$promise
				.then(function(data){
					vm.approvers = data.data
					vm.refreshAvailableUsers()
				})
				vm.load_audit()
			})
			.catch(function(err){
				$log.log(err)
			})
		}

		// /		
		// API FUNCTIONS FOR SAVING / UPDATING
		// /
		vm.isPatchDone = function() {
  			return !vm.patchTimeouts || Object.keys(vm.patchTimeouts).length === 0;
		};

		vm.save_new = function(){
			noc.tasks.save(vm.submissionObj).$promise
			.then(function(data){
				$log.log(data)
				//ADD GO TO /:id PAGE TASK PAGE HERE
				$location.path('/tasks-ecr/'+data.id)
			})
			.catch(function(error){
				$log.log(error)
			})
		}

		vm.patch_task = function(col,newValue){
			if(vm.submissionObj.id){
				noc.tasks.patch({"id":vm.submissionObj.id},{"column":col,"value":newValue}).$promise
				.then(function(){
					toastr.success("Save Successful")
					delete vm.patchTimeouts[col]
					vm.load_audit()
				})
				.catch(function(err){
					toastr.warning("Failed to Save "+col)
					$log.log(err)
				})
			}
			
		}

		vm.debouncedPatchTask = function(col,newValue, oldValue) {
			if (vm.submissionObj.id){
				// Only patch if changed
				if (newValue === oldValue) return;

				if (vm.patchTimeouts[col]) $timeout.cancel(vm.patchTimeouts[col]);

				vm.patchTimeouts[col] = $timeout(function() {
					vm.patch_task(col, newValue);
				}, 2000);
			}
		}

		vm.onApproverDrop = function(user) {
			var index = -1;
			for (var i = 0; i < vm.availableUsers.length; i++) {
				if (vm.availableUsers[i].user.id === user.user.id) {
					index = i;
					break;
				}
			}
			if (index > -1) {
				vm.availableUsers.splice(index, 1);
			}

			vm.approvers.push(user);


			noc.tasks.save({"id":vm.submissionObj.id,"route":"approving-user"}, user).$promise
			.then(function(data){
				$log.log(data)
				toastr.success("Approval User Added")
				vm.load_audit()
			})
			.catch(function(err){
				$log.log(err)
			})
		};

		vm.onAvailableDrop = function(user) {
			var index = -1;
			for (var i = 0; i < vm.approvers.length; i++) {
				if (vm.approvers[i].user.id === user.user.id) {
					index = i;
					break;
				}
			}
			if (index > -1) {
				vm.approvers.splice(index, 1);
			}

			vm.availableUsers.push(user);
			
			noc.tasks.delete({"id":vm.submissionObj.id,"route":"approving-user","route_id":user.user.id}).$promise
			.then(function(data){
				$log.log(data)
				toastr.success("Approval User Removed")
				vm.load_audit()
			})
			.catch(function(err){
				$log.log(err)
			})
		};

		vm.patch_approval = function(col,user_id,newValue){
			noc.tasks.patch({"id":vm.submissionObj.id,"route":"approving-user","route_id":user_id},{"column":col,"value":newValue}).$promise
			.then(function(){
				toastr.success("Save Successfully")
				vm.load_audit()
			})
			.catch(function(err){
				toastr.warning("Failed to Save")
				$log.log(err)
			})
		}

		vm.add_comment = function(){
			noc.audit_log.save({"entity_type":"task","id":vm.submissionObj.id},{"comment":vm.comment}).$promise
			.then(function(data){
				$log.log(data)
				toastr.success("Comment added")
				vm.load_audit()
				vm.comment = null
				vm.comment_open=false
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Failed to Save Comment")
			})
		}

		// Load Beginning Set of Data
		load_options()
		if(task_id){
			vm.load_task(task_id)
		}else{
			load_data()
		}
	}


})();

(function() {
  'use strict';

  angular
  .module('nocAngular')
  .controller('supportTicketController', supportTicketController);

//   /** @ngInject */
  function supportTicketController(toastr, noc, $scope, $q, $uibModal, $log, user,$routeParams,$location,searchFilters) {
    var vm = this;

    vm.ticket_id = $routeParams.id

    vm.tv = false
    vm.remoteSupport = false
    vm.fixedIssue = false

    vm.searchCustomer = function(){
      var format_name = '"%'+vm.customerTextSearch+'%"'
      noc.customers.get({"name":format_name,"page_size":100}).$promise
      .then(function(data){
        searchFilters.ticketSearchParams.searchText = vm.customerTextSearch
        vm.searchResults = data.data
        if (vm.searchResults.length > 1){
          vm.modalInstance = $uibModal.open({
            templateUrl: 'customerChoice.html',
            scope: $scope,
            size: 'lg'
          });
        }else{
          if(vm.searchResults.length > 0){
            vm.openCustomer(vm.searchResults[0]['id'],true,false)
          }else{
            toastr.warning("No results found")
          }
        }
      })
    }

    vm.customerTextSearch = searchFilters.ticketSearchParams.searchText
    if(vm.customerTextSearch && !vm.ticket_id){
      vm.searchCustomer(searchFilters.ticketSearchParams.searchText)
    }

    var userData = user
    vm.defaultObject = {"id":null,"company":{"id":null},"summary":null,"status":{},"board":{},"type":{},"agreement":null,"contactName":"","contactPhoneNumber":""}

    function buildDefaultTime(){
      return {"id":null,"chargeToType":"ServiceTicket","member":{"id":userData.data.connectwise_id},"timeStart":{"viewFormat":null,'pickerFormat':null},"timeEnd":{"viewFormat":null,'pickerFormat':null},"notes":"","itemId":vm.ticket_id,"timeType":{"id":1}}
    }

    vm.userCheck = function(key){
      if(vm.time_entry_array[key].enteredBy.id != userData.data.user_id){
        return true;
      }else{
        return false;
      }
    }
    
    vm.all_resolutions = []
    vm.selectable_resolutions = []
    noc.issue.get({"route":"resolution","page_size":1000}).$promise
    .then(function(data){
      angular.forEach(data.data,function(obj){
        if (obj.active){
          vm.selectable_resolutions.push(obj)
        }
        vm.all_resolutions.push(obj)
      })
      vm.resolutions = data
    })

    if (vm.ticket_id){
      $log.log(vm.ticket_id)
      noc.ticket.get({"id":vm.ticket_id}).$promise
      .then(function(data){
        vm.ticketObject = data

        vm.lastSave = angular.copy(data)
        vm.openCustomer(data.company.id,false)
        vm.timeTypes = noc.ticket_time_options.query({"route":"types"})
        vm.timeRoles = noc.ticket_time_options.query({"route":"roles"})
        load_time_entries()
        load_issues()
        noc.issue.get({"route":"top-level","ticket_relevant":true,"active":true}).$promise
        .then(function(top_issues){
          vm.top_level_issues = top_issues.data
        })
        noc.connectwise_routes.get({"route":"ticket","id":data.connectwise_id}).$promise
        .then(function(connectwise_ticket_data){
          vm.connectwiseStatus = connectwise_ticket_data.closedFlag
        })
      })
    }

    vm.loadTicket = function(t_id){
      $location.path('/supportTicketUpdate/'+t_id)
    }

    vm.ticketObjectCheck = function(){
      if(angular.equals(vm.ticketObject,vm.lastSave)){
        return true
      }else{
        return false
      }
    }


    function load_time_entries(){
      vm.totalEntryTime = 0;
      vm.time_entry_load = noc.time_entry.get({"itemId":vm.ticket_id,"timeType":1}).$promise
      .then(function(data){
        vm.time_entry_array = data.data
        angular.forEach(data.data,function(element){
          var tt = (new Date(element.timeEnd.viewFormat) - new Date(element.timeStart.viewFormat))/1000/60
          element.entryTime = tt
          vm.totalEntryTime += tt
        })
      })
    }

    function load_issues(){
      noc.ticket.get({"id":vm.ticket_id,"route":"issue"}).$promise
      .then(function(data){
        vm.existingIssues = data.data
        vm.calcMinutes()
      })
    }

    vm.loadSecondLevel = function(top_id,is_edit){
      noc.issue.get({"issue_id":top_id,"route":"related"}).$promise
      .then(function(data){
        $log.log(data)
        vm.secondLevelList = data.data
        //Below is for if the second level belongs to the class that was changed, it stays, if that ID is not associated with the new class, wipe it out
        var a = true
        $log.log(is_edit)
        if (!is_edit){
          angular.forEach(data.data,function(element){
            if (element.second_level_id == vm.newOpenIssue.second_level_id){
              a = false
            }
          })
          if(a){
            vm.newOpenIssue.second_level_id = null
          }
        }
        else{
          $log.log("HELLO")
          angular.forEach(data.data,function(element){
            if (element.second_level_id == vm.editIssueObject.second_level.id){
              a = false
            }
          })
          if(a){
            vm.editIssueObject.second_level.id = null
          }
        }
        
      })
    }



    vm.searchID = function(){
      noc.ticket.get({"id":vm.ticketIDSearch}).$promise
      .then(function(data){
        vm.loadTicket(data.id)
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning(err.data.errors)
      })
    }
    vm.opened = false
    
    vm.openCustomer = function(id,setDefault,closeModal){
      vm.special_statuses = []
      var need_special = false
      vm.availableContacts = []
      searchFilters.ticketSearchParams.customer_id = id
      noc.customers.get({"id":id}).$promise
      .then(function(customer_data){
        vm.selectedCustomer = customer_data
        // $log.log(customer_data)
        searchFilters.ticketSearchParams.searchText = customer_data.name
        if(!vm.ticket_id){
          noc.connectwise_routes.get({"route":"company-status","id":customer_data.connectwise_id}).$promise
          .then(function(status){
            if(status.status.id==20){
              noc.connectwise_routes.query({"route":"company-notes","id":customer_data.connectwise_id}).$promise
              .then(function(notes){
                angular.forEach(notes,function(obj){
                  if(obj.status.id==20){
                    vm.special_statuses.push(obj.customNote)
                    need_special = true
                  }
                })
                if(need_special && !vm.opened){
                  vm.modalInstance = $uibModal.open({
                    templateUrl: 'customNotes.html',
                    scope: $scope,
                    size: 'lg'
                  });
                  vm.opened = true
                }
              })
            }
          })
        }
        if(setDefault){
          vm.ticketObject = angular.copy(vm.defaultObject)
          vm.selectedContact = null
          vm.ticketObject.company.id=customer_data.connectwise_id
          load_boards(true)
          vm.newTicket = false;
          if(closeModal){
            vm.modalInstance.dismiss();
          }
          angular.forEach(customer_data.contacts,function(element){
            vm.availableContacts.push({"id":element.id,"name":element.first_name+' '+element.last_name,"phone":element.contact_phone})
          })
          noc.ticket.get({"company/id":customer_data.connectwise_id,"page_size":10,"sort_order":"DESC"}).$promise
          .then(function(recent_ticket){
            vm.recentTickets = recent_ticket.data
          })


        }else{
          $log.log("Here")
          load_boards(false)
          vm.load_statuses(false)
        }
      })
    }

    vm.updateContact = function(){
      vm.ticketObject.contactName = vm.selectedContact.name
      vm.ticketObject.contactPhoneNumber = vm.selectedContact.phone
    }

    function load_boards(setDefault){
      vm.boards = []
      noc.connectwise_routes.query({"route":"ticket-board-options"}).$promise
      .then(function(data){
        angular.forEach(data,function(element){
          var obj = {"id":element.id,"name":element.name}
          if(element.inactiveFlag || element.projectFlag){
            // $log.log("here")
          }else{
            vm.boards.push(obj)
          }
          if(setDefault){
            if(element.id == 22){
              vm.ticketObject.board = obj
              vm.load_statuses(true)
            }
          }
        })
      });
    }

    vm.load_statuses = function(setDefault){
      vm.statuses = []
      if(setDefault){
        vm.ticketObject.status = null;
        vm.ticketObject.type = null;
      }
      noc.connectwise_routes.query({"route":"ticket-status-options","id":vm.ticketObject.board.id}).$promise
      .then(function(data){
        angular.forEach(data,function(element){
          var obj = {"id":element.id,"name":element.name}
          if(!element.inactive){
            vm.statuses.push(obj)
          }
          if(setDefault){
            if(element.id == 446){
              vm.ticketObject.status = obj
            }
          }
        })
      })

      if(vm.selectedCustomer){
        vm.types = []
        noc.connectwise_routes.query({"route":"ticket-type-options","id":vm.ticketObject.board.id}).$promise
        .then(function(data){
            angular.forEach(data,function(element){
              var obj = {"id":element.id,"name":element.name}
              if(!element.inactive){
                vm.types.push(obj)
              }
              if(setDefault){
                if(vm.selectedCustomer.quantum_customer.quantum_system){
                  if(element.id == 265){
                    vm.ticketObject.type = obj
                  }
                }else{
                  if(element.id == 231){
                    vm.ticketObject.type = obj
                  }
                }
              }
            })
          })

        if(setDefault){
          vm.agreements = []
          noc.connectwise_routes.query({"route":"company-agreement","id":vm.selectedCustomer.connectwise_id}).$promise
          .then(function(data){
            angular.forEach(data,function(element,key){
              var obj = {"id":element.id,"name":element.name}
              vm.agreements.push(obj)
              if(key == 0){
                vm.ticketObject.agreement = obj
              }
            })
          })
        }
      }
    }


    vm.startTicket = function(){
      if(vm.ticketObject.contactName){
        vm.start_ticket_promise = noc.connectwise_routes.save({"route":"ticket"},vm.ticketObject).$promise
        .then(function(data){
          $log.log(data)
          var connectwise_ticket_id = data.id
          vm.ticketObject.connectwise_ticket_id = connectwise_ticket_id
          noc.ticket.save(vm.ticketObject).$promise
          .then(function(quantumData){
            $log.log(quantumData)
            $location.path("/supportTicketUpdate/"+quantumData.id)
          })
          .catch(function(err){
            $log.log(err)
            toastr.warning("Ticket Failed to Save to Portal, Contact Drew")
          })
        })
        .catch(function(err){
          $log.log(err)
          toastr.warning("Ticket Failed to Save to Connectwise, Contact Drew")
        })
      }else{
        toastr.warning("You must type a contact")
      }
    }



    vm.openTime = function(){
      vm.newTimeEntryObject = buildDefaultTime()
      var dateOptions = {  year: '2-digit',month: '2-digit', day: '2-digit'};
      var timeOptions = { hour:'2-digit', minute:'2-digit'}
      var now = new Date();

      vm.newTimeEntryObject.timeStart.pickerFormat = now.toLocaleString('en', dateOptions) + " " + now.toLocaleTimeString('en', timeOptions);
      $log.log(vm.ticketObject)
      vm.newTimeEntryObject.chargeToId = vm.ticketObject.connectwise_id
      vm.newTimeEntryObject.workType = vm.timeTypes[0]
      vm.newTimeEntryObject.role = vm.timeRoles[0]

    }

    vm.getNow = function(location,form){
      var dateOptions = {  year: '2-digit',month: '2-digit', day: '2-digit'};
      var timeOptions = { hour:'2-digit', minute:'2-digit'}
      var now = new Date();

      if (location == 'end'){
        if(form == 'edit'){
          vm.editTimeObject.timeEnd.pickerFormat = now.toLocaleString('en', dateOptions) + " " + now.toLocaleTimeString('en', timeOptions);
        }else{
          vm.newTimeEntryObject.timeEnd.pickerFormat = now.toLocaleString('en', dateOptions) + " " + now.toLocaleTimeString('en', timeOptions);
        }
      }else if (location == 'start') {
        vm.newTimeEntryObject.timeStart = now.toLocaleString('en', dateOptions) + " " + now.toLocaleTimeString('en', timeOptions);
      }

    }

    vm.cancelNewTime = function(){
      vm.newTimeEntryObject = null
    }

    vm.openIssue = function(){
      vm.newIssue = true
      vm.newOpenIssue = {"role":null,"top_level":{"id":null},"second_level":{"id":null},"resolution":null,"notes":"","minutes":0}
      // vm.newOpenIssue.ticketId = vm.ticket_id
    }

    vm.calcMinutes = function(){
      var allocated_minutes = 0
      if(vm.newOpenIssue){
        allocated_minutes = vm.newOpenIssue.minutes
      }
      angular.forEach(vm.existingIssues,function(element){
        // allocated_minutes += element.minutes
        if(element.additional_times.length){
          angular.forEach(element.additional_times,function(add_time_entry){
            allocated_minutes += add_time_entry.minutes
          })
        }
      })

      vm.totalAllocatedTime = allocated_minutes
    }

    vm.timeEntryValid = function(obj){
      vm.errors = []
      vm.error_keys = []
      if (obj){
        if (obj.timeStart.pickerFormat){
          try{
           new Date(obj.timeStart.pickerFormat).toISOString()
          }catch(err){
           vm.errors.push('Start Time is not a valid Date Time')
           vm.error_keys.push('startTime')
          }
        }else{
          vm.errors.push('Start Time cannot be empty')
          vm.error_keys.push('startTime')
        }
        if (obj.timeEnd.pickerFormat){
          try{
           new Date(obj.timeEnd.pickerFormat).toISOString()
          }catch(err){
           vm.errors.push('End Time is not a valid Date Time')
           vm.error_keys.push('endTime')
          }
        }else{
          vm.errors.push('End Time cannot be empty')
          vm.error_keys.push('endTime')
        }
        if(!vm.errors.length){
          var duration = (new Date(obj.timeEnd.pickerFormat) - new Date(obj.timeStart.pickerFormat))/1000/60
          if (duration <= 0){
            vm.errors.push('End Time must be greater than Start Time')
            vm.error_keys.push('startTime')
            vm.error_keys.push('endTime')
          }
          if(!obj.notes.length){
            vm.errors.push("Notes cannot be empty")
            vm.error_keys.push('notes')
          }
        }
      }
      if(!vm.errors.length){
        if(obj.id){
          updateTime(obj)
        }else{
          saveTime(obj)
        }
      }else{
        angular.forEach(vm.errors,function(element){
          toastr.warning(element)
        })
      }
    }

    function saveTime(obj){
      obj.timeStart.viewFormat = new Date(obj.timeStart.pickerFormat).toISOString().split('.')[0]+"Z";
      obj.timeEnd.viewFormat = new Date(obj.timeEnd.pickerFormat).toISOString().split('.')[0]+"Z";
      var connectwiseTimeObject = angular.copy(obj);
      connectwiseTimeObject.timeStart = obj.timeStart.viewFormat;
      connectwiseTimeObject.timeEnd = obj.timeEnd.viewFormat;
      delete connectwiseTimeObject.role;
      delete connectwiseTimeObject.itemId;
      delete connectwiseTimeObject.timeType;

      vm.update_ticket_promise = noc.connectwise_routes.save({"route":"time"},connectwiseTimeObject).$promise
      .then(function(data){
        obj.connectwiseTimeId = data.id;
        noc.time_entry.save(obj).$promise
        .then(function(){
          vm.newTimeEntryObject = null;
          toastr.success("SAVE SUCCESSFUL")
          load_time_entries()
        })
        .catch(function(err){
          $log.log(err)
          toastr.warning("DID NOT SAVE TO PORTAL, DID SAVE TO CONNECTWISE CONTACT DREW")
        })
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("COULD NOT SAVE TO CONNECTWISE, PLEASE CONTACT DREW")
      })
    }

    function updateTime(obj){
      obj.timeStart.viewFormat = new Date(obj.timeStart.pickerFormat).toISOString().split('.')[0]+"Z";
      obj.timeEnd.viewFormat = new Date(obj.timeEnd.pickerFormat).toISOString().split('.')[0]+"Z";
      var connectwiseTimeObject = angular.copy(obj);
      connectwiseTimeObject.timeStart = obj.timeStart.viewFormat;
      connectwiseTimeObject.timeEnd = obj.timeEnd.viewFormat;
      delete connectwiseTimeObject.role;
      delete connectwiseTimeObject.itemId;

      vm.update_ticket_promise = noc.connectwise_routes.update({"route":"update-time","id":obj.connectwiseTimeId},connectwiseTimeObject).$promise
      .then(function(){
        //obj.connectwiseTimeId = data.id;
        noc.time_entry.update({"id":obj.id},obj).$promise
        .then(function(){
          delete vm.editActive
          vm.editTimeObject = null;
          toastr.success("SAVE SUCCESSFUL")
          load_time_entries()
        })
        .catch(function(err){
          $log.log(err)
          toastr.warning("DID NOT SAVE TO PORTAL, DID SAVE TO CONNECTWISE CONTACT DREW")
        })
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("COULD NOT SAVE TO CONNECTWISE, PLEASE CONTACT DREW")
      })
    }

    vm.issueEntryValid = function(obj){
      $log.log(obj)
      var errors = []
      // if(obj.role == null){
      //   errors.push("Role cannot be left blank")
      // }
      if(obj.top_level.id == null){
        errors.push("Class cannot be left blank")
      }
      if(obj.second_level.id == null){
        errors.push("Issue / Action cannot be left blank")
      }
      // if(obj.resolution == null){
      //   errors.push("Resolution cannot be left blank")
      // }
      // if(obj.minutes < 1){
      //   errors.push("Minimun for minutes is 1")
      // }
      if(!obj.notes.length){
        errors.push("Notes cannot be empty")
      }
      if(!errors.length){
        if(obj.id){
          updateIssue(obj)
          //$log.log(obj)
        }else{
          saveIssue(obj)
          //$log.log(obj)
        }
      }else{
        angular.forEach(errors,function(element){
          toastr.warning(element)
        })
      }
    }

    function saveIssue(obj){
      noc.ticket.save({"route":"issue","id":vm.ticketObject.id},obj).$promise
      .then(function(){
        toastr.success("SAVE SUCCESSFUL")
        load_issues()
        vm.newIssue = false
        vm.newOpenIssue = {"role":null,"top_level":{"id":null},"second_level":{"id":null},"resolution":null,"notes":"","minutes":0}
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("SAVE NOT SUCCESSFUL")
      })
    }

    function updateIssue(obj){
      noc.ticket.update({"id":vm.ticketObject.id,"route":"issue","route_id":obj.id},obj).$promise
      .then(function(data){
        $log.log(data)
        toastr.success("SAVE SUCCESSFUL")
        vm.editActive = false
        vm.editIssueObject = null
        load_issues()
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("SAVE NOT SUCCESSFUL")
      })
    }

    vm.saveTicketUpdates = function(){
      if(vm.ticketObject.contactName){
        vm.update_ticket_promise = noc.connectwise_routes.update({"route":"update-ticket","id":vm.ticketObject.connectwise_id},vm.ticketObject).$promise
        .then(function(){
          noc.ticket.update({"id":vm.ticketObject.id},vm.ticketObject).$promise
          .then(function(){
            toastr.success("Saved ticket")
          })
        })
        .catch(function(){
          toastr.warning("Failed to Save to Connectwise")
        })
      }else{
        toastr.warning("Must have a contact name")
      }
    }

    vm.editTimeEntry = function(k){
      vm.editTimeObject = vm.time_entry_array[k]
      vm.editActive = true
    }
    vm.cancelEdit = function(){
      vm.editActive = false
    }
    vm.editIssue = function(k){
      vm.editIssueObject = vm.existingIssues[k]
      vm.loadSecondLevel(vm.editIssueObject.top_level.id,true)
      vm.editActive = true
    }
    vm.addTimeToIssue = function(k){
      vm.addTimeIssueObject = vm.existingIssues[k]
      vm.modalInstance = $uibModal.open({
        templateUrl: 'addTimeIssue.html',
        scope: $scope,
        size: 'lg'
      });
    }

    function clear_vars(){
      vm.additional_minutes = 0
      vm.additional_notes = null
      vm.additional_role = null
      vm.additional_resolution = null
      vm.tv = false
      vm.remoteSupport = false
      vm.fixedIssue = false
    }

    vm.saveAddtionalTime = function(update){
      var errors = []

      var t = vm.additional_minutes
      var n = vm.additional_notes
      var r = vm.additional_role
      var res = vm.additional_resolution
      var tv = vm.tv
      var rs = vm.remoteSupport
      var fi = vm.fixedIssue
      if(!t || t <= 0){
        errors.push("Minutes Must be greater than 0")
      }
      if(!n || n.length <= 0){
        errors.push("Notes cannot be empty")
      }
      if(!r){
        errors.push("Role must be selected")
      }
      if(!res){
        errors.push("Resolution must be selected")
      }

      if(errors.length == 0){
        var p
        if(!update){
          var i = vm.addTimeIssueObject.id
          var obj = {"minutes":t,"resolution":{"id":res},"role":{"id":r},"notes":n,"used_tv":tv,"used_remote":rs,"fixed_issue":fi}
          $log.log(obj)
          p = noc.ticket.save({"id":vm.ticket_id,"route":"issue","route_id":i,"extended_route":"issue-time"},{"minutes":t,"resolution":{"id":res},"role":{"id":r},"notes":n,"used_tv":tv,"used_remote":rs,"fixed_issue":fi}).$promise
        }else{
          $log.log(fi)
          p = noc.ticket.update({"id":vm.ticket_id,"route":"issue","route_id":vm.active_issue_obj.ticket_issue_id,"extended_route":"issue-time","extended_route_id":vm.active_issue_obj.id},{"minutes":t,"resolution":{"id":res},"role":{"id":r},"notes":n,"used_tv":tv,"used_remote":rs,"fixed_issue":fi}).$promise
        }
        p.then(function(){
          vm.modalInstance.dismiss();
          toastr.success("Save Successful")
          load_issues()
          clear_vars()
        }).catch(function(){
          toastr.warning("Save Unsuccessful")
        })
      }else{
        angular.forEach(errors,function(element){
          toastr.warning(element)
        })
      }

    }
    vm.editIssueTime = function(a,b){
      // $log.log(a)
      // $log.log(b)
      vm.active_issue_obj = vm.existingIssues[a]['additional_times'][b]

      vm.additional_minutes = vm.active_issue_obj.minutes
      vm.additional_notes = vm.active_issue_obj.notes
      vm.additional_role = vm.active_issue_obj.role.id
      vm.additional_resolution = vm.active_issue_obj.resolution.id
      vm.tv = vm.active_issue_obj.used_tv
      vm.remoteSupport = vm.active_issue_obj.used_remote
      vm.fixedIssue = vm.active_issue_obj.fixed_issue

      vm.modalInstance = $uibModal.open({
        templateUrl: 'editTimeIssue.html',
        scope: $scope,
        size: 'lg'
      });

    }

    vm.close_open_modal = function(){
      vm.modalInstance.dismiss();
    }

  }
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('supportAdminLinuxController', supportAdminLinuxController);

	/** @ngInject */
	function supportAdminLinuxController($log, $location,toastr, noc) {
		var vm = this;
		vm.submissionObj = null;

		function load_data(){
			var obj = {}
			if(vm.searchVal != ""){
				obj = {"include_with_quantum":true,"active":true}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"active":true,"include_with_quantum":true}
			}
			noc.thirdParty.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.update = function(){
			vm.submissionObj.update_linux_data = true
			noc.thirdParty.update({id:vm.submissionObj.id},vm.submissionObj).$promise
			.then(function(){
				toastr.success("Save Successful")
				vm.submissionObj = null
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Save Unsuccessful")
			})
		}

		vm.cancel = function(){
			vm.submissionObj=null;
		}

		load_data()

		vm.load_user = function(i){
			vm.submissionObj = vm.data.data[i]
			$log.log(vm.submissionObj)
			
		}

	}	

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('subContractorUserController', subContractorUserController);

	// /** @ngInject */
	function subContractorUserController($log, toastr, noc,$uibModal, $scope,user) {
		var vm = this;

		vm.currentPage = 1
		vm.sort_by = "user_full_name"
		vm.sort_order = "ASC"
		vm.searchFor = "user_full_name"
		vm.searchVal = ""
		vm.num_results = 15

		vm.access_check = function(){
			if (user.data.admin == 1){
				return true
			}else{
				return false
			}

		}

		vm.admin_check = function(){
			if (user.data.admin == 1 || user.data.install_admin == 1){
				return true
			}else{
				return false
			}

		}

		var defaultObj = {"id":null,"name":null,"address":null,"phone":null,"state":{},"zip":null,"city":null,"notes":null,"sells_things": false, "installs_things": false,"connectwise_location_id":null,"tv_password":null}
		vm.submissionObj = {"id":null,"name":null,"address":null,"phone":null,"state":{},"zip":null,"city":null,"notes":null}
		var defaultUser = {
			"access_level": 0,
			"active": true,
			"email_actions": [],
			"installs_things": false,
			"on_call_device": 0,
			"phone": null,
			"primary_function": null,
			"sells_things": false,
			"third_party_info": {
				"admin": false,
				"id": null,
				"name": ""
			},
			"transaction_id": null,
			"user_email": null,
			"user_full_name": null,
			"user_id": null,
			"user_name": null,
			"uuid": null,
			"wp_id": null,
			"years": []
		}

		function load_locations(){
			vm.connectwise_location_data = []
			noc.connectwise_routes.query({"route":"locations"}).$promise
			.then(function(data){
				angular.forEach(data,function(element){
					if(element.location_flag){
						if(element.id == vm.submissionObj.connectwise_location_id){
							vm.connectwise_location_data.push(element)
						}else{
							if(!element.in_use){
								vm.connectwise_location_data.push(element)
							}
						}
					}
				})
			})
		}
		vm.stateList = noc.states.query()


		function load_data(){
			var obj = {}
			if(vm.searchVal != ""){
				obj = {"active":true,"third_party/id":"!0","page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"active":true,"third_party/id":"!0","page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			noc.userInfo.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.searchVal = ""
			vm.sort_order = "ASC"
			vm.searchFor = "user_full_name"
			vm.sort_by = "user_full_name"
			vm.num_results = 15
			load_data()
		}


		load_data()

	}


})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('subContractorListController', subContractorListController);

	// /** @ngInject */
	function subContractorListController($log, toastr, noc,$uibModal, $scope,user) {
		var vm = this;

		vm.currentPage = 1
		vm.sort_by = "name"
		vm.sort_order = "ASC"
		vm.searchFor = "name"
		vm.searchVal = ""
		vm.num_results = 15

		vm.access_check = function(){
			if (user.data.admin == 1){
				return true
			}else{
				return false
			}

		}

		vm.admin_check = function(){
			if (user.data.admin == 1 || user.data.install_admin == 1){
				return true
			}else{
				return false
			}

		}

		var defaultObj = {"id":null,"name":null,"address":null,"phone":null,"state":{},"zip":null,"city":null,"notes":null,"sells_things": false, "installs_things": false,"connectwise_location_id":null,"tv_password":null}
		vm.submissionObj = {"id":null,"name":null,"address":null,"phone":null,"state":{},"zip":null,"city":null,"notes":null}
		var defaultUser = {
			"access_level": 0,
			"active": true,
			"email_actions": [],
			"installs_things": false,
			"on_call_device": 0,
			"phone": null,
			"primary_function": null,
			"sells_things": false,
			"third_party_info": {
				"admin": false,
				"id": null,
				"name": ""
			},
			"transaction_id": null,
			"user_email": null,
			"user_full_name": null,
			"user_id": null,
			"user_name": null,
			"uuid": null,
			"wp_id": null,
			"years": []
		}

		function load_locations(){
			vm.connectwise_location_data = []
			noc.connectwise_routes.query({"route":"locations"}).$promise
			.then(function(data){
				angular.forEach(data,function(element){
					if(element.location_flag){
						if(element.id == vm.submissionObj.connectwise_location_id){
							vm.connectwise_location_data.push(element)
						}else{
							if(!element.in_use){
								vm.connectwise_location_data.push(element)
							}
						}
					}
				})
			})
		}
		vm.stateList = noc.states.query()


		function load_data(){
			var obj = {}
			if(vm.searchVal != ""){
				obj = {"include_with_quantum":false,"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			noc.thirdParty.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.searchVal = ""
			vm.sort_order = "ASC"
			vm.searchFor = "name"
			vm.sort_by = "name"
			vm.num_results = 15
			load_data()
		}

		vm.back = function(){
			vm.submissionObj = angular.copy(defaultObj,vm.submissionObj)
			vm.activeUser = angular.copy(defaultUser,vm.activeUser)
		}

		vm.loadSub = function(id){
			vm.userList = []
			vm.submissionObj = noc.thirdParty.get({id:id})
			noc.userInfo.get({"third_party/id":id,"active":true,"page_size":100}).$promise
			.then(function(data){
				vm.userList = data
				// data = r_data.data
				// angular.forEach(data,function(element){
				// 	if(element.active){
				// 		vm.userList.push(element)
				// 	}
				// })
				load_locations()
			})
		}

		vm.update = function(){
			noc.thirdParty.update({id:vm.submissionObj.id},vm.submissionObj).$promise
			.then(function(){
				toastr.success("Save Successful")
				vm.submissionObj.update_linux_data = false
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Save Unsuccessful")
				vm.submissionObj.update_linux_data = false
			})
		}

		vm.addNew = function(){
			vm.new = true
			vm.submissionObj = angular.copy(defaultObj,vm.submissionObj)
		}

		vm.cancel = function(){
			vm.new = false
			vm.submissionObj = angular.copy(defaultObj,vm.submissionObj)
		}

		vm.save = function(){
			noc.thirdParty.save(vm.submissionObj).$promise
			.then(function(){
				toastr.success("Save Successful")
				vm.new = false
				load_data()
				vm.back()
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Save Unsuccessful")
			})
		}

		vm.remove = function(){
			noc.thirdParty.delete({id:vm.submissionObj.id}).$promise
			.then(function(){
				toastr.success("Success")
				load_data()
				vm.back()
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Not Successful")
			})

		}

		vm.addUser = function(){
			vm.activeUser = angular.copy(defaultUser,vm.activeUser)
			vm.activeUser.sells_things = vm.submissionObj.sells_things
			vm.activeUser.installs_things = vm.submissionObj.installs_things
			vm.activeUser.third_party_info.id = vm.submissionObj.id
			vm.modalInstance = $uibModal.open({
				templateUrl: 'editUser.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.editUser = function(key){
			vm.activeUser = vm.userList.data[key]

				vm.modalInstance = $uibModal.open({
					templateUrl: 'editUser.html',
					scope: $scope,
					size: 'lg'
				});
		}

		vm.saveUser = function(){
			var p
			if(vm.activeUser.user_id){
				p = noc.userInfo.update({"id":vm.activeUser.user_id},vm.activeUser).$promise
			}else{
				p = noc.userInfo.save(vm.activeUser).$promise
			}
			p.then(function(){
				toastr.success("Save Successful")
				vm.closeModal()
			})
			.catch(function(err){
				$log.log(err)
				$log.log(err.errors)
				toastr.warning("Error: "+err.data.error)
			})

		}

		vm.closeModal = function(){
			vm.activeUser = null
			vm.loadSub(vm.submissionObj.id)
			vm.modalInstance.dismiss();
		};

		vm.remove_user = function(){
			$log.log(vm.activeUser.user_id)
			noc.userInfo.delete({"id":vm.activeUser.user_id}).$promise
			.then(function(){
				toastr.success("User Removed");
				// vm.loadSub(vm.submissionObj.id)
				vm.closeModal()
			})
			.catch(function(err){
				toastr.warning("Failed to Remove User")
				$log.log(err)
			})
		}
		
		vm.pass_reset = function(user_id){
			noc.userInfo.save({"id":user_id,"route":"pw-reset"},{}).$promise
			.then(function(){
				toastr.success("Request Successful")
			})
			.catch(function(err){
				toastr.warning(err)
			})
		}

		vm.buildPass = function(){
			length = length || 8;

			var upper = "ABCDEFGHIJKLMNPQRSTUVWXYZ";
			var lower = "abcdefghjkmnpqrstuvwxyz";
			var numbers = "23456789";
			// var symbols = "!@#$%^&*()";

			var all = upper + lower + numbers;

			function getRandomChar(str) {
				return str.charAt(Math.floor(Math.random() * str.length));
			}

			var password = [
				getRandomChar(upper),
				getRandomChar(lower),
				getRandomChar(numbers)
			];

			for (var i = password.length; i < length; i++) {
				password.push(getRandomChar(all));
			}

			// Shuffle (Fisher-Yates would be better, but keeping your original style)
			password.sort(function () {
				return Math.random() - 0.5;
			});
			var pw = password.join('');
			$log.log(pw)
			vm.submissionObj.plain_password = pw		
		}

		load_data()

	}


})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('salesAdminTerritoriesController', salesAdminTerritoriesController);

	/** @ngInject */
	function salesAdminTerritoriesController($log, $location,toastr, noc, $uibModal, $scope) {
		var vm = this;

		var defaultObj = {"id":null,"name":"","user":{"id":0}}
		vm.selectedTerritory = null;
		vm.states = []

		vm.back = function(){
			$location.path('/adminSales')
		}

		function loadData(){
			noc.region.get().$promise
			.then(function(data){
				vm.territories = data.data
			})
			noc.states.query().$promise
			.then(function(data){
				vm.states = data
			})
			noc.userInfo.get({"active":true,"system_user":false,"third_party/id":0,"sort_by":"user_full_name"}).$promise
			.then(function(data){
				vm.users = data.data
			})
		}

		vm.populateDetails = function(key){
			vm.selectedTerritory = vm.territories[key]
		}

		vm.stateSelected = function(state_id){
			$log.log(state_id)
			var l = [{"key":"region/id","value":vm.selectedTerritory.id}]
			noc.states.patch({"id":state_id},{"updates":l}).$promise
			.then(function(){
				toastr.success("State Added to Region")
				loadData()
			})
		}

		vm.stateRemoved = function(state_id){
			var l = [{"key":"region/id","value":1}]
			noc.states.patch({"id":state_id},{"updates":l}).$promise
			.then(function(){
				toastr.success("State set to unassigned")
				loadData()
			})
		}

		vm.save = function(){
			noc.region.save(vm.newObject).$promise
			.then(function(){
				toastr.success("Region Added")
				loadData()

			}).catch(function(err){
				$log.log(err)
				toastr.warning("Error Saving Region")
			})
		}

		vm.addNew = function(){
			vm.newObject = defaultObj
			vm.modalInstance = $uibModal.open({
				templateUrl: 'addRegion.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.updateRegion = function(){
			$log.log(vm.selectedTerritory)
			noc.region.update({"id":vm.selectedTerritory.id},vm.selectedTerritory).$promise
			.then(function(){
				toastr.success("Updated Region")
			})
			.catch(function(){
				toastr.warning("Failed to update Region")
			})
		}

		vm.removeTerritory = function(key){
			// $log.log(vm.territories[key])
			noc.region.delete({id:vm.territories[key].id}).$promise
			.then(function(){
				toastr.success("Territory Removed")
				loadData()
				vm.selectedTerritory = null
			})
			.catch(function(err){
				toastr.warning("Failed to remove Territory")
				$log.log(err)
			})
		}

		vm.closeModal = function(){
			vm.newObject = defaultObj
			vm.modalInstance.dismiss();
		};

		loadData()

	}

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('salesAdminRepsController', salesAdminRepsController);

	/** @ngInject */
	function salesAdminRepsController($log, $location,toastr, noc) {
		var vm = this;

		vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']
		vm.defaultObj = {"user_id":-1,"years":[],"third_party":false}
		function loadData(){
			vm.third_parties = []
			noc.userInfo.query().$promise
			.then(function(data){
				vm.users = [];
				angular.forEach(data,function(element){
					if(element.active && element.sells_things){
						noc.salesReps.get({id:element.user_id}).$promise
						.then(function(rData){
							element.years = rData.years
						})
						vm.users.push(element)
					}
				})
			})
			noc.thirdParty.query().$promise
			.then(function(data){
				angular.forEach(data,function(element){
					if(element.sells_things){
						element.users = []
						noc.thirdParty.query({id:element.id,route:"user"}).$promise
						.then(function(tData){
							angular.forEach(tData,function(el){
								if(el.sells_things && el.active){
									element.users.push(el)
								}
							})
							vm.third_parties.push(element)
						})
					}
				})
			})
		}

		vm.editRep = function(u_id){
			vm.editActive = true
			vm.edit_id = u_id
		}

		// This is for JNL REPS ONLY
		vm.saveEdit = function(arr_key){
			var obj = vm.users[arr_key]
			obj.third_party = null
			noc.salesReps.update({id:obj.user_id},obj).$promise
			.then(function(){
				toastr.success('Sales Rep Updated');
				loadData()
				vm.editActive = false
				vm.edit_id = null
			})
			.catch(function(err){
				toastr.warning("Failed to Save" + err);
			})
		}

		vm.cancelEdit = function(){
			vm.editActive = false
			vm.edit_id = null
		}

		vm.editThirdParty = function(u_id){
			$log.log(u_id)
			vm.editActive = true
			vm.edit_t_id = u_id
		}

		// This is for Third Party REPS ONLY
		vm.saveThirdParty = function(arr_key){
			noc.thirdParty.get({id:vm.edit_t_id}).$promise
			.then(function(data){
					var obj = data
					obj.years = vm.third_parties[arr_key].years
					noc.thirdParty.update({id:vm.edit_t_id},obj).$promise
					.then(function(){
						toastr.success("Save Successful")
						vm.editActive = false
						vm.edit_t_id = null
					})
					.catch(function(err){
						toastr.warning("Save Unsuccessful")
						$log.log(err)
					})
			})
		}

		vm.back = function(){
      $location.path('/adminSales')
    }

		vm.saveUser = function(){
			noc.salesReps.update({id:vm.defaultObj.user_id},vm.defaultObj).$promise
			.then(function(){
				toastr.success('Sales Rep Updated');
				loadData()
				vm.addNew = false
			})
			.catch(function(err){
				toastr.warning("Failed to Save" + err);
			})
		}

		loadData()

	}

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('salesAdminProductionController', salesAdminProductionController);

  /** @ngInject */
	function salesAdminProductionController($log, $location,toastr, noc) {
		var vm = this;
    var currentTime = new Date()
    var year = currentTime.getFullYear()
    vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']
    vm.repData = noc.salesReps.query()
    vm.third_parties = noc.thirdParty.query()
    vm.users = noc.userInfo.query()
    noc.salesCategories.query().$promise
    .then(function(data){
      vm.salesCategories = data
      resetMonthlyObject()
    })


    function resetMonthlyObject(){
      vm.monthlyObject = {}
      angular.forEach(vm.salesCategories,function(element){
        var i = element.id
        vm.monthlyObject[i] ={"jan":0,"feb":0,"mar":0,"apr":0,"may":0,"jun":0,"jul":0,"aug":0,"sep":0,"oct":0,"nov":0,"dec":0}
      })
    }

    vm.back = function(){
      $location.path('/adminSales')
    }

    function loadData(){
      noc.salesProduction.get({year:year}).$promise
      .then(function(data){
        vm.workingObj = data
      })
    }


    vm.updateYear = function(){
      noc.salesProduction.get({year:vm.workingObj.year}).$promise
      .then(function(data){
        vm.workingObj = data
      })
    }

    loadData()

    vm.saveProduction = function(){
      noc.salesProduction.update({year:vm.workingObj.year},vm.workingObj).$promise
      .then(function(){
        toastr.success('Production Saved');
      })
      .catch(function(err){
        toastr.warning("Failed to Save")
        $log.log(err)
      })
    }


	}

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('salesAdminOwnerUpdateController', salesAdminOwnerUpdateController);

	/** @ngInject */
	function salesAdminOwnerUpdateController($log, $location,toastr, noc) {
		var vm = this;

		vm.searchValue = ''
		var estimates = noc.estimates.query()
		function load_estimates(){
			noc.estimates.query().$promise
			.then(function(data){
				estimates = data
				vm.searchEstimate()
			})
		}
		vm.estimateData = null;
		vm.repData = []

		noc.userInfo.query().$promise
		.then(function(data){
			vm.users = data
			angular.forEach(data,function(element){
				if(element.sells_things){
					vm.repData.push(element)
				}
			})
		})

		vm.updateOwner = function(k){
			vm.estimateData[k].newOwner = vm.newOwnerId
		}

		vm.checkNewOwner = function(){
			angular.forEach(vm.estimateData,function(element){
				if('changeOwner' in element){
					if(element['changeOwner']){
						element.newOwner = vm.newOwnerId
					}
				}
			})
		}

		vm.save = function(){
			vm.reloadPromise = noc.estimates.save({id:'change-owner'},vm.estimateData).$promise
			.then(function(){
				toastr.success("Update Successful")
				load_estimates()
			})
			.catch(function(err){
				toastr.warning("Failed to Update")
				$log.log(err)
			})
		}

		vm.searchEstimate = function(){
			vm.estimateData = []
			if(vm.searchValue.length >= 3){
				angular.forEach(estimates,function(element){
					if(element.site_name.toUpperCase().includes(vm.searchValue.toUpperCase()) || element.estimate_id.includes(vm.searchValue)){
						vm.estimateData.push(element)
					}
				})
			}else{
				vm.estimateData = null;
			}
		}

		vm.back = function(){
			$location.path('/adminSales')
		}


	}

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('salesAdminGoalsController', salesAdminGoalsController);

  /** @ngInject */
	function salesAdminGoalsController($log, $location,toastr, noc) {
		var vm = this;
    var currentTime = new Date()
    var year = currentTime.getFullYear()
    vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']
    vm.repData = noc.salesReps.query()
    vm.users = noc.userInfo.query()
    vm.third_parties = noc.thirdParty.query()
    noc.salesCategories.query().$promise
    .then(function(data){
      vm.salesCategories = data
      resetMonthlyObject()
    })


    function resetMonthlyObject(){
      vm.monthlyObject = {}
      angular.forEach(vm.salesCategories,function(element){
        var i = element.id
        vm.monthlyObject[i] ={"jan":0,"feb":0,"mar":0,"apr":0,"may":0,"jun":0,"jul":0,"aug":0,"sep":0,"oct":0,"nov":0,"dec":0}
      })
    }

    vm.back = function(){
      $location.path('/adminSales')
    }

    vm.calculateYearlyGoal = function(){
      resetMonthlyObject()
      var total = 0
      angular.forEach(vm.workingObj.jnl_reps,function(element){
        angular.forEach(element.goal_data,function(value){
          var cat = value['category'];
          angular.forEach(value.monthly_goals,function(data,key){
            vm.monthlyObject[cat][key] = vm.monthlyObject[cat][key] + parseFloat(data)
            total = total + parseFloat(data)
          })
        })
      })
      angular.forEach(vm.workingObj.third_parties,function(element){
        angular.forEach(element.goal_data,function(value){
          var cat = value['category'];
          angular.forEach(value.monthly_goals,function(data,key){
            vm.monthlyObject[cat][key] = vm.monthlyObject[cat][key] + parseFloat(data)
            total = total + parseFloat(data)
          })
        })
      })
      vm.total = total
    }

    function loadData(){
      noc.salesGoals.get({year:year}).$promise
      .then(function(data){
        vm.workingObj = data
        vm.calculateYearlyGoal()
      })
    }


    vm.updateYear = function(){
      noc.salesGoals.get({year:vm.workingObj.year}).$promise
      .then(function(data){
        vm.workingObj = data
        vm.calculateYearlyGoal()
      })
    }

    loadData()

    vm.saveGoals = function(){
      noc.salesGoals.update({year:vm.workingObj.year},vm.workingObj).$promise
      .then(function(){
        toastr.success('Goals Saved');
      })
      .catch(function(err){
        toastr.warning("Failed to Save")
        $log.log(err)
      })
    }


	}

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('rmaDCSTestController', rmaDCSTestController);

	/** @ngInject */
	function rmaDCSTestController($log,toastr, noc, testAppAPI, $scope, $uibModal, $interval, $location, $window) {
		var vm = this;
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		vm.workingObject = {"serial_number":null,"product_id":null,"associated_serial":null,"customer_id":null,"test_pass":false};
		vm.resultObject = {"serial_number":false,"product_id":false,"input_1":false,"input_2":false,"input_3":false,"input_4":false,"input_5":false,"input_6":false,"input_7":false,"input_8":false,"input_9":false,"input_10":false,"output_1":false,"output_2":false,"output_3":false,"output_4":false,"output_5":false,"wiegand":false,"wiegand_code":false,"wiegand_site":false,"sound":false,"tag_detect":false,"bluetooth_errors":null,"screen":false,"rma_id":null}
		// var requirementObject = {1732:{"inputs":false,"outputs":true,"bluetooth":true,"wiegand":false,"sound":false,"screen":false,"type_id":"qsm"},
		// 													1622:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":"dcs-tontec"},
		// 													1689:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":false,"sound":false,"screen":false,"type_id":"io"},
		// 													1500:{"inputs":false,"outputs":true,"bluetooth":true,"wiegand":false,"sound":false,"screen":false,"type_id":"est"},
		// 													1797:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":"dcs-neosec"},
		// 													1900:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":"dcs-neosec"},
		// 													1907:{"inputs":false,"outputs":true,"bluetooth":true,"wiegand":true,"sound":false,"screen":false,"type_id":"est"},
		// 													2015:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":"dcs-neosec"},
		// 													2128:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":"sad"},
		// 													2200:{"inputs":false,"outputs":true,"bluetooth":false,"wiegand":false,"sound":false,"screen":false,"type_id":"tts"},
		// 													2144:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":false,"type_id":"dcs-neo-no-screen"},
		// 													2234:{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":"dcs-neosec"}
														// }
		vm.availabeRMA = []
		// var rmaArray = []

		// function filterRMA(){
		// 	angular.forEach(rmaArray,function(element){
		// 		if(element.serial_number == vm.workingObject.serial_number && element.status == 3){
		// 			vm.availabeRMA.push(element)
		// 		}
		// 	})
		// }

		function loadData(){
			vm.availablePNs = []
			noc.availableTests.get().$promise
			.then(function(data){
				vm.availableTest = data.data
			})
			// })
		}

		vm.save_updated_board = function(new_jnl_board){
			// vm.workingObject.associated_serial = new_jnl_board
			noc.serialGenerator.get({"id":new_jnl_board}).$promise
			.then(function(data){
				vm.serialNumberData = data
			})
			vm.closeModal()
		}


		loadData()

		vm.boardSet = function(){
			// if(vm.workingObject.product_id == 1622){
			// 	vm.boardReady = false
			// 	vm.screenCheckRequired = true
			// }else{
			// 	vm.boardReady = true
			// }
			vm.testReq = noc.product.get({"id":vm.workingObject.product.id,"route":"test-requirement"}).$promise
			.then(function(data){
				if(data.count == 1){
					vm.testReq = data.data[0]
					vm.boardReady = true
				}else{
					toastr.warning("No Test Requirements specificed for this device")
				}
			})
			.catch(function(){
				toastr.warning("No Test Requirements specificed for this device")
			})
		}

		vm.screenCheck = function(){
			$log.log(vm.selectedHW)
			testAppAPI.server_ip = "http://"+vm.selectedHW.ip_address+":5000"
			testAppAPI.test()
			testAppAPI.tontecBoot.put({},{},function(data){
				if(data.change){
					noc.availableTests.delete({id:vm.selectedHW.mac})
					vm.selectedHW = null
					vm.workingObject.serial_number = null
					loadData()
					toastr.success("Unit Rebooting, refresh in a minute to find the MAC again")
				}else{
					vm.boardReady = true
					toastr.success("Tontec Display Ready")
				}
			})
		}

		vm.ipCheck = function(){
			testAppAPI.server_ip = "http://"+vm.selectedHW.ip_address+":5000"
			testAppAPI.test()
			noc.quantumHardware.get({"id":vm.selectedHW.mac}).$promise
			.then(function(data){
				$log.log("HI")
				vm.workingObject = data
				noc.product.get({"id":data.product.id}).$promise
				.then(function(product_data){
					vm.finished_product = product_data
				})
				noc.serialGenerator.get({"id":data.associated_serial}).$promise
				.then(function(sn_data){
					vm.serialNumberData = sn_data
				})
				// filterRMA()
			})
			.catch(function(){
				vm.workingObject.serial_number = vm.selectedHW.mac
				// filterRMA()
				vm.workingObject.product.id = null
				vm.workingObject.associated_serial = null
				vm.workingObject.customer_id = null
			})
		}

		vm.updateBoard = function(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'newSerial.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.newSerialSelected = function(){
			vm.closeModal()
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss();
		};

		var mainTimer
		function mainTimerFunction(){
			if(angular.isDefined(mainTimer)) return;
			mainTimer = $interval(function(){
				results()
			},1000)
		}

		$scope.$on('$destroy', function() {
			if(angular.isDefined(mainTimer)){
				$interval.cancel(mainTimer)
			}
		})

		vm.stopTest = function(){
			$interval.cancel(mainTimer)
			testAppAPI.stopTest.get()
		}

		vm.cancelTest = function(){
			vm.stopTest()
		}

		vm.startTest = function(){
			vm.resultObject.product_id = vm.workingObject.product_id
			vm.resultObject.serial_number = vm.workingObject.serial_number
			testAppAPI.startTest.get(function(){
				mainTimerFunction()
				vm.testStarted = true
			},function(){
				vm.testStatus = 'FailConnect'
			})
		}

		vm.toggleOut = function(outputNumber){
			testAppAPI.toggleOutput.get({id:outputNumber})
		}

		vm.toggleSound = function(){
			testAppAPI.toggleSound.get()
		}

		vm.changeScreen = function(newValue){
			testAppAPI.screenChange.update({id:newValue},{})
		}

		function results(){
			testAppAPI.currentStatus.get(function(data){
				vm.resultData = data
			})
		}

		function input_test(){
			var r = true
			if(vm.testReq.inputs){
				angular.forEach(vm.resultData.inputs,function(element, key){
					if(!element.tested){
						r = false
					}else{
						vm.resultObject['input_'+key] = true
					}
				})
			}else{
				if(vm.resultObject['input_1'] == false){
					for (var i = 1; i <= 10; i++) {
						vm.resultObject['input_'+String(i)] = true
					}
				}
			}
			return r
		}

		function output_test(){
			var r = true
			if(vm.testReq.outputs){
				angular.forEach(vm.resultObject,function(element,key){
					if(key.includes("output")){
						if(!element){
							r = false
						}
					}
				})
			}else{
				if(vm.resultObject['output_1'] == false){
					for (var i = 1; i <= 5; i++) {
						vm.resultObject['output_'+String(i)] = true
					}
				}
			}
			return r
		}

		function wiegand_test(){
			var r = true
			if(vm.testReq.wiegand){
				if(!vm.resultData.wiegand.result){
					r = false
				}else{
					vm.resultObject['wiegand'] = true;
					vm.resultObject['wiegand_code'] = vm.resultData.wiegand.code
					vm.resultObject['wiegand_site'] = vm.resultData.wiegand.site
				}
			}else{
				vm.resultObject['wiegand'] = true;
			}
			return r
		}

		function bluetooth_test(){
			var r = false
			if(vm.testReq.bluetooth){
				if(vm.resultData.bluetooth.result){
					r = true
					vm.resultObject['tag_detect'] = true
					return r
				}else{
					r = false
					vm.resultObject['tag_detect'] = false
					return r
				}
			}else{
				vm.resultObject['tag_detect'] = true
				r = true
				return r
			}
		}

		function sound_test(){
			var r = false
			if(vm.testReq.sound){
				if(vm.resultObject['sound']){
					r = true
				}
			}else{
				vm.resultObject['sound'] = true
				r = true
			}
			return r
		}

		function screen_test(){
			var r = false
			if(vm.testReq.screen){
				if(vm.resultObject['screen']){
					r = true
				}
			}else{
				vm.resultObject['screen'] = true
				r = true
			}
			return r
		}

		var pass
		vm.passedTest = function(){
			if(vm.resultData){
				vm.testFails = []
				var local_pass = false
				var o = false
				var i = false
				var b = false
				var w = false
				var s = false
				var d = false
				if(output_test()){
					o = true
				}else{
					vm.testFails.push("Output Failure")
				}
				if(bluetooth_test()){
					$log.log("BLUETOOTH PASSED?")
					b = true
				}else{
					vm.testFails.push("Bluetooth Failure")
				}
				if(input_test()){
					i = true
				}else{
					vm.testFails.push("Input Failure")
				}
				if(wiegand_test()){
					w = true
				}else{
					vm.testFails.push("Wiegand Failure")
				}
				if(sound_test()){
					s = true
				}else{
					vm.testFails.push("Sound Failure")
				}
				if(screen_test()){
					d = true
				}else{
					vm.testFails.push("Screen Failure")
				}
				if(o && b && i && w && s && d){
					local_pass = true
					vm.workingObject.test_pass = true
					pass = "PASS"
				}else{
					pass = "FAIL"
					vm.workingObject.test_pass = false
				}
				return local_pass
			}else{
				pass = "FAIL"
				vm.workingObject.test_pass = false
				return false
			}
		}


		vm.submitTest = function(){
			var pass_bool
			noc.availableTests.delete({id:vm.workingObject.serial_number})
			// var displaySerial = null
			vm.resultObject.product_id = vm.workingObject.product.id
			// if(vm.workingObject.associated_serial){
			// 	noc.serialGenerator.get({id:vm.workingObject.associated_serial,route:"ID"}).$promise //Finds Actual Serial Number of selected serial if not null
			// 	.then(function(data){
			// 		displaySerial = data.serial_number
			// 	})
			// }
			// if(vm.passedTest()){
			// 	testAppAPI.updateApp.get({type:requirementObject[vm.workingObject.product_id].type_id}) //Tell the door what to become
			// }
			if(vm.passedTest()){
				pass_bool = true
				if (vm.finished_product.is_dcs_unit){
					testAppAPI.updateApp.get({type:'dcs-neosec'})
				}else if(vm.finished_product.is_enrollment){
					testAppAPI.updateApp.get({type:'est'})
				}else if(vm.finished_product.is_io_repeater){
					testAppAPI.updateApp.get({type:'io'})
				}else if(vm.finished_product.is_qsm){
					testAppAPI.updateApp.get({type:'qsm'})
				}else if(vm.finished_product.is_tts){
					testAppAPI.updateApp.get({type:'tts'})
				}else if(vm.finished_product.is_sad){
					testAppAPI.updateApp.get({type:'sad'})
				}
			}else{
				pass_bool = false
			}
			vm.resultObject.test_pass = pass_bool

			noc.quantumHardware.update({id:vm.workingObject.serial_number},vm.workingObject,function(){
				noc.quantumHardware.save({"id":vm.workingObject.serial_number,"route":"test"},vm.resultObject,function(){
					$window.open(vm.report_server+"/quantum_test_print.php?mac="+vm.workingObject.serial_number+"&qc_str=Board "+vm.serialNumberData.serial_number+" "+pass+"&hw_type="+vm.workingObject.product.id)
					$location.path("/quantumHardwareTest/"+vm.workingObject.serial_number);
				})
			})
		}

		vm.findSerials = function(){
			noc.serialGenerator.get({"serial_number":vm.serialSearch}).$promise
			.then(function(data){
				vm.searchResults = data.data
			})
		}

		vm.chosenPart = function(id){
			vm.workingObject.associated_serial = id
			vm.closeModal()
		}

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('rmaPCTestController', rmaPCTestController);

	/** @ngInject */
	function rmaPCTestController($log,toastr, noc, $scope, $uibModal, $interval, $location, $window) {
		var vm = this;
		vm.workingObject = {"serial_number":null,"product_id":null,"associated_serial":null,"customer_id":null,"test_pass":false};
		vm.resultObject = {"serial_number":false,"product_id":false,"input_1":false,"input_2":false,"input_3":false,"input_4":false,"input_5":false,"input_6":false,"input_7":false,"input_8":false,"input_9":false,"input_10":false,"output_1":false,"output_2":false,"output_3":false,"output_4":false,"output_5":false,"wiegand":false,"wiegand_code":false,"wiegand_site":false,"sound":false,"tag_detect":false,"bluetooth_errors":null,"screen":false,"rma_id":null}
		vm.availablePNs = []
		vm.availabeRMA = []
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		// var rmaArray = []
		vm.serialNumberData = null

		// 	noc.rma.query().$promise
		// 	.then(function(rmaData){
		// 		rmaArray = rmaData
		// 	})
		// })

		vm.inovonics = function(){
			noc.quantumHardware.get({id:vm.workingObject.serial_number}).$promise
			.then(function(data){
				vm.workingObject = data
				vm.inovonicsLoaded = true
				noc.serialGenerator.get({"id":data.associated_serial}).$promise
				.then(function(serial_data){
					vm.serialNumberData = serial_data
				})
					// filterRMA()
			})
			.catch(function(){
				noSerial()
			})
		}

		// function multipleResults(){
		// 	vm.modalInstance = $uibModal.open({
		// 		templateUrl: 'chooseSerial.html',
		// 		scope: $scope,
		// 		size: 'lg'
		// 	});
		// }

		function noSerial(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'noSerial.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.newSerialSelected = function(){
			vm.closeModal()
		}

		// function filterRMA(){
		// 	angular.forEach(rmaArray,function(element){
		// 		if(element.serial_number == vm.workingObject.serial_number && element.status == 3){
		// 			vm.availabeRMA.push(element)
		// 		}
		// 	})
		// }

		vm.updateBoard = function(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'newSerial.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.verify_changed_serial = function(new_sn){
			noc.serialGenerator.get({"serial_number":new_sn}).$promise
			.then(function(data){
				vm.potential_serial_return = data.data
			})
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss();
		};

		function pc_input_control(){
			angular.forEach(vm.resultData.status,function(element, key){
				if(key == 'alarm_bit_1_alarm'){
					vm.resultObject.input_1 = element
				}
				if(key == 'alarm_bit_2_alarm'){
					vm.resultObject.input_3 = element
				}
				if(key == 'alarm_bit_1_reset'){
					vm.resultObject.input_2 = element
				}
				if(key == 'alarm_bit_2_reset'){
					vm.resultObject.input_4 = element
				}
				if(key == 'tamper_active'){
					vm.resultObject.input_5 = element
				}
				if(key == 'tamper_reset'){
					vm.resultObject.input_6 = element
				}
			})
		}

		vm.multipleResultSelected = function(key){
			vm.closeModal();
			vm.workingObject = vm.snResults[key]
			vm.inovonicsLoaded = true
			// filterRMA()
		}

		vm.boardSet = function(){
			vm.boardReady = true
		}

		vm.save_updated_board = function(new_jnl_board){
			vm.workingObject.associated_serial = new_jnl_board
			noc.serialGenerator.get({"id":new_jnl_board}).$promise
			.then(function(data){
				vm.serialNumberData = data
			})
			vm.closeModal()
		}

		vm.addHardware = function(){
			noc.quantumHardware.save({id:vm.workingObject.serial_number,route:"manualAddition"},vm.workingObject).$promise
			.then(function(){
				toastr.success("Serial number saved");
				vm.inovonicsLoaded = true
				// filterRMA()
				vm.closeModal();
			})
			.catch(function(){
				toastr.warning("Serial number not saved");
				vm.closeModal();
			})
		}

		vm.startPCTest = function(){
			vm.resultObject.serial_number = vm.workingObject.serial_number
			vm.resultObject.product_id = vm.workingObject.product.id
			noc.pullCordStart.put({},{'pc_type':vm.workingObject.product.id,'serial_number':vm.workingObject.serial_number}).$promise
			.then(function(data){
				$log.log(data)
				mainTimerFunction()
				vm.pcStarted = true
			})
			.catch(function(error){
				toastr.warning(error.data.message)
			})
		}

		var mainTimer
		function mainTimerFunction(){
			if(angular.isDefined(mainTimer)) return;
			mainTimer = $interval(function(){
				noc.pullCordStatus.get({"serial_number":vm.workingObject.serial_number}).$promise
				.then(function(data){
					vm.resultData = data
					pc_input_control()
					pcInputPass()
				})
				.catch(function(){
					toastr.warning("Test timed out or failed to start")
					$interval.cancel(mainTimer)
					mainTimer = undefined
				})
			},1000)
		}

		$scope.$on('$destroy', function() {
			if(angular.isDefined(mainTimer)){
				$interval.cancel(mainTimer)
			}
		})
		var pcTestStatus
		function pcInputPass(){
			pcTestStatus = "PASS"
			var pass_bool = true
			var val
			for (var i = 1; i <= 6; i++) {
				val = vm.resultObject['input_'+String(i)]
				if(!val){
					pcTestStatus = "FAIL"
					pass_bool = false
				}
			}
			vm.workingObject.test_pass = pass_bool
		}

		vm.userFail = function(){
			for (var i = 1; i <= 6; i++) {
				vm.resultObject['input_'+String(i)] = false
			}
			vm.pcSubmitTest()
		}

		vm.pcSubmitTest = function(){
			noc.pullCordStop.put({"serial_number":vm.workingObject.serial_number},{},function(){
				$log.log("Stopped?")
			})
			noc.quantumHardware.update({id:vm.workingObject.serial_number},vm.workingObject,function(){
				noc.quantumHardware.save({"id":vm.workingObject.serial_number,"route":"test"},vm.resultObject,function(){
					$window.open(vm.report_server+"/quantum_test_print.php?mac="+vm.workingObject.serial_number+"&qc_str=Board "+vm.serialNumberData.serial_number+" "+pcTestStatus+"&hw_type="+vm.workingObject.product.id)
					$location.path("/quantumHardwareTest/"+vm.workingObject.serial_number);
				})
			})

		}

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('rmaCustomerController', rmaCustomerController);

	/** @ngInject */
	function rmaCustomerController($log, toastr, noc, $scope, $uibModal, $routeParams, $location) {
		var vm = this;
		var defaultObject = {"id":null,"serial_number":null,"customer_id":null,"warranty":null,"product_id":null,"reason_id":null,"reason_notes":null,"advanced":false,"issue_id":null,"repair_notes":null,"replacement_serial":null,"transaction_id":null}
		vm.workingObject = {}
		vm.availablePNs = []
		vm.laterStatus = []
		vm.allHardware = []
		vm.manual = false

		noc.quantumHardware.query().$promise
		.then(function(data){
			angular.forEach(data,function(element){
				if(element.site_id == 2 || !element.site_id){
					vm.allHardware.push(element.serial_number)
				}
			})
		})


		function createWorkingObject(){
			angular.copy(defaultObject,vm.workingObject)
		}

		vm.statusFunction = noc.rmaStatus.query().$promise
		.then(function(data){
			vm.rmaStatuses = data
			vm.laterStatus = []
			angular.forEach(data,function(element){
				if(element.id >= 3){
					vm.laterStatus.push(element)
				}
			})
		})

		function filterReasonList(){
			vm.filteredReasonList = []
			vm.filteredIssueList = []
			angular.forEach(vm.currentReasons,function(element){
				angular.forEach(element.product,function(product_id){
					if(product_id == vm.workingObject.product_id){
						if(element.available_for_reason){
							vm.filteredReasonList.push(element)
						}if (element.available_for_repair) {
							vm.filteredIssueList.push(element)
						}
					}
				})
			})
		}

		createWorkingObject()

		vm.populatePromise = noc.quantumCustomer.query().$promise
		.then(function(data){
			vm.customerData = data
			vm.partPromise = noc.product.query().$promise
			.then(function(partData){
				vm.allParts = partData
				angular.forEach(partData,function(element){
					if(element.rma_enabled){
						vm.availablePNs.push(element)
					}
				})
			})
		})

		vm.reasonPromise = noc.rmaReason.query().$promise
		.then(function(data){
			vm.currentReasons = data
		})

		vm.populateCustomer = function(id,need_reset){
			if(need_reset){
				createWorkingObject()
			}
			noc.quantumCustomer.get({id:id}).$promise
			.then(function(customerDetails){
				vm.customerDetails = customerDetails
				vm.workingObject.customer_id = id
			})
		}

		vm.part_selected = function(){
			filterReasonList()
		}
		vm.manualAdd = function(){
			vm.workingObject.product_id = null
			vm.workingObject.serial_number = null
			vm.manual = true
			// vm.manual = true
		}

		vm.cancelManual = function(){
			// vm.manual = false
			vm.manual = false
			vm.workingObject.product_id = null
			vm.workingObject.serial_number = null
		}

		function customerConfirmDialog(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'confirmCustomer.html',
				scope: $scope,
				size: 'lg'
			});
		}

		function serialNumberConfirmDialog(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'chooseSerial.html',
				scope: $scope,
				size: 'lg'
			});
		}

		function serialNumberDoesNotExistDialog(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'NoSerial.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss();
		};

		vm.multipleResultSelected = function(sn){
			vm.workingObject.serial_number = sn
			vm.modalInstance.dismiss();
		}

		vm.addSerial = function(serialNumber){
			vm.workingObject.serial_number = serialNumber
			noc.quantumHardware.query({id:serialNumber}).$promise
			.then(function(data){
				vm.workingObject.product_id = data[0].product_id
				filterReasonList()
				noc.product.get({id:data[0].product_id}).$promise
				.then(function(productData){
					vm.productName = productData.general.name.value
					vm.partNumber = productData.part_number
				})
			})
		}

		vm.checkSN = function(){
			var obj
			noc.quantumHardware.query({id:vm.workingObject.serial_number}).$promise
			.then(function(data){
				vm.snResults = data
				if(data.length == 1){
					obj = data[0] //Have to take
					if(obj.site_id == vm.workingObject.customer_id){
						toastr.success("Serial Number Valid")
					}else{
						if(obj.site_id){
							customerConfirmDialog()
						}else{
							//Get here when the device is in the portal, but not checked into a site
							customerConfirmDialog()
						}
					}
				}else{
					serialNumberConfirmDialog()
					//More than one mac was returned, this will cause issues. So make the user choose one
				}
			})
			.catch(function(){
				serialNumberDoesNotExistDialog()
			})
		}

		vm.dataFilled = function(){
			var valid = true
			angular.forEach(vm.workingObject,function(element,key){
				if(key != 'id' && key != 'issue_id' && key != 'repair_notes' && key != "replacement_serial" && key != "transaction_id"){
					if(element == null || element === ""){
						valid = false
						$log.log(key)
					}
				}
			})
			return valid
		}

		vm.updateCustomer = function(){
			noc.quantumHardware.update({id:vm.workingObject.serial_number,route:"updateSite"},vm.workingObject).$promise
			.then(function(){
				toastr.success("Serial number now belongs to this customer");
				vm.manual = false;
				vm.populateCustomer(vm.workingObject.customer_id,false);
				vm.addSerial(vm.workingObject.serial_number);
				vm.closeModal();
			})
			.catch(function(){
				toastr.warning("Serial number not able to be moved")
			})
		}

		vm.addHardware = function(){
			noc.quantumHardware.save({id:vm.workingObject.serial_number,route:"manualAddition"},vm.workingObject).$promise
			.then(function(){
				toastr.success("Serial now added and assigned to this customer");
				vm.manual = false;
				vm.populateCustomer(vm.workingObject.customer_id,false);
				vm.addSerial(vm.workingObject.serial_number);
				vm.closeModal();
			})
			.catch(function(){
				toastr.warning("Serial number not able to be moved");
				vm.closeModal();
			})
		}

		vm.createRMA = function(){
			noc.rma.save(vm.workingObject).$promise
			.then(function(data){
				$log.log(data)
				toastr.success("RMA CREATED")
				$location.path('/rmaCustomerSearch/'+data.ID)
			})
			.catch(function(){
				toastr.warning("Create RMA Failed")
			})
		}

		vm.updateRMA = function(status){
			if(angular.isDefined(status)){
				var old_status = vm.workingObject.status
				vm.workingObject.status = status
				$log.log(old_status)
				if(old_status == 1 && vm.workingObject.status == 2){
					noc.quantumHardware.update({id:vm.workingObject.serial_number,route:"updateSite"},{customer_id:2}).$promise
					.then(function(){
						toastr.success("Product Location Updated")
					})
					.catch(function(err){
						$log.log(err)
						toastr.warning("Product Location Not Updated")
					})
				}else if(vm.workingObject.status == 4){
					noc.quantumHardware.update({id:vm.workingObject.serial_number,route:"updateSite"},{customer_id:3}).$promise
					.then(function(){
						toastr.success("Product Location Updated")
					})
				}else if(vm.workingObject.status == 5){
					noc.quantumHardware.update({id:vm.workingObject.serial_number,route:"updateSite"},{customer_id:vm.workingObject.customer_id}).$promise
					.then(function(){
						toastr.success("Product Location Updated")
					})
				}
			}
			noc.rma.update({id:vm.workingObject.id},vm.workingObject).$promise
			.then(function(){
				toastr.success("RMA Updated Successfully")
				vm.loadRMA()
			})
		}

		vm.loadRMA = function(id){
			noc.rma.get({id:id}).$promise
			.then(function(data){
				vm.workingObject = data
				vm.populateCustomer(data.customer_id,false)
				filterReasonList()
			})
		}

		function loadAll(){
			noc.rma.query().$promise
			.then(function(data){
				vm.allRMA = data
			})
		}

		if ($location.path() != '/rmaCustomerCreate'){
			var existing_id = $routeParams.id
			if(existing_id > 0){
				vm.loadRMA(existing_id)
			}else{
				loadAll()
			}
		}

		vm.rmaHome = function(){
			createWorkingObject()
			loadAll()
		}

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportTransactionController', reportTransactionController);

	/** @ngInject */
	function reportTransactionController($log,toastr, noc, $q, $window, user, $routeParams, utils) {
		var vm = this;
		vm.last_location = user.data.oldUrl
		var initialValue = $routeParams.id

		noc.transaction.query({id:initialValue}).$promise
		.then(function(txData){
			angular.forEach(txData,function(element){
				if(element.old_object && element.new_object){
					element.differences = utils.compareObj(element.old_object,element.new_object)
				}
			})
			vm.txnData = txData
		})

		vm.txnActions = noc.transactionLogAction.query()
		vm.nocUsers = noc.userInfo.query()



	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportTicketController', reportTicketController);

	/** @ngInject */
	function reportTicketController($log,toastr, noc, $q, $location, $scope, $uibModal,DTOptionsBuilder,$window) {
		var vm = this;

		vm.versions = ['4.0','4.1','5.0','5.1','6.0',"6.1","6.2","7.0","7.1","7.2","7.3"]

		vm.filter_object = {"ticket":{},"time":{},"issue":{}}

		vm.allUsers = []
    noc.userInfo.query().$promise
    .then(function(data){
      angular.forEach(data,function(element){
				vm.allUsers.push({"id":element.user_id,"name":element.user_full_name})
      })
    })

		vm.searchCustomer = function(){
      noc.connectwiseCustomer.query({"id":vm.customerTextSearch}).$promise
      .then(function(data){
        // searchFilters.ticketSearchParams.searchText = vm.customerTextSearch
        vm.searchResults = data
        $log.log(data)
        if (data.length > 1){
          vm.modalInstance = $uibModal.open({
            templateUrl: 'customerChoice.html',
            scope: $scope,
            size: 'lg'
          });
        }else{
          if(data.length > 0){
            vm.filter_object.ticket.customer_id = data[0]['connectwise_id']
						vm.customerTextSearch = data[0]['company_name']
          }else{
            toastr.warning("No results found")
          }
        }
      })
			.catch(function(){
				vm.filter_object.ticket.customer_id = null
			})
    }

		vm.openCustomer = function(i,n){
			vm.filter_object.ticket.customer_id = i
			vm.customerTextSearch = n
			vm.modalInstance.dismiss();
		}

		noc.connectwiseCustomer.get({'id':'name-id-relation'}).$promise
		.then(function(data){
			vm.connectwiseIdRelation = data;
		})

		noc.ticket_board.query().$promise
		.then(function(data){
			vm.boards = data
		})
		noc.ticket_status.query().$promise
		.then(function(data){
			vm.statuses = data
		})
		noc.ticket_type.query().$promise
		.then(function(data){
			vm.types = data
		})
		noc.time_options.query({'route_name':'types'}).$promise
		.then(function(data){
			vm.time_types = data
		})
		noc.time_options.query({'route_name':'roles'}).$promise
		.then(function(data){
			vm.time_roles = data
		})
		noc.issue.query().$promise
		.then(function(data){
			vm.issue_class = data
		})
		noc.issue_second_level.query().$promise
		.then(function(data){
			vm.issue_action = data
		})
		noc.issue_resolution.get().$promise
		.then(function(data){
			$log.log(data)
			vm.resolutions = data.list
		})

		vm.runReport = function(){
			vm.report_load = noc.ticket_report.save(vm.filter_object).$promise
			.then(function(data){
				vm.reportRan = true;
				vm.pageView = 1;
				vm.reportData = data
				$log.log(data)
			})
		}

		vm.getHighestTimeRole = function(){
			var obj = {"name":null,"count":0,"time_spent":0}
			if(vm.reportRan){
				$log.log("HI")
				angular.forEach(vm.reportData.summary.time.role_data,function(element){
					$log.log(element)
					if(element.count > obj.count){
						obj = element
					}
				})
			}
			vm.highestTimeRole = obj
			return obj
		}

		vm.backToFilter = function(){
			vm.reportRan = false;
		}

		vm.getCustomerName = function(id){
			if(vm.connectwiseIdRelation){
				return vm.connectwiseIdRelation[id.toString()]['name']
			}
		}

		vm.dtOptions = DTOptionsBuilder.newOptions()
		.withOption('order',[[1,'desc']])

		vm.listOptions = DTOptionsBuilder.newOptions()
		.withOption('order',[[0,'desc']])

		vm.loadTicket = function(id){
			$window.open('supportTicketUpdate/'+id)
		}
		vm.add_filter = function(key,name,value){
			if(name in vm.filter_object[key]){
				vm.filter_object[key][name].push(value)
			}else{
				vm.filter_object[key][name] = []
				vm.filter_object[key][name].push(value)
			}
			vm.runReport()
		}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('reportTechnicalLandingController', reportTechnicalLandingController);

  /** @ngInject */
	function reportTechnicalLandingController() {
		var vm = this;
		vm.reportResult = {'finished':false,'board':false}

		vm.selectedAreaFunction = function(id, title){
			vm.selectedArea = id;
			vm.title = title
		}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('reportTechnicalAllowedController', reportTechnicalAllowedController);

  /** @ngInject */
	function reportTechnicalAllowedController($log,noc) {
		var vm = this;

    vm.reportData = []
    vm.thirds = []
    noc.thirdParty.get({"active":true,"page_size":1000}).$promise
    .then(function(data){
      angular.forEach(data.data,function(element){
        vm.thirds.push(element)
      })
    })

    vm.update_data = function(t_id){
      noc.thirdParty.get({"id":t_id,"route":"assigned-sites"}).$promise
      .then(function(data){
        vm.quantumsAllowed = data.data
      })
    }

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportServiceBoardController', reportServiceBoardController);

	/** @ngInject */
	function reportServiceBoardController(noc, $log, $scope, $location, $window) {
		var vm = this;
		
		vm.customerObject = {}
		vm.currentPage = 1
		vm.sort_by = "dateEntered"
		vm.sort_order = "DESC"
		vm.searchVal = ""
		vm.num_results = 15
		vm.filterObj = {
							"status/id":[],
							"page":vm.currentPage,
							"sort_by":vm.sort_by,
							"sort_order":vm.sort_order,
							"page_size":vm.num_results
		}

		noc.ticket.get({"route":"status"}).$promise
		.then(function(data){
			vm.statuses = data.data
			angular.forEach(data.data,function(element){
				var lowerCaseStr = element.name.toLowerCase();
				if(!(lowerCaseStr.includes("closed") || lowerCaseStr.includes("cancelled") || lowerCaseStr.includes("resolved") || lowerCaseStr.includes("off board"))){
					vm.filterObj['status/id'].push(element.id)
				}
			})
			load_data()
		})


		function load_data(){
			vm.data = noc.report.save({"route":"service-board"},vm.filterObj)
		}

		

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.filterObj.sort_order == 'ASC'){
				vm.filterObj.sort_order = 'DESC'
			}else{
				vm.filterObj.sort_order = 'ASC'
			}
			load_data()
		}

		vm.loadTicket = function(id){
			// location.path('/supportTicketUpdate/'+id)
			// $log.log($location.path('/supportTicketUpdate/'+id))
			var prot = $location.protocol()
			var port = $location.port()
			var h = $location.host()

			if(port == 3000){
				var url = prot+"://"+h+":3000/supportTicketUpdate/"+id
			}else{
				var url = prot+"://"+h+"/supportTicketUpdate/"+id
			}

			$log.log(url)

			$window.open(url);
		}

		vm.clear_filters = function(){
			vm.filterObj = {
				"status/id":[],
				"page":vm.currentPage,
				"sort_by":vm.sort_by,
				"sort_order":vm.sort_order,
				"page_size":vm.num_results
			}
			load_data()
		}

		// var mainTimer
		// function mainTimerFunction(){
		// 	if(angular.isDefined(mainTimer)) return;
		// 	mainTimer = $interval(function(){
		// 		load_data()
		// 	},10000)
		// }

		// mainTimerFunction()

		// $scope.$on('$destroy', function() {
		// if(angular.isDefined(mainTimer)){
		// 	$interval.cancel(mainTimer)
		// }
		// if(angular.isDefined(timer_id)){
		// 	clearInterval(timer_id)
		// }
		// })

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportSalesYearlyController', reportSalesYearlyController);

	/** @ngInject */
	function reportSalesYearlyController($log,toastr, noc, $q, $timeout, $window, user) {
		var vm = this;
		vm.last_location = user.data.oldUrl
		vm.visibleChart = 1
		vm.maxCharts = 3
		vm.loadedComplete = false;
		vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']
		//CHART DATA FOR MONTHLY TOTAL
		vm.labels = ["January","February","March","April","May","June","July","August","September","October","November","December"]
		vm.series = []
		vm.data = []

		// CHART DATA FOR TOTAL PART COMPARISON
		vm.partCompareLables = []
		vm.partCompareData = []

		vm.chartChange = function(l){
			if(l == "d"){
				vm.visibleChart = vm.visibleChart - 1
			}
			if(l == "u"){
				vm.visibleChart = vm.visibleChart + 1
			}
		}

		vm.txnActions = noc.transactionLogAction.query()
		vm.nocUsers = noc.userInfo.query()
		function formatDollar(num) {
		var p = num.toFixed(2).split(".");
			return "$" + p[0].split("").reverse().reduce(function(acc, num, i) {
					return  num=="-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
			}, "") + "." + p[1];
		}
		function load_data(){
			vm.p = noc.report.get({route:"report-sales",ext:"yearly"}).$promise
			.then(function(data){
				// $log.log(data)
				vm.data = data.data
				vm.series = data.labels
				vm.revenue = data.price_data
				vm.labor_revenue = data.labor_data
				vm.totals = data.total_data
				vm.seriesArray = []
				vm.laborTotal = []
				vm.totalTotals = []
				angular.forEach(data.price_data,function(element){
					var sum = element.reduce(function(a, b) { return a + b; }, 0);
					vm.seriesArray.push(formatDollar(sum))
				})
				angular.forEach(data.labor_data,function(element){
					var sum = element.reduce(function(a, b) { return a + b; }, 0);
					vm.laborTotal.push(formatDollar(sum))
				})
				angular.forEach(data.total_data,function(element){
					var sum = element.reduce(function(a, b) { return a + b; }, 0);
					vm.totalTotals.push(formatDollar(sum))
				})
				vm.populateCompanyGoals()


			})
		}


		vm.populateCompanyGoals = function(){
			vm.loadedComplete = false;
			noc.report.get({route:"report-sales",ext:"company-goals",year:vm.selectedYear}).$promise
			.then(function(companyData){
				vm.selectedYear = companyData.year
				vm.companyGoalData = [];
				vm.companyGoalData.push(companyData['production_totals']);
				vm.companyGoalData.push(companyData['goal_data']);
				vm.companyLabels = ["Sales","Plan"]
				vm.aggregateCompanyData = [];
				vm.calculate()
				vm.loadedComplete = true;
			})
		}

		vm.calculate = function(){
			vm.monthlyDiff = [];
			vm.yearlyDiff = [];
			vm.balance = [];
			var tmpAgg = 0;
			var tmpAggGoal = 0;
			var tmpAggArr = [];
			var tmpAggGoalArr = [];
			angular.forEach(vm.companyGoalData[0],function(val,k){
				vm.monthlyDiff.push(parseFloat(val) - parseFloat(vm.companyGoalData[1][k]))
				tmpAgg = tmpAgg + parseFloat(val)
				tmpAggArr.push(tmpAgg)
			})
			angular.forEach(vm.companyGoalData[1],function(val){
				tmpAggGoal = tmpAggGoal + parseFloat(val)
				tmpAggGoalArr.push(tmpAggGoal)
			})
			vm.aggregateCompanyData[0] = tmpAggArr
			vm.aggregateCompanyData[1] = tmpAggGoalArr
			vm.yearlyGoal = tmpAggGoalArr[11]
			angular.forEach(vm.aggregateCompanyData[0],function(element,key){
				vm.yearlyDiff.push(parseFloat(element) - parseFloat(vm.aggregateCompanyData[1][key]))
				vm.balance.push(parseFloat(vm.yearlyGoal - parseFloat(element)))
			})
		}

		vm.options = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Hardware Revenue Generated'}}]
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}

		vm.options2 = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Monthly Revenue'}}]
									},
									title:{
										display:true,text:"Monthly Revenue vs. Monthly Goal"
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}


		vm.options3 = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Monthly Revenue'}}]
									},
									title:{
										display:true,text:"Yearly Revenue vs. Yearly Goal"
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}
		vm.options4 = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Labor Revenue Generated'}}]
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}

		vm.options5 = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Total Revenue Generated'}}]
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}


		load_data()


	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportSalesThirdPartyController', reportSalesThirdPartyController);

	/** @ngInject */
	function reportSalesThirdPartyController($log,$scope, noc) {
		var vm = this;
		vm.loadedComplete = true
		var year = new Date().getFullYear()
		vm.selectedYear = ""+year
		vm.cached_years = {}
		vm.sortColumn = 'total[0]'; // default sort
		vm.reverse = false;
		vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']

		

		vm.labels = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"]
		vm.year = new Date().getFullYear()
		vm.month = new Date().getMonth() + 1;

		vm.filters = {"sort_by":"siteName","sort_order":"ASC","page_size":30,"active":true,"page":1}
		vm.getTotal = function(index) {
			var total = 0;
			angular.forEach(vm.data.reps.data, function(rep) {
				if (rep.total && rep.total[index] != null) {
					total += rep.total[index];
				}
			});
			return total;
		};

		vm.getNotifyTotal = function(index) {
			var total = 0;
			angular.forEach(vm.data.reps.data, function(rep) {
				if (rep.notify_total && rep.notify_total[index] != null) {
					total += rep.notify_total[index];
				}
			});
			return total;
		};

		vm.getInvoiceTotal = function(index) {
			var total = 0;
			angular.forEach(vm.data.reps.invoice_data, function(rep) {
				if (rep.total && rep.total[index] != null) {
					total += rep.total[index];
				}
			});
			return total;
		};

		vm.getInvoiceNotifyTotal = function(index) {
			var total = 0;
			angular.forEach(vm.data.reps.invoice_data, function(rep) {
				if (rep.notify_total && rep.notify_total[index] != null) {
					total += rep.notify_total[index];
				}
			});
			return total;
		};


		function load_data(){
			if(vm.cached_years[vm.year]){
				vm.data = vm.cached_years[vm.year]
				vm.data.reps.data.forEach(function(obj) {
				// default for yearly if missing
					obj.yearly_quota = obj.yearly_quota || 1000000;

					// watch yearly → update monthly on change
					$scope.$watch(
						function() { return obj.yearly_quota; },
						function(newVal) {
							if (newVal == null) return;
							obj.monthly_quota = newVal / 12;
							vm.cached_years[vm.year] = angular.copy(data)
						}
					);
				});
				vm.data.reps.invoice_data.forEach(function(obj) {
				// default for yearly if missing
					obj.yearly_quota = obj.yearly_quota || 1000000;

					// watch yearly → update monthly on change
					$scope.$watch(
						function() { return obj.yearly_quota; },
						function(newVal) {
							if (newVal == null) return;
							obj.monthly_quota = newVal / 12;
							vm.cached_years[vm.year] = angular.copy(data)
						}
					);
				});
				return;
			}
			vm.load_promise = noc.connectwise_routes.get({"route":'distributor-sales-data','year':vm.year}).$promise
			.then(function(data){
				$log.log(data)
				vm.data = data
				vm.cached_years[vm.year] = angular.copy(data)
				vm.data.reps.data.forEach(function(obj) {
				// default for yearly if missing
					obj.yearly_quota = obj.yearly_quota || 1000000;

					// watch yearly → update monthly on change
					$scope.$watch(
						function() { return obj.yearly_quota; },
						function(newVal) {
							if (newVal == null) return;
							obj.monthly_quota = newVal / 12;
							vm.cached_years[vm.year] = angular.copy(data)
						}
					);
				});
				vm.data.reps.invoice_data.forEach(function(obj) {
				// default for yearly if missing
					obj.yearly_quota = obj.yearly_quota || 1000000;

					// watch yearly → update monthly on change
					$scope.$watch(
						function() { return obj.yearly_quota; },
						function(newVal) {
							if (newVal == null) return;
							obj.monthly_quota = newVal / 12;
							vm.cached_years[vm.year] = angular.copy(data)
						}
					);
				});
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.exportCSV = function () {

			if (!vm.data.inv_table_data || vm.data.inv_table_data.length === 0) {
				alert("No data to export");
				return;
			}

			// First row is header
			var header = vm.data.inv_table_data[0];

			// Remaining rows
			var rows = vm.data.inv_table_data.slice(1);

			var csvContent = "";

			// Add header
			csvContent += header.join(",") + "\n";

			// Process each row
			rows.forEach(function(row) {
				var safe = row.map(function(value) {
					if (value === null || value === undefined) return "";
					var v = value.toString();

					// Escape commas/quotes
					if (v.indexOf(",") !== -1 || v.indexOf('"') !== -1) {
						v = '"' + v.replace(/"/g, '""') + '"';
					}
					return v;
				});

				csvContent += safe.join(",") + "\n";
			});

			// Trigger download
			var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
			var link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.setAttribute("download", "debug_export.csv");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};

		vm.exportDistributorCSV = function () {

			if (!vm.data.distributors.data || vm.data.distributors.data.length === 0) {
				alert("No data to export");
				return;
			}

			// CSV header
			var header = ['Distributor', 'Value'];
			var csvContent = header.join(",") + "\n";

			// Process each distributor object
			vm.data.distributors.data.forEach(function(row) {

				// Extract fields in correct CSV order
				var values = [
					row.name,
					row.total
				];

				// Escape each field
				var safe = values.map(function(v) {
					if (v === null || v === undefined) return "";

					v = v.toString();

					// Escape commas and quotes
					if (v.includes(",") || v.includes('"')) {
						v = '"' + v.replace(/"/g, '""') + '"';
					}

					return v;
				});

				csvContent += safe.join(",") + "\n";
			});

			// Download CSV
			var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
			var link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.setAttribute("download", "distributorValue.csv");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};


		load_data()
	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportSalesTerritoryController', reportSalesTerritoryController);

	/** @ngInject */
	function reportSalesTerritoryController($log,noc,$uibModal, $scope) {
		var vm = this;

		vm.searchVal = ""
		vm.sort_order = "ASC"
		vm.searchFor = "dealer/name"
		vm.sort_by = "dealer/name"
		vm.num_results = 10

		noc.region.get({"sort_by":"name"}).$promise
		.then(function(data){
			vm.regions = data.data
		})

		function load_data(){
			var obj
			if(vm.searchVal != ""){
				obj = {"dealer/active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"dealer/active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			obj['id'] = vm.selectedRegion.id
			obj['route'] = 'dealers'
			noc.region.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.searchVal = ""
			vm.sort_order = "ASC"
			vm.searchFor = "dealer/name"
			vm.sort_by = "dealer/name"
			vm.num_results = 10
			load_data()
		}

		vm.openDealer = function(){
			noc.userInfo.get({"active":true,"third_party/id":vm.selectedDealer.dealer.id}).$promise
			.then(function(data){
				vm.dealerUsers = data.data
				vm.modalInstance = $uibModal.open({
					templateUrl: 'viewContacts.html',
					scope: $scope,
					size: 'lg'
				});
			})
			
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss();
		};



	// 	vm.last_location = user.data.oldUrl
	// 	vm.visibleChart = 1
	// 	vm.maxCharts = 2
	// 	vm.loadedComplete = false;
	// 	vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']

	// 	vm.selectedYear = (new Date()).getFullYear()+""
	// 	noc.territories.query().$promise
	// 	.then(function(data){
	// 		vm.territories = data
	// 		vm.selectionObject = {"years":[vm.selectedYear],"territories":[data[data.length - 1].id]}
	// 		load_data()
	// 	})

	// 	vm.chartChange = function(l){
	// 		if(l == "d"){
	// 			vm.visibleChart = vm.visibleChart - 1
	// 		}
	// 		if(l == "u"){
	// 			vm.visibleChart = vm.visibleChart + 1
	// 		}
	// 	}

	// 	function load_data(){
	// 			yearlyHandle()
	// 			monthlyHandle()
	// 	}

	// 	function yearlyHandle(){
	// 		vm.labels = []
	// 		vm.series = []
	// 		vm.data = []
	// 		noc.report.query({route:"territories-production",year:vm.selectedYear}).$promise
	// 		.then(function(data){
	// 			// $log.log(data)
	// 			// vm.labels.push(vm.selectedYear)
	// 			angular.forEach(data,function(element){
	// 				vm.labels.push(element.name)
	// 				vm.data.push(element.revenue)
	// 				vm.loadedComplete = true
	// 			})
	// 		})
	// 	}

	// 	function monthlyHandle(){
	// 		vm.monthlyData = []
	// 		vm.monthlySeries = []
	// 		noc.report.update({route:"territories-production-monthly"},vm.selectionObject).$promise
	// 		.then(function(data){
	// 			angular.forEach(data,function(element){
	// 				angular.forEach(element.years,function(year, key){
	// 					vm.monthlySeries.push(element.name +" - "+ key)
	// 					vm.monthlyData.push(year.estimates)
	// 				})
	// 			})
	// 		})
	// 	}

	// 	vm.update_year = function(){
	// 		yearlyHandle()
	// 	}

	// 	vm.updateMonthly = function(){
	// 		monthlyHandle()
	// 	}
	// 	vm.monthlyLabel = ["January","February","March","April","May","June","July","August","September","October","November","December"]

	// 	vm.options = {
	// 								legend:{
	// 									display:false, position: 'bottom',labels:{fontSize:12}
	// 								},
	// 								elements:{
	// 									bar:{fill:false}
	// 								},
	// 								scales:{
	// 									yAxes:[{scaleLabel:{display:false,labelString:'Revenue Generated'}}]
	// 								},
	// 								tooltips: {
	// 									callbacks: {
	// 										label: function(tooltipItem, data) {
	// 											$log.log(data)
	// 											return "$" + Number(tooltipItem.xLabel).toFixed(0).replace(/./g, function(c, i, a) {
	// 												return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
	// 											});
	// 										}
	// 									}
	// 								}
	// 							}
	// 							vm.options2 = {
	// 														legend:{
	// 															display:true, position: 'bottom',labels:{fontSize:12}
	// 														},
	// 														elements:{
	// 															line:{fill:false,tension:.2}
	// 														},
	// 														scales:{
	// 															yAxes:[{scaleLabel:{display:true,labelString:'Monthly Revenue'}}]
	// 														},
	// 														title:{
	// 															display:false,text:"Monthly Revenue vs. Monthly Goal"
	// 														},
	// 														tooltips: {
	// 															callbacks: {
	// 																label: function(tooltipItem, data) {
	// 																	$log.log(data)
	// 																	return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
	// 																		return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
	// 																	});
	// 																}
	// 															}
	// 														}
	// 													}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('reportSalesLandingController', reportSalesLandingController);

  /** @ngInject */
	function reportSalesLandingController(user) {
		var vm = this;
		vm.reportResult = {'finished':false,'board':false}

		vm.selectedAreaFunction = function(id, title){
			vm.selectedArea = id;
			vm.title = title
		}

    vm.userData = user;

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportSalesInvoice', reportSalesInvoice);

	/** @ngInject */
	function reportSalesInvoice(noc,$log) {
		var vm = this;
		$log.log("Hello")
		vm.email_list = [];
		vm.submission_object = {"email":[],"quarter":null,"year":null}

		noc.userInfo.query().$promise
		.then(function(data){
			// $log.log(data)
			angular.forEach(data, function(element){
				if(element.active && element.user_id > 2 && element.user_id != 36){
					vm.email_list.push({"email":element.user_email,"name":element.user_full_name})
				}
			})
		})

		function year_filler(startYear) {
			years = []
			var currentYear = new Date().getFullYear(), years = [];
			startYear = startYear || 1980;
				while ( startYear <= currentYear ) {
					years.push(startYear++);
			}
			return years;
		}

		vm.available_years = year_filler(2013)
		vm.available_quarters = [null,'Q1','Q2','Q3','Q4']

		vm.send_it = function(){
			$log.log("Ran it")
			noc.invoice_report.save(vm.submission_object)
		}


	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportSalesIndividualController', reportSalesIndividualController);

	/** @ngInject */
	function reportSalesIndividualController($log,toastr, noc, $q, $timeout, $window, user) {
		var vm = this;
		vm.last_location = user.data.oldUrl
		vm.visibleChart = 1
		vm.maxCharts = 3
		vm.loadedComplete = false;
		var monthConvert = {"jan":0,"feb":1,"mar":2,"apr":3,"may":4,"jun":5,"jul":6,"aug":7,"sep":8,"oct":9,"nov":10,"dec":11}
		vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']
		//CHART DATA FOR MONTHLY TOTAL
		vm.labels = ["January","February","March","April","May","June","July","August","September","October","November","December"]
		vm.series = []
		vm.data = []
		var year = new Date().getFullYear()
		vm.selectedYear = ""+year
		vm.selectedRep = null
		var category_descriptions = {};
		noc.salesCategories.query().$promise
		.then(function(data){
			angular.forEach(data,function(element){
				category_descriptions[element.id] = element.name
			})
		})
		// CHART DATA FOR TOTAL PART COMPARISON
		vm.partCompareLables = []
		vm.partCompareData = []

		vm.chartChange = function(l){
			if(l == "d"){
				vm.visibleChart = vm.visibleChart - 1
			}
			if(l == "u"){
				vm.visibleChart = vm.visibleChart + 1
			}
		}

		// function formatDollar(num) {
		// var p = num.toFixed(2).split(".");
		// 	return "$" + p[0].split("").reverse().reduce(function(acc, num, i) {
		// 			return  num=="-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
		// 	}, "") + "." + p[1];
		// }

		function load_data(){
			vm.availableReps = [];
			noc.salesReps.query().$promise
			.then(function(data){
				$log.log(data)
				angular.forEach(data,function(element){
					if(element.years.includes(vm.selectedYear)){
						vm.availableReps.push(element)
					}
				})
				if(!vm.selectedRep){
					$log.log(vm.availableReps)
					vm.selectedRep = vm.availableReps[0]['user_id']
				}
				vm.update()
			})
		}

		vm.update_year = function(){
			load_data()
		}

		vm.update = function(){
			vm.cats = []
			vm.userChartData = [];
			vm.aggChartData = [];
			vm.totalChartData = [];
			var tmpTotalGoal = [0,0,0,0,0,0,0,0,0,0,0,0]
			var tmpTotalProduction = [0,0,0,0,0,0,0,0,0,0,0,0]
			noc.salesGoals.get({year:vm.selectedYear,rep_id:vm.selectedRep,type:"internal"}).$promise
			.then(function(goalData){
				angular.forEach(goalData.goal_data,function(el){
					vm.cats.push(category_descriptions[el.category] + " goal")
					var tmpAggGoal = 0;
					var tmpAggGoalArr = [];
					var tmpArr = [];
					angular.forEach(el.monthly_goals,function(goalValue,k){
						tmpArr.push(goalValue)
						tmpAggGoal = parseFloat(goalValue) + parseFloat(tmpAggGoal)
						tmpAggGoalArr.push(tmpAggGoal)
						if(k in monthConvert){
							tmpTotalGoal[monthConvert[k]] = parseFloat(tmpTotalGoal[monthConvert[k]]) + parseFloat(goalValue)
						}else{
							tmpTotalGoal[k] = parseFloat(tmpTotalGoal[k]) + parseFloat(goalValue)
						}
					})
					vm.userChartData.push(tmpArr)
					vm.aggChartData.push(tmpAggGoalArr)
				})
				angular.forEach(tmpTotalGoal,function(element,key){
					if(key == 0){
						tmpTotalGoal[key] = tmpTotalGoal[key]
					}else{
						var previous_key = key - 1
						tmpTotalGoal[key] = parseFloat(tmpTotalGoal[key]) + parseFloat(tmpTotalGoal[previous_key])
					}
				})
				noc.salesProduction.get({year:vm.selectedYear,rep_id:vm.selectedRep,type:"internal"}).$promise
				.then(function(productionData){
					// $log.log(productionData)
					vm.productionData = productionData
					angular.forEach(productionData.production_data,function(el){
						vm.cats.push(category_descriptions[el.category] + " production")
						var tmpArr = [];
						var tmpProd = 0;
						var tmpProdArr = [];
						angular.forEach(el.monthly_production,function(goalValue,k){
							tmpArr.push(goalValue)
							tmpProd = parseFloat(tmpProd) + parseFloat(goalValue)
							tmpProdArr.push(tmpProd)

							if(k in monthConvert){
								tmpTotalProduction[monthConvert[k]] = parseFloat(tmpTotalProduction[monthConvert[k]]) + parseFloat(goalValue)
							}else{
								tmpTotalProduction[k] = parseFloat(tmpTotalProduction[k]) + parseFloat(goalValue)
							}
						})
						vm.userChartData.push(tmpArr)
						vm.aggChartData.push(tmpProdArr)
					})
					angular.forEach(tmpTotalProduction,function(element,key){
						if(key == 0){
							tmpTotalProduction[key] = tmpTotalProduction[key]
						}else{
							var previous_key = key - 1
							tmpTotalProduction[key] = parseFloat(tmpTotalProduction[key]) + parseFloat(tmpTotalProduction[previous_key])
						}
					})
				})
				vm.totalChartData.push(tmpTotalGoal)
				vm.totalChartData.push(tmpTotalProduction)
				vm.loadedComplete = true
			})
		}

		vm.totalRevenue = function(){
			var total = 0
			if(vm.productionData){
				angular.forEach(vm.productionData.estimate_data,function(element){
					total = total + parseFloat(element.price)
				})
			}
			return total
		}

		vm.options = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Sales'}}]
									},
									title:{
										display:true,text:"Sales Production vs. Goals"
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}
		vm.options2 = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Sales'}}]
									},
									title:{
										display:true,text:"Sales Production Vs. Goals"
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}

		vm.options3 = {
									legend:{
										display:true, position: 'bottom',labels:{fontSize:12}
									},
									elements:{
										line:{fill:false,tension:.2}
									},
									scales:{
										yAxes:[{scaleLabel:{display:true,labelString:'Sales'}}]
									},
									title:{
										display:true,text:"Sales Production Vs. Goals"
									},
									tooltips: {
										callbacks: {
											label: function(tooltipItem, data) {
												$log.log(data)
												return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
													return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
												});
											}
										}
									}
								}

		load_data()


	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportProcurementSerialNumberController', reportProcurementSerialNumberController);

	/** @ngInject */
	function reportProcurementSerialNumberController($log,toastr, noc, $q, $location, user, $scope, $uibModal) {
		var vm = this;
		vm.last_location = user.data.oldUrl
		vm.reportResult = {'finished':false,'board':false}

		vm.reportRun = false

		vm.runOnEnter = function(keyEvent){
			if(keyEvent.which === 13){
				vm.serialReport()
			}
		}

		vm.serialReport = function(sn){
			vm.reportResult = {'finished':false,'board':false}
			vm.reportRun = true
			vm.multipleError = null
			vm.rmaArray = []
			var reportSn

			if(sn){
				reportSn = sn
				vm.closeModal()
			}else{
				reportSn = vm.serialNumber
				
			}

			//Handles if the serial number is a finished product
			if(!vm.jnl_only){
				var a = reportSn.replaceAll(":","")
				vm.reportPromise = noc.quantumHardware.get({"serial_number":'"%'+a+'%"',"page_size":20}).$promise
				.then(function(finishedData){
					if(finishedData.count == 1){
						finishedData = finishedData.data[0]
						$log.log(finishedData)
						if(finishedData.associated_serial){
							noc.serialGenerator.get({id:finishedData.associated_serial}).$promise
							.then(function(preData){
								vm.reportResult.finished = finishedData
								vm.reportResult.board = preData
							}).catch(function(){
								vm.reportResult.finished = finishedData
							})
						}else{
							vm.reportResult.finished = finishedData
						}
						
						// angular.forEach(rma,function(element){
						// 	if(element.serial_number == reportSn){
						// 		vm.rmaArray.push(noc.rma.get({id:element.id}))
						// 	}
						// })
					}else{
						//For Multiple Results Returned
						if (finishedData.count > 0){
							$log.log(finishedData.count)
							if(finishedData.count <= 15){
								vm.multipleResultData = finishedData.data
							}else{
								vm.multipleError = "More than 15 Results, please narrow your search"
							}
							multipleResultDialog(false)
						}
					}
				})
			}

			//Handles if the serial number is a pre assembled board

			if(!vm.finished_only && !vm.multipleError){
				noc.serialGenerator.get({"serial_number":parseInt(reportSn)}).$promise
				.then(function(preData){
					$log.log(preData)
					if(preData.count == 1){
						if(preData.data[0].final_product){
							noc.quantumHardware.get({"id":preData.data[0].final_product.identifier}).$promise
							.then(function(finishedData){
								vm.reportResult.finished = finishedData
								vm.reportResult.board = preData.data[0]
							}).catch(function(){
								vm.reportResult.board = preData.data[0]
							})
						}else{
							vm.reportResult.board = preData.data[0]
						}
					}else{
						if (preData.count > 0){
							if(preData.count <= 15){
								vm.multipleResultData = preData.data
							}else{
								vm.multipleError = "More than 15 Results, please narrow your search"
							}
							multipleResultDialog(true)
						}
					}
				})
			}
		}

		vm.load_from_serial_generator_id = function(serial_id){
			noc.serialGenerator.get({"id":serial_id}).$promise
			.then(function(preData){
				if(preData.final_product){
					noc.quantumHardware.get({"id":preData.final_product.identifier}).$promise
					.then(function(finishedData){
						vm.reportResult.finished = finishedData
						vm.reportResult.board = preData
					}).catch(function(){
						vm.reportResult.board = preData
					})
				}else{
					vm.reportResult.board = preData
				}
				vm.closeModal()
			})	
		}


		vm.back = function(){
			//$location.path("/report-procurement-landing");
			// console.log(oldUrl)
			$location.path(user.data.oldUrl);
		}

		var multipleResultDialog = function(jnl_search){
				vm.jnl_search = jnl_search
				vm.modalInstance = $uibModal.open({
					templateUrl: 'multipleResults.html',
					scope: $scope,
					size: 'md'
				});
			}

		vm.closeModal = function(){
		vm.modalInstance.dismiss();
		};

		vm.serialReset = function(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'serialNumberData.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.resetSerialNumber = function(obj){
			var final_product_mac = obj['final_product']['identifier']

			var l = [{"key":"associated_serial","value":null}]

			noc.quantumHardware.patch({"id":final_product_mac},{"updates":l}).$promise
			.then(function(){
				toastr.success("Serial Number Reset Successfully")
				vm.closeModal()
				vm.serialGenerator = obj.serial_number
				vm.serialReport(obj.serial_number)
			})
			.catch(function(err){
				$log.log(err)
			})
		}

	}
	
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportProcurementRequiredSubParts', reportProcurementRequiredSubParts);

	/** @ngInject */
	function reportProcurementRequiredSubParts($log,toastr, noc) {
		var vm = this;
		vm.builds = []
		vm.populatePromise = noc.build.get({"page_size":1000,"active":true}).$promise
		.then(function(data){
			vm.builds = data.data
		})

		vm.loadResults = function(){
			vm.selectedBuilds = []
			var parts = {}
			angular.forEach(vm.selectedBuildArray, function(element){
				noc.build.get({'id':element.id,"route":"included-parts","page_size":1000}).$promise
				.then(function(full_build){
					angular.forEach(full_build.data, function(included_part){
						$log.log(element)
						var my_quantity = included_part.quantity
						if(parts.hasOwnProperty(included_part.product_data.part_number)){
							parts[included_part.product_data.part_number][0] = parts[included_part.product_data.part_number][0] + (my_quantity * element.requested_quantity)
						}else{
							parts[included_part.product_data.part_number] = [my_quantity * element.requested_quantity,included_part.product_data.name]
							noc.connectwise_routes.get({"id":included_part.product_data.part_number,"route":"on-hand","page_size":1000}).$promise
							.then(function(on_hand_return){
								included_part['on_hand'] = on_hand_return.count
								parts[included_part.product_data.part_number].push(on_hand_return.count)
							})
						}
					})
					element['included_parts'] = full_build.data
					vm.pd = parts
				})
			})
		}

		vm.all_have_quantity = function(){
			var resp = true
			angular.forEach(vm.selectedBuildArray, function(element){
				if(!element.requested_quantity){
					resp = false
				}
			})
			return resp
		}
		

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportProcurementPurchaseOrderController', reportProcurementPurchaseOrderController);

	/** @ngInject */
	function reportProcurementPurchaseOrderController($log,toastr, noc, $q, $window, user, $routeParams, DTOptionsBuilder, DTColumnDefBuilder) {
		var vm = this;
		vm.last_location = user.data.oldUrl
		var initialValue = $routeParams.id
		var serialNumberArray = []

		var promises = []
		vm.loadDetails = function(poID){
			noc.purchaseOrder.get({id:poID}).$promise
			.then(function(data){
				vm.selectedPo = data
				angular.forEach(data.serial_data,function(snId){
					promises.push(
						noc.serialGenerator.get({id:snId,route:"ID"}).$promise
						.then(function(serialNumberData){
							serialNumberArray.push(serialNumberData)
							vm.detailPromise = $q.all(promises)
							.then(function(){
								vm.serialNumberArray = serialNumberArray
							})
						})
					)
				})
			})
		}

		vm.txnReport = function(){
			$window.open('/report-transaction/'+vm.selectedPo.transaction_id)
		}


		noc.product.query().$promise
		.then(function(partData){
			vm.allParts = partData
		})

		vm.txnActions = noc.transactionLogAction.query()
		vm.nocUsers = noc.userInfo.query()

		if(initialValue != -1){
			vm.loadDetails(initialValue)
		}else{
			vm.poData = noc.purchaseOrder.query().$promise
			.then(function(data){
				vm.poData = data
				vm.dtColumnDefs =[
					DTColumnDefBuilder.newColumnDef([2]).withOption('type', 'date')
				]
				vm.dtOptions = DTOptionsBuilder.newOptions()
				.withOption('order',[[2,'desc']]);
			})
		}


	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportProcurementOnHandController', reportProcurementOnHandController);

	/** @ngInject */
	function reportProcurementOnHandController($log,toastr, noc) {
		var vm = this;
		vm.builds = []
		vm.populatePromise = noc.build.get({"page_size":1000,"active":true}).$promise
		.then(function(data){
			vm.builds = data.data
			// angular.forEach(data, function(element){
				// noc.product.get({'id':element.product_id}).$promise
				// .then(function(product){
				// 	element['name'] = product.general.name.value
				// 	element['part_number'] = product.part_number
				// 	vm.builds.push(element)

				// })
			// })
		})

	vm.loadResults = function(){
		vm.selectedBuilds = []
		// var on_hand_return = {'count':0}
		angular.forEach(vm.selectedBuildArray, function(element){
			var index_of_lowest = 0
			var max_to_build = 1000000000
			noc.build.get({'id':element.id,"route":"included-parts","page_size":1000}).$promise
			.then(function(full_build){
				// $log.log(full_build)
				angular.forEach(full_build.data, function(included_part,includedPartKey){
					var my_quantity = included_part.quantity
					// $log.log(included_part)
					noc.connectwise_routes.get({"id":included_part.product_data.part_number,"route":"on-hand","page_size":1000}).$promise
					.then(function(on_hand_return){
						included_part['on_hand'] = on_hand_return.count
						var my_max = on_hand_return.count / my_quantity
						$log.log(my_max)
						if(my_max < max_to_build && !included_part.ignore){
							index_of_lowest = includedPartKey
							max_to_build = my_max
							element['max'] = max_to_build
							element['index_of_lowest'] = index_of_lowest
							$log.log(max_to_build)
						}
					})
				})
				element['included_parts'] = full_build.data
				vm.selectedBuilds.push(element)
			})
		})
	}

	vm.update_ignore = function(selectedBuildIndex){
		var full_build = vm.selectedBuilds[selectedBuildIndex]
		$log.log(full_build)
		var index_of_lowest = 0
		var max_to_build = 1000000000
		angular.forEach(full_build.included_parts, function(included_part,includedPartKey){
			var my_quantity = included_part.quantity
			var my_on_hand = included_part.on_hand
			var my_max =  my_on_hand / my_quantity
			// $log.log(my_max)
			if(my_max < max_to_build && !included_part.ignore){
				index_of_lowest = includedPartKey
				max_to_build = my_max
				full_build['max'] = max_to_build
				full_build['index_of_lowest'] = index_of_lowest
				$log.log(max_to_build)
			}
		})

	}


	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('reportProcurementLandingController', reportProcurementLandingController);

  /** @ngInject */
	function reportProcurementLandingController() {
		var vm = this;
		vm.reportResult = {'finished':false,'board':false}

		vm.selectedAreaFunction = function(id, title){
			vm.selectedArea = id;
			vm.title = title
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('receiveProductController', receiveProductController);

	/** @ngInject */
	function receiveProductController($log, toastr, noc, $uibModal, $scope) {
		var vm = this;
		var defaultPo = {
            "closed": false,
            "date_created": null,
            "date_processed": null,
            "id": null,
            "notes": null,
            "po_number": null,
            "product_data": {
                "connectwise_id": null,
                "id": null,
                "name": null,
                "part_number": null,
                "quantity": 0,
                "serial_max": null,
                "serial_min": null
            },
            "transaction_id": null
        }
		vm.newSerialLine = null
		vm.recommendedStart = null
		vm.partNumber = null
		vm.preTestArr = []

		//Parts that are currenlty serialized by JNL
		vm.serializedParts = []
		vm.preTestParts = []
		noc.product.get({"jnl_serialized":true,"page_size":1000}).$promise
		.then(function(data){
			vm.serializedParts = data.data
		})

		function load_data(){
			var obj = {}
			
			if(vm.searchVal != ""){
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			if(!vm.showClosed){
				obj['closed'] = false
			}
			vm.loadPromise = noc.purchaseOrder.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.currentPage = 1
			vm.sort_by = "date_created"
			vm.sort_order = "DESC"
			vm.searchFor = "po_number"
			vm.searchVal = ""
			vm.num_results = 10
			vm.showClosed = false
			load_data()
		}

		// clear filters to define defautls and do initial load
		vm.clear_filters()
		// load_data()


		vm.getRecommendedStartSerial = function(){
			var recommendedStart = null
			noc.serialGenerator.get({"product_data/id":vm.poDetail.product_data.id,"page_size":1,"sort_order":"DESC","sort_by":"id"},function(data){
				if(data.data_length == 1){
					recommendedStart = Number(data.data[0].serial_number) + 1
					vm.highest_existing_serial = Number(data.data[0].serial_number)
				}
				vm.poDetail.product_data.serial_min = recommendedStart
			})
			noc.serialGenerator.get({"product_data/id":vm.poDetail.product_data.id,"page_size":1,"sort_order":"ASC","sort_by":"id"},function(data){
				if(data.data_length == 1){
					vm.lowest_existing_serial = Number(data.data[0].serial_number)
				}
			})
		}

		vm.getEndSerial = function(){
			vm.poDetail.product_data.serial_max = null
			if(vm.poDetail.product_data.quantity && vm.poDetail.product_data.serial_min){
				vm.poDetail.product_data.serial_max = (Number(vm.poDetail.product_data.serial_min) + Number(vm.poDetail.product_data.quantity)) - 1
			}
		}

		vm.submitSerials = function(){
			vm.ladda = true
			noc.serialGenerator.save({'startSerial':vm.startSerial,'endSerial':vm.endSerial,'poNumber':vm.selectedPo,'partNumber':vm.partNumber.id,'transaction_id':vm.poDetail.transaction_id},function(){
				vm.newSerialLine = null
				vm.recommendedStart = null
				vm.partNumber = null
				vm.startSerial = null
				vm.endSerial = null
				vm.qty = null
				vm.ladda=false
				vm.populateDetails(vm.selectedPo,true)
				toastr.success('Serial Numbers Created');
			},function(){
				toastr.warning('Serial Numbers Not Entered')
			})
		}

		vm.newSerialsValid = function(){
			var valid = true
			// if(vm.new){
			// 	if(vm.poDetail){
			// 		if(vm.poDetail.product_data.serial_min  && vm.poDetail.product_data.serial_max && vm.poDetail.product_data.id && vm.poDetail.product_data.quantity && vm.poDetail.po_number){
			// 			if(vm.poDetail.product_data.serial_min.toString().length == 6 && (vm.poDetail.product_data.serial_max <= 999999 && vm.poDetail.product_data.serial_max >= 100000)){
			// 				if(vm.poDetail.product_data.serial_min < vm.lowest_existing_serial || vm.poDetail.product_data.serial_min > vm.highest_existing_serial){
			// 					if(vm.poDetail.product_data.serial_max < vm.lowest_existing_serial || vm.poDetail.product_data.serial_max > vm.highest_existing_serial){
			// 						if(vm.poDetail.product_data.quantity > 0){
			// 							if(Number(vm.poDetail.product_data.serial_max) >= Number(vm.poDetail.product_data.serial_min)){
			// 								vm.error = null
			// 								valid = true
			// 							}else{
			// 								vm.error = "Start Serial is in previously used range"
			// 							}
			// 						}
			// 					}
			// 				}
			// 			}
			// 		}else{
			// 			vm.error = "Start and End serial number must be six digits"
			// 		}
			// 	}
			// }else{
			// 	if(vm.poDetail.product_data.quantity > 0){
			// 		if(Number(vm.poDetail.product_data.serial_max) >= Number(vm.poDetail.product_data.serial_min)){
			// 			vm.error = null
			// 			valid = true
			// 		}
			// 	}
			// }
			return valid
		}

		vm.openEdit = function(key){
			vm.serials_in_build = true
			vm.poDetail = angular.copy(vm.data.data[key])
			noc.serialGenerator.get({"po_number":vm.poDetail.id,"part_of_final_build":true,"page_size":1}).$promise
			.then(function(data){
				$log.log(data)
				if(data.count == 0){
					vm.serials_in_build = false
				}
				vm.edit = true
				vm.modalInstance = $uibModal.open({
					templateUrl: 'newPurchaseOrder.html',
					scope: $scope,
					size: 'lg'
				});
			})
		}

		vm.newPoDialog = function(){
			vm.poDetail = angular.copy(defaultPo)
			vm.new = true
			vm.modalInstance = $uibModal.open({
				templateUrl: 'newPurchaseOrder.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.closeModal = function(){
			vm.new = false
			vm.edit = false
			vm.selectedPo = null
			vm.poDetail = null
			vm.modalInstance.dismiss();
		};

		//Saves New PO
		vm.savePO = function(){
			noc.purchaseOrder.save(vm.poDetail,function(){
				vm.new = false
				vm.modalInstance.dismiss();
				toastr.success('Purchase Order Created');
				load_data()
			},function(error){
				toastr.warning("Failed To Create PO")
				$log.log(error)
			})
		}

		vm.updatePO = function(){
			noc.purchaseOrder.update({"id":vm.poDetail.id},vm.poDetail,function(){
				vm.edit = false
				vm.modalInstance.dismiss();
				toastr.success('Purchase Order Updated');
				// vm.populateDetails(vm.poDetail.id,true)
				load_data()
			},function(error){
				toastr.warning("Failed To Update PO")
				$log.log(error)
			})
		}

		vm.removePO = function(){
			noc.purchaseOrder.delete({"id":vm.poDetail.id}).$promise
			.then(function(){
				vm.modalInstance.dismiss();
				toastr.success('Purchase Order Removed');
				load_data()
			},function(error){
				toastr.warning("Failed To Remove PO")
				$log.log(error)
			})
		}
	}

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportProcurementForecastController', reportProcurementForecastController);

	/** @ngInject */
	function reportProcurementForecastController($log,toastr, noc, $q, $uibModal, $scope) {
		var vm = this;
		vm.parts_indexer = {}
		vm.loaded = false
		function build_arr(need_array){
			var a = Array.from({length:vm.parts_we_care_about_length})
			for(var i=0; i<vm.parts_we_care_about_length; i++){
				if(need_array){
					a[i]=[0,'I',false]
				}else{
					a[i] = 0
				}
			}
			return a
		}

		function days_old(text_date_input){
			var install = new Date(text_date_input)
			var today = new Date()
			var diff = install - today
			var num = 1000*60*60*24
			var days = diff / num
			return Math.round(days)
		}

		vm.parts_we_care_about = {}
		var promises = []
		vm.promises = noc.product.query({'on_build_forecast':true}).$promise
		.then(function(data){
			var c = 0
			vm.parts_we_care_about_length = data.length
			angular.forEach(data, function(element){
				promises.push(noc.connectwise_on_hand.get({"part_number":element.part_number},function(on_hand_return){
					// vm.parts_indexer[element.part_number] =
					vm.parts_we_care_about[element.part_number]={"name":element.name,"part_number":element.part_number,"index":c,"on_hand":on_hand_return.count}
					c+=1
				}).$promise)
			})
			$q.all(promises)
				.then(function(){
					vm.load_data()
				})
		})


// Loading estimates
		vm.load_data = function(){
			vm.promises = []
			vm.display = []
			vm.total = build_arr(false)
			vm.day30 = build_arr(false)
			vm.day60 = build_arr(false)
			vm.day90 = build_arr(false)
			vm.dayOver90 = build_arr(false)
			noc.v2estimates.query({'part_of_forecast_report':true,'ORDER':'estimated_install'}).$promise
			.then(function(data){
				angular.forEach(data, function(element){
					var local_promises = []
					var a = build_arr(true)
					var my_index = vm.display.length
					var idate
					if(element.estimated_install == ''){
						idate = '1969-12-31'
					}else{
						idate = element.estimated_install
					}
					vm.display.push({"customer_name":element.site_name,"estimate_id":element.estimate_id,"estimate_type":element.system_type_id,"install_date":idate,"parts":a})
					var install_days = days_old(idate)
					vm.promises.push(noc.v2estimates.query({"id":element.estimate_id,"route":"part-summary"},function(parts_in_estimate){
						angular.forEach(parts_in_estimate, function(part){
							if(vm.parts_we_care_about.hasOwnProperty(part.part_number)){
								var part_index = vm.parts_we_care_about[part.part_number]['index']
								angular.forEach(part.altered_quantity_sub_parts,function(sub_part_obj){
									local_promises.push(noc.v2estimates.query({"id":element.estimate_id,"route":"part-summary","part_number":sub_part_obj.part_number},function(sub_part_response){
										if(sub_part_response.length > 0){
											var sub_quantity = sub_part_response[0].quantity
											var multiplier = sub_part_obj.quantity_multiplier
											var total_from_sub = sub_quantity*multiplier
											part.quantity = total_from_sub+part.quantity
										}
									}).$promise)
								})
								$q.all(local_promises)
								.then(function(){
									vm.display[my_index]['parts'][part_index][0] = part.quantity
									vm.display[my_index]['parts'][part_index][1] = part.part_number
									vm.display[my_index]['parts'][part_index][2] = part.picked_for_order
									if(!vm.display[my_index]['parts'][part_index][2]){
										vm.total[part_index] = vm.total[part_index] + part.quantity
										if(install_days <= 30){
											vm.day30[part_index] = vm.day30[part_index] + part.quantity
										}else if(install_days > 30 && install_days <=60){
											vm.day60[part_index] = vm.day60[part_index] + part.quantity
										}else if(install_days > 60 && install_days <=90){
											vm.day90[part_index] = vm.day90[part_index] + part.quantity
										}else if(install_days > 90){
											vm.dayOver90[part_index] = vm.dayOver90[part_index] + part.quantity
										}
									}
								})
							}
						})
					}).$promise)
				})
				$log.log(vm.promises)
				$q.all(vm.promises)
				.then(function(){
					vm.loaded = true
				})
			})
		}

		vm.checkProposal = function(){
			vm.add_promise = noc.estimates.get({'id':vm.new_proposal}).$promise
			.then(function(data){
					vm.possibleCust = data
					vm.modalInstance = $uibModal.open({
						templateUrl: 'newProposal.html',
						scope: $scope,
						size: 'md'
					});
			})
			.catch(function(){
				toastr.warning("Proposal Not Found")
			})
		}

		vm.closeModal = function(){
      vm.possibleCust = null;
			vm.id_for_removal = null
      vm.modalInstance.dismiss();
    };

		vm.addProposal = function(){
			noc.v2estimates.patch({"id":vm.possibleCust.estimate_id},{"update_cols":[{'key_name':'part_of_forecast_report','value':1}]}).$promise
			.then(function(){
				vm.load_data()
				vm.closeModal()
			})
			.catch(function(){
				toastr.warning("Failed to add this proposal, probably Drew's fault")
			})
		}

		vm.removeProposal = function(e_id){
			vm.id_for_removal = e_id
			vm.modalInstance = $uibModal.open({
				templateUrl: 'confirmRemove.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.finishRemoval = function(){
			noc.v2estimates.patch({"id":vm.id_for_removal},{"update_cols":[{'key_name':'part_of_forecast_report','value':0}]}).$promise
			.then(function(){
				vm.load_data()
				vm.closeModal()
			})
			.catch(function(){
				toastr.warning("Failed to remove this proposal, probably Drew's fault")
			})
		}

		vm.pickPart = function(e_id,part_number,val){
			noc.estimate_data.patch({"id":e_id,"route":"part-summary","part_number":part_number},{"update_cols":[{'key_name':'picked_for_order','value':val}]}).$promise
			.then(function(){
				if(val==1){
					toastr.success("Part Picked, removed from totals")
					vm.load_data()
				}
				if(val==0){
					toastr.success("Part Un-Picked, added back to totals")
					vm.load_data()
				}
			}).catch(function(){
				toastr.warning("Pick Failed, Probably Drew's fault")
			})
		}


	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportProcurementBuildRequestController', reportProcurementBuildRequestController);

	/** @ngInject */
	function reportProcurementBuildRequestController($log,toastr, noc, $q, $timeout, $window, user, $routeParams, DTOptionsBuilder, DTColumnDefBuilder) {
		var vm = this;
		vm.last_location = user.data.oldUrl
		var initialValue = $routeParams.id
		vm.visibleChart = 1
		vm.maxCharts = 3
		vm.loadedComplete = false;
		var year = new Date().getFullYear()
		vm.selectedYear = ""+year
		//CHART DATA FOR MONTHLY TOTAL
		vm.labels = ["January","February","March","April","May","June","July","August","September","October","November","December"]
		vm.series = []
		vm.data = []
		vm.years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028']

		// CHART DATA FOR TOTAL PART COMPARISON
		vm.partCompareLables = []
		vm.partCompareData = []

		vm.loadDetails = function(requestID){
			noc.buildRequest.get({id:requestID}).$promise
			.then(function(data){
				vm.selectedRequest = data
				productBuildCost()
			})
		}

		vm.txnReport = function(){
			$window.open('/report-transaction/'+vm.selectedRequest.transaction_id)
		}

		vm.get_data = function(){
			noc.product.query().$promise
			.then(function(partData){
				vm.allParts = partData
				load_data()
				noc.report.get({route:'report-build-request',year:vm.selectedYear}).$promise
				.then(function(data){
					vm.data = data.data
					vm.series = data.parts
					vm.partCompareData = data.totals_per_part
					vm.loadedComplete = true;
				})
			})
			noc.report.query({route:'report-build-request',ext:'summary',year:vm.selectedYear}).$promise
			.then(function(data){
				vm.summaryData = data
			})
		}

		vm.chartChange = function(l){
			if(l == "d"){
				vm.visibleChart = vm.visibleChart - 1
			}
			if(l == "u"){
				vm.visibleChart = vm.visibleChart + 1
			}
		}

		vm.txnActions = noc.transactionLogAction.query()
		vm.nocUsers = noc.userInfo.query()

		function load_data(){
			if(initialValue != -1){
				vm.loadDetails(initialValue)
			}else{
				noc.buildRequest.query({year:vm.selectedYear}).$promise
				.then(function(data){
					vm.buildRequestData = data
					vm.dtColumnDefs =[
						DTColumnDefBuilder.newColumnDef([3]).withOption('type', 'date')
					]
					vm.dtOptions = DTOptionsBuilder.newOptions()
					.withOption('order',[[3,'desc']]);
				})
			}
		}


		function productBuildCost(){
			vm.laborCost = {}
			vm.costArr = {}
			var laborCost = 0
			angular.forEach(vm.selectedRequest.product_data,function(element){
				var hourlyLabor = parseFloat(element.labor_rate) / 60
				laborCost = hourlyLabor * element.labor_time
				angular.forEach(element.product_pieces,function(value){
					var individualQty = parseInt(value.piece_qty) / element.qty
					if(angular.isUndefined(vm.costArr[element.id])){
						vm.costArr[element.id] = []
					}
					vm.costArr[element.id].push(value.cost * individualQty)
				})
				vm.laborCost[element.id] = laborCost
			})
		}

		vm.hardwareCost = function(id){
			return vm.costArr[id].reduce(function(a, b) { return parseFloat(a) + parseFloat(b); }, 0);
		}

		vm.pieces = true
		vm.togglePieces = function(value){
			vm.pieces = value
		}

		vm.back = function(){
			vm.selectedRequest = null
		}

		vm.get_data()

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportInstallQuoteController', reportInstallQuoteController);

	/** @ngInject */
	function reportInstallQuoteController($log,toastr, noc) {
		var vm = this;

		noc.thirdParty.query().$promise
		.then(function(data){
			vm.subList = data
			// vm.subList.push({"id":null,"name":"JNL Internal"})
		})

		function load_data(){
			noc.report.query({route:"install-report"}).$promise
			.then(function(data){
				vm.data = data
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Failed to load data")
			})
		}

		vm.revenue = function(k){
			if(vm.data){
				var income = vm.data[k].income
				var cost = parseFloat(vm.data[k].cost) + parseFloat(vm.data[k].additional_cost)
				var profit = parseFloat(income) - parseFloat(cost)
				var per = (parseFloat(profit) / parseFloat(income) *100)

				return [profit,per]
			}
		}

		vm.goEdit = function(k){
			vm.selectedQuote = vm.data[k]
		}

		vm.update = function(){
			noc.report.put({route:"install-report",ext:vm.selectedQuote.id},vm.selectedQuote).$promise
			.then(function(){
				toastr.success("Update Successful")
				load_data()
				vm.selectedQuote = null
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Update Unsuccessful")
			})
		}

		load_data()
	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('reportInstallLandingController', reportInstallLandingController);

	/** @ngInject */
	function reportInstallLandingController($log) {
		var vm = this;
		$log.log(vm)

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('receiveProductDetailController', receiveProductDetailController);

  /** @ngInject */
	function receiveProductDetailController(toastr, noc, flask_app, $routeParams,$location) {
		var vm = this;
		vm.submitStatus = false
		// var poId = $routeParams.poId;
		// var lineId = $routeParams.lineItemId;
		var poNumber = $routeParams.poNumber;
		// var lineData = flask_app.lineItem.get({poId:poId,lineId:lineId},function(data){
		// 	vm.partNumber = data.data.product.identifier
		// 	vm.maxQty = data.data.quantity
		// 	load_index()
		// })
		var current_index = null
		function load_index(){
			current_index = noc.serialIndex.get({id:vm.partNumber});
		}
		vm.submitAmount = 0
		vm.submit = function(){
			if(vm.submitCheck()){
				var stop_val = Number(vm.submitAmount) + Number(current_index['index_value'])
				var serial_array = [];
				for (var i = current_index['index_value']; i < stop_val; i++) {
					serial_array.push(i)
				}
				noc.serialIndex.update({id:vm.partNumber},{new_index:stop_val})
				noc.serialGenerator.save({partNumber:vm.partNumber,poNumber:poNumber,serialNumbers:serial_array})
				vm.minSN = current_index['index_value']
				vm.maxSN = serial_array[serial_array.length-1]
				load_index()
				vm.submitStatus = true
			}
		}

		vm.submitCheck = function(){
			if(isNaN(vm.submitAmount) || vm.submitAmount <= 0 || vm.submitStatus || vm.submitAmount > vm.maxQty){
				return false
			}else{
				return true
			}
		}

		vm.go = function(){
			$location.path('/receiveProduct');
		}
	}
})();
(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('quantumStatusController', quantumStatusController);

  /** @ngInject */
	function quantumStatusController(toastr, noc, $routeParams,$log) {
		var vm = this;

		vm.swType = $routeParams.swType

		vm.customerObject = {}
		vm.currentPage = 1
		vm.sort_by = "siteName"
		vm.sort_order = "ASC"
		vm.searchFor = "siteName"
		vm.searchVal = ""
		vm.num_results = 10
		vm.filters = {"sort_by":"siteName","sort_order":"ASC","page_size":10,"active":true,"page":1}

		vm.serverTypes = [{"id":1,"name":"Cloud"},{"id":2,"name":"On Site"},{"id":3,"name":"On Site Virtual"}]

		function load_data(){
			var obj
			if(vm.swType != 'SH'){
				// if(vm.searchVal != "" && vm.searchFor != 'site_id'){
				// 	obj = {"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				// 	obj[vm.searchFor]='"%'+vm.searchVal+'%"'
				// }
				// else if(vm.searchVal != "" && vm.searchFor == 'site_id'){
				// 	obj = {"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				// 	obj[vm.searchFor]=vm.searchVal
				// }else{
				// 	obj = {"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
					
				// }
				// if(vm.backupError == 'yes'){
				// 	$log.log("HILLO")
				// 	obj['backup/timestamp']='">24"'
				// 	obj['support_contract_active']='true'
				// }
				var tmp_siteName = vm.filters.siteName
				if(vm.filters.siteName && vm.filters.siteName != ""){
					vm.filters.siteName = '"'+vm.filters.siteName+'"'
				}
				var tmp_serverVersion = vm.filters.serverVersion
				if(vm.filters.serverVersion && vm.filters.serverVersion != ""){
					vm.filters.serverVersion = '"'+vm.filters.serverVersion+'"'
				}
				vm.load_promise = noc.quantumCustomer.get(vm.filters).$promise
				.then(function(data){
					vm.qStatus = data
					vm.filters.siteName = tmp_siteName
					vm.filters.serverVersion = tmp_serverVersion
				})
			}else{
				vm.qStatus = noc.customers.query({'is_safe_health':true})
			}
		}

		load_data()

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.filters.sort_order == 'ASC'){
				vm.filters.sort_order = 'DESC'
			}else{
				vm.filters.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.filters = {"sort_by":"siteName","sort_order":"ASC","page_size":10,"active":true,"page":1}
			load_data()
		}

		vm.possibleCustomers = function(){
			var n = '"%'+vm.customerObject.siteName+'%"'
			noc.customers.get({"name":n},function(data){
				vm.customerSelected = false;
				vm.connectwiseCustomers = data;
			})
		}

		function newCustomer(){
			vm.customerObject={	"siteName":null,
								"sitePhone":null,
								"siteStreetAddress":null,
								"siteCity":null,
								"siteState":null,
								"siteZip":null,
								"contactName":null,
								"serverLocation":null,
								"tvNumber":null,
								"crashEmail":null,
								"crashPass":null,
								"qsm":false,
								"notes":null,
								"pagingLocation":null,
								"connectwiseID":null
							}
		}

		vm.startEntry = function(){
			vm.newEntry = true;
			newCustomer()
		}

		function newSST(){
		vm.sstObject = {"id":null,"server_type":1,"server_location":null,"teamviewer_access":false,"teamviewer_number":null,"teamviewer_password":null,"technical_contact":null,"notes":null,"customer_data":{},'gateway':null,'subnet':null,'dnsA':null,'dnsB':null}
		}

		vm.startShCustomer = function(){
		vm.newEntry = true;
		newSST()
		}

		vm.checkButton = function(){
			if(vm.customerObject.siteName){
				if (vm.customerObject.siteName.length >= 5){
					return true
				}else{
					return false
				}
			}else{
				return false
			}
		}

		vm.tempFill = function(arrKey){
			if(!(vm.customerSelected)){
				var activeCust = vm.connectwiseCustomers.data[arrKey];
				$log.log(activeCust)
				vm.customerObject.siteName = activeCust.name;
				vm.customerObject.sitePhone = activeCust.phone_number;
				vm.customerObject.siteStreetAddress = activeCust.address;
				vm.customerObject.siteCity = activeCust.city;
				vm.customerObject.siteState = activeCust.state;
				vm.customerObject.siteZip = activeCust.zip;
				// vm.customerObject.contactName = activeCust.contact;
				vm.customerObject.connectwise_id = activeCust.connectwise_id
			}
		}

		vm.tempEmpty = function(){
			if(!(vm.customerSelected)){
				vm.customerObject.siteName = null;
				vm.customerObject.sitePhone = null;
				vm.customerObject.siteStreetAddress = null;
				vm.customerObject.siteCity = null;
				vm.customerObject.siteState = null;
				vm.customerObject.siteZip = null;
				vm.customerObject.contactName = null;
			}
		}

		vm.customerSelect = function(customerId){
			vm.customerSelected = true;
			vm.connectwiseCustomers = [];
			vm.customerObject.connectwiseID = customerId
			vm.sstObject.customer_data.id = customerId
		}

		vm.saveCheck = function(){
			if(vm.customerObject.siteName && vm.customerObject.sitePhone && vm.customerObject.siteStreetAddress && vm.customerObject.siteCity && vm.customerObject.siteState && vm.customerObject.siteZip){
				return true
			}else{
				return false
			}
		}

		vm.sstSaveCheck = function(){
		var val
		val = true
		if(!vm.customerObject.siteName){
			val = false
		}
		else if(!vm.sstObject.server_location){
			val = false
		}

		return val
		}

		vm.saveNew = function(){
			noc.quantumCustomer.save(vm.customerObject,function(){
				toastr.success('Save Successful');
				vm.startEntry()
			})
		}

		vm.saveSST = function(){
		noc.customers.patch({"customer_id":vm.sstObject.customer_data.id,"is_safe_health":true}).$promise
		.then(function(){
				noc.sstSystem.save(vm.sstObject,function(){
				toastr.success('Save Successful');
				vm.newEntry = false
				load_data()
				})
			})
			.catch(function(data){
				toastr.warning(data.errors)
			})
		}

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('quantumHardwareTestDetailController', quantumHardwareTestDetailController);

	/** @ngInject */
	function quantumHardwareTestDetailController($log, toastr, noc, $routeParams, user, $window) {
		var vm = this;
		vm.mac = $routeParams.id;
		vm.hwType = false;
		vm.last_location = user.data.oldUrl
		var pass = false;
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		var requirementObject = {"qsm":{"inputs":false,"outputs":true,"bluetooth":true,"wiegand":false,"sound":false,"screen":false,"type_id":10},"dcs":{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":true,"sound":true,"screen":true,"type_id":4},"io":{"inputs":true,"outputs":true,"bluetooth":true,"wiegand":false,"sound":false,"screen":false,"type_id":9},"est":{"inputs":false,"outputs":true,"bluetooth":true,"wiegand":false,"sound":false,"screen":false,"type_id":2}}

		// var keyObj = {10:"qsm",9:"io",1:"dcs",4:"dcs",2:"est",5:"pc",6:"pc",7:"pc",8:"pc",11:"dcs"}

		vm.qHw = noc.quantumHardwareTest.query({id:vm.mac},function(){
			angular.forEach(vm.qHw,function(element){
				if(!(vm.hwType)){
					vm.associated_serial = element.associated_serial
					vm.hwType = element.product_id
					$log.log(vm.hwType)
					noc.product.get({id:element.product_id}).$promise
					.then(function(data){
						vm.isPC = data.build.is_pull_cord.value
						vm.isTag = data.build.is_tag.value
            //IF DCS UNIT
						vm.isDCS = data.build.is_dcs_unit.value
            if(vm.isDCS){
              vm.myReq = requirementObject["dcs"]
            }
            //IF ENROLLMENT UNIT
						vm.isEnroll = data.build.is_enrollment.value
            if(vm.isEnroll){
              vm.myReq = requirementObject["est"]
            }
            //IF IO REPEATER UNIT
						vm.isIORepeater = data.build.is_io_repeater.value
            if(vm.isIORepeater){
              vm.myReq = requirementObject["io"]
            }
            //IF QSM UNIT
						vm.isQSM = data.build.is_qsm.value
            if(vm.isQSM){
              vm.myReq = requirementObject["qsm"]
            }
            vm.passedTest()
					})
				}
			})
		})

		function input_test(){
			var in_keys = ['input_1','input_2','input_3','input_4','input_5','input_6','input_7','input_8','input_9','input_10']
			var r = true
			if(vm.myReq.inputs){
				angular.forEach(in_keys,function(element){
					if(vm.qHw[0][element]){
						r = false
					}
				})
			}
			return r
		}

		function pc_input_test(){
			var in_keys = ['input_1','input_2','input_3','input_4','input_5','input_6']
			var r = true
			// if(vm.myReq.inputs){
			angular.forEach(in_keys,function(element){
				if(vm.qHw[0][element]){
					r = false
				}
			})
			// }
			return r
		}

		function output_test(){
			var out_keys = ['output_1','output_2','output_3','output_4','output_5']
			var r = true
			if(vm.myReq.outputs){
				angular.forEach(out_keys,function(element){
					if(vm.qHw[0][element]){
						r = false
					}
				})
			}
			return r
		}

		function wiegand_test(){
			var r = true
			if(vm.myReq.wiegand){
				if(vm.qHw[0].wiegand){
					r = false
				}
			}
			return r
		}

		function bluetooth_test(){
			var r = true
			if(vm.myReq.bluetooth){
				if(vm.qHw[0].tag_detect){
					r = false
				}
			}
			return r
		}

		function sound_test(){
			var r = true
			if(vm.myReq.sound){
				if(vm.qHw[0].sound){
					r = false
				}
			}
			return r
		}

		function screen_test(){
			var r = true
			if(vm.myReq.screen){
				if(vm.qHw[0].screen){
					r = false
				}
			}
			return r
		}

		vm.passedTest = function(){
			if(vm.myReq){
				vm.testFails = []
				var local_pass = false
				var o = false
				var i = false
				var b = false
				var w = false
				var s = false
				var d = false
				if(output_test()){
          $log.log("out")
					o = true
				}
				if(bluetooth_test()){
					b = true
				}
				if(input_test()){
					i = true
				}
				if(wiegand_test()){
					w = true
				}
				if(sound_test()){
					s = true
				}
				if(screen_test()){
					d = true
				}
				if(o && b && i && w && s && d){
					local_pass = true
					pass = "PASS"
				}else{
					pass = "FAIL"
				}
				return local_pass
			}else{
				if (vm.isPC){
					if(pc_input_test()){
						pass = "PASS"
					}else{
						pass = "FAIL"
					}
				}else{
					pass = "FAIL"
					return false
				}
			}
		}

		vm.sticker = function(){
			console.log(vm.report_server)
			//var info = vm.qHw[k]
			// vm.passedTest(function(){
				$window.open(vm.report_server+"/quantum_test_print.php?mac="+vm.mac+"&qc_str=Board "+vm.associated_serial+" "+pass+"&hw_type="+vm.hwType)
			// })
		}
	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('quantumHardwareTestController', quantumHardwareTestController);

  /** @ngInject */
	function quantumHardwareTestController(noc,$routeParams,$log,$location,$window) {
		var vm = this;

		vm.selectedSerial = $routeParams.id
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		vm.closeModal = function(){
			vm.modalInstance.dismiss();
		};

		function load_data(){
			if(vm.selectedSerial){
				noc.quantumHardware.get({"id":vm.selectedSerial,"route":"test"}).$promise
				.then(function(data){
					vm.tests = data
				})
				noc.quantumHardware.get({"id":vm.selectedSerial}).$promise
				.then(function(data){
					vm.hardware_data = data
					$log.log(data)
					noc.serialGenerator.get({"id":data.associated_serial}).$promise
					.then(function(sn_data){
						vm.serial_number_data = sn_data
					})
					noc.product.get({"id":data.product.id}).$promise
					.then(function(product_data){
						vm.product_data = product_data
					})
					noc.product.get({"id":data.product.id,"route":"test-requirement"}).$promise
					.then(function(test_req){
						vm.myReq = test_req.data[0]
					})
				})
			}else{
				var obj = {}
			
				if(vm.searchVal != ""){
					obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
					obj[vm.searchFor]='"%'+vm.searchVal+'%"'
				}else{
					obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				}
				vm.loadPromise = noc.quantumHardware.get(obj).$promise
				.then(function(data){
					vm.data = data
				})
			}	
		}
	
		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.currentPage = 1
			vm.sort_by = "tested_date"
			vm.sort_order = "DESC"
			vm.searchFor = "product_data/part_number"
			vm.searchVal = ""
			vm.num_results = 10
			load_data()
		}

		// clear filters to define defautls and do initial load
		vm.clear_filters()

		vm.openEdit = function(serial_number){
			$location.path('/quantumHardwareTest/'+serial_number)
		}

		vm.sticker = function(){
			var pass
			if(vm.hardware_data.test_passed){
				pass = "PASS"
			}else{
				pass = "FAIL"
			}
			$window.open(vm.report_server+"/quantum_test_print.php?mac="+vm.selectedSerial+"&qc_str=Board "+vm.serial_number_data.serial_number+" "+pass+"&hw_type="+vm.hardware_data.product.id)
		}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('purchaseOrderDetailController', purchaseOrderDetailController);

  /** @ngInject */
	function purchaseOrderDetailController(toastr, noc, flask_app, $routeParams,$location) {
		var vm = this;
		var poId = $routeParams.id;
		var poNumber = $routeParams.poNumber;
		vm.dataLoaded = false
		vm.receivedProduct = {}
		vm.openParts = {}
		flask_app.purchaseOrderDetail.get({id:poId},function(data){
			vm.fullDetail = data['data']
			angular.forEach(vm.fullDetail,function(element){
				if(element.closedFlag){
					if(!(vm.receivedProduct.hasOwnProperty(element.product.id))){
						vm.receivedProduct[element.product.id] = {'partNumber':element.product.identifier,'received_quantity':element.quantity,'name':element.description}
					}else{
						vm.receivedProduct[element.product.id].received_quantity = vm.receivedProduct[element.product.id].received_quantity + element.quantity
					}
				}else{
					if(!(vm.openParts.hasOwnProperty(element.product.id))){
						vm.openParts[element.product.id] = {'partNumber':element.product.identifier,'qty':element.quantity,'name':element.description,'id':element.id}
					}
				}
			})
			vm.dataLoaded = true
		})
		vm.receivePart = function(partNumber,lineId){
			$location.path("/receiveProductDetail/"+poId+"/"+lineId+"/"+poNumber);
		}
	}
})();
(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('productTestController', productTestController);

	/** @ngInject */
	function productTestController($log, toastr, noc, $routeParams, $location, testAppAPI, user, $interval, $scope, $uibModal, $window) {
		var vm = this;
		var timer_id
		var pass = "FAIL"
		var pass_bool = false
		var pc_pass = false
		var user_id = user.data.user_id
		vm.availableSerialObject = {}
		vm.pullCordSelectObject = []
		vm.product_id = $routeParams.product_id;
		vm.serial_number_id = $routeParams.serial_id;
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		vm.testStatus = false

		var submissionObject={
								"serial_number":false,
								"hardware_type":false,
								"input_1":false,
								"input_2":false,
								"input_3":false,
								"input_4":false,
								"input_5":false,
								"input_6":false,
								"input_7":false,
								"input_8":false,
								"input_9":false,
								"input_10":false,
								"output_1":false,
								"output_2":false,
								"output_3":false,
								"output_4":false,
								"output_5":false,
								"wiegand":false,
								"wiegand_code":false,
								"wiegand_site":false,
								"sound":false,
								"tag_detect":false,
								"bluetooth_errors":null,
								"screen":false,
								"tester":user_id
							}
		
		noc.product.get({"id":vm.product_id}).$promise
		.then(function(data){
			vm.finished_product = data
		})

		noc.serialGenerator.get({"id":vm.serial_number_id}).$promise
		.then(function(data){
			vm.serial_number_data = data
		})

		vm.ipCheck = function(ip,mac){
			$log.log(ip)
			vm.submissionObject = submissionObject
			vm.submissionObject['serial_number'] = mac
			vm.submissionObject['associated_serial'] = vm.serial_number_data.id
			testAppAPI.server_ip = "http://"+ip+":5000"
			testAppAPI.test()

		}

		var mainTimer
		function mainTimerFunction(){
			var counter = 0;
			if(angular.isDefined(mainTimer)) return;
			mainTimer = $interval(function(){
				if(counter == 0){					
				// if(!vm.finished_product.is_pull_cord){
					noc.product.get({"id":vm.product_id,"route":"test-requirement"}).$promise
					.then(function(data){
						if(data.count == 1){
							vm.testReq = data.data[0]
							$log.log(vm.testReq)
							submissionObject["hardware_type"] = vm.product_id
							noc.availableTests.get().$promise
							.then(function(data){
								vm.availableHw = data
							})
						}else{
							toastr.warning("No test requirements found, define this in the product administration")
						}
					})
				}
				counter +=1
					
				// }else{
				// 	counter +=1
				// 	if(counter == 10){
				// 		counter = 0
				// 	}
				// }
				vm.counter = counter
			},1000)
		}

		mainTimerFunction()

		vm.removeDevice = function(k,mac){
			vm.availableHw.data.splice(k,1)
			noc.availableTests.delete({id:mac}).$promise
			.then(function(){
				toastr.success("Removed Device")
			})
		}

		vm.outputStatus = {"out1":false,"out2":false,"out3":false,"out4":false,"out5":false}

		$scope.$on('$destroy', function() {
		if(angular.isDefined(mainTimer)){
			$interval.cancel(mainTimer)
		}
		if(angular.isDefined(timer_id)){
			clearInterval(timer_id)
		}
		})

		function statusUpdate(){
			testAppAPI.testStatus.get(function(data){
				$log.log(data)
				vm.testStatus = data.test_status
			})
		}

		function timer(){
			return setInterval(function(){
				if(vm.finished_product.is_pull_cord){
					pcStatus()
				}else{
					results()
				}
			}, 1000);
		}

		function results(){
			testAppAPI.currentStatus.get(function(data){
				vm.resultData = data
			})
		}

		vm.startTest = function(){
			vm.ladda = true
			testAppAPI.startTest.get(function(){
				statusUpdate()
				timer_id = timer()
				vm.ladda = false
			},function(){
				vm.testStatus = 'FailConnect'
				vm.ladda = false
			})
		}

		vm.stopTest = function(){
			clearInterval(timer_id)
			testAppAPI.stopTest.get(function(){
				statusUpdate()
			})
			vm.submissionObject.serial_number = null
		}

		vm.cancelTest = function(){
			vm.stopTest()
			$location.path("/productTest/"+vm.product_id+"/"+vm.serial_number_id);
		}

		vm.toggleOut = function(outputNumber){
			testAppAPI.toggleOutput.get({id:outputNumber})
		}

		vm.toggleSound = function(){
			testAppAPI.toggleSound.get()
		}

		vm.changeScreen = function(newValue){
			testAppAPI.screenChange.update({id:newValue},{})
		}

		function input_test(){
			var r = true
			if(vm.testReq.inputs){
				angular.forEach(vm.resultData.inputs,function(element, key){
					if(!element.tested){
						r = false
					}else{
						submissionObject['input_'+key] = true
					}
				})
			}else{
				if(submissionObject['input_1'] == false){
					for (var i = 1; i <= 10; i++) {
						submissionObject['input_'+String(i)] = true
					}
				}
			}
			return r
		}

		function output_test(){
			var r = true
			if(vm.testReq.outputs){
				angular.forEach(vm.outputStatus,function(element){
					if(!element){
						r = false
					}
				})
			}else{
				if(submissionObject['output_1'] == false){
					for (var i = 1; i <= 5; i++) {
						submissionObject['output_'+String(i)] = true
					}
				}
			}
			return r
		}

		function wiegand_test(){
			var r = true
			if(vm.testReq.wiegand){
				if(!vm.resultData.wiegand.result){
					r = false
				}else{
					submissionObject['wiegand'] = true;
					submissionObject['wiegand_code'] = vm.resultData.wiegand.code
					submissionObject['wiegand_site'] = vm.resultData.wiegand.site
				}
			}else{
				submissionObject['wiegand'] = true;
			}
			return r
		}

		function bluetooth_test(){
			var r = false
			if(vm.testReq.bluetooth){
				if(vm.resultData.bluetooth.result){
					r = true
					submissionObject['tag_detect'] = true
				}
			}else{
				submissionObject['tag_detect'] = true
				r = true
			}
			return r
		}

		function sound_test(){
			var r = false
			if(vm.testReq.sound){
				if(submissionObject['sound']){
					r = true
				}
			}else{
				submissionObject['sound'] = true
				r = true
			}
			return r
		}

		function screen_test(){
			var r = false
			if(vm.testReq.screen){
				if(submissionObject['screen']){
					r = true
				}
			}else{
				submissionObject['screen'] = true
				r = true
			}
			return r
		}

		vm.passedTest = function(){
			if(vm.resultData){
				vm.testFails = []
				var local_pass = false
				var o = false
				var i = false
				var b = false
				var w = false
				var s = false
				var d = false
				if(output_test()){
					o = true
				}else{
					vm.testFails.push("Output Failure")
				}
				if(bluetooth_test()){
					b = true
				}else{
					vm.testFails.push("Bluetooth Failure")
				}
				if(input_test()){
					i = true
				}else{
					vm.testFails.push("Input Failure")
				}
				if(wiegand_test()){
					w = true
				}else{
					vm.testFails.push("Wiegand Failure")
				}
				if(sound_test()){
					s = true
				}else{
					vm.testFails.push("Sound Failure")
				}
				if(screen_test()){
					d = true
				}else{
					vm.testFails.push("Screen Failure")
				}
				if(o && b && i && w && s && d){
					local_pass = true
					pass = "PASS"
				}else{
					pass = "FAIL"
				}
				return local_pass
			}else{
				pass = "FAIL"
				return false
			}
		}

		vm.outputResult = function(outputNumber,value){
			if(value == '1'){
				value = true;
			}else{
				value = false;
			}
			vm.outputStatus["out"+outputNumber] = value;
			submissionObject["output_"+outputNumber] = value
		}

		vm.soundResult = function(value){
			if(value == '1'){
				value = true;
			}else{
				value = false;
			}
			submissionObject['sound'] = value
			vm.soundStatus = value
		}

		vm.screenResult = function(value){
			if(value == '1'){
				value = true;
			}else{
				value = false;
			}
			submissionObject['screen'] = value
			vm.screenStatus = value
		}

		vm.submitTest = function(){
			if (vm.testStatus != 'FailConnect'){
				clearInterval(timer_id)
				
				if(pass == 'PASS'){
					pass_bool = true
					if (vm.finished_product.is_dcs_unit){
						testAppAPI.updateApp.get({type:'dcs-neosec'})
					}else if(vm.finished_product.is_enrollment){
						testAppAPI.updateApp.get({type:'est'})
					}else if(vm.finished_product.is_io_repeater){
						testAppAPI.updateApp.get({type:'io'})
					}else if(vm.finished_product.is_qsm){
						testAppAPI.updateApp.get({type:'qsm'})
					}else if(vm.finished_product.is_tts){
						testAppAPI.updateApp.get({type:'tts'})
					}else if(vm.finished_product.is_sad){
						testAppAPI.updateApp.get({type:'sad'})
					}
				}else{
					pass_bool = false
				}
				submissionObject.test_pass = pass_bool
			}

			submissionObject['product_id'] = vm.product_id
			submissionObject['rma_id'] = null
			noc.quantumHardware.save(submissionObject,function(){
				noc.availableTests.delete({id:submissionObject.serial_number},function(){
					noc.quantumHardware.save({"id":submissionObject.serial_number,"route":"test"},submissionObject,function(){
						$window.open(vm.report_server+"/quantum_test_print.php?mac="+submissionObject.serial_number+"&qc_str=Board "+vm.serial_number_data.serial_number+" "+pass+"&hw_type="+vm.product_id)
						$location.path("/quantumHardwareTest/"+submissionObject.serial_number);
					})
				})
			})
		}
		
		//PULL CORD SPECIFIC FUNCTIONS
		vm.checkPCSN = function(){
			vm.Inovalid = false
			vm.errors = []
			if(!(isNaN(vm.InoSerial))){
				vm.Inovalid = true
			}else{
				vm.errors.push('Serial Number must be a number')
			}
		}

		vm.startPCTest = function(){
			noc.pullCordStart.put({},{'pc_type':vm.finished_product.id,'serial_number':vm.InoSerial},function(){
				vm.timed_out = false
				vm.timeout_value = 60
				timer_id = timer()
				vm.pcStarted = true
				submissionObject['hardware_type'] = vm.finished_product.id
			})
		}

		function pcStatus(){
			vm.timeout_value = vm.timeout_value - 1
			noc.pullCordStatus.get({'serial_number':vm.InoSerial}).$promise
			.then(function(data){
				vm.resultData = data
				pc_input_control()
			})
			.catch(function(){
				toastr.warning("Test Timed Out")
				vm.timed_out = true
			})
		}

		function pc_input_control(){
			angular.forEach(vm.resultData.status,function(element, key){
				if(key == 'alarm_bit_1_alarm'){	
					if (vm.testReq.alarm){					
						submissionObject.input_1 = element
					}else{
						submissionObject.input_1 = true
					}
				}
				if(key == 'alarm_bit_2_alarm'){
					if (vm.testReq.staff){
						submissionObject.input_3 = element
					}else{
						submissionObject.input_3 = true
					}
				}
				if(key == 'alarm_bit_1_reset'){
					submissionObject.input_2 = element
				}
				if(key == 'alarm_bit_2_reset'){
					submissionObject.input_4 = true
				}
				if(key == 'tamper_active'){
					if (vm.testReq.checkin){
						submissionObject.input_5 = element
					}else{
						submissionObject.input_5 = true
					}
				}
				if(key == 'tamper_reset'){
					submissionObject.input_6 = true
				}
			})
		}

		vm.pcInputPass = function(){
			var pcTestStatus = "PASS"
			pc_pass = true
			var val
			for (var i = 1; i <= 6; i++) {
				val = submissionObject['input_'+String(i)]
				if(!val){
					pcTestStatus = "FAIL"
					pc_pass = false
				}
			}
			return pcTestStatus
		}

		vm.userFail = function(){
			for (var i = 1; i <= 6; i++) {
				submissionObject['input_'+String(i)] = false
			}
			vm.pcSubmitTest()
		}

		vm.pcSubmitTest = function(){
			var prevSN = vm.InoSerial
			clearInterval(timer_id)
			submissionObject['serial_number'] = vm.InoSerial
			submissionObject['product_id'] = submissionObject['hardware_type']
			submissionObject['rma_id'] = null
			noc.quantumHardware.save({"serial_number":prevSN,"product_id":vm.finished_product.id,"associated_serial":vm.serial_number_data.id,"tester":user_id,"test_pass":pc_pass},function(){
				noc.quantumHardware.save({"id":prevSN,"route":"test"},submissionObject,function(){
					$window.open(vm.report_server+"/quantum_test_print.php?mac="+vm.InoSerial+"&qc_str=Board "+vm.serial_number_data.serial_number+" "+vm.pcInputPass()+"&hw_type="+vm.finished_product.id)
					$location.path("/quantumHardwareTest/"+vm.InoSerial);
				})
			})
			noc.pullCordStop.put({"serial_number":prevSN},{})
		}

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('productPricingController', productPricingController);

	/** @ngInject */
	function productPricingController($log,noc,toastr) {
		var vm = this;
		vm.order_column = 'part_number'
		vm.order_asc = 'ASC'
		vm.currentPage = 1
		vm.products = []
		vm.build_choices = {0:"No",1:"Yes",2:"All"}
		vm.build_filter = "All"

		noc.product_vendor.query().$promise
		.then(function(data){
			vm.vendors = data
		})
		noc.product_types.query().$promise
		.then(function(data){
			vm.types = data
		})

		vm.get_data = function(){

			var filter_obj = {
				"order_by":vm.order_column,
				"order_asc":vm.order_asc,
				"page":vm.currentPage,
				"inactive":false
			}
			if(vm.part_number_filter){
				filter_obj.part_number = '"%'+vm.part_number_filter+'%"'
			}
			if(vm.name_filter){
				filter_obj.name = '"%'+vm.name_filter+'%"'
			}
			if(vm.build_filter != "All"){
				if (vm.build_filter == 'No'){
					filter_obj.jnl_build = false
				}else{
					filter_obj.jnl_build = true
				}
			}
			if(vm.percent_filter){
				filter_obj.percent = vm.percent_filter
			}
			if(vm.vendor_filter){
				filter_obj.vendor = '"'+vm.vendor_filter.vendor+'"'
			}
			if(vm.type_filter){
				filter_obj.type = '"'+vm.type_filter.type+'"'
			}

			// var products = noc.product.query(filter_obj)
			noc.product_report.get(filter_obj).$promise
			.then(function(data){
				vm.products = data.data
				vm.total_rows = data.count
			})
		}
		vm.sort_data = function(){
			if (vm.order_asc == 'ASC'){
				vm.order_asc = 'DESC'
			}else{
				vm.order_asc = 'ASC'
			}
			vm.get_data()
		}

		vm.selectPart = function(i){
			vm.selectedProduct = vm.products[i]
			var part_id = vm.products[i]['id']
			if(vm.selectedProduct.build.jnl_build.value){
				noc.build.query({product_id:part_id}).$promise
				.then(function(data){
					if(data.length){
						var build_id = data[0]['id']
						noc.build.get({id:build_id}).$promise
						.then(function(build_data){
							vm.build_data = build_data
							vm.build_total()
						})
					}else{
						toastr.warning("Product checked to have build, but no build exists for this part")
					}
				})
			}
		}

		vm.build_total = function(){
			if(vm.build_data){
				vm.total = 0
				angular.forEach(vm.build_data.included_parts,function(row){
					vm.total = vm.total + (row.build_product_qty * row.cost)
				})
			}
		}

		vm.build_mods = function(){
			var all_empty = true
			var msrp = vm.selectedProduct.general.price.value;
			var cost = vm.selectedProduct.general.cost.value;
			var percent = vm.selectedProduct.general.percent.value;
			if(vm.new_msrp){
				msrp = vm.new_msrp
				all_empty = false
			}
			if(vm.new_cost){
				cost = vm.new_cost
				all_empty = false
			}
			if(vm.new_percentage){
				percent = vm.new_percentage
				all_empty = false
			}
			if(vm.new_percentage){
				var p = percent / 100
				vm.calculated_msrp = cost / (1-p)
				msrp = vm.calculated_msrp
			}

			vm.calculated_percentage = ((msrp - cost) / msrp) * 100
			vm.calculated_percentage25 = ((msrp - cost) / msrp * .75) * 100
			vm.calculated_percentage30 = ((msrp - cost) / msrp * .7) * 100

			if(all_empty){
				vm.calculated_percentage = null
				vm.calculated_percentage25 = null
				vm.calculated_percentage30 = null
				vm.calculated_msrp = null
			}
		}

		vm.clear_calculations = function(){
			vm.calculated_percentage = null
			vm.calculated_percentage25 = null
			vm.calculated_percentage30 = null
			vm.calculated_msrp = null
			vm.new_percentage = null;
			vm.new_cost = null;
			vm.new_msrp = null
		}

		vm.clear_filters = function(){
			vm.order_column = 'part_number'
			vm.order_asc = 'ASC'
			vm.currentPage = 1
			vm.build_filter = "All"
			vm.type_filter = null
			vm.vendor_filter = null
			vm.percent_filter = null
			vm.name_filter = null
			vm.part_number_filter = null

			vm.get_data()
		}

		vm.get_data()

 }
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('openOrderProductAllocationController', openOrderProductAllocationController);

	/** @ngInject */
	function openOrderProductAllocationController($log,noc,toastr,DTOptionsBuilder) {
		var vm = this;
		vm.order_column = 'part_number'
		vm.order_asc = 'ASC'
		vm.currentPage = 1
		vm.products = []
		vm.build_choices = {0:"No",1:"Yes",2:"All"}
		vm.color_classes = {1:'urgent',2:'highPriority',3:'regular',4:'delayed',5:'onHold'}
		vm.build_filter = "All"

		vm.get_data = function(){
			// noc.open_order.get({page_number:vm.currentPage,number_per_page:15}).$promise
			noc.open_order.get().$promise
			.then(function(data){
				vm.data = data.data
				// vm.data = []
				// angular.forEach(data,function(obj){
				// 	vm.data.push(obj)
				// })
				vm.total_rows = data.total_rows
			})
		}

		vm.priorities = noc.priority.query()

		vm.update_priority = function(id,index){
			noc.open_order.patch({id:id},{"priority/id":vm.data[index]['priority']['id']}).$promise
			.then(function(data){
				$log.log(data)
			})
		}
		vm.update_date = function(id,index){
			noc.open_order.patch({id:id},{"planned_ship":vm.data[index]['planned_ship']}).$promise
			.then(function(data){
				$log.log(data)
			})
		}
		vm.update_notes = function(id,index){
			noc.open_order.patch({id:id},{"notes":vm.data[index]['notes']}).$promise
			.then(function(data){
				$log.log(data)
			})
		}

		vm.askForExcel = function(){
			noc.update_db_check.patch({open_order_update:true}).$promise
			.then(function(){
				toastr.success("Please wait approx 5 minutes to receive an email with an attached excel")
			})
			.catch(function(){
				toastr.warning("Please contact Drew, the request was not successful")
			})
		}

		vm.dtOptions = DTOptionsBuilder.newOptions()
		.withOption('pageLength',30)

		vm.get_data()

 }
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('loginController', loginController);

  /** @ngInject */
	function loginController(toastr, noc, user, $location, $cookies, navItems) {
		var vm = this;
    vm.unsuccessful = false;
		vm.login = function(){
            noc.login.save({"username":vm.userName,"password":vm.passWord},function(data){
                user.data = data
                if(data.pw_change_required){
                  $location.path('/changePassword')
                }else{
                  $location.path('/');
                }
                $cookies.putObject('user', data)
                navItems.rebuild()
            },function(){
                vm.unsuccessful = true;
                toastr.warning("Log in failed")
            })
        }
	}
})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, toastr, noc, $log, user, $q,$location) {
    var vm = this;

    //$log.log(user.data.user_id)
    var promises = []
    function load_data(){
      if(user.data.user_id){
        noc.userInfo.get({id:user.data.user_id}).$promise
        .then(function(data){
          vm.hardwareCounts = noc.quantumCustomer.get({id:0,route:'updateSummary'})
          vm.primary_function = data.primary_function
          if(vm.primary_function == 3){
            promises.push(
              noc.estimates.query({id:"recently-created"}).$promise
              .then(function(data){
                vm.recently_created = data
              })
            )

            promises.push(
              noc.estimates.query({id:"recently-updated"}).$promise
              .then(function(data){
                vm.recently_updated = data
              })
            )
          }
          if(vm.primary_function == 5){
            promises.push(
              noc.estimates.get({id:"install-ready"}).$promise
              .then(function(data){
                vm.data = data
              })
            )
          }
        })

        vm.populatePromise = $q.all(promises)
      }
    }

    $timeout(load_data, 1000)

    vm.openEstimate = function(est_id,est_type,non_t){
      if(non_t == 0){
        $location.path('estimateBuilder/'+est_id+'/'+est_type)
      }else{
        $location.path('buildDealerEstimate/'+est_id)
      }
    }

  }
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('internalTagReaderController', internalTagReaderController);

  /** @ngInject */
	function internalTagReaderController($log, toastr, $interval, noc, $scope, tagTestAPI) {
		var vm = this;
    vm.testSecondCounter = 0
    vm.hardware = {"product_id":null,"associated_serial":null,"test_pass":null}
    vm.hardware_test = {"serial_number":false,"product_id":false,"input_1":false,"input_2":false,"input_3":false,"input_4":false,"input_5":false,"input_6":false,"input_7":false,"input_8":false,"input_9":false,"input_10":false,"output_1":false,"output_2":false,"output_3":false,"output_4":false,"output_5":false,"wiegand":false,"wiegand_code":false,"wiegand_site":false,"sound":false,"tag_detect":false,"bluetooth_errors":null,"screen":false,"battery_level":false,"rssi":false,"tx_rate":false,"test_time":0,"rma_id":-1}
    // vm.test_result = {"battery_level":null,"rssi":null,"tx_rate":null,"test_time":vm.testSecondCounter}
    vm.availableSerialObject = {}

    vm.availableParts = []
    vm.availableSerialNumbers = {}
    noc.product.get({"is_tag":true,"inactive":false}).$promise
    .then(function(data){
      vm.availableParts = data.data
    })

		var loadData = function(){
      noc.internalTagReader.get().$promise
      .then(function(data){
        vm.tagData = data.data
      })
    }

    vm.populateSerials = function(product_id){
      // Get build based on the selected product
      noc.build.get({"product_data/id":product_id}).$promise
      .then(function(data){
        $log.log(data)
        // IF there is a build defined continue
        if(data.data_length == 1){
          var id = data.data[0].id
          // get the products that make up the build for the selected product
          noc.build.get({"id":id,"route":"included-parts","product_data/jnl_serialized":true}).$promise
          .then(function(included_parts){
            angular.forEach(included_parts.data,function(element){
              if(element.product_data.jnl_serialized){
                // $log.log("HERE")
                // Iterating through those parts (should be limited to those that JNL serialized so this should be quite fast)
                noc.serialGenerator.get({"product_data/id":element.product_data.id,"part_of_build":true,"part_of_final_build":false,"page_size":1000}).$promise
                .then(function(serial_data){
                  vm.availableSerialNumbers = serial_data.data
                })
              }
            })
          })
        }
      })
    }

    var mainTimer = false
    function mainTimerFunction(){
      if(mainTimer) return;
      mainTimer = $interval(function(){
          loadData()
      },1000)
    }

    var testTimer = false

    function testCounter(){
      vm.testSecondCounter = vm.testSecondCounter + 1
    }


    var rssi_keeper = []
    function testTimerFunction(){
      if(testTimer) return;
      testTimer = $interval(function(){
          testCounter()
          tagTestAPI.currentStatus.get().$promise
          .then(function(data){
            rssi_keeper.push(data.rssi)
            vm.hardware_test.rssi = data.rssi
            vm.hardware_test.battery_level = data.battery_level
            vm.hardware_test.tx_rate = data.tx_rate
            vm.hardware_test.test_time = vm.testSecondCounter
            vm.currentData = data
          })
      },1000)
    }

    function avg_rssi(){
      if(rssi_keeper.length){
        var sum = rssi_keeper.reduce(function(a, b) { return a + b; }, 0)
        return sum / rssi_keeper.length
      }else{
        return false
      }
    }

    vm.currentTestStatus = function(){
      var pass = false
      var r = avg_rssi()
      if(vm.hardware.product_id){
        if(vm.hardware.associated_serial){
          if (vm.testSecondCounter > 15){
            if (r <= -60 && r >= - 72){
              if (vm.currentData.tx_rate < .9){
                if(vm.currentData.battery_level >= 2.85){
                  pass = true
                }
              }
            }
          }
        }
      }
      return pass
    }

    vm.start_test = function(k){
      vm.testSecondCounter = 0
      vm.activeMac = vm.tagData[k].mac

      testTimerFunction()
      $interval.cancel(mainTimer)
      mainTimer = false
      tagTestAPI.startTest.put(vm.tagData[k])

    }

    vm.complete_test = function(){
      tagTestAPI.completeTest.put({}).$promise
      .then(function(){
        toastr.success("Test Completed Successfully")
        vm.hardware.test_pass = vm.currentTestStatus()
        vm.hardware['serial_number']=vm.activeMac
        noc.quantumHardware.save(vm.hardware).$promise
        .then(function(){
          vm.hardware_test.serial_number = vm.activeMac
          vm.hardware_test.product_id = vm.hardware.product_id
          vm.hardware_test.rssi = avg_rssi()
          noc.quantumHardware.save({"id":vm.activeMac,"route":"test"},vm.hardware_test).$promise
          .then(function(){
            toastr.success("Saved To Portal")
            vm.activeMac = false
          })
          .catch(function(err){
            $log.log(err)
            vm.activeMac = false
          })
        })
        .catch(function(err){
          $log.log(err)
          vm.activeMac = false
        })
      })
      $interval.cancel(testTimer)
      testTimer = false
      mainTimerFunction()
    }

    vm.cancel_test = function(){
      tagTestAPI.completeTest.put({}).$promise
      .then(function(){
        vm.activeMac = false
      })
      .catch(function(){
        vm.activeMac = false
      })
      vm.activeMac = false
      $interval.cancel(testTimer)
      testTimer = false
      mainTimerFunction()
    }

    vm.tag_turn_off = function(k){
      vm.tag_off_promise = tagTestAPI.turnOffTag.put(vm.tagData[k]).$promise
      .then(function(data){
       if(data.Success){
         toastr.success("Tag Turned Off");
       }
      })
    }

    mainTimerFunction()
    // loadSerialNumbers()

    $scope.$on('$destroy', function() {
      if(angular.isDefined(mainTimer)){
        $interval.cancel(mainTimer)
      }
      if(angular.isDefined(testTimer)){
        $interval.cancel(testTimer)
      }
    })
	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('installQuoteStartController', installQuoteStartController);

  /** @ngInject */
	function installQuoteStartController($log,toastr, noc,$location) {
		var vm = this;

    vm.currentPage = 1
		vm.sort_by = "created/date"
		vm.sort_order = "DESC"
		vm.searchFor = "company/name"
		vm.searchVal = ""
		vm.num_results = 10

    function load_data(){
      var obj
			if(vm.searchVal != ""){
				obj = {"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"active":true,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			vm.qStatus = noc.install_quote.get(obj)
		}

		load_data()

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.currentPage = 1
      vm.sort_by = "created/date"
      vm.sort_order = "DESC"
      vm.searchFor = "company/name"
      vm.searchVal = ""
      vm.num_results = 10
			load_data()
		}

    // vm.customers = noc.customers.query()

    // vm.loadPromise = noc.estimates.get({id:"install-ready"}).$promise
    // .then(function(data){
    //   vm.data = data
    //   noc.install_quote.query().$promise
    //   .then(function(install_data){
    //     vm.install_data = install_data
    //     vm.dtOptions = DTOptionsBuilder.newOptions()
		// 		.withOption('order',[3,'desc']);
    //   })
    // })

    vm.loadPromise = noc.install_quote.get().$promise
    .then(function(data){
      vm.install_data = data.data
    })

    vm.openQuote = function(e_id){
      $location.path('/installQuote/'+e_id)
    }


    vm.getEstimateDetail = function(){
      noc.estimates.get({id:vm.estimate_id}).$promise
      .then(function(data){
        vm.selectedEstimate = data
      })
      .catch(function(err){
        toastr.warning("Estimate Not Found")
        $log.log(err)
      })
    }

    vm.loadOffer = function(){
      $location.path('/installQuote/'+vm.estimate_id);
    }

	}

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('installQuoteController', installQuoteController);

	/** @ngInject */
	function installQuoteController($log, $routeParams,toastr, noc, user, $window, $location) {
		var vm = this;
		vm.estimateId = $routeParams.id;
		vm.user_id = user.data.user_id;
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		vm.submissionObj = {"id":null,"estimate_id":null,"date_created":null,"created":{"id":vm.user_id},"updated":{"id":vm.user_id},"parts":[],"third_party":{"id":-1},"burden_rate":null,"accepted_offer":false}

		// vm.staff_data = noc.userInfo.query();

		var burden_rate = 0
		noc.settings.get().$promise
		.then(function(data){
			burden_rate = data['Burden Rate']
		})

		vm.thirdParties = []
		noc.thirdParty.get({"page_size":1000}).$promise
		.then(function(data){
			data = data.data
			data.unshift({"id":-1,"name":"JNL Internal","active":true,"installs_things":true})
			angular.forEach(data,function(element){
				if (element.active && element.installs_things){
					vm.thirdParties.push(element)
				}
			})
		})
		vm.project_hours = noc.estimates.get({id:vm.estimateId,route:"project-hours"})
		var copy = null;



		function buildObj(){
			angular.forEach(vm.systemParts,function(element){
				if(!(element.product_connectwise_id == 1515 || element.product_connectwise_id == 44)){
					var part_found = false
					angular.forEach(vm.estimateData.parts.travel,function(part){
						if(part.product_connectwise_id == element.product_connectwise_id){
							part_found = true
							$log.log(part)
							vm.submissionObj.parts.push({"product_connectwise_id":part.product_connectwise_id,"price":part.product_price,"qty":0,"product_description":"x"})
						}
					})
					if(!part_found){
						vm.submissionObj.parts.push({"product_connectwise_id":element.product_connectwise_id,"price":element.product_price,"qty":0,"product_description":element.product_description})
					}
				}
			})
			vm.submissionObj.estimate_id = vm.estimateId
			vm.submissionObj.burden_rate = burden_rate
			vm.submissionObj.parts.push({"product_connectwise_id":44,"price":vm.estimateData.labor_cost,"qty":0,"product_description":"Install Labor"})
			copy = angular.copy(vm.submissionObj)
		}


		function load_data(){
			vm.populatePromise = noc.estimates.get({"id":vm.estimateId,route:"totals"}).$promise
			.then(function(data){
				vm.estimateTotals = data
				noc.estimates.get({"id":vm.estimateId}).$promise
				.then(function(estimateData){
					vm.estimateData = estimateData
					vm.customers = noc.customers.get({"connectwise_id":estimateData.customer_id});
					noc.install_quote.get({"estimate_id":'"'+vm.estimateId+'"'}).$promise
					.then(function(offerData){
						if(offerData.data.length > 0){
							vm.submissionObj = offerData.data[0]
							vm.offer_id = offerData.data[0].id
							noc.install_quote.get({"id":offerData.data[0].id,"route":"parts"}).$promise
							.then(function(part_data){
								if(part_data.count > 0){
									vm.submissionObj.parts = part_data.data
									copy = angular.copy(vm.submissionObj)
									noc.systemParts.get({"system_id":0}).$promise
									.then(function(systemParts){
										vm.systemParts = systemParts.data
										if(!vm.submissionObj.parts){
											buildObj()
										}
									})
								}else{
									vm.submissionObj.parts = []
									noc.systemParts.get({"system_id":0}).$promise
									.then(function(systemParts){
										vm.systemParts = systemParts.data
										buildObj()
									})
								}
							})
						}else{
							noc.systemParts.get({"system_id":0}).$promise
							.then(function(systemParts){
								vm.systemParts = systemParts.data
								buildObj()
							})
						}
					})
				})
			})
		}

		vm.sameObj = function(){
			if(copy){
				if(vm.submissionObj){
					return angular.equals(copy,vm.submissionObj)
				}
			}
		}

		function getFive(inputValue){
			var c = inputValue / 500
			return (Math.floor(c) * 500)
		}

		vm.totalContract = function(){

			if(vm.estimateTotals && vm.estimateData){
				var subtract_from_total = 0
				var base_profit = 0
				if(vm.submissionObj.third_party && vm.submissionObj.third_party.id > 0){
					angular.forEach(vm.estimateData.parts.travel,function(element){
						if(element.product_connectwise_id == 1515){
							subtract_from_total = element.product_price * element.qty
						}
					})
				}else{
					angular.forEach(vm.estimateData.parts.travel,function(element){
						if(element.product_connectwise_id != 1515){
							if(element.product_connectwise_id == 44){
								subtract_from_total = subtract_from_total + (vm.submissionObj.burden_rate * element.qty)
							}else{
								subtract_from_total = subtract_from_total + (element.product_price * element.qty)
							}
						}
					})
				}
				// $log.log("total from quote: "+subtract_from_total)
				// Subtract the value of the support plan
				var labor_value = vm.estimateTotals.labor_total - subtract_from_total
				var project_hours = 0
				if(vm.project_hours['total_hours']){
					project_hours = parseFloat(vm.project_hours['total_hours'])
				}
				if(vm.submissionObj.third_party && vm.submissionObj.third_party.id > 0){
					// Base Profit is 20% of total labor less the contract plus 10% of the total job hours * the cost of labor for the job
					base_profit = (labor_value * .2) + (project_hours * .1 * vm.estimateData.labor_cost)
				}else{
					base_profit = (project_hours * .1 * vm.submissionObj.burden_rate)
					// $log.log("Base Profit: "+base_profit)
				}



				var totalCost = 0
				if(vm.submissionObj.third_party && vm.submissionObj.third_party.id > 0){
					angular.forEach(vm.submissionObj.parts,function(element){
						// $log.log(element)
						totalCost = totalCost + (element.price * element.qty)
					})
				}else{
					// $log.log("hours"+parseFloat(vm.project_hours['total_hours']))

					totalCost = subtract_from_total + base_profit + (project_hours * vm.submissionObj.burden_rate)
					// $log.log(totalCost)
					angular.forEach(vm.submissionObj.parts,function(element){
						if(element.product_connectwise_id != 44){
							totalCost = totalCost + (element.price * element.qty)
						}else{
							totalCost = totalCost + (vm.submissionObj.burden_rate * element.qty)
						}
					})
				}

				if(vm.submissionObj.third_party && vm.submissionObj.third_party.id > 0){
					return getFive((labor_value - base_profit)  - totalCost)
				}else{
					return totalCost
				}
			}
		}

		vm.saveNew = function(){
			vm.submissionObj.quoted_price = vm.totalContract()
			noc.install_quote.save(vm.submissionObj).$promise
			.then(function(data){
				vm.offer_id = data.id
				noc.install_quote.save({"id":vm.offer_id,"route":"parts"},vm.submissionObj.parts).$promise
				.then(function(){
					toastr.success("Quote Saved")
					load_data()
				}).catch(function(err){
					$log.log(err)
					toastr.warning("Parts not Saved to Quote Successfully")
					noc.install_quote.delete({"id":vm.offer_id})
				})
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Quote Not Saved Successfully")
			})
		}

		vm.update = function(){
			vm.submissionObj.quoted_price = vm.totalContract()
			noc.install_quote.update({"id":vm.offer_id},vm.submissionObj).$promise
			.then(function(){
				noc.install_quote.update({"id":vm.offer_id,"route":"parts"},vm.submissionObj.parts).$promise
				.then(function(){
					toastr.success("Quote Saved")
					load_data()
				}).catch(function(err){
					$log.log(err)
					toastr.warning("Quote Not Saved Successfully")
				})
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Quote Not Saved Successfully")
			})
		}


		vm.createDoc = function(){
			$window.open(vm.report_server+"/reports/estimator/install_offer.php?est="+vm.estimateData.estimate_id+"&allow=allow")
		}

		vm.back = function(){
			$location.path('/installQuoteStart')
		}

		vm.burdenCheck = function(){
			if (burden_rate != vm.submissionObj.burden_rate){
				return true
			}else{
				return false
			}
		}

		vm.updateBurden = function(){
			vm.submissionObj.burden_rate = burden_rate
		}

		load_data()

	}

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('startNewEstimateController', startNewEstimateController);

	/** @ngInject */
		function startNewEstimateController(toastr, noc,$location, user) {
			var vm = this;
			vm.page = 1;
		vm.customer_data = []
		vm.searchCompany = ""
		vm.searchCustomer = function(){
		if(vm.valid()){
			vm.populatePromise = noc.customers.get({"name":'"%'+vm.searchCompany+'%"',"page_size":1000}).$promise
			.then(function(data){
			vm.customer_data = data.data;
			})
		}else{
			toastr.warning("Must Enter at least 3 Characters to run search")
		}
		}
		vm.valid = function(){
		if (vm.searchCompany.length >= 3){
			return true
		}
		}
		noc.systemTypes.get({"active":true}).$promise
		.then(function(data){
			vm.systemTypes = data.data
		})
		vm.chosen_customer = null;
		vm.userData = user.data;

		vm.next = function(k){
		vm.chosen_customer = vm.customer_data[k]
			vm.page = 2;
			vm.newEstimate.customerId = vm.chosen_customer.connectwise_id
			vm.newEstimate.id = Math.floor((Math.random() * 900) + 100).toString()+vm.chosen_customer.connectwise_id.toString();
		}

		vm.back = function(){
			vm.page = 1;
		}
		vm.newEstimate ={	"id":null,
							"customerId":null,
							"title":null,
							"type":null,
							"budgetary":false,
							"user":vm.userData.user_id
						}

		vm.objCheck = function(){
			if(vm.newEstimate.title != null && vm.newEstimate.type != null){
				return true
			}else{
				return false
			}
		}

		vm.startBuilder = function(){
			noc.estimates.save(vm.newEstimate,function(){
				$location.path("/estimateBuilder/"+vm.newEstimate.id+"/"+vm.newEstimate.type);
			})
		}
	}
})();

(function() {
  "use strict";

  angular
	.module("nocAngular")
	.controller("startNewDealerEstimateController", startNewDealerEstimateController);

  /** @ngInject */
	function startNewDealerEstimateController(toastr, noc,$log,$location) {
		var vm = this;
    vm.thirdParties = []
    vm.jnlReps = []
    vm.submissionObj = {"connectwise_id":null,"budgetary":false,"title":null,"third_party_id":null,"third_party":null,"third_party_owner":null,"type":null,"jnl_rep":null}

    vm.systemTypes = noc.systemTypes.query();
    noc.salesReps.query().$promise
    .then(function(data){
      angular.forEach(data,function(element){
        if(!element.third_party){
          vm.jnlReps.push({"name":element.name,"id":element.user_id})
        }
      })
    })

    noc.thirdParty.query().$promise
    .then(function(data){
      angular.forEach(data,function(element){
        if(element.sells_things){
          vm.thirdParties.push(element)
        }
      })
    })

    vm.get_details = function(dealer_id){
      vm.submissionObj.third_party_id = dealer_id
      vm.submissionObj.third_party = true
      vm.submissionObj.third_party_owner = null
      noc.thirdParty.get({id:dealer_id}).$promise
      .then(function(data){
        noc.thirdParty.query({id:dealer_id,route:"user"}).$promise
        .then(function(userData){
          var users = []
          angular.forEach(userData,function(element){
            if(element.sells_things && element.active){
              users.push(element)
            }
          })
          data["users"] = users
          vm.dealer_details = data
        })
      })
    }

    vm.validateForm = function(){
      var formGood = true
      angular.forEach(vm.submissionObj,function(element,k){
        if(k != 'connectwise_id'){
          if(element == null){
            formGood = false
          }
        }
      })
      return formGood
    }

    vm.save = function(){
      noc.nonTraditionalEstimates.save(vm.submissionObj).$promise
      .then(function(data){
        toastr.success("Estimate Created Successfully")
        $log.log(data)
        $location.path('buildDealerEstimate/'+data.estimate_id)
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning(err.data.errors)
      })
    }
	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('findEstimateController', findEstimateController);

	/** @ngInject */
	function findEstimateController($log, toastr, noc, user, searchFilters, $location) {
		var vm = this;

		vm.showInactive = false;
		vm.showAllReps = false;
		function load_data(){
			var owner
			var inactive
			var obj
			if(vm.all_reps){
				owner = null
			}else{
				owner = user.data.user_id
			}
			if(vm.inactive){
				inactive = null
			}else{
				inactive = false
			}

			if(vm.searchVal != ""){
				obj = {'owner':owner,'inactive':inactive,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {'owner':owner,'inactive':inactive,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			noc.estimates.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.clear_filters = function(){
			vm.searchVal = ""
			vm.sort_order = "DESC"
			vm.searchFor = "site_name"
			vm.sort_by = "last_updated"
			vm.num_results = 15
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.load_data = function(){
			load_data()
		}

		if(user.data.user_id){
			vm.clear_filters()
		}

		vm.openEstimate = function(estimate_id,system_type_id){
			$location.path("/estimateBuilder/"+estimate_id+'/'+system_type_id);
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('estimateBuilderController', estimateBuilderController);

	/** @ngInject */
	function estimateBuilderController($log,toastr, noc, $routeParams,user,$location,_,$q,$uibModal,$scope) {
		var vm = this;
		vm.userData = user;
		vm.thirdParties = []
		vm.quantum_exists = false
		vm.server_ip = noc.server_ip
		vm.report_server = noc.report_server_ip
		noc.userInfo.get({"third_party/id":0,"page_size":1000}).$promise
		.then(function(data){
			vm.jnlUsers = data.data
		})
		noc.thirdParty.get({"active":true,"page_size":1000}).$promise
		.then(function(data){
			angular.forEach(data.data,function(element){
				if(element.sells_things){
					vm.thirdParties.push(element)
				}
			})
		})
		vm.view = function(v){
			vm.currentView = v;
		}
		vm.dateOnly = function(){
			var date;
			date = new Date();
			date = date.getUTCFullYear() + '-' +
					('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
					('00' + date.getUTCDate()).slice(-2)
			return date
		}
		vm.expirationDate = function(){
			var someDate = new Date(vm.dateOnly());
			someDate.setDate(someDate.getDate() + 30); //number  of days to add, e.x. 15 days
			var dateFormated = someDate.toISOString().substr(0,10);
			return dateFormated;
		}
		vm.dateTime = function(){
			var date;
			date = new Date();
			date = date.getUTCFullYear() + '-' +
					('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
					('00' + date.getUTCDate()).slice(-2)
					('00' + date.getUTCHours()).slice(-2) + ':' +
					('00' + date.getUTCMinutes()).slice(-2) + ':' +
					('00' + date.getUTCSeconds()).slice(-2);
			return date
		}

		vm.probOptions = [0,25,50,75,100]
		vm.probCheck = function(){
			if(vm.estimateData.probability < 75){
				vm.clear()
			}
		}
		vm.sameObj = function(){
			if(vm.savedObj){
				if(vm.estimateData){
					return angular.equals(vm.savedObj,vm.estimateData)
				}
			}
		}
		vm.estimateId = $routeParams.id;
		vm.estimateType = $routeParams.systemType;
		noc.sub_location.get({"page_size":1000}).$promise
		.then(function(data){
			$log.log(data)
			vm.list_sublocations = data.data
		})
		vm.admin = 1;
		vm.filteredAvailableParts = {"selectedServer":[],
									"selectedRepeater":[],
									"selectedEnrollment":[],
									"selectedPower":[],
									"selectedWire":[],
									"selectedNetwork":[],
									"selectedPaging":[],
									"selectedPagers":[],
									"selectedNurseCall":[],
									"selectedTravel":[],
									"selectedDoorSupplies":[],
									"selectedAccessories":[],
									"selectedAddOns":[],
									"selectedDoorControllers":[],
									"selectedDoorPosition":[],
									"selectedBypassDevices":[],
									"selectedLockDevices":[]
							}

		vm.accessorySaveCheck = function(){
			if(vm.selectedAccessory && vm.accQty > 0){
				return true
			}else{
				return false
			}
		}

		vm.addOnSaveCheck = function(){
			if(vm.selectedAddOn && vm.addQty > 0){
				return true
			}else{
				return false
			}
		}

		vm.emptyArrCheck = function(arrKey){
			if(Object.keys(vm.filteredAvailableParts[arrKey]).length){
				return true
			}else{
				return false
			}
		}
		vm.actionName = function(){
			if(vm.estimateData){
				if(vm.estimateData.estimate_status_id == 0){
					return 'Submit'
				}else if (vm.estimateData.estimate_status_id == 1) {
					return 'Confirm Estimate'
				}else if (vm.estimateData.estimate_status_id == 2) {
					return 'Make Revision'
				}
			}
		}
		vm.submitValid = function(){
			var s = true;
			if(!(vm.estimateData.estimate_status_id == 2)){
				angular.forEach(vm.availableAreas,function(element){
					if(vm.userData.data.estimate_admin == 0){
						if(element.location_id != 0 && element.location_id != 1000 && element.location_id != 2000){
							if(!(vm.buttonValidate(element.location_id))) {
								s = false
							}
						}
					}
				});
			}
			return s
		}
		vm.levelUp = function(){
			if(vm.estimateData.estimate_status_id < 2){
				if(vm.estimateData.estimate_status_id == 1){
					vm.estimateData.approved_date = vm.dateOnly();
					vm.estimateData.expiration = vm.expirationDate();
				}
				vm.estimateData.estimate_status_id = parseInt(vm.estimateData.estimate_status_id) + 1;
				vm.saveEstimate()
			}else{
				vm.estimateData.revision = true;
				vm.estimateData.user = vm.userData.data.user_id
				noc.estimates.update({id:vm.estimateId},vm.estimateData,function(data){
					$location.path('/estimateBuilder/'+data.estimate_id+'/'+data.system_type_id)
				})
			}
		}

		vm.levelDown = function(){
			vm.estimateData.estimate_status_id = 0;
			vm.estimateData.approved_date = null;
			vm.estimateData.expiration = null;
			vm.saveEstimate()
		}

		vm.showEditQty= function(){
			if(vm.estimateData.estimate_status_id < 2 && user.data.estimate_admin == 1){
				return true
			}else{
				return false
			}
		}

		vm.disabler = function(){
			if (vm.estimateData){
				if(vm.estimateData.customer_signed){
					return true
				}else{
					var superIds = [6,9,13];
					var check = superIds.indexOf(vm.userData.data.user_id)
					if(vm.userData){
						if(vm.userData.data.estimate_admin == 0 && vm.estimateData.estimate_status_id > 0){
							return true
						}else if(vm.estimateData.estimate_status_id == 2 && check < 0){
							return true
						}else{
							return false
						}
					}else{
						return false
					}
				}
			}
		}

		vm.statusDisplay = function(){
			var d = false
			if(vm.statusInfo){
				angular.forEach(vm.statusInfo, function(element,key){
					if (key == vm.estimateData.estimate_status_id){
						d = element[vm.estimateData.estimate_status_id]
					}
				});
				return d
			}
		}
		vm.subLocations = null;

		vm.selectedParts = {"server":null,
							"repeater":null,
							"enrol":null,
							"power":null,
							"wire":[],
							"network":[],
							"paging":null,
							"pager":[],
							"nurseCall":[],
							"travel":[],
							"doorSupplies":[],
							"accessories":[],
							"addOns":[],
							"dealer":[]
						}
		var lockHarnessObj
		// noc.product.get({id:1690}).$promise
		// .then(function(data){
		// 	lockHarnessObj = {"related_part_connectwise_id":data.connectwise_id,"related_part_cost":data.general.cost.value,"related_part_description":data.general.name.value,"related_part_discount":0,"related_part_hours":data.estimator.hours.value,"related_part_number":data.part_number,"related_part_parent":452,"related_part_price":data.general.price.value,"related_part_qty":1}
		// })

		vm.doorGlobal = noc.doorGlobals.query();
		vm.licenseParts = noc.licenseInfo.query();
		vm.availableAreas = noc.areas.query({id:vm.estimateType});
		vm.pullCordObj = noc.pullCordData.get({id:vm.estimateId});
		//variables used to easily access the part that has been selected (select boxes only)
		vm.selectedRepeaterPart = null;
		vm.selectedEnrollmentPart = null;
		vm.selectedPowerPart = null;
		vm.selectedPagingPart = null;
		vm.projHours = null;
		vm.saveEstimate = function(initialSave){
			noc.estimates.update({id:vm.estimateId},vm.estimateData).$promise
			.then(function(){
				vm.checkPartsForOpportunity();
				noc.pullCordData.save({id:vm.estimateId},vm.pullCordObj)
				if(!initialSave){
					//Do Audit
					//vm.objectDifferenter(vm.savedObj,vm.estimateData) - skipping auditing for now
					vm.savedObj = angular.copy(vm.estimateData)
				}else{
					vm.savedObj = angular.copy(vm.estimateData)
				}
				toastr.success("SAVE SUCCESSFUL")
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("SAVE UNSUCCESSFUL CONTACT DREW")
			})
		}
		//Door Supply Tag Option Variable
		vm.noTags = false
		//Door Supply Band Option Variable
		vm.noBands = false
		//Door Supply Credential Option Variables
		vm.noCredentials = false

		vm.noneHandle = function(arrKey,subLocationId,noneSubmit){
			angular.forEach(vm.estimateData.parts[arrKey], function(element) {
				if(subLocationId == element.sub_location){
					if(noneSubmit){
						element.qty = 0;
					}else{
						if(element.qty == 0){
							element.qty = null;
						}
					}
				}
			});
		}

		vm.inactiveHandle = function(status){
			vm.estimateData.inactive = status
		}

		vm.budgetaryHandle = function(status){
			vm.estimateData.budgetary = status
		}

		vm.hideLaborHandle = function(status){
			vm.estimateData.hide_labor = status
		}
		//ACCESSORY AND ADDITIONAL PARTS ADD
		vm.accAdd = function(){
			var thisPart = null;
			thisPart = angular.copy(vm.otherPart)
			if(vm.additional_add){
				thisPart.part_location = 1001
				vm.estimateData.parts.addOns.push(thisPart)
				vm.additionalSearchValue = null
				vm.additionalResluts = []
			}else{
				thisPart.part_location = 1000
				vm.estimateData.parts.accessories.push(thisPart)
				vm.searchResults = []
				vm.searchValue = null
			}
			vm.otherPart = null;
			vm.modalInstance.dismiss()
		}
		// vm.saveAdd = function(){
		// 	var thisPart = null;
		// 	thisPart = angular.copy(vm.otherPart)
		// 	thisPart.part_location = 1001
		// 	vm.estimateData.parts.addOns.push(thisPart)
		// 	vm.otherPart = null;
		// 	vm.searchResults = []
		// 	vm.searchValue = null
		// 	vm.modalInstance.dismiss();
		// }
		//////////////////////////////////////

		vm.findStaticQty = function(parentPart,childPart){
			var return_value
			vm.availableParts.forEach( function(element) {
				if(element.product_connectwise_id == parentPart){
					angular.forEach(element.related_parts,function(rp){
						if(rp.related_part_connectwise_id == childPart){
							return_value = rp.related_part_qty
						}
					});
				}
			});
			return return_value
		}

		vm.QtyHandle = function(pn,arrKey){
			var depricatedPart = true
			angular.forEach(vm.selectedParts[arrKey],function(element){
				if(pn.product_connectwise_id == element.product_connectwise_id){
					element.qty = pn.qty
					depricatedPart = false
				}
			})
			if(depricatedPart){
				vm.selectedParts.wire.push(pn)
			}
		}

		//For Select Box Parts
		vm.relatedPartsFunction = function(arrKey){
			var thisQty = vm.estimateData.parts[arrKey].qty
			if(typeof(vm.estimateData.parts[arrKey].related_parts) == 'object') {
				angular.forEach(vm.estimateData.parts[arrKey].related_parts, function(rPart) {
					rPart.related_part_qty = thisQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id)
				});
			}
			if(arrKey == 'repeater'){
				vm.licenseJob()
			}
		};

		vm.licenseJob = function(){
			var enParts = 0;
			angular.forEach(vm.estimateData.parts.nurseCall,function(element){
				if(element.sub_location != 5){
					if(element.qty > 0){
						enParts = Number(enParts) + Number(element.qty)
					}
				}
			})
			if(vm.estimateData.parts.repeater){
				if(vm.estimateData.parts.repeater.qty > 0){
					if(enParts > 0){
						var totalEn = enParts + Number(vm.estimateData.future_devices)
						angular.forEach(vm.licenseParts,function(element){
							if(vm.estimateData.inovonics_location == element.locationEnabled && totalEn > element.min && totalEn < element.max){
								vm.estimateData.parts.licensePart = element
							}
						})
					}
				}
			}
		}

		//For Non Select Box Parts
		vm.relatedPartsFunction2 = function(arrKey,parentPart){
			angular.forEach(vm.estimateData.parts[arrKey],function(element){
				if(element.product_connectwise_id == parentPart){
					var thisQty = element.qty
					if(typeof(element.related_parts) == 'object') {
						angular.forEach(element.related_parts, function(rPart) {
							rPart.related_part_qty = thisQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id)
						});
					}
				}
			})
		};


		vm.totalPartPrice = function(price,qty){
			return price * qty;
		}

		vm.removePart = function(arrKey){
			vm.estimateData.parts[arrKey] = null;
		}

		vm.removePartQty = function(arrKey){
			vm.estimateData.parts[arrKey].qty = 0;
		}

		vm.removeQty = function(i,arrKey){
			vm.estimateData.parts[arrKey][i].qty = null;
		}

		vm.updateCurrentArea = function(val){
			vm.currentArea = val;
		}

		vm.selectionFill = function(arrKey,part){
			if(Object.keys(vm.estimateData.parts[arrKey]).length){
				var write = true
				angular.forEach(vm.estimateData.parts[arrKey],function(dataPart){
					if(dataPart.product_connectwise_id == part.product_connectwise_id){
						write = false
					}
				})
				if(write){
					vm.estimateData.parts[arrKey].push(part)
				}
			}else{
				vm.estimateData.parts[arrKey].push(part)
			}
		}

		vm.subLocationCreator = function(){
			var copyParts = angular.copy(vm.availableParts);
			vm.subLocations = {}
			copyParts.forEach( function(element) {
				if(element.sub_location != null){
					if(element.sub_location == 10){
						vm.filteredAvailableParts.selectedRepeater.push(element)
					}else if(element.sub_location == 11){
						vm.filteredAvailableParts.selectedPower.push(element)
					}else if(element.sub_location == 12){
						vm.selectionFill('wire',element)
					}else if(element.sub_location == 13){
						vm.filteredAvailableParts.selectedEnrollment.push(element)
					}else if (element.sub_location == 17 || element.sub_location == 18) {
						vm.selectionFill('network',element)
					}else if (element.sub_location <= 5) {
						vm.selectionFill('nurseCall',element)
					}else if (element.sub_location == 14 || element.sub_location == 15 || element.sub_location == 16){
						vm.selectionFill('doorSupplies',element)
					}else if(element.sub_location == 9){
						vm.filteredAvailableParts.selectedDoorControllers.push(element)
					}else if(element.sub_location == 6){
						vm.filteredAvailableParts.selectedDoorPosition.push(element)
					}else if(element.sub_location == 7){
						vm.filteredAvailableParts.selectedBypassDevices.push(element)
					}else if(element.sub_location == 8){
						vm.filteredAvailableParts.selectedLockDevices.push(element)
					}
				}else if(element.part_location ==1) {
					vm.filteredAvailableParts.selectedServer.push(element)
				}else if(element.part_location == 3){
					if(element.product_connectwise_id == 1385 || element.product_connectwise_id == 1890 || element.product_connectwise_id == 2253 || element.product_connectwise_id == 2475 || element.product_connectwise_id == 2476 || element.product_connectwise_id == 2477){
						$log.log("here")
						vm.selectionFill('pager',element)
					}else{
						vm.filteredAvailableParts.selectedPaging.push(element)
					}
				}else if(element.part_location == 0) {
					vm.selectionFill('travel',element)
				}else if(element.part_location == 1002){
					vm.selectionFill('dealer',element)
				}
			});
		}

		vm.subLocationValid = function(subLocationId){
			if(subLocationId in vm.subLocations){
				return true;
			}
			return false;
		}

		vm.staticQtyHandle = function(arrKey){
			vm.estimateData.parts[arrKey].qty = 1
		}

		//ALL THE DOOR BS///////////////////////////////////////////////////
		vm.newDoorObj = {
							"id":null,
							"doors_in_group":[],
							"controller":null,
							"doorPosition":null,
							"dpsQuantity":1,
							"requestExit":null,
							"requestEnter":null,
							"lockDevice":null,
							"wander":false,
							"doorbell":false,
							"elevator":false,
							"doubledoor":false,
							"central_unlock":false,
							"description":null,
							"page_number":1,
							"wanderPart":null,
							"doorbellPart":null
						};

		vm.startNewDoor = function(){
			var newDoor = angular.copy(vm.newDoorObj)
			if(Object.keys(vm.doorObj).length > 0){
				var maxId = 0;
				angular.forEach(vm.doorObj,function(element){
					if(element.id > maxId){
						maxId = element.id
					}
				})
				newDoor.id = maxId+1
				vm.doorObj.push(newDoor)
				vm.activateDoor(maxId+1)
			}else{
				newDoor.id = 1
				vm.doorObj.push(newDoor)
				vm.activateDoor(1)
			}
		}

		vm.buildDoorObj = function(){
			vm.doorObj = vm.estimateData.door_information
		}

		vm.checkForDoors = function(){
			if(Object.keys(vm.estimateData.door_information).length > 0){
				return true
			}else{
				return false
			}
		}

		vm.removeDoorRelated = function(i,arrKey,groupId){
			angular.forEach(vm.estimateData.door_information,function(element){
				if(element.id == groupId){
					element[arrKey].related_parts.splice(i,1)
				}
			})
		}

		vm.removeDoorPart = function(arrKey,groupId){
			angular.forEach(vm.estimateData.door_information,function(element){
				if(element.id == groupId){
					element[arrKey] = null;
				}
			})
		}

		vm.updateDoorSelector = function(){
			var foo = [];
			for (var i = 1; i <= vm.estimateData.expected_doors; i++) {
				if(!(vm.availableDoorNumber(i))){
					foo.push(i);
				}
			}
			vm.doorSelector = foo;
		}

		vm.availableDoorNumber = function(num){
			var rValue = false
			angular.forEach(vm.doorObj,function(arr){
				angular.forEach(arr.doors_in_group,function(element){
					if(num == element && arr.id != vm.selectedDoor){
						rValue = true
					}
				});
			});
			return rValue
		}
		vm.activateDoor = function(d){
			vm.selectedDoor = d;
			vm.updateDoorSelector()
		}
		vm.doorQtyHandle = function(id,ddCheck){
			angular.forEach(vm.estimateData.door_information, function(element) {
				if(element.id == id){
					var doorQty = Object.keys(element.doors_in_group).length
					var ddMultiplier = 1;
					if(element.doubledoor){
						ddMultiplier = 2;
					}
					if(ddCheck){
						element.dpsQuantity = ddMultiplier
					}
					if(element.controller){
						element.controller.qty = doorQty
						angular.forEach(element.controller.related_parts,function(rPart){
							rPart.related_part_qty = doorQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id)
						})
					}
					if(element.doorPosition){
						element.doorPosition.qty = doorQty * element.dpsQuantity
						angular.forEach(element.doorPosition.related_parts,function(rPart){
							rPart.related_part_qty = doorQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id) * element.dpsQuantity
						})
					}
					if(element.requestExit){
						element.requestExit.qty = doorQty
						angular.forEach(element.requestExit.related_parts,function(rPart){
							rPart.related_part_qty = doorQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id)
						})
					}
					if(element.requestEnter){
						element.requestEnter.qty = doorQty
						angular.forEach(element.requestEnter.related_parts,function(rPart){
							rPart.related_part_qty = doorQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id)
						})
					}
					if(element.lockDevice){
						element.lockDevice.qty = doorQty * ddMultiplier
						angular.forEach(element.lockDevice.related_parts,function(rPart){
							rPart.related_part_qty = doorQty * vm.findStaticQty(rPart.related_part_parent,rPart.related_part_connectwise_id) * ddMultiplier
						})
					}
					if(element.wanderPart){
						element.wanderPart.qty = doorQty
					}
					if(element.doorbellPart){
						element.doorbellPart.qty = doorQty
					}
				}
			});
			vm.doorRelatedPartsGet(id);
		}

		vm.wanderHandle = function(door_id){
			angular.forEach(vm.estimateData.door_information,function(door){
				if(door.id == door_id){
					if(door.wander){
						angular.forEach(vm.doorGlobal,function(element){
							if(element.is_wander){
								door.wanderPart = angular.copy(element)
							}
						})
					}else{
						door.wanderPart = null;
					}
				}
			})
			vm.doorQtyHandle(door_id)
		}
		vm.doorbellHandle = function(door_id){
			angular.forEach(vm.estimateData.door_information,function(door){
				if(door.id == door_id){
					if(door.doorbell){
						angular.forEach(vm.doorGlobal,function(element){
							if(element.is_doorbell){
								door.doorbellPart = angular.copy(element)
							}
						})
					}else{
						door.doorbellPart = null;
					}
				}
			})
			vm.doorQtyHandle(door_id)
		}
		vm.doorRelatedPartsGet = function(door_id){
			var rParts = []
			var doorKeys = ['controller','doorPosition','requestExit','requestEnter','lockDevice','wanderPart','doorbellPart']
			angular.forEach(vm.estimateData.door_information,function(door){
				if(door.id == door_id){
					if (door.lockDevice){
						if(door.doubledoor && door.lockDevice){
							if(door.lockDevice.product_connectwise_id == 452){
								door.lockDevice.related_parts = null
								lockHarnessObj.related_part_qty = door.doors_in_group.length
								door.lockDevice.related_parts = []
								door.lockDevice.related_parts.push(lockHarnessObj)
								// rParts.push(lockHarnessObj)
							}
						}
					}
					angular.forEach(doorKeys,function(k){
						if(door[k]){
							if(door[k].related_parts){
								angular.forEach(door[k].related_parts,function(element){
									rParts.push(element);
								})
							}
						}
					})
				}
			})
			return rParts
		}

		vm.doorSubTotal = function(){
			var subTotal = 0;
			var doorKeys = ['controller','doorPosition','requestExit','requestEnter','lockDevice','wanderPart','doorbellPart']
			angular.forEach(vm.estimateData.door_information,function(door){
				angular.forEach(doorKeys,function(k){
					if(door[k]){
						var discountMultiplier = (1 - (door[k].discount / 100))
						subTotal = subTotal + (door[k].product_price * door[k].qty * discountMultiplier)
						if(door[k].related_parts){
							angular.forEach(door[k].related_parts,function(rPart){
								var relatedDiscountMultiplier = (1 - (rPart.related_part_discount / 100))
								subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_price * relatedDiscountMultiplier)
							});
						}
					}
				});
			});
			return subTotal
		}

		vm.doorLaborSubTotal = function(){
			var subTotal = 0;
			var doorKeys = ['controller','doorPosition','requestExit','requestEnter','lockDevice','wanderPart','doorbellPart']
			angular.forEach(vm.estimateData.door_information,function(door){
				angular.forEach(doorKeys,function(k){
					if(door[k]){
						subTotal = subTotal + (vm.estimateData.labor_cost * door[k].product_hours * door[k].qty)
						if(door[k].related_parts){
							angular.forEach(door[k].related_parts,function(rPart){
								subTotal = subTotal + (vm.estimateData.labor_cost * rPart.related_part_qty * rPart.related_part_hours)
							});
						}
					}
				});
			});
			return subTotal
		}

		vm.doorHours = function(){
			if(vm.estimateData){
				if(vm.estimateData.door_information){
					var hours = 0;
					var doorKeys = ['controller','doorPosition','requestExit','requestEnter','lockDevice','wanderPart','doorbellPart']
					angular.forEach(vm.estimateData.door_information,function(door){
						angular.forEach(doorKeys,function(k){
							if(door[k]){
								hours = hours + (door[k].product_hours * door[k].qty)
								if(door[k].related_parts){
									angular.forEach(door[k].related_parts,function(rPart){
										hours = hours + (rPart.related_part_qty * rPart.related_part_hours)
									});
								}
							}
						});
					});
					return hours
				}
			}
		}

		vm.validateDoorGroup = function(groupId){
			var requiredKeys = ['controller','doorPosition']
			var allRequired = true;
			if(vm.estimateData.door_information){
				angular.forEach(vm.estimateData.door_information,function(door){
					var keepgoing = true;
					if(door.id == groupId){
						angular.forEach(requiredKeys,function(part){
							if(keepgoing){
								if(!(door[part])){
									allRequired = false;
									keepgoing = false;
								}else if(door[part].qty < 1) {
									allRequired = false;
									keepgoing = false;
								}
							}
						});
					}
				});
				return allRequired
			}
		}
		///////////////////////////////////////////////////////////////////
		///////////////PRICE CALCULATIONS//////////////////////////////////
		vm.hourTotal = function(){
			var selectSum = vm.selectHourArr.reduce(function(a, b) { return a + b; }, 0);
			var nonSelectHours = vm.nonSelectHoursArr.reduce(function(a, b) { return a + b; }, 0);
			return nonSelectHours + selectSum + vm.doorHours()
		}

		vm.hwTotal = function(){
			var subTotal = 0;
			if(vm.estimateData){
				if(vm.estimateData.parts && vm.estimateData.door_information){
					var selectKey = ['server']; //selectSubtotal
					var groupSubtotalKey = ['infrastructure','notification']; //groupSubtotal
					var nonsSelectKey = ['network','nurseCall','doorSupplies','addOns','dealer']; //nonSelectSubtotal
					subTotal = subTotal + vm.doorSubTotal();
					angular.forEach(selectKey,function(element){
						subTotal = subTotal + vm.selectSubtotal(element)
					})
					angular.forEach(groupSubtotalKey,function(element){
						subTotal = subTotal + vm.groupSubtotal(element)
					})
					angular.forEach(nonsSelectKey,function(element){
						subTotal = subTotal + vm.nonSelectSubtotal(element)
					})
				}
			}
			return subTotal
		}

		vm.laborTotal = function(){
			var subTotal = 0;
			if(vm.estimateData){
				if(vm.estimateData.parts && vm.estimateData.door_information){
					var selectKey = ['server']; //selectLaborSubtotal
					var groupSubtotalKey = ['infrastructure','notification']; //groupLaborSubtotal
					var nonsSelectKey = ['network','nurseCall','doorSupplies','addOns']; //nonSelectLaborSubtotal
					subTotal = subTotal + vm.doorLaborSubTotal();
					subTotal = subTotal + vm.travelLaborSubtotal();
					angular.forEach(selectKey,function(element){
						subTotal = subTotal + vm.selectLaborSubtotal(element)
					})
					angular.forEach(groupSubtotalKey,function(element){
						subTotal = subTotal + vm.groupLaborSubtotal(element)
					})
					angular.forEach(nonsSelectKey,function(element){
						subTotal = subTotal + vm.nonSelectLaborSubtotal(element)
					})
				}
			}
			return subTotal
		}

		vm.laborFinal = function(){
			var originalAmount = vm.laborTotal()
			var discountMultiplier = (1 - (vm.estimateData.labor_discount / 100))
			vm.labordiscountAmount = originalAmount - (originalAmount*discountMultiplier)
			return Number(vm.laborTotal())*discountMultiplier
		}
		vm.hwFinal = function(){
			var originalAmount = vm.hwTotal()
			var discountMultiplier = (1 - (vm.estimateData.hardware_discount / 100))
			vm.hwdiscountAmount = originalAmount - (originalAmount*discountMultiplier)
			return Number(originalAmount)*discountMultiplier
		}
		vm.selectSubtotal = function(arrKey){
			var subTotal = 0;
			if(vm.estimateData.parts[arrKey]){
				if(vm.estimateData.parts[arrKey].qty > 0){
					var discountMultiplier = (1 - (vm.estimateData.parts[arrKey].discount / 100))
					subTotal = subTotal + (vm.estimateData.parts[arrKey].product_price * vm.estimateData.parts[arrKey].qty * discountMultiplier)
					if(vm.estimateData.parts[arrKey].related_parts){
						angular.forEach(vm.estimateData.parts[arrKey].related_parts,function(rPart){
							var discountMultiplier = (1 - (rPart.related_part_discount / 100))
							subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_price * discountMultiplier)
						})
					}
				}
			}
			return subTotal
		}
		vm.selectHourArr = [];
		vm.selectLaborSubtotal = function(arrKey){
			var subTotal = 0;
			var hours = 0;
			if(arrKey == 'server'){
				vm.selectHourArr = [];
			}
			if(vm.estimateData.parts[arrKey]){
				subTotal = subTotal + vm.estimateData.parts[arrKey].product_hours * vm.estimateData.parts[arrKey].qty * vm.estimateData.labor_cost
				hours = hours + (vm.estimateData.parts[arrKey].product_hours * vm.estimateData.parts[arrKey].qty)
				if(vm.estimateData.parts[arrKey].is_repeater && vm.estimateData.inovonics_location){
					subTotal = subTotal + vm.estimateData.location_hours * vm.estimateData.location_cost * vm.estimateData.parts[arrKey].qty
					hours = hours + (vm.estimateData.location_hours * vm.estimateData.parts[arrKey].qty)
				}
				if(vm.estimateData.parts[arrKey].related_parts){
					angular.forEach(vm.estimateData.parts[arrKey].related_parts,function(rPart){
						subTotal = subTotal + (vm.estimateData.labor_cost * rPart.related_part_qty * rPart.related_part_hours)
						hours = hours + (rPart.related_part_qty * rPart.related_part_hours)
					})
				}
			}
			vm.selectHourArr.push(hours)
			return subTotal
		}
		vm.nonSelectSubtotal = function(arrKey){
			var subTotal = 0;
			angular.forEach(vm.estimateData.parts[arrKey],function(element){
				if(element.qty > 0){
					var discountMultiplier = (1 - (element.discount / 100))
					subTotal = subTotal + (element.qty * element.product_price * discountMultiplier)
					if(element.related_parts){
						angular.forEach(element.related_parts,function(rPart){
							var discountMultiplier = (1 - (rPart.related_part_discount / 100))
							subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_price * discountMultiplier)
						})
					}
				}
			})
			return subTotal
		}
		vm.nonSelectHoursArr = [];
		vm.nonSelectLaborSubtotal = function(arrKey){
			var subTotal = 0;
			var hours = 0;
			if(arrKey == 'wire'){
				vm.nonSelectHoursArr = [];
			}
			angular.forEach(vm.estimateData.parts[arrKey],function(element){
				if(element.qty > 0){
					subTotal = subTotal + (element.qty * element.product_hours * vm.estimateData.labor_cost)
					if(element.product_hours > 0){
						hours = (element.product_hours * element.qty)
						vm.nonSelectHoursArr.push(hours)
					}
					if(element.related_parts){
						angular.forEach(element.related_parts,function(rPart){
							subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_hours * vm.estimateData.labor_cost)
							if(rPart.related_part_hours > 0){
								hours = (rPart.related_part_hours * rPart.related_part_qty)
								vm.nonSelectHoursArr.push(hours)
							}
						})
					}
				}
			})
			return subTotal
		}
		vm.licenseSubtotal = function(){
			if(vm.estimateData.parts.licensePart){
				return vm.estimateData.parts.licensePart.product_price
			}else{
				return 0;
			}
		}
		vm.groupSubtotal = function(area){
			var keys = {"infrastructure":['repeater','enrol','power'],"notification":['paging']} //PARTS SELECTED BY SELECT BOXES (OBJECTS)
			var otherKeys = {'infrastructure':['wire'],"notification":['pager']} //PARTS BASED ON QTY ENTERED (ARRAYS)
			var subTotal = 0;
			angular.forEach(keys[area],function(key){
				subTotal = subTotal + vm.selectSubtotal(key)
			})
			angular.forEach(otherKeys[area],function(key1){
				subTotal = subTotal + vm.nonSelectSubtotal(key1)
			})
			if(area == 'infrastructure'){
				subTotal = subTotal + Number(vm.licenseSubtotal())
			}
			return subTotal
		}
		vm.groupLaborSubtotal = function(area){
			var keys = {"infrastructure":['repeater','enrol','power'],"notification":['paging']} //PARTS SELECTED BY SELECT BOXES (OBJECTS)
			var otherKeys = {'infrastructure':['wire'],"notification":['pager']} //PARTS BASED ON QTY ENTERED (ARRAYS)
			var subTotal = 0;
			angular.forEach(keys[area],function(key){
				subTotal = subTotal + vm.selectLaborSubtotal(key)
			})
			angular.forEach(otherKeys[area],function(key1){
				subTotal = subTotal + vm.nonSelectLaborSubtotal(key1)
			})

			return subTotal
		}
		vm.travelLaborSubtotal = function(){
			var subTotal = 0
			angular.forEach(vm.estimateData.parts.travel,function(part){
				subTotal = subTotal + part.product_price * part.qty
			});
			return subTotal
		}

		vm.accessoryPrice = function(q,p,d){
			var discountMultiplier = (1 - (d / 100))
			return q * p * discountMultiplier
		}

		vm.totalInvestment = function(){
			return vm.laborFinal() + vm.hwFinal() + parseFloat(vm.estimateData.tax_amount)
		}
		///////////////////////////////////////////////////////////////////

		vm.relatedPartsGet = function(arrKey){
			var rParts = [];
			angular.forEach(vm.estimateData.parts[arrKey],function(part){
				if(part.qty > 0){
					if(part.related_parts){
						angular.forEach(part.related_parts,function(rP){
							rParts.push(rP)
						})
					}
				}
			})
			return rParts
		}
		vm.checkArray = function(arrKey){
			var check = false
			angular.forEach(vm.estimateData.parts[arrKey],function(element){
				if(element.qty > 0){
					check = true
				}
			})
			return check
		}
		vm.removeRelated = function(i,partInfo,arrKey){
			angular.forEach(vm.estimateData.parts[arrKey],function(element, key){
				if(partInfo.related_part_parent == element.product_connectwise_id){
					vm.estimateData.parts[arrKey][key].related_parts.splice(i, 1)
				}
			})
		}
		vm.reset = function(arrKey,pn,i){
			vm.estimateData.parts[arrKey].splice(i, 1)
			var copyParts = angular.copy(vm.availableParts);
			copyParts.forEach( function(element) {
			//S	if (element.sub_location == 17 || element.sub_location == 18) {
					if(element.product_connectwise_id == pn){
						vm.estimateData.parts[arrKey].splice(i, 0, element)
					}
				//}
			})
			vm.relatedPartsFunction2(arrKey,pn)
		}
		//TOP BUTTON BAR VALIDATION
		vm.buttonValidate = function(areaId){
			if(vm.estimateData){
				if(vm.estimateData.parts && vm.estimateData.door_information){
					if(areaId == 1000 || areaId == 2000 || areaId == 0 || areaId == 1002){
						return true
					}else if(areaId == 1){
						if(vm.estimateData.parts.server){
							return true
						}
					}else if(areaId == 2){
						if(vm.emptyArrCheck('selectedRepeater')){
							if(vm.estimateData.parts.repeater){
								if(Number(vm.estimateData.parts.repeater.qty) < 1) {
									return false
								}
							}else{
								return false
							}
						}
						if(vm.emptyArrCheck('selectedEnrollment')){
							if(vm.estimateData.parts.enrol) {
								if(Number(vm.estimateData.parts.enrol.qty) < 1) {
									return false
								}
							}else{
								return false
							}
						}
						if(vm.emptyArrCheck('selectedPower')){
							if(vm.estimateData.parts.power) {
								if(Number(vm.estimateData.parts.power.qty) < 1){
									return false
								}
							}else{
								return false
							}
						}
						return true
					}else if(areaId == 3){
						if(!vm.estimateData.parts.paging && vm.emptyArrCheck('selectedPaging')){
							return false
						}
						return true
					}else if(areaId == 4){
						var ncDevices = false;
						var keepgoing = true;
						angular.forEach(vm.estimateData.parts.nurseCall,function(element){
							if(keepgoing){
								if(element.qty > 0){
									ncDevices = true;
								}
								if(element.sub_location == 1 || element.sub_location == 4){
									if(!(vm.pcLineValid(element.product_connectwise_id,element.qty))){
										ncDevices = false;
										keepgoing = false;
									}
								}
							}
						});
						return ncDevices
					}else if(areaId == 5){
						var doorsgood = true;
						var numDoors = 0
						angular.forEach(vm.estimateData.door_information,function(element){
							numDoors = numDoors + element.doors_in_group.length
							if(!(vm.validateDoorGroup(element.id))){
								doorsgood = false;
							}
						});
						if(numDoors != vm.estimateData.expected_doors){
							doorsgood = false;
						}
						return doorsgood
					}else if(areaId == 6) {
						var doorsupply = false;
						var tags = false;
						var bands = false;
						var credentials = false;
						angular.forEach(vm.estimateData.parts.doorSupplies,function(element){
							if(element.sub_location == 15){
								if(vm.noTags){
									tags = true;
								}
								if(tags == false && element.qty > 0){
									tags = true;
								}
							}
							else if(element.sub_location == 16){
								if(vm.noBands){
									bands = true;
								}
								if(bands == false && element.qty > 0){
									bands = true;
								}
							}else if(element.sub_location == 14){
								if(vm.noCredentials){
									credentials = true;
								}
								if(credentials == false && element.qty > 0){
									credentials = true;
								}
							}
						})
						if(credentials && bands && tags){
							doorsupply = true;
						}
						return doorsupply
					}else if(areaId == 7) {
						var networkDevices = false;
						angular.forEach(vm.estimateData.parts.network,function(element){
							if(element.qty > 0){
								networkDevices = true
							}
						})
						return networkDevices
					}
				}
			}
		}
		//NURSE CALL SPECIFIC FUNCTIONS
		vm.pcHandle = function(pId){
			if(!(vm.pullCordObj[pId])){
				vm.pullCordObj[pId] = {"bed":null,"bath":null,"common":null}
			}
			vm.licenseJob()
		}

		vm.pc = function(){
			if(Object.keys(vm.pullCordObj).length){
				return true
			}
			return false
		}

		vm.pcLineValid = function(pId,quantity){
			if(vm.pullCordObj[pId]){
				if(vm.pullCordObj[pId].bed != undefined){
					if(Number(vm.pullCordObj[pId].bed)+Number(vm.pullCordObj[pId].bath)+Number(vm.pullCordObj[pId].common) == Number(quantity)){
						return true
					}else{
						return false
					}
				}
			}else{
				return true
			}
		}
		/////////////////////////////////
		vm.ladda = true;
		vm.allParts = noc.allParts.query(function(data){
			angular.forEach(data,function(element){
				if(element.product_table_id == 1853){
					lockHarnessObj = {"related_part_connectwise_id":element.product_connectwise_id,"related_part_cost":element.product_cost,"related_part_description":element.product_description,"related_part_discount":0,"related_part_hours":element.product_hours,"related_part_number":element.product_part_number,"related_part_parent":452,"related_part_price":element.product_price,"related_part_qty":1}

				}
			})
			vm.estimateData = noc.estimates.get({id:vm.estimateId},function(){
				vm.loaded_inactive = vm.estimateData.inactive
				noc.systemParts.get({"system_id":vm.estimateType,"page_size":1000}).$promise
				.then(function(data){
					vm.availableParts = data.data

					vm.customerInfo = noc.customers.get({connectwise_id:vm.estimateData.customer_id},function(customerData){
						// $log.log(customerData)
						vm.customerInfo = customerData.data[0]
						noc.contacts.get({"connectwise_customer_id":vm.customerInfo['connectwise_id']}).$promise
						.then(function(contact_data){
							vm.customerInfo['contacts'] = contact_data['data']
						})
						$log.log(vm.customerInfo)
						// vm.savedObj = angular.copy(vm.estimateData)
						vm.statusInfo = [["Editable"],{"1":"Submitted For Review"},{"2":"Confirmed"}]
						vm.buildDoorObj()
						vm.availableAreas.push({"location_description":'Labor and Travel',"location_id":0})
						vm.availableAreas.push({"location_description":'Accessories and Additions',"location_id":1000})
						vm.availableAreas.push({"location_description":'Dealer Assistance',"location_id":1002})
						vm.availableAreas.push({"location_description":'Review',"location_id":2000})
						vm.updateCurrentArea(1);
						vm.currentView = 'details';
						vm.subLocationCreator();
						vm.updateDoorSelector();
						vm.hwTotal();
						vm.checkPartsForOpportunity();
						vm.getReps();
						vm.customerView = vm.report_server+"/reports/estimator/customer_view.php?est="+vm.estimateData.estimate_id+"&allow=allow"
						vm.dealerView = vm.report_server+"/reports/estimator/dealer_view.php?est="+vm.estimateData.estimate_id+"&allow=allow"
						vm.equations = vm.report_server+"/reports/estimator/equations.php?est="+vm.estimateData.estimate_id+"&allow=allow"
						vm.jobPack = vm.report_server+"/reports/estimator/job_pack.php?est="+vm.estimateData.estimate_id+"&allow=allow"
						// vm.saveEstimate(true)
						noc.quantumCustomer.get({"connectwise_id":vm.estimateData.customer_id}).$promise
						.then(function(data){
							$log.log(data)
							if(data.data.length > 0){
								vm.quantum_exists = true
							}
						})
						vm.savedObj = angular.copy(vm.estimateData)
						vm.ladda = false
					});
				})
			});
		})

		vm.updatePricing = function(){
			noc.estimates.update({"route":"update-prices","id":vm.estimateData.estimate_id},{}).$promise
			.then(function(){
				toastr.success("Parts updated, refresh to reflect")
			})
		}
////////////////////////////////////////////////////

		vm.clear = function() {
			vm.estimateData.estimated_close = null;
			vm.estimateData.estimated_ship = null;
			vm.estimateData.estimated_install = null;
		};

		vm.inlineOptions = {
			customClass: getDayClass,
			minDate: new Date(),
			showWeeks: true
		};

		vm.dateOptions = {
			dateDisabled: disabled,
			formatYear: 'yy',
			// maxDate: new Date(2020, 5, 22),
			// minDate: new Date(),
			startingDay: 0
		};

		// Disable weekend selection
		function disabled(data) {
			var date = data.date,
				mode = data.mode;
			return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
		}

		vm.toggleMin = function() {
			vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
			vm.dateOptions.minDate = vm.inlineOptions.minDate;
		};

		vm.toggleMin();

		vm.open1 = function() {
			vm.popup1.opened = true;
		};

		vm.open2 = function() {
			vm.popup2.opened = true;
		};

		vm.open3 = function() {
			vm.popup3.opened = true;
		};

		vm.setDate = function(year, month, day) {
			vm.dt = new Date(year, month, day);
		};

		vm.formats = ['yyyy-MM-dd', 'dd-MMMM-yyyy', 'dd.MM.yyyy', 'shortDate'];
		vm.format = vm.formats[0];
		vm.altInputFormats = ['M!/d!/yyyy'];

		vm.popup1 = {
			opened: false
		};

		vm.popup2 = {
			opened: false
		};

		vm.popup3 = {
			opened: false
		};

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		vm.events = [
			{
				date: tomorrow,
				status: 'full'
			},
			{
				date: afterTomorrow,
				status: 'partially'
			}
		];

		function getDayClass(data) {
			var date = data.date,
			mode = data.mode;
			if (mode === 'day') {
				var dayToCheck = new Date(date).setHours(0,0,0,0);

				for (var i = 0; i < vm.events.length; i++) {
					var currentDay = new Date(vm.events[i].date).setHours(0,0,0,0);

					if (dayToCheck === currentDay) {
						return vm.events[i].status;
					}
				}
			}
			return '';
		}

		vm.goSearch = function(){
			$location.path("/estimatorFindEstimate")
		}
		/////////////////////////////////////////////////////////////////////////////////////////////
		vm.objectDifferenter = function(prevObj,newObj){
			var objKeys = ['repeater','enrol','power','server','paging'] //PARTS SELECTED BY SELECT BOXES (OBJECTS)
			var arrKeys = ['wire','pager','network','nurseCall','travel','doorSupplies','accessories','addOns','dealer'] //PARTS BASED ON QTY ENTERED (ARRAYS)
			var doorObjects = ['controller','doorPosition','wanderPart','doorbellPart','requestEnter','requestExit','lockDevice'] //OBJECTS WITHIN EACH DOOR OBJECT
			var omittedDoors = ['id','is_license','same_bypass','central_unlock']
			var oldPn = null;
			var oldPd = null;
			var oldQty = null;
			var oldPr = null;
			var newPn = null;
			var newPd = null;
			var newQty = null;
			var newPr = null;
			angular.forEach(prevObj,function(element,key){
				if(key != '$promise'){ //IGNORE THIS KEY
					if(key != 'parts' && key != 'door_information'){ //Estimate Base Info
						if(newObj,key){ //CONFIRM NEW OBJ HAS THE KEY
							if(prevObj[key] != newObj[key]){ //CHECK IF PREVIOUS VALUES IS THE SAME AS NEW VALUES
								var a = {"key":key,"old":prevObj[key],"new":newObj[key],"type":1,"user":vm.userData.data.user_id} //BUILD OBJECT FOR SUBMISSION TO API
								noc.audit.save({id:vm.estimateId},a) //SUBMIT THE OBJECT TO THE API
							}
						}
					}else if(key == 'parts') { //ALL PARTS EXCEPT DOORS
						angular.forEach(prevObj.parts,function(v,k){
							if(newObj,k){
								if(_.indexOf(objKeys,k) != -1){ //IF THE "ELEMENT" IS AN OBJECT
									if(!(angular.equals(prevObj.parts[k],newObj.parts[k]))){ //CHECK IF THE PREVIOUS OBJECT IS DIFFERENT THAN THE NEW OBJECT
										if(!prevObj.parts[k]){ //DEFINE EACH VAR AS NULL IF THE KEY IS NULL
											oldPn = null;
											oldPd = null;
											oldQty = null;
											oldPr = null;
										}else{
											oldPn = prevObj.parts[k].product_part_number;
											oldPd = prevObj.parts[k].product_description;
											oldQty = prevObj.parts[k].qty;
											oldPr = prevObj.parts[k].product_price;
										}
										if(!newObj.parts[k]){//DEFINE EACH VAR AS NULL IF THE KEY IS NULL
											newPn = null;
											newPd = null;
											newQty = null;
											newPr = null;
										}else{
											newPn = newObj.parts[k].product_part_number;
											newPd = newObj.parts[k].product_description;
											newQty = newObj.parts[k].qty;
											newPr = newObj.parts[k].product_price;
										}
										//BUILD OBJECT TO PUSH TO API
										var b = {"key":k,"oldPn":oldPn,"oldPartDescription":oldPd,"oldQty":oldQty,"oldPrice":oldPr,"newPn":newPn,"newPartDescription":newPd,"newQty":newQty,
												"newPrice":newPr,"type":2,"user":vm.userData.data.user_id}
										noc.audit.save({id:vm.estimateId},b) //SUBMIT THE OBJECT TO THE API
									}
								}else if (_.indexOf(arrKeys,k) != -1) { //IF THE "ELEMENT" IS AN ARRAY
									angular.forEach(prevObj.parts[k],function(item,head){
										if(!(angular.equals(item,newObj.parts[k][head]))){ //CHECK IF THE OBJECT (WITHIN THE ARRAY) IS THE SAME
											//BUILD THE OBJECT TO PUSH TO API
											// $log.log(newObj.parts[k][head])
											if(newObj.parts[k][head] != undefined){
												var c = {"key":k,"oldPn":item.product_part_number,"oldPartDescription":item.product_description,"oldQty":item.qty,"oldPrice":item.product_price,
														"newPn":newObj.parts[k][head].product_part_number,"newPartDescription":newObj.parts[k][head].product_description,"newQty":newObj.parts[k][head].qty,
														"newPrice":newObj.parts[k][head].product_price,"type":2,"user":vm.userData.data.user_id}
												noc.audit.save({id:vm.estimateId},c) //SUBMIT THE OBJECT TO THE API
											}
										}
									})
								}
							}
						})
					}else if(key == 'door_information') {
						if(Object.keys(prevObj.door_information).length > Object.keys(newObj.door_information).length){
							$log.log('DOOR GROUP REMOVED');
						}else if (Object.keys(prevObj.door_information).length < Object.keys(newObj.door_information).length) {
							$log.log('DOOR GROUP ADDED');
						}else{
							angular.forEach(prevObj.door_information,function(v,k){
								if(!(angular.equals(prevObj.door_information[k],newObj.door_information[k]))){
									angular.forEach(prevObj.door_information[k],function(item,head){
										if(_.indexOf(doorObjects,head) != -1){
											if(!(angular.equals(prevObj.door_information[k][head],newObj.door_information[k][head]))){
												if(!prevObj.door_information[k][head]){ //DEFINE EACH VAR AS NULL IF THE KEY IS NULL
													oldPn = null;
													oldPd = null;
													oldQty = null;
													oldPr = null;
												}else{
													oldPn = prevObj.door_information[k][head].product_part_number;
													oldPd = prevObj.door_information[k][head].product_description;
													oldQty = prevObj.door_information[k][head].qty;
													oldPr = prevObj.door_information[k][head].product_price;
												}
												if(!newObj.door_information[k][head]){//DEFINE EACH VAR AS NULL IF THE KEY IS NULL
													newPn = null;
													newPd = null;
													newQty = null;
													newPr = null;
												}else{
													newPn = newObj.door_information[k][head].product_part_number;
													newPd = newObj.door_information[k][head].product_description;
													newQty = newObj.door_information[k][head].qty;
													newPr = newObj.door_information[k][head].product_price;
												}
												var d = {"key":head,"oldPn":oldPn,"oldPartDescription":oldPd,"oldQty":oldQty,"oldPrice":oldPr,"newPn":newPn,"newPartDescription":newPd,"newQty":newQty,
													"newPrice":newPr,"type":3,"user":vm.userData.data.user_id}
												noc.audit.save({id:vm.estimateId},d)
											}
										}else if(_.indexOf(omittedDoors,head) == -1){
											if(prevObj.door_information[k][head] != newObj.door_information[k][head]) {
												var e = {"key":head,"old":item,"new":newObj.door_information[k][head],"type":4,"user":vm.userData.data.user_id} //BUILD OBJECT FOR SUBMISSION TO API
												noc.audit.save({id:vm.estimateId},e) //SUBMIT THE OBJECT TO THE API
											}
										}
									});
								}
							});
						}
						// angular.forEach(newObj.door_information,function(v,k){
						// 	if(!(prevObj.door_information[k])){
						// 		console.log('NEW DOOR GROUP')
						// 	}
						// })
					}
				}
			})
			vm.savedObj = angular.copy(vm.estimateData)
		}

		vm.opportunityValid = function(){
			var valid = false
			if (vm.estimateData){
				if(vm.estimateData.owner && vm.estimateData.site_contact && vm.estimateData.estimate_status_id == 2){
					if(vm.inactiveParts){
						if(vm.inactiveParts.length == 0){
							valid = true
						}
					}
				}
			}
			return valid
		}

		vm.quantumValid = function(){
			var valid = false
			if(vm.estimateData){
				if(vm.estimateData.estimate_status_id == 2 && vm.estimateData.probability == 100 && !vm.estimateData.customer_signed){
					valid = true
				}
			}
			return valid
		}

		vm.checkPartsForOpportunity = function(){
			noc.estimates.query({id:vm.estimateData.estimate_id,route:'validate-opportunity'}).$promise
			.then(function(data){
				vm.inactiveParts = data
			})
		}


		vm.createOpportunity = function(){
			noc.connectwise_routes.query({"route":"company-opportunity","id":vm.estimateData.customer_id}).$promise
			.then(function(data){
				vm.opp_array = data
				vm.modalInstance = $uibModal.open({
					templateUrl: 'opportunity_handle.html',
					scope: $scope,
					size: 'md'
				});
			})
		}

		vm.selected_opp_f = function(k){
			vm.selected_opp = vm.opp_array[k]
		}

		vm.update_opportunity = function(){
			var new_st = vm.selected_opp.name.split("Proposal")[0]+' Proposal '+vm.estimateData.estimate_id
			new_st = new_st.trim()
			vm.closeModal()

			vm.saveParts = noc.connectwise_routes.update({"route":"company-opportunity","id":vm.selected_opp.id},{"name":new_st,"estimate_id":vm.estimateData.estimate_id}).$promise
			.then(function(){
				toastr.success("Opportunity Updated!!")
			})
		}

		vm.thirdParty = function(){
			if(vm.estimateData.third_party == false){
				vm.estimateData.third_party_id = null
				vm.estimateData.third_party_owner = null
			}
		}

		vm.getReps = function(){
			if(vm.estimateData.third_party_id){
				noc.userInfo.get({"third_party/id":vm.estimateData.third_party_id,"page_size":1000}).$promise
				.then(function(data){
					vm.reps = data.data
				})
			}
		}

		vm.sealTheDeal = function(){
			vm.customerInfo.contact = vm.estimateData.site_contact
			vm.customerInfo.estimate_id = vm.estimateId
			noc.quantumCustomer.save(vm.customerInfo).$promise
			.then(function(){
				toastr.success("Quantum Customer Created")
				vm.estimateData.customer_signed = true
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Failed to Create Quantum Customer")
			})
		}

		vm.searchProduct = function(additional){
			var searchedParts = []
			vm.searchResults = []
			vm.additionalResluts = []
			var s
			if(additional == 1){
				s = vm.additionalSearchValue
			}else{
				s = vm.searchValue
			}
			//$log.log("run")
			angular.forEach(vm.allParts,function(element){
				if(element.product_description.toLowerCase().indexOf(s.toLowerCase()) >= 0 || element.product_part_number.toLowerCase().indexOf(s.toLowerCase()) >= 0){
					if(searchedParts.indexOf(element.product_connectwise_id) == -1){
						searchedParts.push(element.product_connectwise_id)
						// element.sys_part = true
						if(additional == 0){
							vm.additional_add = false
							vm.searchResults.push(element)
						}else{
							vm.additional_add = true
							vm.additionalResluts.push(element)
						}
					}
				}
			})
		}

		vm.chosenPart = function(p){
			vm.otherPart = p
			vm.otherPart.qty = 1
			vm.modalInstance = $uibModal.open({
				templateUrl: 'enterQTY.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.open_change_order = function(){
			// $log.log(vm.estimateData.estimate_id)
			$location.path('change-order-manage/'+vm.estimateData.estimate_id+'/-1')
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss()
		}


	}


})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('findDealerEstimateController', findDealerEstimateController);

  /** @ngInject */
	function findDealerEstimateController($log, toastr, noc, user, searchFilters, $location) {
		var vm = this;

		vm.chosenCustomer = null;

		vm.showInactive = false;
		vm.showAllReps = false;
		vm.userData = user;

    vm.availableCustomers = []
    vm.users = noc.userInfo.query()

    noc.nonTraditionalEstimates.query().$promise
    .then(function(data){
      vm.estimates = data
      angular.forEach(data,function(element){
        if(vm.availableCustomers.indexOf(element.site_name) === -1){
          vm.availableCustomers.push(element.site_name)
        }
      })
    })

		vm.filteredResults = function(){
			var filteredArray = []
      angular.forEach(vm.estimates,function(element){
        var add_to_array = true
        if(searchFilters.estimateSearchParams.customer_name){
          if(element.site_name != searchFilters.estimateSearchParams.customer_name){
            add_to_array = false
          }
        }
        if(searchFilters.estimateSearchParams.estimate_id && add_to_array){
          if(!(element.estimate_id.includes(searchFilters.estimateSearchParams.estimate_id))){
            add_to_array = false
          }
        }
        if(!searchFilters.estimateSearchParams.all_reps && add_to_array){
          if(element.owner != vm.userData.data.user_id){
            add_to_array = false
          }
        }
        if(!searchFilters.estimateSearchParams.inactive && add_to_array){
          if(element.inactive){
            add_to_array = false
          }
        }
        if(searchFilters.estimateSearchParams.won && add_to_array){
          if(element.probability < 100){
            add_to_array = false
          }
        }
        if(add_to_array){
          filteredArray.push(element)
        }
      })

			return filteredArray
		}
    vm.clearFilter = function(){
      searchFilters.estimateSearchParams = {"customer_id":null,"inactive":false,"all_reps":false,"probability":null,"status":null,"customer_name":null,"estimate_id":null,"won":false}
      refresh_filters()
    }
    function refresh_filters(){
      vm.searchData = searchFilters.estimateSearchParams
    }

    vm.openEstimate = function(estimate_id){
      $location.path("/buildDealerEstimate/"+estimate_id);
    }

    vm.won_func = function(){
      if(vm.searchData.won){
        vm.searchData.inactive = true;
      }
    }

    refresh_filters()
	}
})();

(function() {
	"use strict";

	angular
	.module("nocAngular")
	.controller("buildDealerEstimateController", buildDealerEstimateController);

	/** @ngInject */
	function buildDealerEstimateController(toastr, noc,$log,$routeParams,user,$q,$uibModal,$scope,$timeout,$location) {
		var vm = this;
		vm.report_server = noc.report_server_ip
		vm.submissionObj = {'server':null,'repeater':null,'infrastructure':[],'other':[],"license":null}
		vm.e_id = $routeParams.estimate_id
    $log.log(vm.e_id)
		vm.userData = user;
		// var used_infrastructure = [];
		vm.view = 'details'
    vm.subView ='non'
		vm.probOptions = [0,25,50,75,100]

		vm.serverHide = false
		vm.repeaterHide = false

		vm.sss = 'None'

		var promises = []
		vm.available_servers = []
		vm.available_repeaters = []
		vm.available_infrastructure = []
		vm.available_others = []
		var license_required = false
		var searchedParts = []
		vm.searchResults = []

		// vm.licenseFinder = function(){
		// 	angular.forEach(vm.license_data,function(element){
		// 		if(vm.submissionObj.estimate_data.inovonics_location){
		// 			if(vm.submissionObj.estimate_data.future_devices >= element.min && vm.submissionObj.estimate_data.future_devices <= element.max){
		// 				vm.submissionObj.license = element
		// 			}
		// 		}else{
		// 			if(!element.locationEnabled){
		// 				vm.submissionObj.license = element
		// 			}
		// 		}
		// 	})
    //   vm.savedObj = angular.copy(vm.submissionObj)
		// }

		// $timeout(vm.licenseFinder, 1000)
		noc.nonTraditionalEstimates.get({id:vm.e_id}).$promise
		.then(function(data){
			vm.submissionObj = data
			promises.push(
				noc.systemParts.query({id:data.estimate_data.type}).$promise
				.then(function(data){
					angular.forEach(data,function(element){
						// $log.log(element)
						if(element.part_location == 1){
							vm.available_servers.push(element)
						}
						else if(element.part_location == 2){
							if(element.is_repeater){
								vm.available_repeaters.push(element)
								license_required = true
							}else{
								vm.available_infrastructure.push(element)
							}
						}else{
							vm.available_others.push(element)
						}
					})
				})
			)

			promises.push(
				noc.customers.get({id:vm.submissionObj.estimate_data.customer_id}).$promise
				.then(function(data){
					vm.customerInfo = data
				})
			)

			promises.push(
				noc.customers.query().$promise
				.then(function(data){
					vm.otherCustomers = data
					angular.forEach(data,function(element){
						if(element.connectwise_id == vm.submissionObj.estimate_data.t_party_client_id){
							vm.selectedSite = element
							vm.selectedSiteContacts = element.contacts
						}
					})
				})
			)

			promises.push(
				noc.product.query().$promise
				.then(function(data){
					vm.products = data
				})
			)

			promises.push(
				noc.licenseInfo.query().$promise
				.then(function(data){
					vm.license_data = data
					if(license_required){
						vm.licenseFinder()
					}
				})
			)

			// promises.push(
			// 	noc.customers.get({id:vm.submissionObj.estimate_data.customer_id}).$promise
			// 	.then(function(data){
			// 		vm.customer_data = data
			// 	})
			// )

			promises.push(
				noc.statusInfov2.query().$promise
				.then(function(data){
					vm.statuses = data
				})
			)

			vm.jnlUsers = noc.userInfo.query()

			vm.populatePromise = $q.all(promises)
		})


		vm.quantityHandle = function(key){
			if(vm.submissionObj[key]){
				vm.submissionObj[key]['qty'] = 1
			}
		}

		vm.actionName = function(){
			if(vm.submissionObj.estimate_data){
				if(vm.submissionObj.estimate_data.status == 0){
					return 'Submit'
				}else if (vm.submissionObj.estimate_data.status == 1) {
					return 'Confirm Estimate'
				}else if (vm.submissionObj.estimate_data.status == 2) {
					return 'Make Revision'
				}
			}
		}

		vm.updateQty = function(){
			if(vm.selectedPart.qty > 0){
				angular.forEach(vm.selectedPart.related_parts,function(element){
					element.related_part_qty = vm.selectedPart.qty * element.related_part_qty
				})
			}
		}

		vm.checkPartsForOpportunity = function(){
			noc.estimates.query({id:vm.submissionObj.estimate_data.estimate_id,route:'validate-opportunity'}).$promise
			.then(function(data){
				vm.inactiveParts = data
			})
		}
		$timeout(vm.checkPartsForOpportunity, 1000)

		vm.savePart = function(type){
			if (type == 2){
				vm.submissionObj.infrastructure.push(vm.selectedPart)
				vm.selectedPart = null
			}else if(type == 3){
				if(vm.otherPart.sys_part){
					vm.otherPart.part_location = 8
					vm.otherPart.sub_location = null
					if(vm.otherPart.related_parts){
						angular.forEach(vm.otherPart.related_parts,function(element){
							element.related_part_qty = element.related_part_qty * vm.otherPart.qty
						})
					}
					vm.submissionObj.other.push(vm.otherPart)
					vm.otherPart = null
					vm.searchValue = null
					vm.searchResults = []
					vm.modalInstance.dismiss()
				}else{
					noc.product.get({id:vm.otherPart.product_table_id}).$promise
					.then(function(data){
						vm.otherPart.product_price = data.general.price.value
						vm.otherPart.product_cost = data.general.cost.value
						vm.otherPart.product_hours = data.estimator.hours.value
						vm.otherPart.discount = 0
						vm.otherPart.part_location = 8
						vm.otherPart.sub_location = null
						vm.otherPart.system_to_parts_table_id = null
						vm.otherPart.parent_part = null
						vm.otherPart.page_number = 0
						vm.otherPart.related_parts = null
						vm.otherPart.is_repeater = false
						vm.otherPart.is_license = false
						vm.submissionObj.other.push(vm.otherPart)
						vm.otherPart = null
						vm.searchValue = null
						vm.searchResults = []
						vm.modalInstance.dismiss()
					})
				}
			}
		}

		vm.cancelPart = function(type){
			if(type == 2){
				vm.selectedPart = null
			}
		}

		vm.selectSite = function(){
			vm.submissionObj.estimate_data.t_party_client_id = vm.selectedSite.connectwise_id
			vm.submissionObj.estimate_data.t_party_client_contact_id = null
			vm.selectedSiteContacts = vm.selectedSite.contacts
		}

		vm.infrastructure_line_total = function(key){
			$log.log(vm.submissionObj.infrastructure[key])
		}

		vm.searchProduct = function(){
			searchedParts = []
			vm.searchResults = []
			$log.log("run")
			angular.forEach(vm.available_others,function(element){
				if(element.product_description.toLowerCase().indexOf(vm.searchValue.toLowerCase()) >= 0 || element.product_part_number.toLowerCase().indexOf(vm.searchValue.toLowerCase()) >= 0){
					if(searchedParts.indexOf(element.product_connectwise_id) == -1){
						searchedParts.push(element.product_connectwise_id)
						element.sys_part = true
						vm.searchResults.push(element)
					}
				}
			})
			angular.forEach(vm.products,function(element){
				if(element.name.toLowerCase().indexOf(vm.searchValue.toLowerCase()) >= 0 || element.part_number.toLowerCase().indexOf(vm.searchValue.toLowerCase()) >= 0){
					if(searchedParts.indexOf(element.connectwise_id) == -1){
						searchedParts.push(element.connectwise_id)
						vm.searchResults.push({"product_table_id":element.id,"product_connectwise_id":element.connectwise_id,"product_description":element.name,"product_part_number":element.part_number,"sys_part":false})
					}
				}
			})
		}

		vm.chosenPart = function(p){
			vm.otherPart = p
			vm.otherPart.qty = 1
			vm.modalInstance = $uibModal.open({
				templateUrl: 'enterQTY.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss()
		}

		vm.removePartFromArray = function(arrayName,key){
			vm.submissionObj[arrayName].splice(key,1)
		}

		vm.total = function(){
			var hwSubTotal = 0
			var hwSubTotalDealer = 0
			var hours = 0
      var labor = 0
			if(vm.submissionObj.estimate_data){
				var discountMultiplier = 1 - (parseFloat(vm.submissionObj.estimate_data.third_party_discount) / 100)

				var selectKey = ['server','license','repeater']; //selectSubtotal
				var groupSubtotalKey = ['infrastructure','other']; //groupSubtotal

				if(vm.submissionObj.estimate_data.inovonics_location && vm.submissionObj.repeater){
					hours = hours + (vm.submissionObj.estimate_data.location_hours * vm.submissionObj.repeater.qty)
          labor = labor + (vm.submissionObj.estimate_data.location_cost * vm.submissionObj.estimate_data.location_hours * vm.submissionObj.repeater.qty)
				}

				angular.forEach(selectKey,function(element){
					if(vm.submissionObj[element]){
						hwSubTotal = (hwSubTotal + (vm.submissionObj[element].qty * vm.submissionObj[element].product_price))
						hwSubTotalDealer = hwSubTotalDealer + ((vm.submissionObj[element].qty * vm.submissionObj[element].product_price) * discountMultiplier)
						if(vm.submissionObj[element].product_hours > 0){
							hours = hours + (vm.submissionObj[element].product_hours * vm.submissionObj[element].qty)
              labor = labor + (vm.submissionObj.estimate_data.labor_cost * vm.submissionObj[element].product_hours * vm.submissionObj[element].qty)
						}
						if(vm.submissionObj[element].related_parts){
							angular.forEach(vm.submissionObj[element].related_parts,function(rp){
								hwSubTotal = (hwSubTotal + (rp.related_part_qty * rp.related_part_price))
								hwSubTotalDealer = hwSubTotalDealer + ((rp.related_part_qty * rp.related_part_price) * discountMultiplier)
								if(rp.related_part_hours > 0){
									hours = hours + (rp.related_part_hours * rp.related_part_qty)
                  labor = labor + (vm.submissionObj.estimate_data.labor_cost * rp.related_part_hours * rp.related_part_qty)
								}
							})
						}
					}
				})
				angular.forEach(groupSubtotalKey,function(element){
					angular.forEach(vm.submissionObj[element],function(part_in_array){
						hwSubTotal = (hwSubTotal + (part_in_array.qty * part_in_array.product_price))
						hwSubTotalDealer = hwSubTotalDealer + ((part_in_array.qty * part_in_array.product_price) * discountMultiplier)
						if(part_in_array.product_hours > 0){
							hours = hours + (part_in_array.product_hours * part_in_array.qty)
              labor = labor + (vm.submissionObj.estimate_data.labor_cost * part_in_array.product_hours * part_in_array.qty)
						}
						if(part_in_array.related_parts){
							angular.forEach(part_in_array.related_parts,function(rp){
								hwSubTotal = (hwSubTotal + (rp.related_part_qty * rp.related_part_price))
								hwSubTotalDealer = hwSubTotalDealer + ((rp.related_part_qty * rp.related_part_price) * discountMultiplier)
								if(rp.related_part_hours > 0){
									hours = hours + (rp.related_part_hours * rp.related_part_qty)
                  labor = labor + (vm.submissionObj.estimate_data.labor_cost * rp.related_part_hours * rp.related_part_qty)
								}
							})
						}
					})
				})
        angular.forEach(vm.submissionObj.install,function(element){
          labor = labor + (element.product_price * element.qty)
        })
				vm.totalObject = {"hw":hwSubTotal,"hwD":hwSubTotalDealer,"hours":hours,"labor":labor}
				return {"hw":hwSubTotal,"hwD":hwSubTotalDealer,"hours":hours,"labor":labor}
			}
		}

		vm.objValid = function(){
			var valid = false
			if(vm.submissionObj.estimate_data){
				if(vm.submissionObj.estimate_data.future_devices >= 0 && vm.submissionObj.estimate_data.future_devices <= 3000){
					valid = true
				}
			}
			return valid
		}

    vm.sameObj = function(){
			if(vm.savedObj){
				if(vm.submissionObj){
					return angular.equals(vm.savedObj,vm.submissionObj)
				}
			}
		}

		vm.saveEstimate = function(){
			noc.nonTraditionalEstimates.update({id:vm.e_id},vm.submissionObj).$promise
			.then(function(){
				toastr.success("Quote Saved Successfully")
        vm.savedObj = angular.copy(vm.submissionObj)
			})
			.catch(function(err){
				toastr.warning("Drew is Probably Required")
				$log.log(err)
			})
		}

		vm.clear = function() {
			vm.submissionObj.estimate_data.estimated_close = null;
			vm.submissionObj.estimate_data.estimated_ship = null;
			vm.submissionObj.estimate_data.estimated_install = null;
		};
		vm.dateOnly = function(){
			var date;
			date = new Date();
			date = date.getUTCFullYear() + '-' +
					('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
					('00' + date.getUTCDate()).slice(-2)
			return date
		}
		vm.expirationDate = function(){
			var someDate = new Date(vm.dateOnly());
			someDate.setDate(someDate.getDate() + 30); //number  of days to add, e.x. 15 days
			var dateFormated = someDate.toISOString().substr(0,10);
			return dateFormated;
		}
		vm.levelUp = function(){
			if(vm.submissionObj.estimate_data.status < 2){
				if(vm.submissionObj.estimate_data.status == 1){
					vm.submissionObj.estimate_data.approved_date = vm.dateOnly();
					vm.submissionObj.estimate_data.expiration = vm.expirationDate();
				}
				vm.submissionObj.estimate_data.status = parseInt(vm.submissionObj.estimate_data.status) + 1;
				vm.saveEstimate()
			}else{
				vm.submissionObj.estimate_data.revision = true;
				vm.submissionObj.estimate_data.user = vm.userData.user_id
				noc.nonTraditionalEstimates.update({id:vm.e_id},vm.submissionObj,function(data){
					$location.path('/buildDealerEstimate/'+data.estimate_id)
				})
			}
		}
		vm.makeEditable = function(){
			vm.submissionObj.estimate_data.status = 0
			vm.saveEstimate()
		}
		vm.probCheck = function(){
			if(vm.submissionObj.estimate_data.probability < 75){
				vm.clear()
			}
		}

		function disabled(data) {
			var date = data.date,
				mode = data.mode;
			return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
		}

		vm.dateOptions = {
			dateDisabled: disabled,
			formatYear: 'yy',
			// maxDate: new Date(2020, 5, 22),
			// minDate: new Date(),
			startingDay: 0
		};
		function getDayClass(data) {
			var date = data.date,
			mode = data.mode;
			if (mode === 'day') {
				var dayToCheck = new Date(date).setHours(0,0,0,0);

				for (var i = 0; i < vm.events.length; i++) {
					var currentDay = new Date(vm.events[i].date).setHours(0,0,0,0);

					if (dayToCheck === currentDay) {
						return vm.events[i].status;
					}
				}
			}
			return '';
		}

		vm.inlineOptions = {
			customClass: getDayClass,
			minDate: new Date(),
			showWeeks: true
		};

		vm.toggleMin = function() {
			vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
			vm.dateOptions.minDate = vm.inlineOptions.minDate;
		};

		vm.toggleMin();

		vm.popup1 = {
			opened: false
		};

		vm.popup2 = {
			opened: false
		};

		vm.popup3 = {
			opened: false
		};

		vm.open1 = function() {
			vm.popup1.opened = true;
		};

		vm.open2 = function() {
			vm.popup2.opened = true;
		};

		vm.open3 = function() {
			vm.popup3.opened = true;
		};

		vm.opportunityValid = function(){
			var valid = false
			if (vm.submissionObj.estimate_data){
				if(vm.submissionObj.estimate_data.owner && vm.submissionObj.estimate_data.site_contact && vm.submissionObj.estimate_data.status == 2){
					if(vm.inactiveParts){
						if(vm.inactiveParts.length == 0){
							valid = true
						}
					}
				}
			}
			return valid
		}

		vm.quantumValid = function(){
			var valid = false
			if(vm.submissionObj.estimate_data){
				if(vm.submissionObj.estimate_data.status == 2 && vm.submissionObj.estimate_data.probability == 100 && !vm.submissionObj.estimate_data.customer_signed){
					valid = true
				}
			}
			return valid
		}

		vm.disabler = function(){
			if (vm.submissionObj.estimate_data){
				if(vm.submissionObj.estimate_data.customer_signed){
					return true
				}else{
					var superIds = [6,9,13];
					var check = superIds.indexOf(vm.userData.data.user_id)
					$log.log(check)
					if(vm.userData.data){
						if (check >= 0 && !vm.submissionObj.estimate_data.customer_signed){
							return false
						}else if(vm.userData.data.estimate_admin == 0 && vm.submissionObj.estimate_data.status > 0){
							return true
						}else if(vm.submissionObj.estimate_data.estimate_status_id == 2 && check < 0){
							return true
						}else{
							return false
						}
					}else{
						return false
					}
				}
			}
		}

		vm.sealTheDeal = function(){
			vm.customerInfo.contact = vm.submissionObj.estimate_data.site_contact
			vm.customerInfo.estimate_id = vm.e_id
			noc.quantumCustomer.save(vm.customerInfo).$promise
			.then(function(){
				toastr.success("Quantum Customer Created")
				vm.submissionObj.estimate_data.customer_signed = true
			})
			.catch(function(err){
				$log.log(err)
				toastr.warning("Failed to Create Quantum Customer")
			})
		}

		vm.createOpportunity = function(){
			var p = []
			p.push(
				noc.userInfo.get({id:vm.submissionObj.estimate_data.owner}).$promise
				.then(function(data){
					var staff_connectwise_id = data.connectwise_id
					var oppObj = {"primarySalesRep":{"id":staff_connectwise_id},"name":"Proposal "+vm.e_id,"company":{"id":vm.submissionObj.estimate_data.t_party_client_id},"contact":{"id":vm.submissionObj.estimate_data.t_party_client_contact_id}}
					p.push(
						vm.saveOpportunity = noc.opportunity.save(oppObj).$promise
						.then(function(oppData){
							var opp_id = oppData['id']
							p.push(
								vm.saveParts = noc.opportunity.update({id:opp_id},{"name":vm.submissionObj.estimate_data.estimate_id}).$promise
								.then(function(){
									toastr.success("Opportunity Created!!")
								})
							)
						})
					)
				})
			)
		}
		$log.log(noc.ip)
		vm.dealerView = vm.report_server+"/reports/estimator/dealer_view_nonT.php?est="+vm.e_id+"&allow=allow"
		vm.equations = vm.report_server+"/reports/estimator/equation_nonT.php?est="+vm.e_id+"&allow=allow"

		vm.goSearch = function(){
			$location.path("/findDealerEstimate")
		}
    vm.totalPartPrice = function(price,qty){
			return price * qty;
		}
	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('customerDetailController', customerDetailController);

  /** @ngInject */
	function customerDetailController(toastr, noc, $routeParams, $q, $log, $uibModal, $scope) {
		var vm = this;
		var customerId = $routeParams.id;
    var promises = []

    vm.hardwareLoaded = false //Set to False before production

    vm.serverTypes = [{"id":1,"name":"Cloud"},{"id":2,"name":"On Site"},{"id":3,"name":"On Site Virtual"}]
    vm.customer_table_id = null

    function load_quantum_data(){
      promises.push(
        noc.estimates.get({"customer_id":customerId,"probability":100,"status":2}).$promise
        .then(function(data){
          vm.estimate_data = data
        })
      )

      promises.push(
        noc.quantumHardware.get({"quantum_customer/id":vm.quantumId,"page_size":1000}).$promise
        .then(function(data){
          vm.hardware = data.data
          // S$log.log('hardware')
        })
      )

      promises.push(
        noc.thirdParty.get({"active":true,"page_size":1000}).$promise
        .then(function(data){
          vm.active_third_parties = data.data
        })
      )
      vm.populatePromise = $q.all(promises)
      .then(function(){
        vm.hardwareLoaded = true;
      })
 
      vm.unknownHardware = noc.quantumCustomer.get({"id":vm.quantumId,"route":"unknownHardware","page_size":1000})
    }

    function load_ssh_data(){
      noc.sstSystem.query({"customer_data/id":vm.customer_table_id}).$promise
      .then(function(data){
        if(data.length > 0){
          vm.sstData = data[0]
          noc.sstKiosk.query({"customer_data/id":vm.customer_table_id}).$promise
          .then(function(kiosk_data){
            vm.kioskData = kiosk_data
          })
        }else{
          vm.sstData = null
        }
      })
    }

    vm.formChange = function(){
      vm.changed = true
    }

    vm.saveCustomer = function(){
      noc.quantumCustomer.update({id:vm.quantumId},vm.customer).$promise
      .then(function(){
        toastr.success("Customer Updated")
        vm.changed = false
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("Update Failed")
      })
    }

    vm.allegion_enroll = function(){
      vm.allegion_promise = noc.quantumCustomer.save({id:vm.quantumId,route:"allegionSite"},vm.customer).$promise
      .then(function(data){
        toastr.success("Allegion Site Created")
        vm.customer.allegion_key = data.created_hex_key
        vm.customer.allegion_site_reference = data.created_id
        load_quantum_data()
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("Failed to Create Site")
      })
    }

    vm.allegion_rectify_hardware = function(){
      vm.hw_promise = noc.quantumCustomer.get({id:vm.customer.id,route:"allegionHardware"}).$promise
      .then(function(data){
        $log.log(data)
        toastr.success("Hardware Recieved")
        load_quantum_data()
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("Failed to Retrieve Hardware")
      })
    }

    function getIds(){
      // var quantum_there = false;
      noc.customers.get({"connectwise_id":customerId}).$promise
      .then(function(c_data){
        vm.customer_table_id = c_data['data'][0]['id'];
        vm.customer_data = c_data['data'][0]
        // load_ssh_data()
        noc.quantumCustomer.get({"connectwise_id":customerId}).$promise
        .then(function(data){
          if(data.count >= 1){
            vm.quantumId = data['data'][0]['id']
            vm.customer = data['data'][0]
            load_quantum_data()
            noc.connectwise_routes.query({"route":"company-agreement","id":customerId}).$promise
            .then(function(data1){
              if(data1.length == 0){
                vm.customer['support_contract_active'] = false
              }else{
                vm.customer['support_contract_active'] = true
              }
            })
            vm.view = 'qm'
            // quantum_there = true;
          }else{
            vm.quantumId = null;
            vm.view = 'sh'
          }
        })
      })
      // })
    }

    vm.addKiosk = function(){
      vm.activeKiosk = {"id":null,"production_number":0,"name":null,"mac":null,"customer_data":{"id":vm.customer_table_id},"temp_scanner":{"has_scanner":false,"scanner_production_number":0,"scanner_mac":null,"scanner_ip":null},"web_relay":{"has_web_relay":false,"relay_production_number":0,"relay_ip":null,"relay_mac":null}}

      vm.modalInstance = $uibModal.open({
        templateUrl: 'kioskModal.html',
        scope: $scope,
        size: 'md'
      });


    }

    vm.saveKiosk = function(){
      if(vm.activeKiosk.id){
        noc.sstKiosk.update({"id":vm.activeKiosk.id},vm.activeKiosk).$promise
        .then(function(){
          toastr.success("Saved Kiosk Successfully")
          load_ssh_data()
          vm.closeModal()
        }).catch(function(){
          toastr.warning("Failed to save Kiosk")
        })
      }else{
        noc.sstKiosk.save(vm.activeKiosk).$promise
        .then(function(){
          toastr.success("Saved Kiosk Successfully")
          load_ssh_data()
          vm.closeModal()
        }).catch(function(){
          toastr.warning("Failed to save Kiosk")
        })
      }
    }

    vm.loadKiosk = function(kiosk_id){
      noc.sstKiosk.get({"id":kiosk_id}).$promise
      .then(function(data){
        vm.activeKiosk = data
        vm.modalInstance = $uibModal.open({
          templateUrl: 'kioskModal.html',
          scope: $scope,
          size: 'md'
        });
      })

    }

    vm.closeModal = function(){
			vm.modalInstance.dismiss()
      vm.activeKiosk = null;
		}

    getIds()
	}

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('criticalAlertDetailController', criticalAlertDetailController);

  /** @ngInject */
	function criticalAlertDetailController(toastr, noc, $routeParams) {
		var vm = this;
		var alertId = $routeParams.id;
		vm.alertData = noc.alertDetail.get({id:alertId});
		vm.ticketNotes = noc.ticketNotes.query({id:alertId});
		vm.userData = noc.userInfo.query()	
		

		vm.notesEmpty = function(){
			if(vm.ticketNotes.length > 0){
				return false
			}else{
				return true
			}
		}
	}
})();
(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('critAlertsController', critAlertsController);

  /** @ngInject */
	function critAlertsController(toastr, noc,$log,$uibModal,$scope) {
		var vm = this;
		
		vm.num_results = 15
		vm.current_page = 1
		vm.sort_by = "alert_start_time"
		vm.sort_order = "ASC"
		vm.searchFor = "alert_start_time"
		vm.searchVal = ""
		vm.confirmed_show = "no"
		vm.closed = "no"
		vm.alert_type = "all"

		function build_filter_obj(){
			var obj = {}
			obj['page'] = vm.current_page
			obj['sort_order'] = vm.sort_order
			obj['sort_by'] = vm.sort_by
			obj['page_size'] = vm.num_results
			if (vm.confirmed_show == "no"){
				obj['alert_confirmed'] = false
			}else if(vm.confirmed_show == "yes"){
				obj['alert_confirmed'] = true
			}
			if (vm.closed == "no"){
				obj['alert_cleared'] = false
			}else if(vm.closed == "yes"){
				obj['alert_cleared'] = true
			}
			if (vm.alert_type == "hardware"){
				obj['critical_alert'] = false
			}else if(vm.alert_type == "server"){
				obj['critical_alert'] = true
			}
			$log.log(obj)
			return obj
		}
		
		vm.load_data = function(){
			var filter_obj = build_filter_obj()
			noc.quantumAlert.get(filter_obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data()

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			vm.load_data()
		}

		vm.seconds_to_days = function(seconds) {
			// calculate (and subtract) whole days
			var days = Math.floor(seconds / 86400);
			seconds -= days * 86400;
	
			// calculate (and subtract) whole hours
			var hours = Math.floor(seconds / 3600) % 24;
			seconds -= hours * 3600;
	
			// calculate (and subtract) whole minutes
			var minutes = Math.floor(seconds / 60) % 60;
	
			return days + 'd ' + hours + 'h ' + minutes + 'm ';
		}

		vm.confirm_alert = function(){
			noc.quantumAlert.delete({"id":vm.active_id}).$promise
			.then(function(){
				toastr.success("Success")
				vm.close_modal()
				vm.active_id=null
				vm.active_name=null
				vm.load_data()
			}).catch(function(error){
				toastr.warning(error)
			})
		}

		vm.open_modal = function(alert_id,customer_name){
			vm.active_id = alert_id
			vm.active_name = customer_name
			vm.modalInstance = $uibModal.open({
				templateUrl: 'confirmAlert.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.close_modal = function(){
			vm.modalInstance.dismiss();
		}
	}
})();
(function() {
  'use strict';

  angular
    .module('nocAngular')
    .service('utils', utils);

    function utils($log,$filter,$sce) {

      var utils= {}

      utils.compareObj = function(obj1,obj2){
        var differences = {}
        if(angular.equals(obj1,obj2)){
          return false
        }else{
          angular.forEach(obj1,function(element,key){
            if(angular.isUndefined(obj2[key])){
              $log.log(key)
            }else{
              if(obj1[key] !== null && angular.isObject(obj1[key])){
                if(angular.equals(obj1[key],obj2[key])){
                  $log.log("Sub Objects are The Same")
                }else{
                  differences[key] = {"oldValue":obj1[key],"newValue":obj2[key]}
                }
              }else{
                if(obj1[key] == obj2[key]){
                  $log.log("Value Same for key "+key)
                }else{
                  differences[key] = {"oldValue":obj1[key],"newValue":obj2[key]}
                }
              }
            }
          })
          return differences
        }
      }

      utils.toLocalTime = function(utcString, format) {
        if (!utcString) return '';
        try {
          var date = new Date(utcString);

          // Format using Angular's date filter
          var formatted = $filter('date')(date, format || 'medium');

          // Safely get local timezone abbreviation (ES5 way)
          var tzAbbr = '';
          try {
            var parts = new Intl.DateTimeFormat('en-us', { timeZoneName: 'short' }).formatToParts(date);
            for (var i = 0; i < parts.length; i++) {
              if (parts[i].type === 'timeZoneName') {
                tzAbbr = parts[i].value;
                break;
              }
            }
          } catch (e) {
            tzAbbr = '';
          }

          return formatted + (tzAbbr ? ' ' + tzAbbr : '');
        } catch (e) {
          $log.error("toLocalTime failed:", e);
          return utcString;
        }
      };

      utils.renderNewlines = function(text) {
        if (!text) return text;
        
        // Replace \r\n, \n, or \r with <br>
        var html = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        
        // Allow Angular to render HTML safely
        return $sce.trustAsHtml(html);
      };



      return utils
    }
}) ();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .factory('user', function() {

        var userFactory = {}
        userFactory.data = {};
        userFactory.data.authKey = null;

        return userFactory

    })

})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .factory('testAppAPI', function($resource) {

        var doFactory = {}
        //doFactory.ip = null
        doFactory.server_ip = null

        //var server_ip = ""

        var fun = function(){
            doFactory.currentStatus = $resource(doFactory.server_ip +'/currentStatus',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.getMac = $resource(doFactory.server_ip +'/getMac',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.inputStatus = $resource(doFactory.server_ip +'/inStatus/:id',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })


            doFactory.startTest = $resource(doFactory.server_ip +'/start',{},{
                'get':    {method:'GET'},
                'put':    {method:'PUT'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.stopTest = $resource(doFactory.server_ip +'/stop',{},{
                'get':    {method:'GET'},
                'put':    {method:'PUT'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.screenChange = $resource(doFactory.server_ip +'/screenPlay/:id',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'},
                'update': {method:'PUT'}
            })

            doFactory.toggleSound = $resource(doFactory.server_ip +'/toggleSound',{},{
                'get':    {method:'GET'},
                'put':    {method:'PUT'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.toggleOutput = $resource(doFactory.server_ip +'/toggleOutput/:id',{},{
                'get':    {method:'GET'},
                'put':    {method:'PUT'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.testStatus = $resource(doFactory.server_ip +'/testStatus',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.updateApp = $resource(doFactory.server_ip +'/updateApp/:type',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.tontecBoot = $resource(doFactory.server_ip +'/tontec-boot',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'put':    {method:'PUT'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            doFactory.build_bridge = $resource(doFactory.server_ip +'/build-bridge',{},{
                'get':    {method:'GET'},
                'save':   {method:'POST'},
                'put':    {method:'PUT'},
                'query':  {method:'GET', isArray:true},
                'remove': {method:'DELETE'},
                'delete': {method:'DELETE'}
            })

            return doFactory
        }

        doFactory.test = function(){
            var a = fun()
            return a
        }

        return fun()
    })

})();


(function() {
  'use strict';

  angular
	.module('nocAngular')
	.factory('tagTestAPI', function($resource) {

		var doFactory = {}
		var server_ip = "http://10.0.8.21:5000" //IP OF THE PI IN THE ENROLLMENT TAG TESTER
		// var pc_ip = "http://10.0.8.20:5000" //IP ADDRESS OF THE PI IN THE PULL CORD TESTER BOX

		doFactory.startTest = $resource(server_ip +'/start',{},{
            'put':    {method:'PUT'}
		})

		doFactory.currentStatus = $resource(server_ip +'/get-result',{},{
			'get':    {method:'GET'}
		})

		doFactory.completeTest = $resource(server_ip +'/complete',{},{
			'put':    {method:'PUT'}
		})

		doFactory.close = $resource(server_ip +'/close',{},{
            'put':    {method:'PUT'}
		})

        doFactory.turnOffTag = $resource(server_ip +'/turn-off-tag',{},{
            'put':    {method:'PUT'}
		})

		return doFactory

	})

})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .service('searchFilters', searchFilters);

    function searchFilters() {
      var filters = {}

      filters.estimateSearchParams = {"customer_id":null,"inactive":false,"all_reps":false,"probability":null,"status":null,"customer_name":null,"estimate_id":null,"won":false}
      filters.ticketSearchParams = {"ticket_number":null,"customer_id":null,"searchText":null}
      return filters
    }
}) ();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .factory('httpRequestInterceptor', function(user) {

    return {
       request: function (config) {

         config.headers['Auth-Token'] = user.data.authKey;
         //config.headers['Auth-Token'] = 'abc123';

         return config;
       }
     };
    })

})();
(function() {
  'use strict';

  angular
    .module('nocAngular')
    .factory('flask_app', function($resource) {

        var doFactory = {}
        var server_ip = "http://noc.jnltech.net:5000"
        //var server_ip = ""
        
        doFactory.openPurchaseOrders = $resource(server_ip +'/openPurchaseOrders',{},{ 
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'} 
        }) 

        doFactory.purchaseOrderDetail = $resource(server_ip +'/purchaseOrderDetail/:id',{},{ 
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'} 
        })

        doFactory.lineItem = $resource(server_ip +'/lineItem/:poId/:lineId',{},{ 
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'patch':   {method:'PUT'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'} 
        })     

        return doFactory

    })

})();
(function() {
  'use strict';

  angular
    .module('nocAngular')
    .factory('boardTestAPI', function($resource) {

        var doFactory = {}
        var server_ip = "http://192.168.71.141:5000" //IP OF THE PI IN THE DOOR TESTER BOX
        var pc_ip = "http://10.0.8.20:5000" //IP ADDRESS OF THE PI IN THE PULL CORD TESTER BOX

        doFactory.inputStatus = $resource(server_ip +'/inStatus/:id',{},{
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })


        doFactory.startTest = $resource(server_ip +'/start',{},{
            'get':    {method:'GET'},
            'put':    {method:'PUT'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.stopTest = $resource(server_ip +'/stop',{},{
            'get':    {method:'GET'},
            'put':    {method:'PUT'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.currentStatus = $resource(server_ip +'/currentStatus',{},{
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.toggleOutput = $resource(server_ip +'/toggleOutput/:id',{},{
            'get':    {method:'GET'},
            'put':    {method:'PUT'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.testStatus = $resource(server_ip +'/testStatus',{},{
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.pcStart = $resource(pc_ip +'/start',{},{
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'put':    {method:'PUT'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.pcStop = $resource(pc_ip +'/close',{},{
            'get':    {method:'GET'},
            'put':    {method:'PUT'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })

        doFactory.pcTestStatus = $resource(pc_ip +'/status',{},{
            'get':    {method:'GET'},
            'save':   {method:'POST'},
            'query':  {method:'GET', isArray:true},
            'remove': {method:'DELETE'},
            'delete': {method:'DELETE'}
        })
        return doFactory

    })

})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.factory('noc', function($resource,FileSaver,$http) {

			var doFactory = {}

			var ip = "api.jnlportal.com"
			var report_server = "reports.jnlportal.com"
			var server_ip = "https://"+ip
			// var server_ip = "http://localhost/api/v3"
			
			doFactory.ip = ip
			// Set the report server IP
			doFactory.report_server_ip = "https://"+report_server
			
			// Version 3 Routes

			doFactory.accessLevel = $resource(server_ip +'/accessLevel/:id',{},{
				'get':    {method:'GET'},
				'query':  {method:'GET', isArray:true}
			})

			doFactory.alertDevice = $resource(server_ip +'/alertDevice/:id',{},{
				'get':    {method:'GET'}
			})

			doFactory.allParts = $resource(server_ip +'/all-parts',{},{
				'query':  {method:'GET', isArray:true}
			})

			doFactory.availableTests = $resource(server_ip +'/availableTests/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'delete': {method:'DELETE'}
			})

			doFactory.areas = $resource(server_ip +'/areas/:id',{},{
				'query':  {method:'GET', isArray:true}
			})

			doFactory.audit_log = $resource(server_ip +'/audit-log/:entity_type/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'}
			})

			doFactory.build = $resource(server_ip +'/build/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'patch': {method:'PATCH'},
				'delete': {method:'DELETE'}
			})

			doFactory.buildRequest = $resource(server_ip +'/build-request/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'delete': {method:'DELETE'}
			})

			doFactory.change_order = $resource(server_ip +'/change-order/:id/:route_name',{},{
				'get':    {method:'GET'},
				'query':  {method:'GET', isArray:true},
				'save':   {method:'POST'},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.change_order_excel = function(reqObj, fileName) {
				return $http({method: 'POST', url: server_ip+"/excel-maker", data:reqObj, responseType: "arraybuffer"})
				.success(function(data) {
					FileSaver.saveAs(new Blob([data],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}), fileName);
				})
			}

			doFactory.connectwise_routes = $resource(server_ip +'/connectwise/:route/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.contacts = $resource(server_ip +'/contact/:id',{},{
				'get':    {method:'GET'}
			})

			doFactory.customers = $resource(server_ip +'/customer/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'},
				'patch':	{method:"PATCH"}
			})

			doFactory.doorGlobals = $resource(server_ip +'/door-globals',{},{
				'query':  {method:'GET', isArray:true}
			})


			doFactory.emailActions = $resource(server_ip +'/emailAction',{},{
				'get':    {method:'GET'}
			})

			doFactory.estimates = $resource(server_ip +'/estimate/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'},
				'update': {method:'PUT'}
			})

			doFactory.estimator_globals = $resource(server_ip +'/estimate-globals',{},{
					'query':  {method:'GET', isArray:true},
					'save': {method:"POST"}
			})

			doFactory.issue = $resource(server_ip +'/issue/:route/:issue_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.install_quote = $resource(server_ip +'/install-quote/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'post':	  {method:'POST'},
				'update': {method:"PUT"},
				'delete': {method:'DELETE'}
			})
			
			doFactory.internalTagReader = $resource(server_ip +'/internalTagReader',{},{
				'get':	{method:'GET'}
			})

			doFactory.licenseInfo = $resource(server_ip +'/license-info/',{},{
				'query':  {method:'GET', isArray:true}
			})

			doFactory.login = $resource(server_ip +'/login/',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'}
			})

			doFactory.part_locations = $resource(server_ip +'/part-locations/',{},{
				'get':  {method:'GET'}
			})

			doFactory.pickList = $resource(server_ip +'/pick-list/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'patch': {method:'PATCH'},
				'delete': {method:'DELETE'}
			})
			
			doFactory.product = $resource(server_ip +'/product/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'delete': {method:'DELETE'}
			})

			doFactory.product_vendor = $resource(server_ip +'/product-vendor',{},{
				'query':  {method:'GET', isArray:true}
			})

			doFactory.product_types = $resource(server_ip +'/product-type',{},{
				'query':  {method:'GET', isArray:true}
			})

			doFactory.product_report = $resource(server_ip +'/product-pricing',{},{
				'get':    {method:'GET'}
			})

			doFactory.pullCordData = $resource(server_ip +'/pull-cord-data/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'}
			})

			doFactory.purchaseOrder = $resource(server_ip +'/purchase-order/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'delete': {method:'DELETE'}
			})

			doFactory.quantumAlert = $resource(server_ip +'/quantumAlert/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'}
			})

			doFactory.quantumCustomer = $resource(server_ip +'/quantumCustomer/:id/:route',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'update': {method:'PUT'},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'}
			})
			
			doFactory.quantumHardware = $resource(server_ip +'/quantumHardware/:id/:route',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'query':  {method:'GET', isArray:true},
				'delete': {method:'DELETE'},
				'patch':  {method:"PATCH"}
			})

			doFactory.priority = $resource(server_ip +'/priority/:id',{},{
				'get':    {method:'GET'}
			})
			
			doFactory.type = $resource(server_ip +'/type/:id',{},{
				'get':    {method:'GET'}
			})

			doFactory.status = $resource(server_ip +'/status/:id',{},{
				'get':    {method:'GET'}
			})

			doFactory.region = $resource(server_ip +'/region/:id/:route',{},{
				'get':    {method:'GET'},
				'patch':  {method:'PATCH'},
				'update': {method:'PUT'},
				'save':   {method:'POST'},
				'delete': {method:'DELETE'}
			})
			
			doFactory.report = $resource(server_ip +'/report/:route',{},{
				'save':   {method:'POST'}
			})

			doFactory.serialGenerator = $resource(server_ip +'/serial-number/:id/:route',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'patch':  {method:'PATCH'},
				'delete': {method:'DELETE'}
			})

			doFactory.settings = $resource(server_ip +'/settings',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'}
			})

			doFactory.systemParts = $resource(server_ip +'/system-parts/:id/:route/:route_id',{},{
				'get':    {method:'GET'},				
				'save':   {method:'POST'},
				'delete': {method:'DELETE'}
			})

			doFactory.states = $resource(server_ip +'/states/:id',{},{
				'query':  {method:'GET', isArray:true},
				'patch':  {method:'PATCH'}
			})

			doFactory.sub_location = $resource(server_ip +'/sub-locations',{},{
				'get':    {method:'GET'}
			})

			doFactory.systemTypes = $resource(server_ip +'/system-types/:id/:route',{},{
				'get':    {method:'GET'},
				'update': {method:'PUT'},
				'delete': {method:'DELETE'}
			})

			doFactory.tasks = $resource(server_ip +'/tasks/:id/:route/:route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"},
				'patch': {method:"PATCH"}
			})

			doFactory.teams = $resource(server_ip +'/team',{},{
				'get':    {method:'GET'}
			})


			doFactory.ticket = $resource(server_ip +'/ticket/:id/:route/:route_id/:extended_route/:extended_route_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.time_entry = $resource(server_ip +'/time/:id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.ticket_time_options = $resource(server_ip +'/ticket-time-option/:route',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.thirdParty = $resource(server_ip +'/third-party/:id/:route/:user_id',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'query':  {method:'GET', isArray:true},
				'delete': {method:'DELETE'},
				'update': {method:"PUT"}
			})

			doFactory.userInfo = $resource(server_ip +'/userInfo/:id/:route',{},{
				'get':    {method:'GET'},
				'save':   {method:'POST'},
				'update': {method:'PUT'},
				'query':  {method:'GET', isArray:true},
				'remove': {method:'DELETE'},
				'delete': {method:'DELETE'}
			})

			// *****Pull Cord Test Routes******

			doFactory.pullCordStart = $resource('http://10.0.2.21/start_test',{},{
					'get':    {method:'GET'},
					'save':   {method:'POST'},
					'query':  {method:'GET', isArray:true},
					'remove': {method:'DELETE'},
					'delete': {method:'DELETE'},
					'put':    {method:'PUT'}
			})

			doFactory.pullCordStop = $resource('http://10.0.2.21/stop_test/:serial_number',{},{
					'get':    {method:'GET'},
					'save':   {method:'POST'},
					'query':  {method:'GET', isArray:true},
					'remove': {method:'DELETE'},
					'delete': {method:'DELETE'},
					'put':    {method:'PUT'}
			})

			doFactory.pullCordStatus = $resource('http://10.0.2.21/pull_cord_status/:serial_number',{},{
					'get':    {method:'GET'},
					'save':   {method:'POST'},
					'query':  {method:'GET', isArray:true},
					'remove': {method:'DELETE'},
					'delete': {method:'DELETE'}
			})

			return doFactory

	})

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('changePasswordController', changePasswordController);

  /** @ngInject */
	function changePasswordController(toastr, noc, user,$log,$location,navItems) {
		var vm = this;
    vm.submissionObj = {"password":null,"pass_verify":null}
    var user_id = user.data.user_id;
    vm.passwordCheck = function(){
      var errorList = []
      vm.pass_valid = true
      if(vm.submissionObj.password){
        if(vm.submissionObj.password.length < 8){
          errorList.push("Password not long enough, must be 8 characters");
          vm.pass_valid = false
        }
        if(vm.submissionObj.password.search(/.*\d/) < 0){
          errorList.push("Password must contain a number")
          vm.pass_valid = false
        }
        if(vm.submissionObj.password.search(/.*[a-z]/) < 0){
          errorList.push("Password must a lowercase letter")
          vm.pass_valid = false
        }
        if(vm.submissionObj.password.search(/.*[A-Z]/) < 0){
          errorList.push("Password must a uppercase letter")
          vm.pass_valid = false
        }
        if(vm.submissionObj.password.search(/.*[!@#$%^&*() =+_-]/) < 0){
          errorList.push("Password must a special character in this list !@#$%^&*()=+_-")
          vm.pass_valid = false
        }
        if(vm.submissionObj.password != vm.submissionObj.pass_verify){
          errorList.push("Password and confirm password must match")
        }
      }else{
        errorList.push("Type the new password")
         vm.pass_valid = false
      }

      return errorList

    }

    vm.save = function(){
      noc.userInfo.save({"id":user_id,"route":"pw-reset"},vm.submissionObj).$promise
      .then(function(){
          user.data.pw_change_required = false
          toastr.success("Password Updated")
          $location.path('/dashboard')
          navItems.rebuild()

      })
      .catch(function(err){
        toastr.warning("Password Not Updated, Contact Admin")
        $log.log(err)
        alert(err.data.errors)
      })

    }

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('changeOrderManageController', changeOrderManageController);

	/** @ngInject */
	function changeOrderManageController($log, toastr, $routeParams, noc, user, searchFilters, $location,utils,$scope,$uibModal,$timeout,$window,$q) {
		var vm = this;

		vm.report_server = noc.report_server_ip

		vm.chosenCustomer = null;

		vm.showInactive = false;
		vm.showAllReps = false;
		vm.userData = user;
		vm.new_form = false
		vm.view = 'details'
		vm.q_select = 1

		// vm.txnActions = noc.transactionLogAction.query()
		vm.status_select_array = [{"id":1,"name":"Pending"},{"id":2,"name":"Accepted"},{"id":3,"name":"Rejected"}]
		vm.existing_change_orders = []
		vm.this_change_adds = []
		vm.other_change_orders = []	//This will contain the data for all other accepted change orders
																//Only will fill if the co_id is set

		vm.globals = noc.settings.get()
		vm.total_object = {"labor":{},"hardware":{}}
		vm.other_change_quantities = {}
		vm.other_total={}
		vm.allParts = noc.allParts.query()

		vm.estimate_id = $routeParams.estimate_id;
		// vm.server_ip = "45.55.171.198"
		vm.server_ip = noc.server_ip

		vm.thirdParties = []

		noc.thirdParty.get({"page_size":1000}).$promise
		.then(function(data){
			data.data.unshift({"id":-1,"name":"JNL Internal","active":true,"installs_things":true})
			angular.forEach(data.data,function(element){
				if (element.active && element.installs_things){
					vm.thirdParties.push(element)
				}
			})
		})


		vm.build_other_totals = function(){
			vm.other_total={}
			if(vm.other_change_orders){
				angular.forEach(vm.other_change_orders,function(element){
					angular.forEach(element.data,function(o,loc){
						if(loc != 'door'){
							if(vm.other_total[loc] == undefined){
								vm.other_total[loc] = {}
							}
							angular.forEach(o,function(values,key){
								if(vm.other_total[loc][key] == undefined){
									vm.other_total[loc][key] = values
								}else{
									vm.other_total[loc][key]['qty'] += values.qty
								}
							})
						}else{
							if(vm.other_total[loc] == undefined){
								vm.other_total[loc] = {}
							}
							angular.forEach(o,function(oo,door_number){
								if(vm.other_total[loc][door_number] == undefined){
									vm.other_total[loc][door_number] = {}
								}
								angular.forEach(oo,function(values,key){
									if(vm.other_total[loc][door_number][key] == undefined){
										vm.other_total[loc][door_number][key] = values
									}else{
										vm.other_total[loc][door_number][key][Object.keys(values)[0]]['qty'] += values[Object.keys(values)[0]].qty
									}
								})
							})
						}
					})
				})
			}
		}

		vm.get_other_q = function(loc,part_number,door_number,door_key){
			var r_value = 0
			if(loc != 'door'){
				if(vm.other_total){
					if (vm.other_total[loc] != undefined){
						if (vm.other_total[loc][part_number] != undefined){
							r_value = vm.other_total[loc][part_number].qty
						}
					}
				}
			}else{
				if (door_number != undefined){
					if(vm.other_total){
						if (vm.other_total[loc] != undefined){
							if (vm.other_total[loc][door_number.toString()] != undefined){
								if(vm.other_total[loc][door_number.toString()][door_key] != undefined){
									if(vm.other_total[loc][door_number.toString()][door_key][part_number] != undefined){
										r_value = vm.other_total[loc][door_number.toString()][door_key][part_number].qty
									}
								}
							}
						}
					}
				}
			}
			return r_value
		}



		noc.estimates.get({"id":vm.estimate_id}).$promise
		.then(function(data){
			vm.customer_name = data['site_name']
			vm.title = data['title']
			vm.system_type_id = data['system_type_id']
		})
		.catch(function(){
			$location.path('change-order-create')
		})
		vm.dealer_discount = 0
		if ($routeParams.co_id != '-1'){
			vm.co_id = $routeParams.co_id
			var promise1 = noc.estimates.get({"id":vm.estimate_id}).$promise
			.then(function(data){
				vm.estimateData = data

				if(data.third_party_id){
					noc.thirdParty.get({"id":data.third_party_id}).$promise
					.then(function(t_data){
						vm.dealer_discount = parseFloat(t_data.discount)
					})
				}
			})
			// vm.change_object = {}
			var promise2 = noc.change_order.get({"id":vm.co_id}).$promise
			.then(function(data){
				vm.co_object = data
				vm.tmp_status = data.status
				vm.customerView = vm.report_server+"/reports/estimator/change_order.php?co_id="+vm.co_object.name+"&allow=allow"
				vm.installContract = vm.report_server+"/reports/estimator/install_offer.php?est="+vm.estimate_id+"&co_id="+vm.co_object.name+"&allow=allow"
				if(!data.travel_parts){
					var t_parts = []
					var promise3 =noc.systemParts.get({"system_id":0}).$promise
					.then(function(p_data){
						angular.forEach(p_data.data,function(element){
							// $log.log(element)
							if (element.part_location == 0 && element.product_connectwise_id != 1515) {
								element.qty = 0
								var obj = {"part_number": element.product_part_number,
														"product_connectwise_id": element.product_connectwise_id,
														"location": "travel",
														"sub_location": null,
														"qty": 0,
														"price": element.product_price,
														"cost": element.product_cost,
														"hours":element.product_hours,
														"discount": element.discount,
														"door_group": 0,
														"door_location": null,
														"product_description": element.product_description}
								t_parts.push(obj)
							}
						})
						vm.co_object.travel_parts = t_parts
					})
				}
				vm.load = $q.all([promise1,promise2,promise3]).then(function(){
					vm.total_changes()
					vm.edit_check()
					vm.savedObj = angular.copy(vm.co_object)
				})
			})
			.catch(function(err){
				$log.log(err)
				$location.path('change-order-manage/'+vm.estimate_id+'/-1')
			})

			var promises = []
			noc.change_order.get({"estimate_id":'"'+vm.estimate_id+'"',"status":2}).$promise
			.then(function(other_co){
				angular.forEach(other_co.data,function(element){
					if (element.name != vm.co_id){
						promises.push(noc.change_order.get({"id":element.name}).$promise
							.then(function(data){
								vm.other_change_orders.push(data)
							})
						)
					}
				})
				$q.all(promises).then(function(){
					vm.build_other_totals()
				})
			})
		}else{
			noc.change_order.get({"estimate_id":'"'+vm.estimate_id+'"'}).$promise
			.then(function(data){
				vm.existing_change_orders = data.data
			})
			vm.co_id = null
		}

		vm.create_new = function(){
			vm.new_form = true
			vm.new_form_data = {}
			vm.new_form_data.estimate_id = vm.estimate_id
		}

		vm.cancel_new = function(){
			vm.new_form = false
			vm.new_form_data = {}
		}


		vm.save_new = function(){
			if (vm.new_form_data.external_reference && vm.new_form_data.description){
				noc.change_order.save(vm.new_form_data).$promise
				.then(function(data){
					$location.path('change-order-manage/'+vm.estimate_id+'/'+data.co_name)
				})
			}
		}

		vm.expand = function(k){
			vm.existing_change_orders[k].expanded = true
		}
		vm.contract = function(k){
			vm.existing_change_orders[k].expanded = false
		}

		vm.open_co = function(co){
			$location.path('change-order-manage/'+vm.estimate_id+'/'+co)
		}

		vm.edit_check = function(){
			vm.editable = true
			if(vm.co_object){
				if(vm.co_object.status > 1){
					vm.editable = false
				}
			}
		}


		vm.qty_change = function(loc,part_details,operator,door_key,dg,qty,pn_submit){
			var valid = true
			if(vm.co_object['data'] == null){
				vm.co_object['data']={}
			}
			if(qty != undefined){
				qty = qty
			}else{
				qty = Number(vm.q_select)
			}
			if(!(Number.isInteger(vm.q_select))){
				toastr.warning("Quantity Selector must be an integer")
				valid = false
			}

			if(valid){
				var part_number = part_details.product_part_number
				var price
				var cost
				var sub_location
				var hours
				var discount
				var product_connectwise_id
				var door_group
				var product_description

				if (part_number == undefined){
					if(part_details.related_part_number != undefined){
						part_number = part_details.related_part_number
						price = part_details.related_part_price
						cost = part_details.related_part_cost
						hours = part_details.related_part_hours
						product_connectwise_id = part_details.related_part_connectwise_id
						sub_location = null
						discount = part_details.related_part_discount
						product_description = part_details.related_part_description
						door_group = dg
					}else{
						part_number = pn_submit
						price = part_details.price
						cost = part_details.cost
						hours = part_details.hours
						sub_location = part_details.sub_location
						discount = part_details.discount
						product_connectwise_id = part_details.product_connectwise_id
						door_group = part_details.door_group
						product_description = part_details.product_description
					}
				}else{
					price = part_details.product_price
					cost = part_details.product_cost
					hours = part_details.product_hours
					sub_location = part_details.sub_location
					discount = part_details.discount
					product_connectwise_id = part_details.product_connectwise_id
					door_group = part_details.door_group
					product_description = part_details.product_description
				}
				if (vm.co_object['data'][loc] == undefined){
					vm.co_object['data'][loc] = {}
				}
				if(loc != 'door'){
					if(vm.co_object['data'][loc][part_number] == undefined){
						vm.co_object['data'][loc][part_number] = {"qty":0,
																											"price":price,
																											"sub_location":sub_location,
																											"cost":cost,
																											"hours":hours,
																											"discount":discount,
																											"product_connectwise_id":product_connectwise_id,
																											"door_group":door_group,
																											"part_number":part_number,
																											"product_description":product_description}
					}
					if (operator == 'minus'){
						vm.co_object['data'][loc][part_number].qty -=qty
					}else{
						vm.co_object['data'][loc][part_number].qty +=qty
					}

				}else{
					if(vm.co_object['data'][loc][door_group.toString()] == undefined){
						vm.co_object['data'][loc][door_group.toString()] = {}
					}
					if(vm.co_object['data'][loc][door_group.toString()][door_key] == undefined){
						vm.co_object['data'][loc][door_group.toString()][door_key] = {}
					}
					if(vm.co_object['data'][loc][door_group.toString()][door_key][part_number] == undefined){
						vm.co_object['data'][loc][door_group.toString()][door_key][part_number] = {"qty":0,
																											"price":price,
																											"sub_location":sub_location,
																											"cost":cost,
																											"hours":hours,
																											"discount":discount,
																											"product_connectwise_id":product_connectwise_id,
																											"door_group":door_group}
					}
					if (operator == 'minus'){
						vm.co_object['data'][loc][door_group.toString()][door_key][part_number].qty -=1
					}else{
						vm.co_object['data'][loc][door_group.toString()][door_key][part_number].qty +=1
					}
				}
				vm.total_changes()
			}
		}



		vm.get_change_q = function(loc,part_number,door_number,door_key){
			var r_value = 0
			if(loc != 'door'){
				if(vm.co_object){
					if (vm.co_object['data']){
						if (vm.co_object['data'][loc] != undefined){
							if (vm.co_object['data'][loc][part_number] != undefined){
								r_value = vm.co_object['data'][loc][part_number].qty
							}
						}
					}
				}
			}else{
				if (door_number != undefined){
					if(vm.co_object){
						if (vm.co_object['data']){
							if (vm.co_object['data'][loc] != undefined){
								if (vm.co_object['data'][loc][door_number.toString()] != undefined){
									if(vm.co_object['data'][loc][door_number.toString()][door_key] != undefined){
										if(vm.co_object['data'][loc][door_number.toString()][door_key][part_number] != undefined){
											r_value = vm.co_object['data'][loc][door_number.toString()][door_key][part_number].qty
										}
									}
								}
							}
						}
					}
				}
			}
			return r_value
		}


		vm.save_co = function(load_filtered){
			if(vm.savedObj.status == 1){
				if(!vm.sameObj()){
					noc.change_order.update({"id":vm.co_id},vm.co_object).$promise
					.then(function(){
						toastr.success("SAVE SUCCESSFUL")
						vm.load_filtered()
						// var obj = {"new":vm.co_object,"old":vm.savedObj}
						// noc.transactionLogAction.save({"id":vm.co_object.transaction_id},obj).$promise
						// .then(function(){
						// 	vm.savedObj = angular.copy(vm.co_object)
						// })
						vm.savedObj = angular.copy(vm.co_object)
						if(load_filtered){
							vm.load_filtered(load_filtered)
						}
					})
					.catch(function(err){
						$log.log(err)
						toastr.warning("SAVE UNSUCCESSFUL CONTACT DREW")
					})
				}
			}
			if(load_filtered){
				vm.load_filtered(load_filtered)
			}
		}


		vm.co_change_hw_subtotal = function(k,obj){
			var subtotal = 0;
			var dealer_discount_value = (1 - (vm.dealer_discount / 100))
			var update_total = false

			if(obj == undefined){
				update_total = true
				obj = vm.co_object
			}
			if(obj){
				if(obj.data){
					var est_hw_discount = (1 - (vm.estimateData.hardware_discount / 100))
					var co_hw_discount = (1 - (vm.co_object.hw_discount / 100))
					angular.forEach(obj.data[k],function(element){
						if (k != 'door'){
							var discountMultiplier = (1 - (element.discount / 100))
							subtotal = subtotal + (Math.round(element.price * element.qty * discountMultiplier * dealer_discount_value * est_hw_discount *co_hw_discount *100) / 100)
						}else{
							angular.forEach(element,function(d_part) {
								angular.forEach(d_part,function(part){
									var discountMultiplier = (1 - (part.discount / 100))
									subtotal = subtotal + (Math.round(part.price * part.qty * discountMultiplier * dealer_discount_value * est_hw_discount *co_hw_discount * 100) / 100)
								})
							})
						}
					})
				}
				if(update_total){
					vm.total_object.hardware[k] = subtotal
				}
			}

			return subtotal
		}

		vm.co_change_labor_subtotal = function(k,obj){
			var subtotal = 0;
			var update_total = false
			if(obj == undefined){
				update_total = true
				obj = vm.co_object
			}
			if(obj){
				if(obj.data){
					if(vm.co_object.include_labor){
						var est_labor_discount = (1 - (vm.estimateData.labor_discount / 100))
						var co_labor_discount = (1 - (vm.co_object.labor_discount / 100))
						angular.forEach(obj.data[k],function(element){
							if (k != 'door'){
								subtotal = subtotal + (Math.round(element.hours * element.qty * vm.estimateData.labor_cost * co_labor_discount * est_labor_discount * 100) / 100)
							}else{
								angular.forEach(element,function(d_part) {
									angular.forEach(d_part,function(part){
										subtotal = subtotal + (Math.round(part.hours * part.qty * vm.estimateData.labor_cost * co_labor_discount * est_labor_discount * 100) / 100)
									})
								})
							}
						})
					}
				}
				if(update_total){
					vm.total_object.labor[k] = subtotal
				}
			}
			return subtotal
		}

		vm.total_changes = function(){
			var labor_sub_total = 0
			var hardware_sub_total = 0
			if(vm.estimateData){
				if(vm.co_object){
					var est_labor_discount = (1 - (vm.estimateData.labor_discount / 100))
					var co_labor_discount = (1 - (vm.co_object.labor_discount / 100))
					if(vm.co_object.data){
						var keys = ['server','infrastructure','notification','network','nurseCall','doorSupplies','addOns','dealer','door','changeAdd']
						angular.forEach(keys,function(k){
							hardware_sub_total = hardware_sub_total + vm.co_change_hw_subtotal(k)
						})
						angular.forEach(keys,function(k){
							labor_sub_total = labor_sub_total + vm.co_change_labor_subtotal(k)
						})
					}
					if(vm.co_object.include_labor && vm.co_object.travel_parts){
						angular.forEach(vm.co_object.travel_parts,function(element){
							labor_sub_total = labor_sub_total + (element.price * element.qty * est_labor_discount * co_labor_discount)
						})
					}else{
						labor_sub_total = 0
						if(vm.view=='install_quote'){
							vm.view='details'
						}
					}
				}
			}

			vm.co_object.hardware_total = hardware_sub_total
			vm.co_object.labor_total = labor_sub_total
			vm.install_calc()
		}


		vm.sameObj = function(){
			if(vm.savedObj){
				if(vm.co_object){
					return angular.equals(vm.savedObj,vm.co_object)
				}
			}
		}

		vm.load_audit = function(){
			vm.view = 'audit'
			noc.transaction.query({"id":vm.co_object.transaction_id}).$promise
			.then(function(txData){
				angular.forEach(txData,function(element){
					if(element.old_object && element.new_object){
						element.differences = utils.compareObj(element.old_object,element.new_object)
					}
				})
				vm.audit_results = txData
			})
		}

		vm.co_excel = function(){
			noc.change_order_excel({"estimate_id":vm.estimate_id},vm.estimate_id+".xlsx")
		}

		vm.open_estimate = function(){
			$location.path('estimateBuilder/'+vm.estimate_id+'/'+vm.system_type_id)
		}

		vm.searchProduct = function(){
			var searchedParts = []
			vm.searchResults = []
			vm.additionalResluts = []
			var s
			s = vm.part_search_text
			angular.forEach(vm.allParts,function(element){
				if(element.product_description.toLowerCase().indexOf(s.toLowerCase()) >= 0 || element.product_part_number.toLowerCase().indexOf(s.toLowerCase()) >= 0){
					if(searchedParts.indexOf(element.product_connectwise_id) == -1){
						searchedParts.push(element.product_connectwise_id)

						vm.additional_add = true
						vm.additionalResluts.push(element)
					}
				}
			})
		}

		vm.chosenPart = function(p){
			vm.otherPart = p
			vm.otherPart.qty = 1
			vm.modalInstance = $uibModal.open({
				templateUrl: 'enterQTY.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss()
		}

		function helper(){
			vm.save_co()
			var  element = angular.element('#changeAddBox')
			$window.scrollTo(element.offset())
		}
		vm.accAdd = function(){
			var thisPart = null;
			thisPart = angular.copy(vm.otherPart)
			vm.qty_change('changeAdd',thisPart,'add',null,null,Number(thisPart.qty))
			vm.view = 'parts'
			toastr.success("Part Added Successfully")
			$timeout(helper,500)
			vm.part_search_text = null
			vm.additionalResluts = []
			vm.closeModal()
		}

		vm.changes = {}

		vm.load_filtered = function(input_val){
			var obj = {}
			var hours = 0

			if(input_val == 1){
				vm.view='filtered'
			}else if (input_val == 2) {
				vm.view='install_quote'
			}

			noc.change_order.query({"id":vm.co_id,"route_name":"part-summary"}).$promise
			.then(function(data){
				angular.forEach(data,function(element){
					if(!(element.location == 'travel' && element.qty == 0)){
						var pn = element.part_number
						if(obj[pn] == undefined){
							obj[pn] = element
						}else{
							obj[pn].qty += element.qty
						}
						hours = hours + (element.qty * element.hours)
					}
				})
				vm.changes = obj
				vm.hours = hours
				
				$timeout(vm.install_calc(),500)
			})
		}

		function round_it(inputValue){
			var c = inputValue / 50
			return (Math.floor(c) * 50)
		}

		vm.install_calc = function(){
			if(vm.co_object){
				if(!vm.co_object.install_information){
					vm.co_object.install_information = {"accepted_offer":false,"quoted_price":"0.0000","third_party_id":-1,"burden_rate":parseFloat(vm.globals['Burden Rate']),"manual_input":0,"include_return":false}
				}
				var labor_less_travel = 0
				if(vm.co_object.install_information.third_party_id < 0){
					angular.forEach(vm.co_object.travel_parts,function(element){
						if(element.product_connectwise_id != 1515){
							if(element.product_connectwise_id == 44){
								labor_less_travel = labor_less_travel + (vm.co_object.install_information.burden_rate * element.qty)
							}else{
								labor_less_travel = labor_less_travel + (element.price * element.qty)
							}
						}
					})
				}

				var labor_value = vm.co_object.labor_total - labor_less_travel
				$log.log(vm.hours)
				var base_profit
				var val
				if(vm.co_object.install_information.third_party_id > 0){
					base_profit = (labor_value * .2) + (vm.hours * .1 * vm.estimateData.labor_cost)
					val = round_it(labor_value - base_profit) + vm.co_object.install_information.manual_input
				}else{
					base_profit = (vm.hours * .1 * vm.co_object.install_information.burden_rate)
					val = labor_less_travel + base_profit + (vm.hours * vm.co_object.install_information.burden_rate) + vm.co_object.install_information.manual_input
				}

				if(val != null){
					val = val.toFixed(4)
					vm.co_object.install_information.quoted_price = val
				}
			}
		}


		vm.connectwise_add = function(){
			$log.log(vm.selectedTicket)
			if(vm.selectedTicket){
				vm.load = noc.connectwise_routes.update({"id":vm.selectedTicket,"route":"add-product"},{"co_id":vm.co_id,"estimate_id":vm.estimate_id}).$promise
				.then(function(data){
					vm.selectedTicket = null;
					$log.log(data)
					toastr.success("Confirm Parts are on ticket in Connectwise")
					vm.co_object.pushed_to_cw = true
					vm.savedObj = vm.co_object
				})
				.catch(function(err){
					$log.log(err)
					toastr.success("One or all parts failed to go to Connectwise, Contact Drew before trying again")
				})
				vm.closeModal()
			}
		}

		vm.status_change = function(){
			vm.available_tickets = []
			if(vm.tmp_status == 2){
				noc.ticket.get({"company/id":vm.estimateData.customer_id,"board/id":5}).$promise
				.then(function(data){
					angular.forEach(data.data,function(element){
						if(element.status.name != '>Closed' && element.status.name != 'Closed'){
							vm.available_tickets.push(element)
						}
					})
					noc.ticket.get({"company/id":vm.estimateData.customer_id,"board/id":6}).$promise
					.then(function(data2){
						angular.forEach(data2.data,function(element){
							if(element.status.name != '>Closed' && element.status.name != 'Closed'){
								vm.available_tickets.push(element)
							}
						})
						if(vm.available_tickets.length){
							vm.modalInstance = $uibModal.open({
								templateUrl: 'status_change.html',
								scope: $scope,
								size: 'md',
								backdrop: 'static'
							});
						}else{
							toastr.warning("No Available Tickets to put the changed parts to, cannot accept")
							vm.tmp_status = 1
						}
					})
				})
			}else if (vm.tmp_status == 3) {
				$log.log('here')
				vm.modalInstance = $uibModal.open({
					templateUrl: 'status_change.html',
					scope: $scope,
					size: 'md',
					backdrop: 'static'
				});
			}
		}

		vm.cancel_status = function(){
			vm.tmp_status = 1
			vm.closeModal()
		}

		vm.confirm_status = function(){
			vm.co_object.status = vm.tmp_status
			vm.save_co()
			vm.closeModal()
			if(vm.tmp_status ==2){
				vm.connectwise_add()
			}
		}





// ?????????????????????????????????????????????//
// ESTIMATE FUNCTIONS///////
//????????????????????????????????????????//
		vm.checkArray = function(arrKey){
			var check = false
			if(vm.estimateData.parts){
				angular.forEach(vm.estimateData.parts[arrKey],function(element){
					if(element.qty > 0){
						check = true
					}
				})
				return check
			}
		}
		vm.selectLaborSubtotal = function(arrKey){
			var subTotal = 0;
			var hours = 0;
			if(arrKey == 'server'){
				vm.selectHourArr = [];
			}
			if(vm.estimateData.parts[arrKey]){
				subTotal = subTotal + vm.estimateData.parts[arrKey].product_hours * vm.estimateData.parts[arrKey].qty * vm.estimateData.labor_cost
				hours = hours + (vm.estimateData.parts[arrKey].product_hours * vm.estimateData.parts[arrKey].qty)
				if(vm.estimateData.parts[arrKey].is_repeater && vm.estimateData.inovonics_location){
					subTotal = subTotal + vm.estimateData.location_hours * vm.estimateData.location_cost * vm.estimateData.parts[arrKey].qty
					hours = hours + (vm.estimateData.location_hours * vm.estimateData.parts[arrKey].qty)
				}
				if(vm.estimateData.parts[arrKey].related_parts){
					angular.forEach(vm.estimateData.parts[arrKey].related_parts,function(rPart){
						subTotal = subTotal + (vm.estimateData.labor_cost * rPart.related_part_qty * rPart.related_part_hours)
						hours = hours + (rPart.related_part_qty * rPart.related_part_hours)
					})
				}
			}
			vm.selectHourArr.push(hours)
			return subTotal
		}

		vm.selectSubtotal = function(arrKey){
			var subTotal = 0;
			if(vm.estimateData.parts[arrKey]){
				if(vm.estimateData.parts[arrKey].qty > 0){
					var discountMultiplier = (1 - (vm.estimateData.parts[arrKey].discount / 100))
					subTotal = subTotal + (vm.estimateData.parts[arrKey].product_price * vm.estimateData.parts[arrKey].qty * discountMultiplier)
					if(vm.estimateData.parts[arrKey].related_parts){
						angular.forEach(vm.estimateData.parts[arrKey].related_parts,function(rPart){
							var discountMultiplier = (1 - (rPart.related_part_discount / 100))
							subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_price * discountMultiplier)
						})
					}
				}
			}
			return subTotal
		}

		vm.groupSubtotal = function(area){
			var keys = {"infrastructure":['repeater','enrol','power'],"notification":['paging']} //PARTS SELECTED BY SELECT BOXES (OBJECTS)
			var otherKeys = {'infrastructure':['wire'],"notification":['pager']} //PARTS BASED ON QTY ENTERED (ARRAYS)
			var subTotal = 0;
			angular.forEach(keys[area],function(key){
				subTotal = subTotal + vm.selectSubtotal(key)
			})
			angular.forEach(otherKeys[area],function(key1){
				subTotal = subTotal + vm.nonSelectSubtotal(key1)
			})
			if(area == 'infrastructure'){
				subTotal = subTotal + Number(vm.licenseSubtotal())
			}
			return subTotal
		}

		vm.groupLaborSubtotal = function(area){
			var keys = {"infrastructure":['repeater','enrol','power'],"notification":['paging']} //PARTS SELECTED BY SELECT BOXES (OBJECTS)
			var otherKeys = {'infrastructure':['wire'],"notification":['pager']} //PARTS BASED ON QTY ENTERED (ARRAYS)
			var subTotal = 0;
			angular.forEach(keys[area],function(key){
				subTotal = subTotal + vm.selectLaborSubtotal(key)
			})
			angular.forEach(otherKeys[area],function(key1){
				subTotal = subTotal + vm.nonSelectLaborSubtotal(key1)
			})
			return subTotal
		}

		vm.nonSelectLaborSubtotal = function(arrKey){
			var subTotal = 0;
			var hours = 0;
			if(arrKey == 'wire'){
				vm.nonSelectHoursArr = [];
			}
			angular.forEach(vm.estimateData.parts[arrKey],function(element){
				if(element.qty > 0){
					subTotal = subTotal + (element.qty * element.product_hours * vm.estimateData.labor_cost)
					if(element.product_hours > 0){
						hours = (element.product_hours * element.qty)
						vm.nonSelectHoursArr.push(hours)
					}
					if(element.related_parts){
						angular.forEach(element.related_parts,function(rPart){
							subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_hours * vm.estimateData.labor_cost)
							if(rPart.related_part_hours > 0){
								hours = (rPart.related_part_hours * rPart.related_part_qty)
								vm.nonSelectHoursArr.push(hours)
							}
						})
					}
				}
			})
			return subTotal
		}

		vm.nonSelectSubtotal = function(arrKey){
			var subTotal = 0;
			angular.forEach(vm.estimateData.parts[arrKey],function(element){
				if(element.qty > 0){
					var discountMultiplier = (1 - (element.discount / 100))
					subTotal = subTotal + (element.qty * element.product_price * discountMultiplier)
					if(element.related_parts){
						angular.forEach(element.related_parts,function(rPart){
							var discountMultiplier = (1 - (rPart.related_part_discount / 100))
							subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_price * discountMultiplier)
						})
					}
				}
			})
			return subTotal
		}

		vm.licenseSubtotal = function(){
			if(vm.estimateData.parts.licensePart){
				return vm.estimateData.parts.licensePart.product_price
			}else{
				return 0;
			}
		}

		vm.travelLaborSubtotal = function(){
			var subTotal = 0
			angular.forEach(vm.estimateData.parts.travel,function(part){
				subTotal = subTotal + part.product_price * part.qty
			});
			return subTotal
		}

		vm.doorLaborSubTotal = function(){
			var subTotal = 0;
			var doorKeys = ['controller','doorPosition','requestExit','requestEnter','lockDevice','wanderPart','doorbellPart']
			angular.forEach(vm.estimateData.door_information,function(door){
				angular.forEach(doorKeys,function(k){
					if(door[k]){
						subTotal = subTotal + (vm.estimateData.labor_cost * door[k].product_hours * door[k].qty)
						if(door[k].related_parts){
							angular.forEach(door[k].related_parts,function(rPart){
								subTotal = subTotal + (vm.estimateData.labor_cost * rPart.related_part_qty * rPart.related_part_hours)
							});
						}
					}
				});
			});
			return subTotal
		}

		vm.laborTotal = function(){
			var subTotal = 0;
			if(vm.estimateData){
				if(vm.estimateData.parts && vm.estimateData.door_information){
					var selectKey = ['server']; //selectLaborSubtotal
					var groupSubtotalKey = ['infrastructure','notification']; //groupLaborSubtotal
					var nonsSelectKey = ['network','nurseCall','doorSupplies','addOns']; //nonSelectLaborSubtotal
					subTotal = subTotal + vm.doorLaborSubTotal();
					subTotal = subTotal + vm.travelLaborSubtotal();
					angular.forEach(selectKey,function(element){
						subTotal = subTotal + vm.selectLaborSubtotal(element)
					})
					angular.forEach(groupSubtotalKey,function(element){
						subTotal = subTotal + vm.groupLaborSubtotal(element)
					})
					angular.forEach(nonsSelectKey,function(element){
						subTotal = subTotal + vm.nonSelectLaborSubtotal(element)
					})
				}
			}
			return subTotal
		}

		vm.laborFinal = function(){
			var originalAmount = vm.laborTotal()
			var discountMultiplier = (1 - (vm.estimateData.labor_discount / 100))
			vm.labordiscountAmount = originalAmount - (originalAmount*discountMultiplier)
			vm.labor_final_total = Number(originalAmount)*discountMultiplier
			return Number(vm.laborTotal())*discountMultiplier
		}

		vm.checkForDoors = function(){
			if(Object.keys(vm.estimateData.door_information).length > 0){
				return true
			}else{
				return false
			}
		}

		vm.doorSubTotal = function(){
			var subTotal = 0;
			var doorKeys = ['controller','doorPosition','requestExit','requestEnter','lockDevice','wanderPart','doorbellPart']
			angular.forEach(vm.estimateData.door_information,function(door){
				angular.forEach(doorKeys,function(k){
					if(door[k]){
						var discountMultiplier = (1 - (door[k].discount / 100))
						subTotal = subTotal + (door[k].product_price * door[k].qty * discountMultiplier)
						if(door[k].related_parts){
							angular.forEach(door[k].related_parts,function(rPart){
								var relatedDiscountMultiplier = (1 - (rPart.related_part_discount / 100))
								subTotal = subTotal + (rPart.related_part_qty * rPart.related_part_price * relatedDiscountMultiplier)
							});
						}
					}
				});
			});
			return subTotal
		}

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('changeOrderCreateController', changeOrderCreateController);

	/** @ngInject */
	function changeOrderCreateController($log, noc, user, $location) {
		var vm = this;

		vm.showInactive = false;
		vm.showAllReps = false;
		function load_data(){
			var owner
			if(vm.all_reps){
				owner = null
			}else{
				owner = user.data.user_id
			}

			var obj = {'owner':owner,"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results,"probability":100,"inactive":true}
			if(vm.searchVal != ""){
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}
			noc.estimates.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.clear_filters = function(){
			vm.searchVal = ""
			vm.sort_order = "DESC"
			vm.searchFor = "site_name"
			vm.sort_by = "last_updated"
			vm.num_results = 15
			vm.currentPage = 1
			load_data()
		}

		vm.sort_data = function(){
				if (vm.sort_order == 'ASC'){
					vm.sort_order = 'DESC'
				}else{
					vm.sort_order = 'ASC'
				}
				load_data()
			}

		vm.load_data = function(){
			load_data()
		}

		if(user.data.user_id){
			vm.clear_filters()
		}

		vm.openEstimate = function(estimate_id){
			$location.path("/change-order-manage/"+estimate_id+"/-1");
		}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('buildRequestsController', buildRequestsController);

  /** @ngInject */
	function buildRequestsController($log, $location,toastr, noc, $uibModal, $scope) {
		var vm = this;

    vm.newBuildRequest = {"id":null,"description":null,"notes":null}
    vm.defaultPick = {"id":null,"build_request":{"id":null},"quantity":null}
    vm.newPartInBuild = null
    vm.countObject = {}
    vm.new_qty = 0

    noc.build.get({"active":true,"page_size":1000}).$promise
    .then(function(data){
      vm.availableBuilds = data.data
    })

    vm.closeModal = function(){
      vm.currentBuild = null
      vm.currentPick = null
      vm.modalInstance.dismiss();
    };

    vm.closeModalOnly = function(){
      if(vm.modalInstance){
        vm.modalInstance.dismiss();
      }
    };

    function load_data(){
			var obj = {}
			
			if(vm.searchVal != ""){
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				obj[vm.searchFor]='"%'+vm.searchVal+'%"'
			}else{
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
			vm.loadPromise = noc.buildRequest.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

		vm.load_data = function(){
			load_data()
		}

		vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

		vm.clear_filters = function(){
			vm.currentPage = 1
			vm.sort_by = "date_created"
			vm.sort_order = "DESC"
			vm.searchFor = "build_data/product_data/part_number"
			vm.searchVal = ""
			vm.num_results = 10
			load_data()
		}

		// clear filters to define defautls and do initial load
		vm.clear_filters()
    
    vm.newBuildDialog = function(){
      vm.currentBuild = angular.copy(vm.newBuildRequest)
      vm.modalInstance = $uibModal.open({
        templateUrl: 'newBuildDialog.html',
        scope: $scope,
        size: 'lg'
      });
    }

    vm.openEdit = function(k){
      vm.currentBuild = vm.data.data[k]
      noc.pickList.get({"build_request/id":vm.currentBuild.id}).$promise
      .then(function(data){
        vm.pickLists = data
      })
      vm.modalInstance = $uibModal.open({
				templateUrl: 'newBuildDialog.html',
				scope: $scope,
				size: 'lg'
			});
    }

    vm.openPick = function(k){
      vm.currentBuild = vm.data.data[k]
      vm.currentPick = angular.copy(vm.defaultPick)
      vm.currentPick.build_request = vm.currentBuild
      noc.build.get({"id":vm.currentBuild.build_data.id,"route":"included-parts","page_size":100}).$promise
      .then(function(data){
        vm.currentPick.parts = data.data
      })
      noc.build.get({"id":vm.currentBuild.build_data.id}).$promise
      .then(function(data){
        vm.currentPick.labor_cost = data.labor_cost
        vm.currentPick.time_to_build = data.time_to_build
        vm.currentPick.build_cost = data.build_cost
      })
       
      vm.modalInstance = $uibModal.open({
          templateUrl: 'partial.html',
          scope: $scope,
          size: 'lg'
        });
    }

    vm.createPick = function(){
      noc.pickList.save(vm.currentPick).$promise
      .then(function(){
        toastr.success("Pick List Created Successfully")
        load_data()
        vm.closeModal()
      })
      .catch(function(){
        toastr.warning("Failed to Create Pick List")
      })
    }

    vm.remove_valid = function(){
      var ok_to_remove = true
      if(vm.currentBuild.num_picked > 0){
        ok_to_remove = false
      }
      // if(vm.currentBuild.built){
      //   ok_to_remove = false
      // }
      return ok_to_remove
    }
    // ___________________

    vm.populateDetails = function(request_id){
      vm.countObject = {}
      vm.populatePromise = noc.buildRequest.get({id:request_id}).$promise
      .then(function(data){
        vm.currentBuild = data
        angular.forEach(data.product_data,function(element){
          angular.forEach(element.product_built,function(value){
            if(angular.isUndefined(vm.countObject[element.id])){
              vm.countObject[element.id] = 0
            }
            if(value.built){
              vm.countObject[element.id] = vm.countObject[element.id] + 1
            }
          })
        })
        vm.newPartInBuild = null
      }).catch(function(error){
        toastr.warning(error)
      })
    }


    vm.addRequest = function(){
      noc.buildRequest.save(vm.currentBuild).$promise
      .then(function(){
        toastr.success("Request Added")
        vm.closeModal()
        load_data()
      })
    }

  vm.removeRequest = function(){
    noc.buildRequest.delete({id:vm.currentBuild.id}).$promise
    .then(function(){
      toastr.success("Removal Successful")
      vm.closeModal()
      load_data()
    })
    .catch(function(data){
      $log.log(data)
      toastr.warning("Removal Unsuccessful")
    })
  }

    

  vm.updateRequest = function(lock){
    if(lock){
      vm.currentBuild.locked = true
    }
    if(vm.newPartInBuild){
      vm.currentBuild.product_data.push(vm.newPartInBuild)
    }
   
    noc.buildRequest.update({id:vm.currentBuild.id},vm.currentBuild).$promise
    .then(function(){
      vm.newPartLine = false
      vm.newPartInBuild = null
      toastr.success("Update Successful")
      vm.populateDetails(vm.currentBuild.id)
      vm.closeModalOnly()
    })
    .catch(function(data){
      $log.log(data)
    })
  }

    vm.lockRequest = function(){
      vm.updateRequest(true)
    }

    vm.deleteUnpickedList = function(id){
      noc.pickList.delete({"id":id}).$promise
      .then(function(){
        toastr.success("Pick List Removed")
        noc.pickList.get({"build_request/id":vm.currentBuild.id}).$promise
        .then(function(data){
          vm.pickLists = data
        })
      })
      .catch(function(err){
        toastr.warning(err.data.error)
      })
      load_data()
    }

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('buildPickListController', buildPickListController);

  /** @ngInject */
	function buildPickListController($log, $location,toastr, noc, $uibModal, $scope,user,$q) {
		var vm = this;

    var user_data = user.data
    if(user_data.admin == "1"){
      vm.admin = true
    }
    vm.productFullyPicked = {}
    vm.pending_promises = []


    vm.load_data = function(){
			load_data()
		}

    vm.sort_data = function(){
			if (vm.sort_order == 'ASC'){
				vm.sort_order = 'DESC'
			}else{
				vm.sort_order = 'ASC'
			}
			load_data()
		}

    function load_data(){
			var obj = {}
			
			if(vm.searchVal != ""){
        
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
				if(vm.searchFor == 'build_request/id'){
          obj[vm.searchFor]=vm.searchVal
        }else{
          obj[vm.searchFor]='"%'+vm.searchVal+'%"'
        }
			}else{
				obj = {"page":vm.currentPage,"sort_by":vm.sort_by,"sort_order":vm.sort_order,"page_size":vm.num_results}
			}
      if(!vm.showPicked){
        obj['picked']=false
      }
			vm.loadPromise = noc.pickList.get(obj).$promise
			.then(function(data){
				vm.data = data
			})
		}

    vm.clear_filters = function(){
			vm.currentPage = 1
			vm.sort_by = "ID"
			vm.sort_order = "ASC"
			vm.searchFor = "build_request/build_data/product_data/part_number"
			vm.searchVal = ""
			vm.num_results = 10
      vm.showPicked = false
			load_data()
		}

    vm.openEdit = function(index){
      vm.currentPick = vm.data.data[index]
      noc.pickList.get({"id":vm.currentPick.id,"route":"pieces","page_size":100}).$promise
      .then(function(data){
        vm.pieces = data.data
        vm.checkFullyPicked()
      })
    }

    vm.home = function(){
      vm.currentPick = null
      load_data()
    }

    vm.checkFullyPicked = function(){
      var requestPicked = true
      angular.forEach(vm.pieces,function(piece){
        if(!piece.picked){
          requestPicked = false
        }
      })
      vm.checkAllBoxChecked = requestPicked
      vm.productFullyPicked = requestPicked
      return requestPicked
    }

    vm.patchPart = function(piece_id,picked,requires_process){
      var l = [{"key":"picked","value":picked}]
      $log.log(l)
      vm.pending_promises.push(noc.pickList.patch({"id":vm.currentPick.id,"route":"pieces","route_id":piece_id},{"updates":l}).$promise)
      if (requires_process){
        vm.process_promises()
      }
    }

    vm.checkPickAll = function(){
      angular.forEach(vm.pieces,function(piece){
        piece.picked = vm.checkAllBoxChecked
        vm.patchPart(piece.id,vm.checkAllBoxChecked,true)
      })
    }

    vm.process_promises = function(){
      vm.p = $q.all(vm.pending_promises)
      .then(function(){
        vm.checkFullyPicked()
        vm.pending_promises = []
      })
    }

    vm.completePickList = function(){
      var l = [{"key":"picked","value":true}]
      noc.pickList.patch({"id":vm.currentPick.id},{"updates":l}).$promise
      .then(function(){
        toastr.success("Pick List Complete")
        noc.pickList.get({"id":vm.currentPick.id}).$promise
        .then(function(data){
          vm.currentPick = data
        })

      })
    }

    vm.DeletePickList = function(id){
      noc.pickList.delete({"id":id}).$promise
      .then(function(){
        toastr.success("Pick list removed")
        vm.home()
      })
      .catch(function(err){
        toastr.warning(err.data.error)
      })
    }

    // clear filters to define defautls and do initial load
		vm.clear_filters()


	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('buildOverviewController', buildOverviewController);

  /** @ngInject */
	function buildOverviewController($log, $location,toastr, noc, $scope, $uibModal, $q, $routeParams, $window, $interval) {
		var vm = this;
    vm.preTestSummaryObject = null
    vm.selectedTransaction = []
    vm.pending_promises = []
    vm.attached_to_finished_product = []
    
    
    vm.selectedId = $routeParams.id
    vm.num_results = 20
    vm.current_page = 1



    vm.process_promises = function(){
      vm.p = $q.all(vm.pending_promises)
      .then(function(){
        vm.pending_promises = []
      })
    }

    function readyForBuild(){
      noc.pickList.get({"picked":true,"built":false,"page":vm.currentPage,"page_size":vm.num_results}).$promise
      .then(function(data){
        vm.readyForBuild = data
        angular.forEach(data.data,function(element,index){
          vm.pending_promises.push(noc.pickList.get({"id":element.id,"route":"production-build","route_id":"count","built":true}).$promise
          .then(function(count){
            vm.readyForBuild["data"][index]['quantity_built'] = count.count
          }))
          vm.pending_promises.push(noc.serialGenerator.get({"route":"count","pick_list/id":element.id,"final_product/final_test_passed":true}).$promise
          .then(function(count){
            vm.readyForBuild["data"][index]['quantity_passed_test'] = count.count
          }))
        })

          

        vm.process_promises()
      })
    }
      
    vm.load_data = function(){
			load_data()
		}

    var load_data = function(){
      if(vm.selectedId){
        vm.attached_to_finished_product = []
        var obj = {}
        obj = {"page":vm.currentPage,"page_size":vm.num_results,"id":vm.selectedId,"route":"production-build"}
        noc.pickList.get(obj).$promise
        .then(function(data){
          vm.buildList = data
          angular.forEach(data.data,function(element){
            if(element.serial_number_data){
              vm.pending_promises.push(noc.serialGenerator.get({"id":element.serial_number_data.id}).$promise
              .then(function(serial_data){
                if(serial_data.final_product){
                  vm.attached_to_finished_product.push(serial_data.id)
                }
              }))
            }          
          })
          vm.process_promises()
        })

        noc.pickList.get({"id":vm.selectedId}).$promise
        .then(function(data){
          vm.pickList = data
        })

        noc.pickList.get({"id":vm.selectedId,"route":"pieces","product_data/jnl_serialized":true}).$promise
        .then(function(data){
          vm.serializedCount = data.count
          vm.serializedProduct = data.data
        })
      }else{
        readyForBuild()
      }
    }

    vm.home = function(){
      vm.selectedTransaction = []
      vm.selectedBuild = null
      vm.selectedBuildId = null
      vm.activeKey = null
      vm.action = null
      vm.finalSerials = null
      load_data()
    }

    vm.loadBuildRequestDetail = function(id){
      $location.path('buildOverview/'+id)
    }

    vm.checkSerial = function(sn,build_id){
      // vm.serializedProduct.id upon entering the screen with a pick list id as a route parameter, load_data function defines vm.serializedProduct which is the "daughter" or "JNL" board attached to the final product
      noc.serialGenerator.get({"serial_number":sn,"product_data/id":vm.serializedProduct[0].product_data.id}).$promise
      .then(function(data){
        if(data.count == 1 && !data.data[0].build_status && !data.data[0].final_product){
          toastr.success("Serial Number Valid")
          var serial_generator_id = data.data[0].id
          var l = [{"key":"build_started","value":true}]
          noc.pickList.patch({"id":vm.pickList.id,"route":"production-build","route_id":build_id},{"updates":l}).$promise
          .then(function(){
            var q = [{"key":"product_build_id","value":build_id},{"key":"part_of_build","value":true},{"key":"part_of_final_build","value":false},{"key":"final_product_tested","value":false},{"key":"final_test_passed","value":false}]
            noc.serialGenerator.patch({"id":serial_generator_id},{"updates":q}).$promise
            .then(function(){
              toastr.success("Build Started")
              load_data()
            })
            .catch(function(){
              var l = [{"key":"build_started","value":false}]
              noc.pickList.patch({"id":vm.pickList.id,"route":"production-build","route_id":build_id},{"updates":l}).$promise
              .then(function(){
                $log.log("Reversed Build Started Status")
              })
            })
            
          })
          .catch(function(data){
            toastr.warning(data)
          })
        }else{
          noc.serialGenerator.get({"serial_number":sn}).$promise
          .then(function(data){
            vm.invalidSerialData = data.data
            vm.modalInstance = $uibModal.open({
              templateUrl: 'serialNumberData.html',
              scope: $scope,
              size: 'lg'
            });
          })
        }
      })
    }

    vm.restartBuild = function(serial_generator_id,build_id){
      var l = [{"key":"build_started","value":false},{"key":"built","value":false}]
      noc.pickList.patch({"id":vm.pickList.id,"route":"production-build","route_id":build_id},{"updates":l}).$promise
      .then(function(){
        // load_data()
        var q = [{"key":"product_build_id","value":null}]
        noc.serialGenerator.patch({"id":serial_generator_id},{"updates":q}).$promise
        .then(function(){
          toastr.success("Serial Number Removed, Build Restarted")
          load_data()
        })
      })
    }

    vm.completeBuild = function(serial_generator_id,build_id){
      var l = [{"key":"built","value":true}]
      noc.pickList.patch({"id":vm.pickList.id,"route":"production-build","route_id":build_id},{"updates":l}).$promise
      .then(function(){
        if(serial_generator_id){
          var q = [{"key":"part_of_final_build","value":true}]
          noc.serialGenerator.patch({"id":serial_generator_id},{"updates":q}).$promise
          .then(function(){
            toastr.success("Build Completed")
            load_data()
          })
        }
        else{
          toastr.success("Build Completed")
          load_data()
        }
      })
    }

    vm.closeModal = function(){
			vm.modalInstance.dismiss();
		};
    
    vm.clear_filters = function(){
			vm.currentPage = 1
			vm.sort_by = "ID"
			vm.sort_order = "ASC"
			vm.searchFor = "build_request/build_data/product_data/part_number"
			vm.searchVal = ""
			vm.num_results = 15
      vm.showPicked = false
			load_data()
		}

    vm.showSerialNumberData = function(serial_number_id){
      noc.serialGenerator.get({"id":serial_number_id}).$promise
      .then(function(data){
        $log.log(data)
      })
    }

    vm.resetSerialNumber = function(obj){
      var final_product_mac = obj['final_product']['identifier']

      var l = [{"key":"associated_serial","value":null}]

      noc.quantumHardware.patch({"id":final_product_mac},{"updates":l}).$promise
      .then(function(){
        toastr.success("Serial Number Reset Successfully")
        vm.closeModal()
        vm.load_data()
      })
      .catch(function(err){
        $log.log(err)
      })
    }

    vm.finalize_request = function(){
      noc.serialGenerator.get({"route":"count","pick_list/id":vm.pickList.id,"final_product/final_test_passed":true}).$promise
      .then(function(s_data){
        vm.tested_value = s_data.count
        noc.pickList.get({"id":vm.pickList.id,"route":"production-build","route_id":"count","built":true}).$promise
        .then(function(p_data){
          vm.built_value = p_data.count
          vm.modalInstance = $uibModal.open({
            templateUrl: 'finalizeRequest.html',
            scope: $scope,
            size: 'lg'
          });
        })
      })
    }

    vm.confirm_final = function(){
      noc.pickList.patch({"id":vm.pickList.id},{"updates":[{"key":"built","value":true}]}).$promise
      .then(function(){
        toastr.success("Request Finalized Successfully")
        vm.closeModal()
        $location.path('buildOverview')
      })
    }

    vm.testProduct = function(sn_id,product_id){
      $log.log(sn_id,product_id)
      var prot = $location.protocol()
      var port = $location.port()
      var h = $location.host()

      if(port == 3000){
        var url = prot+"://"+h+":3000/productTest/"+product_id+'/'+sn_id
      }else{
        var url = prot+"://"+h+"/productTest/"+product_id+'/'+sn_id
      }

      $log.log(url)

      $window.open(url);
      // $location.path('/productTest/'+product_id+'/'+sn_id)
    }

    vm.start_no_serial_build = function(build_id){
      var l = [{"key":"build_started","value":true}]
      noc.pickList.patch({"id":vm.pickList.id,"route":"production-build","route_id":build_id},{"updates":l}).$promise
      .then(function(){
        toastr.success("Build Started")
        load_data()
      })
    }

    vm.complete_no_serial_build = function(build_id){
      var l = [{"key":"built","value":true}]
      noc.pickList.patch({"id":vm.pickList.id,"route":"production-build","route_id":build_id},{"updates":l}).$promise
      .then(function(){        
          toastr.success("Build Completed")
          load_data()
      })
      .catch(function(){
        toastr.warning("Failed to complete the build")
      })
    }

    vm.viewTest = function(sn){
      $location.path('/quantumHardwareTest/'+sn)
    }

    // var mainTimer
		// function mainTimerFunction(){
		// 	if(angular.isDefined(mainTimer)) return;
		// 	mainTimer = $interval(function(){
		// 		vm.load_data()
		// 	},10000)
		// }

		// mainTimerFunction()

    // $scope.$on('$destroy', function() {
    //   if(angular.isDefined(mainTimer)){
    //     $interval.cancel(mainTimer)
    //   }
    //   if(angular.isDefined(timer_id)){
    //     clearInterval(timer_id)
    //   }
    // })

    vm.clear_filters()

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('boardTestController', boardTestController);

  /** @ngInject */
	function boardTestController(toastr, noc, boardTestAPI, $location, $routeParams, user) {
		var vm = this;
		var timer_id
		var outputPassed = false
		vm.testType = $routeParams.id
		vm.prevSN = null
		vm.loadedData = false
		vm.errors = []
		vm.warnings = []
		vm.userConfirm = false
		var user_id = user.data.user_id

    vm.checkSN = function(){
		vm.valid = false
		vm.errors = []
		vm.warnings = []
		if(vm.serialNumber){
	vm.valid = true
		}
	}
    if($routeParams.sn > 0){
      noc.serialGenerator.get({id:$routeParams.sn,route:"ID"}).$promise
      .then(function(data){
        vm.serialNumber_id = $routeParams.sn
        vm.serialNumber = data.serial_number
        vm.checkSN()
      })
    }
		// var inputStatus = boardTestAPI.inputStatus.get({id:1})
		// console.log(inputStatus)
		function statusUpdate(){
			if(vm.testType == 'dcs'){
				boardTestAPI.testStatus.get(function(data){
					vm.testStatus = data.test_status
				})
			}else if(vm.testType == 'pc'){
				boardTestAPI.pcTestStatus.get(function(data){
					vm.testStatus = data.test_status
				})
			}
		}

		function timer(){
			return setInterval(function(){
				results()
			}, 1000);
		}

		function results(){
			if(vm.testType == 'dcs'){
				boardTestAPI.currentStatus.get(function(data){
					vm.resultData = data
				})
			}else if (vm.testType =='pc') {
				boardTestAPI.pcTestStatus.get(function(data){
					vm.resultData = data
				})
			}
		}

		statusUpdate()

		vm.startTest = function(){
			vm.errors = []
			if(vm.testType == 'dcs'){
				boardTestAPI.startTest.put(function(){
					statusUpdate()
				})
			}else if (vm.testType == 'pc') {
				vm.startPromise = boardTestAPI.pcStart.put(function(data){
					if(data['running']){
						statusUpdate()
						timer_id = timer()
					}else{
						vm.errors.push('No Board affixed to the tester')
					}
				},function(){
					vm.errors.push('Tester Offline or Unavailable')
				}).$promise
			}
		}

		vm.stopTest = function(){
			clearInterval(timer_id)
			boardTestAPI.stopTest.put(function(){
				statusUpdate()
			})
		}



		vm.toggleOut = function(outputNumber){
			boardTestAPI.toggleOutput.get({id:outputNumber})
		}

		vm.outputOn = function(){
			outputPassed = true
		}

		function input_test(){
			var r = true
			angular.forEach(vm.resultData.inputs,function(element){
				if(!element){
					r = false
				}
			})
			return r
		}

		vm.passedTest = function(){
			var pass = false
			if(outputPassed){
				if(vm.resultData.bluetooth.result){
					if(input_test()){
						pass = true
						clearInterval(timer_id)
					}
				}
			}
			return pass
		}

		vm.confirm = function(){
			vm.userConfirm = true
		}

		vm.pcStopTest = function(){
			clearInterval(timer_id)
			boardTestAPI.pcStop.put(function(){
				vm.testStatus = false
				vm.serialNumber = null
			})
		}

		vm.submitFail = function(){
			var prevSN = vm.serialNumber
			vm.resultData.test_result = false
			noc.preAssemblyTest.put({id:prevSN},{"result":vm.resultData.test_result,"user":user_id})
				vm.pcStopTest()
				statusUpdate()
		}

		vm.submitTest = function(){
			var prevSN = vm.serialNumber
			clearInterval(timer_id)
			if(vm.testType == 'dcs'){
				boardTestAPI.stopTest.put(function(){
					noc.preAssemblyTest.put({id:prevSN},{"result":vm.resultData.test_result,"user":user_id})
					statusUpdate()
				})
			}else if (vm.testType == 'pc') {
				noc.preAssemblyTest.put({id:vm.serialNumber_id},{"result":vm.resultData.test_result,"user":user_id})
					vm.userConfirm = false
					vm.pcStopTest()
					statusUpdate()
          $location.path('/buildOverview')
			}
		}
	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminUserController', adminUserController);

  /** @ngInject */
	function adminUserController(toastr, noc, $scope, $q, $uibModal, user) {
		var vm = this;
		
		var load_users = function(){
			var promises = []
			vm.users = []

			noc.userInfo.get({"third_party/id":0,"active":true,"system_user":false,"page_size":100}).$promise
			.then(function(data){
				vm.users = data.data
			})


			noc.accessLevel.get().$promise
			.then(function(data){
				vm.accessLevels = data.data
			})

			noc.teams.get().$promise
			.then(function(data){
				vm.teams = data.data
			})


			noc.alertDevice.get().$promise
			.then(function(data){
				vm.alertDevices = data.data
			})

			vm.userPromise = $q.all(promises)
			.then(function(){
				vm.ladda=false
			})
		}

		noc.emailActions.get().$promise
		.then(function(data){
			vm.emailActions = data.data
		})

		vm.currentUser = user.data.user_id
		load_users()
		var newUserObject = {"user_id": null,"user_name": null,"user_full_name": null,"user_email": null,"on_call_device": null,"access_level": null,"active": true,"primary_function": null,"password": null,"email_actions":[]}

		//Object Actions
		vm.removeUserDialog = function(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'confirmModal.html',
				scope: $scope,
				size: 'md'
			});
		}

		vm.closeModal = function(){
			vm.modalInstance.dismiss();
			vm.selectedUser = null
		};

		vm.loadUser = function(id) {
			vm.selectedUser = noc.userInfo.get({id:id})
		}

		vm.clearUser = function() {
			vm.selectedUser = null
			vm.pass = false
		}

		vm.passFunc = function(){
			if(!vm.pass){
				vm.selectedUser.password = null;
			}
		}

		//API CALLS
		vm.newUser = function(){
			vm.selectedUser = angular.copy(newUserObject)
		}

		vm.saveUser = function(){
			noc.userInfo.save(vm.selectedUser,function(){
				load_users();
				toastr.success('User Added');
				vm.clearUser()
			})
		}

		vm.updateUser = function(){
			noc.userInfo.update({id:vm.selectedUser.user_id},vm.selectedUser,function(){
				toastr.success('User Updated');
				load_users();
				vm.clearUser();
			})
		}

		vm.removeUser = function(){
			noc.userInfo.remove({id:vm.selectedUser.user_id},function(){
				load_users();
				toastr.success('User Removed');
				vm.modalInstance.dismiss();
				vm.clearUser();
			})
		}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminSupportController', adminSupportController);

  /** @ngInject */
	function adminSupportController($location) {
		var vm = this;

    vm.load = function(Name){
      if(Name == 'linuxUsers'){
        $location.path("/supportAdminLinux");
      }
    }
  }

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminSettingsController', adminSettingsController);

  /** @ngInject */
	function adminSettingsController(toastr, noc) {
		var vm = this;

    //Current settings in database
		noc.settings.get().$promise
    .then(function(data){
      vm.settingsArr = data
    })

    //Get locations from Connectwise
    vm.connectwise_location_data = []
    noc.connectwise_routes.query({"route":"locations"}).$promise
    .then(function(data){
      angular.forEach(data,function(element){
        if(element.location_flag){
          vm.connectwise_location_data.push(element)
        }
      })
    })

    vm.estimator_settings = noc.estimator_globals.query()

    vm.update = function(){
      noc.settings.save(vm.settingsArr).$promise
      .then(function(){
        toastr.success("Save Settings Success")
      })
      .catch(function(){
        toastr.warning("Save Settings Unsuccessful")
      })
      noc.estimator_globals.save(vm.estimator_settings).$promise
      .then(function(){
        toastr.success("Save Estimator Settings Success")
      })
      .catch(function(){
        toastr.warning("Save Estimator Settings Unsuccessful")
      })
    }
	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminSalesController', adminSalesController);

  /** @ngInject */
	function adminSalesController($location) {
		var vm = this;

    vm.load = function(Name){
      if(Name == 'goals'){
        $location.path("/salesAdminGoals");
      }
      else if(Name == 'reps'){
        $location.path("/salesAdminReps");
      }
      else if(Name == 'ownerUpdate'){
        $location.path("/salesAdminOwnerUpdate");
      }
      else if(Name == 'production'){
        $location.path("/salesAdminProduction");
      }
      else if(Name == 'territory'){
        $location.path("/salesAdminTerritories");
      }
    }
  }

})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminRMAController', adminRMAController);

  /** @ngInject */
	function adminRMAController($log, toastr, noc) {
		var vm = this;
    var defaultObject = {"id":null,"product":[],"reason":null,"available_for_reason":true,"available_for_repair":true}
    vm.workingObject = {}
    vm.availablePNs = []

    function createWorkingObject(){
			angular.copy(defaultObject,vm.workingObject)
		}
    var load_data = function(){
      vm.reasonPromise = noc.rmaReason.query().$promise
      .then(function(data){
        vm.currentReasons = data
      })
    }

		createWorkingObject()
    load_data()

    vm.partPromise = noc.product.query().$promise
    .then(function(partData){
      vm.allParts = partData
      angular.forEach(partData,function(element){
        if(element.rma_enabled){
          vm.availablePNs.push(element)
        }
      })
    })

    vm.populateDetails = function(reasonId){
      $log.log(reasonId)
      noc.rmaReason.get({id:reasonId}).$promise
      .then(function(data){
        vm.workingObject = data
      })
    }

    vm.newReason = function(){
      createWorkingObject()
    }

    vm.saveReason = function(){
      if(vm.workingObject.id){
        noc.rmaReason.update({id:vm.workingObject.id},vm.workingObject).$promise
        .then(function(){
          toastr.success("Reason Updated")
          load_data()
          createWorkingObject()
        })
        .catch(function(err){
          $log.log(err)
          toastr.warning("Reason Not Updated")
        })
      }else{
        noc.rmaReason.save(vm.workingObject).$promise
        .then(function(){
          toastr.success("Reason Created")
          load_data()
          createWorkingObject()
        })
        .catch(function(err){
          $log.log(err)
          toastr.warning("Reason Not Created")
        })
      }
    }

	}
})();

(function() {
	'use strict';

	angular
	.module('nocAngular')
	.controller('adminProductController', adminProductController);

	/** @ngInject */
	function adminProductController(toastr, noc, $uibModal, $scope, $log) {
		var vm = this;
		vm.productEdit = false
		vm.addExtendedPart = {};
		vm.currentPage = 1
		vm.num_results = 10
		vm.searchFor = 'part_number'
		vm.default_test_req_object = {
										"id":null,
										"bluetooth": false,
										"inputs": false,
										"outputs": false,
										"product_data": {
											"id": null
										},
										"screen": false,
										"sound": false,
										"wiegand": false,
										"alarm": false,
										"staff": false,
										"checkin": false
									}


		var load_data = function(){
			var obj = {"page":vm.currentPage,"page_size":vm.num_results,"sort_by":"name"}
			
			if(vm.searchValue){
				obj[vm.searchFor]='"%'+vm.searchValue+'%"'
			}

			noc.product.get(obj).$promise
			.then(function(data){
				vm.productList = data
			})
			
			
		}

		load_data()

		vm.load_data = function(){
			load_data()
		}

		vm.populateDetails = function(i){
			vm.has_test = false
			// vm.loadPromise = noc.product.get({id:id}).$promise
			// .then(function(data){
			if (i != -1){
				vm.selectedProduct = vm.productList.data[i]
			}
			vm.productEdit = true
			vm.estimate_systems_data = []
			vm.test_reqs = null
			vm.hardware_test = false
			vm.pull_cord_test = false
			noc.systemParts.get({"product_table_id":vm.selectedProduct.id,"active":true,"page_size":1000}).$promise
			.then(function(data){
				angular.forEach(data.data,function(element){
					if (element['system_id'] != 0){
						vm.estimate_systems_data.push(element)
					}
				})
				noc.product.get({"id":vm.selectedProduct.id,"route":"test-requirement"}).$promise
				.then(function(req_data){
					if(req_data['count'] > 0){
						vm.requirement_object = req_data['data'][0]
					}else{
						vm.requirement_object = angular.copy(vm.default_test_req_object)
					}
				})
			})
			if (vm.selectedProduct.is_pull_cord){
				vm.has_test = true
				vm.pull_cord_test = true
			}else{
				angular.forEach([vm.selectedProduct.is_dcs_unit,vm.selectedProduct.is_enrollment,vm.selectedProduct.is_qsm,vm.selectedProduct.is_io_repeater,vm.selectedProduct.is_sad,vm.selectedProduct.is_tts],function(element){
					$log.log(element)
					if(element){
						vm.has_test = true
						vm.hardware_test = true
					}
				})
			}

			// if (vm.has_test){
			// 	noc.product.get({"id":vm.selectedProduct.id,"route":"test-requirement"}).$promise
			// 	.then(function(test_reqs){
			// 		$log.log(test_reqs)
			// 		if(test_reqs.count == 0){
			// 			vm.test_reqs = angular.copy(vm.default_test_req_object)
			// 		}else{
			// 			vm.test_reqs = test_reqs.data[0]
			// 		}
			// 	})
			// }
			if (i != -1){
				vm.changeView(0)
			}
			// })
		}

		vm.validDetail = function(){
			var valid = false;
			if(!(isNaN(vm.selectedProduct.hours))){
				valid = true;
			}
			return valid
		}

		vm.clearSearch = function(){
			vm.currentPage = 1
			vm.num_results = 10
			vm.searchFor = 'part_number'
			vm.searchValue = ""
			load_data()
		}

		vm.saveProduct = function(){
			var modal_needs_close = false
			var test_req_promise = null
			if(!angular.equals({},vm.addExtendedPart)){
				vm.selectedProduct.extended_parts.push(vm.addExtendedPart)
				vm.addExtendedPart = {}
				modal_needs_close = true;
			}
			
			$log.log(vm.selectedProduct)
			vm.loadPromise = noc.product.update({id:vm.selectedProduct.id},vm.selectedProduct).$promise
			.then(function(){
				if(vm.requirement_object){
					if(vm.requirement_object.id){
						test_req_promise = noc.product.update({"id":vm.selectedProduct.id,"route":"test-requirement","route_id":vm.requirement_object.id},vm.requirement_object).$promise
						.then(function(){
							toastr.success("Test Requirements Saved")
							vm.populateDetails(-1)
						})
					}else{
						test_req_promise = noc.product.save({"id":vm.selectedProduct.id,"route":"test-requirement"},vm.requirement_object).$promise
						.then(function(){
							toastr.success("Test Requirements Saved")
							vm.populateDetails(-1)
						})
					}
				}
				toastr.success("Product Updated")
				// vm.productEdit = false;
				// vm.selectedProduct = null;
			},function(){
				toastr.warning("Product Save Fail")
			})
			if(modal_needs_close){
				vm.closeModal()
			}
			
		}

		vm.checkForTestChange = function(){
			vm.has_test = false
			angular.forEach([vm.selectedProduct.is_dcs_unit,vm.selectedProduct.is_enrollment,vm.selectedProduct.is_qsm,vm.selectedProduct.is_io_repeater,vm.selectedProduct.is_sad,vm.selectedProduct.is_tts],function(element){
				$log.log(element)
				if(element){
					vm.has_test = true
				}
			})
		}

		vm.cancelEdit = function(){
			vm.selectedProduct = null
			vm.productEdit = false;
			vm.page_id= null
		}

		vm.changeView = function(pageID){
			if(pageID == 0){
				vm.activeObject = vm.selectedProduct.general
				vm.activeList = null
				vm.page_id = 0
			}else if (pageID == 1) {
				vm.activeObject = vm.selectedProduct.build
				vm.activeList = null
				vm.page_id = 1
			}else if (pageID == 2) {
				vm.activeObject = vm.selectedProduct.estimator
				vm.activeList = null
				vm.page_id = 2
			}else if (pageID == 3) {
				vm.activeObject = null
				vm.activeList = vm.selectedProduct.extended_parts
				vm.page_id = 3
			}
		}

		vm.searchExtendedParts = function(){
			var searchval ='"%'+vm.searchExtended+'%"'
			noc.product.get({"part_number":searchval,"page_size":1000}).$promise
			.then(function(data){
				vm.extendedProductList = data.data
			})
		}

		vm.searchRelatedParts = function(){
			var searchval ='"%'+vm.searchRelated+'%"'
			noc.product.get({"part_number":searchval,"page_size":1000}).$promise
			.then(function(data){
				vm.relatedProductList = data.data
			})
		}

		vm.addExtended = function(){
			vm.extendedProductList = false
			vm.relatedProductList = false
			vm.modalInstance = $uibModal.open({
				templateUrl: 'AddPart.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.closeModal = function(){
			vm.addExtendedPart = {};
			vm.related_part_obj = {};
			vm.modalInstance.dismiss();
		};

		vm.removeExtended = function(k){
			vm.selectedProduct.extended_parts.splice(k)
		}

		vm.modify_related = function(system_id,id,add){
			vm.related_part_obj = {}
			vm.related_part_obj.system_id = system_id
			vm.related_part_obj.estimator_sys_id = id
			vm.extendedProductList = false
			vm.relatedProductList = false
			if(add){
				vm.action = "Add"
			}else{
				vm.action = "Remove"
			}

			vm.modalInstance = $uibModal.open({
				templateUrl: 'addRelatedPart.html',
				scope: $scope,
				size: 'lg'
			});
		}

		vm.saveRelatedPart = function(){
			var all_sys = vm.related_part_obj['all']
			if (all_sys){
				angular.forEach(vm.estimate_systems_data,function(system_part_obj){
					var sys_type = system_part_obj.system_id
					var sys_part_id = system_part_obj.id
					var obj = {'related_part_connectwise_id':vm.related_part_obj.connectwise_id,'related_part_qty':vm.related_part_obj.qty,'related_part_parent':vm.selectedProduct.connectwise_id,'system_id':sys_type}
					noc.systemParts.save({"id":sys_part_id,"route":"related-part"},obj).$promise
					.then(function(){
						toastr.success("Addition Success")
						noc.systemParts.get({"product_table_id":vm.selectedProduct.id,"page_size":1000}).$promise
						.then(function(data){
							vm.estimate_systems_data = []
							angular.forEach(data.data,function(element){
								if (element['system_id'] != 0){
									vm.estimate_systems_data.push(element)
								}
							})
							vm.closeModal()
						})
					})
					.catch(function(data){
						toastr.success(data)
					})
				})
			}else{
				var sys_type = vm.related_part_obj.system_id
				var sys_part_id = vm.related_part_obj.estimator_sys_id
				var obj = {'related_part_connectwise_id':vm.related_part_obj.connectwise_id,'related_part_qty':vm.related_part_obj.qty,'related_part_parent':vm.selectedProduct.connectwise_id,'system_id':sys_type}
				noc.systemParts.save({"id":sys_part_id,"route":"related-part"},obj).$promise
				.then(function(){
					toastr.success("Addition Success")
					noc.systemParts.get({"product_table_id":vm.selectedProduct.id,"page_size":1000}).$promise
						.then(function(data){
							vm.estimate_systems_data = []
							angular.forEach(data.data,function(element){
								if (element['system_id'] != 0){
									vm.estimate_systems_data.push(element)
								}
							})
							vm.closeModal()
						})
				})
				.catch(function(data){
					toastr.success(data)
				})
			}
		}

		vm.removeRelatedPart = function(){
			var all_sys = vm.related_part_obj['all']
			if (all_sys){
				angular.forEach(vm.estimate_systems_data,function(system_part_obj){
					angular.forEach(system_part_obj.related_parts,function(related_part){
						if(related_part.related_part_number == vm.remove_part_pn){
							noc.systemParts.delete({"id":system_part_obj.id,"route":"related-part","route_id":related_part.id}).$promise
							.then(function(){
								toastr.success("Removal Success")
								noc.systemParts.get({"product_table_id":vm.selectedProduct.id}).$promise
								.then(function(data){
									vm.estimate_systems_data = []
									angular.forEach(data.data,function(element){
										if (element['system_id'] != 0){
											vm.estimate_systems_data.push(element)
										}
									})
									vm.closeModal()
								})
							})
							.catch(function(data){
								toastr.success(data)
							})
						}
					})
				})
			}else{
				noc.systemParts.delete({"id":vm.related_part_obj.estimator_sys_id,"route":"related-part","route_id":vm.remove_part_id}).$promise
				.then(function(){
					toastr.success("Removal Success")
					noc.systemParts.get({"product_table_id":vm.selectedProduct.id,"page_size":1000}).$promise
					.then(function(data){
						vm.estimate_systems_data = []
						angular.forEach(data.data,function(element){
							if (element['system_id'] != 0){
								vm.estimate_systems_data.push(element)
							}
						})
						vm.closeModal()
					})
				})
				.catch(function(data){
					toastr.success(data)
				})
			}
		}

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminIssueController', adminIssueController);

  /** @ngInject */
	function adminIssueController($log, toastr, noc, $scope, $uibModal) {
		var vm = this;

    vm.pageView = 3
    vm.subPage = 1
    vm.addObject = {}

     noc.issue.get({"route":"resolution","page_size":1000}).$promise
    .then(function(data){
      vm.resolutions = data.data
    })

    noc.issue.get({"route":"top-level","page_size":1000}).$promise
    .then(function(top_issues){
      vm.top_levels = top_issues.data
    })

    noc.issue.get({"route":"second-level","page_size":1000}).$promise
    .then(function(second_issues){
      vm.second_levels = second_issues.data
    })

    vm.loadTopLevel = function(id){
      angular.forEach(vm.second_levels,function(second_level){
          second_level.assigned = false
      })
      noc.issue.get({"issue_id":id,"route":"related"}).$promise
      .then(function(data){
        vm.selected_second_levels = data.data
        angular.forEach(data.data,function(element){
          angular.forEach(vm.second_levels,function(second_level){
            if(element.second_level_id == second_level.id){
              second_level.assigned = true
            }
          })
        })
        vm.activeId = id
      })
    }

    vm.edit = function(id){
      vm.editActive = true;
      vm.editId = id
    }

    vm.save = function(second_level_id,assigned){
      if (assigned){
        noc.issue.save({"route":"related"},{"second_level_id":second_level_id,"top_level_id":vm.editId}).$promise
        .then(function(){
          toastr.success("Save Successful")
          vm.loadTopLevel(vm.activeId)
        })
      }
      else{
        angular.forEach(vm.selected_second_levels,function(element){
          $log.log(element)
          if(element.second_level_id == second_level_id){
            noc.issue.delete({"route":"related","issue_id":element.id}).$promise
            .then(function(){
              toastr.success("Save Successful")
              vm.loadTopLevel(vm.activeId)
            })
          }
        })
        
      }
    }

    vm.updateResolution = function(k){
      var obj = vm.resolutions.list[k]
      noc.issue_resolution.update({"id":obj.id},obj).$promise
      .then(function(){
        toastr.success("UPDATE Successful")
      })
      .catch(function(){
        toastr.warning("SAVE FAILED")
      })
    }

    vm.updateTopLevel = function(k){
      var obj = vm.top_levels[k]
      noc.issue.update({"issue_id":obj.id},obj).$promise
      .then(function(){
        toastr.success("UPDATE Successful")
      })
      .catch(function(){
        toastr.warning("SAVE FAILED")
      })
    }


    vm.addFunction = function(title){
      vm.addObject.title = title
      vm.modalInstance = $uibModal.open({
				templateUrl: 'addItem.html',
				scope: $scope,
				size: 'md'
			});
    }

    vm.closeModal = function(){
      vm.addObject = {}
      if(vm.modalInstance){
        vm.modalInstance.dismiss();
      }
    };

    vm.saveItem = function(){
      var p = null
      if(vm.addObject.title == 'resolution'){
        p = noc.issue_resolution.save(vm.addObject).$promise
      }else if (vm.addObject.title == 'class') {
        p = noc.issue.save(vm.addObject).$promise
      }else if (vm.addObject.title == 'action') {
        p = noc.issue_second_level.save(vm.addObject).$promise
      }
      p.then(function(){
        toastr.success(vm.addObject.title +" Add Successful");
        vm.closeModal()
      })
      .catch(function(){
        toastr.warning('Add Failed')
      })
    }

  }
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminBuildController', adminBuildController);

  /** @ngInject */
	function adminBuildController($log, toastr, noc, $scope, $uibModal) {
		var vm = this;
    vm.simplifySearchProduct = [];
    vm.currentBuilds = [];
    vm.newParts = null
    vm.availableBuildParts = []

    function load_data(){
      vm.simplifySearchProduct = [];
      vm.currentBuilds = [];
      vm.buildData = null
      noc.build.get({"active":true,"page_size":1000}).$promise
      .then(function(data){
        vm.currentBuilds = data.data
      })
    }

    load_data()

    vm.newBuildConfirmDialog = function(){
      vm.modalInstance = $uibModal.open({
				templateUrl: 'newBuild.html',
				scope: $scope,
				size: 'md'
			});
    }

    vm.searchParts = function(){
      var search = '"%'+vm.searchNewPart+'%"'
      noc.product.get({"part_number":search}).$promise
      .then(function(data){
        vm.searchedProductList = data.data
      })
    }

    vm.populateDetails = function(buildID){
      vm.selectedBuildPartId = buildID
      vm.populatePromise = noc.build.get({id:buildID}).$promise
      .then(function(data){
        vm.buildData = data
        noc.product.get({id:vm.buildData.product_data.id},function(product_data){
          // vm.subIterator()
          vm.product_information = product_data
        })
        noc.build.get({"id":buildID,"route":"included-parts","page_size":100}).$promise
        .then(function(included_data){
          vm.included_parts = included_data.data
        })
      }).catch(function(error){
        toastr.warning(error)
      })
    }

    vm.populateEditor = function(){
      vm.editing = true
    }

    vm.backToBuild = function(){
      vm.editing = false
    }

    vm.subIterator = function(){
      vm.totalCost = 0;
      angular.forEach(vm.buildData.included_parts,function(element){
        vm.totalCost = (element.cost * element.build_product_qty) + vm.totalCost
      })
    }

    vm.closeModal = function(){
      vm.newParts = null;
      vm.modalPartDisplay = null;
      vm.modalPartId = null;
      vm.modalTransactionId = null;
      vm.searchedProductList = null
      vm.modalInstance.dismiss();
    };

    vm.newBuildDialog = function(){
      var found
      noc.product.get({"jnl_build":true,"inactive":false,"page_size":1000}).$promise
      .then(function(data){
        $log.log(data)
        angular.forEach(data.data,function(product){
          found = false
          angular.forEach(vm.currentBuilds,function(build){
            if(product.id == build.product_data.id){
              found = true
            }
          })
          if(!found){
            vm.availableBuildParts.push(product)
          }
        })
      })
      vm.modalInstance = $uibModal.open({
				templateUrl: 'newBuildDialog.html',
				scope: $scope,
				size: 'lg'
			});
    }

    vm.addBuild = function(){
      noc.build.save({"product_data":{"id":vm.newBuild.id}}).$promise
      .then(function(data){
        load_data()
        vm.populateDetails(data.id)
        vm.closeModal()
        vm.searchValue = vm.newBuild.part_number
        vm.newBuild = null
      })
    }

    vm.updateBuild = function(){
      noc.build.update({id:vm.buildData.id},vm.buildData).$promise
      .then(function(){
        toastr.success("Build Updated");
      })
    }

    vm.newPartDialog = function(){
      vm.searchNewPart = null
      vm.searchedProductList = null
			vm.modalInstance = $uibModal.open({
				templateUrl: 'newPart.html',
				scope: $scope,
				size: 'lg'
			});
		}

    vm.confirmRemove = function(){
			vm.modalInstance = $uibModal.open({
				templateUrl: 'removeConfirm.html',
				scope: $scope,
				size: 'md'
			});
		}

    vm.addPart = function(){
      noc.build.save({"id":vm.buildData.id,"route":'included-parts'},{"product_data":{"id":vm.newParts.id},"quantity":Number(vm.newPartQty)}).$promise
      .then(function(){
        vm.populateDetails(vm.buildData.id)
        vm.closeModal()
      })
    }

    vm.editPartDialog = function(rowId,pn,name,transaction_id){
      vm.modalPartDisplay = pn + '-'+ name;
      vm.modalPartId = rowId;
      vm.modalTransactionId = transaction_id
      vm.modalInstance = $uibModal.open({
				templateUrl: 'editPartConfirm.html',
				scope: $scope,
				size: 'md'
			});
    }

    vm.editPart = function(){
      // noc.build.update({id:vm.buildData.id,route:'buildPart',partId:vm.modalPartId},{"build_product_id":vm.modalPartId,"build_product_qty":Number(vm.editPartQty),"transaction_id":vm.modalTransactionId}).$promise
      var l = [{"key":"quantity","value":vm.editPartQty}]
      noc.build.patch({"id":vm.buildData.id,"route":"included-parts","route_id":vm.modalPartId},{"updates":l}).$promise
      .then(function(){
        vm.populateDetails(vm.buildData.id)
        vm.closeModal()
      })
    }

    vm.removePartDialog = function(rowId,pn,name){
      vm.modalPartDisplay = pn + '-'+ name;
      vm.modalPartId = rowId;
      vm.modalInstance = $uibModal.open({
				templateUrl: 'removePartConfirm.html',
				scope: $scope,
				size: 'md'
			});
    }

    vm.removePart = function(rowId){
      noc.build.delete({id:vm.buildData.id,route:'included-parts',"route_id":rowId}).$promise
      .then(function(){
        vm.closeModal()
      })
    }

    vm.copyDialog = function(){
      vm.modalInstance = $uibModal.open({
				templateUrl: 'copyBuildDialog.html',
				scope: $scope,
				size: 'lg'
			});
    }

    vm.copyBuild = function(){
      // noc.build.save({route:'copy'},{"build_id_to_populate":vm.selectedBuildPartId,"build_id_to_copy":vm.selectedCopy.id}).$promise
      var copied_parts = []
      noc.build.delete({"id":vm.buildData.id,"route":"included-parts"}).$promise
      .then(function(){
        $log.log("removed parts")
        noc.build.get({"id":vm.selectedCopy.id,"route":"included-parts"}).$promise
        .then(function(data){
          copied_parts = data.data
          $log.log(copied_parts)
          angular.forEach(copied_parts,function(element){
            noc.build.save({"id":vm.buildData.id,"route":'included-parts'},{"product_data":{"id":element.product_data.id},"quantity":Number(element.quantity)}).$promise
            .then(function(){
              $log.log("Part Added")
            })
          })
          toastr.success("Copy Complete")
          vm.closeModal()
          vm.populateDetails(vm.buildData.id)
        })
      })

      
      
    }

    vm.removeBuild = function(){
      noc.build.delete({"id":vm.buildData.id}).$promise
      .then(function(){
        vm.closeModal()
        vm.selectedBuildPartId = null
        vm.buildData = null
        vm.editing = false
        load_data()
      })
    }

	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('adminEstimatorController', adminEstimatorController);

  /** @ngInject */
	function adminEstimatorController(toastr, noc, $uibModal, $scope, $log) {
		var vm = this;

    vm.submit_obj = {}

    vm.load = function(type){
        vm.page_loaded = type
    }

    function load_types(){
      noc.systemTypes.get({"active":true}).$promise
      .then(function(data){
        $log.log(data)
        vm.system_types = data.data
      })
    }
    
    noc.part_locations.get().$promise
    .then(function(data){
      vm.all_part_locations = data.data
    })
    noc.sub_location.get().$promise
    .then(function(data){
      vm.all_sub_locations = data.data
    })
    // vm.productList = noc.product.query();h

    vm.searchParts = function(){
      var searchVal = '"%'+vm.searchValue+'%"'
      noc.product.get({"part_number":searchVal,"page_size":1000}).$promise
      .then(function(data){
        vm.productList = data.data
      })
    }

    vm.load_system = function(){
      vm.submit_obj = {}
      noc.systemParts.get({"system_id":vm.system_id,"page_size":1000}).$promise
      .then(function(data){
        vm.systemParts = data.data
      })
      noc.systemTypes.get({"id":vm.system_id,"route":"canned-message"}).$promise
      .then(function(data){
        vm.canned_obj = data
      })
    }
    
    vm.remove_system = function(){
      noc.systemTypes.delete({"id":vm.system_id}).$promise
      .then(function(){
        toastr.success("Deactivated System")
        vm.system_id = null
        load_types()
      })
      .catch(function(error){
        toastr.warning("Error "+error)
      })
    }
    
    vm.filterSubLocations = function(){
      vm.submit_obj.sub_location_id = null
      vm.availableSubs = []
      angular.forEach(vm.all_sub_locations,function(obj){
        if(obj.location_id == vm.submit_obj.location_id){
          vm.availableSubs.push(obj)
        }
      })
    }

    vm.removePart = function(id){
      noc.systemParts.delete({"id":id}).$promise
      .then(function(){
        toastr.success("Removed Part Successfully")
        vm.load_system()
      })
    }

    vm.validSelections = function(){
      var valid = true
      if(!vm.submit_obj.system_type){
        valid = false
      }
      if(!vm.submit_obj.location_id){
        valid = false
      }
      if(!vm.submit_obj.connectwise_id){
        valid = false
      }
      if(vm.availableSubs && vm.availableSubs.length > 0){
        if(!vm.submit_obj.sub_location_id){
          valid = false
        }
      }
      return valid
    }

    vm.handle_multiple = function(){
      vm.submit_obj.system_type = [vm.system_id]
    }

    vm.saveProduct = function(){
      var obj_list = []
      angular.forEach(vm.submit_obj.system_type,function(sys_type){
        obj_list.push({"system_id":sys_type,"product_connectwise_id":vm.submit_obj.connectwise_id,"part_location":vm.submit_obj.location_id,"sub_location":vm.submit_obj.sub_location_id})
        // $log.log(local_copy)

      })
      angular.forEach(obj_list,function(obj){
        noc.systemParts.save(obj).$promise
        .then(function(){
          toastr.success("Added Part to System Successfully")
          vm.closeModal()
        })
        .catch(function(err){
          toastr.warning(err)
        })
      })
      // $log.log(obj_list)
      vm.load_system()
    }

    vm.save_canned_message = function(){
      noc.systemTypes.update({"id":vm.system_id,"route":"canned-message"},vm.canned_obj).$promise
      .then(function(){
        toastr.success("Default Scope Saved")
      })
      .catch(function(err){
        $log.log(err)
        toastr.warning("Failed to Save")
      })
    }

    vm.loadModal = function(){
      vm.submit_obj = {}
      vm.productList = null
      vm.searchValue = null
      vm.submit_obj.system_type = [vm.system_id]
			vm.modalInstance = $uibModal.open({
				templateUrl: 'AddPart.html',
				scope: $scope,
				size: 'lg'
			});
    }

    vm.closeModal = function(){
      vm.addExtendedPart = {};
      vm.modalInstance.dismiss();
    };

    load_types()
	}
})();

(function() {
  'use strict';

  angular
	.module('nocAngular')
	.controller('GlobalController', GlobalController);

  /** @ngInject */
	function GlobalController(toastr, noc, $cookies, $location, user) {
		var vm = this;
		vm.userData = user
		vm.logout = function(){
			user.data = {"authKey":null}
			$cookies.remove('user')
			$location.path("/login");
		}
		vm.dashboard = function(){
			$location.path("/dashboard");
		}
		vm.critAlerts = function(){
			$location.path("/critAlerts");
		}
		vm.quantumStatus = function(){
			$location.path("/quantumStatus");
		}
		vm.quantumHardwareTest = function(){
			$location.path("/quantumHardwareTest");
		}
		vm.receiveProduct = function(){
			$location.path("/receiveProduct");
		}
		vm.reports = function(){
			$location.path("/reports");
		}

		vm.runDate = new Date();
		vm.code = null
		vm.runForDate = function(){
			var dateStr = vm.runDate.toISOString().slice(0, 10);
			noc.quantumCustomer.get({"id":1,"route":"recoveryPass","date":dateStr}).$promise
			.then(function(data){
				vm.code = data.code
			})

		}
	}
})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log,$location,user,$rootScope,$cookies,navItems,noc) {

     if (typeof $cookies.get('user') != 'undefined') {
        var cook = $cookies.getObject('user')
        if(angular.isUndefined(cook.pw_change_required)){
          user.data.authKey = null
          $location.path("/login");
        }else{
          user.data.authKey = cook.authKey
          noc.userInfo.get({id:cook.user_id}).$promise
          .then(function(d){
            cook.pw_change_required = d.pw_change_required
            user.data = null
            user.data = cook
            navItems.rebuild()
          })
          .catch(function(){
            user.data.authKey = null
            $location.path("/login");
            $cookies.remove('user')
          })
        }
      }
      // Redirect when logged out
     var redirectCalback = $rootScope.$on( "$routeChangeStart", function() {
        if (!user.data.authKey) {
          $location.path("/login");
        }
      })
      var a = $rootScope.$on('$locationChangeSuccess', function (event,url,oldUrl) {
          // console.log('$locationChangeSuccess changed!', new Date());
          user.data.oldUrl = oldUrl
      });
      $log.log(a)
     $rootScope.$on('$destroy', redirectCalback)
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm'
      })
      .when('/adminBuild', {
        templateUrl: 'app/adminBuild/adminBuild.html',
        controller: 'adminBuildController',
        controllerAs: 'vm'
      })
      .when('/adminEstimator', {
        templateUrl: 'app/adminEstimator/adminEstimator.html',
        controller: 'adminEstimatorController',
        controllerAs: 'vm'
      })
      .when('/adminProduct', {
        templateUrl: 'app/adminProduct/adminProduct.html',
        controller: 'adminProductController',
        controllerAs: 'vm'
      })
      .when('/adminRMA', {
        templateUrl: 'app/adminRMA/adminRMA.html',
        controller: 'adminRMAController',
        controllerAs: 'vm'
      })
      .when('/adminSales', {
        templateUrl: 'app/adminSales/adminSales.html',
        controller: 'adminSalesController',
        controllerAs: 'vm'
      })
      .when('/adminSupport', {
        templateUrl: 'app/adminSupport/adminSupport.html',
        controller: 'adminSupportController',
        controllerAs: 'vm'
      })
      .when('/adminUser', {
        templateUrl: 'app/adminUser/adminUser.html',
        controller: 'adminUserController',
        controllerAs: 'vm'
      })
      .when('/boardTest/:id/:sn', {
        templateUrl: 'app/boardTest/boardTest.html',
        controller: 'boardTestController',
        controllerAs: 'vm'
      })
      .when('/buildOverview', {
       templateUrl: 'app/buildOverview/buildOverview.html',
       controller: 'buildOverviewController',
       controllerAs: 'vm'
     })
     .when('/buildOverview/:id', {
      templateUrl: 'app/buildOverview/buildOverview.html',
      controller: 'buildOverviewController',
      controllerAs: 'vm'
    })
     .when('/buildPickList', {
      templateUrl: 'app/buildPickList/buildPickList.html',
      controller: 'buildPickListController',
      controllerAs: 'vm'
    })
     .when('/buildRequests', {
      templateUrl: 'app/buildRequests/buildRequests.html',
      controller: 'buildRequestsController',
      controllerAs: 'vm'
    })
      .when('/critAlerts', {
        templateUrl: 'app/critAlerts/critAlerts.html',
        controller: 'critAlertsController',
        controllerAs: 'vm'
      })
      .when('/criticalAlertDetail/:id', {
        templateUrl: 'app/criticalAlertDetail/criticalAlertDetail.html',
        controller: 'criticalAlertDetailController',
        controllerAs: 'vm'
      })
      .when('/customerDetail/:id', {
        templateUrl: 'app/customerDetail/customerDetail.html',
        controller: 'customerDetailController',
        controllerAs: 'vm'
      })
      .when('/installQuote/:id', {
        templateUrl: 'app/installQuote/installQuote.html',
        controller: 'installQuoteController',
        controllerAs: 'vm'
      })
      .when('/installQuoteStart', {
        templateUrl: 'app/installQuoteStart/installQuoteStart.html',
        controller: 'installQuoteStartController',
        controllerAs: 'vm'
      })
      .when('/internalTagReader', {
        templateUrl: 'app/internalTagReader/internalTagReader.html',
        controller: 'internalTagReaderController',
        controllerAs: 'vm'
      })
      .when('/login', {
        templateUrl: 'app/login/login.html',
        controller: 'loginController',
        controllerAs: 'vm'
      })
      .when('/quantumStatus', {
        templateUrl: 'app/quantumStatus/quantumStatus.html',
        controller: 'quantumStatusController',
        controllerAs: 'vm'
      })
      .when('/quantumStatus/:swType', {
        templateUrl: 'app/quantumStatus/quantumStatus.html',
        controller: 'quantumStatusController',
        controllerAs: 'vm'
      })
      .when('/quantumHardwareTest', {
        templateUrl: 'app/quantumHardwareTest/quantumHardwareTest.html',
        controller: 'quantumHardwareTestController',
        controllerAs: 'vm'
      })
      .when('/quantumHardwareTest/:id', {
        templateUrl: 'app/quantumHardwareTest/quantumHardwareTest.html',
        controller: 'quantumHardwareTestController',
        controllerAs: 'vm'
      })
      .when('/receiveProduct', {
        templateUrl: 'app/receiveProduct/receiveProduct.html',
        controller: 'receiveProductController',
        controllerAs: 'vm'
      })
      .when('/productTest/:id', {
        templateUrl: 'app/productTest/productTest.html',
        controller: 'productTestController',
        controllerAs: 'vm'
      })
      .when('/productTest/:product_id/:serial_id', {
        templateUrl: 'app/productTest/productTest.html',
        controller: 'productTestController',
        controllerAs: 'vm'
      })
      .when('/productPricing', {
        templateUrl: 'app/productPricing/productPricing.html',
        controller: 'productPricingController',
        controllerAs: 'vm'
      })
      .when('/receiveProductDetail/:poId/:lineItemId/:poNumber', {
        templateUrl: 'app/receiveProductDetail/receiveProductDetail.html',
        controller: 'receiveProductDetailController',
        controllerAs: 'vm'
      })
      .when('/rmaCustomerCreate', {
        templateUrl: 'app/rmaCustomer/rmaCustomerCreate.html',
        controller: 'rmaCustomerController',
        controllerAs: 'vm'
      })
      .when('/rmaCustomerSearch/:id', {
        templateUrl: 'app/rmaCustomer/rmaCustomerSearch.html',
        controller: 'rmaCustomerController',
        controllerAs: 'vm'
      })
      .when('/rmaDCSTest', {
        templateUrl: 'app/rmaDCSTest/rmaDCSTest.html',
        controller: 'rmaDCSTestController',
        controllerAs: 'vm'
      })
      .when('/rmaPCTest', {
        templateUrl: 'app/rmaPCTest/rmaPCTest.html',
        controller: 'rmaPCTestController',
        controllerAs: 'vm'
      })
      .when('/purchaseOrderDetail/:id/:poNumber', {
        templateUrl: 'app/purchaseOrderDetail/purchaseOrderDetail.html',
        controller: 'purchaseOrderDetailController',
        controllerAs: 'vm'
      })
      .when('/report-install-landing', {
        templateUrl: 'app/report-install-landing/report-install-landing.html',
        controller: 'reportInstallLandingController',
        controllerAs: 'vm'
      })
      .when('/report-install-quote', {
        templateUrl: 'app/report-install-quote/report-install-quote.html',
        controller: 'reportInstallQuoteController',
        controllerAs: 'vm'
      })
      .when('/report-transaction/:id', {
        templateUrl: 'app/reportTransaction/report-transaction.html',
        controller: 'reportTransactionController',
        controllerAs: 'vm'
      })
      .when('/report-procurement-serial-number', {
        templateUrl: 'app/report-procurement-serial-number/report-procurement-serial-number.html',
        controller: 'reportProcurementSerialNumberController',
        controllerAs: 'vm'
      })
      .when('/report-procurement-purchase-order/:id', {
        templateUrl: 'app/report-procurement-purchase-order/report-procurement-purchase-order.html',
        controller: 'reportProcurementPurchaseOrderController',
        controllerAs: 'vm'
      })
      .when('/report-procurement-build-request/:id', {
        templateUrl: 'app/report-procurement-build-request/report-procurement-build-request.html',
        controller: 'reportProcurementBuildRequestController',
        controllerAs: 'vm'
      })
      .when('/report-procurement-on-hand', {
        templateUrl: 'app/report-procurement-on-hand/report-procurement-on-hand.html',
        controller: 'reportProcurementOnHandController',
        controllerAs: 'vm'
      })
      .when('/report-procurement-required-sub-parts', {
        templateUrl: 'app/report-procurement-required-sub-parts/report-procurement-required-sub-parts.html',
        controller: 'reportProcurementRequiredSubParts',
        controllerAs: 'vm'
      })
      .when('/report-procurement-forecast', {
        templateUrl: 'app/report-procurement-forecast/report-procurement-forecast.html',
        controller: 'reportProcurementForecastController',
        controllerAs: 'vm'
      })
      .when('/report-procurement-landing', {
        templateUrl: 'app/report-procurement-landing/report-procurement-landing.html',
        controller: 'reportProcurementLandingController',
        controllerAs: 'vm'
      })
      .when('/report-sales-landing', {
        templateUrl: 'app/report-sales-landing/report-sales-landing.html',
        controller: 'reportSalesLandingController',
        controllerAs: 'vm'
      })
      .when('/report-sales-yearly', {
        templateUrl: 'app/report-sales-yearly/report-sales-yearly.html',
        controller: 'reportSalesYearlyController',
        controllerAs: 'vm'
      })
      .when('/report-sales-individual', {
        templateUrl: 'app/report-sales-individual/report-sales-individual.html',
        controller: 'reportSalesIndividualController',
        controllerAs: 'vm'
      })
      .when('/report-sales-territory', {
        templateUrl: 'app/report-sales-territory/report-sales-territory.html',
        controller: 'reportSalesTerritoryController',
        controllerAs: 'vm'
      })
      .when('/report-sales-third-party', {
        templateUrl: 'app/report-sales-third-party/report-sales-third-party.html',
        controller: 'reportSalesThirdPartyController',
        controllerAs: 'vm'
      })
      .when('/report-sales-invoice', {
        templateUrl: 'app/report-sales-invoice/report-sales-invoice.html',
        controller: 'reportSalesInvoice',
        controllerAs: 'vm'
      })
      .when('/supportAdminLinux', {
        templateUrl: 'app/supportAdminLinux/supportAdminLinux.html',
        controller: 'supportAdminLinuxController',
        controllerAs: 'vm'
      })
      .when('/report-technical-landing', {
        templateUrl: 'app/report-technical-landing/report-technical-landing.html',
        controller: 'reportTechnicalLandingController',
        controllerAs: 'vm'
      })
      .when('/report-technical-allowed', {
        templateUrl: 'app/report-technical-allowed/report-technical-allowed.html',
        controller: 'reportTechnicalAllowedController',
        controllerAs: 'vm'
      })
      .when('/salesAdminGoals', {
        templateUrl: 'app/salesAdminGoals/salesAdminGoals.html',
        controller: 'salesAdminGoalsController',
        controllerAs: 'vm'
      })
      .when('/salesAdminReps', {
        templateUrl: 'app/salesAdminReps/salesAdminReps.html',
        controller: 'salesAdminRepsController',
        controllerAs: 'vm'
      })
      .when('/salesAdminTerritories', {
        templateUrl: 'app/salesAdminTerritories/salesAdminTerritories.html',
        controller: 'salesAdminTerritoriesController',
        controllerAs: 'vm'
      })
      .when('/salesAdminOwnerUpdate', {
        templateUrl: 'app/salesAdminOwnerUpdate/salesAdminOwnerUpdate.html',
        controller: 'salesAdminOwnerUpdateController',
        controllerAs: 'vm'
      })
      .when('/salesAdminProduction', {
        templateUrl: 'app/salesAdminProduction/salesAdminProduction.html',
        controller: 'salesAdminProductionController',
        controllerAs: 'vm'
      })
      //Estimator
      .when('/estimatorHome', {
        templateUrl: 'app/estimatorHome/homeDisplay.html'
      })
      .when('/estimatorStartNewEstimate', {
        templateUrl: 'app/estimatorStartNewEstimate/startNewEstimate.html',
        controller: 'startNewEstimateController',
        controllerAs: 'vm'
      })
      .when('/estimatorFindEstimate', {
        templateUrl: 'app/estimatorFindEstimate/findEstimate.html',
        controller: 'findEstimateController',
        controllerAs: 'vm'
      })
      .when('/estimateBuilder/:id/:systemType', {
        templateUrl: 'app/estimatorBuilder/estimateBuilder.html',
        controller: 'estimateBuilderController',
        controllerAs: 'vm'
      })
      .when('/subContractorList', {
        templateUrl: 'app/subContractorList/subContractorList.html',
        controller: 'subContractorListController',
        controllerAs: 'vm'
      })
      .when('/subContractorUser', {
        templateUrl: 'app/subContractorUsers/subContractorUser.html',
        controller: 'subContractorUserController',
        controllerAs: 'vm'
      })
      .when('/tasks', {
        templateUrl: 'app/tasks/tasks.html',
        controller: 'tasksController',
        controllerAs: 'vm'
      })
      .when('/tasks-ecr', {
        templateUrl: 'app/tasks/tasksEcr.html',
        controller: 'tasksController',
        controllerAs: 'vm'
      })
      .when('/tasks-ecr/:id', {
        templateUrl: 'app/tasks/tasksEcr.html',
        controller: 'tasksController',
        controllerAs: 'vm'
      })
      .when('/adminSettings', {
        templateUrl: 'app/adminSettings/adminSettings.html',
        controller: 'adminSettingsController',
        controllerAs: 'vm'
      })
      .when('/changePassword', {
        templateUrl: 'app/changePassword/changePassword.html',
        controller: 'changePasswordController',
        controllerAs: 'vm'
      })
      .when('/startNewDealerEstimate',{
        templateUrl: 'app/estimatorStartDealerEstimate/startNewDealerEstimate.html',
        controller: 'startNewDealerEstimateController',
        controllerAs: 'vm'
      })
      .when('/buildDealerEstimate/:estimate_id',{
        templateUrl: 'app/estimatorBuildDealerEstimate/buildDealerEstimate.html',
        controller: 'buildDealerEstimateController',
        controllerAs: 'vm'
      })
      .when('/findDealerEstimate',{
        templateUrl: 'app/estimatorFindDealerEstimate/findDealerEstimate.html',
        controller: 'findDealerEstimateController',
        controllerAs: 'vm'
      })
      .when('/supportTicket',{
        templateUrl: 'app/supportTicket/supportTicketLanding.html',
        controller: 'supportTicketController',
        controllerAs: 'vm'
      })
      .when('/supportTicketUpdate/:id',{
        templateUrl: 'app/supportTicket/supportTicketUpdate.html',
        controller: 'supportTicketController',
        controllerAs: 'vm'
      })
      .when('/adminIssues',{
        templateUrl: 'app/adminIssue/adminIssue.html',
        controller: 'adminIssueController',
        controllerAs: 'vm'
      })
      .when('/report-ticket',{
        templateUrl: 'app/report-ticket/report-ticket.html',
        controller: 'reportTicketController',
        controllerAs: 'vm'
      })
      .when('/report-service-board',{
        templateUrl: 'app/report-service-board/report-service-board.html',
        controller: 'reportServiceBoardController',
        controllerAs: 'vm'
      })
      .when('/change-order-create',{
        templateUrl: 'app/changeOrderCreate/changeOrderCreate.html',
        controller: 'changeOrderCreateController',
        controllerAs: 'vm'
      })
      .when('/change-order-manage/:estimate_id/:co_id',{
        templateUrl: 'app/changeOrderManage/changeOrderManage.html',
        controller: 'changeOrderManageController',
        controllerAs: 'vm'
      })
      .when('/openOrderProductAllocation',{
        templateUrl: 'app/openOrderProductAllocation/openOrderProductAllocation.html',
        controller: 'openOrderProductAllocationController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

}) ();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('nocAngular')
    .constant('malarkey', malarkey)
    .constant('_',window._)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('nocAngular')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
     $httpProvider.interceptors.push('httpRequestInterceptor');

     // Remove the hash
     $locationProvider.html5Mode(true);
     //requireBase: false;

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 2000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }

})();

angular.module("nocAngular").run(["$templateCache", function($templateCache) {$templateCache.put("app/adminBuild/adminBuild.html","<script type=text/ng-template id=newPart.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Add Part to Build</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<tr>\n						<th>\n							Property\n						</th>\n						<th>\n							Value\n						</th>\n					</tr>\n				</thead>\n				<tbody>\n					<tr ng-if=\"!vm.searchedProductList\">\n						<td>Enter Part of the Part number you are looking for:</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchNewPart\"></td>\n						<td><button class=\"btn btn-primary\" ng-click=\"vm.searchParts()\">Search Products</button></td>\n					</tr>\n					<tr ng-if=\"vm.searchedProductList\">\n						<td>Part Number</td>\n						<td>\n							<ui-select ng-model=\"vm.newParts\">\n								<ui-select-match>{{$select.selected.name}} - ({{$select.selected.part_number}})</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"pn in vm.searchedProductList | filter:$select.search\" refresh-delay=\"300\">\n								{{pn.name}} - ({{pn.part_number}})\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n					<tr ng-if=\"vm.searchedProductList\">\n						<td>Quantity</td>\n						<td>\n							<input type=\"text\" class=\"form-control\" ng-model=\"vm.newPartQty\">\n						</td>\n					</tr>\n				</tbody>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.addPart()\">Save</button>\n    </div>\n	</div></script><script type=text/ng-template id=removePartConfirm.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Remove Part?</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      {{vm.modalPartDisplay}}\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.removePart(vm.modalPartId)\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=editPartConfirm.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Edit Part?</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-12\">{{vm.modalPartDisplay}}</span>\n			</div>\n			<div class=\"row\">\n				<span class=\"col-sm-4\">New Quantity</span> <span class=\"col-sm-6\"><input type=\"number\" class=\"form-control\" ng-model=\"vm.editPartQty\"></span>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.editPart()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=newBuildDialog.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">New Build</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-4\">Choose Part</span>\n				<span class=\"col-sm-8\">\n					<ui-select ng-model=\"vm.newBuild\">\n						<ui-select-match>{{$select.selected.name}}</ui-select-match>\n						<ui-select-choices class=\"ui-select-choices\" repeat=\"pn in vm.availableBuildParts | filter:$select.search\" refresh-delay=\"300\">\n						{{pn.part_number+\' - \'+pn.name}}\n						</ui-select-choices>\n					</ui-select>\n				</span>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.addBuild()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=copyBuildDialog.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Copy Parts Included in build</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-4\">Copy Parts From which Product?</span>\n				<span class=\"col-sm-8\">\n					<ui-select ng-model=\"vm.selectedCopy\">\n						<ui-select-match>{{$select.selected.product_data.name}} - ({{$select.selected.product_data.part_number}})</ui-select-match>\n						<ui-select-choices class=\"ui-select-choices\" repeat=\"pn in vm.currentBuilds | filter:$select.search\" refresh-delay=\"300\">\n							{{pn.product_data.name}} - ({{pn.product_data.part_number}})\n						</ui-select-choices>\n					</ui-select>\n				</span>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.copyBuild()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=removeConfirm.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Part No Longer Requires Building</h4>\n		</div>  \n	</div> \n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.removeBuild()\">Remove</button>\n    </div></script><div class=page-header><div><h1>Build Administration</h1></div></div><div ng-if=!vm.editing cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=row><div class=col-sm-5><div class=box><div class=box-title><h3><i class=\"fa fa-cogs\"></i>Builds</h3><span class=pull-right><button class=btn ng-click=vm.newBuildDialog()><i class=\"fa fa-plus\"></i></button></span></div><div class=box-content><div class=form-group><div class=input-group><input class=form-control ng-model=vm.searchValue ng-keypress=vm.resetSelect()><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Current Builds</th></tr></thead><tbody><tr dir-paginate=\"line in vm.currentBuilds | filter:vm.searchValue | itemsPerPage:12\" role=button ng-click=vm.populateDetails(line.id)><td ng-class={danger:line.contains_invalid_part}>{{line.product_data.part_number}} - {{line.product_data.name}}</td></tr><tr><td colspan=2 ng-if=!vm.currentBuilds.length>No Results Found</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Details</h3></div><div class=box-content><span ng-hide=vm.selectedBuildPartId>No Purchase Order Selected</span><table class=\"table table-hover\" ng-if=vm.selectedBuildPartId><thead><tr><th>Property</th><th>Value</th><th><button class=\"btn btn-primary pull-right\" ng-click=vm.populateEditor()>Edit Build</button></th><th><button class=\"btn btn-primary pull-right\" ng-click=vm.copyDialog()>Copy Build</button></th><th><button class=\"btn btn-danger pull-right\" ng-click=vm.confirmRemove()>Remove Build</button></th></tr></thead><tbody><tr><td>Cost</td><td colspan=1>{{vm.buildData.build_cost | currency}}</td><td colspan=3>* Calculated from the cost of parts in the build</td></tr><tr><td>List</td><td colspan=1>{{vm.product_information.price | currency}}</td><td colspan=3>* Price from the product table (should match Connectwise)</td></tr><tr><td>Date Created</td><td colspan=4>{{vm.buildData.date_created | date:\'medium\'}}</td></tr><tr><td>Part Count</td><td colspan=4>{{vm.included_parts.length}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=vm.editing cg-busy={promise:vm.editorPromise,delay:300,minDuration:1000}><div class=row><div class=col-sm-8><div class=box><div class=box-title><table class=\"table table-hover\"><tr><td><b>Product:</b></td><td>{{vm.buildData.product_data.name}}</td><td><b>Cost:</b></td><td>{{vm.buildData.build_cost | currency}}</td></tr><tr><td><b>Part Number:</b></td><td>{{vm.buildData.product_data.part_number}}</td><td><b>List:</b></td><td>{{vm.product_information.price | currency}}</td></tr><tr><td colspan=2><b>Estimated Time To Build (in minutes):</b></td><td><input class=form-control ng-model=vm.buildData.time_to_build></td><td><button class=\"btn btn-success\" ng-click=vm.updateBuild()>Update Build</button></td></tr><tr><td colspan=2><b>Labor Cost (per hour):</b></td><td><input class=form-control ng-model=vm.buildData.labor_cost></td><td><button class=\"btn btn-success\" ng-click=vm.updateBuild()>Update Build</button></td></tr></table></div></div></div><div class=col-sm-4><span class=pull-right><button class=btn ng-click=vm.backToBuild()>Back</button></span></div></div><div class=row><div class=col-sm-12><span class=pull-right ng-if=!vm.selectedUser><button class=btn ng-click=vm.newPartDialog()><i class=\"fa fa-plus\"></i></button></span></div><div class=box-content><table class=\"table table-hover\"><thead><tr><th>Part Count</th><th>Description</th><th>Quantity</th><th>Part #</th><th>Serialized</th><th>Vendor</th><th>Vendor Part #</th><th>Vendor Description</th><th>Unit Cost</th><th>Build Cost</th><th>Edit Row</th></tr></thead><tbody><tr ng-repeat=\"(key,line) in vm.included_parts\" ng-class={danger:line.product_data.inactive}><td><i class=\"fa fa-minus-circle text-danger\" ng-click=vm.removePartDialog(line.id,line.product_data.part_number,line.product_data.name)></i>{{key + 1}}</td><td>{{line.product_data.name}}</td><td>{{line.quantity}}</td><td>{{line.product_data.part_number}}</td><td>{{line.product_data.jnl_serialized?\'Y\':\'N\'}}</td><td>Vendor</td><td>Vendor Part #</td><td>Vendor Description</td><td>{{line.product_data.cost | currency}}</td><td>{{line.product_data.cost * line.quantity | currency}}</td><td><i class=\"fa fa-edit text-primary\" ng-click=vm.editPartDialog(line.id,line.product_data.part_number,line.product_data.name,line.transaction_id)></i></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/adminEstimator/adminEstimator.html","<script type=text/ng-template id=AddPart.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Add Part to System</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<table class=\"table\">\n				<tbody>\n					<tr ng-if=\"!vm.productList\">\n						<td>Enter Part of the Part number you are looking for:</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchValue\"></td>\n						<td><button class=\"btn btn-primary\" ng-click=\"vm.searchParts()\">Search Products</button></td>\n					</tr>\n					<tr ng-if=\"vm.productList\">\n						<th>Choose Part:</th>\n						<td><ui-select ng-model=\"vm.submit_obj.connectwise_id\">\n							<ui-select-match>{{$select.selected.name}} - ({{$select.selected.part_number}})</ui-select-match>\n							<ui-select-choices class=\"ui-select-choices\" repeat=\"product.connectwise_id as product in vm.productList | filter:$select.search\" refresh-delay=\"300\">\n								{{product.name}} - ({{product.part_number}})\n							</ui-select-choices>\n						</ui-select></td>\n					</tr>\n					<tr ng-if=\"vm.submit_obj.connectwise_id\">\n						<th>Choose Location:</th>\n						<td><ui-select ng-model=\"vm.submit_obj.location_id\" ng-change=\"vm.filterSubLocations()\">\n							<ui-select-match>{{$select.selected.location_description}}</ui-select-match>\n							<ui-select-choices class=\"ui-select-choices\" repeat=\"location.id as location in vm.all_part_locations | filter:$select.search\" refresh-delay=\"300\">\n								{{location.location_description}}\n							</ui-select-choices>\n						</ui-select></td>\n					</tr>\n					<tr ng-if=\"vm.availableSubs && vm.availableSubs.length > 0 && vm.submit_obj.connectwise_id\">\n						<th>Choose Sub Location:</th>\n						<td><ui-select ng-model=\"vm.submit_obj.sub_location_id\">\n							<ui-select-match>{{$select.selected.description}}</ui-select-match>\n							<ui-select-choices class=\"ui-select-choices\" repeat=\"location.id as location in vm.availableSubs | filter:$select.search\" refresh-delay=\"300\">\n								{{location.description}}\n							</ui-select-choices>\n						</ui-select></td>\n					</tr>\n					<tr ng-if=\"vm.submit_obj.connectwise_id\">\n						<th>Add to multiple System Types</th>\n						<td><input type=\"checkbox\" class=\"form-control\" ng-model=\"vm.add_multiple\" ng-change=\"vm.handle_multiple()\" value=\"\"></td>\n					</tr>\n					<tr ng-if=\"vm.add_multiple && vm.submit_obj.connectwise_id\">\n						<th>Add to these system types as well</th>\n						<td>\n							<ui-select multiple ng-model=\"vm.submit_obj.system_type\">\n							<ui-select-match>{{$item.name}}</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"system_type.id as system_type in vm.system_types | filter:$select.search\">\n									{{system_type.name}}\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n				</tbody>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveProduct()\" ng-disabled=\"!vm.validSelections()\">Save Product</button>\n    </div>\n	</div></script><div class=page-header><div><h1><i class=\"fa fa-dollar\"></i><i class=\"fa fa-dollar\"></i><i class=\"fa fa-dollar\"></i> Estimator Administration</h1></div></div><div class=box cg-busy=\"{promise:vm.userPromise,message:\'Loading\',delay:300,minDuration:1000}\"><div class=box-content><div ng-if=!vm.page_loaded class=row><table class=table><th style=width:20%>Title</th><th>Description</th><tr ng-click=\"vm.load(\'systems\')\" style=\"cursor: pointer\"><td>System Parts and Locations</td><td>Add Parent Parts to a system type(s) in the estimator</td></tr><tr ng-click=\"vm.load(\'paging\')\" style=\"cursor: pointer\"><td>Paging Options</td><td>Assign an antenna and license to paging base if needed</td></tr><tr ng-click=\"vm.load(\'scopes\')\" style=\"cursor: pointer\"><td>Canned Messages</td><td>Scope of work for each system type</td></tr></table></div><div ng-if=\"vm.page_loaded == \'systems\'\" class=row><div class=col-lg-4><span>Choose System to View</span><span><select class=form-control ng-model=vm.system_id ng-change=vm.load_system() ng-options=\"sys.id as sys.name for sys in vm.system_types\"></select></span></div><div ng-if=vm.system_id class=col-lg-8><button class=\"btn btn-danger pull-right\" ng-click=vm.remove_system()>Make System Type Inactive</button></div><table class=table ng-if=vm.system_id><thead><th><i class=\"fa fa-plus-circle text-success top7\" aria-hidden=true ng-click=vm.loadModal()></i><span class=left5>Part Number</span></th><th>Product</th><th>Location</th><th>Sub Location</th></thead><tbody ng-repeat=\"location in vm.all_part_locations\"><tr style=\"background-color: #2C5E7B; color: white\"><td>{{location.location_description}}</td><td></td><td></td><td></td></tr><tr ng-repeat=\"part in vm.systemParts\" ng-if=\"part.part_location == location.id\"><td><i class=\"fa fa-minus-circle text-danger top7\" aria-hidden=true ng-click=vm.removePart(part.id)></i><span class=left5>{{part.product_part_number}}</span></td><td>{{part.product_description}}</td><td>{{location.location_description}}</td><td>{{part.sub_location_description}}</td></tr></tbody></table></div><div ng-if=\"vm.page_loaded == \'scopes\'\" class=row><div class=col-lg-4><span>Choose System to View</span><span><select class=form-control ng-model=vm.system_id ng-change=vm.load_system() ng-options=\"sys.id as sys.name for sys in vm.system_types\"></select></span></div><div class=col-lg-5><button class=\"btn btn-success pull-right\" ng-click=vm.save_canned_message()>Save</button></div><div class=\"col-lg-3 pull-right\"></div><!-- <table class=\"table\" ng-if=\"vm.system_id\">\n				<thead>\n					<th><i class=\'fa fa-plus-circle text-success top7\' aria-hidden=\"true\" ng-click=\"vm.loadModal()\"></i><span class=\"left5\">Part Number</span></th>\n					<th>Product</th>\n					<th>Location</th>\n					<th>Sub Location</th>\n				</thead>\n				<tbody ng-repeat=\"location in vm.all_part_locations\">\n					<tr style=\"background-color: #2C5E7B; color: white;\">\n						<td>{{location.location_description}}</td>\n						<td></td>\n						<td></td>\n						<td></td>\n					</tr>\n					<tr ng-repeat=\"part in vm.systemParts\" ng-if=\"part.part_location == location.id\">\n						<td><i class=\'fa fa-minus-circle text-danger top7\' aria-hidden=\"true\" ng-click=\"vm.removePart(part.id)\"></i><span class=\"left5\">{{part.product_part_number}}</span></td>\n						<td>{{part.product_description}}</td>\n						<td>{{location.location_description}}</td>\n						<td>{{part.sub_location_description}}</td>\n					</tr>\n				</tbody>\n			</table> --><div class=row ng-if=vm.system_id><div class=\"col-lg-12 top10\"><textarea class=\"msd-elastic: \\n;\" style=\"width: 80%\" ng-model=vm.canned_obj.message></textarea></div></div></div></div></div>");
$templateCache.put("app/adminIssue/adminIssue.html","<script type=text/ng-template id=addItem.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">New {{vm.addObject.title}}</h4>\n		</div>\n		<div class=\"modal-body\">\n			<div class=\"row\">\n				<div class=\"col-lg-1 col-md-1 col-sm-2 top7\">\n					Name:\n				</div>\n				<div class=\"col-lg-6 col-md-6 col-sm-8\">\n					<input type=\"text\" class=\"form-control\" ng-model=\"vm.addObject.name\">\n				</div>\n			</div>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveItem()\" ng-disabled=\"!vm.addObject.name\">Save</button>\n  	</div>\n	</div></script><div class=page-header><div><h1>Issue Administration</h1></div></div><div class=row><div class=col-sm-12><ul class=\"nav nav-tabs\"><li ng-class=\"{active:vm.pageView ==3}\"><a href=# ng-click=\"vm.pageView = 3\">Issue Options</a></li><!-- <li><a href=\"#\">Menu 3</a></li> --></ul></div></div><div class=row ng-if=\"vm.pageView == 3\"><div class=col-sm-12><ul class=\"nav nav-tabs my_nav\"><li ng-class=\"{\'active\':vm.subPage ==1}\"><a href=# ng-click=\"vm.subPage = 1\">Class / Action Options</a></li><li ng-class=\"{\'active\':vm.subPage ==2}\"><a href=# ng-click=\"vm.subPage = 2\">Resolution Options</a></li></ul></div></div><!-- <div class=\"row\" ng-show=\"vm.pageView == 1\">\n	<div class=\"col-sm-4\">\n		<div class=\"box\">\n			<div class=\"box-title\">\n				<h3>\n					<i class=\"fa fa-cogs\"></i>Boards\n				</h3>\n			</div>\n			<div class=\"box-content\">\n				<table class=\"table table-hover\">\n					<thead>\n						<tr>\n							<th>ID</th>\n							<th>Name</th>\n						</tr>\n					</thead>\n					<tbody>\n						<tr ng-repeat=\"board in vm.boards\">\n							<td>{{board.id}}</td>\n							<td>{{board.name}}</td>\n						</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n	</div>\n	<div class=\"col-sm-4\">\n		<div class=\"box\">\n			<div class=\"box-title\">\n				<h3>\n					<i class=\"fa fa-cogs\"></i>Types\n				</h3>\n			</div>\n			<div class=\"box-content\">\n				<table class=\"table table-hover\">\n					<thead>\n						<tr>\n							<th>ID</th>\n							<th>Name</th>\n						</tr>\n					</thead>\n					<tbody>\n						<tr ng-repeat=\"type in vm.types\">\n							<td>{{type.id}}</td>\n							<td>{{type.name}}</td>\n						</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n	</div>\n	<div class=\"col-sm-4\">\n		<div class=\"box\">\n			<div class=\"box-title\">\n				<h3>\n					<i class=\"fa fa-cogs\"></i>Statuses\n				</h3>\n			</div>\n			<div class=\"box-content\">\n				<table class=\"table table-hover\">\n					<thead>\n						<tr>\n							<th>ID</th>\n							<th>Name</th>\n						</tr>\n					</thead>\n					<tbody>\n						<tr ng-repeat=\"sta in vm.statuses\">\n							<td>{{sta.id}}</td>\n							<td>{{sta.name}}</td>\n						</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n	</div>\n</div> --><!-- TIME OPTIONS --><!-- <div class=\"row\" ng-show=\"vm.pageView == 2\">\n	<div class=\"col-sm-4\">\n		<div class=\"box\">\n			<div class=\"box-title\">\n				<h3>\n					<i class=\"fa fa-cogs\"></i>Roles\n				</h3>\n			</div>\n			<div class=\"box-content\">\n				<table class=\"table table-hover\">\n					<thead>\n						<tr>\n							<th>ID</th>\n							<th>Name</th>\n						</tr>\n					</thead>\n					<tbody>\n						<tr ng-repeat=\"role in vm.timeRoles\">\n							<td>{{role.id}}</td>\n							<td>{{role.name}}</td>\n						</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n	</div>\n	<div class=\"col-sm-4\">\n		<div class=\"box\">\n			<div class=\"box-title\">\n				<h3>\n					<i class=\"fa fa-cogs\"></i>Types\n				</h3>\n			</div>\n			<div class=\"box-content\">\n				<table class=\"table table-hover\">\n					<thead>\n						<tr>\n							<th>ID</th>\n							<th>Name</th>\n						</tr>\n					</thead>\n					<tbody>\n						<tr ng-repeat=\"type in vm.timeTypes\">\n							<td>{{type.id}}</td>\n							<td>{{type.name}}</td>\n						</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n	</div>\n</div> --><!-- ISSUE OPTIONS --><div class=row ng-show=\"vm.pageView == 3\"><div ng-if=\"vm.subPage==1\"><div class=col-sm-4><div class=box><div class=box-title><h3><i class=\"fa fa-cogs\"></i>Top Level Category (Class)</h3><span class=pull-right><button class=btn ng-click=\"vm.addFunction(\'class\')\"><i class=\"fa fa-plus\"></i></button></span></div><div class=box-content><div class=form-group><div class=input-group><input class=form-control ng-model=vm.searchValue ng-keypress=vm.resetSelect()><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Current Top Levels</th><th>Available</th><th></th></tr></thead><tbody><tr ng-repeat=\"(k,line) in vm.top_levels | filter:{name:vm.searchValue} | filter:{id:vm.editId}:true\"><td ng-class={danger:line.invalid} role=button ng-click=vm.loadTopLevel(line.id)>{{line.name}}</td><td><input type=checkbox ng-model=line.active ng-change=vm.updateTopLevel(k)></td><td ng-if=\"line.id == vm.activeId && !vm.editActive\"><button class=btn type=button ng-click=vm.edit(line.id)>Edit</button></td><td ng-if=\"line.id == vm.activeId && vm.editActive\"><button class=btn type=button>Save Changes</button></td><td ng-if=\"line.id != vm.activeId\"></td></tr><tr><td colspan=2 ng-if=!vm.top_levels.length>No Results Found</td></tr></tbody></table><!-- <div class=\"center-pagination\">\n						<dir-pagination-controls></dir-pagination-controls>\n					</div> --></div></div></div><div class=col-sm-4><div class=box><div class=box-title><h3><i class=\"fa fa-cogs\"></i>Second Level Category (Issue / Action)</h3><span class=pull-right><button class=btn ng-click=\"vm.addFunction(\'action\')\"><i class=\"fa fa-plus\"></i></button></span></div><div class=box-content><div class=form-group><div class=input-group><input class=form-control ng-model=vm.searchValue ng-keypress=vm.resetSelect()><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Current Second Levels</th></tr></thead><tbody><tr dir-paginate=\"line in vm.second_levels | itemsPerPage:15\" role=button><td ng-class={danger:line.invalid}><input type=checkbox ng-model=line.assigned ng-click=vm.save(line.id,line.assigned) ng-disabled=!vm.editActive>{{line.name}}</td></tr><tr><td colspan=2 ng-if=!vm.second_levels.length>No Results Found</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div></div><div ng-if=\"vm.subPage==2\"><div class=col-sm-4><div class=box><div class=box-title><h3><i class=\"fa fa-cogs\"></i>Resolution</h3><span class=pull-right><button class=btn ng-click=\"vm.addFunction(\'resolution\')\"><i class=\"fa fa-plus\"></i></button></span></div><div class=box-content><div class=form-group><div class=input-group><input class=form-control ng-model=vm.resolutionSearchValue ng-keypress=vm.resolutionSearch()><div class=input-group-btn><button class=btn type=button ng-click=vm.clearResolutionSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Resolutions</th><th>Available</th></tr></thead><tbody><tr dir-paginate=\"(k,line) in vm.resolutions | itemsPerPage:15\" role=button><td>{{line.name}}</td><td><input type=checkbox ng-model=line.active ng-change=vm.updateResolution(k)></td></tr><tr><td colspan=2 ng-if=!vm.resolutions.length>No Results Found</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div></div></div>");
$templateCache.put("app/adminRMA/adminRMA.html","<div class=page-header><div><h1>RMA Administration</h1></div></div><div cg-busy={promise:vm.reasonPromise,minDuration:1000}><div class=row><!-- LEFT PANE WHEN PART IS NOT SELECTED --><div class=col-sm-5 ng-hide=vm.productEdit><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>RMA Problem Descriptions</h3><span class=pull-right><button class=btn ng-click=vm.newReason()><i class=\"fa fa-plus pull-right\"></i></button></span></div><div class=box-content><div class=form-group><div class=input-group><input class=form-control ng-model=vm.searchValue ng-keypress=vm.resetSelect()><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><tbody><tr dir-paginate=\"line in vm.currentReasons | filter:{reason:vm.searchValue} | itemsPerPage:12\" role=button ng-click=vm.populateDetails(line.id)><td><span>{{line.reason}}</span></td></tr><tr><td colspan=2 ng-if=!vm.currentReasons.length>No Results Found</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i>Details</h3><div><button class=\"btn pull-right\" ng-click=vm.cancelEdit()>Cancel</button> <button class=\"btn btn-success pull-right\" ng-disabled=!vm.workingObject.reason ng-click=vm.saveReason()>Save</button></div></div><div class=box-content><div class=row><span class=col-sm-4><label>Product(s)</label></span><span class=col-sm-8><ui-select multiple ng-model=vm.workingObject.product ng-change=vm.part_selected($select.selected)><ui-select-match>{{$item.part_number}} - {{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"pn.id as pn in vm.availablePNs | filter:$select.search\" refresh-delay=300>{{pn.part_number}} - {{pn.name}}</ui-select-choices></ui-select></span></div><div class=row><span class=\"col-sm-4 top7\"><label>Available For Reason?</label></span><span class=\"col-sm-8 top7\"><input type=checkbox ng-model=vm.workingObject.available_for_reason></span></div><div class=row><span class=\"col-sm-4 top7\"><label>Available For Repair?</label></span><span class=\"col-sm-8 top7\"><input type=checkbox ng-model=vm.workingObject.available_for_repair></span></div><div class=row><span class=\"col-sm-4 top7\"><label>Description</label></span><span class=\"col-sm-8 top7\"><textarea ng-model=vm.workingObject.reason rows=4 cols=60></textarea></span></div></div></div></div></div></div>");
$templateCache.put("app/adminProduct/adminProduct.html","<script type=text/ng-template id=AddPart.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Proposal Details</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<table class=\"table\">\n				<tbody>\n					<tr ng-if=\"!vm.extendedProductList\">\n						<td>Enter Part of the Part number you are looking for:</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchExtended\"></td>\n						<td><button class=\"btn btn-primary\" ng-click=\"vm.searchExtendedParts()\">Search Products</button></td>\n					</tr>\n					<tr ng-if=\"vm.extendedProductList\">\n						<th>Choose Part:</th>\n						<td><ui-select ng-model=\"vm.addExtendedPart.part_number\">\n							<ui-select-match>{{$select.selected.name}} - ({{$select.selected.part_number}})</ui-select-match>\n							<ui-select-choices class=\"ui-select-choices\" repeat=\"product.part_number as product in vm.extendedProductList | filter:$select.search\" refresh-delay=\"300\">\n								{{product.name}} - ({{product.part_number}})\n							</ui-select-choices>\n						</ui-select></td>\n					</tr>\n					<tr ng-if=\"vm.extendedProductList\">\n						<th>Multiplier</th>\n						<td><input type=\"number\" class=\"form-control\" ng-model=\"vm.addExtendedPart.value\" value=\"\"></td>\n					</tr>\n				</tbody>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveProduct()\">Save Product</button>\n    </div>\n	</div></script><script type=text/ng-template id=addRelatedPart.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">{{vm.action}} Related Part: {{vm.selectedProduct.general.name.value}}</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<table class=\"table\">\n				<tbody>\n					<tr ng-if=\"!vm.relatedProductList && vm.action == \'Add\'\">\n						<td>Enter Part of the Part number you are looking for:</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchRelated\"></td>\n						<td><button class=\"btn btn-primary\" ng-click=\"vm.searchRelatedParts()\">Search Products</button></td>\n					</tr>\n					<tr ng-if=\"vm.action == \'Add\' && vm.relatedProductList\">\n						<th>Choose Part:</th>\n						<td><ui-select ng-model=\"vm.related_part_obj.connectwise_id\">\n							<ui-select-match>{{$select.selected.name}} - ({{$select.selected.part_number}})</ui-select-match>\n							<ui-select-choices class=\"ui-select-choices\" repeat=\"product.connectwise_id as product in vm.relatedProductList | filter:$select.search\" refresh-delay=\"300\">\n								{{product.name}} - ({{product.part_number}})\n							</ui-select-choices>\n						</ui-select></td>\n					</tr>\n					<tr ng-if=\"vm.action == \'Add\' && vm.relatedProductList\">\n						<th>Quantity</th>\n						<td><input type=\"number\" class=\"form-control\" ng-model=\"vm.related_part_obj.qty\" value=\"\"></td>\n					</tr>\n					<tr ng-if=\"(vm.action == \'Add\' && vm.relatedProductList) || vm.action == \'Remove\'\">\n						<th>{{vm.action}} part to all currently assigned system types</th>\n						<td><input type=\"checkbox\" class=\"form-control\" ng-model=\"vm.related_part_obj.all\" value=\"\"></td>\n					</tr>\n				</tbody>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button ng-if=\"vm.action == \'Add\'\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveRelatedPart()\">Add</button>\n			<button ng-if=\"vm.action == \'Remove\'\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.removeRelatedPart()\">Remove</button>\n    </div>\n	</div></script><div class=page-header><div><h1>Product Administration</h1></div></div><div><div class=row><!-- LEFT PANE WHEN PART IS NOT SELECTED --><div class=col-sm-5 ng-hide=vm.productEdit><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>Product List</h3></div><div class=box-content><div class=form-group><div class=input-group><select class=form-control ng-model=vm.searchFor><option value=part_number>Part Number</option><option value=name>Product Name</option></select><div class=input-group-btn><button class=btn type=button ng-click=vm.load_data() ng-disabled=vm.productEdit><i class=\"fa fa-search text-muted\"></i></button></div></div></div><div class=form-group><div class=input-group><input class=form-control ng-model=vm.searchValue ng-keypress=vm.resetSelect() ng-disabled=vm.productEdit><div class=input-group-btn><button class=btn type=button ng-click=vm.load_data() ng-disabled=vm.productEdit><i class=\"fa fa-search text-muted\"></i></button></div><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch() ng-disabled=vm.productEdit><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Products</th></tr></thead><tbody><!-- <tr dir-paginate=\"(index,object) in vm.readyForBuild.data | itemsPerPage:vm.num_results\" current-page=\"vm.currentPage\" total-items=\"vm.readyForBuild.count\" ng-click=\"vm.loadBuildRequestDetail(object.id)\" style=\"cursor: pointer;\"></tr> --><tr dir-paginate=\"(key,line) in vm.productList.data | itemsPerPage:10\" role=button ng-click=vm.populateDetails(key) total-items=vm.productList.count current-page=vm.currentPage><td>{{line.part_number}} - {{line.name}}</td></tr><tr><td colspan=2 ng-if=!vm.productList.data.length>No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.productList.data.length}} of {{vm.productList.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div></div></div><!-- LEFT PANE WHEN PART IS SELECTED --><div class=col-sm-5 ng-show=vm.productEdit><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>Product - {{vm.selectedProduct.part_number}}</h3></div><div class=box-content><table class=\"table table-hover\"><thead><tr><th>Configuration</th></tr></thead><tbody><tr ng-click=vm.changeView(0) role=button><td>General Properties</td></tr><tr ng-click=vm.changeView(1) role=button><td>Production / Build</td></tr><tr ng-click=vm.changeView(2) role=button><td>Estimator</td></tr><tr ng-click=vm.changeView(3) role=button><td>Extended Parts (additional quantities)</td></tr></tbody></table></div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Details</h3><div ng-if=vm.productEdit><button class=\"btn pull-right\" ng-click=vm.cancelEdit()>Cancel</button> <button class=\"btn btn-success pull-right\" ng-click=vm.saveProduct()>Save</button></div></div><div class=box-content><span ng-hide=vm.selectedProduct>No Product Selected</span><table class=\"table table-hover\" ng-if=vm.selectedProduct><thead><tr><th width=50%>Property</th><th>Value <span ng-if=vm.activeList class=pull-right><button class=\"btn btn-primary\" ng-click=vm.addExtended()>Add Extended Part</button></span></th></tr></thead><tbody ng-if=\"vm.page_id == 0\"><tr><td>Product Name</td><td>{{vm.selectedProduct.name}}</td></tr><tr><td>Cost</td><td>{{vm.selectedProduct.cost}}</td></tr><tr><td>Price</td><td>{{vm.selectedProduct.price}}</td></tr><tr><td>Inactive</td><td><input type=checkbox ng-model=vm.selectedProduct.inactive></td></tr><tr><td>Updated By</td><td>{{vm.selectedProduct.updated_by}}</td></tr><tr><td>Last Updated</td><td>{{vm.selectedProduct.last_update | date:\'medium\'}}</td></tr><tr><td>Available For RMA</td><td><input type=checkbox ng-model=vm.selectedProduct.rma_enabled></td></tr></tbody><tbody ng-if=\"vm.page_id == 1\"><tr><td>JNL Serializes Part</td><td><input type=checkbox ng-model=vm.selectedProduct.jnl_serialized></td></tr><tr><td>JNL Builds Part</td><td><input type=checkbox ng-model=vm.selectedProduct.jnl_build></td></tr><tr><td>Requires Pull Cord Test (Is a Pull Cord)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_pull_cord></td></tr><tr><td>Requires Door (DCS) Test (Is a Quantum Door)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_dcs_unit ng-change=vm.checkForTestChange()></td></tr><tr><td>Requires Enrollment Test (Is a TES)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_enrollment ng-change=vm.checkForTestChange()></td></tr><tr><td>Requires QSM Test (Is a QSM)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_qsm ng-change=vm.checkForTestChange()></td></tr><tr><td>Requires IO Repeater Test (Is an IO Repeater)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_io_repeater ng-change=vm.checkForTestChange()></td></tr><tr><td>Requires Stand Alone Test (Is a Stand Alone Unit)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_sad ng-change=vm.checkForTestChange()></td></tr><tr><td>Requires Text to Speech Test (Is a TTS)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_tts ng-change=vm.checkForTestChange()></td></tr><tr><td>Requires Tag Test (Is a Quantum Wander Tag)</td><td><input type=checkbox ng-model=vm.selectedProduct.is_tag></td></tr></tbody><tbody ng-if=\"vm.page_id == 1 && vm.has_test && vm.hardware_test\"><tr><th colspan=2>Test Requirements</th></tr><tr><td>Bluetooth</td><td><input type=checkbox ng-model=vm.requirement_object.bluetooth></td></tr><tr><td>Inputs</td><td><input type=checkbox ng-model=vm.requirement_object.inputs></td></tr><tr><td>Outputs</td><td><input type=checkbox ng-model=vm.requirement_object.outputs></td></tr><tr><td>Screen</td><td><input type=checkbox ng-model=vm.requirement_object.screen></td></tr><tr><td>Sounder</td><td><input type=checkbox ng-model=vm.requirement_object.sound></td></tr><tr><td>Wiegand</td><td><input type=checkbox ng-model=vm.requirement_object.wiegand></td></tr></tbody><tbody ng-if=\"vm.page_id == 1 && vm.has_test && vm.pull_cord_test\"><tr><th colspan=2>Test Requirements</th></tr><tr><td>Alarm</td><td><input type=checkbox ng-model=vm.requirement_object.alarm></td></tr><tr><td>Staff Assist</td><td><input type=checkbox ng-model=vm.requirement_object.staff></td></tr><tr><td>Check In</td><td><input type=checkbox ng-model=vm.requirement_object.checkin></td></tr></tbody><tbody ng-if=\"vm.page_id == 2\"><tr><td>Hours</td><td><input type=number ng-model=vm.selectedProduct.hours></td></tr><tr><td>Dealer Assistance</td><td><input type=checkbox ng-model=vm.selectedProduct.is_dealer_assistance></td></tr></tbody><tbody ng-if=\"vm.activeList && vm.page_id == 3\"><tr ng-repeat=\"(key,value) in vm.activeList\"><td><i class=\"fa fa-minus-circle text-danger top7 left5\" aria-hidden=true ng-click=vm.removeExtended(key)></i>{{value.name}} ({{value.part_number}})</td><td><input class=form-control type=number ng-model=value.value></td></tr></tbody></table></div></div></div><div class=col-sm-12><table class=table ng-if=\"vm.page_id == 2\"><thead><tr><th style=width:33%>Systems Part is Included</th><th>Location</th><th>Sub Location</th></tr></thead><tbody><tr ng-repeat-start=\"value in vm.estimate_systems_data\"><td><span><i class=\"fa fa-plus-circle text-success top7\" aria-hidden=true ng-click=vm.modify_related(value.system_id,value.id,true)></i></span><span class=left5>{{value.system_description}}</span></td><td>{{value.location_description}}</td><td>{{value.sub_location_description}}</td></tr><tr ng-repeat-end ng-repeat=\"rp in value.related_parts\"><td colspan=3><span><i class=\"fa fa-minus-circle text-danger top7 left5\" aria-hidden=true ng-click=\"vm.modify_related(value.system_id,value.id,false); vm.remove_part_id = rp.id; vm.remove_part_pn = rp.related_part_number\"></i></span><span class=\"negativeNumber left17\">{{rp.related_part_number}} - {{rp.related_part_description}} ({{rp.related_part_qty}})</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/adminSales/adminSales.html","<div class=page-header><div><h1><i class=\"fa fa-dollar\"></i><i class=\"fa fa-dollar\"></i><i class=\"fa fa-dollar\"></i> Sales Administration</h1></div></div><div class=box cg-busy=\"{promise:vm.userPromise,message:\'Loading\',delay:300,minDuration:1000}\"><div class=box-content><div class=row><table class=table><thead><th style=width:20%>Title</th><th>Description</th></thead><tbody><tr ng-click=\"vm.load(\'territory\')\" style=\"cursor: pointer\"><td>Setup and Assign Regions</td></tr></tbody><!-- <tr ng-click=\"vm.load(\'goals\')\" style=\"cursor: pointer;\">\n					<td>Sales Goals</td>\n					<td>Create / Update yearly goals and figures</td>\n				</tr>\n				<tr ng-click=\"vm.load(\'production\')\" style=\"cursor: pointer;\">\n					<td>Sales Production</td>\n					<td>Update the sales numbers generated outside the estimator</td>\n				</tr>\n				<tr ng-click=\"vm.load(\'reps\')\" style=\"cursor: pointer;\">\n					<td>Sales Reps</td>\n					<td>Choose users who have sold, or will sell products, including 3rd Parties</td>\n				</tr>\n				<tr ng-click=\"vm.load(\'ownerUpdate\')\" style=\"cursor: pointer;\">\n					<td>Update Owner</td>\n					<td>Choose the correct owner of an estimate, if currently incorrect or undefined</td>\n				</tr>\n				<tr ng-click=\"vm.load(\'territory\')\" style=\"cursor: pointer;\">\n					<td>Territories</td>\n					<td>Define what states make up Territories</td>\n				</tr> --></table></div></div></div>");
$templateCache.put("app/adminSettings/adminSettings.html","<div class=page-header><div class=row><div class=\"col-sm-10 my-form-control\"><h1>Settings Administration</h1></div><div class=\"col-sm-2 pull-right\"><button class=\"btn btn-primary form-control\" ng-click=vm.update()>Save</button></div></div></div><div class=box cg-busy=\"{promise:vm.userPromise,message:\'Loading\',delay:300,minDuration:1000}\"><div class=box-title><div class=row><div class=\"col-sm-12 bottom5\"><h3>Estimator Settings</h3></div><div ng-repeat=\"obj in vm.estimator_settings\"><div class=\"col-sm-12 bottom5\"><div class=\"col-lg-3 col-sm-4\"><span class=my-form-control>{{obj.name}}</span></div><div class=\"col-lg-9 col-sm-8 pull-left\"><div class=col-md-3><input class=form-control ng-model=obj.value></div></div></div></div></div></div><div class=box-title><div class=row><div class=\"col-sm-12 bottom5\"><h3>Miscellaneous Settings</h3></div><div ng-repeat=\"(key,setting) in vm.settingsArr\"><div class=\"col-sm-12 bottom5\"><div class=\"col-lg-3 col-sm-4\"><span class=my-form-control>{{key}}</span></div><div class=\"col-lg-9 col-sm-8 pull-left\" ng-if=\"key==\'Burden Rate\'\"><div class=col-md-3><input class=form-control ng-model=vm.settingsArr[key]></div></div><div class=\"col-lg-9 col-sm-8 pull-left\"><div class=col-md-3 ng-if=\"key==\'Default Opportunity Location\'\"><ui-select ng-model=vm.settingsArr[key]><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.connectwise_location_data | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div></div></div></div></div>");
$templateCache.put("app/adminSupport/adminSupport.html","<div class=page-header><div><h1><i class=\"fa fa-dollar\"></i><i class=\"fa fa-dollar\"></i><i class=\"fa fa-dollar\"></i> Sales Administration</h1></div></div><div class=box cg-busy=\"{promise:vm.userPromise,message:\'Loading\',delay:300,minDuration:1000}\"><div class=box-content><div class=row><table class=table><thead><th style=width:20%>Title</th><th>Description</th></thead><tbody><tr ng-click=\"vm.load(\'linuxUsers\')\" style=\"cursor: pointer\"><td>View / Edit JNL Linux Users</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/adminUser/adminUser.html","<script type=text/ng-template id=confirmModal.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Make User Inactive?</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      User {{vm.selectedUser.user_full_name}}? This cannot be undone.\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.removeUser()\">OK</button>\n    </div>\n	</div></script><div class=page-header><div><h1>User Administration</h1></div></div><div class=box cg-busy=\"{promise:vm.userPromise,message:\'Loading\',delay:300,minDuration:1000}\"><div class=box-title><h3><i class=\"fa fa-users\"></i> Users</h3><span class=pull-right ng-if=!vm.selectedUser><button class=btn ng-click=vm.newUser()><i class=\"fa fa-plus\"></i> Add User</button> <button class=\"btn btn-primary\" ng-click=vm.mangageGroups()>Manage User Groups</button> </span><span class=pull-right ng-if=vm.selectedUser><button class=btn ng-click=vm.clearUser()>Cancel</button> <button ng-if=vm.selectedUser.user_id class=\"btn btn-success\" ng-click=vm.updateUser()>Save</button> <button ng-if=!vm.selectedUser.user_id class=\"btn btn-success\" ng-click=vm.saveUser()>Save</button></span></div><div class=\"box-content nopadding\"><table ng-if=!vm.selectedUser class=\"table table-hover table-nomargin\"><thead><tr><th>Full Name</th><th>Access Level</th><th>Team Name</th><th>Username</th><th>Email</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" ng-click=vm.loadUser(user.user_id) style=\"cursor: pointer\"><td ng-if=\"vm.currentUser != user.user_id\"><i class=\"fa fa-minus-circle text-danger\" ng-click=vm.removeUserDialog()></i> {{user.user_full_name}}</td><td ng-if=\"vm.currentUser == user.user_id\"><i class=\"fa fa-minus-circle\"></i> {{user.user_full_name}}</td><td ng-repeat=\"group in vm.accessLevels | filter:{id:user.access_level}:true\">{{group.description}}</td><td>{{user.team.name}}</td><td>{{user.user_name}}</td><td>{{user.user_email}}</td></tr><tr ng-if=!vm.users.length><td colspan=4>No Results Found</td></tr></tbody></table><!-- User Loaded --><div ng-if=vm.selectedUser><div class=row><div class=col-sm-5><div class=box><div class=box-title><h3><i class=\"fa fa-sign-in\"></i>Selected User</h3></div><div class=box-content>{{vm.selectedUser.user_full_name}}</div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> User Editor</h3></div><div class=box-content><table class=\"table table-hover\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Full Name</td><td><input class=form-control ng-model=vm.selectedUser.user_full_name></td></tr><tr><td>User Name</td><td><input type=text class=form-control ng-model=vm.selectedUser.user_name></td></tr><tr><td>Password</td><td><span ng-if=vm.selectedUser.user_id>Check box to update password <input type=checkbox ng-change=vm.passFunc() ng-model=vm.pass></span><input type=password class=form-control ng-disabled=\"!vm.pass && vm.selectedUser.user_id\" ng-model=vm.selectedUser.password></td></tr><tr><td>Email</td><td><input class=form-control ng-model=vm.selectedUser.user_email></td></tr><tr><td>Access Group</td><td><select class=form-control ng-model=vm.selectedUser.access_level ng-options=\"item.id as item.description for item in vm.accessLevels\"></select></td></tr><tr><td>Primary Function</td><td><select class=form-control ng-model=vm.selectedUser.primary_function ng-options=\"item.value as item.lable for item in [{lable: \'Admin\', value: 1 },{ lable: \'Technical\', value: 2 }, {lable: \'Sales\', value: 3 },{ lable: \'Production\', value: 4 },{ lable: \'Install\', value: 5 }]\"></select></td></tr><tr><td>On Call Device</td><td><select class=form-control ng-model=vm.selectedUser.on_call_device ng-options=\"item.id as item.name for item in vm.alertDevices\"></select></td></tr><tr><td>Sells Things</td><td><input type=checkbox ng-model=vm.selectedUser.sells_things></td></tr><tr><td>Quantum Access</td><td><input type=checkbox ng-model=vm.selectedUser.installs_things></td></tr><tr><td>Receive Emails For:</td><td><ui-select multiple ng-model=vm.selectedUser.email_actions><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"action.id as action in vm.emailActions | filter:$select.search\">{{action.name}}</ui-select-choices></ui-select></td></tr><tr><td>Team</td><td><select class=form-control ng-model=vm.selectedUser.team.id ng-options=\"item.id as item.name for item in vm.teams\"></select></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/boardTest/boardTest.html","<div class=page-header><div><h1>Pre Assembly Test</h1></div></div><div><div class=\"row row-fluid title-div\" cg-busy=\"{promise:vm.startPromise,message:\'Loading\',delay:300,minDuration:1000}\"><span class=col-sm-4>Enter Serial Number</span> <span class=col-sm-8><input class=form-control ng-model=vm.serialNumber ng-change=vm.checkSN()></span></div><div class=\"row body-div\" ng-if=!vm.testStatus><button class=\"btn btn-primary\" ng-disabled=!vm.valid ng-click=vm.startTest()>Start Test</button><div><ul ng-repeat=\"error in vm.errors\"><li>{{error}}</li></ul></div><div><ul ng-repeat=\"error in vm.warnings\"><li>Note: {{error}}</li></ul></div></div></div><!-- DISPLAY FOR DCS BOARD --><div class=\"row body-div\" ng-if=\"vm.testStatus && vm.testType == \'dcs\'\"><table class=table><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\">Input {{key}}</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\">{{value.status}}</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\" ng-class={success:value.tested,danger:!value.tested}>{{value.tested}}</td></tr></table><table class=table><tr><td>Output 1</td><td>Output 2</td><td>Output 3</td><td>Output 4</td><td>Output 5</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.outputs\">{{value.status}}</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(1)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(2)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(3)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(4)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(5)>Toggle Output</button></td></tr><tr><td><button class=\"btn btn-warning\" ng-click=vm.outputOn()>Outputs Function</button></td></tr></table><table class=table><tr><td>Bluetooth Chip Firmware</td><td>Bluetooth Test Status</td></tr><tr><td>{{vm.resultData.bluetooth.firmware}}</td><td ng-class={success:vm.resultData.bluetooth.result,danger:!vm.resultData.bluetooth.result}>{{vm.resultData.bluetooth.result}}</td></tr></table><button ng-if=!vm.passedTest() class=\"btn btn-primary\" ng-click=vm.stopTest()>Cancel Test</button> <button ng-if=vm.passedTest() class=\"btn btn-primary\" ng-click=vm.submitTest()>Submit Test</button></div><!-- DISPLAY FOR PC BOARD --><div class=\"row body-div\" ng-if=\"vm.testStatus && vm.testType == \'pc\'\">Action required in: {{vm.resultData.timer}}<table class=table><tr><td>Alarm 1</td><td>Alarm 1 Reset</td><td>Alarm 2</td><td>Alarm 2 Reset</td><td>Check IN</td><td>Check IN Reset</td></tr><tr><td>{{vm.resultData.status.alarm1}}</td><td>{{vm.resultData.status.alarm1reset}}</td><td>{{vm.resultData.status.alarm2}}</td><td>{{vm.resultData.status.alarm2reset}}</td><td>{{vm.resultData.status.tamper}}</td><td>{{vm.resultData.status.tamperReset}}</td></tr></table><button ng-if=\"vm.resultData.test_result == true && !vm.userConfirm\" class=\"btn btn-primary\" ng-click=vm.confirm()>Confirm Pass</button> <button ng-if=\"vm.resultData.test_result == true && !vm.userConfirm\" class=\"btn btn-danger\" ng-click=vm.submitFail()>User Fail</button> <button ng-if=\"vm.resultData.test_result != \'Unknown\' && vm.userConfirm || vm.resultData.timer == 15\" class=\"btn btn-primary\" ng-click=vm.submitTest()>Submit Test</button> <button class=\"btn btn-primary\" ng-click=vm.pcStopTest()>Cancel Test</button></div>");
$templateCache.put("app/buildOverview/buildOverview.html","<script type=text/ng-template id=finalizeRequest.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Request Complete?</h4>\n		</div>\n	 	<div class=\"modal-body\">\n			<div class=\"row left5\">This will lock this request, no more tests or assigning serial numbers.  This should only be used when the request is fully completed.</div>\n			<div class=\"row left5\">Quantity Requested: <span class=\"bold\">{{vm.pickList.quantity}}</span>, Quantity Built: <span class=\"bold\">{{vm.built_value}}</span>, Quantity Passed Test: <span class=\"bold\">{{vm.tested_value}}</span></div>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n			<button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.confirm_final()\">YES, complete the request</button>\n		</div>\n	</div></script><script type=text/ng-template id=serialNumberData.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Serial Number Information, anything red indicates why it can\'t be used in a new build</h4>\n		</div>\n		<div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<th>\n						Product Name (If Found)\n					</th>\n					<th>\n						Serial selected for build\n					</th>\n					<th>\n						Serial selected in a completed build\n					</th>\n					<th>\n						Serial associated to a completed product\n					</th>\n				</thead>\n				<tbody ng-if=\"vm.invalidSerialData.length == 0\">\n					<tr>\n						<td class=\"danger\">Invalid Serial Number, Does Not Exist</td>\n						<td></td>\n					</tr>\n				</tbody>\n				<tbody ng-if=\"vm.invalidSerialData.length > 0\">\n					<tr ng-repeat=\"obj in vm.invalidSerialData\">\n						<td ng-class=\"{success:obj.product_data.id == vm.serializedProduct[0].product_data.id,danger:obj.product_data.id != vm.serializedProduct[0].product_data.id}\">{{obj.product_data.name}}</td>\n						<td ng-class=\"{success:!obj.build_status.build_started,danger:obj.build_status.build_started}\">{{obj.build_status.build_started ? \"YES\":\"NO\"}}</td>\n						<td ng-class=\"{success:!obj.build_status.built,danger:obj.build_status.built}\">{{obj.build_status.built ? \"YES\":\"NO\"}}</td>\n						<td ng-class=\"{success:!obj.final_product,danger:obj.final_product}\">{{obj.final_product ? \"YES\":\"NO\"}}</td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Ok</button>\n			<button class=\"btn btn-danger\" type=\"button\" ng-if=\"vm.invalidSerialData[0].final_product\" ng-click=\"vm.resetSerialNumber(vm.invalidSerialData[0])\">Restart Serial Number {{vm.invalidSerialData[0].serial_number}}</button>\n			<div ng-if=\"vm.invalidSerialData[0].final_product\" class=\"negativeNumber boldItalic\">Warning, resetting a serial number will clear any existing assocations with previous products it was associated with.  This should only be done if you are sure it is the correct thing to do</div>\n		</div>\n	</div></script><div ng-if=!vm.selectedId cg-busy=\"{promise:vm.p,message:\'Loading\',delay:0,minDuration:1000}\"><div class=page-header><div><h1>Build Requests - Production</h1></div></div><div class=box><div class=box-title><h3><i class=\"fa fa-signing\"></i>Picked Parts - Ready For Build</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin table-striped\"><thead><tr><th style=width:50%>Part Description</th><th>Build Request (ID) (Pick List ID)</th><th>Qty to Build (Qty Built)</th><th>Qty Ready Test (Qty Passed Test)</th></tr></thead><tbody><!-- <tr dir-paginate=\"(index,buildObj) in vm.buildList.data | itemsPerPage:vm.num_results\" current-page=\"vm.currentPage\" total-items=\"vm.buildList.count\" style=\"cursor: pointer;\"></tr> --><tr dir-paginate=\"(index,object) in vm.readyForBuild.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.readyForBuild.count ng-click=vm.loadBuildRequestDetail(object.id) style=\"cursor: pointer\"><td>{{object.build_request.build_data.product_data.part_number}} - {{object.build_request.build_data.product_data.name}}</td><td>{{object.build_request.name}} ({{object.build_request.id}}) ({{object.id}})</td><td>{{object.quantity}} ({{object.quantity_built}})</td><td>{{object.quantity_built - object.quantity_passed_test}} ({{object.quantity_passed_test}})</td></tr><tr ng-if=\"readyForBuild.length == 0\"><td colspan=4>No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.readyForBuild.data.length}} of {{vm.readyForBuild.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div></div></div><div ng-if=vm.selectedId cg-busy=\"{promise:vm.p,message:\'Loading\',delay:100,minDuration:1000}\"><div class=box><div class=box-title><div class=row><h3 class=col-sm-12><div class=col-sm-4><i class=\"fa fa-signing\"></i>Product Progress</div><div class=\"pull-right col-sm-1\"><button class=btn ng-click=vm.load_data()><i class=\"fa fa-refresh\"></i></button></div><div class=\"pull-right col-sm-7\">Building Product: {{vm.pickList.build_request.build_data.product_data.name}} - ({{vm.pickList.build_request.build_data.product_data.part_number}})</div></h3></div></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th style=width:15%>Line (Database ID)</th><th>Serialized Daughter Product: <span style=\"font-style: italic\" ng-if=\"vm.serializedProduct.length > 0\">{{vm.serializedProduct[0].product_data.name}} - ({{vm.serializedProduct[0].product_data.part_number}})</span> <span style=\"font-style: italic\" ng-if=\"vm.serializedProduct.length == 0\">No JNL serialized parts to assign</span></th><th>Action</th><th><button class=\"btn btn-primary\" ng-if=!vm.pickList.built ng-click=vm.finalize_request()>Finalize Request</button></th></tr></thead><tbody><tr dir-paginate=\"(index,buildObj) in vm.buildList.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.buildList.count><td>{{(index + 1)+(vm.num_results*(vm.currentPage-1))}} ({{buildObj.id}})</td><td ng-if=\"!buildObj.build_started && vm.serializedProduct.length > 0\"><input class=form-control type=number ng-model=buildObj.serial_number_data.serial_number></td><td ng-if=\"buildObj.serial_number_data && buildObj.build_started && vm.serializedProduct.length > 0\">{{buildObj.serial_number_data.serial_number}}</td><td ng-if=\"vm.serializedProduct.length == 0\">No JNL serialized parts to assign</td><td ng-if=\"!buildObj.build_started && !vm.pickList.built && vm.serializedProduct.length > 0\"><button class=\"btn btn-primary\" ng-disabled=!buildObj.serial_number_data.serial_number ng-click=vm.checkSerial(buildObj.serial_number_data.serial_number,buildObj.id)>Start Build</button></td><td ng-if=\"!buildObj.build_started && !vm.pickList.built && vm.serializedProduct.length == 0\"><button class=\"btn btn-primary\" ng-click=vm.start_no_serial_build(buildObj.id)>Start Build</button></td><td ng-if=\"buildObj.build_started && !buildObj.built && !vm.pickList.built\"><button class=\"btn btn-primary\" ng-disabled=\"!buildObj.serial_number_data.serial_number && !vm.serializedProduct.length == 0\" ng-click=vm.completeBuild(buildObj.serial_number_data.id,buildObj.id)>Complete Build</button> <button class=\"btn btn-danger\" ng-disabled=!buildObj.serial_number_data.serial_number ng-click=vm.restartBuild(buildObj.serial_number_data.id,buildObj.id)>Restart Build</button></td><td ng-if=\"buildObj.built && !vm.pickList.built && !vm.serializedProduct.length == 0\"><button class=\"btn btn-primary\" ng-if=!vm.attached_to_finished_product.includes(buildObj.serial_number_data.id) ng-click=vm.testProduct(buildObj.serial_number_data.id,vm.pickList.build_request.build_data.product_data.id)>Go To Product Test</button> <button class=\"btn btn-primary\" ng-if=vm.attached_to_finished_product.includes(buildObj.serial_number_data.id) ng-click=vm.testProduct(buildObj.serial_number_data.id,vm.pickList.build_request.build_data.product_data.id)>Retest Product</button> <button class=\"btn btn-danger\" ng-if=!vm.attached_to_finished_product.includes(buildObj.serial_number_data.id) ng-click=vm.restartBuild(buildObj.serial_number_data.id,buildObj.id)>Restart Build</button> <button class=\"btn btn\" ng-if=vm.attached_to_finished_product.includes(buildObj.serial_number_data.id) ng-click=vm.checkSerial(buildObj.serial_number_data.serial_number,buildObj.id)>View Serial Number</button> <button class=\"btn btn-success\" ng-if=vm.attached_to_finished_product.includes(buildObj.serial_number_data.id) ng-click=vm.viewTest(buildObj.serial_number_data.final_product.serial_number)>View Last Test</button></td><td ng-if=\"buildObj.built && vm.serializedProduct.length == 0\">Build Completed</td><td></td></tr><tr ng-if=\"readyForBuild.length == 0\"><td colspan=4>No Results Found</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.buildList.data.length}} of {{vm.buildList.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/buildPickList/buildPickList.html","<script type=text/ng-template id=allPartDialog.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Action</h4>\n		</div>\n    <div class=\"modal-body\">\n      Picked / Unpicked all of these parts?\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModalSave()\">No</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.pickAll()\">YES</button>\n    </div>\n	</div></script><script type=text/ng-template id=addPart.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Add Part to Build Request</h4>\n		</div>\n    <div class=\"modal-body\">\n			<div class=\"row\" ng-if=\"!vm.newPartObject.piece_part_id\">\n	      	<span class=\"col-sm-2 top7\">Enter Part Number:</span>\n	      	<span class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"vm.newPartText\"></span>\n					<span class=\"col-sm-2\"><button class=\"button btn\" ng-click=\"vm.checkNewPart()\">Next</button></span>\n			</div>\n			<div class=\"row\">\n				<table class=\"table\" ng-if=\"vm.newParts && !vm.newPartObject.piece_part_id\">\n					<tr ng-repeat=\"part in vm.newParts\" ng-click=\"vm.confirmNewPart(part.id,part.part_number,part.name)\" style=\"cursor: pointer;\">\n						<td>{{part.part_number}} - {{part.name}}</td>\n					</tr>\n				</table>\n			</div>\n			<div class=\"row\" ng-if=\"vm.newPartObject.piece_part_id\">\n	      	<span class=\"col-sm-2\">New Part:</span>\n	      	<span class=\"col-sm-8\">{{vm.selectedNewPart}}</span>\n			</div>\n			<div class=\"row\" ng-if=\"vm.newPartObject.piece_part_id && !vm.newPartObject.piece_qty\">\n				<span class=\"col-sm-2 top7\">Enter Qty for build:</span>\n				<span class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"vm.newPartQty\"></span>\n				<span class=\"col-sm-2\"><button class=\"button btn\" ng-click=\"vm.checkNewQty()\">Next</button></span>\n			</div>\n			<div class=\"row\" ng-if=\"vm.newPartObject.piece_qty\">\n	      	<span class=\"col-sm-2\">New Part Qty:</span>\n	      	<span class=\"col-sm-8\">{{vm.newPartQty}}</span>\n					<span class=\"col-sm-2\"><button class=\"button btn\" ng-click=\"vm.addNewPart()\">Add Part To Build</button></span>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n    </div>\n	</div></script><div class=page-header><div><h1><i class=\"fa fa-hand-lizard-o\"></i> Pick Lists</h1></div></div><div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000} ng-if=!vm.currentPick><div class=\"row bottom10 border-bottom\"><div class=col-sm-2><a class=\"btn btn-primary\" ng-click=vm.newBuildDialog()><i class=\"fa fa-plus\"></i> Add New</a></div></div><div class=\"row top5\"><div class=col-sm-1><label class=top7>Show Picked:</label><input type=checkbox ng-model=vm.showPicked ng-change=vm.load_data()></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=build_request/build_data/product_data/part_number>Product Number</option><option value=build_request/build_data/product_data/name>Product Name</option><option value=build_request/id>Build Request ID</option><option value=build_request/name>Build Request Name</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'id\'; vm.sort_data()\">Pick List ID <span ng-show=\"vm.sort_by == \'id\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'id\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'notes\'; vm.sort_data()\">Build Request Name (ID) <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Finished Quantity</th><th>Finished Product</th></thead><tbody><tr dir-paginate=\"(key,obj) in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count style=\"cursor: pointer\"><td ng-click=vm.openEdit(key)>{{obj.id}}</td><td ng-click=vm.openEdit(key)>{{obj.build_request.name}} - ({{obj.build_request.id}})</td><td ng-click=vm.openEdit(key)>{{obj.quantity}}</td><td ng-click=vm.openEdit(key)>{{obj.build_request.build_data.product_data.name}} - ({{obj.build_request.build_data.product_data.part_number}})</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div><div ng-if=vm.currentPick cg-busy=\"{promise:vm.p,delay:200,minDuration:1000,message:\'Updating Parts\'}\"><h2>Build Request: {{vm.currentPick.build_request.name}} - ({{vm.currentPick.build_request.id}}) <span class=pull-right><button class=btn ng-click=vm.home()>Back</button></span></h2><table class=table ng-if=!vm.currentPick.picked><thead><tr><th>Finished Product:</th><th>{{vm.currentPick.build_request.build_data.product_data.part_number}} - {{vm.currentPick.build_request.build_data.product_data.name}}</th><th>Finished Product Quantity: {{vm.currentPick.quantity}}</th><th><button ng-disabled=!vm.productFullyPicked class=\"btn btn-primary\" ng-click=vm.completePickList()>Complete Pick List</button> <button class=\"btn btn-danger pull-right\" ng-disabled=vm.currentPick.picked class=\"btn btn-primary\" ng-click=vm.DeletePickList(vm.currentPick.id)>Delete Pick List</button></th></tr><tr><th colspan=2>Piece Description</th><th>Quantity to Pick</th><th><span>Picked</span><span><input type=checkbox ng-model=vm.productFullyPicked disabled><span>Check All</span><span><input type=checkbox ng-model=vm.checkAllBoxChecked ng-click=vm.checkPickAll()></span></span></th></tr></thead><tbody><tr ng-repeat=\"(build_key,part) in vm.pieces\" class=\"table table-hover table-striped\"><td colspan=2><span class=left10>{{part.product_data.part_number}} - {{part.product_data.name}}</span></td><td>{{part.quantity}}</td><td><input class=form-control type=checkbox ng-model=part.picked ng-change=vm.patchPart(part.id,part.picked,true)></td></tr></tbody></table><table class=table ng-if=vm.currentPick.picked><thead><tr><th>Finished Product:</th><th>{{vm.currentPick.build_request.build_data.product_data.part_number}} - {{vm.currentPick.build_request.build_data.product_data.name}}</th><th>Finished Product Quantity: {{vm.currentPick.quantity}}</th><th></th></tr><tr><th colspan=2>Piece Description</th><th>Quantity Picked</th><th><span>Picked</span><span><input type=checkbox ng-model=vm.productFullyPicked disabled></span></th></tr></thead><tbody><tr ng-repeat=\"(build_key,part) in vm.pieces\" class=\"table table-hover table-striped\"><td colspan=2><span class=left10>{{part.product_data.part_number}} - {{part.product_data.name}}</span></td><td>{{part.quantity}}</td><td></td></tr></tbody></table></div>");
$templateCache.put("app/buildRequests/buildRequests.html","<script type=text/ng-template id=newBuildDialog.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">New Request</h4>\n		</div>\n		<!-- /.modal-header -->\n    	<div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<tr>\n						<th>\n							Property\n						</th>\n						<th>\n							Value\n						</th>\n					</tr>\n				</thead>\n				<tbody>\n					<tr>\n						<td>Name</td>\n						<td><textarea name=\"name\" rows=\"8\" cols=\"60\" ng-model=\"vm.currentBuild.notes\"></textarea></td>\n					</tr>\n					<tr>\n						<td>Product</td>\n						<td><ui-select ng-model=\"vm.currentBuild.build_data\" ng-disabled=\"vm.currentBuild.id\">\n							<ui-select-match>{{$select.selected.product_data.part_number}} - {{$select.selected.product_data.name}}</ui-select-match>\n							<ui-select-choices class=\"ui-select-choices\" repeat=\"build in vm.availableBuilds  | filter:$select.search track by build.id\" refresh-delay=\"300\">\n								{{build.product_data.part_number}} - {{build.product_data.name}}\n							</ui-select-choices>\n						</ui-select></td>\n					</tr>\n					<tr>\n						<td>Quantity</td>\n						<td><input type=\"number\" class=\"form-control\" ng-model=\"vm.currentBuild.quantity\" ng-disabled=\"!vm.currentBuild.build_data.id || vm.currentBuild.id\"></td>\n					</tr>\n\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.addRequest()\" ng-if=\"!vm.currentBuild.id\" ng-disabled=\"!(vm.currentBuild.build_data.id && vm.currentBuild.quantity && vm.currentBuild.notes)\">Create Build Request</button>\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.updateRequest()\" ng-if=\"vm.currentBuild.id\" ng-disabled=\"!vm.currentBuild.notes\">Save Changes</button>\n			<button class=\"btn btn-danger pull-left\" type=\"button\" ng-click=\"vm.removeRequest()\" ng-if=\"vm.currentBuild.id\" ng-disabled=\"!(vm.remove_valid())\">Delete Build Request</button>\n    	</div>\n		<div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<tr>\n						<th>\n							Existing Pick Lists (ID)\n						</th>\n						<th>\n							Quantity To Pick\n						</th>\n						<th>\n							Picked\n						</th>\n					</tr>\n				</thead>\n				<tbody>\n					<tr ng-repeat=\"row in vm.pickLists.data\">\n						<td>\n							<button class=\"btn btn-danger\" ng-click=\"vm.deleteUnpickedList(row.id)\" ng-disabled=\"row.picked\"><i class=\'fa fa-trash-o\'></i></button> ({{row.id}})\n						</td>\n						<td>\n							{{row.quantity}}\n						</td>\n						<td>\n							{{row.picked ? \"YES\":\"NO\"}}\n						</td>\n					</tr>\n				</tbody>\n			</table>\n    	</div>\n	</div></script><script type=text/ng-template id=editRequestDialog.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">New Request</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<tr>\n						<th>\n							Property\n						</th>\n						<th>\n							Value\n						</th>\n					</tr>\n				</thead>\n				<tbody>\n					<tr>\n						<td>Purchase Order Number (Optional)</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.currentBuild.description\"></td>\n					</tr>\n					<tr>\n						<td>Notes</td>\n						<td><textarea name=\"name\" rows=\"8\" cols=\"60\" ng-model=\"vm.currentBuild.notes\"></textarea></td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.updateRequest(false)\">Save</button>\n    </div>\n	</div></script><script type=text/ng-template id=confirmLock.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Action</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      This will lock this request from additional parts. Make sure your selections are correct.\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModalOnly()\">Cancel</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.lockRequest()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=partial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Create Pick List</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-5 top7\">Enter the quantity of request to be picked</span><span class=\"col-sm-2\"><input type=\"number\" class=\"form-control\" ng-model=\"vm.currentPick.quantity\"></span>\n				<span class=\"col-sm-3 top7\">MAX: ({{vm.currentBuild.quantity - vm.currentBuild.num_pick_requested}})</span>\n			</div>\n		</div>\n		<div class=\"modal-footer\">\n		<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModalOnly()\">Cancel</button>\n			<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"((vm.currentBuild.quantity - (vm.currentBuild.num_pick_requested + vm.currentPick.quantity)) < 0) || vm.currentPick.quantity <= 0\" ng-click=\"vm.createPick()\">Create Pick List</button>\n		</div>\n		<div class=\"modal-body\">\n			<div class=\"row\">\n				<div class=\"col-sm-4\"> \n					Cost Per Unit: {{vm.currentPick.build_cost + (vm.currentPick.time_to_build/60 * vm.currentPick.labor_cost)  | currency}}\n				</div>\n				<div class=\"col-sm-4\">\n					Hardware: {{vm.currentPick.build_cost | currency}}\n				</div>\n				<div class=\"col-sm-4\">\n					Labor: {{(vm.currentPick.time_to_build/60 * vm.currentPick.labor_cost) | currency}}\n				</div>  \n			</div>\n			<table class=\"table table-striped\">\n				<thead>\n					<th>Part</th>\n					<th>Quantity</th>\n				</thead>\n				<tbody>\n					<tr ng-repeat=\"obj in vm.currentPick.parts\">\n						<td>{{obj.product_data.name}}</td>\n						<td>{{obj.quantity}} - ({{obj.quantity * vm.currentPick.quantity}})</td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n	</div></script><div class=page-header><div><h1><i class=\"fa fa-cogs\"></i> Build Requests</h1></div></div><div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=\"row bottom10 border-bottom\"><div class=col-sm-2><a class=\"btn btn-primary\" ng-click=vm.newBuildDialog()><i class=\"fa fa-plus\"></i> Add New</a></div></div><div class=\"row top5\"><div class=col-sm-1></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=build_data/product_data/part_number>Product Number</option><option value=build_data/product_data/name>Product Name</option><option value=notes>Notes</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'id\'; vm.sort_data()\">Build Request ID <span ng-show=\"vm.sort_by == \'id\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'id\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'notes\'; vm.sort_data()\">Name <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Product</th><th>Requested Quantity</th><th>Requested Pick Amt. (Picked Amt)</th><th>Built Amount</th><th ng-click=\"vm.sort_by=\'date_created\'; vm.sort_data()\">Date Created <span ng-show=\"vm.sort_by == \'date_created\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'date_created\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th></th></thead><tbody><tr dir-paginate=\"(key,obj) in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count style=\"cursor: pointer\"><td ng-click=vm.openEdit(key)>{{obj.id}}</td><td ng-click=vm.openEdit(key)>{{obj.notes}}</td><td ng-click=vm.openEdit(key)>{{obj.build_data.product_data.name}}-({{obj.build_data.product_data.part_number}})</td><td ng-click=vm.openEdit(key)>{{obj.quantity}}</td><td ng-click=vm.openEdit(key)>{{obj.num_pick_requested}} ({{obj.num_picked}})</td><td ng-click=vm.openEdit(key)>{{obj.num_built}}</td><td ng-click=vm.openEdit(key)>{{obj.date_created | date:\'medium\'}}</td><td><button class=\"btn btn-primary\" type=button ng-click=vm.openPick(key) ng-disabled=\"obj.num_pick_requested >= obj.quantity\">Create Pick List</button></td></tr><tr ng-if=\"\"></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div>");
$templateCache.put("app/changeOrderCreate/changeOrderCreate.html","<div><div class=row><div class=col-sm-6><h3>Find an Estimate</h3></div></div></div><div class=\"row bottom5\"><div class=col-sm-2></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-1><select class=form-control ng-model=vm.searchFor><option value=site_name>Customer</option><option value=estimate_id>Estimate ID</option><option value=title>Title</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><div class=row><div class=col-sm-2></div><div class=\"col-sm-1 top7\"><label class=\"pull-right top7\">Show All Reps:</label></div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.all_reps ng-change=vm.load_data()></div><div class=col-sm-4></div></div><table class=table><thead><tr><th ng-click=\"vm.sort_by=\'site_name\'; vm.sort_data()\">Customer <span ng-show=\"vm.sort_by == \'site_name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'site_name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'estimate_id\'; vm.sort_data()\">Estimate ID <span ng-show=\"vm.sort_by == \'estimate_id\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'estimate_id\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'title\'; vm.sort_data()\">Title <span ng-show=\"vm.sort_by == \'title\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'title\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Type</th><th>Status</th><th>Budgetary</th><th>Owner</th></tr></thead><tbody><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count><td>{{obj.site_name}}</td><td><button class=btn ng-click=vm.openEstimate(obj.estimate_id,obj.system_type_id)>{{obj.estimate_id}}</button></td><td>{{obj.title}}</td><td>{{obj.system_type}}</td><td>{{obj.status}}</td><td>{{obj.budgetary ? \"YES\":\"NO\"}}</td><td>{{obj.owner}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div><!-- <div class=\"box simple-border bottom15\">\n	<div class=\"box-content\">\n		<div class=\"row bottom5\">\n			<div class=\"col-sm-1 top7\">\n				Customer\n			</div>\n			<div class=\"col-sm-3\">\n				<ui-select ng-model=\"vm.searchData.customer_name\">\n					<ui-select-match>{{$select.selected}} - {{$select.selected}}</ui-select-match>\n					<ui-select-choices class=\"ui-select-choices\" repeat=\"site in vm.availableCustomers | filter:$select.search\" refresh-delay=\"300\">\n						{{site}}\n					</ui-select-choices>\n				</ui-select>\n			</div>\n		</div>\n		<div class=\"row bottom5\">\n			<div class=\"col-sm-1 top7\">\n				Estimate ID\n			</div>\n			<div class=\"col-sm-3\">\n				<input class=\"form-control\" ng-model=\"vm.searchData.estimate_id\">\n			</div>\n			<div class=\"col-sm-1 top7\">\n				Show All Reps:\n			</div>\n			<div class=\"col-sm-1 top7\">\n				<input type=\"checkbox\" ng-model=\"vm.searchData.all_reps\">\n			</div>\n			<div class=\"col-sm-1 top7\">\n				Show Inactive:\n			</div>\n			<div class=\"col-sm-1 top7\">\n				<input type=\"checkbox\" ng-model=\"vm.searchData.inactive\">\n			</div>\n			<div class=\"col-sm-1 top7\">\n				Won:\n			</div>\n			<div class=\"col-sm-1 top7\">\n				<input type=\"checkbox\" ng-model=\"vm.searchData.won\" ng-change=\"vm.won_func()\">\n			</div>\n			<div class=\"col-sm-1 top5\">\n				<button class=\"btn\" ng-click=\"vm.clearFilter()\">Clear Filters</button>\n			</div>\n		</div>\n	</div>\n</div>\n<div class=\"box\">\n	<div class=\"box-content nopadding\">\n		<table class=\"table\">\n			<tr>\n				<th class=\"col-md-3\">\n					Customer\n				</th>\n				<th class=\"col-md-2\">\n					Estimate ID\n				</th>\n				<th class=\"col-md-3\">\n					Estimate Title\n				</th>\n				<th class=\"col-md-2\">\n					Estimate Type\n				</th>\n				<th>\n					Status\n				</th>\n				<th class=\"col-md-1\">\n					Budgetary\n				</th>\n				<th class=\"col-md-1\">\n					Owner\n				</th>\n			</tr>\n			<tr ng-repeat=\"estimate in vm.filteredResults()\">\n				<td>{{estimate.site_name}}</td>\n				<td><button class=\"btn\" ng-click=\"vm.openEstimate(estimate.estimate_id,estimate.system_type_id)\">{{estimate.estimate_id}}</button></td>\n				<td>{{estimate.title}}</td>\n				<td>{{estimate.system_type}}</td>\n				<td ng-repeat=\"st in vm.status_obj | filter:{id:estimate.estimate_status_id}\">{{st.name}}</td>\n				<td>{{estimate.budgetary ? \"Yes\":\"No\"}}</td>\n				<td ng-repeat=\"user in vm.users | filter:{user_id:estimate.owner}:true\">{{user.user_full_name}}</td>\n			</tr>\n		</table>\n	</div>\n</div> -->");
$templateCache.put("app/changeOrderManage/changeOrderManage.html","<script type=text/ng-template id=enterQTY.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Enter Quantity</h4>\n		</div>\n		<div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-7\">{{vm.otherPart.product_description}}</span><span class=\"col-sm-2\">Quantity</span><span class=\"col-sm-3\"><input class=\"form-control\" ng-model=\"vm.otherPart.qty\"></span>\n				<span class=\"col-sm-7\"></span><span class=\"col-sm-2\">Discount</span><span class=\"col-sm-3\"><input class=\"form-control\" ng-model=\"vm.otherPart.discount\"></span>\n			</div>\n			<div class=\"modal-footer\">\n				<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.accAdd()\">Add Part To Quote</button>\n			  <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n			</div>\n		</div>\n	</div></script><script type=text/ng-template id=status_change.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Status Change</h4>\n		</div>\n		<div class=\"modal-body\">\n			<div class=\"row no-side-margin bottom5\">\n				<b>This will lock the change order, click yes to change status, no to cancel</b>\n			</div>\n			<div class=\"row no-side-margin bottom5\">\n				Choose the ticket to attach the parts:\n			</div>\n			<div ng-repeat=\"t in vm.available_tickets\" class=\"row no-margin\">\n				<input type=\"radio\" name=\"ch\" ng-model=\"vm.selectedTicket\" value=\"{{t.id}}\"><span>{{t.summary}} - ({{t.id}})</span>\n			</div>\n			<div class=\"modal-footer\">\n				<button ng-if=\"vm.tmp_status == 2\" class=\"btn btn-primary\" ng-disabled=\"!vm.selectedTicket\" type=\"button\" ng-click=\"vm.confirm_status()\">Yes</button>\n				<button ng-if=\"vm.tmp_status == 3\" class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.confirm_status()\">Yes</button>\n			  <button class=\"btn\" type=\"button\" ng-click=\"vm.cancel_status()\">No</button>\n			</div>\n		</div>\n	</div></script><div class=fixed-top-left><div class=\"box simple-border border-groove\"><div class=\"row no-side-margin\"><span ng-if=!vm.estimate_action_open ng-click=\"vm.estimate_action_open=true\"><i class=\"fa fa-plus text-primary\"></i> Estimate Actions</span> <span ng-if=vm.estimate_action_open ng-click=\"vm.estimate_action_open=false\"><i class=\"fa fa-minus text-primary\"></i> Estimate Actions</span></div><ul ng-if=vm.estimate_action_open class=nav><li class=nav-item><a class=\"nav-link co-menu-sub\" ng-click=vm.co_excel() href=# style=\"cursor: pointer\">Open Excel <i class=\"fa fa-file-excel-o text-primary\"></i></a></li><li class=nav-item><a class=\"nav-link co-menu-sub\" ng-click=vm.open_estimate() href=# style=\"cursor: pointer\">Open Estimate</a></li></ul></div><div ng-if=\"vm.co_id && vm.sameObj()\" class=\"box simple-border border-groove\"><div class=\"row no-side-margin\"><span ng-if=!vm.co_output_open ng-click=\"vm.co_output_open=true\"><i class=\"fa fa-plus text-primary\"></i> Change Order Outputs</span> <span ng-if=vm.co_output_open ng-click=\"vm.co_output_open=false\"><i class=\"fa fa-minus text-primary\"></i> Change Order Outputs</span></div><ul ng-if=vm.co_output_open class=nav><li class=nav-item><!-- <a class=\"nav-link co-menu-sub\" ng-click=\"vm.customerView\" href=\"#\" style=\"cursor: pointer;\">Customer View</a> --> <a class=\"nav-link co-menu-sub\" href={{vm.customerView}} target=_blank>Customer View</a> <a ng-if=\"vm.co_object.status != 3 && vm.co_object.include_labor\" class=\"nav-link co-menu-sub\" href={{vm.installContract}} target=_blank>Install Contract</a></li><!-- <li class=\"nav-item\">\n				<a class=\"nav-link co-menu-sub\" ng-click=\"vm.open_estimate()\" href=\"#\" style=\"cursor: pointer;\">Open Estimate</a>\n			</li> --></ul></div><div ng-if=vm.co_id><span ng-hide=vm.blah>{{vm.edit_check()}}</span><!-- <span ng-hide=\"vm.blah\">{{vm.build_other_totals()}}</span> --><div class=\"box simple-border border-groove\"><div class=\"row no-margin\"><span>Hardware Changes:</span> <span class=pull-right>{{vm.co_object.hardware_total | currency}}</span></div><div class=\"row no-margin\"><span>Labor Changes:</span> <span class=pull-right>{{vm.co_object.labor_total | currency}}</span></div><div class=\"row no-margin\"><span>Total Changes:</span> <span class=\"pull-right bold\">{{vm.co_object.labor_total +vm.co_object.hardware_total+vm.co_object.tax | currency}}</span></div><div ng-if=\"vm.estimateData.hardware_discount > 0 || vm.estimateData.labor_discount > 0 || vm.dealer_discount > 0\"><div class=\"row no-side-margin top10\"><span>Discounts applied from Estimate:</span></div><div class=\"row no-margin\"><span>Hardware:</span> <span class=pull-right>% {{vm.estimateData.hardware_discount}}</span></div><div class=\"row no-margin\"><span>Labor:</span> <span class=pull-right>% {{vm.estimateData.labor_discount}}</span></div><div class=\"row no-margin\"><span>Dealer:</span> <span class=pull-right>% {{vm.dealer_discount}}</span></div></div><div ng-if=\"vm.co_object.status == 1\"><div class=\"row no-side-margin top10\"><span>Part Quantity Selector:</span></div><div class=\"row no-margin\"><button class=btn ng-click=\"vm.q_select = 1\">1X</button> <button class=btn ng-click=\"vm.q_select = 10\">10X</button> <button class=btn ng-click=\"vm.q_select = 100\">100X</button> <input type=number class=form-control ng-model=vm.q_select></div></div><div ng-if=\"vm.co_object.status != 1 && vm.co_object.hw_discount > 0 || vm.co_object.status == 1\"><div class=\"row no-side-margin top10\"><span>Change Order HW Discount %:</span></div><div class=\"row no-margin\"><input ng-if=\"vm.co_object.status == 1\" type=number step=1 class=form-control ng-model=vm.co_object.hw_discount ng-change=vm.total_changes()> <span ng-if=\"vm.co_object.status != 1 && vm.co_object.hw_discount > 0\">{{vm.co_object.hw_discount}}</span></div></div><div ng-if=\"vm.co_object.status != 1 && vm.co_object.labor_discount > 0 || vm.co_object.status == 1\"><div class=\"row no-side-margin top10\"><span>Change Order Labor Discount %:</span></div><div class=\"row no-margin\"><input ng-if=\"vm.co_object.status == 1\" type=number class=form-control ng-model=vm.co_object.labor_discount ng-change=vm.total_changes()> <span ng-if=\"vm.co_object.status != 1 && vm.co_object.labor_discount > 0\">{{vm.co_object.labor_discount}}</span></div></div><div><div class=\"row no-side-margin top10\"><span>Tax:</span></div><div class=\"row no-margin\"><input ng-if=\"vm.co_object.status == 1\" type=number class=form-control ng-model=vm.co_object.tax> <span ng-if=\"vm.co_object.status != 1\">{{vm.co_object.tax}}</span></div></div><div><div class=\"row no-side-margin top10\"><span>Include Labor:</span><span class=add-pad><input type=checkbox ng-change=vm.total_changes() ng-model=vm.co_object.include_labor></span></div></div></div></div></div><div class=\"row center\" cg-busy=\"{promise:vm.load,delay:0,message:\'Loading Data\',minDuration:1000}\"><div ng-if=!vm.co_id><div class=box><div class=row><div class=col-sm-6><h3>Change Orders</h3></div></div></div><div class=box><div class=\"row bottom5\"><div class=col-sm-4><span class=my-form-control>{{vm.customer_name}}</span></div><div class=col-sm-4><span class=my-form-control>{{vm.estimate_id}}</span></div><div class=col-sm-4><span class=my-form-control>{{vm.title}}</span></div></div></div><div class=\"box bottom10\" ng-if=!vm.new_form><div class=box-content><div class=\"row bottom5\"><button class=btn ng-click=vm.create_new()>Create New Change Order</button></div></div></div><div class=\"box simple-border border-groove\" ng-if=vm.new_form><div class=box-content><div class=\"row bottom5\"><div class=form-group><label>External Reference:</label><input class=form-control type=text ng-model=vm.new_form_data.external_reference maxlength=255></div></div><div class=\"row bottom5\"><div class=form-group><label>Change Order Summary:</label><input class=form-control type=text ng-model=vm.new_form_data.description maxlength=255></div></div><div class=\"row bottom5\"><button class=\"btn btn-success\" ng-click=vm.save_new()>Create</button> <button class=btn ng-click=vm.cancel_new()>Cancel</button></div></div></div><!-- Create the existing box below make openable the pending ones, others, not --><div class=row><div class=col-sm-12 ng-if=\"vm.existing_change_orders.length && !vm.new_form\"><div class=\"simple-border border-groove\" ng-repeat=\"(k,co) in vm.existing_change_orders\"><div class=row><span class=col-sm-1 ng-if=!vm.existing_change_orders[k].expanded><i class=\"fa fa-plus text-primary\" ng-click=vm.expand(k)></i></span> <span class=col-sm-1 ng-if=vm.existing_change_orders[k].expanded><i class=\"fa fa-minus text-primary\" ng-click=vm.contract(k)></i></span> <span class=col-sm-2 ng-click=vm.open_co(co.name)>{{co.name}}</span> <span class=col-sm-8>({{co.description}})</span> <span class=col-sm-1 ng-if=\"co.status==1\"><i class=\"fa fa-clock-o text-warning\"></i></span> <span class=col-sm-1 ng-if=\"co.status==2\"><i class=\"fa fa-check-circle text-success\"></i></span> <span class=col-sm-1 ng-if=\"co.status==3\"><i class=\"fa fa-times-circle text-danger\"></i></span></div><div ng-if=vm.existing_change_orders[k].expanded><div class=row><span class=col-sm-1></span> <span class=col-sm-11>External Reference: {{co.external_reference}}</span></div><div class=row><span class=col-sm-1></span> <span class=col-sm-11>Created By: {{co.__meta.created.name}} ({{co.__meta.created.db_date}})</span></div><div class=row ng-if=\"co.updated_by > 0\"><span class=col-sm-1></span> <span class=col-sm-11>Updated By: {{co.__meta.updated.name}} ({{co.__meta.updated.db_date}})</span></div></div></div></div></div></div><div ng-if=vm.co_id><div class=box><div class=row><div class=col-sm-6><h3>Change Order {{vm.co_id}}</h3></div></div></div><div class=box><div class=\"row simple-border border-groove no-margin\"><nav class=\"nav no-print\"><ul class=\"nav nav-tabs\" style=border:none><li class=nav-item><a class=nav-link ng-click=\"vm.view=\'details\'\" href=# style=\"cursor: pointer\">CO Details</a></li><li class=nav-item><a ng-if=\"vm.co_object.status == 1\" ng-click=\"vm.view=\'parts\'\" href=# style=\"cursor: pointer\">Existing Parts</a></li><li ng-if=\"vm.co_object.status == 1\" class=nav-item><a ng-click=\"vm.view=\'additional\'\" href=# style=\"cursor: pointer\">Add Parts</a></li><li ng-if=\"vm.co_object.status == 1\" class=nav-item><a ng-click=\"vm.view=\'add_labor\'\" href=# style=\"cursor: pointer\">Add Labor</a></li><li class=nav-item><a ng-click=\"vm.view=\'scope\'\" href=# style=\"cursor: pointer\">Scope of Work</a></li><li class=nav-item><a ng-click=\"vm.view=\'notes\'\" href=# style=\"cursor: pointer\">Internal Notes</a></li><li class=nav-item><a ng-click=vm.save_co(1) href=# style=\"cursor: pointer\">Filter Changes</a></li><li class=nav-item><a ng-if=vm.co_object.include_labor ng-click=vm.save_co(2) href=# style=\"cursor: pointer\">Install Options</a></li><li ng-if=\"!vm.sameObj() && vm.co_object.status == 1\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a ng-click=vm.save_co()>Save</a></li></ul></nav></div></div><div ng-if=\"vm.view==\'details\'\"><div class=\"box-content center simple-border border-groove add-pad\"><div class=\"row bottom5 no-margin\"><div class=form-group><label>External Reference:</label><input ng-if=vm.editable class=form-control type=text ng-model=vm.co_object.external_reference maxlength=255> <span ng-if=!vm.editable>{{vm.co_object.external_reference}}</span></div></div><div class=\"row bottom5 no-margin\"><div class=form-group><label>Change Order Summary:</label><input ng-if=vm.editable class=form-control type=text ng-model=vm.co_object.description maxlength=255> <span ng-if=!vm.editable>{{vm.co_object.description}}</span></div></div><div class=\"row bottom5 no-margin\"><div class=form-group><label>Status:</label><div ng-if=vm.editable class=controls><ui-select ng-model=vm.tmp_status ng-disabled=vm.disabler() ng-change=vm.status_change()><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.status_select_array | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div><span ng-if=!vm.editable ng-repeat=\"status_obj in vm.status_select_array | filter:{id:vm.co_object.status}:true\">{{status_obj.name}}</span></div></div><div class=\"row no-margin\"><div class=form-group><label>Created On:</label>{{vm.co_object.__meta.created.db_date}} by {{vm.co_object.__meta.created.name}}</div></div><div ng-if=vm.co_object.__meta.updated><div class=\"row no-margin\"><div class=form-group><label>Updated On:</label>{{vm.co_object.__meta.updated.db_date}} by {{vm.co_object.__meta.updated.name}}</div></div></div></div></div><div ng-if=\"vm.view==\'scope\'\"><div class=\"container content\"><div class=\"module top15\"><div class=module-body><form class=\"form-horizontal row-fluid\"><textarea class=msd-elastic; ng-disabled=!vm.editable ng-model=vm.co_object.scope style=width:100%></textarea></form></div></div></div></div><div ng-if=\"vm.view==\'notes\'\"><div class=\"container content\"><div class=\"module top15\"><div class=module-body><form class=\"form-horizontal row-fluid\"><textarea class=msd-elastic; ng-disabled=!vm.editable ng-model=vm.co_object.notes style=width:100%></textarea></form></div></div></div></div><div ng-if=\"vm.view==\'audit\'\"><table class=\"table table-bordered table-striped\"><thead><th>Action</th><!-- <th>User</th> --><th>Date</th><th>Object</th></thead><tbody><tr ng-repeat=\"txn in vm.audit_results\"><td ng-repeat=\"action in vm.txnActions | filter:{id:txn.action}:true\">{{action.name}}</td><!-- <td ng-repeat=\"user in vm.nocUsers | filter:{user_id:txn.user_id}:true\">{{user.user_full_name}}</td> --><td>{{txn.date_modified | date:\"medium\"}}</td><td ng-if=txn.differences><table class=table><tr ng-repeat=\"(key,diff) in txn.differences\"><td>{{key}} changed from <b>{{diff.oldValue}}</b> to <b>{{diff.newValue}}</b></td></tr></table></td><td ng-if=\"!txn.old_object && txn.new_object\"><table class=table><tr ng-repeat=\"(key,val) in txn.new_object\"><td>{{key}} = {{val}}</td></tr></table></td><td ng-if=\"!txn.new_object && txn.old_object\"><table class=table><tr ng-repeat=\"(key,val) in txn.old_object\"><td>{{key}} = {{val}}</td></tr></table></td></tr></tbody></table></div><div ng-if=\"vm.view==\'parts\'\"><div class=module-body><div class=module-body><!-- SERVER START --><div class=review-box ng-if=vm.estimateData.parts.server><h4 class=review-header>Head End</h4><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.server><span class=review-span>{{ vm.estimateData.parts.server.qty}}</span> <span class=review-span>{{vm.estimateData.parts.server.product_description}} ({{vm.estimateData.parts.server.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'server\',vm.estimateData.parts.server.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'server\',vm.estimateData.parts.server,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'server\',vm.estimateData.parts.server,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{vm.estimateData.parts.server.qty+vm.get_change_q(\'server\',vm.estimateData.parts.server.product_part_number)+vm.get_other_q(\'server\',vm.estimateData.parts.server.product_part_number) }})</span></div><div><ul><li ng-repeat=\"(k,part) in vm.estimateData.parts.server.related_parts\" class=review-body-row ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'server\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'server\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'server\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'server\',part.related_part_number + vm.get_other_q(\'server\',part.related_part_number))}})</span></li></ul></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.selectLaborSubtotal(\'server\') | currency}}</span> Hardware: {{vm.selectSubtotal(\'server\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.server><span class=review-span>Labor: {{vm.total_object.labor.server | currency}}</span> Hardware: {{vm.total_object.hardware.server | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.server\">\n							<span class=\"review-span\">Labor: {{vm.selectLaborSubtotal(\'server\') + vm.total_object.labor.server | currency}}</span> Hardware: {{vm.selectSubtotal(\'server\') + vm.total_object.hardware.server | currency}}\n						</div> --></div><!-- SERVER END --><!-- INFRASTRUCTURE START --><div class=review-box ng-if=\"vm.estimateData.parts.repeater || vm.estimateData.parts.enrol || vm.estimateData.parts.power || vm.checkArray(\'wire\')\"><h4 class=review-header>Infrastructure</h4><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.repeater><span class=review-span>{{vm.estimateData.parts.repeater.qty}}</span> <span class=review-span>{{vm.estimateData.parts.repeater.product_description}} ({{vm.estimateData.parts.repeater.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',vm.estimateData.parts.repeater.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',vm.estimateData.parts.repeater,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',vm.estimateData.parts.repeater,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{vm.estimateData.parts.repeater.qty+vm.get_change_q(\'infrastructure\',vm.estimateData.parts.repeater.product_part_number)+vm.get_other_q(\'infrastructure\',vm.estimateData.parts.repeater.product_part_number)}})</span></div><div ng-if=vm.estimateData.part.repeater.related_parts><ul><li ng-repeat=\"part in vm.estimateData.parts.repeater.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'infrastructure\',part.related_part_number)+vm.get_other_q(\'infrastructure\',part.related_part_number)}})</span></li></ul></div><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.licensePart><span class=review-span>{{vm.estimateData.parts.licensePart.qty}}</span> <span class=review-span>{{vm.estimateData.parts.licensePart.product_description}} ({{vm.estimateData.parts.licensePart.product_part_number}})</span><!-- <span class=\"pull-right\">Change QTY: {{vm.get_change_q(\'licensePart\',vm.estimateData.parts.licensePart.product_part_number)}} <button ng-if=\"vm.editable\" class=\'fa fa-plus text-success\' ng-click=\"vm.qty_change(\'licensePart\',vm.estimateData.parts.licensePart,\'add\')\"></button><button ng-if=\"vm.editable\" class=\'fa fa-minus-circle text-danger\' ng-click=\"vm.qty_change(\'licensePart\',vm.estimateData.parts.licensePart,\'minus\')\"></button> <span ng-if=\"!vm.editable\" class=\"tab-1\"></span> Total({{vm.estimateData.parts.licensePart.qty+vm.get_change_q(\'licensePart\',vm.estimateData.parts.licensePart.product_part_number)}})</span> --></div><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.enrol><span class=review-span>{{vm.estimateData.parts.enrol.qty}}</span> <span class=review-span>{{vm.estimateData.parts.enrol.product_description}} ({{vm.estimateData.parts.enrol.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',vm.estimateData.parts.enrol.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',vm.estimateData.parts.enrol,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',vm.estimateData.parts.enrol,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{vm.estimateData.parts.enrol.qty+vm.get_change_q(\'infrastructure\',vm.estimateData.parts.enrol.product_part_number)+vm.get_other_q(\'infrastructure\',vm.estimateData.parts.enrol.product_part_number)}})</span></div><div><ul><li class=review-body-row ng-repeat=\"part in vm.estimateData.parts.enrol.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'infrastructure\',part.related_part_number)+vm.get_other_q(\'infrastructure\',part.related_part_number)}})</span></li></ul></div><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.power><span class=review-span>{{vm.estimateData.parts.power.qty}}</span> <span class=review-span>{{vm.estimateData.parts.power.product_description}} ({{vm.estimateData.parts.power.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',vm.estimateData.parts.power.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',vm.estimateData.parts.power,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',vm.estimateData.parts.power,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{vm.estimateData.parts.power.qty+vm.get_change_q(\'infrastructure\',vm.estimateData.parts.power.product_part_number)+vm.get_other_q(\'infrastructure\',vm.estimateData.parts.power.product_part_number)}})</span></div><div><ul><li class=review-body-row ng-repeat=\"part in vm.estimateData.parts.power.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'infrastructure\',part.related_part_number)+vm.get_other_q(\'infrastructure\',part.related_part_number)}})</span></li></ul></div><div class=review-body-row ng-repeat=\"value in vm.estimateData.parts.wire\" ng-if=\"value.qty > 0\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'infrastructure\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'infrastructure\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'infrastructure\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'wire\',value.product_part_number)+vm.get_other_q(\'wire\',value.product_part_number)}})</span></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.groupLaborSubtotal(\'infrastructure\') | currency}}</span> Hardware: {{vm.groupSubtotal(\'infrastructure\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.infrastructure><span class=review-span>Labor: {{vm.total_object.labor.infrastructure | currency}}</span> Hardware: {{vm.total_object.hardware.infrastructure | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.infrastructure\">\n							<span class=\"review-span\">Labor: {{vm.groupLaborSubtotal(\'infrastructure\') + vm.total_object.labor.infrastructure | currency}}</span> Hardware: {{vm.groupSubtotal(\'infrastructure\') + vm.total_object.hardware.infrastructure | currency}}\n						</div> --></div><!-- INFRASTRUCTURE END --><!-- NETWORK START --><div class=review-box ng-if=\"vm.checkArray(\'network\')\"><h4 class=review-header>Network</h4><div class=review-body-row ng-repeat=\"value in vm.estimateData.parts.network\" ng-if=\"value.qty > 0\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'network\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'network\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'network\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'network\',value.product_part_number)+vm.get_other_q(\'network\',value.product_part_number)}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'network\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'network\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'network\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'network\',part.related_part_number)+vm.get_other_q(\'network\',part.related_part_number)}})</span></li></ul></div></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'network\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'network\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.network><span class=review-span>Labor: {{vm.total_object.labor.network | currency}}</span> Hardware: {{vm.total_object.hardware.network| currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.network\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'network\') + vm.total_object.labor.network | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'network\') + vm.total_object.hardware.network | currency}}\n						</div> --></div><!-- NETWORK END --><!-- PAGING START --><div class=review-box ng-if=\"vm.checkArray(\'pager\') || vm.estimateData.parts.paging\"><h4 class=review-header>Paging</h4><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.paging><span class=review-span>{{ vm.estimateData.parts.paging.qty}}</span> <span class=review-span>{{vm.estimateData.parts.paging.product_description}} ({{vm.estimateData.parts.paging.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'notification\',vm.estimateData.parts.paging.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'notification\',vm.estimateData.parts.paging,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'notification\',vm.estimateData.parts.paging,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{vm.estimateData.parts.paging.qty+vm.get_change_q(\'notification\',vm.estimateData.parts.paging.product_part_number)+vm.get_other_q(\'notification\',vm.estimateData.parts.paging.product_part_number)}})</span></div><div ng-if=vm.estimateData.parts.paging.related_parts><ul><li class=review-body-row ng-repeat=\"part in vm.estimateData.parts.paging.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'notification\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'notification\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'notification\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'notification\',part.related_part_number)+vm.get_other_q(\'notification\',part.related_part_number)}})</span></li></ul></div><div class=review-body-row ng-repeat=\"value in vm.estimateData.parts.pager\" ng-if=\"value.qty > 0\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span ng-class-odd=\"\'darker\'\">{{value.qty}}</span> <span class=review-span ng-class-odd=\"\'darker\'\">{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'notification\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'notification\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'notification\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'notification\',value.product_part_number)+vm.get_other_q(\'notification\',value.product_part_number)}})</span></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.groupLaborSubtotal(\'notification\') | currency}}</span> Hardware: {{vm.groupSubtotal(\'notification\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.notification><span class=review-span>Labor: {{vm.total_object.labor.notification | currency}}</span> Hardware: {{vm.total_object.hardware.notification | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.notification\">\n							<span class=\"review-span\">Labor: {{vm.groupLaborSubtotal(\'notification\') + vm.total_object.labor.notification | currency}}</span> Hardware: {{vm.groupSubtotal(\'notification\') + vm.total_object.hardware.notification | currency}}\n						</div> --></div><!-- PAGING END --><!-- NURSECALL START --><div class=review-box ng-if=\"vm.checkArray(\'nurseCall\')\"><h4 class=review-header>Nurse Call</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.nurseCall\" ng-if=\"value.qty > 0\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'nurseCall\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'nurseCall\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'nurseCall\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'nurseCall\',value.product_part_number)}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'nurseCall\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'nurseCall\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'nurseCall\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'nurseCall\',part.related_part_number)+vm.get_other_q(\'nurseCall\',part.related_part_number)}})</span></li></ul></div></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'nurseCall\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'nurseCall\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.nurseCall><span class=review-span>Labor: {{vm.total_object.labor.nurseCall | currency}}</span> Hardware: {{vm.total_object.hardware.nurseCall | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.nurseCall\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'nurseCall\') + vm.total_object.nurseCall | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'nurseCall\') + vm.total_object.hardware.nurseCall | currency}}\n						</div> --></div><!-- NURSECALL END --><!-- DOORS START --><div class=review-box ng-if=vm.checkForDoors()><div><h4 class=review-header>Doors</h4></div><div class=review-box ng-repeat=\"value in vm.estimateData.door_information\"><h4 class=review-door-group-header>Doors in Group {{value.doors_in_group}} <i class=\"fa fa-minus-circle text-danger marg-right\" ng-if=vm.showEditQty() ng-click=\"vm.estimateData.door_information.splice($index, 1)\"></i></h4><div class=\"review-body-row lighter\" ng-repeat=\"(key,item) in value\" ng-if=\"(key == \'controller\' && value.controller) || (key == \'doorPosition\' && value.doorPosition) || (key == \'requestExit\' && value.requestExit) ||\n							(key == \'requestEnter\' && value.requestEnter) || (key == \'lockDevice\' && value.lockDevice) || (key == \'wanderPart\' && value.wanderPart) || (key == \'doorbellPart\' && value.doorbellPart)\"><span class=review-span>{{item.qty}}</span> <span class=review-span>{{item.product_description}} ({{item.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'door\',item.product_part_number,item.door_group,key)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'door\',item,\'add\',key)\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'door\',item,\'minus\',key)\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{item.qty+vm.get_change_q(\'door\',item.product_part_number,item.door_group,key)+vm.get_other_q(\'door\',item.product_part_number,item.door_group,key)}})</span><div ng-if=item.related_parts><ul><li class=review-body-row ng-repeat=\"part in item.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'door\',part.related_part_number,item.door_group,key)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'door\',part,\'add\',key,value.id)\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'door\',part,\'minus\',key,value.id)\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'door\',part.related_part_number,value.id,key)+vm.get_other_total(\'door\',part.related_part_number,value.id,key)}})</span></li></ul></div></div></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.doorLaborSubTotal() | currency}}</span> Hardware: {{vm.doorSubTotal() | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.door><span class=review-span>Labor: {{vm.total_object.labor.door | currency}}</span> Hardware: {{vm.total_object.hardware.door | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.door\">\n							<span class=\"review-span\">Labor: {{vm.doorLaborSubTotal() + vm.total_object.labor.door | currency}}</span> Hardware: {{vm.doorSubTotal() + vm.total_object.hardware.door | currency}}\n						</div> --></div><!-- DOORS END --><!-- DOOR SUPPLY START --><div class=review-box ng-if=\"vm.checkArray(\'doorSupplies\')\"><h4 class=review-header>Door Supplies</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.doorSupplies\" ng-if=\"value.qty > 0\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'doorSupplies\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'doorSupplies\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'doorSupplies\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'doorSupplies\',value.product_part_number)+vm.get_other_q(\'doorSupplies\',value.product_part_number)}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'doorSupplies\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'doorSupplies\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'doorSupplies\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'doorSupplies\',part.related_part_number)+vm.get_other_q(\'doorSupplies\',part.related_part_number)}})</span></li></ul></div></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'doorSupplies\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'doorSupplies\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.doorSupplies><span class=review-span>Labor: {{vm.total_object.labor.doorSupplies | currency}}</span> Hardware: {{vm.total_object.hardware.doorSupplies | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.doorSupplies\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'doorSupplies\') + vm.total_object.labor.doorSupplies | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'doorSupplies\') + vm.total_object.hardware.doorSupplies | currency}}\n						</div> --></div><!-- DOOR SUPPLY END --><!-- DEALER ASSISTANCE START --><div class=review-box ng-if=\"vm.checkArray(\'dealer\')\"><h4 class=review-header>Install Assistance</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.dealer\" ng-if=\"value.qty > 0\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'dealer\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'dealer\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'dealer\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'dealer\',value.product_part_number)+vm.get_other_q(\'dealer\',value.product_part_number)}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'dealer\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'dealer\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.dealer><span class=review-span>Labor: {{vm.total_object.labor.dealer | currency}}</span> Hardware: {{vm.total_object.hardware.dealer | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.dealer\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'dealer\') + vm.total_object.labor.dealer | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'dealer\') + vm.total_object.hardware.dealer | currency}}\n						</div> --></div><!-- DEALER ASSISTANCE END --><!-- LABOR START --><div class=review-box ng-if=\"vm.checkArray(\'travel\')\"><h4 class=review-header>Travel / Labor</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.travel\" ng-if=\"value.qty > 0\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><!-- <div class=\"review-footer\">\n							<span class=\"marg-right\">Labor: {{vm.travelLaborSubtotal(\'travel\') | currency}}</span>\n						</div> --></div><!-- LABOR END --><!-- ADDITIONAL PARTS START --><div class=review-box ng-if=\"vm.checkArray(\'addOns\')\"><h4 class=review-header>Additional Parts</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.addOns\" ng-if=\"value.qty > 0\"><span class=review-span>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'addOns\',value.product_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'addOns\',value,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'addOns\',value,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty+vm.get_change_q(\'addOns\',value.product_part_number)+vm.get_other_q(\'addOns\',value.product_part_number)}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'addOns\',part.related_part_number)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'addOns\',part,\'add\')\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'addOns\',part,\'minus\')\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{part.related_part_qty+vm.get_change_q(\'addOns\',part.related_part_number)+vm.get_other_q(\'addOns\',part.related_part_number)}})</span></li></ul></div></div><!-- <div class=\"review-footer\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'addOns\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'addOns\') | currency}}\n						</div> --><div class=review-footer ng-if=vm.co_object.data.addOns><span class=review-span>Labor: {{vm.co_change_labor_subtotal(\'addOns\') | currency}}</span> Hardware: {{vm.co_change_hw_subtotal(\'addOns\') | currency}}</div><!-- <div class=\"review-footer\" ng-if=\"vm.co_object.data.addOns\">\n							<span class=\"review-span\">Labor: {{vm.nonSelectLaborSubtotal(\'addOns\') + vm.co_change_labor_subtotal(\'addOns\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'addOns\') + vm.co_change_hw_subtotal(\'addOns\') | currency}}\n						</div> --></div><!-- ADDITIONAL PARTS END --><!-- This change order additional parts added --><div id=changeAddBox class=\"review-box anchor\" ng-if=vm.co_object.data.changeAdd><h4 class=review-header>This CO ({{vm.co_object.name}})</h4><div class=\"review-body-row lighter\" ng-repeat=\"(k,value) in vm.co_object.data.changeAdd\"><span class=review-span>0</span> <span class=review-span>{{value.product_description}} ({{k}})</span> <span class=pull-right>Change QTY: {{vm.get_change_q(\'changeAdd\',k)}} <button ng-if=vm.editable class=\"fa fa-plus text-success\" ng-click=\"vm.qty_change(\'changeAdd\',value,\'add\',null,null,undefined,k)\"></button> <button ng-if=vm.editable class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.qty_change(\'changeAdd\',value,\'minus\',null,null,undefined,k)\"></button> <span ng-if=!vm.editable class=tab-1></span> Total({{vm.get_change_q(\'changeAdd\',k)}})</span></div></div><!-- Previous Change Orders --><div ng-repeat=\"co in vm.other_change_orders\"><div ng-if=co.data.changeAdd><div class=review-box ng-if=vm.co_object.data.changeAdd><h4 class=review-header>{{co.name}}</h4><div class=\"review-body-row lighter\" ng-repeat=\"(k,value) in co.data.changeAdd\"><span class=review-span>0</span> <span class=review-span>{{value.product_description}} ({{k}})</span> <span class=pull-right>Change QTY: {{value.qty}}<!-- <button ng-if=\"vm.editable\" class=\'fa fa-plus text-success\' ng-click=\"vm.qty_change(\'changeAdd\',value,\'add\',null,null,undefined,k)\"></button>\n											<button ng-if=\"vm.editable\" class=\'fa fa-minus-circle text-danger\' ng-click=\"vm.qty_change(\'changeAdd\',value,\'minus\',null,null,undefined,k)\"></button> --> <span ng-if=!vm.editable class=tab-1></span> Total({{value.qty}})</span></div></div></div></div><!-- Previous Change Orders END --></div></div></div><div ng-if=\"vm.view==\'additional\'\"><div class=\"box-content center simple-border border-groove add-pad\"><div class=\"row no-margin\"><div class=form-group><label>Search Part:</label><input class=form-control type=text ng-model=vm.part_search_text maxlength=255> <button class=\"btn btn-primary top5\" ng-click=vm.searchProduct()>Search</button></div></div><div class=row ng-if=vm.additionalResluts.length><table datatable=ng class=table><thead><tr><td>Part</td><td></td></tr></thead><tbody><tr ng-repeat=\"p in vm.additionalResluts\"><td>{{p.product_description}} - ({{p.product_part_number}})</td><td><button class=\"btn btn-primary\" ng-click=vm.chosenPart(p)>Choose Part</button></td></tr></tbody></table></div></div></div><div ng-if=\"vm.view == \'add_labor\'\"><div class=module-body><form id=labor_form><!-- <div class=\"row\">\n						<span class=\"col-sm-3\">Project Hours: {{vm.hours}}</span>\n					</div> --><div class=\"module-body table\"><table cellpadding=0 cellspacing=0 border=0 id=pull_cord_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:55%>Description</th><th style=width:15%>Price</th><th style=width:15%>Quantity</th><th style=width:15%>Total</th></tr></thead><tbody ng-repeat=\"part in vm.co_object.travel_parts\"><tr><td>{{part.product_description}} ({{part.part_number}})</td><td><input type=text ng-model=part.price ng-change=vm.total_changes()></td><td><input type=text ng-model=part.qty ng-change=vm.total_changes()></td><td>{{part.qty*part.price | currency}}</td></tr></tbody></table></div></form></div></div><div ng-if=\"vm.view==\'filtered\'\"><div class=review-box ng-if=vm.co_object.data><h4 class=review-header>Edited Parts</h4><div class=review-body-row ng-repeat=\"part in vm.changes\" ng-if=vm.co_object.data ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><span class=review-span>{{part.name}} ({{part.part_number}})</span> <span class=pull-right>Change QTY: {{part.qty}} <span ng-if=!vm.editable class=tab-1></span></span></div></div></div><div ng-if=\"vm.view==\'install_quote\'\"><div class=\"box-content center simple-border border-groove add-pad\"><div class=\"row bottom5 no-margin\"><div class=form-group><label>Current Labor Cost:</label><span>{{vm.co_object.install_information.quoted_price | currency}}</span></div></div><div class=\"row bottom5 no-margin\"><div class=form-group><label>Select Installer:</label><ui-select ng-disabled=!vm.editable ng-model=vm.co_object.install_information.third_party_id ng-change=vm.install_calc()><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.thirdParties | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select><!-- <span ng-if=\"!vm.editable\" ng-repeat=\"status_obj in vm.status_select_array | filter:{id:vm.co_object.status}:true\">{{status_obj.name}}</span> --><!-- <span ng-if=\"!vm.editable\" ng-repeat=\"t_party in vm.thirdParties | filter:{id:vm.co_object.install_information.third_party_id}:true\">{{t_party.name}}</span> --></div></div><div class=\"row no-margin\"><div class=form-group><label>Installer to return parts:</label><span class=add-pad><input type=checkbox ng-disabled=!vm.editable ng-model=vm.co_object.install_information.include_return></span></div></div><div><div class=\"row no-margin\"><div class=form-group><label>Manual Install Additition:</label><input class=form-control type=number ng-disabled=!vm.editable ng-change=vm.install_calc() ng-model=vm.co_object.install_information.manual_input></div></div></div></div></div></div></div>");
$templateCache.put("app/changePassword/changePassword.html","<div class=page-header><div><h1>Password Update</h1></div></div><div class=box style=\"width:75%; margin:auto\"><div class=box-content><div class=row><div class=col-sm-12><h4>Password must have at least 8 characters, one capital, one lower case letter, a number and a symbol to be valid.</h4></div></div><div class=row><div class=col-sm-6 ng-class=\"{\'has-success\':vm.pass_valid}\"><div class=\"form-group has-feedback\"><label class=control-label>Enter the new password:</label><input type=password class=form-control ng-model=vm.submissionObj.password> <i ng-if=vm.pass_valid class=\"glyphicon glyphicon-ok form-control-feedback success\"></i></div></div></div><div class=row><div class=col-sm-6 ng-class=\"{\'has-success\':vm.passwordCheck().length == 0}\"><div class=\"form-group has-feedback\"><label class=control-label>Re-enter the new password:</label><input type=password class=form-control ng-model=vm.submissionObj.pass_verify> <i ng-if=\"vm.passwordCheck().length == 0\" class=\"glyphicon glyphicon-ok form-control-feedback success\"></i></div></div></div><div class=\"row top7\"><div class=col-sm-2><button class=\"btn btn-primary\" ng-click=vm.save() ng-if=\"vm.passwordCheck().length == 0\">Update Password</button></div></div><div class=\"row top5\" ng-repeat=\"err in vm.passwordCheck()\"><div class=col-sm-6>{{err}}</div></div></div></div>");
$templateCache.put("app/critAlerts/critAlerts.html","<script type=text/ng-template id=confirmAlert.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Would you like to confirm this alert?</h4>\n		</div>\n		<div class=\"modal-body table\">\n			<div>Alert ID: {{vm.active_id}}</div>\n			<div>Customer: {{vm.active_name}}</div>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-primary\" ng-click=\"vm.confirm_alert()\">Yes</button>\n			<button class=\"btn\" ng-click=\"vm.close_modal()\">No</button>\n    	</div>\n	</div></script><div class=page-header><div><h1>Quantum Alerts</h1></div></div><div class=col-sm-12><div class=\"col-sm-1 top7\">Show Confirmed?</div><div class=col-sm-1><select class=form-control ng-model=vm.confirmed_show ng-change=vm.load_data()><option value=no>No</option><option value=yes>Yes</option><option value=all>All</option></select></div><div class=\"col-sm-1 top7\">Show Closed?</div><div class=col-sm-1><select class=form-control ng-model=vm.closed ng-change=vm.load_data()><option value=no>No</option><option value=yes>Yes</option><option value=all>All</option></select></div><div class=\"col-sm-1 top7\">Show Alert?</div><div class=col-sm-2><select class=form-control ng-model=vm.alert_type ng-change=vm.load_data()><option value=server>Server Offline</option><option value=hardware>Hardware</option><option value=all>All</option></select></div><table class=table><thead><tr><th>ID</th><th>Site ID</th><th ng-click=\"vm.sort_by=\'quantum_customer/name\'; vm.sort_data()\">Site Name <span ng-show=\"vm.sort_by == \'quantum_customer/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'quantum_customer/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Phone Number</th><th>Alert Type</th><th ng-click=\"vm.sort_by=\'alert_start_time\'; vm.sort_data()\">Alert Start <span ng-show=\"vm.sort_by == \'alert_start_time\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'alert_start_time\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-if=\"vm.confirmed_show == \'no\'\">Open Time</th><th ng-if=\"vm.confirmed_show == \'yes\'\">User</th><th>Status</th><!-- <th ng-click=\"vm.sort_by=\'serverVersion\'; vm.sort_data()\">SW Version\n					<span ng-show=\"vm.sort_by == \'serverVersion\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span>\n					<span ng-show=\"vm.sort_by == \'serverVersion\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span>\n				</th> --></tr></thead><tbody><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.current_page total-items=vm.data.count><td>{{obj.id}}</td><td>{{obj.quantum_customer.id}}</td><td>{{obj.quantum_customer.name}}</td><td>{{obj.quantum_customer.phone}}</td><td>{{obj.critical_alert ? \"Offline Server\":\"Hardware\"}}</td><td>{{obj.alert_start_time | date:\'medium\'}}</td><td ng-if=\"vm.confirmed_show == \'no\'\">{{vm.seconds_to_days(obj.open_alert_duration)}}</td><td ng-if=\"vm.confirmed_show == \'yes\'\">{{obj.confirmed_user.name}}</td><td ng-if=obj.alert_confirmed>Confirmed</td><td ng-if=\"obj.alert_cleared && !obj.alert_confirmed\">Closed</td><td ng-if=\"!obj.alert_cleared && !obj.alert_confirmed\" class=negativeNumber ng-click=vm.open_modal(obj.id,obj.quantum_customer.name)>Open</td><!-- <td ng-repeat=\"setting in obj.server_settings | filter:{name:\'Server Version\'}\">{{setting.value}}</td> --></tr></tbody></table></div><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div>");
$templateCache.put("app/criticalAlertDetail/criticalAlertDetail.html","<div class=page-header><div><h1>{{vm.alertData.alertSite}} - {{vm.alertData.alertMonitor}}</h1><h4 class=text-muted>Alert Started: {{vm.alertData.alertStartTime}}</h4></div></div><div><h3>Alert Details</h3><table class=\"table table-striped\"><thead><tr><th>Type</th><th>Detail</th></tr></thead><tbody><tr><td>Alert Status</td><td><i ng-if=!vm.alertData.alertConfirmedBy class=\"fa fa-exclamation-triangle icon-fail-large\"></i> <i ng-if=vm.alertData.alertConfirmedBy class=\"fa fa-check-circle-o icon-ok-large\"></i> <span ng-if=vm.alertData.alertConfirmedBy><span ng-repeat=\"user in vm.userData | filter:{user_id:vm.alertData.alertConfirmedBy}:true\">{{user.user_full_name}} </span></span><span ng-if=!vm.alertData.alertConfirmedBy>Not Confirmed</span></td></tr><tr><td>Phone Number</td><td>{{vm.alertData.alertSitePhone}}</td></tr><tr><td>Site Details</td><td><a href=/customerDetail/{{vm.alertData.quantumSiteId}}>Click Here for Details</a></td></tr><tr><td>Alert Duration</td><td><span ng-if=!vm.alertData.alertCleared>{{vm.alertData.openAlertDuration}}</span> <span ng-if=vm.alertData.alertDuration>{{vm.alertData.AlertDuration}}</span> <span ng-if=\"!vm.alertData.alertDuration && vm.alertData.alertCleared\">Unknown Duration</span></td></tr></tbody></table></div><!-- <div class=\"row row-fluid\">\n		<div class=\"btn-box-text col-sm-6\">\n			<p>\n				<h5>Quick Notes</h5>\n			</p>\n			<h5><input type=\"text\" style=\"width:95%\" placeholder=\"Type note here\"></h5>\n			<span>\n				<span class=\"btn btn-primary\">Submit Note</span>\n			</span>\n		</div>\n	</div> --><div ng-if=!vm.notesEmpty()><h3>Quick Note History</h3><table class=\"datatable-1 table table-striped\"><thead><tr><th>User</th><th>Note</th><th>Date</th></tr></thead><tbody><tr ng-repeat=\"note in vm.ticketNotes\"><td><span ng-repeat=\"user in vm.userData | filter:{user_id:note.noteUser}\">{{user.user_full_name}}</span></td><td>{{note.quickNote}}</td><td>{{note.noteDate}}</td></tr></tbody></table></div>");
$templateCache.put("app/customerDetail/customerDetail.html","<script type=text/ng-template id=kioskModal.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Kiosk Admin</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row simple-border\">\n				<div class=\"col-sm-6\">\n					Kiosk (Elo) Production Number\n				</div>\n				<div class=\"col-sm-6\">\n					<input class=\"form-control\" type=\"number\" ng-model=\"vm.activeKiosk.production_number\">\n				</div>\n				<div class=\"col-sm-6\">\n					Kiosk (Elo) Name\n				</div>\n				<div class=\"col-sm-6\">\n					<input class=\"form-control\" type=\"text\" ng-model=\"vm.activeKiosk.name\">\n				</div>\n				<div class=\"col-sm-6\">\n					Kiosk (Elo) MAC\n				</div>\n				<div class=\"col-sm-6\">\n					<input class=\"form-control\" type=\"text\" ng-model=\"vm.activeKiosk.mac\">\n				</div>\n			</div>\n			<div class=\"row\">\n				<div class=\"col-sm-6\">\n					Has Temp Scanner?\n				</div>\n				<div class=\"col-sm-6\">\n					<input type=\"checkbox\" ng-model=\"vm.activeKiosk.temp_scanner.has_scanner\">\n				</div>\n				<div ng-if=\"vm.activeKiosk.temp_scanner.has_scanner\">\n					<div class=\"col-sm-6\">\n						Scanner Production Number\n					</div>\n					<div class=\"col-sm-6\">\n						<input class=\"form-control\" type=\"number\" ng-model=\"vm.activeKiosk.temp_scanner.scanner_production_number\">\n					</div>\n					<div class=\"col-sm-6\">\n						Scanner IP Address\n					</div>\n					<div class=\"col-sm-6\">\n						<input class=\"form-control\" type=\"text\" ng-model=\"vm.activeKiosk.temp_scanner.scanner_ip\">\n					</div>\n					<div class=\"col-sm-6\">\n						Scanner MAC\n					</div>\n					<div class=\"col-sm-6\">\n						<input class=\"form-control\" type=\"text\" ng-model=\"vm.activeKiosk.temp_scanner.scanner_mac\">\n					</div>\n				</div>\n			</div>\n			<div class=\"row simple-border\">\n				<div class=\"col-sm-6\">\n					Has Web Relay?\n				</div>\n				<div class=\"col-sm-6\">\n					<input type=\"checkbox\" ng-model=\"vm.activeKiosk.web_relay.has_web_relay\">\n				</div>\n				<div ng-if=\"vm.activeKiosk.web_relay.has_web_relay\">\n					<div class=\"col-sm-6\">\n						Web Relay Production Number\n					</div>\n					<div class=\"col-sm-6\">\n						<input class=\"form-control\" type=\"number\" ng-model=\"vm.activeKiosk.web_relay.relay_production_number\">\n					</div>\n					<div class=\"col-sm-6\">\n						Web Relay IP Address\n					</div>\n					<div class=\"col-sm-6\">\n						<input class=\"form-control\" type=\"text\" ng-model=\"vm.activeKiosk.web_relay.relay_ip\">\n					</div>\n					<div class=\"col-sm-6\">\n						Scanner MAC\n					</div>\n					<div class=\"col-sm-6\">\n						<input class=\"form-control\" type=\"text\" ng-model=\"vm.activeKiosk.web_relay.relay_mac\">\n					</div>\n				</div>\n			</div>\n			<div class=\"modal-footer\">\n				<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveKiosk()\">Save Kiosk</button>\n			  <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	</div>\n		</div>\n	</div></script><div class=page-header><div><h1>{{vm.customer_data.name}}</h1></div></div><div class=row style=\"margin-left: 0px; margin-right:0px\"><div class=col-sm-12 style=\"border-bottom: 1px solid #ddd\"><div class=col-sm-6><ul class=\"nav nav-tabs\" style=\"border-bottom: None\"><li ng-class=\"{\'active\':vm.view==\'qm\'}\"><a href=# ng-click=\"vm.view=\'qm\'\">Quantum Details</a></li></ul></div><div class=col-sm-6><div class=pull-right><button type=submit class=\"btn btn-success\" ng-click=vm.saveCustomer() ng-disabled=!vm.changed>Save</button></div></div></div></div><div class=row cg-busy={promise:vm.allegion_promise,delay:0,minDuration:200}><div class=col-sm-6><div><h3>Customer Details</h3><table class=\"table table-striped\"><thead><tr><th>Property</th><th>Detail</th></tr></thead><tbody><tr><td>Address</td><td>{{vm.customer_data.address}}, {{vm.customer_data.city}}, {{vm.customer_data.state}} {{vm.customer_data.zip}}</td></tr><tr><td>Phone Number</td><td>{{vm.customer_data.phone_number}}</td></tr><tr ng-if=\"vm.customer && vm.view==\'qm\'\"><td>Quantum Contact</td><td>{{vm.customer.mainContact}}</td></tr><tr ng-if=\"vm.customer.allegion_key && vm.view==\'qm\'\"><td>Allegion Key</td><td>{{vm.customer.allegion_key}}</td></tr><tr ng-if=\"vm.customer.allegion_key && vm.view==\'qm\'\"><td>Allegion Site Ref</td><td>{{vm.customer.allegion_site_reference}}</td></tr><tr ng-if=\"vm.customer && !vm.customer.allegion_key && vm.view==\'qm\'\"><td>Allegion Key</td><td><button type=submit class=\"btn btn-primary\" ng-if=!vm.customer.allegion_key ng-click=vm.allegion_enroll()>Create Allegion Key</button></td></tr><tr ng-if=\"vm.customer && vm.view==\'qm\'\"><td>Notes</td><td>{{vm.customer.siteNotes}}</td></tr><tr ng-if=\"vm.sstData && vm.view==\'sh\'\"><td>Notes</td><td>{{vm.sstData.notes}}</td></tr><tr><td>System Active</td><td><select class=form-control ng-change=vm.formChange() ng-model=vm.customer.active ng-options=\"item.value as item.lable for item in [{lable: \'Yes\', value: true },{ lable: \'No\', value: false }]\"></select></td></tr></tbody></table></div></div><div class=col-sm-6><div ng-if=\"vm.customer && vm.view==\'qm\'\"><h3>Support Details</h3><table class=\"table table-striped\"><thead><tr><th>Property</th><th>Detail</th></tr></thead><tbody><tr><td>TeamViewer Number</td><!-- <td>{{vm.customer.teamviewerNumber}}</td> --><td><input type=text class=form-control ng-model=vm.customer.teamviewerNumber ng-change=vm.formChange()></td></tr><tr><td>Crashplan Email</td><td>{{vm.customer.crashplanEmail}}</td></tr><tr><td>Crashplan Password</td><td>{{vm.customer.crashplanPassword}}</td></tr><tr><td>Server Location</td><td>{{vm.customer.serverLocation}}</td></tr><tr><td>Paging Location</td><td>{{vm.customer.pagingLocation}}</td></tr><tr><td>Contract Active</td><td><select class=form-control ng-change=vm.formChange() ng-model=vm.customer.support_contract_active ng-options=\"item.value as item.lable for item in [{lable: \'Yes\', value: true },{ lable: \'No\', value: false }]\"></select></td></tr></tbody></table></div><div ng-if=\"vm.sstData && vm.view==\'sh\'\"><h3>Support Details</h3><table class=\"table table-striped\"><thead><tr><th>Property</th><th>Detail</th></tr></thead><tbody><tr><td>Server Location / Address</td><td>{{vm.sstData.server_location}}</td></tr><tr><td>Server Type</td><td ng-repeat=\"type in vm.serverTypes | filter: vm.sstData.server_type:type.id\">{{type.name}}</td></tr><tr><td>Customer Subnet</td><td>{{vm.sstData.subnet}}</td></tr><tr><td>Customer Gateway</td><td>{{vm.sstData.gateway}}</td></tr><tr><td>Customer DNS</td><td>{{vm.sstData.dnsA}}</td></tr><tr><td>Customer DNS</td><td>{{vm.sstData.dnsB}}</td></tr><tr><td>TeamViewer Access</td><td>{{vm.sstData.teamviewer_access ? \"YES\":\"NO\"}}</td></tr><tr ng-if=vm.sstData.teamviewer_access><td>TeamViewer Number</td><td>{{vm.sstData.teamviewer_number}}</td></tr><tr ng-if=vm.sstData.teamviewer_access><td>TeamViewer Password</td><td>{{vm.sstData.teamviewer_password}}</td></tr><tr ng-if=\"vm.customer && vm.view==\'qm\'\"><td>Contract Active</td><td><select class=form-control ng-change=vm.formChange() ng-model=vm.customer.support_contract_active ng-options=\"item.value as item.lable for item in [{lable: \'Yes\', value: true },{ lable: \'No\', value: false }]\"></select></td></tr></tbody></table></div></div></div><div ng-if=\"vm.view==\'qm\' && !vm.customer\"><div class=row><div class=col-sm-6><h2>No Quantum System Found</h2></div></div></div><div ng-if=\"vm.view==\'sh\' && !vm.sstData\"><div class=row><div class=col-sm-6><h2>No SafeHealth System Found</h2></div></div></div><div ng-if=\"vm.view==\'qm\' && vm.customer\"><div class=row><div class=col-sm-6><h3>Dealers / Sub Contracters</h3><table class=\"table table-striped\"><ui-select ng-change=vm.formChange() ng-model=vm.customer.assigned_third_party multiple><ui-select-match placeholder=\"Choose Dealers / Subs allowed to access this system\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user in vm.active_third_parties | filter:$select.search\">{{user.name}}</ui-select-choices></ui-select></table></div></div><div class=row><div class=col-sm-6><h3>System Settings</h3><table class=\"table table-striped\"><thead><tr><th>Property</th><th>Detail</th></tr></thead><tbody><tr ng-repeat=\"setting in vm.customer.server_settings\"><td>{{setting.name}}</td><td>{{setting.value}}</td></tr></tbody></table></div><div class=col-sm-6><h3>System Licensing</h3><table class=\"table table-striped\"><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr ng-repeat=\"license in vm.customer.server_license\"><td>{{license.name}}</td><td ng-class={success:license.active,danger:!license.active}>{{license.active?\'Active\':\'Inactive\'}}</td></tr></tbody></table></div></div><div class=row cg-busy={promise:vm.populatePromise,delay:0,minDuration:1000} ng-if=vm.customer.allegion_key><div class=col-sm-12 ng-if=vm.hardwareLoaded><h3><span class=col-sm-6>Allegion Hardware</span></h3><button type=submit class=\"btn btn-primary\" ng-click=vm.allegion_rectify_hardware()>Retrieve Hardware From Allegion Cloud</button><table datatable=ng class=table><thead><tr><th>Name</th><th>Device Ref</th><th>Device Type</th><th>Short SN</th><th>Long SN</th></tr></thead><tbody><tr ng-repeat=\"hw in vm.customer.allegion_hardware\"><td>{{hw.friendly_name}}</td><td>{{hw.dev_reference}}</td><td>{{hw.device_type}}</td><td>{{hw.serial_number_short}}</td><td>{{hw.serial_number_long}}</td></tr></tbody></table></div></div><div class=row cg-busy={promise:vm.populatePromise,delay:0,minDuration:1000}><div class=col-sm-12 ng-if=vm.hardwareLoaded><h3>Backup Data</h3><table class=table><thead><tr><th>Filename</th><th>sha1</th><th>Size</th><th>Tool Version</th><th>Last Success</th></tr></thead><tbody><tr><td>{{vm.customer.backup.filename}}</td><td>{{vm.customer.backup.sha1}}</td><td>{{vm.customer.backup.size}}</td><td ng-if=vm.customer.backup.debug_info.version>{{vm.customer.backup.debug_info.version}}</td><td ng-if=!vm.customer.backup.debug_info.version>0</td><td>{{vm.customer.backup.timestamp | date:\'medium\'}}</td></tr></tbody></table></div></div><div class=row cg-busy={promise:vm.populatePromise,delay:0,minDuration:1000}><div class=col-sm-12 ng-if=vm.hardwareLoaded><h3>Estimate Data</h3><table datatable=ng class=table><thead><tr><th>Estimate</th><th>Title</th><th>Closed Date</th><th>Install Date</th><th># Doors</th><th>Inovonics Location</th><th>Pull Cords</th></tr></thead><tbody><tr ng-repeat=\"est in vm.estimate_data.data\"><td>{{est.estimate_id}}</td><td>{{est.title}}</td><td>{{est._meta.estimated_close | date : med}}</td><td>{{est._meta.estimated_install | date : med}}</td><td>{{est.door_data.expected_doors}}</td><td>{{est.settings.inovonics_location ? \"YES\":\"NO\"}}</td><td><span ng-repeat=\"pc in est.pull_cord_data\">{{pc.pn}}({{pc.count}})<br></span></td></tr></tbody></table></div></div><div class=row cg-busy={promise:vm.populatePromise,delay:0,minDuration:1000}><div class=col-sm-12 ng-if=vm.hardwareLoaded><h3>Known Hardware</h3><table datatable=ng class=table><thead><tr><th style=text-align:center>Serial Number</th><th>Product</th><th style=text-align:center>Date Tested</th><th style=text-align:center>Test Passed</th></tr></thead><tbody><tr ng-repeat=\"hw in vm.hardware\"><td>{{hw.serial_number}}</td><td>{{hw.product.name}}</td><td>{{hw.tested_date | date : med}}</td><td ng-class={success:hw.test_passed,danger:!hw.test_passed}>{{hw.test_passed?\"Yes\":\"No\"}}</td></tr></tbody></table></div></div><div class=row cg-busy={promise:vm.populatePromise,delay:0,minDuration:1000}><div class=col-sm-12 ng-if=vm.hardwareLoaded><h3>Unknown Hardware</h3><table datatable=ng class=table><thead><tr><th>Product Type</th><th>Serial Number</th><th>Date Entered</th><th>PTI</th></tr></thead><tbody><tr ng-repeat=\"hw in vm.unknownHardware.data\"><td>{{hw.type_description}}</td><td>{{hw.serial_number}}</td><td>{{hw.date_entered | date : medium}}</td><td>{{hw.pti}}</td></tr></tbody></table></div></div></div><div ng-if=\"vm.view==\'sh\' && vm.sstData\"><div class=row><div class=col-sm-12><div class=col-sm-11><h3>Kiosk List</h3></div><div class=\"actions col-sm-1 pull-right\" style=\"margin-top: 20px; margin-bottom:10px\"><a class=\"btn btn-mini\" ng-click=vm.addKiosk()><i class=\"fa fa-plus\"></i></a></div><table class=\"table table-striped\"><thead><tr><th>Production Number</th><th>Name</th><th>MAC</th><th>Has Scanner</th><th>Scanner Production Number</th><th>Scanner MAC</th><th>Scanner IP</th><th>Has Web Relay</th><th>Relay Production Number</th><th>Relay MAC</th><th>Relay IP</th></tr></thead><tbody><tr ng-repeat=\"kiosk in vm.kioskData\" ng-click=vm.loadKiosk(kiosk.id)><td>{{kiosk.production_number}}</td><td>{{kiosk.name}}</td><td>{{kiosk.mac}}</td><td>{{kiosk.temp_scanner.has_scanner?\"Yes\":\"No\"}}</td><td>{{kiosk.temp_scanner.scanner_production_number}}</td><td>{{kiosk.temp_scanner.scanner_mac}}</td><td>{{kiosk.temp_scanner.scanner_ip}}</td><td>{{kiosk.web_relay.has_web_relay?\"Yes\":\"No\"}}</td><td>{{kiosk.web_relay.relay_production_number}}</td><td>{{kiosk.web_relay.relay_mac}}</td><td>{{kiosk.web_relay.relay_ip}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/estimatorBuildDealerEstimate/buildDealerEstimate.html","<script type=text/ng-template id=enterQTY.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Enter Quantity</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-7\">{{vm.otherPart.product_description}}</span><span class=\"col-sm-2\">Quantity</span><span class=\"col-sm-3\"><input class=\"form-control\" ng-model=\"vm.otherPart.qty\"></span>\n			</div>\n			<div class=\"modal-footer\">\n				<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.savePart(3)\">Add Part To Quote</button>\n			  <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	</div>\n		</div>\n	</div></script><nav class=\"nav nav-inverse\"><ul class=\"nav nav-tabs\"><li ng-if=\"vm.sameObj() && vm.submissionObj.estimate_data.t_party_client_id && vm.submissionObj.estimate_data.t_party_client_contact_id && vm.submissionObj.estimate_data.status == 2\" class=nav-item style=\"cursor: pointer\"><a ng-click=vm.createOpportunity()>Create Opportunity</a></li><li ng-if=vm.quantumValid() class=nav-item style=\"cursor: pointer\"><a ng-click=vm.sealTheDeal()>Customer has Signed!</a></li><li ng-if=\"vm.submissionObj.estimate_data.status == 0 || vm.submissionObj.estimate_data.status == 2 || (vm.submissionObj.estimate_data.status == 1 && vm.userData.data.estimate_admin == 1)\" class=nav-item style=\"cursor: pointer\"><a ng-click=vm.levelUp()>{{vm.actionName()}}</a></li><li class=nav-item style=\"cursor: pointer\"><a ng-click=vm.goSearch()>Estimate Search</a></li><li ng-if=\"!vm.disabler() && vm.submissionObj.estimate_data.status != 0\" class=nav-item style=\"cursor: pointer\"><a ng-click=vm.makeEditable()>Make Editable</a></li><li ng-if=\"vm.submissionObj.estimate_data.status <= 2\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a href={{vm.dealerView}} target=_blank>Dealer View</a></li><li ng-if=\"vm.userData.data.estimate_admin == 1\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a href={{vm.equations}} target=_blank>Parts with Equations</a></li><!-- <li ng-if=\"vm.estimateData.estimate_status_id == 2\" class=\"nav-item pull-right\" style=\"cursor: pointer;\">\n			<a href=\"{{vm.jobPack}}\" target=\"_blank\">Job Pack</a>\n		</li> --></ul></nav><nav class=nav><ul class=\"nav nav-tabs\"><li class=nav-item><a class=nav-link ng-click=\"vm.view = \'details\'\" href=# style=\"cursor: pointer\">Estimate Details</a></li><li class=nav-item><a ng-click=\"vm.view = \'parts\'\" href=# style=\"cursor: pointer\">Parts</a></li><li class=nav-item><a ng-click=\"vm.view = \'scope\'\" href=# style=\"cursor: pointer\">Scope of Work</a></li><li ng-if=!vm.sameObj() class=\"nav-item pull-right\" style=\"cursor: pointer\"><a ng-click=vm.saveEstimate()>Save</a></li></ul></nav><div class=module cg-busy={promise:vm.populatePromise,delay:200,minDuration:500}><!-- <div class=\"module-head\">\n		<div class=\"row\">\n			<div class=\"col-sm-6\"><h3>Estimate Builder</h3></div>\n		</div>\n	</div> --><div class=\"row customRow nonT-review-header\" ng-if=\"vm.submissionObj.estimate_data && vm.statuses\"><!-- </div>\n	<div class=\"row customRow review-header\"> --> <span class=col-sm-4>{{vm.customerInfo.company_name}}</span> <span class=col-sm-4>Estimate: {{vm.submissionObj.estimate_data.estimate_id}}</span> <span class=\"col-sm-4 pull-right\" ng-repeat=\"status in vm.statuses | filter:{id:vm.submissionObj.estimate_data.status}:true\">Status: {{status.status}}</span> <span class=col-sm-4>Hardware Total: {{vm.total().hw | currency}}</span> <span class=col-sm-4>Dealer Total: {{vm.totalObject.hwD | currency}}</span> <span ng-if=!vm.submissionObj.estimate_data.jnl_install class=col-sm-4>Total Hours: {{vm.totalObject.hours}}</span> <span ng-if=vm.submissionObj.estimate_data.jnl_install class=col-sm-4>Total Labor: {{vm.totalObject.labor | currency}}</span></div><div ng-if=\"vm.view == \'details\'\"><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Title:</label><div class=\"controls customPadLeft customPadBottom col-sm-10\"><input name=hourly_labor id=hourly_labor class=form-control ng-model=vm.submissionObj.estimate_data.title></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top5\">Budgetary?:</label><div class=col-sm-4><button class=btn ng-click=\"vm.submissionObj.estimate_data.budgetary = false\" ng-class=\"{\'btn-success\': !vm.submissionObj.estimate_data.budgetary}\">No</button> <button class=btn ng-click=\"vm.submissionObj.estimate_data.budgetary = true\" ng-class=\"{\'btn-primary\': vm.submissionObj.estimate_data.budgetary}\">Yes</button></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top5\">Inactive?:</label><div class=col-sm-4><button class=btn ng-click=\"vm.submissionObj.estimate_data.inactive = false\" ng-class=\"{\'btn-success\': !vm.submissionObj.estimate_data.inactive}\">No</button> <button class=btn ng-click=\"vm.submissionObj.estimate_data.inactive = true\" ng-class=\"{\'btn-danger\': vm.submissionObj.estimate_data.inactive}\">Yes</button></div></div><div class=\"row bottom10\"><label class=col-sm-2>Probability:</label><div class=row><div class=col-sm-1 ng-repeat=\"prob in vm.probOptions\">{{prob}} <input type=radio class=btn ng-click=vm.probCheck() ng-model=vm.submissionObj.estimate_data.probability ng-value=prob></div></div></div><div class=row ng-if=\"vm.submissionObj.estimate_data.probability >= 75\"><div class=col-md-4><p class=input-group><label class=col-sm-4>Close Date:</label><input type=text class=\"form-control col-sm-6\" uib-datepicker-popup={{vm.format}} ng-model=vm.submissionObj.estimate_data.estimated_close is-open=vm.popup1.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=vm.altInputFormats disabled> <span class=input-group-btn><button type=button class=\"btn top23\" ng-click=vm.open1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-md-4><p class=input-group><label class=col-sm-4>Ship Date:</label><input type=text class=\"form-control col-sm-6\" uib-datepicker-popup={{vm.format}} ng-model=vm.submissionObj.estimate_data.estimated_ship is-open=vm.popup2.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=vm.altInputFormats disabled> <span class=input-group-btn><button type=button class=\"btn top23\" ng-click=vm.open2()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-md-4><p class=input-group><label class=col-sm-4>Install Date:</label><input type=text class=\"form-control col-sm-6\" uib-datepicker-popup={{vm.format}} ng-model=vm.submissionObj.estimate_data.estimated_install is-open=vm.popup3.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=vm.altInputFormats disabled> <span class=input-group-btn><button type=button class=\"btn top23\" ng-click=vm.open3()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"row bottom10\"><span ng-if=\"vm.userData.data.estimate_admin == 1\"><label class=\"col-sm-2 top7\">Hourly Labor:</label><div class=\"controls col-sm-10 customPadLeft\"><input name=hourly_labor id=hourly_labor class=form-control style=width:120px ng-model=vm.submissionObj.estimate_data.labor_cost ng-disabled=vm.disabler()></div></span></div><div class=\"row bottom10\"><span ng-if=\"vm.userData.data.estimate_admin == 1\"><label class=\"col-sm-2 top7\">Hourly Labor - Location:</label><div class=\"controls col-sm-10 customPadLeft\"><input name=hourly_labor_location id=hourly_labor_location class=form-control style=width:120px ng-model=vm.submissionObj.estimate_data.location_cost ng-disabled=vm.disabler()></div></span></div><div class=\"row bottom10\"><span ng-if=\"vm.userData.data.estimate_admin == 1\"><label class=\"col-sm-2 top7\">Hours per Repeater:</label><div class=\"controls col-sm-10 customPadLeft customPadBottom\"><input name=repeater_hours id=repeater_hours class=\"form-control col-sm-10\" style=width:120px ng-model=vm.submissionObj.estimate_data.location_hours ng-disabled=vm.disabler()></div></span></div><div class=row><label class=\"col-sm-2 top7\">Dealer Contact:</label><div class=\"controls col-sm-10 customPadBottom customPadLeft\"><ui-select ng-model=vm.submissionObj.estimate_data.site_contact ng-disabled=vm.disabler()><ui-select-match class=ui-select-match>{{$select.selected.first_name}} {{$select.selected.last_name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.customerInfo.contacts | filter:$select.search\">{{item.first_name}} {{item.last_name}}</ui-select-choices></ui-select></div></div><div class=row><label class=\"col-sm-2 top10\">Site:</label><div class=\"controls col-sm-10 top7 customPadBottom customPadLeft\"><select chosen class=col-sm-6 ng-model=vm.selectedSite ng-options=\"p as p.company_name for (k,p) in vm.otherCustomers\" ng-change=vm.selectSite() ng-disabled=vm.disabler()><option value=\"\"></option></select></div></div><div class=row><label class=\"col-sm-2 top10\">Site Contact:</label><div class=\"controls col-sm-10 top7 customPadBottom customPadLeft\"><select class=col-sm-6 chosen data-placeholder-text-single=\"\'Choose a contact\'\" ng-model=vm.submissionObj.estimate_data.t_party_client_contact_id ng-options=\"k as p.first_name+\' \'+p.last_name for (k,p) in vm.selectedSiteContacts\" ng-disabled=vm.disabler()></select></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">City:</label><div class=\"col-sm-10 top7\">{{vm.customerInfo.city}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">State:</label><div class=\"col-sm-10 top7\">{{vm.customerInfo.state}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Phone:</label><div class=\"col-sm-10 top7\">{{vm.customerInfo.phone_number}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">JNL Sales:</label><div class=\"col-sm-10 top7\" ng-repeat=\"user in vm.jnlUsers | filter:{user_id:vm.submissionObj.estimate_data.owner}:true\">{{user.user_full_name}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">JNL Install:</label><div class=\"col-sm-10 top7\"><input type=checkbox ng-model=vm.submissionObj.estimate_data.jnl_install ng-disabled=vm.disabler()></div></div></div><div class=\"row top15\" ng-if=\"vm.submissionObj.estimate_data.jnl_install && vm.view == \'parts\'\"><button class=\"btn-r left15\" ng-click=\"vm.subView = \'non\'\">Non-Install Parts<button class=\"btn-r left5\" ng-click=\"vm.subView = \'install\'\">Install</button></button></div><div ng-if=\"vm.view == \'parts\' && vm.subView == \'non\'\"><div class=\"module-body top7\"><div class=bottom17><div ng-show=vm.serverHide><span ng-click=\"vm.serverHide=false\"><i class=\"fa fa-plus-square-o\" aria-hidden=true></i> Show Head End</span></div><div ng-hide=vm.serverHide><span ng-click=\"vm.serverHide=true\"><i class=\"fa fa-minus-square-o\" aria-hidden=true></i> Hide Head End</span><div class=\"row bottom7\"><span class=col-sm-1></span><label class=\"col-sm-2 top7\">Server Select:</label><div class=\"controls col-sm-5\"><select class=form-control name=server_select ng-model=vm.submissionObj.server ng-change=\"vm.quantityHandle(\'server\')\" ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.available_servers track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></div></div><div id=related_parts ng-if=vm.submissionObj.server.related_parts><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped display\" width=100%><thead><tr><th>Sub Parts</th><th>Quantity</th></tr></thead><tbody id=tbody_related_parts><tr ng-repeat=\"relatedPart in vm.submissionObj.server.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div></div></div><div class=bottom17><div ng-show=vm.repeaterHide><span ng-click=\"vm.repeaterHide=false\"><i class=\"fa fa-plus-square-o\" aria-hidden=true></i> Show Repeater</span></div><div ng-hide=vm.repeaterHide><span ng-click=\"vm.repeaterHide=true\"><i class=\"fa fa-minus-square-o\" aria-hidden=true></i> Hide Repeater</span><div class=\"row bottom7\"><span class=col-sm-1></span><label class=\"col-sm-2 top7\">Repeater Select:</label><div class=\"controls col-sm-5\"><select class=form-control ng-model=vm.submissionObj.repeater ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.available_repeaters track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></div><div ng-show=vm.submissionObj.repeater><div class=\"col-sm-1 top7\">Quantity:</div><div class=col-sm-1><input ng-model=vm.submissionObj.repeater.qty class=form-control ng-disabled=vm.disabler()></div><!-- <div class=\"col-sm-1 top7\">\n								Location:\n							</div>\n							<div class=\"col-sm-1 top7\">\n								<input ng-change=\"vm.licenseFinder()\" ng-model=\"vm.submissionObj.estimate_data.inovonics_location\" type=\"checkbox\" ng-disabled=\"vm.disabler()\">\n							</div> --></div></div><!-- <div class=\"row\" ng-if=\"vm.submissionObj.estimate_data.inovonics_location\">\n						<span class=\"col-sm-1\"></span>\n						<label class=\"col-sm-2 top7\">Amount of Echostream Devices:</label>\n						<span class=\"col-sm-5 top7\"><input class=\"form-control\" type=\"number\" ng-keyup=\"vm.licenseFinder()\" ng-model=\"vm.submissionObj.estimate_data.future_devices\" min=\"0\" max=\"3000\" ng-disabled=\"vm.disabler()\"></span>\n					</div> --><!-- <div class=\"row\">\n						<span class=\"col-sm-1\"></span>\n						<label class=\"col-sm-2 top7\">Nurse Call License:</label>\n						<span class=\"col-sm-9 top7\">{{vm.submissionObj.license.product_description}} - ({{vm.submissionObj.license.product_part_number}})</span>\n					</div> --><div id=related_parts ng-if=vm.submissionObj.repeater.related_parts><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped display\" width=100%><thead><tr><th>Sub Parts</th><th>Quantity</th></tr></thead><tbody id=tbody_related_parts><tr ng-repeat=\"relatedPart in vm.submissionObj.server.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div></div></div><div class=bottom17><div ng-if=vm.available_infrastructure.length class=bottom10><div ng-show=vm.otherInfrastructure><span ng-click=\"vm.otherInfrastructure=false\"><i class=\"fa fa-plus-square-o\" aria-hidden=true></i> Show Recommended Infrastructure</span></div><div ng-hide=vm.otherInfrastructure><span ng-click=\"vm.otherInfrastructure=true\"><i class=\"fa fa-minus-square-o\" aria-hidden=true></i> Hide Recommended Infrastructure</span><div class=\"row top5 bottom10\"><span class=col-sm-1></span><label class=\"col-sm-2 top7\">Part Select:</label><div class=\"controls col-sm-5\"><select chosen class=form-control ng-model=vm.selectedPart ng-disabled=vm.disabler() ng-change=\"vm.selectedPart.qty = 1\" ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.available_infrastructure track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></div><div ng-show=vm.selectedPart><div class=\"col-sm-1 top7\">Quantity:</div><div class=col-sm-1><input ng-model=vm.selectedPart.qty ng-change=vm.updateQty() class=form-control></div><div class=col-sm-2><button class=\"btn btn-success form-control\" ng-click=vm.savePart(2)>Add To Quote</button> <button class=\"btn form-control\" ng-click=vm.cancelPart(2)>Cancel</button></div></div></div><div id=related_parts ng-if=vm.selectedPart.related_parts><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped display\" width=100%><thead><tr><th>Sub Parts</th><th>Quantity</th></tr></thead><tbody id=tbody_related_parts><tr ng-repeat=\"relatedPart in vm.selectedPart.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><div ng-if=vm.submissionObj.infrastructure.length><div class=\"simple-border bottom5pad\" ng-repeat=\"(k,p) in vm.submissionObj.infrastructure\"><div class=row><span class=col-sm-1></span> <span class=col-sm-1 style=text-align:right><i class=\"fa fa-minus-circle text-danger\" aria-hidden=true ng-click=\"vm.removePartFromArray(\'infrastructure\',k)\" ng-disabled=vm.disabler()></i></span> <span class=\"col-sm-6 nonT-part-header\">{{p.product_description}} - ({{p.product_part_number}})</span> <span class=col-sm-4>{{p.qty}}</span></div><div ng-repeat=\"rp in p.related_parts\"><div class=row><span class=col-sm-2></span> <span class=col-sm-6>{{rp.related_part_description}} - ({{rp.related_part_number}})</span> <span class=col-sm-4>{{rp.related_part_qty}}</span></div></div></div></div></div></div></div><div ng-show=vm.otherParts><span ng-click=\"vm.otherParts=false\"><i class=\"fa fa-plus-square-o\" aria-hidden=true></i> Show Other Parts</span></div><div ng-hide=vm.otherParts><div class=row><span class=col-sm-12 ng-click=\"vm.otherParts=true\"><i class=\"fa fa-minus-square-o\" aria-hidden=true></i> Hide Other Parts</span> <span class=col-sm-3><label>Type Part Number or Part Description to search for a part:</label></span><span class=col-sm-5><input ng-model=vm.searchValue class=form-control></span><span class=col-sm-4><button class=\"btn btn-primary\" ng-click=vm.searchProduct()>Search</button></span></div><div class=row ng-if=vm.searchResults.length><table datatable=ng class=table><thead><tr><td>Part</td><td></td></tr></thead><tbody><tr ng-repeat=\"p in vm.searchResults\"><td>{{p.product_description}} - ({{p.product_part_number}})</td><td><button class=\"btn btn-primary\" ng-click=vm.chosenPart(p)>Choose Part</button></td></tr></tbody></table></div><div class=row ng-if=vm.submissionObj.other.length><div class=\"simple-border bottom5pad\" ng-repeat=\"(k,p) in vm.submissionObj.other\"><div class=row><span class=col-sm-1></span> <span class=col-sm-1 ng-if=vm.disabler()></span> <span class=col-sm-1 style=text-align:right ng-if=!vm.disabler()><i class=\"fa fa-minus-circle text-danger\" aria-hidden=true ng-click=\"vm.removePartFromArray(\'other\',k)\"></i></span> <span class=\"col-sm-6 nonT-part-header\">{{p.product_description}} - ({{p.product_part_number}})</span> <span class=col-sm-4>{{p.qty}}</span></div><div ng-repeat=\"rp in p.related_parts\"><div class=row><span class=col-sm-2></span> <span class=col-sm-6>{{rp.related_part_description}} - ({{rp.related_part_number}})</span> <span class=col-sm-4>{{rp.related_part_qty}}</span></div></div></div></div></div></div></div><div ng-if=\"vm.view == \'parts\' && vm.subView == \'install\'\"><div class=module-body><form id=labor_form><div class=row><span class=col-sm-3>Project Hours: {{vm.totalObject[\'hours\']}}</span></div><div class=\"module-body table\"><table cellpadding=0 cellspacing=0 border=0 id=pull_cord_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:55%>Description</th><th style=width:15%>Price</th><th style=width:15%>Quantity</th><th style=width:15%>Total</th></tr></thead><tbody ng-repeat=\"part in vm.submissionObj.install\"><tr><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.product_price ng-disabled=vm.disabler()></td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td><td>{{vm.totalPartPrice(part.product_price,part.qty) | currency}}</td></tr></tbody></table></div></form></div></div><div ng-if=\"vm.view == \'scope\'\"><div class=\"container content\"><div class=module><div class=module-body><form class=\"form-horizontal row-fluid\"><textarea class=msd-elastic; ng-disabled=vm.disabler() ng-model=vm.submissionObj.scope style=width:80%></textarea></form></div></div></div></div></div>");
$templateCache.put("app/estimatorBuilder/estimateBuilder.html","<script type=text/ng-template id=enterQTY.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Enter Quantity</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-7\">{{vm.otherPart.product_description}}</span><span class=\"col-sm-2\">Quantity</span><span class=\"col-sm-3\"><input class=\"form-control\" ng-model=\"vm.otherPart.qty\"></span>\n				<span class=\"col-sm-7\"></span><span class=\"col-sm-2\">Discount</span><span class=\"col-sm-3\"><input class=\"form-control\" ng-model=\"vm.otherPart.discount\"></span>\n			</div>\n			<div class=\"modal-footer\">\n				<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.accAdd()\">Add Part To Quote</button>\n			  <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	</div>\n		</div>\n	</div></script><script type=text/ng-template id=opportunity_handle.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Opportunity Management</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-1\"></span><span class=\"col-sm-7\">Name</span><span class=\"col-sm-4\">Status</span>\n			</div>\n			<div class=\"row\" ng-repeat=\"(k,opp) in vm.opp_array\">\n				<span class=\"col-sm-1\"><input type=\"radio\" name=\"opp_id\" value={{k}} ng-model=\"vm.opp_key\" ng-change=\"vm.selected_opp_f(vm.opp_key)\"></span><span class=\"col-sm-7\">{{opp.name}}</span><span class=\"col-sm-4\">{{opp.status.name}}</span>\n			</div>\n			<div class=\"modal-footer\">\n				<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.update_opportunity()\" ng-disabled=\"!vm.selected_opp\">Submit to Connectwise</button>\n			  <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	</div>\n		</div>\n	</div></script><nav class=\"nav nav-inverse no-print\"><ul class=\"nav nav-tabs\"><li ng-if=\"vm.userData.data.estimate_admin == 1\" class=nav-item style=\"cursor: pointer\"><a ng-click=vm.updatePricing()>Update to Current Pricing</a></li><li ng-if=\"vm.opportunityValid() && (!vm.loaded_inactive || vm.userData.data.estimate_admin == 1)\" class=nav-item style=\"cursor: pointer\"><a ng-click=vm.createOpportunity()>Create Opportunity</a></li><!-- <li ng-if=\"vm.quantumValid()\" class=\"nav-item\" style=\"cursor: pointer;\">\n			<a ng-click=\"vm.sealTheDeal()\">Customer has Signed!</a>\n		</li> --><li ng-if=vm.submitValid() class=nav-item style=\"cursor: pointer\"><a ng-click=vm.levelUp()>{{vm.actionName()}}</a></li><li class=nav-item style=\"cursor: pointer\"><a ng-click=vm.goSearch()>Estimate Search</a></li><li ng-if=!vm.disabler() class=nav-item style=\"cursor: pointer\"><a ng-click=vm.levelDown()>Make Editable</a></li><li ng-if=\"vm.estimateData.probability == 100 && vm.estimateData.inactive && vm.sameObj()\" class=nav-item style=\"cursor: pointer\"><a ng-click=vm.open_change_order()>Manage Change Orders</a></li><li ng-if=\"vm.estimateData.estimate_status_id == 2\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a href={{vm.customerView}} target=_blank>Customer View</a></li><li ng-if=\"vm.estimateData.estimate_status_id == 2 && vm.estimateData.third_party\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a href={{vm.dealerView}} target=_blank>Dealer View</a></li><li ng-if=\"vm.userData.data.estimate_admin == 1\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a href={{vm.equations}} target=_blank>Parts with Equations</a></li><li ng-if=\"vm.estimateData.estimate_status_id == 2\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a href={{vm.jobPack}} target=_blank>Job Pack</a></li></ul></nav><div class=\"row troubleHeader\" ng-if=vm.inactiveParts.length><div class=\"col-sm-12, no-print\">Parts listed here are inactive in Connectwise. An opportunity cannot be created until these parts are updated!</div></div><div class=\"row troubleRow\" ng-repeat=\"part in vm.inactiveParts\"><div class=no-print><span class=col-sm-5>{{part.description}} ({{part.part_number}})</span> <span class=col-sm-2 ng-repeat=\"loc in vm.availableAreas | filter:{location_id:part.quote_location}\">{{loc.location_description}}</span> <span class=col-sm-2 ng-repeat=\"subLoc in vm.list_sublocations | filter:{id:part.sub_location}\">{{subLoc.description}}</span> <span class=col-sm-2>{{part.door_group}}</span></div></div><div cg-busy=\"{promise:vm.saveOpportunity,delay:0,message:\'Creating Opportunity\'}\"><div class=\"box simple-border\" cg-busy=\"{promise:vm.saveParts,delay:0,message:\'Saving Parts to Opportunity, this can take a minute or two\'}\"><!-- <div class=\"box-content\"> --><div ng-if=vm.ladda><button ladda=vm.ladda data-spinner-size=400 data-spinner-color=#248aaf class=\"btn form-control\" style=\"height: 400px\" disabled></button></div><div ng-if=!vm.ladda><!-- <div class=\"row\"> --><nav class=\"nav no-print\"><ul class=\"nav nav-tabs\"><li class=nav-item><a class=nav-link ng-click=\"vm.view(\'details\')\" href=# style=\"cursor: pointer\">Estimate Details</a></li><li class=nav-item><a ng-click=\"vm.view(\'parts\')\" href=# style=\"cursor: pointer\">Parts</a></li><li class=nav-item><a ng-click=\"vm.view(\'scope\')\" href=# style=\"cursor: pointer\">Scope of Work</a></li><li class=nav-item><a ng-click=\"vm.view(\'notes\')\" href=# style=\"cursor: pointer\">Internal Notes</a></li><li ng-if=\"(!vm.sameObj() && vm.userData.data.estimate_admin == 1) || (!vm.sameObj() && !vm.loaded_inactive)\" class=\"nav-item pull-right\" style=\"cursor: pointer\"><a ng-click=vm.saveEstimate()>Save</a></li></ul></nav><div class=\"row customRow review-header\"><span class=\"col-sm-4 no-print\">Hardware Total: {{vm.hwTotal() | currency}} Labor Total: {{vm.laborTotal() | currency}}</span> <span class=col-sm-3>{{vm.customerInfo.name}}</span> <span class=col-sm-1>{{vm.estimateData.estimate_id}}</span> <span class=\"col-sm-4 pull-right no-print\">Status: {{vm.statusDisplay()}}</span></div><div ng-if=\"vm.currentView == \'details\'\"><div class=\"container content\"><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Title:</label><div class=\"controls customPadLeft customPadBottom col-sm-10\"><input name=hourly_labor id=hourly_labor class=form-control ng-model=vm.estimateData.title></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top5\">Budgetary?:</label><div class=col-sm-4><button class=btn ng-click=vm.budgetaryHandle(false) ng-class=\"{\'btn-success\': !vm.estimateData.budgetary}\">No</button> <button class=btn ng-click=vm.budgetaryHandle(true) ng-class=\"{\'btn-primary\': vm.estimateData.budgetary}\">Yes</button></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top5\">Omit Labor?:</label><div class=col-sm-4><button class=btn ng-click=vm.hideLaborHandle(false) ng-class=\"{\'btn-success\': !vm.estimateData.hide_labor}\">No</button> <button class=btn ng-click=vm.hideLaborHandle(true) ng-class=\"{\'btn-primary\': vm.estimateData.hide_labor}\">Yes</button></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top5\">Inactive?:</label><div class=col-sm-4><button class=btn ng-click=vm.inactiveHandle(false) ng-class=\"{\'btn-success\': !vm.estimateData.inactive}\" ng-disabled=\"vm.userData.data.estimate_admin != 1 && vm.loaded_inactive\">No</button> <button class=btn ng-click=vm.inactiveHandle(true) ng-class=\"{\'btn-danger\': vm.estimateData.inactive}\" ng-disabled=\"vm.userData.data.estimate_admin != 1 && vm.loaded_inactive\">Yes</button></div></div><div class=\"row bottom10\"><label class=col-sm-2>Probability:</label><div class=row><div class=col-sm-1 ng-repeat=\"prob in vm.probOptions\">{{prob}} <input type=radio class=btn ng-click=vm.probCheck() ng-model=vm.estimateData.probability ng-value=prob></div></div></div><div class=row ng-if=\"vm.estimateData.probability >= 75\"><div class=col-md-4><p class=input-group><label class=col-sm-4>Close Date:</label><input type=text class=\"form-control col-sm-6\" uib-datepicker-popup={{vm.format}} ng-model=vm.estimateData.estimated_close is-open=vm.popup1.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=vm.altInputFormats disabled> <span class=input-group-btn><button type=button class=\"btn top23\" ng-click=vm.open1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-md-4><p class=input-group><label class=col-sm-4>Ship Date:</label><input type=text class=\"form-control col-sm-6\" uib-datepicker-popup={{vm.format}} ng-model=vm.estimateData.estimated_ship is-open=vm.popup2.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=vm.altInputFormats disabled> <span class=input-group-btn><button type=button class=\"btn top23\" ng-click=vm.open2()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-md-4><p class=input-group><label class=col-sm-4>Install Date:</label><input type=text class=\"form-control col-sm-6\" uib-datepicker-popup={{vm.format}} ng-model=vm.estimateData.estimated_install is-open=vm.popup3.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=vm.altInputFormats disabled> <span class=input-group-btn><button type=button class=\"btn top23\" ng-click=vm.open3()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"row bottom10\"><span ng-if=\"vm.userData.data.estimate_admin == 1\"><label class=\"col-sm-2 top7\">Hourly Labor:</label><div class=\"controls col-sm-10 customPadLeft\"><input name=hourly_labor id=hourly_labor class=form-control style=width:120px ng-model=vm.estimateData.labor_cost ng-disabled=vm.disabler()></div></span></div><div class=\"row bottom10\"><span ng-if=\"vm.userData.data.estimate_admin == 1\"><label class=\"col-sm-2 top7\">Hourly Labor - Location:</label><div class=\"controls col-sm-10 customPadLeft\"><input name=hourly_labor_location id=hourly_labor_location class=form-control style=width:120px ng-model=vm.estimateData.location_cost ng-disabled=vm.disabler()></div></span></div><div class=\"row bottom10\"><span ng-if=\"vm.userData.data.estimate_admin == 1\"><label class=\"col-sm-2 top7\">Hours per Repeater:</label><div class=\"controls col-sm-10 customPadLeft customPadBottom\"><input name=repeater_hours id=repeater_hours class=\"form-control col-sm-10\" style=width:120px ng-model=vm.estimateData.location_hours ng-disabled=vm.disabler()></div></span></div><div class=row><label class=\"col-sm-2 top7\">Site Contact:</label><div class=\"controls col-sm-10 customPadBottom customPadLeft\"><ui-select ng-model=vm.estimateData.site_contact ng-disabled=vm.disabler()><ui-select-match class=ui-select-match>{{$select.selected.first_name}} {{$select.selected.last_name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.connectwise_id as item in vm.customerInfo.contacts | filter:$select.search\">{{item.first_name}} {{item.last_name}}</ui-select-choices></ui-select></div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">City:</label><div class=\"col-sm-10 top7\">{{vm.customerInfo.city}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">State:</label><div class=\"col-sm-10 top7\">{{vm.customerInfo.state}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Phone:</label><div class=\"col-sm-10 top7\">{{vm.customerInfo.phone_number}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">JNL Sales:</label><div class=\"col-sm-10 top7\" ng-repeat=\"user in vm.jnlUsers | filter:{user_id:vm.estimateData.owner}:true\">{{user.user_full_name}}</div></div><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Third Party Sale:</label><div class=\"col-sm-10 top7\"><input type=checkbox ng-model=vm.estimateData.third_party ng-change=vm.thirdParty() ng-disabled=vm.disabler()></div></div><div ng-if=vm.estimateData.third_party><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Third Party Company:</label><div class=\"controls col-sm-10 customPadBottom customPadLeft\"><ui-select ng-model=vm.estimateData.third_party_id ng-disabled=vm.disabler() ng-change=vm.getReps()><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.thirdParties | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div ng-if=\"vm.estimateData.third_party && vm.estimateData.third_party_id > 0\"><div class=\"row bottom10\"><label class=\"col-sm-2 top7\">Third Party Rep:</label><div class=\"controls col-sm-10 customPadBottom customPadLeft\"><ui-select ng-model=vm.estimateData.third_party_owner ng-disabled=vm.disabler()><ui-select-match class=ui-select-match>{{$select.selected.user_full_name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.user_id as item in vm.reps | filter:$select.search\">{{item.user_full_name}}</ui-select-choices></ui-select></div></div></div></div></div><div class=container ng-if=\"vm.currentView == \'parts\'\"><div class=\"navbar navbar\"><div class=navbar-inner><div id=estimator_nav class=estimator_nav><div><button ng-repeat=\"area in vm.availableAreas\" class=\"btn-r left5\" ng-class=\"{\'btn-success\': vm.buttonValidate(area.location_id),\'btn-danger\':!vm.buttonValidate(area.location_id)}\" ng-click=vm.updateCurrentArea(area.location_id)>{{area.location_description}}</button></div></div></div></div><div ng-if=\"vm.currentArea == 1\"><div class=\"row bottom7\"><label class=\"col-sm-2 top7\">Server Select:</label><div class=\"controls col-sm-10\"><select class=form-control name=server_select ng-model=vm.estimateData.parts.server ng-change=\"vm.staticQtyHandle(\'server\')\" ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedServer track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></div></div><div id=related_parts ng-if=vm.estimateData.parts.server.related_parts><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped display\" width=100%><thead><tr><th>Sub Parts</th><th>Qauntity</th></tr></thead><tbody id=tbody_related_parts><tr ng-repeat=\"relatedPart in vm.estimateData.parts.server.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div></div><div ng-if=\"vm.currentArea == 2\"><div class=module-body><form class=\"form-horizontal row-fluid\" id=infrastructure_form><div id=repeater_options class=\"module-body table\" ng-if=\"vm.emptyArrCheck(\'selectedRepeater\')\"><table cellpadding=0 cellspacing=0 border=0 id=repeater_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:50%>Repeater Options</th><th style=width:25%>Quantity</th><th style=width:25%>Location</th></tr></thead><tbody id=repeater_body><tr><td><select class=form-control name=repeater_select ng-model=vm.estimateData.parts.repeater ng-disabled=vm.disabler() ng-change=\"vm.relatedPartsFunction(\'repeater\')\" ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedRepeater track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></td><td><input class=form-control type=text ng-model=vm.estimateData.parts.repeater.qty ng-change=\"vm.relatedPartsFunction(\'repeater\')\"></td><td><input type=checkbox name=ino_location ng-change=vm.licenseJob() ng-model=vm.estimateData.inovonics_location></td></tr><tr ng-repeat=\"relatedPart in vm.estimateData.parts.repeater.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><div id=tes_options class=\"module-body table\" ng-if=\"vm.emptyArrCheck(\'selectedEnrollment\')\"><table cellpadding=0 cellspacing=0 border=0 id=tes_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:50%>Enrollment Station Options</th><th style=width:50%>Quantity</th></tr></thead><tbody id=tes_body><tr><td><select class=form-control name=enrol_select ng-model=vm.estimateData.parts.enrol ng-disabled=vm.disabler() ng-change=\"vm.relatedPartsFunction(\'enrol\')\" ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedEnrollment track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></td><td><input class=form-control type=text ng-model=vm.estimateData.parts.enrol.qty ng-change=\"vm.relatedPartsFunction(\'enrol\')\" ng-disabled=vm.disabler()></td></tr><tr ng-repeat=\"relatedPart in vm.estimateData.parts.enrol.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><div id=power_options class=\"module-body table\" ng-if=\"vm.emptyArrCheck(\'selectedPower\')\"><table cellpadding=0 cellspacing=0 border=0 id=power_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:50%>Power Supply Options</th><th style=width:50%>Quantity</th></tr></thead><tbody id=power_body><tr><td><select class=form-control name=power_select ng-change=\"vm.relatedPartsFunction(\'power\')\" ng-disabled=vm.disabler() ng-model=vm.estimateData.parts.power ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedPower track by part.product_connectwise_id\"><option value=\"\">Select Option</option></select></td><td><input class=form-control type=text ng-change=\"vm.relatedPartsFunction(\'power\')\" ng-model=vm.estimateData.parts.power.qty ng-disabled=vm.disabler()></td></tr><tr ng-repeat=\"relatedPart in vm.estimateData.parts.power.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><div id=wire_options class=\"module-body table\"><table cellpadding=0 cellspacing=0 border=0 id=wire_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:50%>Wire Options</th><th style=width:50%>Quantity</th></tr></thead><tbody id=wire_body><tr ng-repeat=\"part in vm.estimateData.parts.wire\"><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table></div></form></div></div><div ng-if=\"vm.currentArea == 7\"><!-- <div class=\"module-body\">\n								<form class=\"form-horizontal row-fluid\" id=\"network_opt_form\"> --><div id=network_options class=\"module-body table\" ng-if=vm.selectedParts.network><table cellpadding=0 cellspacing=0 border=0 id=wire_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th colspan=2 style=width:100%>Network Options</th></tr></thead><thead><tr><th style=width:50%>Switch Options</th><th style=width:50%>Quantity</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.network\" ng-if=\"part.sub_location==17\"><tr><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-change=\"vm.relatedPartsFunction2(\'network\',part.product_connectwise_id)\" ng-model=part.qty ng-disabled=vm.disabler()> <button class=btn ng-click=\"vm.reset(\'network\',part.product_connectwise_id,$index)\" ng-if=!vm.disabler()>Reset Part</button></td></tr><tr ng-repeat=\"relatedPart in part.related_parts\" ng-if=\"part.qty > 0\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody><thead><tr><th style=width:50%>Punch Down Options</th><th style=width:50%>Quantity</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.network\" ng-if=\"part.sub_location==18\"><tr><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-change=\"vm.relatedPartsFunction2(\'network\',part.product_connectwise_id)\" ng-model=part.qty ng-disabled=vm.disabler()> <button class=btn ng-click=\"vm.reset(\'network\',part.product_connectwise_id,$index)\" ng-if=!vm.disabler()>Reset Part</button></td></tr><tr ng-repeat=\"relatedPart in part.related_parts\" ng-if=\"part.qty > 0\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><!-- </form>\n							</div> --></div><div ng-if=\"vm.currentArea == 1002\"><!-- <div class=\"module-body\">\n								<form class=\"form-horizontal row-fluid\" id=\"network_opt_form\"> --><div id=network_options class=\"module-body table\" ng-if=vm.selectedParts.network><table cellpadding=0 cellspacing=0 border=0 id=wire_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th colspan=2 style=width:100%>Dealer Assistance Options</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.dealer\"><tr><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-change=\"vm.relatedPartsFunction2(\'dealer\',part.product_connectwise_id)\" ng-model=part.qty ng-disabled=vm.disabler()> <button class=btn ng-click=\"vm.reset(\'dealer\',part.product_connectwise_id,$index)\" ng-if=!vm.disabler()>Reset Part</button></td></tr><tr ng-repeat=\"relatedPart in part.related_parts\" ng-if=\"part.qty > 0\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><!-- </form>\n							</div> --></div><div ng-if=\"vm.currentArea == 3\"><!-- <div class=\"module-body\">\n								<form class=\"form-horizontal row-fluid\" id=\"paging_form\" method=\"POST\"> --><div class=\"row bottom7\"><label class=\"col-sm-2 top7\">Paging Select:</label><div class=\"controls col-sm-10 customPadBottom\"><select class=form-control name=paging_select ng-model=vm.estimateData.parts.paging ng-change=\"vm.staticQtyHandle(\'paging\')\" ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedPaging track by part.product_connectwise_id\"></select></div></div><div id=related_parts ng-if=vm.estimateData.parts.paging.related_parts><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped	display\" width=100%><thead><tr><th>Sub Parts</th><th>Qauntity</th></tr></thead><tbody id=tbody_related_parts><tr ng-repeat=\"relatedPart in vm.estimateData.parts.paging.related_parts\"><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div><div><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped display\" width=100%><thead><tr><th>Pagers</th><th>Qauntity</th></tr></thead><tbody id=pager><tr ng-repeat=\"part in vm.estimateData.parts.pager\"><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table></div><!-- </form>\n							</div> --></div><div ng-if=\"vm.currentArea == 4\"><div class=module-body><form id=nursecall_form><div class=\"module-body table\"><table cellpadding=0 cellspacing=0 border=0 id=pull_cord_table class=\"table table-bordered\" width=100%><thead><tr><th style=width:40%>Pull Cord Options</th><th style=width:15%>Total Qty</th><th style=width:15%>Bed Qty</th><th style=width:15%>Bath Qty</th><th style=width:15%>Common Qty</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.nurseCall\" ng-if=\"part.sub_location==1 || part.sub_location==4\"><tr ng-class=\"{\'forceRedBackground\': !vm.pcLineValid(part.product_connectwise_id, part.qty)}\"><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-model=part.qty ng-change=vm.pcHandle(part.product_connectwise_id) ng-disabled=vm.disabler()></td><td><input class=\"form-control customInput\" type=text ng-if=\"part.qty > 0\" ng-model=vm.pullCordObj[part.product_connectwise_id].bed ng-disabled=vm.disabler()></td><td><input class=\"form-control customInput\" type=text ng-if=\"part.qty > 0\" ng-model=vm.pullCordObj[part.product_connectwise_id].bath ng-disabled=vm.disabler()></td><td><input class=\"form-control customInput\" type=text ng-if=\"part.qty > 0\" ng-model=vm.pullCordObj[part.product_connectwise_id].common ng-disabled=vm.disabler()></td></tr></tbody></table><table cellpadding=0 cellspacing=0 border=0 id=call_cord_table class=\"datatable-1 table table-bordered table-striped\" width=100% ng-if=vm.pc()><thead><tr><th style=width:70%>Call Cord Options</th><th style=width:30%>Total Qty</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.nurseCall\" ng-if=\"part.sub_location==5\"><tr><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table><table cellpadding=0 cellspacing=0 border=0 id=pendant_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:70%>Pendant Options</th><th style=width:30%>Estimated Total</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.nurseCall\" ng-if=\"part.sub_location==2\"><tr><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-change=vm.licenseJob() ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table><table cellpadding=0 cellspacing=0 border=0 id=echostream_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:70%>Echostream Options</th><th style=width:30%>Total Qty</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.nurseCall\" ng-if=\"part.sub_location==3\"><tr><td class=vCenter>{{part.product_description}} ({{part.product_part_number}})</td><td><input class=\"form-control customInput\" type=text ng-change=vm.licenseJob() ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table><table cellpadding=0 cellspacing=0 border=0 id=echostream_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:70%>Future Echostream Devices</th><th style=width:30%>Total Qty</th></tr></thead><tbody id=body><tr><td class=vCenter>Future Devices</td><td><input class=\"form-control customInput\" id=future_devices name=future_devices ng-change=vm.licenseJob() ng-model=vm.estimateData.future_devices ng-disabled=vm.disabler()></td></tr></tbody></table></div></form></div></div><div ng-if=\"vm.currentArea == 0\"><div class=module-body><form id=labor_form><div class=row><span class=col-sm-3>Project Hours: {{vm.hourTotal()}}</span></div><div class=\"module-body table\"><table cellpadding=0 cellspacing=0 border=0 id=pull_cord_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:55%>Description</th><th style=width:15%>Price</th><th style=width:15%>Quantity</th><th style=width:15%>Total</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.travel\"><tr><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.product_price ng-disabled=vm.disabler()></td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td><td>{{vm.totalPartPrice(part.product_price,part.qty) | currency}}</td></tr></tbody></table></div></form></div></div><div ng-if=\"vm.currentArea == 6\"><div class=module-body><form id=door_supply_form><div class=\"module-body table\"><table cellpadding=0 cellspacing=0 border=0 id=pull_cord_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:60%>Tag Options</th><th style=width:40%>Total Qty None:<input type=checkbox ng-model=vm.noTags ng-change=\"vm.noneHandle(\'doorSupplies\',15,vm.noTags)\" ng-disabled=vm.disabler()></th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.doorSupplies\" ng-if=\"part.sub_location == 15 && !vm.noTags\"><tr><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody><thead><tr><th style=width:60%>Band Options</th><th style=width:40%>Total Qty None:<input type=checkbox ng-model=vm.noBands ng-change=\"vm.noneHandle(\'doorSupplies\',16,vm.noBands)\" ng-disabled=vm.disabler()></th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.doorSupplies\" ng-if=\"part.sub_location == 16 && !vm.noBands\"><tr><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody><table cellpadding=0 cellspacing=0 border=0 id=pendant_table class=\"datatable-1 table table-bordered table-striped\" width=100%><thead><tr><th style=width:60%>Credential Options</th><th style=width:40%>Total Qty None:<input type=checkbox ng-model=vm.noCredentials ng-change=\"vm.noneHandle(\'doorSupplies\',14,vm.noCredentials)\" ng-disabled=vm.disabler()></th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.doorSupplies\" ng-if=\"part.sub_location == 14  && !vm.noCredentials\"><tr><td>{{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table></table></div></form></div></div><div ng-if=\"vm.currentArea == 1000\"><div class=module-body><div class=\"row bottom7\"><span><h3>Accessory Parts</h3></span><span>*Accessory Parts will not be figured into total cost</span></div><div class=\"row bottom7\"><span class=\"col-sm-2 top5\"><label>Choose Part:</label></span><span class=col-sm-8><input ng-model=vm.searchValue class=form-control></span><span class=\"col-sm-2 top3\"><button class=\"btn btn-primary\" ng-click=vm.searchProduct(0)>Search</button></span></div><div class=row ng-if=vm.searchResults.length><table datatable=ng class=table><thead><tr><td>Part</td><td></td></tr></thead><tbody><tr ng-repeat=\"p in vm.searchResults\"><td>{{p.product_description}} - ({{p.product_part_number}})</td><td><button class=\"btn btn-primary\" ng-click=vm.chosenPart(p)>Choose Part</button></td></tr></tbody></table></div><div id=accessory_parts ng-if=vm.estimateData.parts.accessories.length><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped	display\" width=100% ng-if=vm.filteredAvailableParts.selectedAccessories><thead><tr><th>Description (Part Number)</th><th>Qauntity</th><th>Discount</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.accessories\"><tr><td><button class=\"btn btn-danger\" ng-click=\"vm.estimateData.parts.accessories.splice($index, 1)\"><i class=\"fa fa-trash-o\"></i></button> {{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td><td><input type=text ng-model=part.discount ng-disabled=vm.disabler()></td></tr></tbody></table></div><div class=row><span class=\"col-sm-12 border-bottom\"></span></div><div class=\"row bottom7\"><span><h3>Additional Parts</h3></span><span>*Additional Parts will be figured into total cost</span></div><div class=\"row bottom7\"><span class=\"col-sm-2 top5\"><label>Choose Part:</label></span><span class=col-sm-8><input ng-model=vm.additionalSearchValue class=form-control></span><span class=\"col-sm-2 top3\"><button class=\"btn btn-primary\" ng-click=vm.searchProduct(1)>Search</button></span></div><div class=row ng-if=vm.additionalResluts.length><table datatable=ng class=table><thead><tr><td>Part</td><td></td></tr></thead><tbody><tr ng-repeat=\"p in vm.additionalResluts\"><td>{{p.product_description}} - ({{p.product_part_number}})</td><td><button class=\"btn btn-primary\" ng-click=vm.chosenPart(p)>Choose Part</button></td></tr></tbody></table></div><div id=additional_parts><table cellpadding=0 cellspacing=0 border=0 class=\"datatable-1 table table-bordered table-striped	display\" width=100% ng-if=vm.filteredAvailableParts.selectedAddOns><thead><tr><th>Description (Part Number)</th><th>Qauntity</th></tr></thead><tbody ng-repeat=\"part in vm.estimateData.parts.addOns\"><tr><td><button class=\"btn btn-danger\" ng-click=\"vm.estimateData.parts.addOns.splice($index, 1)\"><i class=\"fa fa-trash-o\"></i></button> {{part.product_description}} ({{part.product_part_number}})</td><td><input type=text ng-model=part.qty ng-disabled=vm.disabler()></td></tr></tbody></table></div></div></div><div ng-if=\"vm.currentArea == 5\"><div class=\"row simple-border\"><button ng-repeat=\"(key,value) in vm.doorObj\" ng-click=vm.activateDoor(value.id) ng-class=\"{\'btn-success\': vm.validateDoorGroup(value.id),\'btn-danger\':!vm.validateDoorGroup(value.id)}\" class=\"left5 btn-r\">{{value.doors_in_group}}</button> <button ng-click=vm.startNewDoor() ng-if=!disabler()>New</button></div><div class=\"row top7\"><span>Number of Doors for the quote: <input type=text name=door_q id=door_quantity ng-change=vm.updateDoorSelector() ng-model=vm.estimateData.expected_doors ng-disabled=vm.disabler()></span></div><div class=row><table cellpadding=0 cellspacing=0 border=0 id=pull_cord_table class=\"datatable-1 table table-bordered table-striped\" width=100%><tbody id=pull_cord_body ng-repeat=\"door in vm.estimateData.door_information\" ng-if=\"vm.selectedDoor == door.id\"><tr><th colspan=2>Doors that share this functionality:<ui-select name=escalations multiple ng-model=door.doors_in_group ng-change=vm.doorQtyHandle(door.id,false) ng-disabled=vm.disabler()><ui-select-match class=ui-select-match>{{$item}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item in vm.doorSelector\">{{item}}</ui-select-choices></ui-select><button class=\"btn btn-danger\" ng-if=!vm.disabler() ng-click=\"vm.estimateData.door_information.splice($index, 1)\"><i class=\"fa fa-trash-o\">Remove Door Group</i></button></th></tr><tr><td colspan=2><textarea class=\"msd-elastic: \\n;\" ng-model=door.description style=width:80%></textarea></td></tr><tr><td colspan=2>Report Page Allocation <input class=special_door_input ng-model=door.page_number id=page style=width:30px> *1 will not be page 1, but first page of door displays</td></tr><tr><td>Wandering: <input type=checkbox id=wandering class=checkbox ng-model=door.wander ng-change=vm.wanderHandle(door.id) ng-disabled=vm.disabler()></td><td>Doorbell: <input type=checkbox id=doorbell class=checkbox ng-model=door.doorbell ng-change=vm.doorbellHandle(door.id) ng-disabled=vm.disabler()></td></tr><tr><td>Double Door: <input type=checkbox id=doubledoor class=checkbox ng-model=door.doubledoor ng-change=vm.doorQtyHandle(door.id,true) ng-disabled=vm.disabler()></td><td>Elevator: <input type=checkbox id=elevator class=checkbox ng-model=door.elevator ng-disabled=vm.disabler()></td></tr><tr><td>Door Controller</td><td><select class=\"span7 customer_select select2-single\" name=repeater_select ng-model=door.controller ng-change=vm.doorQtyHandle(door.id,false) ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedDoorControllers track by part.product_connectwise_id\"><option value=\"\"></option></select></td></tr><tr><td>Door Position Device</td><td><select class=\"span7 customer_select select2-single\" name=repeater_select ng-model=door.doorPosition ng-change=vm.doorQtyHandle(door.id,false) ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedDoorPosition track by part.product_connectwise_id\"><option value=\"\"></option></select><input ng-model=door.dpsQuantity id=dps_quantity class=dps style=width:30px ng-disabled=vm.disabler()>*DPS Quantity</td></tr><tr><td>Request to Exit Device</td><td><select class=\"span7 customer_select select2-single\" name=repeater_select ng-model=door.requestExit ng-change=vm.doorQtyHandle(door.id,false) ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedBypassDevices track by part.product_connectwise_id\"><option value=\"\"></option></select></td></tr><tr><td>Request to Enter Device</td><td><select class=\"span7 customer_select select2-single\" name=repeater_select ng-model=door.requestEnter ng-change=vm.doorQtyHandle(door.id,false) ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedBypassDevices track by part.product_connectwise_id\"><option value=\"\"></option></select></td></tr><tr><td>Locking Device</td><td><select class=\"span7 customer_select select2-single\" name=repeater_select ng-model=door.lockDevice ng-change=vm.doorQtyHandle(door.id,false) ng-disabled=vm.disabler() ng-options=\"part as part.product_description+\' (\'+part.product_part_number+\')\' for part in vm.filteredAvailableParts.selectedLockDevices track by part.product_connectwise_id\"><option value=\"\"></option></select></td></tr><tr><td></td><td>Central Unlock Required? <input type=checkbox id=central_unlock class=checkbox name=central_unlock ng-disabled=vm.disabler()></td></tr><tr><td colspan=2>* DPS Quantity Per Door</td></tr></tbody><tbody ng-repeat=\"relatedPart in vm.doorRelatedPartsGet(vm.selectedDoor)\"><tr><td>{{relatedPart.related_part_description}} ({{relatedPart.related_part_number}})</td><td>{{relatedPart.related_part_qty}}</td></tr></tbody></table></div></div><div ng-if=\"vm.currentArea == 2000\"><div class=module-body><div class=module-body><!-- SERVER START --><div class=review-box ng-if=vm.estimateData.parts.server><h4 class=review-header>Head End</h4><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.server><i class=\"fa fa-minus-circle text-danger top7 left5\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.removePartQty(\'server\')\" ng-dblclick=\"vm.removePart(\'server\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.parts.server.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=vm.estimateData.parts.server.qty>{{ vm.estimateData.parts.server.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{ vm.estimateData.parts.server.qty}}</span> <span class=review-span>{{vm.estimateData.parts.server.product_description}} ({{vm.estimateData.parts.server.product_part_number}})</span></div><div><ul><li ng-repeat=\"part in vm.estimateData.parts.server.related_parts\" class=review-body-row ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.estimateData.parts.server.related_parts.splice($index, 1)\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div><div class=review-footer><span class=review-span>Labor: {{vm.selectLaborSubtotal(\'server\') | currency}}</span> Hardware: {{vm.selectSubtotal(\'server\') | currency}}</div></div><!-- SERVER END --><!-- INFRASTRUCTURE START --><div class=review-box ng-if=\"vm.estimateData.parts.repeater || vm.estimateData.parts.enrol || vm.estimateData.parts.power || vm.checkArray(\'wire\')\"><h4 class=review-header>Infrastructure</h4><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.repeater><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.removePartQty(\'repeater\')\" ng-dblclick=\"vm.removePart(\'repeater\')\"></i> <span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.parts.repeater.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text={{vm.estimateData.parts.repeater.qty}}>{{vm.estimateData.parts.repeater.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{vm.estimateData.parts.repeater.qty}}</span> <span class=review-span>{{vm.estimateData.parts.repeater.product_description}} ({{vm.estimateData.parts.repeater.product_part_number}})</span></div><div ng-if=vm.estimateData.part.repeater.related_parts><ul><li ng-repeat=\"part in vm.estimateData.parts.repeater.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.estimateData.parts.repeater.related_parts.splice($index, 1)\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.licensePart><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.estimateData.parts.licensePart = null\"></i><!-- <i class=\'fa fa-minus-circle review-span\' ng-if=\"vm.showEditQty()\" aria-hidden=\"true\"></i> --> <span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.parts.licensePart.discount></span><span class=review-span>{{vm.estimateData.parts.licensePart.qty}}</span> <span class=review-span>{{vm.estimateData.parts.licensePart.product_description}} ({{vm.estimateData.parts.licensePart.product_part_number}})</span></div><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.enrol><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.removePartQty(\'enrol\')\" ng-dblclick=\"vm.removePart(\'enrol\')\"></i> <span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.parts.enrol.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text={{vm.estimateData.parts.enrol.qty}}>{{vm.estimateData.parts.enrol.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{vm.estimateData.parts.enrol.qty}}</span> <span class=review-span>{{vm.estimateData.parts.enrol.product_description}} ({{vm.estimateData.parts.enrol.product_part_number}})</span></div><div><ul><li class=review-body-row ng-repeat=\"part in vm.estimateData.parts.enrol.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger marg-right\" ng-if=vm.showEditQty() ng-click=\"vm.estimateData.parts.enrol.related_parts.splice($index, 1)\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.power><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.removePartQty(\'power\')\" ng-dblclick=\"vm.removePart(\'power\')\"></i> <span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.parts.power.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text={{vm.estimateData.parts.enrol.qty}}>{{vm.estimateData.parts.power.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{vm.estimateData.parts.power.qty}}</span> <span class=review-span>{{vm.estimateData.parts.power.product_description}} ({{vm.estimateData.parts.power.product_part_number}})</span></div><div><ul><li class=review-body-row ng-repeat=\"part in vm.estimateData.parts.power.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.estimateData.parts.power.related_parts.splice($index, 1)\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div><div class=review-body-row ng-repeat=\"value in vm.estimateData.parts.wire\" ng-if=\"value.qty > 0\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'wire\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span></div><div class=review-footer><span class=review-span>Labor: {{vm.groupLaborSubtotal(\'infrastructure\') | currency}}</span> Hardware: {{vm.groupSubtotal(\'infrastructure\') | currency}}</div></div><!-- INFRASTRUCTURE END --><!-- NETWORK START --><div class=review-box ng-if=\"vm.checkArray(\'network\')\"><h4 class=review-header>Network</h4><div class=review-body-row ng-repeat=\"value in vm.estimateData.parts.network\" ng-if=\"value.qty > 0\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'network\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'network\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><div class=review-footer><span class=review-span>Labor: {{vm.nonSelectLaborSubtotal(\'network\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'network\') | currency}}</div></div><!-- NETWORK END --><!-- PAGING START --><div class=review-box ng-if=\"vm.checkArray(\'pager\') || vm.estimateData.parts.paging\"><h4 class=review-header>Paging</h4><div class=\"review-body-row lighter\" ng-if=vm.estimateData.parts.paging><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.removePartQty(\'paging\')\" ng-dblclick=\"vm.removePart(\'paging\')\"></i> <span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.parts.paging.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=vm.estimateData.parts.paging.qty>{{ vm.estimateData.parts.paging.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{ vm.estimateData.parts.paging.qty}}</span> <span class=review-span>{{vm.estimateData.parts.paging.product_description}} ({{vm.estimateData.parts.paging.product_part_number}})</span></div><div ng-if=vm.estimateData.parts.paging.related_parts><ul><li class=review-body-row ng-repeat=\"part in vm.estimateData.parts.paging.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() aria-hidden=true ng-click=\"vm.estimateData.parts.paging.related_parts.splice($index, 1)\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div><div class=review-body-row ng-repeat=\"value in vm.estimateData.parts.pager\" ng-if=\"value.qty > 0\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'pager\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=value.discount></span><span class=review-span ng-class-odd=\"\'darker\'\" ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-class-odd=\"\'darker\'\" ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span ng-class-odd=\"\'darker\'\">{{value.product_description}} ({{value.product_part_number}})</span></div><div class=review-footer><span class=review-span>Labor: {{vm.groupLaborSubtotal(\'notification\') | currency}}</span> Hardware: {{vm.groupSubtotal(\'notification\') | currency}}</div></div><!-- PAGING END --><!-- NURSECALL START --><div class=review-box ng-if=\"vm.checkArray(\'nurseCall\')\"><h4 class=review-header>Nurse Call</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.nurseCall\" ng-if=\"value.qty > 0\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'nurseCall\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'nurseCall\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><div class=review-footer><span class=review-span>Labor: {{vm.nonSelectLaborSubtotal(\'nurseCall\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'nurseCall\') | currency}}</div></div><!-- NURSECALL END --><!-- DOORS START --><div class=review-box ng-if=vm.checkForDoors()><div><h4 class=review-header>Doors</h4></div><div class=review-box ng-repeat=\"value in vm.estimateData.door_information\"><h4 class=review-door-group-header>Doors in Group {{value.doors_in_group}} <i class=\"fa fa-minus-circle text-danger marg-right\" ng-if=vm.showEditQty() ng-click=\"vm.estimateData.door_information.splice($index, 1)\"></i></h4><div class=\"review-body-row lighter\" ng-repeat=\"(key,item) in value\" ng-if=\"(key == \'controller\' && value.controller) || (key == \'doorPosition\' && value.doorPosition) || (key == \'requestExit\' && value.requestExit) ||\n											(key == \'requestEnter\' && value.requestEnter) || (key == \'lockDevice\' && value.lockDevice) || (key == \'wanderPart\' && value.wanderPart) || (key == \'doorbellPart\' && value.doorbellPart)\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=vm.removeDoorPart(key,value.id)></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=item.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=item.qty>{{item.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{item.qty}}</span> <span class=review-span>{{item.product_description}} ({{item.product_part_number}})</span><div ng-if=item.related_parts><ul><li ng-repeat=\"part in item.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeDoorRelated($index, key, value.id)\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div></div><div class=review-footer><span class=review-span>Labor: {{vm.doorLaborSubTotal() | currency}}</span> Hardware: {{vm.doorSubTotal() | currency}}</div></div><!-- DOORS END --><!-- DOOR SUPPLY START --><div class=review-box ng-if=\"vm.checkArray(\'doorSupplies\')\"><h4 class=review-header>Door Supplies</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.doorSupplies\" ng-if=\"value.qty > 0\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'doorSupplies\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'doorSupplies\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><div class=review-footer><span class=review-span>Labor: {{vm.nonSelectLaborSubtotal(\'doorSupplies\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'doorSupplies\') | currency}}</div></div><!-- DOOR SUPPLY END --><!-- DEALER ASSISTANCE START --><div class=review-box ng-if=\"vm.checkArray(\'dealer\')\"><h4 class=review-header>Dealer Only Parts / Install Assistance</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.dealer\" ng-if=\"value.qty > 0\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'dealer\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'doorSupplies\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><div class=review-footer><span class=review-span>Labor: {{vm.nonSelectLaborSubtotal(\'dealer\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'dealer\') | currency}}</div></div><!-- DEALER ASSISTANCE END --><!-- LABOR START --><div class=review-box ng-if=\"vm.checkArray(\'travel\')\"><h4 class=review-header>Travel / Labor</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.travel\" ng-if=\"value.qty > 0\"><i class=\"fa fa-minus-circle text-danger marg-right\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'travel\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'travel\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><div class=review-footer><span class=marg-right>Labor: {{vm.travelLaborSubtotal(\'travel\') | currency}}</span></div></div><!-- LABOR END --><!-- ADDITIONAL PARTS START --><div class=review-box ng-if=\"vm.checkArray(\'addOns\')\"><h4 class=review-header>Additional Parts</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.addOns\" ng-if=\"value.qty > 0\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'addOns\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span><div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger marg-right\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'addOns\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div><div class=review-footer><span class=review-span>Labor: {{vm.nonSelectLaborSubtotal(\'addOns\') | currency}}</span> Hardware: {{vm.nonSelectSubtotal(\'addOns\') | currency}}</div></div><!-- ADDITIONAL PARTS END --><!-- ACCESSORIES START --><div class=review-box ng-if=\"vm.checkArray(\'accessories\')\"><h4 class=review-header>Accessories</h4><div class=\"review-body-row lighter\" ng-repeat=\"value in vm.estimateData.parts.accessories\" ng-if=\"value.qty > 0\"><i class=\"fa fa-minus-circle text-danger marg-right\" ng-if=vm.showEditQty() ng-click=\"vm.removeQty($index,\'accessories\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=\"review-input marg-right\" ng-model=value.discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=value.qty>{{value.qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{value.qty}}</span> <span class=review-span>{{value.product_description}} ({{value.product_part_number}})</span>{{vm.accessoryPrice(value.qty,value.product_price,value.discount) | currency}} Initials: __________________<div ng-if=value.related_parts><ul><li class=review-body-row ng-repeat=\"part in value.related_parts\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\"><i class=\"fa fa-minus-circle text-danger\" ng-if=vm.showEditQty() ng-click=\"vm.removeRelated($index, part, \'accessories\')\"></i> <span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=part.related_part_discount></span><span class=review-span ng-if=vm.showEditQty()><a href=# editable-text=part.related_part_qty>{{part.related_part_qty}}</a></span> <span class=review-span ng-if=!vm.showEditQty()>{{part.related_part_qty}}</span> <span class=review-span>{{part.related_part_description}} ({{part.related_part_number}})</span></li></ul></div></div></div><!-- ACCESSORIES END --><div class=review-box><h4 class=review-header>Summary</h4><div class=review-body-row><span class=review-span>Labor Subtotal: {{vm.laborTotal() | currency}}</span> %<span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.labor_discount></span><span class=review-span>Discount Amount: {{vm.labordiscountAmount | currency}}</span></div><div class=review-body-row><h3>Labor Total: {{vm.laborFinal() | currency}}</h3></div><div class=review-body-row><span class=review-span>Hardware Subtotal: {{vm.hwTotal() | currency}}</span> %<span class=review-span ng-if=vm.showEditQty()><input class=review-input ng-model=vm.estimateData.hardware_discount></span><span class=review-span>Discount Amount: {{vm.hwdiscountAmount | currency}}</span></div><div class=review-body-row><h3>Hardware Total: {{vm.hwFinal() | currency}}</h3></div><div class=review-body-row><span class=review-span ng-if=vm.showEditQty()>Tax: <input class=review-input ng-model=vm.estimateData.tax_amount></span><span ng-if=!vm.showEditQty()>Tax: {{vm.estimateData.tax_amount | currency}}</span></div><div class=review-body-row><h2>Total Investment: {{vm.totalInvestment() | currency}}</h2></div></div></div></div></div></div></div><div ng-if=\"vm.currentView == \'scope\'\"><div class=\"container content\"><div class=module><div class=module-body><form class=\"form-horizontal row-fluid\"><textarea class=msd-elastic; ng-disabled=vm.disabler() ng-model=vm.estimateData.scope style=width:80%></textarea></form></div></div></div></div><div ng-if=\"vm.currentView == \'notes\'\"><div class=\"container content\"><div class=module><div class=module-body><div class=row><div class=col-sm-12>Internal Notes:</div></div><form class=\"form-horizontal row-fluid\"><textarea class=msd-elastic; ng-model=vm.estimateData.notes style=width:80%></textarea></form></div></div></div></div></div></div>");
$templateCache.put("app/estimatorFindDealerEstimate/findDealerEstimate.html","<div><div class=row><div class=col-sm-6><h3>Find an Estimate</h3></div></div></div><div class=\"box simple-border bottom15\"><div class=box-content><div class=\"row bottom5\"><div class=\"col-sm-1 top7\">Customer</div><div class=col-sm-3><ui-select ng-model=vm.searchData.customer_name><ui-select-match>{{$select.selected}} - {{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"site in vm.availableCustomers | filter:$select.search\" refresh-delay=300>{{site}}</ui-select-choices></ui-select></div></div><div class=\"row bottom5\"><div class=\"col-sm-1 top7\">Estimate ID</div><div class=col-sm-3><input class=form-control ng-model=vm.searchData.estimate_id></div><div class=\"col-sm-1 top7\">Show All Reps:</div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.searchData.all_reps></div><div class=\"col-sm-1 top7\">Show Inactive:</div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.searchData.inactive></div><div class=\"col-sm-1 top7\">Won:</div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.searchData.won ng-change=vm.won_func()></div><div class=\"col-sm-1 top5\"><button class=btn ng-click=vm.clearFilter()>Clear Filters</button></div></div></div></div><div class=box><div class=\"box-content nopadding\"><table class=table><tr><th class=col-md-3>Customer</th><th class=col-md-2>Estimate ID</th><th class=col-md-3>Estimate Title</th><th class=col-md-2>Estimate Type</th><th class=col-md-1>Budgetary</th><th class=col-md-1>Owner</th></tr><tr ng-repeat=\"estimate in vm.filteredResults()\"><td>{{estimate.site_name}}</td><td><button class=btn ng-click=vm.openEstimate(estimate.estimate_id,estimate.system_type_id)>{{estimate.estimate_id}}</button></td><td>{{estimate.title}}</td><td>{{estimate.system_type}}</td><td>{{estimate.budgetary ? \"Yes\":\"No\"}}</td><td ng-repeat=\"user in vm.users | filter:{user_id:estimate.owner}:true\">{{user.user_full_name}}</td></tr></table></div></div>");
$templateCache.put("app/estimatorFindEstimate/findEstimate.html","<div><div class=row><div class=col-sm-6><h3>Find an Estimate</h3></div></div></div><div class=\"row bottom5\"><div class=col-sm-2></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-1><select class=form-control ng-model=vm.searchFor><option value=site_name>Customer</option><option value=estimate_id>Estimate ID</option><option value=title>Title</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><div class=row><div class=col-sm-2></div><div class=\"col-sm-1 top7\"><label class=\"pull-right top7\">Show All Reps:</label></div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.all_reps ng-change=vm.load_data()></div><div class=\"col-sm-1 top7\"><label class=\"pull-right top7\">Show Inactive:</label></div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.inactive ng-change=vm.load_data()></div><div class=\"col-sm-1 top7\"><label class=\"pull-right top7\">Won:</label></div><div class=\"col-sm-1 top7\"><input type=checkbox ng-model=vm.won ng-change=vm.won_func()></div><div class=col-sm-4></div></div><table class=table><thead><tr><th ng-click=\"vm.sort_by=\'site_name\'; vm.sort_data()\">Customer <span ng-show=\"vm.sort_by == \'site_name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'site_name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'estimate_id\'; vm.sort_data()\">Estimate ID <span ng-show=\"vm.sort_by == \'estimate_id\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'estimate_id\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'title\'; vm.sort_data()\">Title <span ng-show=\"vm.sort_by == \'title\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'title\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Type</th><th>Status</th><th>Budgetary</th><th>Owner</th></tr></thead><tbody><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count><td>{{obj.site_name}}</td><td><button class=btn ng-click=vm.openEstimate(obj.estimate_id,obj.system_type_id)>{{obj.estimate_id}}</button></td><td>{{obj.title}}</td><td>{{obj.system_type}}</td><td>{{obj.status}}</td><td>{{obj.budgetary ? \"YES\":\"NO\"}}</td><td>{{obj.owner}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div><!-- <div class=\"box simple-border bottom15\">\n	<div class=\"box-content\">\n		<div class=\"row bottom5\">\n			<div class=\"col-sm-1 top7\">\n				Customer\n			</div>\n			<div class=\"col-sm-3\">\n				<ui-select ng-model=\"vm.searchData.customer_name\">\n					<ui-select-match>{{$select.selected}} - {{$select.selected}}</ui-select-match>\n					<ui-select-choices class=\"ui-select-choices\" repeat=\"site in vm.availableCustomers | filter:$select.search\" refresh-delay=\"300\">\n						{{site}}\n					</ui-select-choices>\n				</ui-select>\n			</div>\n		</div>\n		<div class=\"row bottom5\">\n			<div class=\"col-sm-1 top7\">\n				Estimate ID\n			</div>\n			<div class=\"col-sm-3\">\n				<input class=\"form-control\" ng-model=\"vm.searchData.estimate_id\">\n			</div>\n			<div class=\"col-sm-1 top7\">\n				Show All Reps:\n			</div>\n			<div class=\"col-sm-1 top7\">\n				<input type=\"checkbox\" ng-model=\"vm.searchData.all_reps\">\n			</div>\n			<div class=\"col-sm-1 top7\">\n				Show Inactive:\n			</div>\n			<div class=\"col-sm-1 top7\">\n				<input type=\"checkbox\" ng-model=\"vm.searchData.inactive\">\n			</div>\n			<div class=\"col-sm-1 top7\">\n				Won:\n			</div>\n			<div class=\"col-sm-1 top7\">\n				<input type=\"checkbox\" ng-model=\"vm.searchData.won\" ng-change=\"vm.won_func()\">\n			</div>\n			<div class=\"col-sm-1 top5\">\n				<button class=\"btn\" ng-click=\"vm.clearFilter()\">Clear Filters</button>\n			</div>\n		</div>\n	</div>\n</div>\n<div class=\"box\">\n	<div class=\"box-content nopadding\">\n		<table class=\"table\">\n			<tr>\n				<th class=\"col-md-3\">\n					Customer\n				</th>\n				<th class=\"col-md-2\">\n					Estimate ID\n				</th>\n				<th class=\"col-md-3\">\n					Estimate Title\n				</th>\n				<th class=\"col-md-2\">\n					Estimate Type\n				</th>\n				<th>\n					Status\n				</th>\n				<th class=\"col-md-1\">\n					Budgetary\n				</th>\n				<th class=\"col-md-1\">\n					Owner\n				</th>\n			</tr>\n			<tr ng-repeat=\"estimate in vm.filteredResults()\">\n				<td>{{estimate.site_name}}</td>\n				<td><button class=\"btn\" ng-click=\"vm.openEstimate(estimate.estimate_id,estimate.system_type_id)\">{{estimate.estimate_id}}</button></td>\n				<td>{{estimate.title}}</td>\n				<td>{{estimate.system_type}}</td>\n				<td ng-repeat=\"st in vm.status_obj | filter:{id:estimate.estimate_status_id}\">{{st.name}}</td>\n				<td>{{estimate.budgetary ? \"Yes\":\"No\"}}</td>\n				<td ng-repeat=\"user in vm.users | filter:{user_id:estimate.owner}:true\">{{user.user_full_name}}</td>\n			</tr>\n		</table>\n	</div>\n</div> -->");
$templateCache.put("app/estimatorHome/homeDisplay.html","<div class=page-header><div><h1>Sales Home</h1></div></div><div class=row><div class=\"box-content nopadding col-sm-4\"><div class=control-group style=padding-bottom:5px><div class=controls><ul><li class=bottom5><a class=\"btn btn-primary\" id=new_estimate_link href=/estimatorStartNewEstimate>Create a new estimate</a></li><li class=bottom5><a class=\"btn btn-primary\" id=find_estimate_link href=/estimatorFindEstimate>Find an existing estimate</a></li></ul></div></div></div><div class=\"box-content nopadding col-sm-4\"><div class=control-group style=padding-bottom:5px><div class=controls><ul><li class=bottom5><a class=\"btn btn-primary\" href=/change-order-create>Manage Change Orders</a></li></ul></div></div></div><!-- <div class=\"box-content nopadding col-sm-4\">\n   <div class=\"control-group\" style=\"padding-bottom:5px;\">\n     <div class=\"controls\">\n       <ul>\n         <li class=\"bottom5\"><a class=\"btn btn-primary\" id=\"new_estimate_link\" href=\"/estimatorStartNewEstimate\">Create a new project</a></li>\n       </ul>\n     </div>\n   </div>\n </div> --></div>");
$templateCache.put("app/estimatorStartDealerEstimate/startNewDealerEstimate.html","<div class=module><div class=module-head><div class=row><div class=col-sm-6><h3>New Estimate</h3></div></div></div><div class=module-body><form class=\"form-horizontal row-fluid\" id=new_user_form><div class=row><div class=\"col-sm-2 top7\">Choose Dealer</div><div class=col-sm-6><ui-select ng-model=vm.selectedDealer ng-change=vm.get_details($select.selected.id)><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"dealer in vm.thirdParties | filter:$select.search\" refresh-delay=300>{{dealer.name}}</ui-select-choices></ui-select></div></div><div class=\"row top5\" ng-if=vm.dealer_details><div class=\"col-sm-2 top7\">Choose Dealer Rep</div><div class=col-sm-6><ui-select ng-model=vm.submissionObj.third_party_owner ng-change=vm.update_user($select.selected.id)><ui-select-match>{{$select.selected.user_full_name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"rep.id as rep in vm.dealer_details.users | filter:$select.search\" refresh-delay=300>{{rep.user_full_name}}</ui-select-choices></ui-select></div></div><div class=\"row top5\" ng-if=vm.dealer_details><div class=\"col-sm-2 top7\">Choose System Type</div><div class=col-sm-6><ui-select ng-model=vm.submissionObj.type><ui-select-match>{{$select.selected.system_description}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"sys.id as sys in vm.systemTypes | filter:$select.search\" refresh-delay=300>{{sys.system_description}}</ui-select-choices></ui-select></div></div><div class=\"row top5\" ng-if=vm.dealer_details><div class=\"col-sm-2 top7\">JNL Sales Rep</div><div class=col-sm-6><ui-select ng-model=vm.submissionObj.jnl_rep><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"sys.id as sys in vm.jnlReps | filter:$select.search\" refresh-delay=300>{{sys.name}}</ui-select-choices></ui-select></div></div><div class=\"row top5\" ng-if=vm.dealer_details><div class=\"col-sm-2 top7\">Estimate Title</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.title></div></div><div class=\"row top5\" ng-if=vm.dealer_details><div class=\"col-sm-2 top7\">Budgetary</div><div class=\"col-sm-6 top7\"><input type=checkbox ng-model=vm.submissionObj.budgetary></div></div><div class=\"row top5\" ng-if=vm.validateForm()><div class=col-sm-2><button class=\"btn btn-primary\" ng-click=vm.save()>Save and Continue</button></div></div></form></div></div>");
$templateCache.put("app/estimatorStartNewEstimate/startNewEstimate.html","<div class=module ng-if=\"vm.page == 1\"><div class=module-head><div class=row><div class=col-sm-6><h3>New Estimate</h3></div></div></div><div class=row><div class=col-sm-6>Company Name: <input type=text class=form-control ng-model=vm.searchCompany ng-keyup=\"$event.keyCode == 13 ? vm.searchCustomer() : null\" ng-model-options=\"{debounce: 200}\"><button class=btn ng-click=vm.searchCustomer() ng-disabled=!vm.valid()>Search</button></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:1000}><form class=\"form-horizontal row-fluid\" id=new_user_form><table datatable=ng class=table><thead><tr><th>Customer Name</th><th>Address</th><th>Phone Number</th><th>City</th><th>State</th></tr></thead><tbody><tr ng-repeat=\"(key,customer) in vm.customer_data\"><td><button class=\"btn btn-primary\" ng-click=vm.next(key)>{{customer.name}}</button></td><td>{{customer.address}}</td><td>{{customer.phone_number}}</td><td>{{customer.city}}</td><td>{{customer.state}}</td></tr></tbody></table></form></div></div><div class=module ng-if=\"vm.page == 2\"><div class=module-head><div class=row><div class=col-sm-6><h3>New Estimate for {{vm.chosen_customer.name}}</h3></div></div></div><div class=module-body><form class=\"form-horizontal row-fluid\" id=new_user_form><div class=\"row bottom5\"><div class=col-sm-2>Estimate Title:</div><div class=col-sm-10><input name=hourly_labor class=form-control ng-model=vm.newEstimate.title></div></div><div class=\"row bottom5\"><div class=col-sm-2>Estimate Type:</div><div class=col-sm-10><select name=hourly_labor class=form-control ng-model=vm.newEstimate.type ng-options=\"sys.id as sys.name for sys in vm.systemTypes\"></select></div></div><div class=row><div class=col-sm-2>Budgetary:</div><div class=col-sm-10><input type=checkbox class=checkboxMargin ng-model=vm.newEstimate.budgetary></div></div><div class=row><div class=col-sm-2><button role=presentation class=\"btn btn-primary\" ng-if=vm.objCheck() ng-click=vm.startBuilder()>Save and Continue</button></div><div class=col-sm-2><button role=presentation class=\"btn btn-primary\" ng-click=vm.back()>Back</button></div></div><div class=details ng-if=vm.chosen_customer><div class=module-head><h3>Details:</h3></div><div class=control_group style=padding-bottom:5px><span>Address: </span><span>{{vm.chosen_customer.address}}</span></div><div class=control_group style=padding-bottom:5px><span>Phone Number: </span><span>{{vm.chosen_customer.phone_number}}</span></div><div class=control_group style=padding-bottom:5px><span>City: </span><span>{{vm.chosen_customer.city}}</span></div><div class=control_group style=padding-bottom:5px><span>State: </span><span>{{vm.chosen_customer.state}}</span></div><div class=control_group style=padding-bottom:5px><span>Zip: </span><span>{{vm.chosen_customer.zip}}</span></div><div class=control_group style=padding-bottom:5px><span>Contact: </span><span>{{vm.chosen_customer.contacts[vm.chosen_customer.default_contact_id].first_name}} {{vm.chosen_customer.contacts[vm.chosen_customer.default_contact_id].last_name}}</span></div></div></form></div></div>");
$templateCache.put("app/installQuote/installQuote.html","<div class=page-header><div><h1><span class=col-md-9>Install Quote</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700}><div class=\"box simple-border\"><div class=box-content><div class=row><div class=col-sm-4><div class=\"row review-header\">JNL Costs</div><div ng-repeat=\"part in vm.submissionObj.parts\" class=row><span class=\"col-sm-3 top7\"><label>{{part.product_description}}</label></span><span class=col-sm-5><input ng-disabled=vm.submissionObj.accepted_offer type=number class=form-control ng-model=part.qty></span></div></div><div class=col-sm-4><div class=\"row review-header\"><div class=col-sm-12><span>Payment: {{vm.totalContract() | currency}}</span></div></div><div class=row><div class=col-sm-12><span class=form-control>{{vm.customers.data[0].name}}</span></div></div><div class=row><div class=col-sm-12><span class=form-control>{{vm.estimateData.estimate_id}}</span></div></div><div class=row><div class=col-sm-12><span ng-if=!vm.submissionObj.accepted_offer><select class=form-control ng-model=vm.submissionObj.third_party.id ng-options=\"item.id as item.name for item in vm.thirdParties\" placeholder=\"JNL Internal\"></select></span><span class=form-control ng-if=vm.submissionObj.accepted_offer>{{vm.submissionObj.third_party.name}}</span></div></div><div class=row><div class=col-sm-6><button class=\"btn btn-primary form-control\" ng-if=!vm.submissionObj.id ng-click=vm.saveNew()>Save Quote</button> <button class=\"btn btn-primary form-control\" ng-if=\"vm.submissionObj.id && !vm.sameObj()\" ng-click=vm.update()>Update Quote</button></div><div class=col-sm-6><button class=\"btn btn-primary form-control\" ng-if=\"vm.submissionObj.id && vm.sameObj()\" ng-click=vm.createDoc()>Create Quote</button></div></div></div><div class=col-sm-4><div class=\"row review-header\"><div class=col-sm-12><span>Offer Properties</span></div></div><div class=row><span class=\"col-sm-3 top7\"><label>Created By</label></span><span class=\"col-sm-5 top7\">{{vm.submissionObj.created.name}}</span></div><div class=row><span class=\"col-sm-3 top7\"><label>Created Date</label></span><span class=\"col-sm-5 top7\">{{vm.submissionObj.created.date | date:\'medium\'}}</span></div><div class=row><span class=\"col-sm-3 top7\"><label>Last Updated By</label></span><span class=\"col-sm-5 top7\">{{vm.submissionObj.updated.name}}</span></div><div class=row><span class=\"col-sm-3 top7\"><label>Last Updated</label></span><span class=\"col-sm-5 top7\">{{vm.submissionObj.updated.date | date:\'medium\'}}</span></div><div class=row ng-if=vm.burdenCheck()><span class=\"col-sm-3 top10\"><label>Update Burden Rate</label></span><span class=\"col-sm-5 top7\">Current: {{vm.submissionObj.burden_rate}} <button class=\"btn btn-primary\" ng-click=vm.updateBurden()>Yes</button></span></div><div class=row ng-if=vm.submissionObj.id><span class=\"col-sm-3 top10\"><label>Offer Accepted</label></span><span class=\"col-sm-5 top7\"><input type=checkbox ng-disabled=vm.submissionObj.accepted_offer ng-model=vm.submissionObj.accepted_offer></span></div></div></div></div></div></div>");
$templateCache.put("app/installQuoteStart/installQuoteStart.html","<div class=page-header><div><h1>Install Quote</h1></div></div><div cg-busy={promise:vm.loadPromise,delay:200,minDuration:700}><div class=box><div class=box-content><div class=row><span class=col-sm-3><input class=form-control ng-model=vm.estimate_id placeholder=\"Enter Estimate / Proposal\"></span><span class=col-sm-2><button class=\"btn btn-primary form-control\" ng-click=vm.getEstimateDetail()>Search</button></span></div><div ng-if=vm.selectedEstimate><div class=row><h3>Estimate Details:</h3></div><div class=row><div class=col-sm-4><span class=form-control ng-repeat=\"site in vm.customers | filter:{connectwise_id:vm.selectedEstimate.customer_id}:true\">{{site.company_name}}</span></div></div><div class=row><div class=col-sm-4><span ng-if=\"vm.selectedEstimate.probability < 100 || vm.selectedEstimate.estimate_status_id != 2\" class=\"forceRedBackground form-control\">Open</span> <span ng-if=\"vm.selectedEstimate.probability == 100 && vm.selectedEstimate.estimate_status_id == 2\" class=\"forceGreenBackground form-control\">Closed</span></div></div><div class=row><div class=col-sm-2><span ng-if=\"vm.selectedEstimate.probability == 100 && vm.selectedEstimate.estimate_status_id == 2\"><button class=\"btn form-control\" ng-click=vm.loadOffer()>Continue</button></span></div></div></div></div></div></div><div class=page-header><div><h1>Previous Quotes</h1></div></div><div class=box><div class=box-content><div><div><div class=col-sm-2></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-1><select class=form-control ng-model=vm.searchFor><option value=company/name>Company</option><option value=estimate_id>Estimate ID</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=table><thead><tr><th>Estimate ID</th><th ng-click=\"vm.sort_by=\'company/name\'; vm.sort_data()\">Site Name <span ng-show=\"vm.sort_by == \'company/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'company/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'created/date\'; vm.sort_data()\">Created Date <span ng-show=\"vm.sort_by == \'created/date\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'created/date\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'updated/date\'; vm.sort_data()\">Last Updated <span ng-show=\"vm.sort_by == \'updated/date\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'updated/date\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><!-- <th ng-click=\"vm.sort_by=\'missingDevices\'; vm.sort_data()\">Missing Devices\n							<span ng-show=\"vm.sort_by == \'missingDevices\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span>\n							<span ng-show=\"vm.sort_by == \'missingDevices\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span>\n						</th>\n						<th ng-click=\"vm.sort_by=\'lowBatteries\'; vm.sort_data()\">Low Batteries\n							<span ng-show=\"vm.sort_by == \'lowBatteries\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span>\n							<span ng-show=\"vm.sort_by == \'lowBatteries\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span>\n						</th>\n						<th ng-click=\"vm.sort_by=\'serverVersion\'; vm.sort_data()\">SW Version\n							<span ng-show=\"vm.sort_by == \'serverVersion\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span>\n							<span ng-show=\"vm.sort_by == \'serverVersion\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span>\n						</th> --></tr></thead><tbody><tr dir-paginate=\"obj in vm.qStatus.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.qStatus.count style=\"cursor: pointer\" ng-click=vm.openQuote(obj.estimate_id)><td>{{obj.estimate_id}}</td><td>{{obj.company.name}}</td><td>{{obj.created.date | date:\'medium\'}}</td><td>{{obj.updated.date | date:\'medium\'}}</td><!-- <td>{{obj.status.missingDevices}}</td>\n						<td>{{obj.status.lowBatteries}}</td>\n						<td ng-repeat=\"setting in obj.server_settings | filter:{name:\'Server Version\'}\">{{setting.value}}</td> --></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.qStatus.data.length}} of {{vm.qStatus.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div></div></div><!-- <div class=\"box\">\n		<div class=\"box-content\"> --><!-- <div class=\"row\">\n				<div class=\"col-sm-6\">\n					<table class=\"table\">\n						<tr class=\"custom\">\n							<th colspan=\"3\">Completed Quotes, not accepted</th>\n						</tr>\n						<tr>\n							<th>Estimate</th>\n							<th>Customer</th>\n							<th>Estimated Install</th>\n						</tr>\n						<tr ng-repeat=\"row in vm.data.not_accepted\" ng-click=\"vm.openQuote(row.estimate_id)\"><a href=\"#\">\n							<td>{{row.estimate_id}}</td>\n							<td>{{row.customer_name}}</td>\n							<td>{{row.estimated_install | date : med}}</td>\n						</a></tr>\n					</table>\n				</div>\n				<div class=\"col-sm-6\">\n					<table class=\"table\">\n						<tr class=\"custom\">\n							<th colspan=\"3\">Closed sales without offer</th>\n						</tr>\n						<tr>\n							<th>Estimate</th>\n							<th>Customer</th>\n							<th>Estimated Install</th>\n						</tr>\n						<tr ng-repeat=\"row in vm.data.not_started\" ng-click=\"vm.openQuote(row.estimate_id)\"><a href=\"#\">\n							<td>{{row.estimate_id}}</td>\n							<td>{{row.customer_name}}</td>\n							<td>{{row.estimated_install | date : med}}</td>\n						</a></tr>\n					</table>\n				</div>\n			</div> --> <!-- <div class=\"row\" ng-if=\"vm.install_data\">\n				<div class=\"col-sm-12\">\n					<table class=\"table\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n						<thead>\n							<tr>\n								<th>Estimate</th>\n								<th>Customer</th>\n								<th>Created Date</th>\n								<th>Last Updated</th>\n							</tr>\n						</thead>\n						<tbody>\n							<tr ng-repeat=\"row in vm.install_data\" style=\"cursor: pointer\" ng-click=\"vm.openQuote(row.estimate_id)\">\n								<td>{{row.estimate_id}}</td>\n								<td>{{row.company_name}}</td>\n								<td>{{row.created_date | date : med}}</td>\n								<td>{{row.last_updated | date : med}}</td>\n							</tr>\n						</tbody>\n					</table>\n				</div>\n			</div>\n		</div>\n	</div> -->");
$templateCache.put("app/internalTagReader/internalTagReader.html","<div class=page-header><div><h1>Internal Tag Reader</h1></div></div><div ng-if=!vm.activeMac class=box cg-busy=\"{promise:vm.tag_off_promise,message:\'Turning Tag Off, Leave by Station\',delay:0,minDuration:1000}\"><div class=box-title><h3><i class=\"fa fa-signal\"></i> Tags On Reader</h3></div><div class=\"box-content nopadding\"><table class=\"table table-hover table-nomargin\"><thead><tr><th>Mac Address</th><th>Battery Level</th><th>Version</th><th>RSSI</th><th>TX Rate</th><th style=text-align:center>Actions</th></tr></thead><tbody><tr ng-repeat=\"(key,tag) in vm.tagData\"><td>{{tag.mac}}</td><td>{{tag.battery_level}}</td><td>{{tag.version}}</td><td>{{tag.rssi}}</td><td>{{tag.tx_rate}}</td><td style=text-align:center><button class=btn ng-click=vm.start_test(key)>Start Test</button> <button class=btn ng-click=vm.tag_turn_off(key)>Turn Off Tag</button></td></tr><tr ng-if=!vm.tagData.length><td colspan=4>No Results Found</td></tr></tbody></table></div></div><div ng-if=vm.activeMac><div class=box-title><div class=row><div class=col-sm-6><h3><i class=\"fa fa-signal\"></i> Tags Test Active for {{vm.activeMac}}</h3></div></div><div class=row><div class=col-sm-6><span class=\"col-sm-3 top10\"><label>Choose Part</label></span><span class=col-sm-9><ui-select ng-model=vm.hardware.product_id on-select=vm.populateSerials(vm.hardware.product_id)><ui-select-match>{{$select.selected.part_number}} - {{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"product.id as product in vm.availableParts | filter:$select.search\" refresh-delay=300>{{product.part_number}} - {{product.name}}</ui-select-choices></ui-select></span></div><div class=col-sm-6><span class=\"col-sm-4 top10\"><label>Choose Serial Number</label></span><span class=col-sm-8 ng-if=vm.hardware.product_id><ui-select ng-model=vm.hardware.associated_serial><ui-select-match>{{$select.selected.serial_number}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"sn.id as sn in vm.availableSerialNumbers | filter:$select.search\" refresh-delay=300>{{sn.serial_number}}</ui-select-choices></ui-select></span></div></div></div><div class=\"row top15\"><div class=col-sm-3>Test Duration: {{vm.testSecondCounter}}</div><div class=col-sm-3>Current RSSI: {{vm.hardware_test.rssi}}</div><div class=col-sm-3>Current Tx Rate: {{vm.hardware_test.tx_rate | number:3}}</div><div class=col-sm-3>Current Battery Level: {{vm.hardware_test.battery_level | number:3}}</div></div><div class=\"row top15\"><div class=col-sm-3 ng-class={success:vm.currentTestStatus(),danger:!vm.currentTestStatus()}>Test Status: {{vm.currentTestStatus()?\"Pass\":\"Fail\"}}</div><div class=col-sm-3><button class=\"btn btn-primary\" ng-disabled=!vm.currentTestStatus() ng-click=vm.complete_test()>Submit Test</button></div><div class=col-sm-3><button class=\"btn btn-warning\" ng-click=vm.cancel_test()>Cancel Test</button></div></div></div>");
$templateCache.put("app/login/login.html","<div class=wrapper><h1><a href=#><img src=assets/images/logo-big.png>PORTAL</a></h1><div class=login-body style=min-height:275px><div class=\"alert alert-danger\" ng-if=vm.unsupportedBrowser><i class=\"fa fa-warning\"></i> Unsupported Web Browser. <a href=https://www.google.com/chrome/browser/desktop/ >Download Chrome</a></div><h2>SIGN IN</h2><form name=loginform ng-submit=vm.login(vm.userData)><div class=form-group><div class=\"email controls\"><input type=text ng-disabled=vm.unsupportedBrowser placeholder=\"User Name\" class=form-control ng-model=vm.userName></div></div><div class=form-group><div class=\"pw controls\"><input ng-disabled=vm.unsupportedBrowser type=password placeholder=Password class=form-control ng-model=vm.passWord></div></div><div class=submit ng-if=!vm.unsupportedBrowser><button type=submit class=\"btn btn-primary\" ng-click=vm.login()>Log In</button></div></form></div></div>");
$templateCache.put("app/main/main.html","<div class=page-header><div><h1>JNL Portal</h1></div></div><div class=box cg-busy={promise:vm.populatePromise,delay:0,minDuration:500}><div ng-if=!vm.ladda class=box-title><h3><i class=\"fa fa-dashboard\"></i> Dashboard</h3></div><div class=\"box-content nopadding\"><div class=row><div class=col-sm-6><table class=\"table custom\"><tr><th colspan=3>Total equipment in the field for Quantum Systems<br>Number of Active Systems: {{vm.hardwareCounts.customer_data.active_customers}}<br>Customers with high enough version to count: {{vm.hardwareCounts.customer_data.qualified_sw_version}}</th></tr><tr ng-repeat=\"est in vm.hardwareCounts.count_data\"><td>{{est.name}}</td><td>{{est.value}}</td></tr></table></div></div></div></div><div ng-if=\"vm.primary_function == 3\" class=\"box-content nopadding\"><div class=row><div class=col-sm-6><table class=\"table custom\"><tr><th colspan=3>Recently Created Estimates</th></tr><tr ng-repeat=\"est in vm.recently_created\" ng-click=vm.openEstimate(est.estimate_id,est.estimate_type,est.non_traditional)><a href=#><td>{{est.estimate_id}}</td><td>{{est.company_name}}</td><td>{{est.estimate_title}}</td></a></tr></table></div><div class=col-sm-6><table class=\"table custom\"><tr><th colspan=3>Recently Updated Estimates</th></tr><tr ng-repeat=\"est in vm.recently_updated\" ng-click=vm.openEstimate(est.estimate_id,est.estimate_type,est.non_traditional)><a href=#><td>{{est.estimate_id}}</td><td>{{est.company_name}}</td><td>{{est.estimate_title}}</td></a></tr></table></div></div></div><div ng-if=\"vm.primary_function == 5\"><div class=box-content><div class=row><div class=col-sm-6><table class=table><tr class=custom><th colspan=3>Completed Quotes, not accepted</th></tr><tr><th>Estimate</th><th>Customer</th><th>Estimated Install</th></tr><tr ng-repeat=\"row in vm.data.not_accepted\" ng-click=vm.openQuote(row.estimate_id)><a href=#><td>{{row.estimate_id}}</td><td>{{row.customer_name}}</td><td>{{row.estimated_install | date : med}}</td></a></tr></table></div><div class=col-sm-6><table class=table><tr class=custom><th colspan=3>Closed sales without offer</th></tr><tr><th>Estimate</th><th>Customer</th><th>Estimated Install</th></tr><tr ng-repeat=\"row in vm.data.not_started\" ng-click=vm.openQuote(row.estimate_id)><a href=#><td>{{row.estimate_id}}</td><td>{{row.customer_name}}</td><td>{{row.estimated_install | date : med}}</td></a></tr></table></div></div></div></div>");
$templateCache.put("app/openOrderProductAllocation/openOrderProductAllocation.html","<div class=page-header><div class=row><h1><span class=col-lg-9>Open Orders Product Allocation</span></h1><span></span></div></div><div class=row cg-busy=\"{promise:vm.update_ticket_promise,delay:0,message:\'Saving Ticket, one moment please\'}\"><div class=col-sm-2><button type=button class=\"btn btn-primary form-control\" ng-click=vm.askForExcel()>Generate Excel</button></div><div class=box><div class=\"box-content border-groove\" ng-if=!vm.selectedProduct><table class=table width=100% datatable=ng dt-options=vm.dtOptions><thead><tr><th>Date</th><th>SO / ST</th><th>Facility</th><th>Planned Ship Date</th><th>Priority</th><th>Notes</th></tr></thead><tbody><tr ng-repeat=\"(i,row) in vm.data\"><td>{{row.order_date | date : \'yyyy/MM/dd\'}}</td><td>{{row.entity_id}}</td><td>{{row.customer.company_name}}</td><td><input class=form-control type=text ng-model=\"vm.data[i][\'planned_ship\']\" ng-keyup=vm.update_date(row.id,i)></td><td ng-class=vm.color_classes[row.priority.id]><select class=form-control ng-model=\"vm.data[i][\'priority\']\" style=\"width: 140px\" ng-change=vm.update_priority(row.id,i) ng-options=\"item.name for item in vm.priorities track by item.id\"></select></td><td><input class=form-control type=text ng-model=\"vm.data[i][\'notes\']\" ng-keyup=vm.update_notes(row.id,i)></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/productPricing/productPricing.html","<div class=page-header><div class=row><h1><span class=col-lg-9>Product Pricing</span></h1><span></span></div></div><div class=row cg-busy=\"{promise:vm.update_ticket_promise,delay:0,message:\'Saving Ticket, one moment please\'}\"><div class=box><div class=\"box-content border-groove\" ng-if=!vm.selectedProduct><button class=\"btn btn-primary\" ng-click=vm.get_data()>Apply Filters</button> <button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Clear Filters</button><table class=table width=100%><thead><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th colspan=8 style=\"text-align:center; border-left:2px solid; border-right:2px solid\">Distributor Programs</th><th></th><th></th></tr><tr><th><input class=form-control ng-model=vm.part_number_filter style=\"width: 140px\"></th><th><select class=form-control ng-model=vm.type_filter style=\"width: 140px\" ng-change=vm.get_data() ng-options=\"item.type for item in vm.types\"></select></th><th><select class=form-control ng-model=vm.build_filter style=\"width: 80px\" ng-change=vm.get_data() ng-options=\"part for part in vm.build_choices\"></select></th><th><input class=form-control ng-model=vm.name_filter style=\"width: 200px\"></th><th></th><th></th><th></th><th><input class=form-control ng-model=vm.percent_filter style=\"width: 120px\"></th><th colspan=4 style=\"background-color:#469C31; border-left:2px solid; text-align:center\">25%</th><th colspan=4 style=\"background-color:#E9750E; border-right:2px solid; text-align:center\">30%</th><th><select class=form-control ng-model=vm.vendor_filter style=\"width: 140px\" ng-change=vm.get_data() ng-options=\"item.vendor for item in vm.vendors\"></select></th><th></th></tr><tr><th ng-click=\"vm.order_column = \'part_number\'; vm.sort_data();\">Item <span ng-show=\"vm.order_column == \'part_number\' && vm.order_asc == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.order_column == \'part_number\' && vm.order_asc == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Type</th><th>Has Build</th><th>Description</th><th>MSRP</th><th>Cost</th><th>Net</th><th ng-click=\"vm.order_column = \'percent\'; vm.sort_data();\">% <span ng-show=\"vm.order_column == \'percent\' && vm.order_asc == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.order_column == \'percent\' && vm.order_asc == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th style=\"background-color:#469C31; border-left:2px solid\">Sell</th><th style=background-color:#469C31>Cost</th><th style=background-color:#469C31>Net</th><th ng-click=\"vm.order_column = \'percent25\'; vm.sort_data();\" style=background-color:#469C31>% <span ng-show=\"vm.order_column == \'percent25\' && vm.order_asc == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.order_column == \'percent25\' && vm.order_asc == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th style=background-color:#E9750E>Sell</th><th style=background-color:#E9750E>Cost</th><th style=background-color:#E9750E>Net</th><th ng-click=\"vm.order_column = \'percent30\'; vm.sort_data();\" style=\"background-color:#E9750E;border-right:2px solid\">% <span ng-show=\"vm.order_column == \'percent30\' && vm.order_asc == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.order_column == \'percent30\' && vm.order_asc == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Supplier</th><th>Supplier Part #</th></tr></thead><tbody><tr dir-paginate=\"(i,product) in vm.products | itemsPerPage:15\" current-page=vm.currentPage total-items=vm.total_rows><td ng-click=vm.selectPart(i)><a href=\"\">{{product.part_number}}</a></td><td>{{product.type}}</td><td>{{product.build.jnl_build.value?\'Yes\':\'No\'}}</td><td>{{product.general.name.value}}</td><td>{{product.general.price.value | currency}}</td><td>{{product.general.cost.value | currency}}</td><td>{{product.general.net.value | currency}}</td><td>{{product.general.percent.value | number:2}} %</td><td style=\"background-color:#469C31; border-left:2px solid\">{{product.general.price25.value | currency}}</td><td style=background-color:#469C31>{{product.general.cost.value | currency}}</td><td style=background-color:#469C31>{{product.general.net25.value | currency}}</td><td style=background-color:#469C31>{{product.general.percent25.value | number:2}} %</td><td style=background-color:#E9750E>{{product.general.price30.value | currency}}</td><td style=background-color:#E9750E>{{product.general.cost.value | currency}}</td><td style=background-color:#E9750E>{{product.general.net30.value | currency}}</td><td style=\"background-color:#E9750E; border-right:2px solid\">{{product.general.percent30.value | number:2}} %</td><td>{{product.general.vendor.value}}</td><td>{{product.general.vendor_sku.value}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.products.length}} of {{vm.total_rows}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.get_data()></dir-pagination-controls></div></div></div><div class=\"box-content border-groove\" ng-if=vm.selectedProduct><button class=\"btn btn-primary\" ng-click=\"vm.selectedProduct=null; vm.clear_calculations()\">Back to Table</button><table class=table width=100%><thead><tr><th class=orange-header>Part Number</th><th class=orange-header>Description</th><th class=orange-header>MSRP</th><th class=orange-header>Cost</th><th class=orange-header>Addl. %</th><th class=orange-header>Addl. $</th><th class=orange-header>TTL Cost</th><th class=orange-header>Net</th><th class=orange-header>%</th></tr></thead><tbody><tr><td>{{vm.selectedProduct.part_number}}</td><td>{{vm.selectedProduct.general.name.value}}</td><td><span class=review-span>{{vm.selectedProduct.general.price.value | currency}}</span><span ng-if=vm.calculated_msrp class=negativeNumber>({{vm.calculated_msrp | currency}})</span></td><td>{{vm.selectedProduct.general.cost.value | currency}}</td><td></td><td></td><td></td><td>{{vm.selectedProduct.general.net.value | currency}}</td><td><span class=review-span>{{vm.selectedProduct.general.percent.value | number:2}}%</span><span ng-if=vm.calculated_percentage class=negativeNumber>({{vm.calculated_percentage | number:2}}%)</span></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{vm.selectedProduct.general.net25.value | currency}}</td><td><span class=review-span>{{vm.selectedProduct.general.percent25.value | number:2}}%</span><span ng-if=vm.calculated_percentage class=negativeNumber>({{vm.calculated_percentage25 | number:2}}%)</span></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{vm.selectedProduct.general.net30.value | currency}}</td><td><span class=review-span>{{vm.selectedProduct.general.percent30.value | number:2}}%</span><span ng-if=vm.calculated_percentage class=negativeNumber>({{vm.calculated_percentage30 | number:2}}%)</span></td></tr><tr><td></td><td></td><td><input type=number class=form-control ng-model=vm.new_msrp ng-change=vm.build_mods() ng-disabled=vm.new_percentage></td><td><input type=number class=form-control ng-model=vm.new_cost ng-change=vm.build_mods()></td><td></td><td></td><td></td><td></td><td><input type=number class=form-control ng-model=vm.new_percentage ng-change=vm.build_mods() ng-disabled=vm.new_msrp></td></tr></tbody></table><div class=col-lg-12 ng-if=vm.build_data.included_parts><div class=col-lg-6><table class=table><thead><tr><th colspan=4>Components</th><th>{{vm.total | currency}}</th></tr><tr><th class=green-header>Part Number</th><th class=green-header>Description</th><th class=green-header>Cost</th><th class=green-header>Qty</th><th class=green-header>Total</th></tr></thead><tbody><tr ng-repeat=\"row in vm.build_data.included_parts\"><td>{{row.part_number}}</td><td>{{row.name}}</td><td>{{row.cost | currency}}</td><td>{{row.build_product_qty}}</td><td>{{row.build_product_qty*row.cost | currency}}</td></tr></tbody></table></div><div class=col-lg-6><table class=table><thead><tr><th colspan=3>Labor</th></tr><tr><th class=green-header>Hourly Rate</th><th class=green-header>Time (Min)</th><th class=green-header>Total</th></tr></thead><tbody><tr><td>{{vm.build_data.labor_cost | currency}}</td><td>{{vm.build_data.time_to_build | number:2}}</td><td>{{vm.build_data.labor_cost * vm.build_data.time_to_build / 60 | currency}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/productTest/productTest.html","<script type=text/ng-template id=confirmModal.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Existing Association</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      This product is already associated with Serial Number {{vm.serialNumber.sn}}.<br>\n			If this a re test with the same board click \"Go To Test\" to start the test.<br>\n			If testing with a new board, click on \"Choose New Board\", you can then choose an available Serial Number.<br>\n			<span class=\"text-danger\">Choosing a new board will remove the existing serial number from this product.</span>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.removeAssociation()\">Choose New Board</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.closeAndGo()\">Go To Test</button>\n    </div>\n	</div></script><div cg-busy=\"{promise:vm.partPromise,message:\'Loading\',delay:200,minDuration:1000}\"><div class=page-header><div><h1>Product Test - {{vm.finished_product.name}}</h1></div></div><div ng-if=!vm.finished_product.is_pull_cord><div ng-if=!vm.submissionObject.serial_number><div ng-if=\"vm.availableHw.count > 0\"><div class=\"row row-fluid title-div\"><h3>Available Hardware To Test Looking for testable hardware in {{10 - vm.counter}}</h3></div><div class=\"row row-fluid body-div\"><ul><li ng-repeat=\"(key,hw) in vm.availableHw.data\"><span><button class=btn ng-click=vm.ipCheck(hw.ip_address,hw.mac)>{{hw.ip_address}}</button> ({{hw.mac}}) </span><span class=left7><button class=\"btn btn-danger\" ng-click=vm.removeDevice(key,hw.mac)>Remove Device</button></span></li></ul></div></div><div ng-if=!vm.availableHw.data.length><div class=\"row row-fluid title-div\">There are no devices on the network detected. Verify a raspberry pi with the test application sd card is running and plugged into the network.</div></div></div><div ng-if=vm.submissionObject.serial_number><div class=row>Attached Serial Number: {{vm.serial_number_data.serial_number}}</div><button class=\"btn btn-primary ladda-button\" ladda=vm.ladda data-spinner-size=10 ng-click=vm.startTest() data-style=slide-down aria-disabled=false><span class=ladda-label>Start Test</span><span class=ladda-spinner></span></button></div><div class=\"row body-div\" ng-if=\"vm.testStatus == \'FailConnect\'\">Failed to connect to test device. This means that the device hasn\'t fully booted, isn\'t connected to the network, or there is a problem with the pi or board.<br><br>1. Try the \"Retry\" button below to start the test<br>2. Go the the dashboard, right click and refresh. Reboot the device, wait 2 minutes and come back to the test again.<br>3. If you have confirmed the device is bad, and cannot get it to start the test, click the \"Submit Test\" button. It will show as a failed test in our records.<br><button class=\"btn btn-primary ladda-button\" ladda=vm.ladda data-spinner-size=20 ng-click=vm.startTest() data-style=slide-down aria-disabled=false><span class=ladda-label>Retry</span><span class=ladda-spinner></span></button> <button class=\"btn btn-primary\" ng-click=vm.submitTest()>Submit Test</button></div><div class=\"row body-div\" ng-if=\"vm.testStatus && vm.testStatus != \'FailConnect\'\"><div class=col-sm-6>Current DCS Serial Number: {{vm.serial_number_data.serial_number}}</div><div class=col-sm-6>Current PI MAC: {{vm.submissionObject.serial_number}}</div><table class=table ng-if=vm.testReq.inputs><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\">Input {{key}}</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\">{{value.status}}</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\" ng-class={success:value.tested,danger:!value.tested}>{{value.tested}}</td></tr></table><table class=table ng-if=vm.testReq.outputs><tr><td>Output 1</td><td>Output 2</td><td>Output 3</td><td>Output 4</td><td>Output 5</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.outputs\">{{value.status}}</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(1)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(2)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(3)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(4)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(5)>Toggle Output</button></td></tr><tr><td><button class=btn ng-class=\"{\'btn-success\':vm.outputStatus.out1}\" ng-click=vm.outputResult(1,1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.outputStatus.out1}\" ng-click=vm.outputResult(1,0)>Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.outputStatus.out2}\" ng-click=vm.outputResult(2,1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.outputStatus.out2}\" ng-click=vm.outputResult(2,0)>Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.outputStatus.out3}\" ng-click=vm.outputResult(3,1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.outputStatus.out3}\" ng-click=vm.outputResult(3,0)>Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.outputStatus.out4}\" ng-click=vm.outputResult(4,1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.outputStatus.out4}\" ng-click=vm.outputResult(4,0)>Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.outputStatus.out5}\" ng-click=vm.outputResult(5,1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.outputStatus.out5}\" ng-click=vm.outputResult(5,0)>Fail</button></td></tr></table><table class=table ng-if=vm.testReq.bluetooth><tr><td>Bluetooth Chip Firmware</td><td>Bluetooth Test Status</td></tr><tr><td>{{vm.resultData.bluetooth.firmware}}</td><td ng-class={success:vm.resultData.bluetooth.result,danger:!vm.resultData.bluetooth.result}>{{vm.resultData.bluetooth.result}}</td></tr></table><table ng-if=vm.testReq.wiegand class=table><tr><td>Wiegand Code</td><td>Site ID</td><td>Wiegand Test Status</td></tr><tr><td>{{vm.resultData.wiegand.code}}</td><td>{{vm.resultData.wiegand.site}}</td><td ng-class={success:vm.resultData.wiegand.result,danger:!vm.resultData.wiegand.result}>{{vm.resultData.wiegand.result}}</td></tr></table><table ng-if=vm.testReq.sound class=table><tr><td>Internal Sounder</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.toggleSound()>Toggle Internal Sounder</button></td></tr><tr><td><button class=btn ng-class=\"{\'btn-success\':vm.soundStatus}\" ng-click=vm.soundResult(1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.soundStatus}\" ng-click=vm.soundResult(0)>Fail</button></td></tr></table><table ng-if=vm.testReq.screen class=table><tr><td>Screen</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.changeScreen(10)>HOME</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(0)>KEYPAD</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(1)>BYPASS</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(2)>ACCESS DENIED</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(3)>INVALID CODE</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(4)>EGRESS ACTIVATED</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(5)>SERVER CONNECTING</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(6)>CONNECTION FAILED</button></td></tr><tr><td><button class=btn ng-class=\"{\'btn-success\':vm.screenStatus}\" ng-click=vm.screenResult(1)>Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.screenStatus}\" ng-click=vm.screenResult(0)>Fail</button></td></tr></table><div ng-if=!vm.passedTest()><div>The test is currently in FAILED status</div><div ng-repeat=\"fail in vm.testFails\">{{fail}}</div></div><span class=col-sm-3><button class=\"btn btn-primary\" ng-click=vm.submitTest()>Submit Test</button><button class=\"btn pull-right\" ng-click=vm.cancelTest()>Cancel</button></span></div></div><div ng-if=vm.finished_product.is_pull_cord><div class=title-div><div class=row><span class=col-sm-4>Pull Cord Type:</span> <span class=col-sm-8><input class=form-control ng-model=vm.finished_product.name disabled></span></div><div class=row><span class=col-sm-4>Choose PC Board Serial Number:</span> <span class=col-sm-8><input class=form-control ng-model=vm.serial_number_data.serial_number disabled></span></div><div class=row><span class=col-sm-4>Enter Inovonics Serial Number:</span> <span class=col-sm-8><input class=form-control ng-model=vm.InoSerial ng-change=vm.checkPCSN()></span></div><button ng-if=!vm.pcStarted class=\"btn btn-primary\" ng-disabled=!vm.Inovalid ng-click=vm.startPCTest()>Start Test</button></div><div ng-if=\"vm.pcStarted && vm.pcInputPass() == \'FAIL\' && vm.resultData.timer > 0\"><h3>Test will timeout in: {{vm.timeout_value}}</h3></div><div ng-if=\"vm.pcStarted && vm.pcInputPass() == \'PASS\'\"><h3>Test Passed, click \"Submit Test\" Or \"User Failed\"</h3><h4>\"User Failed\" is for the test thinks it passed, but the user can over ride it</h4></div><div ng-if=\"vm.pcStarted && vm.timed_out\"><h3>The test has timed out\"</h3><h4>\"If the test is passed, you can still click the Submit Test button, otherwise you have to refresh and restart the test.\"</h4></div><div ng-if=\"vm.pcStarted && vm.pcInputPass() == \'FAIL\' && vm.resultData.timer == 0\"><h3>The test has failed, click \"Retry\" to try again, other submit the failure with \"Submit Test\"</h3></div><div ng-if=vm.pcStarted><table class=\"table white-back\"><tr><th ng-if=vm.testReq.alarm>Alarm</th><th>Reset</th><th ng-if=vm.testReq.staff>Staff Assist (Alarm 2)</th><th ng-if=vm.testReq.checkin>Check In</th></tr><tr><td ng-if=vm.testReq.alarm>{{vm.resultData.status.alarm_bit_1_alarm}}</td><td>{{vm.resultData.status.alarm_bit_1_reset}}</td><td ng-if=vm.testReq.staff>{{vm.resultData.status.alarm_bit_2_alarm}}</td><td ng-if=vm.testReq.checkin>{{vm.resultData.status.tamper_active}}</td></tr></table><span class=col-sm-3><button class=\"btn btn-primary\" ng-click=vm.pcSubmitTest()>Submit Test</button> <button class=\"btn btn-primary\" ng-click=vm.userFail()>User Fail</button> <button ng-if=\"vm.resultData.timer == 0\" class=\"btn btn-primary pull-right\" ng-click=vm.startPCTest()>Retry</button></span></div></div></div>");
$templateCache.put("app/purchaseOrderDetail/purchaseOrderDetail.html","<div class=span9 ng-if=vm.dataLoaded><h3>Parts still to be received</h3><table class=\"datatable-1 table table-striped\"><thead><tr><th>Part Number</th><th>Part Description</th><th>Qty</th><th></th></tr></thead><tbody><tr ng-repeat=\"line in vm.openParts\"><td>{{line.partNumber}}</td><td>{{line.name}}</td><td>{{line.qty}}</td><td><span class=btn ng-click=vm.receivePart(line.partNumber,line.id)>Generate Serial Numbers</span></td></tr></tbody></table></div><div class=span9 ng-if=vm.dataLoaded><h3>Parts received so far</h3><table class=\"datatable-1 table table-striped\"><thead><tr><th>Part Number</th><th>Part Description</th><th>Qty Received</th></tr></thead><tbody><tr ng-repeat=\"line in vm.receivedProduct\"><td>{{line.partNumber}}</td><td>{{line.name}}</td><td>{{line.received_quantity}}</td></tr></tbody></table></div><div class=span9 ng-if=vm.dataLoaded><h3>Full Audit</h3><table datatable=ng class=table><thead><tr><th>Line</th><th>Part Number</th><th>Part Description</th><th>Quantity</th><th>Received</th><th>Notes</th></tr></thead><tbody><tr ng-repeat=\"line in vm.fullDetail\"><td>{{line.lineNumber}}</td><td>{{line.product.identifier}}</td><td>{{line.description}}</td><td>{{line.quantity}}</td><td>{{line.closedFlag}}</td><td>{{line.internalNotes}}</td></tr></tbody></table></div>");
$templateCache.put("app/quantumHardwareTest/quantumHardwareTest.html","<div ng-if=!vm.selectedSerial><div class=page-header><div><h1>Hardware Test Results</h1></div></div><div cg-busy={promise:vm.populatePromise,delay:0,minDuration:1000}><div class=\"row top5\"><div class=col-sm-1></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=product_data/part_number>Product Number</option><option value=product_data/name>Product Name</option><option value=serial_number>Serial Number</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'serial_number\'; vm.sort_data()\">Serial Number <span ng-show=\"vm.sort_by == \'serial_number\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'serial_number\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'product_data/name\'; vm.sort_data()\">Product <span ng-show=\"vm.sort_by == \'product_data/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'product_data/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Number of Tests Run</th><th ng-click=\"vm.sort_by=\'tested_date\'; vm.sort_data()\">Most Recent Test <span ng-show=\"vm.sort_by == \'tested_date\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'tested_date\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th></thead><tbody><tr dir-paginate=\"(key,obj) in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count style=\"cursor: pointer\"><td ng-click=vm.openEdit(obj.serial_number)>{{obj.serial_number}}</td><td ng-click=vm.openEdit(obj.serial_number)>{{obj.product.name}} - ({{obj.product.part_number}})</td><td ng-click=vm.openEdit(obj.serial_number)>{{obj.times_tested}}</td><td ng-click=vm.openEdit(obj.serial_number)>{{obj.tested_date | date:\'medium\'}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div></div><div ng-if=vm.selectedSerial><div class=page-header><div><h2><span>Tests for {{vm.selectedSerial}}</span><span class=left10 style=font-style:italic>Product: {{vm.hardware_data.product.name}} - ({{vm.hardware_data.product.part_number}})</span><span class=pull-right>JNL Board: {{vm.serial_number_data.serial_number}}</span></h2></div></div><table class=\"table white-back\" ng-if=vm.product_data.is_pull_cord ng-repeat=\"(key,test) in vm.tests.data\"><tr><th colspan=3>Test Date: {{test.test_date | date:\'medium\'}}</th><th colspan=2><button ng-if=\"key == 0\" class=\"btn btn-primary pull-right\" ng-click=vm.sticker()>Print QC Sticker</button></th><th colspan=1></th></tr><tr><th>Alarm 1</th><th>Alarm 1 Reset</th><th>Alarm 2</th><th>Alarm 2 Reset</th><th>Check In</th><th>Check In Reset</th></tr><tr><td ng-class={success:!test_input_1,danger:test.input_1}>{{test.input_1 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_2,danger:test.input_2}>{{test.input_2 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_3,danger:test.input_3}>{{test.input_3 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_4,danger:test.input_4}>{{test.input_4 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_5,danger:test.input_5}>{{test.input_5 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_6,danger:test.input_6}>{{test.input_6 ? \"Fail\":\"Pass\"}}</td></tr></table><table class=table ng-if=\"!vm.product_data.is_pull_cord && !vm.product_data.is_tag\" ng-repeat=\"(key,test) in vm.tests.data\"><tr><th colspan=5>Test Date: {{test.test_date | date:\'medium\'}}</th><th colspan=3 style=text-align:right><button ng-if=\"key == 0\" class=\"btn btn-primary\" ng-click=vm.sticker()>Print QC Sticker</button></th><th colspan=2 style=text-align:right></th></tr><tr ng-if=vm.myReq.inputs><th>Input 1</th><th>Input 2</th><th>Input 3</th><th>Input 4</th><th>Input 5</th><th>Input 6</th><th>Input 7</th><th>Input 8</th><th>Input 9</th><th>Input 10</th></tr><tr ng-if=vm.myReq.inputs><td ng-class={success:!test_input_1,danger:test.input_1}>{{test.input_1 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_2,danger:test.input_2}>{{test.input_2 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_3,danger:test.input_3}>{{test.input_3 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_4,danger:test.input_4}>{{test.input_4 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_5,danger:test.input_5}>{{test.input_5 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_6,danger:test.input_6}>{{test.input_6 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_7,danger:test.input_7}>{{test.input_7 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_8,danger:test.input_8}>{{test.input_8 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_9,danger:test.input_9}>{{test.input_9 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test_input_10,danger:test.input_10}>{{test.input_10 ? \"Fail\":\"Pass\"}}</td></tr><tr ng-if=vm.myReq.outputs><th colspan=2>Output 1</th><th colspan=2>Output 2</th><th colspan=2>Output 3</th><th colspan=2>Output 4</th><th colspan=2>Output 5</th></tr><tr ng-if=vm.myReq.outputs><td ng-class={success:!test.output_1,danger:test.output_1}>{{test.output_1 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test.output_2,danger:test.output_2}>{{test.output_2 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test.output_3,danger:test.output_3}>{{test.output_3 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test.output_4,danger:test.output_4}>{{test.output_4 ? \"Fail\":\"Pass\"}}</td><td ng-class={success:!test.output_5,danger:test.output_5}>{{test.output_5 ? \"Fail\":\"Pass\"}}</td></tr><tr ng-if=vm.myReq.bluetooth><th colspan=5>Tag Detect</th><th colspan=5>Bluetooth Errors</th></tr><tr ng-if=vm.myReq.bluetooth><td colspan=5 ng-if=!test.tag_detect class=success>Pass</td><td colspan=5 ng-if=test.tag_detect class=danger>Fail</td><td colspan=5>{{test.bluetooth_errors}}</td></tr><tr ng-if=vm.myReq.wiegand><th colspan=3>Wiegand Test</th><th colspan=3>Submitted Site ID</th><th colspan=3>Submitted Code</th></tr><tr ng-if=vm.myReq.wiegand><td colspan=3 ng-if=!test.wiegand class=success>Pass</td><td colspan=3 ng-if=test.wiegand class=danger>Fail</td><td colspan=3>{{test.wiegand_site}}</td><td colspan=3>{{test.wiegand_code}}</td></tr><tr><th colspan=5 ng-if=vm.myReq.sound>Sound Test</th><th colspan=5 ng-if=vm.myReq.screen>Screen Test</th></tr><tr><td colspan=5 ng-if=\"vm.myReq.sound && !test.sound\" class=success>Pass</td><td colspan=5 ng-if=\"vm.myReq.sound && test.sound\" class=danger>Fail</td><td colspan=5 ng-if=\"vm.myReq.screen && !test.screen\" class=success>Pass</td><td colspan=5 ng-if=\"vm.myReq.screen && test.screen\" class=danger>Fail</td></tr></table><table class=\"table white-back\" ng-if=vm.product_data.is_tag ng-repeat=\"(key,test) in vm.tests.data\"><tr><th colspan=3>Test Date: {{test.test_date | date:\'medium\'}}</th><th colspan=1><a href={{vm.last_location}} ng-if=\"key == 0\" class=\"btn pull-right\">Back</a></th></tr><tr><th>Average RSSI</th><th>TX Rate</th><th>Battery Level</th><th>Test Duration (seconds)</th></tr><tr><td ng-class=\"{success:test.avg_rssi >= -72 && test.avg_rssi <= -60,danger:test.avg_rssi < -74 || test.avg_rssi > -60}\">{{test.avg_rssi}}</td><td ng-class=\"{success:test.tx_rate <= .9,danger:test.tx_rate > .9}\">{{test.tx_rate}}</td><td ng-class=\"{success:test.battery_level >= 3,danger:test.battery_level < 3}\">{{test.battery_level}}</td><td>{{test.test_length}}</td></tr></table></div>");
$templateCache.put("app/quantumHardwareTestDetail/quantumHardwareTestDetail.html","<div class=page-header><div><h2><span>Tests for {{vm.mac}}</span><span class=pull-right>JNL Board: {{vm.associated_serial}}</span></h2></div></div><div ng-if=vm.hwType><table class=\"table white-back\" ng-if=vm.isPC ng-repeat=\"(key,test) in vm.qHw\"><tr><th colspan=3>Test Date: {{test.test_date}}</th><th colspan=2><!-- <a href=\"#\">Print Sticker</a> --> <button ng-if=\"key == 0\" class=\"btn btn-primary pull-right\" ng-click=vm.sticker(key)>Print QC Sticker</button></th><th colspan=1><a href={{vm.last_location}} ng-if=\"key == 0\" class=\"btn pull-right\">Back</a></th></tr><tr><th>Alarm 1</th><th>Alarm 1 Reset</th><th>Alarm 2</th><th>Alarm 2 Reset</th><th>Check In</th><th>Check In Reset</th></tr><tr><td ng-if=!test.input_1 class=success>Pass</td><td ng-if=test.input_1 class=danger>Fail</td><td ng-if=!test.input_2 class=success>Pass</td><td ng-if=test.input_2 class=danger>Fail</td><td ng-if=!test.input_3 class=success>Pass</td><td ng-if=test.input_3 class=danger>Fail</td><td ng-if=!test.input_4 class=success>Pass</td><td ng-if=test.input_4 class=danger>Fail</td><td ng-if=!test.input_5 class=success>Pass</td><td ng-if=test.input_5 class=danger>Fail</td><td ng-if=!test.input_6 class=success>Pass</td><td ng-if=test.input_6 class=danger>Fail</td></tr></table><table class=table ng-if=vm.myReq ng-repeat=\"(key,test) in vm.qHw\"><tr><th colspan=5>Test Date: {{test.test_date}}</th><th colspan=3 style=text-align:right><button ng-if=\"key == 0\" class=\"btn btn-primary\" ng-click=vm.sticker(key)>Print QC Sticker</button></th><th colspan=2 style=text-align:right><a href={{vm.last_location}}><button class=\"btn form-control\">Back</button></a></th></tr><tr ng-if=vm.myReq.inputs><th>Input 1</th><th>Input 2</th><th>Input 3</th><th>Input 4</th><th>Input 5</th><th>Input 6</th><th>Input 7</th><th>Input 8</th><th>Input 9</th><th>Input 10</th></tr><tr ng-if=vm.myReq.inputs><td ng-if=!test.input_1 class=success>Pass</td><td ng-if=test.input_1 class=danger>Fail</td><td ng-if=!test.input_2 class=success>Pass</td><td ng-if=test.input_2 class=danger>Fail</td><td ng-if=!test.input_3 class=success>Pass</td><td ng-if=test.input_3 class=danger>Fail</td><td ng-if=!test.input_4 class=success>Pass</td><td ng-if=test.input_4 class=danger>Fail</td><td ng-if=!test.input_5 class=success>Pass</td><td ng-if=test.input_5 class=danger>Fail</td><td ng-if=!test.input_6 class=success>Pass</td><td ng-if=test.input_6 class=danger>Fail</td><td ng-if=!test.input_7 class=success>Pass</td><td ng-if=test.input_7 class=danger>Fail</td><td ng-if=!test.input_8 class=success>Pass</td><td ng-if=test.input_8 class=danger>Fail</td><td ng-if=!test.input_9 class=success>Pass</td><td ng-if=test.input_9 class=danger>Fail</td><td ng-if=!test.input_10 class=success>Pass</td><td ng-if=test.input_10 class=danger>Fail</td></tr><tr ng-if=vm.myReq.outputs><th colspan=2>Output 1</th><th colspan=2>Output 2</th><th colspan=2>Output 3</th><th colspan=2>Output 4</th><th colspan=2>Output 5</th></tr><tr ng-if=vm.myReq.outputs><td colspan=2 ng-if=!test.output_1 class=success>Pass</td><td colspan=2 ng-if=test.output_1 class=danger>Fail</td><td colspan=2 ng-if=!test.output_2 class=success>Pass</td><td colspan=2 ng-if=test.output_2 class=danger>Fail</td><td colspan=2 ng-if=!test.output_3 class=success>Pass</td><td colspan=2 ng-if=test.output_3 class=danger>Fail</td><td colspan=2 ng-if=!test.output_4 class=success>Pass</td><td colspan=2 ng-if=test.output_4 class=danger>Fail</td><td colspan=2 ng-if=!test.output_5 class=success>Pass</td><td colspan=2 ng-if=test.output_5 class=danger>Fail</td></tr><tr ng-if=vm.myReq.bluetooth><th colspan=5>Tag Detect</th><th colspan=5>Bluetooth Errors</th></tr><tr ng-if=vm.myReq.bluetooth><td colspan=5 ng-if=!test.tag_detect class=success>Pass</td><td colspan=5 ng-if=test.tag_detect class=danger>Fail</td><td colspan=5>{{test.bluetooth_errors}}</td></tr><tr ng-if=vm.myReq.wiegand><th colspan=3>Wiegand Test</th><th colspan=3>Submitted Site ID</th><th colspan=3>Submitted Code</th></tr><tr ng-if=vm.myReq.wiegand><td colspan=3 ng-if=!test.wiegand class=success>Pass</td><td colspan=3 ng-if=test.wiegand class=danger>Fail</td><td colspan=3>{{test.wiegand_site}}</td><td colspan=3>{{test.wiegand_code}}</td></tr><tr><th colspan=5 ng-if=vm.myReq.sound>Sound Test</th><th colspan=5 ng-if=vm.myReq.screen>Screen Test</th></tr><tr><td colspan=5 ng-if=\"vm.myReq.sound && !test.sound\" class=success>Pass</td><td colspan=5 ng-if=\"vm.myReq.sound && test.sound\" class=danger>Fail</td><td colspan=5 ng-if=\"vm.myReq.screen && !test.screen\" class=success>Pass</td><td colspan=5 ng-if=\"vm.myReq.screen && test.screen\" class=danger>Fail</td></tr></table><table class=\"table white-back\" ng-if=vm.isTag ng-repeat=\"(key,test) in vm.qHw\"><tr><th colspan=3>Test Date: {{test.test_date}}</th><!-- <th colspan=\"2\"> --><!-- <a href=\"#\">Print Sticker</a> --><!-- <button ng-if=\"key == 0\" class=\"btn btn-primary pull-right\" ng-click=\"vm.sticker(key)\"> Print QC Sticker </button> --><!-- </th> --><th colspan=1><a href={{vm.last_location}} ng-if=\"key == 0\" class=\"btn pull-right\">Back</a></th></tr><tr><th>Average RSSI</th><th>TX Rate</th><th>Battery Level</th><th>Test Duration (seconds)</th></tr><tr><td ng-class=\"{success:test.avg_rssi >= -72 && test.avg_rssi <= -60,danger:test.avg_rssi < -74 || test.avg_rssi > -60}\">{{test.avg_rssi}}</td><td ng-class=\"{success:test.tx_rate <= .9,danger:test.tx_rate > .9}\">{{test.tx_rate}}</td><td ng-class=\"{success:test.battery_level >= 3,danger:test.battery_level < 3}\">{{test.battery_level}}</td><td>{{test.test_length}}</td></tr></table></div>");
$templateCache.put("app/quantumStatus/quantumStatus.html","<div class=row cg-busy=\"{promise:vm.load_promise,message:\'Loading\',delay:100,minDuration:250}\"><div class=col-sm-12><div class=page-header><div><h1>Quantum Site Status</h1></div></div></div><div class=col-sm-2><div class=col-sm-12><div class=report-title>Filters</div></div><div><label for=\"\">Site ID</label><input type=text class=form-control ng-model=vm.filters.site_id ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div><label for=\"\">Site Name</label><input type=text class=form-control ng-model=vm.filters.siteName ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div><label for=\"\">Server Version</label><input type=text class=form-control ng-model=vm.filters.serverVersion ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div><label for=\"\">Contract Active</label><span class=left7><input type=radio id=contract_yes name=contract_filter ng-model=vm.filters.support_contract_active value=true ng-change=vm.load_data()></span><span class=left5><label for=contract_yes>Yes Only</label></span><span class=left7><input type=radio id=contract_no name=contract_filter ng-model=vm.filters.support_contract_active value=false ng-change=vm.load_data()></span><span class=left5><label for=contract_no>No Only</label></span></div><div class=row><div class=col-sm-3><label class=top7 for=show_amount>Show Rows:</label></div><div class=col-sm-3><input name=show_amount class=form-control type=number ng-model=vm.filters.page_size></div></div><div class=\"row top7\"><div class=col-sm-3><button class=\"btn btn-success\" ng-click=vm.load_data()>Apply Filters</button></div><div class=col-sm-3><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div><div class=col-sm-6></div></div></div><div class=col-sm-10 ng-if=\"vm.swType != \'SH\'\"><div ng-if=!vm.newEntry><div><div class=col-sm-2><button class=\"btn btn-primary\" ng-click=vm.startEntry()>Add a New Quantum Customer</button></div><div class=col-sm-6></div></div><table class=table><thead><tr><th>Site ID</th><th ng-click=\"vm.filters.sort_by == \'siteName\'; vm.sort_data()\">Site Name <span ng-show=\"vm.filters.sort_by == \'siteName\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'siteName\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'lastCheckin\'; vm.sort_data()\">Last Check In <span ng-show=\"vm.filters.sort_by == \'lastCheckin\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'lastCheckin\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'offlineHardware\'; vm.sort_data()\">Offline Hardware <span ng-show=\"vm.filters.sort_by == \'offlineHardware\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'offlineHardware\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'missingDevices\'; vm.sort_data()\">Missing Devices <span ng-show=\"vm.filters.sort_by == \'missingDevices\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'missingDevices\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'lowBatteries\'; vm.sort_data()\">Low Batteries <span ng-show=\"vm.filters.sort_by == \'lowBatteries\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'lowBatteries\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'serverVersion\'; vm.sort_data()\">SW Version <span ng-show=\"vm.filters.sort_by == \'serverVersion\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'serverVersion\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'support_contract_active\'; vm.sort_data()\">Support Contract <span ng-show=\"vm.filters.sort_by == \'support_contract_active\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'support_contract_active\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'backup/timestamp\'; vm.sort_data()\">Last Backup <span ng-show=\"vm.filters.sort_by == \'backup/timestamp\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'backup/timestamp\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'backup/backup_tool_version\'; vm.sort_data()\">Backup Version <span ng-show=\"vm.filters.sort_by == \'backup/backup_tool_version\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'backup/backup_tool_version\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr ng-class=\"{danger:obj.backup.issue, warning:obj.backup.grace_period_detected, success:!obj.backup.grace_period_detected && !obj.backup.issue && obj.support_contract_active, info:!obj.backup.grace_period_detected && !obj.backup.issue && !obj.support_contract_active}\" dir-paginate=\"obj in vm.qStatus.data | itemsPerPage:vm.filters.page_size\" current-page=vm.filters.page total-items=vm.qStatus.count><td>{{obj.id}}</td><td><a href=/customerDetail/{{obj.connectwise_id}}>{{obj.siteName}}</a></td><td>{{obj.status.lastCheckin | date:\'medium\'}}</td><td>{{obj.status.offlineHardware}}</td><td>{{obj.status.missingDevices}}</td><td>{{obj.status.lowBatteries}}</td><td ng-repeat=\"setting in obj.server_settings | filter:{name:\'Server Version\'}\">{{setting.value}}</td><td>{{obj.support_contract_active ? \"YES\":\"NO\"}}</td><td>{{obj.backup.timestamp | date:\'medium\'}}</td><td>{{obj.backup.backup_tool_version}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.qStatus.data.length}} of {{vm.qStatus.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right on-page-change=vm.load_data()></dir-pagination-controls></div></div><div class=col-md-6><table class=table><tr class=success><td>Plan Active, Database backup received within 24 hours</td></tr><tr class=warning><td>Expired Plan, In Grace Period</td></tr><tr class=danger><td>Plan Active, Database backup not received within 24 hours</td></tr><tr class=info><td>Expired Plan, outside Grace Period</td></tr></table></div></div><div ng-if=vm.newEntry><span ng-if=!vm.connectwiseCustomers class=direction-display>1. To use the \"Get Information from Connectwise\" button, enter 5 or more letters of the Site name, and click the button.<br>2. You will be presented with a list of matches from that database.<br>3. As you Mouse Over the options, the data will temporarily be filled, clicking the name will lock in that customers data<br>4. After the boxes are filled, feel free to change anything that needs updating or completing. The site contact will likely be different here. A technical contact is what should be entered here instead of a sales contact. </span><span ng-if=vm.connectwiseCustomers ng-repeat=\"(key,customer) in vm.connectwiseCustomers.data\" class=direction-display><button ng-mouseleave=vm.tempEmpty() ng-mouseover=vm.tempFill(key,customer.id) ng-click=vm.customerSelect(customer.id)>{{customer.name}}</button></span><h3>New Quantum System <button class=\"btn btn-primary pull-right\" ng-disabled=!vm.checkButton() ng-click=vm.possibleCustomers()>Get Information from Connectwise</button></h3><span class=col-sm-6>Site Name: <input type=text class=form-control ng-model=vm.customerObject.siteName> </span><span class=col-sm-6>Site Phone: <input type=text class=form-control ng-model=vm.customerObject.sitePhone> </span><span class=col-sm-6>Site Street Address: <input type=text class=form-control ng-model=vm.customerObject.siteStreetAddress> </span><span class=col-sm-6>Site City: <input type=text class=form-control ng-model=vm.customerObject.siteCity> </span><span class=col-sm-6>Site State: <input type=text class=form-control ng-model=vm.customerObject.siteState> </span><span class=col-sm-6>Site Zip: <input type=text class=form-control ng-model=vm.customerObject.siteZip> </span><span class=col-sm-12>Technical Contact: <input type=text class=form-control ng-model=vm.customerObject.contactName></span><h3>Server Information</h3><span class=col-sm-6>Server Location: <input type=text class=form-control ng-model=vm.customerObject.serverLocation> </span><span class=col-sm-6>Paging Location: <input type=text class=form-control ng-model=vm.customerObject.pagingLocation> </span><span class=col-sm-6>Teamviewer Number: <input type=text class=form-control ng-model=vm.customerObject.tvNumber> </span><span class=col-sm-6>Crashplan Email: <input type=text class=form-control ng-model=vm.customerObject.crashEmail> </span><span class=col-sm-6>Crashplan Password: <input type=text class=form-control ng-model=vm.customerObject.crashPass> </span><span class=col-sm-6>QSM Active (System Monitor): <input type=checkbox class=form-control ng-model=vm.customerObject.qsm> </span><span class=col-sm-12>Site Notes:<textarea class=form-control ng-model=vm.customerObject.notes></textarea></span><button class=\"btn btn-primary pull-right\" ng-disabled=!vm.saveCheck() ng-click=vm.saveNew()>Save New Quautum Customer</button></div></div></div><div class=col-sm-12 ng-if=\"vm.swType == \'SH\'\"><div class=page-header><div><h1>SafeHealth Customers</h1></div></div><div class=title-div><button class=\"btn btn-primary\" ng-click=vm.startShCustomer()>Add a New SafeHealth Customer</button></div><div ng-if=!vm.newEntry><table datatable=ng class=table><thead><tr><th>Site ID</th><th>Site Name</th><!-- <th style=\"text-align:center;\">\n						Server Type\n					</th>\n					<th>\n						Number of Kiosks\n					</th>\n					<th>\n						Uses Web Kiosk\n					</th> --></tr></thead><tbody><tr ng-repeat=\"result in vm.qStatus\"><td>{{result.table_id}}</td><td><a href=/customerDetail/{{result.connectwise_id}}>{{result.company_name}}</a></td><!-- <td>\n						{{result.server_type}}\n					</td>\n					<td>\n						{{result.server_address}}\n					</td>\n					<td>\n						{{result.web_use}}\n					</td> --></tr></tbody></table></div><div ng-if=vm.newEntry><span ng-if=!vm.connectwiseCustomers class=direction-display>1. To use the \"Get Information from Connectwise\" button, enter 5 or more letters of the Site name, and click the button.<br>2. You will be presented with a list of matches from that database.<br>3. As you Mouse Over the options, the data will temporarily be filled, clicking the name will lock in that customers data<br>4. After the boxes are filled, feel free to change anything that needs updating or completing. The site contact will likely be different here. A technical contact is what should be entered here instead of a sales contact. </span><span ng-if=vm.connectwiseCustomers ng-repeat=\"(key,customer) in vm.connectwiseCustomers.data\" class=direction-display><button ng-mouseleave=vm.tempEmpty() ng-mouseover=vm.tempFill(key,customer.id) ng-click=vm.customerSelect(customer.id)>{{customer.name}}</button></span><h3>New SafeHealth System <button class=\"btn btn-primary pull-right\" ng-disabled=!vm.checkButton() ng-click=vm.possibleCustomers()>Get Information from Connectwise</button></h3><span class=col-sm-6>Site Name: <input type=text class=form-control ng-model=vm.customerObject.siteName> </span><span class=col-sm-6>Site Phone: <input type=text class=form-control ng-model=vm.customerObject.sitePhone> </span><span class=col-sm-6>Site Street Address: <input type=text class=form-control ng-model=vm.customerObject.siteStreetAddress> </span><span class=col-sm-6>Site City: <input type=text class=form-control ng-model=vm.customerObject.siteCity> </span><span class=col-sm-6>Site State: <input type=text class=form-control ng-model=vm.customerObject.siteState> </span><span class=col-sm-6>Site Zip: <input type=text class=form-control ng-model=vm.customerObject.siteZip> </span><span class=col-sm-12>Technical Contact: <input type=text class=form-control ng-model=vm.sstObject.technical_contact></span><h3>Server Information</h3><span class=col-sm-6>Server Type:<select class=form-control ng-model=vm.sstObject.server_type ng-options=\"stype.id as stype.name for stype in vm.serverTypes\"></select></span><span class=col-sm-6>Server Location: <input type=text class=form-control ng-model=vm.sstObject.server_location> </span><span class=col-sm-6>Customer Subnet: <input type=text class=form-control ng-model=vm.sstObject.subnet> </span><span class=col-sm-6>Customer Gateway: <input type=text class=form-control ng-model=vm.sstObject.gateway> </span><span class=col-sm-6>Customer DNS: <input type=text class=form-control ng-model=vm.sstObject.dnsA> </span><span class=col-sm-6>Customer DNS: <input type=text class=form-control ng-model=vm.sstObject.dnsB> </span><span class=col-sm-12>Teamviewer Access? <input type=checkbox ng-model=vm.sstObject.teamviewer_access ng-click=vm.tvClear()> </span><span class=col-sm-6 ng-if=vm.sstObject.teamviewer_access>Teamviewer Number: <input type=text class=form-control ng-model=vm.sstObject.teamviewer_number> </span><span class=col-sm-6 ng-if=vm.sstObject.teamviewer_access>Teamviewer Password: <input type=text class=form-control ng-model=vm.sstObject.teamviewer_password> </span><span class=col-sm-12>Site Notes:<textarea class=form-control ng-model=vm.sstObject.notes></textarea></span><button class=\"btn btn-primary pull-right\" ng-disabled=!vm.sstSaveCheck() ng-click=vm.saveSST()>Save New SafeHealth Customer</button></div></div>");
$templateCache.put("app/receiveProduct/receiveProduct.html","<script type=text/ng-template id=newPurchaseOrder.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Create Purchase Order</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<tr>\n						<th>\n							Property\n						</th>\n						<th>\n							Value\n						</th>\n					</tr>\n				</thead>\n				<tbody>\n					<tr>\n						<td>Purchase Order Number</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.poDetail.po_number\" ng-disabled=\"vm.poDetail.closed\"></td>\n					</tr>\n					<tr ng-if=\"vm.new\">\n						<td>Product</td>\n						<td><ui-select ng-model=\"vm.poDetail.product_data.id\" ng-change=\"vm.getRecommendedStartSerial()\">\n							<ui-select-match>{{$select.selected.part_number}} - {{$select.selected.name}}</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"pn.id as pn in vm.serializedParts | filter:$select.search\" refresh-delay=\"300\">\n									{{pn.part_number}} - {{pn.name}}\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n					<tr>\n						<td>Product</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.poDetail.product_data.name\" readonly></td>\n					</tr>\n					<tr>\n						<td>Start Serial Number:</td>\n						<td><input type=\"number\" class=\"form-control\" ng-disabled=\"!vm.poDetail.product_data.id || vm.poDetail.closed || vm.edit\" ng-keyup=\"vm.getEndSerial()\" ng-model=\"vm.poDetail.product_data.serial_min\"></td>\n					</tr>\n					<tr>\n						<td>Quantity:</td>\n						<td><input type=\"number\" class=\"form-control\" ng-disabled=\"!vm.poDetail.product_data.id || vm.poDetail.closed || vm.edit\" ng-keyup=\"vm.getEndSerial()\" ng-model=\"vm.poDetail.product_data.quantity\"></td>\n					</tr>\n					<tr>\n						<td>Ending Serial Number:</td>\n						<td><input type=\"number\" class=\"form-control\" ng-disabled=\"!vm.poDetail.product_data.id || vm.poDetail.closed\" ng-keyup=\"vm.getEndSerial()\" ng-model=\"vm.poDetail.product_data.serial_max\" readonly></td>\n					</tr>\n					<tr>\n						<td>Notes</td>\n						<td><textarea name=\"name\" rows=\"8\" cols=\"60\" ng-model=\"vm.poDetail.notes\" ng-disabled=\"!vm.poDetail.product_data.id || vm.poDetail.closed\"></textarea></td>\n					</tr>\n					<tr ng-if=\"vm.edit\">\n						<td>Close PO</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.poDetail.closed\" ng-disabled=\"vm.poDetail.closed\"></td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-danger pull-left\" ng-disabled=\"vm.serials_in_build\" ng-click=\"vm.removePO()\">Remove PO</button>\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.savePO()\" ng-if=\"vm.new\" ng-disabled=\"!vm.newSerialsValid()\">Save</button>\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.updatePO()\" ng-if=\"vm.edit\">Save</button>\n		</div>\n	</div></script><div class=page-header><div><h1><i class=\"fa fa-chevron-right\"></i> Receive Goods</h1></div></div><div cg-busy={promise:vm.loadPromise,delay:150}><div class=\"row bottom10 border-bottom\"><div class=col-sm-2><a class=\"btn btn-primary\" ng-click=vm.newPoDialog()><i class=\"fa fa-plus\"></i> Add New</a></div></div><div class=\"row top5\"><div class=col-sm-1><span class=\"top7 pull-left\"><label>Show Closed?</label></span><span class=\"pull-left top5 left5\"><input type=checkbox ng-model=vm.showClosed ng-change=vm.load_data()></span></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=po_number>PO Number</option><option value=product_data/part_number>Part Number</option><option value=product_data/name>Part Name</option><option value=notes>Notes</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'po_number\'; vm.sort_data()\">PO Number <span ng-show=\"vm.sort_by == \'po_number\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'po_number\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'notes\'; vm.sort_data()\">Notes <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'product_data/name\'; vm.sort_data()\">Product <span ng-show=\"vm.sort_by == \'product_data/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'product_data/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Serial Min - Max</th><th ng-click=\"vm.sort_by=\'date_created\'; vm.sort_data()\">Date Created <span ng-show=\"vm.sort_by == \'date_created\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'date_created\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Closed</th></thead><tbody><tr dir-paginate=\"(key,obj) in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count ng-click=vm.openEdit(key) style=\"cursor: pointer\"><td>{{obj.po_number}}</td><td>{{obj.notes}}</td><td>{{obj.product_data.name}} - ({{obj.product_data.part_number}})</td><td>{{obj.product_data.serial_min}} - {{obj.product_data.serial_max}}</td><td>{{obj.date_created | date:\'medium\'}}</td><td ng-if=obj.closed><i class=\"fa fa-check text-success\" aria-hidden=true></i></td><td ng-if=!obj.closed><i class=\"fa fa-exclamation text-danger\" aria-hidden=true></i></td></tr><tr ng-if=\"\"></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div>");
$templateCache.put("app/receiveProductDetail/receiveProductDetail.html","<div class=span9><div class=\"row row-fluid title-div\"><span class=col-sm-6>Part Number: {{vm.partNumber}}</span> <span class=col-sm-6>Max to Receive: {{vm.maxQty}}</span></div><div class=\"row row-fluid body-div\"><span class=col-sm-3>Amount Received</span> <span class=col-sm-8><input class=form-control ng-model=vm.submitAmount type=text name=received></span></div><div class=\"row row-fluid\"><span class=\"btn btn-primary col-sm-12\" ng-click=vm.submit() ng-disabled=!vm.submitCheck()>Submit</span></div><div class=\"row row-fluid\" ng-if=vm.submitStatus><a href=\"http://45.55.171.198/board_serial_print.php?start_sn={{vm.minSN}}&end_sn={{vm.maxSN}}\" target=_blank ng-click=vm.go()>Print Sticker</a></div></div>");
$templateCache.put("app/report-install-landing/report-install-landing.html","<div class=page-header><div><h1>Install Reports</h1></div></div><table class=table><tr><th style=width:20%>Report Title</th><th>Description</th></tr><tr><td><a href=/report-install-quote>Install Data</a></td><td>See install margins</td></tr></table>");
$templateCache.put("app/report-install-quote/report-install-quote.html","<div class=page-header><div><h1>Install Report</h1></div></div><div class=box ng-if=\"vm.data && !vm.selectedQuote\"><div class=box-content><div class=row><table datatable=ng class=table><thead><tr><th>Company Name</th><th>estimate_id</th><th>Install Company</th><th>Revenue</th><th>Cost</th><th>Additional Cost</th><th>Profit</th><th>% margin</th></tr></thead><tbody><tr ng-repeat=\"(key,val) in vm.data\" ng-click=vm.goEdit(key) style=\"cursor: pointer\"><td>{{val.company_name}}</td><td>{{val.estimate_id}}</td><td ng-if=\"val.third_party_id != null\" ng-repeat=\"sub in vm.subList | filter:{id:val.third_party_id}:true\">{{sub.name}}</td><td ng-if=\"val.third_party_id == null\">JNL Internal</td><td>{{val.income | currency}}</td><td>{{val.cost | currency}}</td><td>{{val.additional_cost | currency}}</td><td>{{vm.revenue(key)[0] | currency}}</td><td>%{{vm.revenue(key)[1] | number}}</td></tr></tbody></table></div></div></div><div class=box ng-if=vm.selectedQuote><div class=box-content><div class=row><div class=col-sm-4><div class=row><div class=\"col-sm-12 my-form-control\">Customer: {{vm.selectedQuote.company_name}}</div><div class=\"col-sm-12 my-form-control\">Estimate ID: {{vm.selectedQuote.estimate_id}}</div></div><div class=row><div class=col-sm-3><button class=\"btn btn-primary form-control\" ng-click=vm.update()>Save</button></div></div></div><div class=col-sm-8><div class=row><div class=col-sm-2><span class=my-form-control>Additional Cost:</span></div><div class=col-sm-3><input class=form-control ng-model=vm.selectedQuote.additional_cost></div></div><div class=row><div class=col-sm-2><span class=my-form-control>Notes:</span></div><div class=col-sm-6><textarea class=msd-elastic; style=width:100% ng-model=vm.selectedQuote.notes></textarea></div></div></div></div></div></div>");
$templateCache.put("app/report-procurement-build-request/report-procurement-build-request.html","<script type=text/ng-template id=multipleResults.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Choose Serial Number</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<div ng-if=\"!vm.multipleError\" class=\"col-sm-12\" ng-repeat=\"line in vm.multipleResultData\">\n					<button class=\"btn\" type=\"button\" ng-click=\"vm.serialReport(line.mac)\">{{line.mac}}</button>\n				</div>\n				<div ng-if=\"vm.multipleError\" class=\"col-sm-12\">\n					{{vm.multipleError}}\n				</div>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    </div>\n	</div></script><div class=page-header><div><h1>Build Request Report</h1></div></div><div class=box ng-if=vm.loadedComplete><div class=\"box-content nopadding\" ng-if=!vm.selectedRequest><div class=row><div class=col-md-1><button class=\"btn btn-primary\" ng-click=\"vm.chartChange(\'d\')\" ng-disabled=\"vm.visibleChart==1\"><i class=\"fa fa-chevron-left\"></i></button></div><div ng-if=\"vm.visibleChart == 1\"><div class=col-md-10><canvas id=line height=80 class=\"chart chart-bar\" chart-data=vm.data chart-labels=vm.labels chart-series=vm.series chart-options=\"{legend:{display:true, position: \'bottom\',labels:{fontSize:12}}}\" chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div ng-if=\"vm.visibleChart == 2\"><div class=col-md-10><canvas id=line height=60 class=\"chart chart-pie\" chart-data=vm.partCompareData chart-labels=vm.series chart-options=\"{legend:{display:true, position: \'bottom\',labels:{fontSize:12}}}\" chart-click=onClick></canvas></div></div><div ng-if=\"vm.visibleChart == 3\"><div class=col-md-10><table datatable=ng dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs class=\"table table-bordered table-striped\"><thead><th>Product</th><th>Quantity Built</th><th>Average Build Time</th></thead><tbody><tr ng-repeat=\"row in vm.summaryData\"><td ng-repeat=\"p in vm.allParts | filter:{id:row.product_id}:true\">{{p.part_number}} - {{p.name}}</td><td>{{row.number_built}}</td><td>{{(row.build_time / row.number_built)/60 | number:2}} minutes</td></tr></tbody></table></div></div><div class=col-md-1><button class=\"btn btn-primary\" ng-click=\"vm.chartChange(\'u\')\" ng-disabled=\"vm.maxCharts == vm.visibleChart\"><i class=\"fa fa-chevron-right\"></i></button></div></div><div class=row><div class=col-md-3><ui-select ng-model=vm.selectedYear ng-change=vm.get_data()><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\" refresh-delay=300>{{year}}</ui-select-choices></ui-select></div></div><div class=row><table datatable=ng dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs class=\"table table-bordered table-striped\"><thead><th>Build Request</th><th>Picked</th><th>Built</th><th>Date Created</th></thead><tbody><tr ng-repeat=\"request in vm.buildRequestData\" ng-click=vm.loadDetails(request.id) style=\"cursor: pointer\"><td><span>{{request.id}}</span><span ng-if=request.description> - {{request.description}}</span></td><td>{{request.picked ?\'Yes\':\'No\'}}</td><td>{{request.built ?\'Yes\':\'No\'}}</td><td>{{request.date_created | date:\"medium\"}}</td></tr></tbody></table></div></div></div><div class=box ng-if=vm.loadedComplete><div class=box-content><div ng-if=vm.selectedRequest><div class=row><span class=pull-right><button class=btn ng-click=vm.back()>Back</button></span></div><div class=row><table class=\"table table-bordered\"><thead><th>Build Request</th><th>Picked</th><th>Built</th><th>Date Created</th><th>Notes</th></thead><tbody><tr><td>{{vm.selectedRequest.description}}</td><td>{{vm.selectedRequest.picked ?\'Yes\':\'No\'}}</td><td>{{vm.selectedRequest.built ?\'Yes\':\'No\'}}</td><td>{{vm.selectedRequest.date_created | date:\"medium\"}}</td><td>{{vm.selectedRequest.notes}}</td></tr></tbody></table></div><div class=row ng-repeat=\"product in vm.selectedRequest.product_data\"><table class=\"table table-bordered\"><tr><th width=45%>Product</th><th>Quantity</th><th>Hardware Cost</th><th>Labor Cost</th><th>Cost Per Unit</th><th>Unit Price</th></tr><tr><td ng-repeat=\"p in vm.allParts | filter:{id:product.product_id}:true\">{{p.part_number}} - {{p.name}}</td><td>{{product.qty}}</td><td>{{vm.hardwareCost(product.id) | currency}}</td><td>{{vm.laborCost[product.id] | currency}}</td><td>{{vm.hardwareCost(product.id) + vm.laborCost[product.id] | currency}}</td><td>{{product.price | currency}}</td></tr><tr ng-show=!vm.pieces><td><i class=\"fa fa-plus-square\" ng-click=vm.togglePieces(true)></i> Show Pieces</td></tr><tr ng-show=vm.pieces><th><i class=\"fa fa-minus-square text-primary\" ng-click=vm.togglePieces(false)></i> Piece</th><th>Quantity</th><th>Piece Cost</th></tr><tr ng-repeat=\"piece in product.product_pieces\" ng-show=vm.pieces><td ng-repeat=\"p in vm.allParts | filter:{id:piece.piece_part_id}:true\">{{p.part_number}} - {{p.name}}</td><td>{{piece.piece_qty}}</td><td>{{piece.cost}}</td></tr></table></div><div class=\"bottomless-border row\"><div class=\"row title-div\"><div class=col-sm-12><h3>Audit Data<span class=pull-right><button class=\"btn btn-primary\" ng-click=vm.txnReport()>View Full Audit</button></span></h3></div></div><table class=\"table table-bordered\"><thead><th>Date</th><th>Action</th><th>User</th></thead><tbody><tr ng-repeat=\"txn in vm.selectedRequest.transaction_data\"><td>{{txn.date_modified | date:\"medium\"}}</td><td ng-repeat=\"action in vm.txnActions | filter:{id:txn.action}:true\">{{action.name}}</td><td ng-repeat=\"user in vm.nocUsers | filter:{user_id:txn.user_id}:true\">{{user.user_full_name}}</td></tr></tbody></table></div><div cg-busy={promise:vm.detailPromise,delay:0,minDuration:1000} class=\"bottomless-border top7 row\"><div class=\"row title-div\"><div class=col-sm-12><h3>Serial Number Data</h3></div></div><table ng-if=vm.serialNumberArray.length datatable=ng class=\"table table-bordered\"><thead><th>Serial Number</th><th>Product</th><th>Part of Final Product</th><th>Date Received</th></thead><tbody><tr ng-repeat=\"sn in vm.serialNumberArray\"><td>{{sn.serial_number}}</td><td ng-repeat=\"product in vm.allParts | filter:{id:sn.product_id}:true\">{{product.part_number}} - {{product.name}}</td><td>{{sn.part_of_final_build ?\"Yes\":\"No\"}}</td><td>{{sn.date_entered | date:\"medium\"}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/report-procurement-forecast/report-procurement-forecast.html","<script type=text/ng-template id=newProposal.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Proposal Details</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<table class=\"table\">\n				<tbody>\n					<tr>\n						<th>Customer</th>\n						<td>{{vm.possibleCust.site_name}}</td>\n					</tr>\n					<tr>\n						<th>Install Date</th>\n						<td>{{vm.possibleCust.estimated_install}}</td>\n					</tr>\n				</tbody>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.addProposal()\">Add to Report</button>\n    </div>\n	</div></script><script type=text/ng-template id=confirmRemove.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Are you sure?</h4>\n		</div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">No</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.finishRemoval()\">Yes, Remove</button>\n    </div>\n	</div></script><div class=page-header><div><h1>Part Forecasting</h1></div></div><div class=row cg-busy={promise:vm.promises,minDuration:500}><div class=row><div class=\"box-content nopadding\"><div class=\"row col-sm-12\"><div class=\"col-sm-4 top5\"><span style=float:right>Enter Proposal Number here to add:</span></div><div class=col-sm-2><input class=form-control type=text ng-model=vm.new_proposal name=\"\"></div><div class=col-sm-1><button class=\"btn btn-primary\" type=button name=button ng-click=vm.checkProposal()>Add</button></div></div></div></div><div class=box ng-if=vm.loaded><div class=\"box-content col-sm-12\"><table class=\"table table-striped\"><thead><th class=rotate style=width:180px><div><span>Customer</span></div></th><th class=rotate style=\"width:100px; font-size:10px\"><div><span>Install Date</span></div></th><th ng-repeat=\"part in vm.parts_we_care_about\" class=rotate><div><span>{{part.name}}<br>{{part.part_number}}</span></div></th></thead><tbody><tr ng-repeat=\"obj in vm.display\"><td style=font-size:10px><i class=\"fa fa-minus-circle text-danger top7\" aria-hidden=true ng-click=vm.removeProposal(obj.estimate_id)></i> {{obj.customer_name}}<br><a href=/estimateBuilder/{{obj.estimate_id}}/{{obj.estimate_type}} target=_blank>{{obj.estimate_id}}</a></td><td style=padding-top:15px>{{obj.install_date}}</td><td ng-repeat=\"(i,num) in obj.parts track by i\" style=\"border: 1px solid #ccc; text-align: center; padding-top:15px\"><span ng-if=\"!num[2] && num[0] > 0\"><i class=\"fa fa-hand-rock-o text-danger top7\" aria-hidden=false ng-click=vm.pickPart(obj.estimate_id,num[1],1)></i></span><span ng-if=\"num[2] && num[0] > 0\"><i class=\"fa fa-eye text-success top7\" aria-hidden=true ng-click=vm.pickPart(obj.estimate_id,num[1],0)></i></span><span ng-if=\"num[0] > 0\">{{num[0]}}</span></td></tr></tbody><tbody><tr class=bold-and-dark><th colspan=2 style=\"background-color: black !important\">Total</th><td ng-repeat=\"(i,num) in vm.total track by i\" style=\"text-align: center\">{{num}}</td></tr><tr><th colspan=2>30 Days</th><td ng-repeat=\"(i,num) in vm.day30 track by i\" style=\"text-align: center\">{{num}}</td></tr><tr><th colspan=2>60 Days</th><td ng-repeat=\"(i,num) in vm.day60 track by i\" style=\"text-align: center\">{{num}}</td></tr><tr><th colspan=2>90 Days</th><td ng-repeat=\"(i,num) in vm.day90 track by i\" style=\"text-align: center\">{{num}}</td></tr><tr><th colspan=2>Over 90 Days</th><td ng-repeat=\"(i,num) in vm.dayOver90 track by i\" style=\"text-align: center\">{{num}}</td></tr><tr><th colspan=2>Inventory On Hand</th><td ng-repeat=\"part in vm.parts_we_care_about\" style=\"text-align: center\">{{part.on_hand}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/report-procurement-landing/report-procurement-landing.html","<div class=page-header><div><h1>Procurement Reports</h1></div></div><table class=table><tr><th style=width:20%>Report Title</th><th>Description</th></tr><tr><td><a href=/report-procurement-serial-number>Serial Number Report</a></td><td>View data related to serial numbers of JNL Boards, Mac Addresses of Pi\'s</td></tr><!-- <tr>\n		<td>\n			<a href=\"/report-procurement-purchase-order/-1\">Purchase Order Report</a>\n		</td>\n		<td>\n			View data related to a specific Purchase Order\n		</td>\n	</tr>\n	<tr>\n		<td>\n			<a href=\"/report-procurement-build-request/-1\">Build Request Report</a>\n		</td>\n		<td>\n			View data related to a specific Build Request\n		</td>\n	</tr> --><tr><td><a href=/report-procurement-on-hand>Build Part Quantity Report</a></td><td>Select Builds, and see on hand quantities of parts required</td></tr><tr><td><a href=/report-procurement-required-sub-parts>Build Part Quantity Requirement Report</a></td><td>Select builds, assign quantities, find how many of each sub part are required to accomplish it</td></tr><!-- <tr>\n		<td>\n			<a href=\"/report-procurement-forecast\">Forecast Report</a>\n		</td>\n		<td>\n			Forecast report\n		</td>\n	</tr> --></table>");
$templateCache.put("app/report-procurement-on-hand/report-procurement-on-hand.html","<div class=page-header><div><h1>Build On Hand Parts</h1></div></div><div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=\"box-content nopadding\"><div class=\"row col-sm-12\"><ui-select ng-change=vm.loadResults() ng-model=vm.selectedBuildArray multiple><ui-select-match placeholder=\"Choose Build(s) to examine\">{{$item.product_data.name}} - ({{$item.product_data.part_number}})</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"build in vm.builds | filter:$select.search\">{{build.product_data.name}} - ({{build.product_data.part_number}})</ui-select-choices></ui-select></div></div></div><div class=box ng-if=vm.selectedBuilds><div class=\"box-content col-sm-8\"><table class=\"table table-striped\" ng-repeat=\"(selectedBuildIndex,obj) in vm.selectedBuilds\"><tr><th colspan=3>{{obj.product_data.name}} ({{obj.product_data.part_number}})</th><th>Max: {{obj.max}}</th></tr><tr><th>Required Parts</th><th>Required Quantity</th><th>Quantity On Hand</th><th>Ignore Part</th></tr><tr ng-repeat=\"(index,part) in obj.included_parts\" ng-class=\"{\'danger text-danger bold\':index==obj.index_of_lowest}\"><td>{{part.product_data.name}} ({{part.product_data.part_number}})</td><td>{{part.quantity}}</td><td>{{part.on_hand}}</td><td><input type=checkbox ng-model=part.ignore ng-change=vm.update_ignore(selectedBuildIndex)></td></tr></table></div></div>");
$templateCache.put("app/report-procurement-purchase-order/report-procurement-purchase-order.html","<script type=text/ng-template id=multipleResults.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Choose Serial Number</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<div ng-if=\"!vm.multipleError\" class=\"col-sm-12\" ng-repeat=\"line in vm.multipleResultData\">\n					<button class=\"btn\" type=\"button\" ng-click=\"vm.serialReport(line.mac)\">{{line.mac}}</button>\n				</div>\n				<div ng-if=\"vm.multipleError\" class=\"col-sm-12\">\n					{{vm.multipleError}}\n				</div>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    </div>\n	</div></script><div class=page-header><div><h1>Purchase Order Report</h1></div></div><div class=row ng-if=!vm.selectedPo><table datatable=ng dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs class=\"table table-bordered table-striped\"><thead><th>PO Number</th><th>Status</th><th>Date Created</th></thead><tbody><tr ng-repeat=\"po in vm.poData\" ng-click=vm.loadDetails(po.id) style=\"cursor: pointer\"><td>{{po.po_number}}</td><td>{{po.closed ?\'Closed\':\'Open\'}}</td><td>{{po.date_created | date:\"medium\"}}</td></tr></tbody></table></div><div class=row ng-if=vm.selectedPo><table class=\"table table-bordered\"><thead><th>PO Number</th><th>Status</th><th>Notes</th></thead><tbody><tr><td>{{vm.selectedPo.po_number}}</td><td>{{vm.selectedPo.closed ?\'Closed\':\'Open\'}}</td><td>{{vm.selectedPo.notes}}</td></tr></tbody></table><div class=bottomless-border><div class=\"row title-div\"><div class=col-sm-12><h3>Audit Data<span class=pull-right><button class=\"btn btn-primary\" ng-click=vm.txnReport()>View Full Audit</button></span></h3></div></div><table class=\"table table-bordered\"><thead><th>Date</th><th>Action</th><th>User</th></thead><tbody><tr ng-repeat=\"txn in vm.selectedPo.transaction_data\"><td>{{txn.date_modified | date:\"medium\"}}</td><td ng-repeat=\"action in vm.txnActions | filter:{id:txn.action}:true\">{{action.name}}</td><td ng-repeat=\"user in vm.nocUsers | filter:{user_id:txn.user_id}:true\">{{user.user_full_name}}</td></tr></tbody></table></div><div cg-busy={promise:vm.detailPromise,delay:0,minDuration:1000} class=\"bottomless-border top7\"><div class=\"row title-div\"><div class=col-sm-12><h3>Serial Number Data</h3></div></div><table ng-if=vm.serialNumberArray.length datatable=ng class=\"table table-bordered\"><thead><th>Serial Number</th><th>Product</th><th>Part of Final Product</th><th>Date Received</th></thead><tbody><tr ng-repeat=\"sn in vm.serialNumberArray\"><td>{{sn.serial_number}}</td><td ng-repeat=\"product in vm.allParts | filter:{id:sn.product_id}:true\">{{product.part_number}} - {{product.name}}</td><td>{{sn.part_of_final_build ?\"Yes\":\"No\"}}</td><td>{{sn.date_entered | date:\"medium\"}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/report-procurement-required-sub-parts/report-procurement-required-sub-parts.html","<div class=page-header><div><h1>Build On Hand Parts</h1></div></div><div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=\"box-content nopadding\"><div class=\"row col-sm-12\"><ui-select ng-model=vm.selectedBuildArray multiple><ui-select-match placeholder=\"Choose Build(s) to examine\">{{$item.product_data.name}} - ({{$item.product_data.part_number}})</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"build in vm.builds | filter:$select.search\">{{build.product_data.name}} - ({{build.product_data.part_number}})</ui-select-choices></ui-select></div></div></div><div class=row ng-if=vm.selectedBuildArray><div class=col-sm-12><button class=\"btn btn-primary\" ng-click=vm.loadResults() ng-disabled=!vm.all_have_quantity()>Run Report</button></div><div class=col-sm-12><table class=table><thead><tr><th>Part (Part Number)</th><th>Quantity to Build</th></tr></thead><tbody><tr ng-repeat=\"(k,part) in vm.selectedBuildArray\"><td>{{part.product_data.name}} - ({{part.product_data.part_number}})</td><td><input type=number class=form-control ng-model=part.requested_quantity></td></tr></tbody></table></div></div><div class=box ng-if=vm.pd><div class=\"box-content col-sm-8\"><table class=\"table table-striped\"><tbody><tr><th>Part - (Part Number)</th><th>Required Quantity</th><th>Quantity On Hand</th><th>Amount Short</th></tr><tr ng-repeat=\"(part_number,arr) in vm.pd\" ng-class=\"{\'danger text-danger bold\':arr[2] - arr[0] < 0}\"><td>{{arr[1]}} ({{part_number}})</td><td>{{arr[0]}}</td><td>{{arr[2]}}</td><td ng-if=\"arr[2] - arr[0] < 0\">{{(arr[2] - arr[0])*-1}}</td><td ng-if=\"arr[2] - arr[0] >= 0\">0</td></tr></tbody></table></div></div>");
$templateCache.put("app/report-procurement-serial-number/report-procurement-serial-number.html","<script type=text/ng-template id=multipleResults.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Choose Serial Number</h4>\n		</div>\n    	<div class=\"modal-body\">\n			<div class=\"row\">\n				<div ng-if=\"!vm.multipleError\" class=\"col-sm-12\" ng-repeat=\"line in vm.multipleResultData\">\n					<div ng-if=\"vm.jnl_search\">\n						<button class=\"btn\" type=\"button\" ng-click=\"vm.load_from_serial_generator_id(line.id)\">{{line.serial_number}}</button> {{line.product_data.name}} - ({{line.product_data.part_number}})\n					</div>\n					<div ng-if=\"!vm.jnl_search\">\n						<button class=\"btn\" type=\"button\" ng-click=\"vm.serialReport(line.serial_number)\">{{line.serial_number}}</button> {{line.product.name}} - ({{line.product.part_number}})\n					</div>\n				</div>\n				<div ng-if=\"vm.multipleError\" class=\"col-sm-12\">\n					{{vm.multipleError}}\n				</div>\n			</div>\n    	</div>\n		<div class=\"modal-footer\">\n		<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n		</div>\n	</div></script><script type=text/ng-template id=serialNumberData.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Detach a JNL board from a final product?</h4>\n		</div>\n		<div class=\"modal-body\">\n			<table class=\"table table-hover\">\n				<thead>\n					<th>\n						Product Name\n					</th>\n					<th>\n						Serial associated to a completed product\n					</th>\n				</thead>\n				<tbody>\n					<tr>\n						<td>{{vm.reportResult.board.product_data.part_number}} - {{vm.reportResult.board.product_data.name}}</td>\n						<td ng-class=\"{success:!vm.reportResult.board.final_product,danger:vm.reportResult.board.final_product}\">{{vm.reportResult.board.final_product ? \"YES\":\"NO\"}}</td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Ok</button>\n			<button class=\"btn btn-danger\" type=\"button\" ng-if=\"vm.reportResult.board.final_product\" ng-click=\"vm.resetSerialNumber(vm.reportResult.board)\">Restart Serial Number {{vm.reportResult.board.serial_number}}</button>\n			<div ng-if=\"vm.reportResult.board.final_product\" class=\"negativeNumber boldItalic\">Warning, resetting a serial number will clear any existing assocations with previous products it was associated with.  This should only be done if you are sure it is the correct thing to do</div>\n		</div>\n	</div></script><div class=page-header><div><h1>Serial Number Report</h1></div></div><div class=row><div class=col-sm-2><span>Enter Serial Number</span></div><div class=col-sm-6><input class=form-control ng-model=vm.serialNumber ng-keypress=vm.runOnEnter($event)></div><div class=col-sm-2><button type=submit ng-click=vm.serialReport() class=\"btn btn-primary form-control\">Run Report</button></div><div class=col-sm-2><a href={{vm.last_location}}><button class=\"btn form-control\">Back</button></a></div></div><div class=row><div class=col-sm-2>Search Finished Product Only <input type=checkbox ng-model=vm.finished_only ng-disabled=vm.jnl_only></div><div class=col-sm-2>Search JNL Board Only <input type=checkbox ng-model=vm.jnl_only ng-disabled=vm.finished_only></div></div><div ng-if=vm.reportRun cg-busy={promise:vm.reportPromise,minDuration:700}><h3 ng-if=!vm.reportResult.finished>Finished Product Data - No Data Found</h3><h3 ng-if=vm.reportResult.finished>Finished Product Data</h3><table class=table ng-if=vm.reportResult.finished><tr><th>Mac Address</th><th>Device</th><th>Site</th><th>Last Tested</th><th>Last Tester</th></tr><tr><td>{{vm.reportResult.finished.serial_number}}</td><td>{{vm.reportResult.finished.product.part_number}} - {{vm.reportResult.finished.product.name}}</td><td ng-if=vm.reportResult.finished.quantum_customer.id><a href=customerDetail/{{vm.reportResult.finished.quantum_customer.id}} target=_blank>{{vm.reportResult.finished.quantum_customer.name}}</a></td><td ng-if=!vm.reportResult.finished.quantum_customer.id>Not Registered</td><td>{{vm.reportResult.finished.tested_date | date:\'medium\'}}</td><td>{{vm.reportResult.finished.tester.name}}</td></tr></table><h3 ng-if=!vm.reportResult.board>Board Data - No Data Found</h3><h3 ng-if=vm.reportResult.board>Board Data</h3><table class=table ng-if=vm.reportResult.board><tr><th>Serial Number</th><th>Part Number</th><th>Date Entered</th><th>Purchase Order</th><th>Test Passed</th><th>Date Tested</th><th>Tester</th></tr><tr><td ng-click=vm.serialReset() style=\"cursor: pointer\">{{vm.reportResult.board.serial_number}}</td><td>{{vm.reportResult.board.product_data.part_number}} - {{vm.reportResult.board.product_data.name}}</td><td>{{vm.reportResult.board.date_entered | date:\'medium\'}}</td><td><a href=report-procurement-purchase-order/{{vm.reportResult.board.purchase_order.po_number}} target=_blank>{{vm.reportResult.board.purchase_order.po_number}}</a></td><td>{{vm.reportResult.board.test_status.passed ? \"YES\":\"NO\"}}</td><td>{{vm.reportResult.board.test_status.tested_date | date:\'medium\'}}</td><td ng-repeat=\"user in vm.nocUsers | filter:{user_id:vm.reportResult.board.tester}:true\">{{user.user_full_name}}</td></tr></table></div>");
$templateCache.put("app/report-sales-individual/report-sales-individual.html","<div class=page-header><div><h1>Sales Report</h1></div></div><div class=box ng-if=vm.loadedComplete><div class=\"box-content nopadding\" ng-if=!vm.selectedRequest><div class=row><div class=col-md-1><button class=\"btn btn-primary\" ng-click=\"vm.chartChange(\'d\')\" ng-disabled=\"vm.visibleChart==1\"><i class=\"fa fa-chevron-left\"></i></button></div><div ng-if=\"vm.visibleChart == 1\"><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.userChartData chart-labels=vm.labels chart-series=vm.cats chart-options=vm.options chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div ng-if=\"vm.visibleChart == 2\"><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.aggChartData chart-labels=vm.labels chart-series=vm.cats chart-options=vm.options2 chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div ng-if=\"vm.visibleChart == 3\"><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.totalChartData chart-labels=vm.labels chart-series=\"[\'Goal\',\'Sales\']\" chart-options=vm.options3 chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div class=col-md-1><button class=\"btn btn-primary\" ng-click=\"vm.chartChange(\'u\')\" ng-disabled=\"vm.maxCharts == vm.visibleChart\"><i class=\"fa fa-chevron-right\"></i></button></div></div><div class=\"row top7\"><div class=col-md-1></div><div class=\"col-md-1 top7\">Select Year:</div><div class=col-md-3><ui-select ng-model=vm.selectedYear ng-change=vm.update_year()><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\" refresh-delay=300>{{year}}</ui-select-choices></ui-select></div><div class=\"col-md-1 top7\">Select Rep:</div><div class=col-md-3><ui-select ng-model=vm.selectedRep ng-change=vm.update()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"rep.user_id as rep in vm.availableReps | filter:$select.search\" refresh-delay=300>{{rep.name}}</ui-select-choices></ui-select></div><div class=col-md-1></div></div><div class=\"row top7\"><div class=col-md-1></div><div class=col-sm-10><table class=\"table table-striped\"><thead><tr><th>Customer</th><th>Revenue</th><th>Date Closed</th></tr></thead><tbody><tr ng-repeat=\"est in vm.productionData.estimate_data\"><td>{{est.name}}</td><td>{{est.price | currency}}</td><td>{{est.close_date}}</td></tr><tr class=bottom-bold><td>Number of Sales: {{vm.productionData.estimate_data.length}}</td><td>Total Dollars Sold: {{vm.totalRevenue() | currency}}</td><td></td></tr></tbody></table></div><div class=col-md-1></div></div></div></div>");
$templateCache.put("app/report-sales-invoice/report-sales-invoice.html","<div class=page-header><div><h1>Invoice Report</h1></div></div><div class=\"row center\" cg-busy=\"{promise:vm.load,delay:0,message:\'Loading Data\',minDuration:1000}\"><div class=\"row bottom5\">*Just click the run button to email to Jim, the current year and quarter are automatically selected if the form is empty</div><div class=\"box bottom5\"><div class=row><div class=col-sm-2>Emails To:</div><div class=\"controls col-sm-6\"><ui-select multiple ng-model=vm.submission_object.email ng-change=vm.part_selected($select.selected)><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"pn.email as pn in vm.email_list | filter:$select.search\" refresh-delay=300>{{pn.name}}</ui-select-choices></ui-select></div></div></div><div class=\"box bottom5\"><div class=row><div class=col-sm-2>Year:</div><div class=\"controls col-sm-6\"><ui-select ng-model=vm.submission_object.year><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"pn in vm.available_years | filter:$select.search\" refresh-delay=300>{{pn}}</ui-select-choices></ui-select></div></div></div><div class=box><div class=row><div class=col-sm-2>Quarter:</div><div class=\"controls col-sm-6\"><ui-select ng-model=vm.submission_object.quarter><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"pn in vm.available_quarters | filter:$select.search\" refresh-delay=300>{{pn}}</ui-select-choices></ui-select></div></div></div><div class=box><div class=row><div class=col-sm-2><button class=\"btn btn-primary\" ng-click=vm.send_it()>Run</button></div></div></div></div>");
$templateCache.put("app/report-sales-landing/report-sales-landing.html","<div class=page-header><div><h1>Sales Reports</h1></div></div><table class=table><tr><th style=width:20%>Report Title</th><th>Description</th></tr><tr><td><a href=/report-sales-territory>View Dealers per Region</a></td><td>View Dealers and their registered users per region.</td></tr><!-- <tr>\n		<td>\n			<a href=\"/report-sales-individual\">Individual Sales Data</a>\n		</td>\n		<td>\n			See individual data that shows yearly comparisons, as well as sales vs. goals.\n		</td>\n	</tr>\n	<tr>\n		<td>\n			<a href=\"/report-sales-territory\">Territory Sales Data</a>\n		</td>\n		<td>\n			See sales data based on terrirtory.\n		</td>\n	</tr> --><tr><td><a href=/report-sales-third-party>Yearly Sales Data</a></td><td>See the Sales Data, for this year, or any year in the past</td></tr><!-- <tr ng-if=\"vm.userData.data.user_id == 6 || vm.userData.data.user_id == 9\">\n		<td>\n			<a href=\"/report-sales-invoice\">Run Invoice Reports</a>\n		</td>\n		<td>\n			Send email of invoice data\n		</td>\n	</tr> --></table>");
$templateCache.put("app/report-sales-territory/report-sales-territory.html","<script type=text/ng-template id=viewContacts.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Registered Users</h4>\n		</div>\n		<!-- /.modal-header -->\n    	<div class=\"modal-body\">\n			<table class=\"table table-striped\">\n				<thead>\n					<tr>\n						<th>Name</th>\n						<th>Phone Number</th>\n						<th>Email</th>\n					</tr>\n				</thead>\n				<tbody>\n					<tr ng-repeat=\"user in vm.dealerUsers\">\n						<td>{{user.user_full_name}}</td>\n						<td>{{user.phone}}</td>\n						<td>{{user.user_email}}</td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Close</button>\n		</div>\n	</div></script><div class=page-header><div><h1>Territory Report</h1></div></div><div class=box ng-if=!vm.selectedRegion><div class=\"box-content nopadding\" ng-if=!vm.selectedRequest><div class=row><div class=\"col-sm-1 custom_label\">Choose Region</div><div class=col-md-3><ui-select ng-model=vm.selectedRegion ng-change=vm.load_data()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"region in vm.regions | filter:$select.search\" refresh-delay=300>{{region.name}}</ui-select-choices></ui-select></div></div></div></div><div ng-if=vm.selectedRegion><div class=\"row bottom10\"><div class=col-sm-2><ui-select ng-model=vm.selectedRegion ng-change=vm.load_data()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"region in vm.regions | filter:$select.search\" refresh-delay=300>{{region.name}}</ui-select-choices></ui-select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-1><select class=form-control ng-model=vm.searchFor><option value=dealer/name>Dealer Name</option><option value=state/name>State Name</option><option value=state/abbreviation>State Abbreviation</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=table><thead><tr><th ng-click=\"vm.sort_by=\'dealer/name\'; vm.sort_data()\">Name <span ng-show=\"vm.sort_by == \'dealer/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'dealer/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Address</th><th>City</th><th ng-click=\"vm.sort_by=\'state/abbreviation\'; vm.sort_data()\">State <span ng-show=\"vm.sort_by == \'state/abbreviation\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'state/abbreviation\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Zip</th><th>Phone</th></tr></thead><tbody><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count ng-click=\"vm.selectedDealer = obj; vm.openDealer()\"><td>{{obj.dealer.name}}</td><td>{{obj.dealer.address}}</td><td>{{obj.dealer.city}}</td><td>{{obj.state.abbreviation}}</td><td>{{obj.dealer.zip}}</td><td>{{obj.dealer.phone}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div>");
$templateCache.put("app/report-sales-third-party/report-sales-third-party.html","<div class=page-header><div class=row><div class=col-md-9><h1 class=page-title>Sales Report Data</h1></div><div class=\"col-md-3 text-right\"><!-- <button class=\"btn btn-primary\" ng-if=\"vm.submissionObj.id\" ng-click=\"vm.back()\">Back</button>\n			<button class=\"btn btn-success\" ng-if=\"!vm.submissionObj.id && !vm.new\" ng-click=\"vm.new=true\">New</button> --></div></div></div><div cg-busy={promise:vm.load_promise,delay:0,minDuration:1000} class=container-fluid><div class=row><div class=col-md-12><div class=\"row bottom10\"><div class=col-sm-1><input class=form-control type=text ng-model=vm.year></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.load_data()>Run Report</button></div></div><div class=report-header><div class=row><div class=col-md-12><h3 class=page-title>Order Intake</h3></div><div class=\"col-md-3 text-right\"><!-- <button class=\"btn btn-primary\" ng-if=\"vm.submissionObj.id\" ng-click=\"vm.back()\">Back</button>\n						<button class=\"btn btn-success\" ng-if=\"!vm.submissionObj.id && !vm.new\" ng-click=\"vm.new=true\">New</button> --></div></div></div><div class=row ng-if=vm.data><table class=\"table table-bordered table-striped table-sm\"><thead><tr><th ng-click=\"vm.sortColumn = \'year\'; vm.reverse = !vm.reverse\">Year</th><th ng-click=\"vm.sortColumn = \'name\'; vm.reverse = !vm.reverse\">Rep</th><th ng-click=\"vm.sortColumn = \'total[0]\'; vm.reverse = !vm.reverse\">YTD</th><th ng-repeat=\"label in vm.labels\">{{label}}</th></tr></thead><tbody><tr ng-repeat=\"obj in vm.data.reps.data | orderBy:vm.sortColumn:vm.reverse\"><td>{{obj.year}}</td><td>{{obj.name}}</td><td><span class=bold>{{obj.total[0] | currency}}</span><span class=left5>({{obj.notify_total[0] | currency}})</span></td><td ng-repeat=\"value in obj.total.slice(1) track by $index\"><span class=bold>{{value | currency}}</span><span class=left5>({{obj.notify_total[$index +1] | currency}})</span></td></tr></tbody><tfoot class=\"fw-bold bg-light\"><tr><td colspan=2>Totals</td><td><span class=bold>{{vm.getTotal(0) | currency}}</span><span class=left5>({{vm.getNotifyTotal(0) | currency}})</span></td><td ng-repeat=\"i in [].constructor(vm.labels.length) track by $index\"><span class=bold>{{vm.getTotal($index + 1) | currency}}</span><span class=left5>({{vm.getNotifyTotal($index+1) | currency}})</span></td></tr></tfoot></table></div><div class=report-header><div class=row><div class=col-md-12><h3 class=page-title>Orders Shipped</h3></div><div class=\"col-md-3 text-right\"><!-- <button class=\"btn btn-primary\" ng-if=\"vm.submissionObj.id\" ng-click=\"vm.back()\">Back</button>\n						<button class=\"btn btn-success\" ng-if=\"!vm.submissionObj.id && !vm.new\" ng-click=\"vm.new=true\">New</button> --></div></div></div><div class=row ng-if=vm.data><table class=\"table table-bordered table-striped table-sm\"><thead><tr><th ng-click=\"vm.sortColumn = \'year\'; vm.reverse = !vm.reverse\">Year</th><th ng-click=\"vm.sortColumn = \'name\'; vm.reverse = !vm.reverse\">Rep</th><th ng-click=\"vm.sortColumn = \'total[0]\'; vm.reverse = !vm.reverse\">YTD</th><th ng-repeat=\"label in vm.labels\">{{label}}</th></tr></thead><tbody><tr ng-repeat=\"obj in vm.data.reps.invoice_data | orderBy:vm.sortColumn:vm.reverse\"><td>{{obj.year}}</td><td>{{obj.name}}</td><td><span class=bold>{{obj.total[0] | currency}}</span><span class=left5>({{obj.notify_total[0] | currency}})</span></td><td ng-repeat=\"value in obj.total.slice(1) track by $index\"><span class=bold>{{value | currency}}</span><span class=left5>({{obj.notify_total[$index +1] | currency}})</span></td></tr></tbody><tfoot class=\"fw-bold bg-light\"><tr><td colspan=2>Totals</td><td><span class=bold>{{vm.getInvoiceTotal(0) | currency}}</span><span class=left5>({{vm.getInvoiceNotifyTotal(0) | currency}})</span></td><td ng-repeat=\"i in [].constructor(vm.labels.length) track by $index\"><span class=bold>{{vm.getInvoiceTotal($index + 1) | currency}}</span><span class=left5>({{vm.getInvoiceNotifyTotal($index+1) | currency}})</span></td></tr></tfoot></table></div><div class=report-header><div class=row><div class=col-md-6><h3 class=page-title>Summary Order Intake</h3></div><div class=col-md-6><h3 class=page-title>Summary Invoice Intake</h3></div></div></div><div class=row ng-if=vm.data><div class=col-md-6><table class=\"table table-bordered table-sm\"><thead><tr><th>Rep</th><th>MTD Bookings</th><th>Monthly Quota</th><th>%MTD Quota</th><th>YTD Bookings</th><th>Yearly Quota</th><th>%YTD Quota</th></tr></thead><tbody><tr ng-repeat=\"obj in vm.data.reps.data | orderBy:vm.sortColumn:vm.reverse\"><td>{{obj.name}}</td><td>{{obj.total[vm.month] | currency}}</td><td><input class=form-control type=number disabled ng-model=obj.monthly_quota ng-value=\"obj.monthly_quota | currency\"></td><td><span ng-if=obj.monthly_quota>{{ (obj.total[vm.month] / obj.monthly_quota * 100) | number:2 }}%</span></td><td>{{obj.total[0] | currency}}</td><td><input class=form-control type=number ng-model=obj.yearly_quota ng-value=\"obj.yearly_quota | currency\"></td><td><span ng-if=obj.yearly_quota>{{ (obj.total[0] / obj.yearly_quota * 100) | number:2 }}%</span></td></tr></tbody></table></div><div class=col-md-6><table class=\"table table-bordered table-sm\"><thead><tr><th>Rep</th><th>MTD Bookings</th><th>Monthly Quota</th><th>%MTD Quota</th><th>YTD Bookings</th><th>Yearly Quota</th><th>%YTD Quota</th></tr></thead><tbody><tr ng-repeat=\"obj in vm.data.reps.invoice_data | orderBy:vm.sortColumn:vm.reverse\"><td>{{obj.name}}</td><td>{{obj.total[vm.month] | currency}}</td><td><input class=form-control type=number disabled ng-model=obj.monthly_quota ng-value=\"obj.monthly_quota | currency\"></td><td>{{ (obj.total[vm.month] / obj.monthly_quota * 100) | number:2 }}%</td><td>{{obj.total[0] | currency}}</td><td><input class=form-control type=number ng-model=obj.yearly_quota ng-value=\"obj.yearly_quota | currency\"></td><td>{{ (obj.total[0] / obj.yearly_quota * 100) | number:2 }}%</td></tr></tbody></table></div></div><div class=report-header><div class=row><div class=col-md-6><h3 class=page-title>Distributor Totals (Values are based on \"credited value\")</h3></div><div class=col-md-12><button class=\"btn btn-primary\" ng-click=vm.exportDistributorCSV()>Export CSV</button></div></div></div><div class=row ng-if=vm.data><div class=col-md-6><table class=\"table table-bordered table-striped table-sm\"><thead><tr><th>Distributor</th><th>Value</th></tr></thead><tbody><tr ng-repeat=\"obj in vm.data.distributors.data\"><td>{{obj.name}}</td><td>{{obj.total | currency}}</td></tr></tbody></table></div></div><div class=report-header ng-if=\"vm.data && vm.viewPage=\'invoiceTable\'\"><div class=row><div class=col-md-12><h3 class=page-title>Invoice Table</h3></div><div class=\"col-md-3 text-right\"><!-- <button class=\"btn btn-primary\" ng-if=\"vm.submissionObj.id\" ng-click=\"vm.back()\">Back</button>\n						<button class=\"btn btn-success\" ng-if=\"!vm.submissionObj.id && !vm.new\" ng-click=\"vm.new=true\">New</button> --></div></div></div><div ng-if=\"vm.data && vm.viewPage=\'invoiceTable\'\"><button class=\"btn btn-primary\" ng-click=vm.exportCSV()>Export CSV</button><table class=table><thead><tr><th>Invoice ID</th><th ng-click=\"vm.filters.sort_by == \'siteName\'; vm.sort_data()\">Sales Rep <span ng-show=\"vm.filters.sort_by == \'siteName\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'siteName\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'lastCheckin\'; vm.sort_data()\">Date <span ng-show=\"vm.filters.sort_by == \'lastCheckin\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'lastCheckin\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'offlineHardware\'; vm.sort_data()\">End User <span ng-show=\"vm.filters.sort_by == \'offlineHardware\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'offlineHardware\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'missingDevices\'; vm.sort_data()\">Distributor <span ng-show=\"vm.filters.sort_by == \'missingDevices\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'missingDevices\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'lowBatteries\'; vm.sort_data()\">Department <span ng-show=\"vm.filters.sort_by == \'lowBatteries\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'lowBatteries\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'serverVersion\'; vm.sort_data()\">IS NOTIFY <span ng-show=\"vm.filters.sort_by == \'serverVersion\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'serverVersion\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'support_contract_active\'; vm.sort_data()\">Credited Value <span ng-show=\"vm.filters.sort_by == \'support_contract_active\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'support_contract_active\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'backup/timestamp\'; vm.sort_data()\">Invoice Tax <span ng-show=\"vm.filters.sort_by == \'backup/timestamp\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'backup/timestamp\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filters.sort_by=\'backup/timestamp\'; vm.sort_data()\">CC/S&H/Tarrif <span ng-show=\"vm.filters.sort_by == \'backup/timestamp\' && vm.filters.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filters.sort_by == \'backup/timestamp\' && vm.filters.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr ng-class={danger:obj.backup.issue} dir-paginate=\"obj in vm.data.inv_table_data | itemsPerPage:vm.filters.page_size\" current-page=vm.filters.page><td>{{obj[0]}}</td><td>{{obj[1]}}</td><td>{{obj[2] | date:\'short\'}}</td><td>{{obj[3]}}</td><td>{{obj[4]}}</td><td>{{obj[5]}}</td><td>{{obj[6]}}</td><td>{{obj[7]}}</td><td>{{obj[8]}}</td><td>{{obj[9]}}</td></tr></tbody></table><dir-pagination-controls max-size=30 direction-links=true boundary-links=true></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-sales-yearly/report-sales-yearly.html","<div class=page-header><div><h1>Sales Report</h1></div></div><div cg-busy={promise:vm.p,delay:200,minDuration:1000}><div class=box ng-if=vm.loadedComplete><div class=\"box-content nopadding\" ng-if=!vm.selectedRequest><div class=row><div class=col-md-1><button class=\"btn btn-primary\" ng-click=\"vm.chartChange(\'d\')\" ng-disabled=\"vm.visibleChart==1\"><i class=\"fa fa-chevron-left\"></i></button></div><div ng-if=\"vm.visibleChart == 1\"><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.data chart-labels=vm.labels chart-series=vm.series chart-options=\"{legend:{display:true, position: \'bottom\',labels:{fontSize:12}},elements:{line:{fill:false,tension:.2}},scales:{yAxes:[{scaleLabel:{display:true,labelString:\'Sales Closed\'}}]}}\" chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div ng-if=\"vm.visibleChart == 2\"><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.companyGoalData chart-labels=vm.labels chart-series=vm.companyLabels chart-options=vm.options2 chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div ng-if=\"vm.visibleChart == 3\"><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.aggregateCompanyData chart-labels=vm.labels chart-series=vm.companyLabels chart-options=vm.options3 chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div class=col-md-1><button class=\"btn btn-primary\" ng-click=\"vm.chartChange(\'u\')\" ng-disabled=\"vm.maxCharts == vm.visibleChart\"><i class=\"fa fa-chevron-right\"></i></button></div></div><div class=\"simple-border bottom15\"><div class=\"row top15\" ng-if=\"vm.visibleChart == 1\"><div><div class=col-md-1></div><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.totals chart-labels=vm.labels chart-series=vm.series chart-options=vm.options5 chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div class=col-md-1></div></div><div class=row ng-if=\"vm.visibleChart == 1\"><div class=col-md-1></div><div class=col-md-2 ng-repeat=\"(k,v) in vm.totalTotals\">{{vm.series[k]}} = <span><b>{{v}}</b></span></div><div class=col-md-1></div></div></div><div class=\"simple-border bottom15\"><div class=\"row top15\" ng-if=\"vm.visibleChart == 1\"><div><div class=col-md-1></div><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.revenue chart-labels=vm.labels chart-series=vm.series chart-options=vm.options chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div class=col-md-1></div></div><div class=row ng-if=\"vm.visibleChart == 1\"><div class=col-md-1></div><div class=col-md-2 ng-repeat=\"(k,v) in vm.seriesArray\">{{vm.series[k]}} = <span><b>{{v}}</b></span></div><div class=col-md-1></div></div></div><div class=\"simple-border bottom15\"><div class=\"row top15\" ng-if=\"vm.visibleChart == 1\"><div><div class=col-md-1></div><div class=col-md-10><canvas id=line height=70 class=chart-line chart-data=vm.labor_revenue chart-labels=vm.labels chart-series=vm.series chart-options=vm.options4 chart-dataset-override=datasetOverride chart-click=onClick></canvas></div></div><div class=col-md-1></div></div><div class=row ng-if=\"vm.visibleChart == 1\"><div class=col-md-1></div><div class=col-md-2 ng-repeat=\"(k,v) in vm.laborTotal\">{{vm.series[k]}} = <span><b>{{v}}</b></span></div><div class=col-md-1></div></div></div><div ng-if=\"vm.visibleChart == 2 || vm.visibleChart == 3\"><div class=row><div class=col-md-1></div><div class=col-md-1>Select Year:</div><div class=col-md-3><ui-select ng-model=vm.selectedYear ng-change=vm.populateCompanyGoals()><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\" refresh-delay=300>{{year}}</ui-select-choices></ui-select></div><div class=col-md-1></div></div><div class=\"row top10\"><div class=col-sm-12><table class=\"table table-striped\"><tr><th></th><th>January</th><th>February</th><th>March</th><th>April</th><th>May</th><th>June</th><th>July</th><th>August</th><th>September</th><th>October</th><th>November</th><th>December</th></tr><tr><th>Sales Monthly</th><td ng-repeat=\"(k,sm) in vm.companyGoalData[0] track by $index\"><input class=form-control ng-model=vm.companyGoalData[0][k] ng-change=vm.calculate()> {{sm | currency}}</td></tr><tr><th>Sales Yearly</th><td ng-repeat=\"sm in vm.aggregateCompanyData[0] track by $index\">{{sm | currency}}</td></tr><tr><th>Plan Monthly</th><td ng-repeat=\"(k,sm) in vm.companyGoalData[1] track by $index\"><input class=form-control ng-model=vm.companyGoalData[1][k] ng-change=vm.calculate()> {{sm | currency}}</td><!-- <td ng-repeat=\"sm in vm.companyGoalData[1] track by $index\">{{sm | currency}}</td> --></tr><tr><th>Plan Yearly</th><td ng-repeat=\"sm in vm.aggregateCompanyData[1] track by $index\">{{sm | currency}}</td></tr><tr><th>Difference Month</th><td ng-repeat=\"sm in vm.monthlyDiff track by $index\" ng-class=\"{success:sm > 0,negativeNumber:sm <= 0}\">{{sm | currency}}</td></tr><tr><th>Difference Year</th><td ng-repeat=\"sm in vm.yearlyDiff track by $index\">{{sm | currency}}</td></tr><tr><th>Yearly Target Balance</th><td ng-repeat=\"sm in vm.balance track by $index\">{{sm | currency}}</td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/report-service-board/report-service-board.html","<!-- <div cg-busy=\"{promise:vm.report_load,delay:0,message:\'Loading Data, this could take a few moments\'}\">\n	<div class=\"page-header\">\n		<div>\n			<h1>Service Board</h1>\n		</div>\n	</div>\n	<div>\n		<div class=\"box\">\n			<div class=\"box-content\">\n				<div class=\"row\">\n					<button class=\"btn\" ng-click=\"vm.load_report()\"><i class=\"fa fa-refresh\"></i></button>\n				</div>\n				<table class=\"table small-text-table\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\">\n					<thead>\n						<tr>\n							<th>Ticket #</th>\n							<th>Age</th>\n							<th>Status</th>\n							<th>Customer</th>\n							<th>Contact</th>\n							<th>Summary</th>\n							<th>Hours</th>\n							<th>Started By</th>\n							<th>Last Entry By</th>\n						</tr>\n					</thead>\n					<tbody>\n						<tr ng-repeat=\"row in vm.reportData\" style=\"cursor: pointer\" ng-click=\"vm.loadTicket(row.id)\">\n							<td>{{row.id}}</td>\n							<td>{{row.age}}</td>\n							<td>{{row.status}}</td>\n							<td>{{row.company_name}}</td>\n							<td>{{row.contact}}</td>\n							<td>{{row.summary}}</td>\n							<td>{{row.time_spent}}</td>\n							<td>{{row.enteredBy}}</td>\n							<td>{{row.lastUpdatedBy}}</td>\n						</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n	</div>\n</div> --><div class=col-sm-12><div class=\"page-header col-sm-11\"><div><h1>Quantum Site Status</h1></div></div><div ng-if=!vm.newEntry><div><div class=col-sm-2>Status Filter:<ui-select multiple ng-model=\"vm.filterObj[\'status/id\']\" ng-change=vm.load_data()><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"status.id as status in vm.statuses | filter:$select.search\">{{status.name}}</ui-select-choices></ui-select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Company Name Search:</label></div><div class=col-sm-2><input type=text class=form-control ng-model=\"vm.filterObj[\'company/name\']\"></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Summary Search:</label></div><div class=col-sm-2><input type=text class=form-control ng-model=vm.filterObj.summary ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.filterObj.page_size></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button><div class=\"pull-right col-sm-1\"><button class=btn ng-click=vm.load_data()><i class=\"fa fa-refresh\"></i></button></div></div></div><table class=table><thead><tr><th ng-click=\"vm.filterObj.sort_by=\'ID\'; vm.sort_data()\">Ticket # <span ng-show=\"vm.filterObj.sort_by == \'ID\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'ID\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filterObj.sort_by=\'age\'; vm.sort_data()\">Age (in hours) <span ng-show=\"vm.filterObj.sort_by == \'age\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'age\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filterObj.sort_by=\'dateEntered\'; vm.sort_data()\">Date Opened <span ng-show=\"vm.filterObj.sort_by == \'dateEntered\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'dateEntered\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filterObj.sort_by=\'status/name\'; vm.sort_data()\">Status <span ng-show=\"vm.filterObj.sort_by == \'status/name\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'status/name\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.filterObj.sort_by=\'company/name\'; vm.sort_data()\">Customer <span ng-show=\"vm.filterObj.sort_by == \'company/name\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'company/name\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Contact</th><th ng-click=\"vm.filterObj.sort_by=\'summary\'; vm.sort_data()\">Summary <span ng-show=\"vm.filterObj.sort_by == \'summary\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'summary\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Hours on Ticket</th><th ng-click=\"vm.filterObj.sort_by=\'enteredBy/name\'; vm.sort_data()\">Started By <span ng-show=\"vm.filterObj.sort_by == \'enteredBy/name\' && vm.filterObj.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.filterObj.sort_by == \'enteredBy/name\' && vm.filterObj.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th></tr></thead><tbody><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.filterObj.page_size\" current-page=vm.filterObj.page total-items=vm.data.count style=\"cursor: pointer\" ng-click=vm.loadTicket(obj.id)><td>{{obj.id}}</td><td>{{obj.age}}</td><td>{{obj.dateEntered | date:\'medium\'}}</td><td>{{obj.status.name}}</td><td>{{obj.company.name}}</td><td>{{obj.contactName}}</td><td>{{obj.summary}}</td><td>{{obj.hours_on_ticket}}</td><td>{{obj.enteredBy.name}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/report-technical-allowed/report-technical-allowed.html","<div cg-busy=\"{promise:vm.report_load,delay:0,message:\'Loading Data, this could take a few moments\'}\"><div class=page-header><div><h1>Third Party Access Report</h1></div></div><div class=row><div class=col-sm-12><div class=col-sm-4><div class=col-sm-6>Select Third Party:</div></div><div class=col-sm-8><div class=col-sm-6><ui-select ng-model=vm.selectedParty ng-change=vm.update_data({{$select.selected.id}})><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"third in vm.thirds | filter:$select.search\" refresh-delay=300>{{third.name}}</ui-select-choices></ui-select></div></div></div></div><div class=\"row top15\"><div class=col-sm-12 ng-if=vm.selectedParty><div class=col-sm-4><div class=col-sm-6>Teamviewer ID:</div></div><div class=col-sm-8><div class=col-sm-6 ng-if=vm.selectedParty.tv_password>{{vm.selectedParty.tv_password}}</div><div class=col-sm-6 ng-if=!vm.selectedParty.tv_password>Not Defined</div></div></div></div><div class=\"row top15\"><div ng-if=vm.selectedParty class=col-sm-12><div class=col-sm-4><div class=col-sm-6>Sites Allowed:</div></div><div class=col-sm-6><div class=\"col-sm-12 bottom5\" ng-repeat=\"row in vm.quantumsAllowed\">{{row.name}}</div><div class=col-sm-12 ng-if=\"vm.quantumsAllowed.length == 0\">No access to Quantum Sites</div></div></div></div></div>");
$templateCache.put("app/report-technical-landing/report-technical-landing.html","<div class=page-header><div><h1>Support Reports</h1></div></div><table class=table><tr><th style=width:20%>Report Title</th><th>Description</th></tr><tr><td><a href=/report-procurement-serial-number>Serial Number Report</a></td><td>View data related to serial numbers of JNL Boards, Mac Addresses of Pi\'s</td></tr><!-- <tr>\n		<td>\n			<a href=\"/report-ticket\">Ticket Report</a>\n		</td>\n		<td>\n			View data related to tickets\n		</td>\n	</tr> --><tr><td><a href=/report-service-board>Service Board</a></td><td>View \"Unclosed\" Tickets</td></tr><tr><td><a href=/report-technical-allowed>Allowed Users</a></td><td>Per third party, view systems they are allowed access to</td></tr></table>");
$templateCache.put("app/report-ticket/report-ticket.html","<script type=text/ng-template id=customerChoice.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Select correct customer</h4>\n		</div>\n		<div class=\"modal-body table\">\n			<table class=\"table-striped\" width=\"100%\">\n				<thead>\n					<th>Name</th>\n					<th>Phone</th>\n					<th>State</th>\n				</thead>\n				<tbody>\n					<tr ng-repeat=\"row in vm.searchResults\" ng-click=\"vm.openCustomer(row.connectwise_id,row.company_name)\" style=\"cursor: pointer;\">\n						<td>{{row.company_name}}</td>\n						<td>{{row.phone_number}}</td>\n						<td>{{row.state}}</td>\n					</tr>\n				</tbody>\n			</table>\n			<div class=\"modal-footer\">\n    	</div>\n		</div>\n	</div></script><div cg-busy=\"{promise:vm.report_load,delay:0,message:\'Loading Data, this could take a few moments\'}\"><div class=page-header><div><h1>Ticket Report</h1></div></div><div class=row ng-if=vm.reportRan><div class=col-sm-12><ul class=\"nav nav-tabs\"><li ng-class=\"{active:vm.pageView ==1}\"><a href=# ng-click=\"vm.pageView = 1\">General Info</a></li><li ng-class=\"{active:vm.pageView ==2}\"><a href=# ng-click=\"vm.pageView = 2\">Customer Info</a></li><li ng-class=\"{active:vm.pageView ==3}\"><a href=# ng-click=\"vm.pageView = 3\">Employee Info</a></li><li ng-class=\"{active:vm.pageView ==4}\"><a href=# ng-click=\"vm.pageView = 4\">Ticket List</a></li><!-- <li><a href=\"#\">Menu 3</a></li> --></ul></div></div><div ng-if=!vm.reportRan><div class=box><div class=box-content><div class=row><div class=col-sm-4><h3>Ticket Filters</h3></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Entered On (From): </span><span class=\"col-lg-4 col-sm-6\"><input datetime-picker ng-model=vm.filter_object.ticket.timeEntered.start class=form-control></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Entered On (To): </span><span class=\"col-lg-4 col-sm-6\"><input datetime-picker ng-model=vm.filter_object.ticket.timeEntered.end class=form-control></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Entered By: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.ticket.enteredBy multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user.id as user in vm.allUsers | filter:$select.search\">{{user.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Customer: </span><span class=\"col-lg-4 col-sm-6\"><input type=text class=form-control ng-model=vm.customerTextSearch ng-blur=vm.searchCustomer() ng-model-options=\"{debounce: 200}\"></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Board: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.ticket.board multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"board.id as board in vm.boards | filter:$select.search\">{{board.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Status: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.ticket.status multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"status.id as status in vm.statuses | filter:$select.search\">{{status.name}}</ui-select-choices></ui-select></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Type: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.ticket.type multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type.id as type in vm.types | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Version: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.ticket.version multiple><ui-select-match placeholder=\"All / Any\">{{$item}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"ver in vm.versions | filter:$select.search\">{{ver}}</ui-select-choices></ui-select></span></div></div></div></div><div class=box><div class=box-content><div class=row><div class=col-sm-4><h3>Time Filters</h3></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Time Started (From): </span><span class=\"col-lg-4 col-sm-6\"><input datetime-picker ng-model=vm.filter_object.time.timeStart.from class=form-control></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Time Started (To): </span><span class=\"col-lg-4 col-sm-6\"><input datetime-picker ng-model=vm.filter_object.time.timeStart.to class=form-control></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Time Ended (From): </span><span class=\"col-lg-4 col-sm-6\"><input datetime-picker ng-model=vm.filter_object.time.timeEnded.from class=form-control></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Time Ended (To): </span><span class=\"col-lg-4 col-sm-6\"><input datetime-picker ng-model=vm.filter_object.time.timeEnded.to class=form-control></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Entered By: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.time.enteredBy multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user.id as user in vm.allUsers | filter:$select.search\">{{user.name}}</ui-select-choices></ui-select></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6 top5\"><span class=\"col-lg-3 col-sm-6 custom_label\">Role: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.time.role multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"role.id as role in vm.time_roles | filter:$select.search\">{{role.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6 top5\"><span class=\"col-lg-3 col-sm-6 custom_label\">Type: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.time.type multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type.id as type in vm.time_types | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></span></div></div></div></div><div class=box><div class=box-content><div class=row><div class=col-sm-4><h3>Issue Filters</h3></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6 top5\"><span class=\"col-lg-3 col-sm-6 custom_label\">Class: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.issue.class multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"class.id as class in vm.issue_class | filter:$select.search\">{{class.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6 top5\"><span class=\"col-lg-3 col-sm-6 custom_label\">Issue / Action: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.issue.action multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"action.id as action in vm.issue_action | filter:$select.search\">{{action.name}}</ui-select-choices></ui-select></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Entered By: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.issue.enteredBy multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user.id as user in vm.allUsers | filter:$select.search\">{{user.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Role: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.issue.role multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"role.id as role in vm.time_roles | filter:$select.search\">{{role.name}}</ui-select-choices></ui-select></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Resolution: </span><span class=\"col-lg-4 col-sm-6\"><ui-select ng-model=vm.filter_object.issue.resolution multiple><ui-select-match placeholder=\"All / Any\">{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"res.id as res in vm.resolutions | filter:$select.search\">{{res.name}}</ui-select-choices></ui-select></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Solved Issue: </span><span class=\"col-lg-4 col-sm-6 top5\"><input type=checkbox ng-model=vm.filter_object.issue.fixed_issue></span></div></div><div class=\"row top5\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Used Teamviewer: </span><span class=\"col-lg-4 col-sm-6 top5\"><input type=checkbox ng-model=vm.filter_object.issue.used_tv></span></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><span class=\"col-lg-3 col-sm-6 custom_label\">Used Remote Support: </span><span class=\"col-lg-4 col-sm-6 top5\"><input type=checkbox ng-model=vm.filter_object.issue.used_remote></span></div></div></div></div><div class=box><div class=box-content><div class=\"row top5\"><button class=\"btn btn-primary\" ng-click=vm.runReport()>Run Report</button></div></div></div></div><!-- REPORT RAN PAGE 1 --><div ng-show=\"vm.reportRan && vm.pageView == 1\"><div class=box><!-- TICKET DATA DISPLAY --><div class=row><div class=box-content><div class=col-sm-12><div class=row><div class=\"col-sm-12 report-header\">Ticket Statistics ({{vm.reportData.summary.ticket.count}})</div></div><div class=row><div class=col-sm-6><div class=\"col-sm-12 report-title simple-border\">Board Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.ticket.board_data\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'ticket\',\'board\',row.id)\"><div class=\"col-sm-4 bold\"><span ng-repeat=\"board in vm.boards | filter:{id:row.id}:true\">{{board.name}}</span></div><div class=\"col-sm-4 bold\">{{row.count}}</div><div class=\"col-sm-4 bold\">{{(row.count / vm.reportData.summary.ticket.count)*100 | number:2}}%</div><div class=row ng-repeat=\"role in row.role\"><div class=col-sm-3></div><div class=col-sm-3><span ng-repeat=\"r in vm.time_roles | filter:{id:role.id}:true\">{{r.name}}</span></div><div class=col-sm-3>{{role.count}}</div><div class=col-sm-3>{{(role.time_spent / 60) | number:2}} Hours</div></div></div></div><div class=col-sm-6><div class=\"col-sm-12 report-title simple-border\">Type Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.ticket.type_data\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'ticket\',\'type\',row.id)\"><div class=col-sm-3><span ng-repeat=\"type in vm.types | filter:{id:row.id}:true\">{{type.name}}</span></div><div class=col-sm-3>{{row.count}}</div><div class=col-sm-3>{{(row.count / vm.reportData.summary.ticket.count)*100 | number:2}}%</div><div class=col-sm-3>{{(row.time_spent / 60) | number:2}} Hours</div></div></div></div></div></div></div><!-- TIME DATA DISPLAY  --><div class=row><div class=box-content><div class=col-sm-12><div class=row><div class=\"col-sm-12 report-header\">Time Statistics</div></div><div class=\"row row-fit-margin\"><div class=\"col-sm-12 simple-border\"><div class=col-sm-3>Total Time Entries: {{vm.reportData.summary.time.count}}</div><div class=col-sm-3>Total Time: {{(vm.reportData.summary.time.time_spent / 60) | number:2}} Hours</div><div class=col-sm-3>Avg Time / Ticket: {{((vm.reportData.summary.time.time_spent / 60) / vm.reportData.summary.ticket.count) | number:2}} Hours</div><div class=col-sm-3>Avg Time / Entry: {{((vm.reportData.summary.time.time_spent / 60) / vm.reportData.summary.time.count) | number:2}} Hours</div></div></div><div class=row><div class=col-sm-6><div class=\"col-sm-12 report-title simple-border\">Role Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.time.role_data\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'time\',\'role\',row.id)\"><div class=col-sm-3><span ng-repeat=\"role in vm.time_roles | filter:{id:row.id}:true\">{{role.name}}</span></div><div class=col-sm-3>{{row.count}}</div><div class=col-sm-3>{{(row.time_spent /60) | number:2}} Hours</div><div class=col-sm-3>{{(row.count / vm.reportData.summary.time.count)*100 | number:2}}%</div></div></div><div class=col-sm-6><div class=\"col-sm-12 report-title simple-border\">Type Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.time.type_data\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'time\',\'type\',row.id)\"><div class=col-sm-3><span ng-repeat=\"type in vm.time_types | filter:{id:row.id}:true\">{{type.name}}</span></div><div class=col-sm-3>{{row.count}}</div><div class=col-sm-3>{{(row.count / vm.reportData.summary.time.count)*100 | number:2}}%</div><div class=col-sm-3>{{(row.time_spent / 60) | number:2}} Hours</div></div></div></div></div></div></div><!-- ISSUE DATA DISPLAY  --><div class=row><div class=box-content><div class=col-sm-12><div class=row><div class=\"col-sm-12 report-header\">Issue Statistics</div></div><div class=\"row row-fit-margin\"><div class=\"col-sm-12 simple-border\"><div class=col-sm-4>Total Issues: {{vm.reportData.summary.issue.count}}</div><div class=col-sm-4>Total Time: {{(vm.reportData.summary.issue.time_spent / 60) | number:2}} Hours</div><div class=col-sm-4>Avg Time / Issue: {{((vm.reportData.summary.issue.time_spent / 60) / vm.reportData.summary.issue.count) | number:2}} Hours</div><!-- <div class=\"col-sm-3\">\n									Avg Time / Entry: {{(vm.reportData.summary.time.count / vm.reportData.summary.time.count) | number:2}} Hours\n								</div> --></div></div><div class=row><div class=col-sm-4><div class=\"col-sm-12 report-title simple-border\">Class Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.issue.top_level\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'issue\',\'class\',row.id)\"><div class=col-sm-3><span ng-repeat=\"class in vm.issue_class | filter:{id:row.id}:true\">{{class.name}}</span></div><div class=col-sm-3>{{row.count}}</div><div class=col-sm-3>{{(row.time_spent /60) | number:2}} Hours</div><div class=col-sm-3>{{(row.count / vm.reportData.summary.issue.count)*100 | number:2}}%</div></div></div><div class=col-sm-4><div class=\"col-sm-12 report-title simple-border\">Issue / Action Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.issue.second_level\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'issue\',\'action\',row.id)\"><div class=col-sm-3><span ng-repeat=\"action in vm.issue_action | filter:{id:row.id}:true\">{{action.name}}</span></div><div class=col-sm-3>{{row.count}}</div><div class=col-sm-3>{{(row.count / vm.reportData.summary.issue.count)*100 | number:2}}%</div><div class=col-sm-3>{{(row.time_spent / 60) | number:2}} Hours</div></div></div><div class=col-sm-4><div class=\"col-sm-12 report-title simple-border\">Resolution Data</div><div class=\"col-sm-12 simple-border\" ng-repeat=\"row in vm.reportData.summary.issue.resolution\" style=\"cursor: pointer\" ng-click=\"vm.add_filter(\'issue\',\'resolution\',row.id)\"><div class=col-sm-3><span ng-repeat=\"res in vm.resolutions | filter:{id:row.id}:true\">{{res.name}}</span></div><div class=col-sm-3>{{row.count}}</div><div class=col-sm-3>{{(row.count / vm.reportData.summary.issue.resolution_count)*100 | number:2}}%</div><div class=col-sm-3>{{(row.time_spent / 60) | number:2}} Hours</div></div></div></div></div></div></div></div></div><!-- RAN REPORT PAGE 2 --><div ng-show=\"vm.reportRan && vm.pageView == 2\"><div class=box><!-- CUSTOMER DATA DISPLAY --><div class=row><div class=box-content><div class=col-sm-12><table class=table datatable=ng dt-options=vm.dtOptions><thead><th>Customer</th><th>Ticket Count</th><th>Time Entries</th><th>Time Spent (Hours)</th></thead><tbody><tr ng-repeat=\"c_data in vm.reportData.summary.customer\"><td><a href=\"\">{{vm.getCustomerName(c_data.company_id)}}</a></td><td>{{c_data.ticket.count}}</td><td>{{c_data.time.count}}</td><td>{{(c_data.time.time_spent /60) | number:2}}</td></tr></tbody></table></div></div></div></div></div><!-- RAN REPORT PAGE 3 --><div ng-if=\"vm.reportRan && vm.pageView == 3\"><div class=box><!-- EMPLOYEE DATA DISPLAY --><div class=row><div class=box-content><div class=col-sm-12><table class=table datatable=ng><thead><th>Employee</th><th>Tickets Opened</th><th>Time Entries</th><th>Time Spent (Hours)</th></thead><tbody><tr ng-repeat=\"p_data in vm.reportData.summary.people.general_data\"><td ng-repeat=\"u in vm.allUsers | filter:{id:p_data.id}:true\">{{u.name}}</td><td>{{p_data.ticket_opened}}</td><td>{{p_data.time_count}}</td><td>{{(p_data.time_spent /60) | number:2}}</td></tr></tbody></table></div></div></div></div></div><!-- RAN REPORT PAGE 4 --><div ng-if=\"vm.reportRan && vm.pageView == 4\"><div class=box><!-- Ticket List DISPLAY --><div class=row><div class=box-content><div class=col-sm-12><table class=table datatable=ng dt-options=vm.listOptions><thead><tr><th>Ticket #</th><th>Age</th><th>Status</th><th>Customer</th><th>Contact</th><th>Summary</th><th>Started By</th><th>Last Entry By</th></tr></thead><tbody><tr ng-repeat=\"row in vm.reportData.summary.ticket.list\" style=\"cursor: pointer\" ng-click=vm.loadTicket(row.id)><td>{{row.id}}</td><td>{{row.age}}</td><td ng-repeat=\"stat in vm.statuses | filter:{id:row.status}:true\">{{stat.name}}</td><td>{{vm.getCustomerName(row.company)}}</td><td>{{row.contactName}}</td><td>{{row.summary}}</td><td ng-repeat=\"u in vm.allUsers | filter:{id:row.enteredBy}:true\">{{u.name}}</td><td>{{row.lastUpdatedBy}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=vm.reportRan class=box><div class=box-content><div class=\"row top5\"><button class=\"btn btn-primary\" ng-click=vm.backToFilter()>Back To Filter</button></div></div></div></div>");
$templateCache.put("app/reportTransaction/report-transaction.html","<div class=page-header><div><h1>Audit Report</h1></div></div><div class=row><table class=\"table table-bordered table-striped\"><thead><th>Action</th><th>User</th><th>Date</th><th>Object</th></thead><tbody><tr ng-repeat=\"txn in vm.txnData\"><td ng-repeat=\"action in vm.txnActions | filter:{id:txn.action}:true\">{{action.name}}</td><td ng-repeat=\"user in vm.nocUsers | filter:{user_id:txn.user_id}:true\">{{user.user_full_name}}</td><td>{{txn.date_modified | date:\"medium\"}}</td><td ng-if=txn.differences><table class=table><tr ng-repeat=\"(key,diff) in txn.differences\"><td>{{key}} changed from <b>{{diff.oldValue}}</b> to <b>{{diff.newValue}}</b></td></tr></table></td><td ng-if=\"!txn.old_object && txn.new_object\"><table class=table><tr ng-repeat=\"(key,val) in txn.new_object\"><td>{{key}} = {{val}}</td></tr></table></td><td ng-if=\"!txn.new_object && txn.old_object\"><table class=table><tr ng-repeat=\"(key,val) in txn.old_object\"><td>{{key}} = {{val}}</td></tr></table></td></tr></tbody></table></div>");
$templateCache.put("app/rmaCustomer/rmaCustomerCreate.html","<script type=text/ng-template id=confirmCustomer.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Action</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      This serial number <b>({{vm.snResults[0].serial_number}})</b> is not currently assigned to this customer. <br>\n			By clicking OK, the serial number will be moved to this customer, please be sure this is correct before proceeding.\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.updateCustomer()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=chooseSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Multiple Results Found</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<span ng-if=\"vm.snResults.length < 15\">Please choose the correct Serial Number</span>\n			<table class=\"table table-hover\">\n				<tr ng-if=\"vm.snResults.length < 15\" ng-repeat=\"row in vm.snResults\" ng-click=\"vm.multipleResultSelected(row.serial_number)\">\n					<td>{{row.serial_number}}</td>\n					<td ng-repeat=\"product in vm.allParts | filter:{id:row.product_id}:true\">{{product.part_number}} - {{product.name}}</td>\n				</tr>\n				<tr ng-if=\"vm.snResults.length >= 15\">\n					<td>More than 15 Results, please narrow your search</td>\n				</tr>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    </div>\n	</div></script><script type=text/ng-template id=NoSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Action</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      This serial number <b>({{vm.workingObject.serial_number}})</b> is not recorded. <br>\n			By clicking OK, you will create the serial number for the selected part. Please be sure you have typed the serial number correctly.<br>\n			The serial number will be associated with the part you have chosen, and won\'t let you hit OK if a part isn\'t selected.\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.workingObject.product_id\" ng-click=\"vm.addHardware()\">OK</button>\n    </div>\n	</div></script><div class=page-header><div><h1>Customer RMA</h1></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:1000}><div class=row><div class=col-sm-12><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>General Information</h3><span class=pull-right><button class=\"btn btn-primary\" type=button ng-disabled=!vm.dataFilled() ng-click=vm.createRMA()>Create RMA</button></span></div></div></div></div></div><div class=\"row top7\"><div class=col-sm-4><label>Choose Customer</label></div><div class=col-sm-8><ui-select ng-model=vm.workingObject.customer_id ng-change=vm.populateCustomer($select.selected.id,true)><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"customer.id as customer in vm.customerData | filter:$select.search\" refresh-delay=300>{{customer.name}}</ui-select-choices></ui-select></div></div><div class=\"row top7\"><div class=col-sm-4><label>Warrantied?</label></div><div class=col-sm-8>No <input type=radio ng-model=vm.workingObject.warranty ng-value=false> Yes <input type=radio ng-model=vm.workingObject.warranty ng-value=true></div></div><div class=\"row top7 border-bottom\"><div class=col-sm-4><label>Advanced Replacement?</label></div><div class=col-sm-8>No <input type=radio ng-model=vm.workingObject.advanced ng-value=false> Yes <input type=radio ng-model=vm.workingObject.advanced ng-value=true></div></div><div class=\"row top7\" ng-if=\"vm.customerDetails && vm.workingObject.serial_number != null && !vm.manual\"><div class=col-sm-4><label>Part Information</label></div><div class=col-sm-8>{{vm.partNumber}} - {{vm.productName}}</div></div><div class=\"row top7\" ng-if=\"vm.customerDetails && !vm.manual && vm.workingObject.warranty != null\"><div class=col-sm-4><label>Serial Number</label></div><div class=col-sm-8><ui-select ng-model=vm.workingObject.serial_number ng-change=vm.addSerial($select.selected)><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"mac in vm.customerDetails.hardware | filter:$select.search\" refresh-delay=300>{{mac}}</ui-select-choices></ui-select></div></div><div class=\"row top7 border-bottom\" ng-if=\"vm.customerDetails && !vm.manual && vm.workingObject.warranty != null\"><div class=col-sm-4><label></label></div><div class=col-sm-8><button class=\"btn btn-primary\" type=button ng-click=vm.manualAdd()>Add Serial Number Manually</button></div></div><div class=\"row top7\" ng-if=vm.manual><div class=col-sm-4><label>Part Number</label></div><div class=col-sm-8><ui-select ng-model=vm.workingObject.product_id ng-change=vm.part_selected($select.selected)><ui-select-match>{{$select.selected.part_number}} - {{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"pn.id as pn in vm.availablePNs | filter:$select.search\" refresh-delay=300>{{pn.part_number}} - {{pn.name}}</ui-select-choices></ui-select></div></div><div class=\"row top7\" ng-if=vm.manual><div class=col-sm-4><label>Serial Number</label></div><div class=col-sm-8><input class=form-control type=text ng-model=vm.workingObject.serial_number></div></div><div ng-if=vm.manual class=\"row top7 border-bottom\"><div class=col-sm-4 ng-if=vm.manual><button class=btn type=button ng-click=vm.cancelManual()>Cancel Manual Addition</button></div><div class=col-sm-8 ng-if=vm.manual><button class=\"btn btn-primary\" type=button ng-click=vm.checkSN()>Check Serial Number</button></div></div><div class=\"row top7\" ng-if=vm.workingObject.serial_number><div class=col-sm-4><label>Reason For Return</label></div><div class=col-sm-8><ui-select ng-model=vm.workingObject.reason_id ng-change=vm.reasonSelected($select.selected)><ui-select-match>{{$select.selected.reason}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"reason.id as reason in vm.filteredReasonList | filter:$select.search\" refresh-delay=300>{{reason.reason}}</ui-select-choices></ui-select></div></div><div class=\"row top7\" ng-if=vm.workingObject.serial_number><div class=col-sm-4><label>Return Notes</label></div><div class=col-sm-8><textarea rows=8 ng-model=vm.workingObject.reason_notes cols=100></textarea></div></div>");
$templateCache.put("app/rmaCustomer/rmaCustomerSearch.html","<div class=\"page-header no-print\"><div><h1>Customer RMA</h1></div></div><div class=title-div><h3><span ng-if=!vm.workingObject.id><i class=\"fa fa-search\"></i>Find an existing RMA</span></h3></div><div class=row ng-if=!vm.workingObject.id><div class=row ng-if=vm.allParts><table datatable=ng class=\"table table-bordered table-striped\"><thead><th>RMA Number</th><th>Customer</th><th>Product</th><th>Serial Number</th><th>Status</th></thead><tbody><tr ng-repeat=\"rma in vm.allRMA\" ng-click=vm.loadRMA(rma.id) style=\"cursor: pointer\"><td>{{rma.id}}</td><td ng-repeat=\"customer in vm.customerData | filter:{id:rma.customer_id}:true\">{{customer.name}}</td><td ng-repeat=\"product in vm.allParts | filter:{id:rma.product_id}:true\">{{product.part_number}} - {{product.name}}</td><td>{{rma.serial_number}}</td><td ng-repeat=\"status in vm.rmaStatuses | filter:{id:rma.status}\">{{status.status}}</td></tr></tbody></table></div></div><div class=row ng-if=vm.workingObject.id><div class=row><span class=pull-right ng-if=vm.workingObject.id><button class=\"btn no-print\" type=button ng-click=vm.rmaHome()>Find RMA</button></span></div><div class=\"row top7\"><div class=col-sm-4><label>Customer</label></div><div class=col-sm-8><span ng-repeat=\"customer in vm.customerData | filter:{id:vm.workingObject.customer_id}:true\">{{customer.name}}</span></div></div><div class=\"row top7\"><div class=col-sm-4><label>Warrantied?</label></div><div class=col-sm-8>No <input type=radio ng-disabled=\"vm.workingObject.status > 3\" ng-model=vm.workingObject.warranty ng-value=false> Yes <input type=radio ng-disabled=\"vm.workingObject.status > 3\" ng-model=vm.workingObject.warranty ng-value=true></div></div><div class=\"row top7 border-bottom no-print\"><div class=col-sm-4><label>Advanced Replacement?</label></div><div class=col-sm-8>No <input type=radio ng-disabled=\"vm.workingObject.status > 1\" ng-model=vm.workingObject.advanced ng-value=false> Yes <input type=radio ng-disabled=\"vm.workingObject.status > 1\" ng-model=vm.workingObject.advanced ng-value=true></div></div><div class=\"row top7\"><div class=col-sm-4><label>Part Information</label></div><div class=col-sm-8 ng-repeat=\"product in vm.allParts | filter:{id:vm.workingObject.product_id}:true\">{{product.part_number}} - {{product.name}}</div></div><div class=\"row top7 border-bottom\"><div class=col-sm-4><label>Serial Number</label></div><div class=col-sm-8>{{vm.workingObject.serial_number}}</div></div><div class=\"row top7 no-print\"><div class=col-sm-4><label>Reason For Return</label></div><div class=col-sm-8 ng-if=\"vm.workingObject.status <= 2\"><ui-select ng-model=vm.workingObject.reason_id ng-change=vm.reasonSelected($select.selected)><ui-select-match>{{$select.selected.reason}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"reason.id as reason in vm.filteredReasonList | filter:$select.search\" refresh-delay=300>{{reason.reason}}</ui-select-choices></ui-select></div><div class=col-sm-8 ng-if=\"vm.workingObject.status >= 3\" ng-repeat=\"reason in vm.currentReasons | filter:{id:vm.workingObject.reason_id}\">{{reason.reason}}</div></div><div class=\"row top7 border-bottom\"><div class=col-sm-4><label>Return Notes</label></div><div class=col-sm-8 ng-class=\"{\'simple-border\':vm.workingObject.status >= 3,\'bottom5\':vm.workingObject.status >= 3}\"><textarea rows=8 ng-if=\"vm.workingObject.status < 3\" ng-model=vm.workingObject.reason_notes cols=100 style=white-space:pre-wrap></textarea><span ng-if=\"vm.workingObject.status >= 3\" style=white-space:pre-wrap>{{vm.workingObject.reason_notes}}</span></div></div><div class=\"row top7 no-print\"><div class=col-sm-4><label>Issue Found</label></div><div class=col-sm-8 ng-if=\"vm.workingObject.status <= 3\"><ui-select ng-disabled=\"vm.workingObject.status != 3\" ng-model=vm.workingObject.issue_id ng-change=vm.repairSelected($select.selected)><ui-select-match>{{$select.selected.reason}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"reason.id as reason in vm.filteredIssueList | filter:$select.search\" refresh-delay=300>{{reason.reason}}</ui-select-choices></ui-select></div><div class=col-sm-8 ng-if=\"vm.workingObject.status > 3\" ng-repeat=\"reason in vm.currentReasons | filter:{id:vm.workingObject.issue_id}\">{{reason.reason}}</div></div><div class=\"row top7 border-bottom\"><div class=col-sm-4><label>Repair Notes</label></div><div class=col-sm-8 ng-class=\"{\'simple-border\':vm.workingObject.status >= 4,\'bottom5\':vm.workingObject.status >= 4}\"><textarea rows=8 ng-disabled=\"vm.workingObject.status != 3\" ng-if=\"vm.workingObject.status < 4\" ng-model=vm.workingObject.repair_notes cols=100 style=white-space:pre-wrap></textarea><span ng-if=\"vm.workingObject.status >= 4\" style=white-space:pre-wrap>{{vm.workingObject.repair_notes}}</span></div></div><div class=\"row top7 border-bottom no-print\"><div class=col-sm-4><label>Disposition</label></div><div class=col-sm-8 ng-repeat=\"status in vm.rmaStatuses | filter:{id:vm.workingObject.status}:true\"><span ng-if=\"vm.workingObject.status != 3\" class=col-sm-3>{{status.status}} <i ng-if=\"vm.workingObject.status <= 3\" class=\"fa fa-arrow-right\"></i></span> <button ng-if=\"vm.workingObject.status == 1\" class=\"btn btn-primary\" type=button ng-click=vm.updateRMA(2)>Receive Product</button> <button ng-if=\"vm.workingObject.status == 2\" class=\"btn btn-primary\" type=button ng-click=vm.updateRMA(3)>Start Repair</button> <span class=col-sm-4 ng-if=\"vm.workingObject.status == 3\"><ui-select ng-disabled=\"!(vm.workingObject.issue_id && vm.workingObject.repair_notes)\" ng-model=vm.workingObject.status ng-change=vm.updateRMA($select.selected.id)><ui-select-match>{{$select.selected.status}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"status.id as status in vm.laterStatus | filter:$select.search\" refresh-delay=300>{{status.status}}</ui-select-choices></ui-select></span></div></div><div ng-if=\"vm.workingObject.status == 6\" class=\"row top7 border-bottom no-print\"><div class=col-sm-4><label>New Serial Number</label></div><div class=col-sm-8><ui-select ng-model=vm.workingObject.replacement_serial ng-change=vm.updateRMA()><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"sn in vm.allHardware | filter:$select.search\" refresh-delay=30000>{{sn}}</ui-select-choices></ui-select></div></div></div>");
$templateCache.put("app/rmaDCSTest/rmaDCSTest.html","<script type=text/ng-template id=chooseSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Multiple Results Found</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<span ng-if=\"vm.snResults.length < 15\">Please choose the correct Serial Number</span>\n			<table class=\"table table-hover\">\n				<tr ng-if=\"vm.snResults.length < 15\" ng-repeat=\"(key,row) in vm.snResults\" ng-click=\"vm.multipleResultSelected(key)\">\n					<td>{{row.serial_number}}</td>\n					<td ng-repeat=\"product in vm.allParts | filter:{id:row.product_id}:true\">{{product.part_number}} - {{product.name}}</td>\n				</tr>\n				<tr ng-if=\"vm.snResults.length >= 15\">\n					<td>More than 15 Results, please narrow your search</td>\n				</tr>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    </div>\n	</div></script><script type=text/ng-template id=noSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Action</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      This serial number <b>({{vm.workingObject.serial_number}})</b> is not recorded. <br>\n			By clicking OK, you will create the serial number for the selected part. Please be sure you have typed the serial number correctly.<br>\n			The serial number will be associated with the part you have chosen, and won\'t let you hit OK if a part isn\'t selected.\n    </div>\n		<div class=\"col-sm-4\">\n			<label>Part Number</label>\n		</div>\n		<div class=\"col-sm-8\">\n			<ui-select ng-model=\"vm.workingObject.product_id\" ng-change=\"vm.part_selected($select.selected)\">\n			<ui-select-match>{{$select.selected.part_number}} - {{$select.selected.name}} </ui-select-match>\n			<ui-select-choices class=\"ui-select-choices\" repeat=\"pn.id as pn in vm.availablePNs | filter:$select.search\" refresh-delay=\"300\">\n				{{pn.part_number}} - {{pn.name}}\n			</ui-select-choices>\n			</ui-select>\n		</div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.workingObject.product_id\" ng-click=\"vm.addHardware()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=newSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Choose New Serial Number</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<div class=\"row\">\n				<span>The select box will be slow due to the number of selections... please be patient</span>\n			</div>\n			<div class=\"row\">\n				<!-- <div class=\"col-sm-2\">\n					<label>Serial Numbers</label>\n				</div> -->\n				<div class=\"col-sm-10\">\n					<!-- <span class=\"col-sm-8\"><input ng-model=\"vm.serialSearch\" class=\"form-control\"></span><span class=\"col-sm-2 top3\"><button class=\"btn btn-primary\" ng-click=\"vm.findSerials()\">Search</button></span> -->\n					<div class=\"row bottom7\">\n						<span class=\"col-sm-2 top5\"><label>Type Serial, Click Search:</label></span>\n						<span class=\"col-sm-8\"><input ng-model=\"vm.serialSearch\" class=\"form-control\"></span><span class=\"col-sm-2 top3\"><button class=\"btn btn-primary\" ng-click=\"vm.findSerials()\">Search</button></span>\n					</div>\n					<div class=\"row\" ng-if=\"vm.searchResults.length\">\n						<table class=\"table table-striped\">\n							<thead>\n								<th>Product (Part Number)</th>\n								<th>Part of Build</th>\n								<th>Part of Final Build</th>\n								<th>Attached to Final Product</th>\n								<th></th>\n							</thead>\n							<tbody ng-repeat=\"row in vm.searchResults\">\n								<tr>\n									<td>{{row.product_data.name}} - ({{row.product_data.part_number}})</td>\n									<td ng-class=\"{success:!row.build_status.build_started,danger:row.build_status.build_started}\">{{row.build_status.build_started ? \"YES\":\"NO\"}}</td>\n									<td ng-class=\"{success:!row.build_status.built,danger:row.build_status.built}\">{{row.build_status.built ? \"YES\":\"NO\"}}</td>\n									<td ng-class=\"{success:!row.final_product,danger:row.final_product}\">{{row.final_product.passed ? \"YES\":\"NO\"}}</td>\n									<td><button class=\"btn btn-success\" ng-disabled=\"row.final_product.passed\" ng-click=\"vm.save_updated_board(row.id)\">Use this One</button></td>\n								</tr>\n							</tbody>\n						</table>\n					</div>\n					<!-- <ui-select ng-model=\"vm.workingObject.associated_serial\" ng-change=\"vm.newSerialSelected($select.selected)\">\n					<ui-select-match>{{$select.selected.serial_number}} </ui-select-match>\n					<ui-select-choices class=\"ui-select-choices\" repeat=\"sn.id as sn in vm.serialNumberData | filter:$select.search\" refresh-delay=\"300\">\n						{{sn.serial_number}}\n					</ui-select-choices>\n					</ui-select> -->\n				</div>\n			</div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    </div>\n	</div></script><div cg-busy={promise:vm.partPromise,delay:200,minDuration:1000}><div class=page-header><div><h1>RMA DCS Equipment Test</h1></div></div><div class=row><div class=col-sm-3><span><label>Choose Mac Address</label></span></div><div class=col-sm-4><ui-select ng-model=vm.selectedHW ng-change=vm.ipCheck()><ui-select-match>{{$select.selected.mac}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"hw in vm.availableTest | filter:$select.search\" refresh-delay=300>{{hw.mac}}</ui-select-choices></ui-select></div></div><div ng-if=vm.workingObject.serial_number><div class=\"row top7\" ng-if=vm.workingObject.product.id><div class=col-sm-3><span><label>Product Information</label></span></div><div class=col-sm-4>{{vm.workingObject.product.part_number}} - {{vm.workingObject.product.name}}</div></div><div class=\"row top7\" ng-if=!vm.workingObject.product.id><div class=col-sm-3><span><label>Choose Product</label></span></div><div class=col-sm-4><ui-select ng-model=vm.workingObject.product.id ng-change=vm.part_selected($select.selected)><ui-select-match>{{$select.selected.part_number}} - {{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"pn.id as pn in vm.availablePNs | filter:$select.search\" refresh-delay=300>{{pn.part_number}} - {{pn.name}}</ui-select-choices></ui-select></div></div><div class=\"row top10\"><div class=col-sm-3><span><label>Enter JNL Board Serial Number</label></span></div><div ng-if=vm.workingObject.associated_serial class=col-sm-4>{{vm.serialNumberData.serial_number}}</div><div ng-if=!vm.workingObject.associated_serial class=col-sm-4><!-- <input class=\"form-control\" disabled ng-model=\"vm.workingObject.associated_serial\"> --> No JNL Board Defined</div><div class=col-sm-5><button type=button class=\"btn btn-primary\" ng-click=vm.updateBoard()>Change</button></div></div><div class=\"row top7\"><div class=col-sm-3><span><label>Choose RMA (Optional)</label></span></div><div class=col-sm-4><ui-select ng-model=vm.resultObject.rma_id><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"rma.id as rma in vm.availabeRMA | filter:$select.search\" refresh-delay=300>{{rma.id}}</ui-select-choices></ui-select></div></div><div class=\"row top7\" ng-if=\"!vm.boardReady && !vm.screenCheckRequired\"><div class=col-sm-5><span class=col-sm-6><button type=button class=\"btn btn-primary\" ng-click=vm.boardSet()>Next</button></span></div></div><div class=\"row top7\"><div class=\"row top7\" ng-if=vm.screenCheckRequired><div class=col-sm-12><span class=col-sm-6><button type=button class=\"btn btn-primary\" ng-click=vm.screenCheck()>Check Screen</button></span></div></div></div></div><div class=\"row top7\"><div class=\"row top7\" ng-if=vm.boardReady><div class=col-sm-12><span class=col-sm-6><button type=button class=\"btn btn-primary\" ng-click=vm.startTest()>Start Test</button></span></div></div></div></div><div class=\"row body-div\" ng-if=\"vm.testStarted && vm.testStatus != \'FailConnect\'\"><div class=col-sm-6>Current DCS Serial Number: {{vm.workingObject.serial_number}}</div><div class=col-sm-6>Current PI MAC: {{vm.workingObject.serial_number}}</div><table class=table ng-if=vm.testReq.inputs><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\">Input {{key}}</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\">{{value.status}}</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.inputs\" ng-class={success:value.tested,danger:!value.tested}>{{value.tested}}</td></tr></table><table class=table><tr><td>Output 1</td><td>Output 2</td><td>Output 3</td><td>Output 4</td><td>Output 5</td></tr><tr><td ng-repeat=\"(key,value) in vm.resultData.outputs\">{{value.status}}</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(1)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(2)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(3)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(4)>Toggle Output</button></td><td><button class=\"btn btn-primary\" ng-click=vm.toggleOut(5)>Toggle Output</button></td></tr><tr><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.output_1}\" ng-click=\"vm.resultObject.output_1 = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.output_1}\" ng-click=\"vm.resultObject.output_1 = false\">Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.output_2}\" ng-click=\"vm.resultObject.output_2 = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.output_2}\" ng-click=\"vm.resultObject.output_2 = false\">Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.output_3}\" ng-click=\"vm.resultObject.output_3 = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.output_3}\" ng-click=\"vm.resultObject.output_3 = false\">Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.output_4}\" ng-click=\"vm.resultObject.output_4 = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.output_4}\" ng-click=\"vm.resultObject.output_4 = false\">Fail</button></td><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.output_5}\" ng-click=\"vm.resultObject.output_5 = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.output_5}\" ng-click=\"vm.resultObject.output_5 = false\">Fail</button></td></tr></table><table class=table ng-if=vm.testReq.bluetooth><tr><td>Bluetooth Chip Firmware</td><td>Bluetooth Test Status</td></tr><tr><td>{{vm.resultData.bluetooth.firmware}}</td><td ng-class={success:vm.resultData.bluetooth.result,danger:!vm.resultData.bluetooth.result}>{{vm.resultData.bluetooth.result}}</td></tr></table><table ng-if=vm.testReq.wiegand class=table><tr><td>Wiegand Code</td><td>Site ID</td><td>Wiegand Test Status</td></tr><tr><td>{{vm.resultData.wiegand.code}}</td><td>{{vm.resultData.wiegand.site}}</td><td ng-class={success:vm.resultData.wiegand.result,danger:!vm.resultData.wiegand.result}>{{vm.resultData.wiegand.result}}</td></tr></table><table ng-if=vm.testReq.sound class=table><tr><td>Internal Sounder</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.toggleSound()>Toggle Internal Sounder</button></td></tr><tr><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.sound}\" ng-click=\"vm.resultObject.sound = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.sound}\" ng-click=\"vm.resultObject.sound = false\">Fail</button></td></tr></table><table ng-if=vm.testReq.screen class=table><tr><td>Screen</td></tr><tr><td><button class=\"btn btn-primary\" ng-click=vm.changeScreen(10)>HOME</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(0)>KEYPAD</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(1)>BYPASS</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(2)>ACCESS DENIED</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(3)>INVALID CODE</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(4)>EGRESS ACTIVATED</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(5)>SERVER CONNECTING</button> <button class=\"btn btn-primary\" ng-click=vm.changeScreen(6)>CONNECTION FAILED</button></td></tr><tr><td><button class=btn ng-class=\"{\'btn-success\':vm.resultObject.screen}\" ng-click=\"vm.resultObject.screen = true\">Pass</button> <button class=btn ng-class=\"{\'btn-danger\':!vm.resultObject.screen}\" ng-click=\"vm.resultObject.screen = false\">Fail</button></td></tr></table><div ng-if=!vm.passedTest()><div>The test is currently in FAILED status</div><div ng-repeat=\"fail in vm.testFails\">{{fail}}</div></div><span class=col-sm-3><button class=\"btn btn-primary\" ng-click=vm.submitTest()>Submit Test</button><button class=\"btn pull-right\" ng-click=vm.cancelTest()>Cancel</button></span></div><div class=\"row body-div\" ng-if=\"vm.testStatus == \'FailConnect\'\">Failed to connect the product, confirm network connectivity. Was the proper SD card placed in the unit? Have Drew confirm bad JNL board, or try an additional board, if passes, the original dcs board was the problem.</div>");
$templateCache.put("app/rmaPCTest/rmaPCTest.html","<script type=text/ng-template id=chooseSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Multiple Results Found</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<span ng-if=\"vm.snResults.length < 15\">Please choose the correct Serial Number</span>\n			<table class=\"table table-hover\">\n				<tr ng-if=\"vm.snResults.length < 15\" ng-repeat=\"(key,row) in vm.snResults\" ng-click=\"vm.multipleResultSelected(key)\">\n					<td>{{row.serial_number}}</td>\n					<td ng-repeat=\"product in vm.allParts | filter:{id:row.product_id}:true\">{{product.part_number}} - {{product.name}}</td>\n				</tr>\n				<tr ng-if=\"vm.snResults.length >= 15\">\n					<td>More than 15 Results, please narrow your search</td>\n				</tr>\n			</table>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    </div>\n	</div></script><script type=text/ng-template id=noSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Confirm Action</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n      This serial number <b>({{vm.workingObject.serial_number}})</b> is not recorded. <br>\n			By clicking OK, you will create the serial number for the selected part. Please be sure you have typed the serial number correctly.<br>\n			The serial number will be associated with the part you have chosen, and won\'t let you hit OK if a part isn\'t selected.\n    </div>\n		<div class=\"col-sm-4\">\n			<label>Part Number</label>\n		</div>\n		<div class=\"col-sm-8\">\n			<ui-select ng-model=\"vm.workingObject.product_id\" ng-change=\"vm.part_selected($select.selected)\">\n			<ui-select-match>{{$select.selected.part_number}} - {{$select.selected.name}} </ui-select-match>\n			<ui-select-choices class=\"ui-select-choices\" repeat=\"pn.id as pn in vm.availablePNs | filter:$select.search\" refresh-delay=\"300\">\n				{{pn.part_number}} - {{pn.name}}\n			</ui-select-choices>\n			</ui-select>\n		</div>\n    <div class=\"modal-footer\">\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n    	<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.workingObject.product_id\" ng-click=\"vm.addHardware()\">OK</button>\n    </div>\n	</div></script><script type=text/ng-template id=newSerial.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Choose New Serial Number</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\">\n			<div class=\"row\">\n			</div>\n			<div class=\"row\">\n				<div class=\"col-sm-2\">\n					<label>Type the New Serial Number</label>\n				</div>\n				<div class=\"col-sm-10\">\n					<input type=\"text\" class=\"form-control\" ng-model=\"vm.potential_sn\">\n				</div>\n			</div>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.verify_changed_serial(vm.potential_sn)\">Verify Serial Number</button>\n			<button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n		</div>\n		<div ng-if=\"vm.potential_serial_return\">\n			<table class=\"table table-striped\">\n				<thead>\n					<th>Product (Part Number)</th>\n					<th>Part of Build</th>\n					<th>Part of Final Build</th>\n					<th>Attached to Final Product</th>\n					<th></th>\n				</thead>\n				<tbody ng-repeat=\"row in vm.potential_serial_return\">\n					<tr>\n						<td>{{row.product_data.name}} - ({{row.product_data.part_number}})</td>\n						<td ng-class=\"{success:!row.build_status.build_started,danger:row.build_status.build_started}\">{{row.build_status.build_started ? \"YES\":\"NO\"}}</td>\n						<td ng-class=\"{success:!row.build_status.built,danger:row.build_status.built}\">{{row.build_status.built ? \"YES\":\"NO\"}}</td>\n						<td ng-class=\"{success:!row.final_product,danger:row.final_product}\">{{row.final_product.passed ? \"YES\":\"NO\"}}</td>\n						<td><button class=\"btn btn-success\" ng-disabled=\"row.final_product.passed\" ng-click=\"vm.save_updated_board(row.id)\">Use this One</button></td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n	</div></script><div cg-busy={promise:vm.partPromise,delay:200,minDuration:1000}><div class=page-header><div><h1>RMA Pull Cord Test</h1></div></div><div class=row><div class=col-sm-3><span><label>Enter Inovonics Serial Number</label></span></div><div class=col-sm-4><input class=form-control ng-disabled=vm.inovonicsLoaded ng-model=vm.workingObject.serial_number></div><div class=col-sm-5 ng-if=!vm.inovonicsLoaded><button type=button class=\"btn btn-primary\" ng-click=vm.inovonics()>Next</button></div></div><div ng-if=vm.inovonicsLoaded><div class=\"row top7\"><div class=col-sm-3><span><label>Product Information</label></span></div><div class=col-sm-4>{{vm.workingObject.product.part_number}} - {{vm.workingObject.product.name}}</div></div><div class=\"row top10\"><div class=col-sm-3><span><label>Enter JNL Board Serial Number</label></span></div><div ng-if=vm.workingObject.associated_serial class=col-sm-4>{{vm.serialNumberData.serial_number}}</div><div ng-if=!vm.workingObject.associated_serial class=col-sm-4>No JNL Board Defined</div><div class=col-sm-5><button type=button class=\"btn btn-primary\" ng-click=vm.updateBoard()>Change</button></div></div><div class=\"row top7\"><div class=col-sm-3><span><label>Choose RMA (Optional)</label></span></div><div class=col-sm-4><ui-select ng-model=vm.resultObject.rma_id><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"rma.id as rma in vm.availabeRMA | filter:$select.search\" refresh-delay=300>{{rma.id}}</ui-select-choices></ui-select></div></div><div class=\"row top7\"><div class=col-sm-5 ng-if=!vm.boardReady><span class=col-sm-6><button type=button class=\"btn btn-primary\" ng-click=vm.boardSet()>Next</button></span></div></div><div class=\"row top7\"><div class=\"row top7\" ng-if=vm.boardReady><div class=col-sm-12><span class=col-sm-6><button type=button class=\"btn btn-primary\" ng-click=vm.startPCTest()>Start Test</button></span></div></div></div></div><div ng-if=vm.pcStarted><table class=\"table white-back\"><tr><th>Alarm 1</th><th>Alarm 1 Reset</th><th>Alarm 2</th><th>Alarm 2 Reset</th><th>Check In</th><th>Check In Reset</th></tr><tr><td>{{vm.resultData.status.alarm_bit_1_alarm}}</td><td>{{vm.resultData.status.alarm_bit_1_reset}}</td><td>{{vm.resultData.status.alarm_bit_2_alarm}}</td><td>{{vm.resultData.status.alarm_bit_2_reset}}</td><td>{{vm.resultData.status.tamper_active}}</td><td>{{vm.resultData.status.tamper_reset}}</td></tr></table><span class=col-sm-3><button class=\"btn btn-primary\" ng-click=vm.pcSubmitTest()>Submit Test</button> <button class=\"btn btn-primary\" ng-click=vm.userFail()>User Fail</button> <button ng-if=\"vm.resultData.timer == 0\" class=\"btn btn-primary pull-right\" ng-click=vm.startPCTest()>Retry</button></span></div></div>");
$templateCache.put("app/salesAdminGoals/salesAdminGoals.html","<div class=page-header><div><h1><span class=col-md-9>Sales Goals</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=box><div class=box-content><div class=row><div class=\"col-md-1 top7\"><b>Year:</b></div><div class=col-md-3><ui-select ng-model=vm.workingObj.year ng-change=vm.updateYear()><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\" refresh-delay=300>{{year}}</ui-select-choices></ui-select></div></div><div class=\"row top7 bottom7\"><div class=col-md-1><b>Yearly Goal:</b></div><div class=col-md-3>{{vm.total | currency}}</div></div><div class=row><table class=\"table table-striped\"><tr><th></th><th>January</th><th>February</th><th>March</th><th>April</th><th>May</th><th>June</th><th>July</th><th>August</th><th>September</th><th>October</th><th>November</th><th>December</th></tr><tr ng-repeat=\"(key,row) in vm.monthlyObject\"><th ng-repeat=\"cat in vm.salesCategories | filter:{id:key}\">{{cat.name}}</th><td>{{row.jan | currency}}</td><td>{{row.feb | currency}}</td><td>{{row.mar | currency}}</td><td>{{row.apr | currency}}</td><td>{{row.may | currency}}</td><td>{{row.jun | currency}}</td><td>{{row.jul | currency}}</td><td>{{row.aug | currency}}</td><td>{{row.sep | currency}}</td><td>{{row.oct | currency}}</td><td>{{row.nov | currency}}</td><td>{{row.dec | currency}}</td></tr><tr><td colspan=13><button class=\"btn btn-primary\" type=button ng-click=vm.saveGoals()>Save Goals</button></td></tr></table></div><div class=row ng-repeat=\"salesRep in vm.workingObj.jnl_reps\"><table class=\"table table-striped\"><td ng-repeat=\"user in vm.users | filter:{user_id:salesRep.user_id}:true\">{{user.user_full_name}}</td><th>January</th><th>February</th><th>March</th><th>April</th><th>May</th><th>June</th><th>July</th><th>August</th><th>September</th><th>October</th><th>November</th><th>December</th><tr ng-repeat=\"data in salesRep.goal_data\"><th ng-repeat=\"cat in vm.salesCategories | filter:{id:data.category}:true\">{{cat.name}}</th><td><input class=form-control ng-model=data.monthly_goals.jan ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.feb ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.mar ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.apr ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.may ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.jun ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.jul ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.aug ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.sep ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.oct ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.nov ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.dec ng-change=vm.calculateYearlyGoal()></td></tr></table></div><div class=row ng-repeat=\"salesRep in vm.workingObj.third_parties\"><table class=\"table table-striped\"><td ng-repeat=\"tparty in vm.third_parties | filter:{id:salesRep.third_party_id}:true\">{{tparty.name}}</td><th>January</th><th>February</th><th>March</th><th>April</th><th>May</th><th>June</th><th>July</th><th>August</th><th>September</th><th>October</th><th>November</th><th>December</th><tr ng-repeat=\"data in salesRep.goal_data\"><th ng-repeat=\"cat in vm.salesCategories | filter:{id:data.category}:true\">{{cat.name}}</th><td><input class=form-control ng-model=data.monthly_goals.jan ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.feb ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.mar ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.apr ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.may ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.jun ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.jul ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.aug ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.sep ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.oct ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.nov ng-change=vm.calculateYearlyGoal()></td><td><input class=form-control ng-model=data.monthly_goals.dec ng-change=vm.calculateYearlyGoal()></td></tr></table></div></div></div></div>");
$templateCache.put("app/salesAdminOwnerUpdate/salesAdminOwnerUpdate.html","<div class=page-header><div><h1><span class=col-md-9>Owner Update Utility</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div cg-busy={promise:vm.reloadPromise,delay:100,minDuration:1000}><div class=box><div class=box-content><div class=\"row bottom7\"><div class=\"col-sm-2 top7\">Enter Customer Name or Estimate ID</div><div class=col-sm-4><input class=form-control ng-model=vm.searchValue ng-change=vm.searchEstimate()></div><div class=\"col-sm-2 top7\">Select New Owner</div><div class=col-sm-4><ui-select ng-model=vm.newOwnerId ng-change=vm.checkNewOwner()><ui-select-match>{{$select.selected.user_full_name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user.user_id as user in vm.repData | filter:$select.search\" refresh-delay=300>{{user.user_full_name}}</ui-select-choices></ui-select></div></div><div class=\"row bottom7\"><div class=col-sm-2><button class=\"btn btn-primary\" ng-click=vm.save()>Save Changes</button></div></div><div class=row ng-if=vm.estimateData><table datatable=ng class=\"table table-striped\"><thead><tr><th>Site Name</th><th>Estimate ID</th><th>Estimate Title</th><th>Active</th><th>Current Owner</th><th>Check to indicate required change</th></tr></thead><tbody><tr ng-repeat=\"(key,row) in vm.estimateData\"><td>{{row.site_name}}</td><td>{{row.estimate_id}}</td><td>{{row.title}}</td><td>{{row.inactive?\"NO\":\"YES\"}}</td><td ng-repeat=\"user in vm.users | filter:{user_id:row.owner}:true\">{{user.user_full_name}}</td><td><input type=checkbox ng-model=row.changeOwner ng-change=vm.updateOwner(key)></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/salesAdminProduction/salesAdminProduction.html","<div class=page-header><div><h1><span class=col-md-9>Sales Production</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=box><div class=box-content><div class=row><div class=\"col-md-1 top7\"><b>Year:</b></div><div class=col-md-3><ui-select ng-model=vm.workingObj.year ng-change=vm.updateYear()><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\" refresh-delay=300>{{year}}</ui-select-choices></ui-select></div></div><div class=\"row top7 bottom15\"><div class=col-sm-2><button class=\"btn btn-primary\" type=button ng-click=vm.saveProduction()>Save Production</button></div></div><div class=row ng-repeat=\"salesRep in vm.workingObj.jnl_reps\"><table class=\"table table-striped\"><td ng-repeat=\"user in vm.users | filter:{user_id:salesRep.user_id}:true\">{{user.user_full_name}}</td><th>January</th><th>February</th><th>March</th><th>April</th><th>May</th><th>June</th><th>July</th><th>August</th><th>September</th><th>October</th><th>November</th><th>December</th><tr ng-repeat=\"data in salesRep.production_data\"><th ng-repeat=\"cat in vm.salesCategories | filter:{id:data.category}:true\">{{cat.name}}</th><td><input class=form-control ng-model=data.monthly_production.jan></td><td><input class=form-control ng-model=data.monthly_production.feb></td><td><input class=form-control ng-model=data.monthly_production.mar></td><td><input class=form-control ng-model=data.monthly_production.apr></td><td><input class=form-control ng-model=data.monthly_production.may></td><td><input class=form-control ng-model=data.monthly_production.jun></td><td><input class=form-control ng-model=data.monthly_production.jul></td><td><input class=form-control ng-model=data.monthly_production.aug></td><td><input class=form-control ng-model=data.monthly_production.sep></td><td><input class=form-control ng-model=data.monthly_production.oct></td><td><input class=form-control ng-model=data.monthly_production.nov></td><td><input class=form-control ng-model=data.monthly_production.dec></td></tr></table></div><div class=row ng-repeat=\"salesRep in vm.workingObj.third_parties\"><table class=\"table table-striped\"><td ng-repeat=\"tparty in vm.third_parties | filter:{id:salesRep.third_party_id}:true\">{{tparty.name}}</td><th>January</th><th>February</th><th>March</th><th>April</th><th>May</th><th>June</th><th>July</th><th>August</th><th>September</th><th>October</th><th>November</th><th>December</th><tr ng-repeat=\"data in salesRep.production_data\"><th ng-repeat=\"cat in vm.salesCategories | filter:{id:data.category}:true\">{{cat.name}}</th><td><input class=form-control ng-model=data.monthly_production.jan></td><td><input class=form-control ng-model=data.monthly_production.feb></td><td><input class=form-control ng-model=data.monthly_production.mar></td><td><input class=form-control ng-model=data.monthly_production.apr></td><td><input class=form-control ng-model=data.monthly_production.may></td><td><input class=form-control ng-model=data.monthly_production.jun></td><td><input class=form-control ng-model=data.monthly_production.jul></td><td><input class=form-control ng-model=data.monthly_production.aug></td><td><input class=form-control ng-model=data.monthly_production.sep></td><td><input class=form-control ng-model=data.monthly_production.oct></td><td><input class=form-control ng-model=data.monthly_production.nov></td><td><input class=form-control ng-model=data.monthly_production.dec></td></tr></table></div></div></div></div>");
$templateCache.put("app/salesAdminReps/salesAdminReps.html","<div cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=page-header><div><h1><span class=col-md-9>Sales Reps</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div class=box><div class=box-content><div class=row><table class=\"table table-striped\"><tr><th style=width:20%>Name</th><th style=width:50%>Years</th><th></th></tr><tr ng-if=!vm.addNew ng-repeat=\"(k,rep) in vm.users\"><td ng-repeat=\"user in vm.users | filter:{user_id:rep.user_id}:true\">{{user.user_full_name}}</td><td ng-if=\"!(vm.editActive && rep.user_id == vm.edit_id)\">{{rep.years.toString()}}</td><td ng-if=\"vm.editActive && rep.user_id == vm.edit_id\"><ui-select multiple ng-model=rep.years><ui-select-match>{{$item}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\">{{year}}</ui-select-choices></ui-select></td><td ng-if=!(vm.editActive)><button class=\"btn btn-primary\" type=button ng-click=vm.editRep(rep.user_id)>Edit</button></td><td ng-if=\"vm.editActive && rep.user_id == vm.edit_id\"><button class=\"btn btn-primary\" type=button ng-click=vm.saveEdit(k)>Save</button><button class=\"btn btn-danger\" type=button ng-click=vm.cancelEdit()>Cancel</button></td></tr></table></div></div></div><div class=page-header><div><h1><span class=col-md-9>Third Parties</span></h1></div></div><div class=box><div class=box-content><div ng-repeat=\"(k,third_p) in vm.third_parties\" class=row><table class=\"table table-striped\"><tr><th style=width:20%>Company</th><th style=width:20%>Years</th><th style=width:50%>Reps</th><th></th></tr><tr><td>{{third_p.name}}</td><td ng-if=\"!(vm.editActive && third_p.id == vm.edit_t_id)\">{{third_p.years.toString()}}</td><td ng-if=\"vm.editActive && third_p.id == vm.edit_t_id\"><ui-select multiple ng-model=third_p.years><ui-select-match>{{$item}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"year in vm.years | filter:$select.search\">{{year}}</ui-select-choices></ui-select></td><td><span ng-repeat=\"rep in third_p.users\">{{rep.user_full_name}}<br></span></td><td ng-if=!(vm.editActive)><button class=\"btn btn-primary\" type=button ng-click=vm.editThirdParty(third_p.id)>Edit</button></td><td ng-if=\"vm.editActive && third_p.id == vm.edit_t_id\"><button class=\"btn btn-primary\" type=button ng-click=vm.saveThirdParty(k)>Save</button><button class=\"btn btn-danger\" type=button ng-click=vm.cancelEdit()>Cancel</button></td></tr></table></div></div></div></div>");
$templateCache.put("app/salesAdminTerritories/salesAdminTerritories.html","<script type=text/ng-template id=addRegion.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">New Region</h4>\n		</div>\n		<div class=\"modal-body\">\n			<div class=\"row\">\n				<span class=\"col-sm-2 top7\">New Region Name:</span>\n				<span class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"vm.newObject.name\"></span>\n			</div>\n			<div class=\"row top5\"></div>\n			<div class=\"row\" ng-if=\"vm.newObject.name\">\n				<span class=\"col-sm-2\">JNL Employee:</span>\n				<span class=\"col-sm-8\"><ui-select ng-model=\"vm.newObject.user.id\">\n					<ui-select-match>{{$select.selected.user_full_name}}</ui-select-match>\n					<ui-select-choices class=\"ui-select-choices\" repeat=\"user.user_id as user in vm.users | filter:$select.search\" refresh-delay=\"300\">\n						{{user.user_full_name}}\n					</ui-select-choices>\n				</ui-select></td></span>\n			</div>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!(vm.newObject.name && vm.newObject.user.id)\" ng-click=\"vm.save()\">Save</button>\n		</div>\n	</div></script><div class=page-header><div><h1><span class=col-md-9>Regions Definitions</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div ng-if=!vm.editing cg-busy={promise:vm.populatePromise,delay:300,minDuration:1000}><div class=row><div class=col-sm-5><div class=box><div class=box-title><h3><i class=\"fa fa-suitcase\"></i>Regions</h3><span class=pull-right><button class=btn ng-click=vm.addNew()><i class=\"fa fa-plus\"></i></button></span></div><div class=box-content><table class=\"table table-hover\"><thead><tr><th colspan=2>Current Regions</th></tr></thead><tbody><tr dir-paginate=\"(key,line) in vm.territories | filter:{displayName:vm.searchValue} | itemsPerPage:12\" role=button ng-click=vm.populateDetails(key)><td ng-if=\"line.id != 1\" style=width:2%><i class=\"fa fa-minus-circle text-danger\" ng-click=vm.removeTerritory(key)></i></td><td ng-if=\"line.id == 1\" style=width:2%><i class=\"fa fa-minus-circle\"></i></td><td ng-class={danger:line.invalid}>{{line.name}}</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=col-sm-7><div class=box><div class=\"box-title col-sm-12\"><div class=col-sm-10><h3><i class=\"fa fa-pencil-square-o\"></i> Details</h3></div><div class=col-sm-2><button class=\"btn btn-primary\" ng-disabled=!vm.selectedTerritory ng-click=vm.updateRegion()>Save</button></div></div><div class=box-content><span ng-hide=vm.selectedTerritory>No Territory Selected</span><table class=\"table table-hover\" ng-if=vm.selectedTerritory><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Territory Name</td><td><input class=form-control type=text ng-model=vm.selectedTerritory.name></td></tr><tr><td>States in Territory</td><td ng-if=\"vm.selectedTerritory.id != 1\"><ui-select multiple ng-model=vm.selectedTerritory.states on-select=vm.stateSelected($item.id) on-remove=vm.stateRemoved($item.id)><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"state.id as state in vm.states | filter:$select.search\" refresh-delay=300>{{state.name}}, {{state.country}}</ui-select-choices></ui-select></td><td ng-if=\"vm.selectedTerritory.id == 1\"><ui-select multiple ng-disabled=true ng-model=vm.selectedTerritory.states ng-change=vm.part_selected($select.selected)><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"state.id as state in vm.states | filter:$select.search\" refresh-delay=300>{{state.name}}, {{state.country}}</ui-select-choices></ui-select></td></tr><tr><td>JNL Employee</td><td><!-- <ui-select ng-model=\"vm.selectedTerritory.user.id\" ng-change=\"vm.change_user($select.selected)\">\n										<ui-select-match>{{$item.name}} </ui-select-match>\n										<ui-select-choices class=\"ui-select-choices\" repeat=\"user.user_id as user in vm.users | filter:$select.search\" refresh-delay=\"300\">\n											{{user.user_full_name}}\n										</ui-select-choices>\n									</ui-select> --><ui-select ng-model=vm.selectedTerritory.user.id><ui-select-match>{{$select.selected.user_full_name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user.user_id as user in vm.users | filter:$select.search\" refresh-delay=300>{{user.user_full_name}}</ui-select-choices></ui-select></td><!-- <select class=\"form-control\" ng-model=\"vm.selectedTerritory.user.id\" ng-options=\"item.user_id as item.user_full_name for item in vm.users\"></select> --></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/subContractorList/subContractorList.html","<script type=text/ng-template id=editUser.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Edit User</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<table class=\"table table-striped\">\n\n				<tbody>\n					<tr>\n						<td>Name</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.user_full_name\"></td>\n					</tr>\n					<tr ng-if=\"!vm.activeUser.id\">\n						<td>User Name</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.user_name\"></td>\n					</tr>\n						<td>Email</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.user_email\"></td>\n					</tr>\n					<tr>\n						<td>Phone Number</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.phone\"></td>\n					</tr>\n					<tr ng-if=\"vm.submissionObj.sells_things\">\n						<td>Sells Things</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.activeUser.sells_things\"></td>\n					</tr>\n					<tr ng-if=\"vm.submissionObj.installs_things\">\n						<td>Installs Things</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.activeUser.installs_things\"></td>\n					</tr>\n					<tr>\n						<td>Admin</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.activeUser.third_party_info.admin\"></td>\n					</tr>\n\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-danger pull-left\" ng-click=\"vm.remove_user()\">Remove User</button>\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveUser()\">Save</button>\n    </div>\n	</div></script><div class=page-header><div><h1><span class=col-md-9>Third Parties</span></h1><span ng-if=vm.submissionObj.id><button class=btn type=button ng-click=vm.back()>Back</button></span><span ng-if=\"!vm.submissionObj.id && !vm.new\"><button class=btn type=button ng-click=vm.addNew()>New</button></span></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700} ng-if=\"!vm.submissionObj.id && !vm.new\"><div><div class=col-sm-1></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=name>Company Name</option><option value=state/name>State</option><option value=city>City</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'name\'; vm.sort_data()\">Company Name <span ng-show=\"vm.sort_by == \'name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'city\'; vm.sort_data()\">City <span ng-show=\"vm.sort_by == \'city\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'city\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'state/name\'; vm.sort_data()\">State <span ng-show=\"vm.sort_by == \'state/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'state/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Linux Password</th></thead><tbody ng-if=!vm.admin_check()><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count><td>{{obj.name}}</td><td>{{obj.city}}</td><td>{{obj.state.name}}</td><td>{{obj.plain_password}}</td></tr></tbody><tbody ng-if=vm.admin_check()><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count ng-click=vm.loadSub(obj.id) style=\"cursor: pointer\"><td>{{obj.name}}</td><td>{{obj.city}}</td><td>{{obj.state.name}}</td><td>{{obj.plain_password}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700} ng-if=vm.submissionObj.id><div class=row><div class=col-sm-6><div class=row><div class=\"col-sm-2 top7\">Company Name</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.name></div></div><div class=row><div class=\"col-sm-2 top7\">Address</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.address></div></div><div class=row><div class=\"col-sm-2 top7\">Phone</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.phone></div></div><div class=row><div class=\"col-sm-2 top7\">City</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.city></div></div><div class=row><div class=\"col-sm-2 top7\">State</div><div class=col-sm-6><select class=form-control ng-model=vm.submissionObj.state.id ng-options=\"item.id as item.abbreviation for item in vm.stateList\"></select></div></div><div class=row><div class=\"col-sm-2 top7\">Zip</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.zip></div></div><div class=row><div class=\"col-sm-2 top7\">Sells Things</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.sells_things></div></div><div class=row><div class=\"col-sm-2 top7\">Installs Things</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.installs_things></div></div><div class=row ng-if=vm.access_check()><div class=\"col-sm-2 top7\">Discount Percentage</div><div class=\"col-sm-6 top5\"><input ng-model=vm.submissionObj.discount>%</div></div><div class=row ng-if=vm.access_check()><div class=\"col-sm-2 top7\">Connectwise ID</div><div class=\"col-sm-6 top5\"><input ng-model=vm.submissionObj.connectwise_id></div></div><div class=row><div class=\"col-sm-2 top7\">Connectwise Location</div><div class=\"col-sm-6 top5\"><div class=\"controls col-sm-10\"><ui-select ng-model=vm.submissionObj.connectwise_location_id><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.connectwise_location_data | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-sm-2 top7\"><button ng-if=vm.submissionObj.name.length class=\"btn btn-primary form-control\" ng-click=vm.update()>Save Changes</button></div><div class=col-2-sm></div><div class=\"col-sm-2 top7\"><button class=\"btn btn-danger form-control\" ng-click=vm.remove()>Make Inactive</button></div></div></div><div class=col-sm-6><div class=row><div class=col-sm-2><span>Last Updated</span></div><div class=col-sm-10><span>{{vm.submissionObj.last_updated | date:\'medium\'}}</span></div></div><div class=\"row top7\"><div class=col-sm-2><span>Created</span></div><div class=col-sm-10><span>{{vm.submissionObj.date_created | date:\'medium\'}}</span></div></div><div class=\"row top7\"><div class=\"col-sm-2 top7\"><span>Notes</span></div><div class=col-sm-10><textarea ng-model=vm.submissionObj.notes class=msd-elastic; style=width:80%></textarea></div></div><div class=row><div class=\"col-sm-2 top7\">Linux Username</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.username></div></div><div class=row><div class=\"col-sm-2 top7\">Linux Password</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.plain_password></div><div class=\"col-sm-2 top5\"><button><i class=\"fa fa-refresh text-primary\" ng-click=vm.buildPass()></i></button></div></div><div class=row><div class=\"col-sm-2 top7\">Save Linux Info</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.update_linux_data></div></div></div></div><div class=row><div><div><h1><span class=col-md-9>Users</span></h1><span><button class=\"btn btn-primary\" ng-click=vm.addUser()>Add User</button></span></div></div><table class=table><tr><th>Name</th><th>User Name</th><th>Email</th><th>Phone</th><th>Sells Stuff</th><th>Installs Stuff</th><th>Admin</th><th>Set / Reset Password</th><!-- <th>Password Change Needed</th> --></tr><tr ng-repeat=\"(key,user) in vm.userList.data\" ng-click=vm.editUser(key) style=\"cursor: pointer\"><td><span class=left5>{{user.user_full_name}}</span></td><td>{{user.user_name}}</td><td>{{user.user_email}}</td><td>{{user.phone}}</td><td>{{user.sells_things ? \"YES\":\"NO\"}}</td><td>{{user.installs_things ? \"YES\":\"NO\"}}</td><td>{{user.third_party_info.admin ? \"YES\":\"NO\"}}</td><td><button class=\"btn btn-primary\" ng-click=vm.pass_reset(user.user_id,vm.submissionObj.id)>Reset</button></td><!-- <td>{{user.pw_change_required ? \"YES\":\"NO\"}}</td> --></tr></table></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700} ng-if=vm.new><div class=row><div class=col-sm-6><div class=row><div class=\"col-sm-2 top7\">Company Name</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.name></div></div><div class=row><div class=\"col-sm-2 top7\">Address</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.address></div></div><div class=row><div class=\"col-sm-2 top7\">Phone</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.phone></div></div><div class=row><div class=\"col-sm-2 top7\">City</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.city></div></div><div class=row><div class=\"col-sm-2 top7\">State</div><div class=col-sm-6><select class=form-control ng-model=vm.submissionObj.state.id ng-options=\"item.id as item.abbreviation for item in vm.stateList\"></select></div></div><div class=row><div class=\"col-sm-2 top7\">Zip</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.zip></div></div><div class=row><div class=\"col-sm-2 top7\">Sells Things</div><div class=\"col-sm-6 top7\"><input type=checkbox ng-model=vm.submissionObj.sells_things></div></div><div class=row><div class=\"col-sm-2 top7\">Installs Things</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.installs_things></div></div><div class=row><div class=\"col-sm-2 top7\">Connectwise Location</div><div class=\"col-sm-6 top5\"><div class=\"controls col-sm-10 customPadBottom customPadLeft\"><ui-select ng-model=vm.submissionObj.connectwise_location_id><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.connectwise_location_data | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-sm-2 top5\"><button ng-if=vm.submissionObj.name.length class=\"btn btn-primary form-control\" ng-click=vm.save()>Save Changes</button></div><div class=col-sm-2></div><div class=\"col-sm-2 top7\"><button class=\"btn form-control\" ng-click=vm.cancel()>Cancel</button></div></div></div><div class=col-sm-6><div class=row><div class=col-sm-2><span class=my-form-control>Last Updated</span></div><div class=col-sm-10><span class=my-form-control>{{vm.submissionObj.last_updated | date:\'medium\'}}</span></div></div><div class=row><div class=col-sm-2><span class=my-form-control>Created</span></div><div class=col-sm-10><span class=my-form-control>{{vm.submissionObj.date_created | date:\'medium\'}}</span></div></div><div class=row><div class=col-sm-2><span class=my-form-control>Notes</span></div><div class=col-sm-10><textarea ng-model=vm.submissionObj.notes class=msd-elastic; style=width:80%></textarea></div></div><div class=row><div class=\"col-sm-2 top7\">Teamviewer Password</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.tv_password></div></div></div></div></div>");
$templateCache.put("app/subContractorUsers/subContractorUser.html","<script type=text/ng-template id=editUser.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Edit User</h4>\n		</div>\n		<!-- /.modal-header -->\n    <div class=\"modal-body\">\n			<table class=\"table table-striped\">\n\n				<tbody>\n					<tr>\n						<td>Name</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.user_full_name\"></td>\n					</tr>\n					<tr ng-if=\"!vm.activeUser.id\">\n						<td>User Name</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.user_name\"></td>\n					</tr>\n						<td>Email</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.user_email\"></td>\n					</tr>\n					<tr>\n						<td>Phone Number</td>\n						<td><input type=\"text\" class=\"form-control\" ng-model=\"vm.activeUser.phone\"></td>\n					</tr>\n					<tr ng-if=\"vm.submissionObj.sells_things\">\n						<td>Sells Things</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.activeUser.sells_things\"></td>\n					</tr>\n					<tr ng-if=\"vm.submissionObj.installs_things\">\n						<td>Installs Things</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.activeUser.installs_things\"></td>\n					</tr>\n					<tr>\n						<td>Admin</td>\n						<td><input type=\"checkbox\" ng-model=\"vm.activeUser.third_party_info.admin\"></td>\n					</tr>\n\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-danger pull-left\" ng-click=\"vm.remove_user()\">Remove User</button>\n      <button class=\"btn\" type=\"button\" ng-click=\"vm.closeModal()\">Cancel</button>\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.saveUser()\">Save</button>\n    </div>\n	</div></script><div class=page-header><div class=\"row align-items-center\"><div class=col-md-9><h1 class=page-title>Distributor Users</h1></div><div class=\"col-md-3 text-end\"><span ng-if=vm.submissionObj.id><button class=\"btn btn-primary\" type=button ng-click=vm.back()>Back</button> </span><span ng-if=\"!vm.submissionObj.id && !vm.new\"><button class=\"btn btn-success\" type=button ng-click=vm.addNew()>New</button></span></div></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700} ng-if=\"!vm.submissionObj.id && !vm.new\"><div class=\"row bottom5\"><div class=col-sm-1></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=user_full_name>Full Name</option><option value=user_name>User Name</option><option value=third_party_info/name>Company</option><option value=user_email>User Email</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'user_full_name\'; vm.sort_data()\">Full Name <span ng-show=\"vm.sort_by == \'user_full_name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'user_full_name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'user_name\'; vm.sort_data()\">User Name <span ng-show=\"vm.sort_by == \'user_name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'user_name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'third_party_info/name\'; vm.sort_data()\">Company <span ng-show=\"vm.sort_by == \'third_party_info/name\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'third_party_info/name\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'user_email\'; vm.sort_data()\">User Email <span ng-show=\"vm.sort_by == \'user_email\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'user_email\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th></thead><tbody><tr dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count><td>{{obj.user_full_name}}</td><td>{{obj.user_name}}</td><td>{{obj.third_party_info.name}}</td><td>{{obj.user_email}}</td></tr></tbody><!-- <tbody ng-if=\"vm.admin_check()\">\n			<tr  dir-paginate=\"obj in vm.data.data | itemsPerPage:vm.num_results\" current-page=\"vm.currentPage\" total-items=\"vm.data.count\" ng-click=\"vm.loadSub(obj.id)\" style=\"cursor: pointer;\">\n				<td>{{obj.user_full_name}}</td>\n				<td>{{obj.user_name}}</td>\n				<td>{{obj.third_party_info.name}}</td>\n				<td>{{obj.user_email}}</td>\n			</tr>\n		</tbody> --></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700} ng-if=vm.submissionObj.id><div class=row><div class=col-sm-6><div class=row><div class=\"col-sm-2 top7\">Company Name</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.name></div></div><div class=row><div class=\"col-sm-2 top7\">Address</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.address></div></div><div class=row><div class=\"col-sm-2 top7\">Phone</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.phone></div></div><div class=row><div class=\"col-sm-2 top7\">City</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.city></div></div><div class=row><div class=\"col-sm-2 top7\">State</div><div class=col-sm-6><select class=form-control ng-model=vm.submissionObj.state.id ng-options=\"item.id as item.abbreviation for item in vm.stateList\"></select></div></div><div class=row><div class=\"col-sm-2 top7\">Zip</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.zip></div></div><div class=row><div class=\"col-sm-2 top7\">Sells Things</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.sells_things></div></div><div class=row><div class=\"col-sm-2 top7\">Installs Things</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.installs_things></div></div><div class=row ng-if=vm.access_check()><div class=\"col-sm-2 top7\">Discount Percentage</div><div class=\"col-sm-6 top5\"><input ng-model=vm.submissionObj.discount>%</div></div><div class=row ng-if=vm.access_check()><div class=\"col-sm-2 top7\">Connectwise ID</div><div class=\"col-sm-6 top5\"><input ng-model=vm.submissionObj.connectwise_id></div></div><div class=row><div class=\"col-sm-2 top7\">Connectwise Location</div><div class=\"col-sm-6 top5\"><div class=\"controls col-sm-10\"><ui-select ng-model=vm.submissionObj.connectwise_location_id><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.connectwise_location_data | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-sm-2 top7\"><button ng-if=vm.submissionObj.name.length class=\"btn btn-primary form-control\" ng-click=vm.update()>Save Changes</button></div><div class=col-2-sm></div><div class=\"col-sm-2 top7\"><button class=\"btn btn-danger form-control\" ng-click=vm.remove()>Make Inactive</button></div></div></div><div class=col-sm-6><div class=row><div class=col-sm-2><span>Last Updated</span></div><div class=col-sm-10><span>{{vm.submissionObj.last_updated | date:\'medium\'}}</span></div></div><div class=\"row top7\"><div class=col-sm-2><span>Created</span></div><div class=col-sm-10><span>{{vm.submissionObj.date_created | date:\'medium\'}}</span></div></div><div class=\"row top7\"><div class=\"col-sm-2 top7\"><span>Notes</span></div><div class=col-sm-10><textarea ng-model=vm.submissionObj.notes class=msd-elastic; style=width:80%></textarea></div></div><div class=row><div class=\"col-sm-2 top7\">Teamviewer Password</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.tv_password></div></div></div></div><div class=row><div><div><h1><span class=col-md-9>Users</span></h1><span><button class=\"btn btn-primary\" ng-click=vm.addUser()>Add User</button></span></div></div><table class=table><tr><th>Name</th><th>User Name</th><th>Email</th><th>Phone</th><th>Sells Stuff</th><th>Installs Stuff</th><th>Admin</th><th>Set / Reset Password</th><!-- <th>Password Change Needed</th> --></tr><tr ng-repeat=\"(key,user) in vm.userList.data\" ng-click=vm.editUser(key) style=\"cursor: pointer\"><td><span class=left5>{{user.user_full_name}}</span></td><td>{{user.user_name}}</td><td>{{user.user_email}}</td><td>{{user.phone}}</td><td>{{user.sells_things ? \"YES\":\"NO\"}}</td><td>{{user.installs_things ? \"YES\":\"NO\"}}</td><td>{{user.third_party_info.admin ? \"YES\":\"NO\"}}</td><td><button class=\"btn btn-primary\" ng-click=vm.pass_reset(user.user_id,vm.submissionObj.id)>Reset</button></td><!-- <td>{{user.pw_change_required ? \"YES\":\"NO\"}}</td> --></tr></table></div></div><div cg-busy={promise:vm.populatePromise,delay:200,minDuration:700} ng-if=vm.new><div class=row><div class=col-sm-6><div class=row><div class=\"col-sm-2 top7\">Company Name</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.name></div></div><div class=row><div class=\"col-sm-2 top7\">Address</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.address></div></div><div class=row><div class=\"col-sm-2 top7\">Phone</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.phone></div></div><div class=row><div class=\"col-sm-2 top7\">City</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.city></div></div><div class=row><div class=\"col-sm-2 top7\">State</div><div class=col-sm-6><select class=form-control ng-model=vm.submissionObj.state.id ng-options=\"item.id as item.abbreviation for item in vm.stateList\"></select></div></div><div class=row><div class=\"col-sm-2 top7\">Zip</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.zip></div></div><div class=row><div class=\"col-sm-2 top7\">Sells Things</div><div class=\"col-sm-6 top7\"><input type=checkbox ng-model=vm.submissionObj.sells_things></div></div><div class=row><div class=\"col-sm-2 top7\">Installs Things</div><div class=\"col-sm-6 top5\"><input type=checkbox ng-model=vm.submissionObj.installs_things></div></div><div class=row><div class=\"col-sm-2 top7\">Connectwise Location</div><div class=\"col-sm-6 top5\"><div class=\"controls col-sm-10 customPadBottom customPadLeft\"><ui-select ng-model=vm.submissionObj.connectwise_location_id><ui-select-match class=ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"item.id as item in vm.connectwise_location_data | filter:$select.search\">{{item.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-sm-2 top5\"><button ng-if=vm.submissionObj.name.length class=\"btn btn-primary form-control\" ng-click=vm.save()>Save Changes</button></div><div class=col-sm-2></div><div class=\"col-sm-2 top7\"><button class=\"btn form-control\" ng-click=vm.cancel()>Cancel</button></div></div></div><div class=col-sm-6><div class=row><div class=col-sm-2><span class=my-form-control>Last Updated</span></div><div class=col-sm-10><span class=my-form-control>{{vm.submissionObj.last_updated | date:\'medium\'}}</span></div></div><div class=row><div class=col-sm-2><span class=my-form-control>Created</span></div><div class=col-sm-10><span class=my-form-control>{{vm.submissionObj.date_created | date:\'medium\'}}</span></div></div><div class=row><div class=col-sm-2><span class=my-form-control>Notes</span></div><div class=col-sm-10><textarea ng-model=vm.submissionObj.notes class=msd-elastic; style=width:80%></textarea></div></div><div class=row><div class=\"col-sm-2 top7\">Teamviewer Password</div><div class=col-sm-6><input class=form-control ng-model=vm.submissionObj.tv_password></div></div></div></div></div>");
$templateCache.put("app/supportAdminLinux/supportAdminLinux.html","<div class=page-header><div class=row><div class=col-md-9><h1 class=page-title>JNL Linux Users</h1></div><div class=\"col-md-3 text-right\"><!-- <button class=\"btn btn-primary\" ng-if=\"vm.submissionObj.id\" ng-click=\"vm.back()\">Back</button>\n			<button class=\"btn btn-success\" ng-if=\"!vm.submissionObj.id && !vm.new\" ng-click=\"vm.new=true\">New</button> --></div></div></div><div cg-busy={promise:vm.load_promise,delay:0,minDuration:1000} class=container-fluid><div class=row><div class=col-md-6 ng-if=vm.data><table class=table><thead><th>Users</th></thead><tbody><tr ng-if=!vm.submissionObj ng-repeat=\"(key,obj) in vm.data.data\" ng-click=vm.load_user(key) style=\"cursor: pointer\"><td>{{obj.name}}</td></tr><tr ng-if=vm.submissionObj><td>{{vm.submissionObj.name}}</td></tr></tbody></table></div><div class=col-md-6 ng-if=vm.submissionObj><table class=table><thead><th>Details</th><th><button class=\"btn pull-right\" ng-click=vm.cancel()>Cancel</button></th><th><button class=\"btn btn-success pull-right\" ng-click=vm.update()>Save</button></th></thead><tbody><tr><td>Username:</td><td>{{vm.submissionObj.username}}</td></tr><tr><td>Password:</td><td><input type=text ng-model=vm.submissionObj.plain_password></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/supportTicket/supportTicketLanding.html","<script type=text/ng-template id=customerChoice.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Select correct customer</h4>\n		</div>\n		<div class=\"modal-body table\">\n			<table class=\"table-striped\" width=\"100%\">\n				<thead>\n					<th>Name</th>\n					<th>Phone</th>\n					<th>State</th>\n					<th>Status</th>\n				</thead>\n				<tbody>\n					<tr ng-repeat=\"row in vm.searchResults\" ng-click=\"vm.openCustomer(row.id,true,true)\" style=\"cursor: pointer;\">\n						<td>{{row.name}}</td>\n						<td>{{row.phone_number}}</td>\n						<td>{{row.state}}</td>\n						<td>{{row.status}}</td>\n					</tr>\n				</tbody>\n			</table>\n			<div class=\"modal-footer\">\n    	</div>\n		</div>\n	</div></script><script type=text/ng-template id=customNotes.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h3 class=\"modal-title\">Attention Required!</h3>\n		</div>\n		<div class=\"modal-body\">\n				<div class=\"row\" ng-repeat=\"row in vm.special_statuses\">\n					<div class=\"col-sm-12\">\n						<textarea class=\"msd-elastic;\" ng-model=\"row\" style=\"width:100%\"></textarea>\n					</div>\n				</div>\n			<div class=\"modal-footer\">\n				<button class=\"btn\" type=\"button\" ng-click=\"vm.close_open_modal()\">Got it!</button>\n    	</div>\n		</div>\n	</div></script><div cg-busy=\"{promise:vm.start_ticket_promise,delay:0,message:\'Saving Ticket, one moment please\'}\"><div class=page-header><div><h1><span class=col-md-9>New Ticket</span></h1><span><button class=btn type=button ng-click=vm.back()>Back</button></span></div></div><div class=box><div class=box-content><div class=row><div class=\"col-sm-1 top5\">Customer:</div><div class=col-sm-6><input type=text class=form-control ng-model=vm.customerTextSearch ng-keyup=\"$event.keyCode == 13 ? vm.searchCustomer() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-2><button class=\"btn btn-primary\" type=button ng-click=vm.searchCustomer()>Find Customer</button></div></div><div class=\"row top7\"><div class=\"col-sm-1 top5\">Ticket Number:</div><div class=col-sm-6><input type=text class=form-control ng-model=vm.ticketIDSearch ng-keyup=\"$event.keyCode == 13 ? vm.searchID() : null\"></div><div class=col-sm-2><button class=\"btn btn-primary\" type=button ng-click=vm.searchID()>Find Ticket</button></div></div></div></div><div class=box ng-if=vm.selectedCustomer><div class=box-content><div class=table><table class=table width=100%><thead><th>Customer Details</th><th></th></thead><tbody><tr><td>Name: {{vm.selectedCustomer.name}}</td><td>Address: {{vm.selectedCustomer.address}}</td></tr><tr><td>Contact: {{vm.selectedCustomer.contacts[0].first_name}} {{vm.selectedCustomer.contacts[0].last_name}}</td><td>State: {{vm.selectedCustomer.state}}</td></tr><tr><td>Phone: {{vm.selectedCustomer.phone_number}}</td><td>Zip: {{vm.selectedCustomer.zip}}</td></tr></tbody></table></div></div></div><div class=box ng-if=\"vm.selectedCustomer && !vm.newTicket\"><div class=box-content><div class=row><div class=col-sm-2><h3>Recent Tickets</h3></div><div class=\"col-sm-9 top20 bottom10\"><button class=\"btn btn-primary\" type=button ng-click=\"vm.newTicket = true\" ng-disabled=\"vm.selectedCustomer.status===\'Accounting Hold\'\">Start New Ticket</button><span ng-if=\"vm.selectedCustomer.status===\'Accounting Hold\'\">Customer is in Accounting Hold</span></div></div><div class=table><table class=\"table table-striped\" width=100%><thead><th>Ticket #</th><th>Summary</th><th>Contact</th><th>Phone Number</th><th>System</th><th>Status</th><th>Entered</th></thead><tbody><tr ng-repeat=\"ticket in vm.recentTickets\" style=\"cursor: pointer\" ng-click=vm.loadTicket(ticket.id)><td>{{ticket.id}}</td><td>{{ticket.summary}}</td><td>{{ticket.contactName}}</td><td>{{ticket.contactPhoneNumber}}</td><td>{{ticket.type.name}}</td><td>{{ticket.status.name}}</td><td>{{ticket.dateEntered | date : \'MMM d, y h:mm:ss a\' : ticket.offset}}</td></tr></tbody></table></div></div></div><div class=box ng-if=\"vm.selectedCustomer && vm.newTicket\"><div class=box-content><div class=table><table class=table width=100%><thead><th width=15%>New Ticket</th><th><button class=\"btn btn-danger\" type=button ng-click=\"vm.newTicket = false\">Cancel Ticket</button></th></thead><tbody><tr><td>Initial Problem Description</td><td><input class=form-control ng-model=vm.ticketObject.summary></td></tr><!-- <tr>\n							<td>Contact Name</td>\n							<td><select class=\"select2-single form-control\" ng-model=\"vm.ticketObject.contact.id\"  ng-focus=\"vm.contact_control(1)\"\n										ng-options=\"contact.id as contact.first_name+\' \'+contact.last_name for contact in vm.selectedCustomer.contacts\">\n										<option value=\"\"></option>\n								</select></td>\n								<td>\n									<ui-select ng-model=\"vm.selectedContact\" ng-change=\"vm.updateContact()\">\n										<ui-select-match>{{$select.selected.name}}</ui-select-match>\n										<ui-select-choices class=\"ui-select-choices\" repeat=\"contact in vm.availableContacts | filter:$select.search\">\n											{{contact.name}}\n										</ui-select-choices>\n									</ui-select>\n								</td>\n						</tr> --><tr><td>Contact Name</td><td><input type=text class=form-control ng-model=vm.ticketObject.contactName></td></tr><tr><td>Contact Phone</td><td><input type=text class=form-control ng-model=vm.ticketObject.contactPhoneNumber></td></tr><tr><td>Board</td><td><ui-select ng-model=vm.ticketObject.board ng-change=vm.load_statuses(true)><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"board in vm.boards | filter:$select.search\">{{board.name}}</ui-select-choices></ui-select></td></tr><tr><td>Status</td><td><ui-select ng-model=vm.ticketObject.status><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"status in vm.statuses | filter:$select.search\">{{status.name}}</ui-select-choices></ui-select></td></tr><tr><td>Type</td><td><ui-select ng-model=vm.ticketObject.type><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type in vm.types | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></td></tr><tr><td>Agreement</td><td><select class=\"select2-single form-control\" ng-model=vm.ticketObject.agreement ng-options=\"ag as ag.name for ag in vm.agreements\"></select></td></tr><tr><td><button class=\"btn btn-primary\" type=button ng-click=vm.startTicket()>Save Ticket</button></td><td></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/supportTicket/supportTicketUpdate.html","<script type=text/ng-template id=addTimeIssue.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Select correct customer</h4>\n		</div>\n		<div class=\"modal-body table\">\n			<table class=\"table-striped\" width=\"100%\">\n				<thead>\n					<th>Add Time to Issue</th>\n					<th></th>\n					<th></th>\n				</thead>\n				<tbody>\n					<tr>\n						<td>Time Role</td>\n						<td colspan=\"2\">\n							<ui-select ng-model=\"vm.additional_role\">\n								<ui-select-match>{{$select.selected.name}}</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"role.id as role in vm.timeRoles | filter:$select.search\">\n									{{role.name}}\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n					<tr>\n						<td class=\"table_select_label\">Resolution</td>\n						<td colspan=\"2\">\n							<ui-select ng-model=\"vm.additional_resolution\">\n								<ui-select-match>{{$select.selected.name}}</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"issue.id as issue in vm.selectable_resolutions | filter:$select.search track by issue.id\">\n									{{issue.name}}\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n					<tr>\n						<td class=\"table_select_label\">Notes</td>\n						<td colspan=\"2\"><textarea class=\"msd-elastic: \\n;\" style=\"width:100%\" ng-model=\"vm.additional_notes\"></textarea></td>\n					</tr>\n					<tr>\n						<td>Number of Minutes to Add:</td>\n						<td colspan=\"2\"><input type=\"text\" ng-model=\"vm.additional_minutes\" value=\"\"></td>\n					</tr>\n					<tr>\n						<td>Used TeamViewer <input type=\"checkbox\" ng-model=\"vm.tv\"></td>\n						<td>Used Remote Support <input type=\"checkbox\" ng-model=\"vm.remoteSupport\"></td>\n						<td>Fixed Issue <input type=\"checkbox\" ng-model=\"vm.fixedIssue\"></td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-primary\" ng-click=\"vm.saveAddtionalTime()\">Save Time</button>\n    </div>\n	</div></script><script type=text/ng-template id=editTimeIssue.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<h4 class=\"modal-title\">Edit Issue Time</h4>\n		</div>\n		<div class=\"modal-body table\">\n			<table class=\"table-striped\" width=\"100%\">\n				<thead>\n					<th></th>\n					<th></th>\n					<th></th>\n				</thead>\n				<tbody>\n					<tr>\n						<td>Time Role</td>\n						<td colspan=\"2\">\n							<ui-select ng-model=\"vm.additional_role\">\n								<ui-select-match>{{$select.selected.name}}</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"role.id as role in vm.timeRoles | filter:$select.search\">\n									{{role.name}}\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n					<tr>\n						<td class=\"table_select_label\">Resolution</td>\n						<td colspan=\"2\">\n							<ui-select ng-model=\"vm.additional_resolution\">\n								<ui-select-match>{{$select.selected.name}}</ui-select-match>\n								<ui-select-choices class=\"ui-select-choices\" repeat=\"issue.id as issue in vm.selectable_resolutions | filter:$select.search track by issue.id\">\n									{{issue.name}}\n								</ui-select-choices>\n							</ui-select>\n						</td>\n					</tr>\n					<tr>\n						<td class=\"table_select_label\">Notes</td>\n						<td colspan=\"2\"><textarea class=\"msd-elastic: \\n;\" style=\"width:100%\" ng-model=\"vm.additional_notes\"></textarea></td>\n					</tr>\n					<tr>\n						<td>Number of Minutes to Add:</td>\n						<td colspan=\"2\"><input type=\"text\" ng-model=\"vm.additional_minutes\" value=\"\"></td>\n					</tr>\n					<tr>\n						<td>Used TeamViewer <input type=\"checkbox\" ng-model=\"vm.tv\"></td>\n						<td>Used Remote Support <input type=\"checkbox\" ng-model=\"vm.remoteSupport\"></td>\n						<td>Fixed Issue <input type=\"checkbox\" ng-model=\"vm.fixedIssue\"></td>\n					</tr>\n				</tbody>\n			</table>\n		</div>\n		<div class=\"modal-footer\">\n			<button class=\"btn btn-primary\" ng-click=\"vm.saveAddtionalTime(1)\">Save Time</button>\n    </div>\n	</div></script><div class=page-header><div class=row><h1><span class=col-lg-9>Ticket #{{vm.ticket_id}} - {{vm.ticketObject.company.name}}</span></h1><span></span></div></div><div class=row cg-busy=\"{promise:vm.update_ticket_promise,delay:0,message:\'Saving Ticket, one moment please\'}\"><div class=box ng-if=\"vm.ticketObject.id && !vm.editActive\"><div class=\"box-content border-groove\"><table class=table width=100%><thead><th width=15%>Ticket Details</th><th>Opened By - {{vm.ticketObject.enteredBy.name}}<button class=\"btn btn-success\" type=button ng-click=vm.saveTicketUpdates() ng-hide=\"vm.connectwiseStatus || vm.ticketObjectCheck()\">Save Ticket</button></th></thead><tbody><tr><td>Initial Problem Description</td><td><input class=form-control ng-model=vm.ticketObject.summary ng-disabled=vm.connectwiseStatus maxlength=100></td></tr><tr><td>Contact Name</td><td><input type=text class=form-control ng-model=vm.ticketObject.contactName ng-disabled=vm.connectwiseStatus></td></tr><tr><td>Contact Phone</td><td><input type=text class=form-control ng-model=vm.ticketObject.contactPhoneNumber ng-disabled=vm.connectwiseStatus></td></tr><tr><td>Board</td><td><ui-select ng-model=vm.ticketObject.board ng-change=vm.load_statuses(true) ng-disabled=vm.connectwiseStatus><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"board in vm.boards | filter:$select.search\">{{board.name}}</ui-select-choices></ui-select></td></tr><tr><td>Status</td><td><ui-select ng-model=vm.ticketObject.status ng-disabled=vm.connectwiseStatus><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"status in vm.statuses | filter:$select.search\">{{status.name}}</ui-select-choices></ui-select></td></tr><tr><td>Type</td><td><ui-select ng-model=vm.ticketObject.type ng-disabled=vm.connectwiseStatus><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type in vm.types | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></td></tr></tbody></table></div><div class=\"box-content border-groove col-sm-6\" cg-busy=\"{promise:vm.time_entry_load,delay:0,message:\'Loading Time Entries\'}\"><div class=table><table class=table width=100%><thead><th width=15%>Time Details</th><th><button class=\"btn btn-primary\" type=button ng-click=vm.openTime() ng-if=!vm.newTimeEntryObject ng-hide=vm.connectwiseStatus>Add Time</button></th><th><button class=\"btn btn-info\" type=button ng-click=vm.cancelNewTime() ng-if=vm.newTimeEntryObject>Cancel</button></th><th>Minutes on Ticket: {{vm.totalEntryTime}}</th></thead><tbody ng-if=vm.newTimeEntryObject><tr><td>Time Type</td><td><ui-select ng-model=vm.newTimeEntryObject.workType><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type in vm.timeTypes | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></td><td>Time Role</td><td><ui-select ng-model=vm.newTimeEntryObject.role><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"role in vm.timeRoles | filter:$select.search\">{{role.name}}</ui-select-choices></ui-select></td></tr><tr><td>Start Time</td><td><input datetime-picker ng-model=vm.newTimeEntryObject.timeStart.pickerFormat class=form-control></td><td>End Time <button class=\"btn btn-info\" type=button ng-click=\"vm.getNow(\'end\',\'new\')\"><i class=\"fa fa-clock-o\"></i></button></td><td><input datetime-picker ng-model=vm.newTimeEntryObject.timeEnd.pickerFormat class=form-control></td></tr><tr><td>Notes</td><td colspan=3><textarea class=\"msd-elastic: \\n;\" style=width:100% ng-model=vm.newTimeEntryObject.notes></textarea></td></tr><tr><td colspan=2><button class=\"btn btn-primary\" type=button ng-click=vm.timeEntryValid(vm.newTimeEntryObject)>Save Time</button></td></tr></tbody></table><table width=100% ng-repeat=\"(k,time_entry) in vm.time_entry_array\"><thead><th>Time Entries</th><th><button class=\"btn btn-primary\" type=button ng-click=vm.editTimeEntry(k) ng-hide=\"vm.connectwiseStatus || vm.userCheck(k)\">Edit</button></th><th>{{time_entry.enteredBy.name}}</th><th>Minutes: {{time_entry.entryTime}}</th></thead><tbody><tr><td>Start Time</td><td>{{time_entry.timeStart.viewFormat | date : \'MMM d, y h:mm:ss a\' : time_entry.tz_offset}}</td><td>End Time</td><td>{{time_entry.timeEnd.viewFormat | date : \'MMM d, y h:mm:ss a\' : time_entry.tz_offset}}</td></tr><tr><td>Work Role</td><td>{{time_entry.role.name}}</td><td>Work Type</td><td>{{time_entry.workType.name}}</td></tr><tr><td>Notes</td><td colspan=3>{{time_entry.notes}}</td></tr></tbody></table></div></div><div class=\"box-content border-groove col-sm-6\"><div class=table><table class=table width=100%><thead><th width=15%>Issue Details</th><th><button class=\"btn btn-primary\" type=button ng-click=vm.openIssue()>Add Issue</button></th><th>Unallocated Minutes on Ticket: {{vm.totalEntryTime - vm.totalAllocatedTime}}</th></thead><tbody ng-if=vm.newIssue><tr><td class=table_select_label>Class</td><td colspan=2><ui-select ng-model=vm.newOpenIssue.top_level.id ng-change=vm.loadSecondLevel($select.selected.id)><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"issue.id as issue in vm.top_level_issues | filter:$select.search\">{{issue.name}}</ui-select-choices></ui-select></td></tr><tr><td class=table_select_label>Issue / Action</td><td colspan=2><ui-select ng-model=vm.newOpenIssue.second_level.id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"issue.second_level_id as issue in vm.secondLevelList | filter:$select.search\">{{issue.name}}</ui-select-choices></ui-select></td></tr><tr><td class=table_select_label>Notes</td><td colspan=2><textarea class=\"msd-elastic: \\n;\" style=width:100% ng-model=vm.newOpenIssue.notes></textarea></td></tr><tr><td colspan=2><button class=\"btn btn-primary\" type=button ng-click=vm.issueEntryValid(vm.newOpenIssue)>Save Issue</button></td></tr></tbody></table><table class=\"table success-table\" width=100% ng-repeat=\"(k,issue) in vm.existingIssues\"><thead ng-click=vm.editIssue(k) style=\"cursor: pointer\"><th width=25% class=th-dark>{{issue.top_level.name}}</th><th width=25% class=th-dark>{{issue.second_level.name}}</th><th width=25% class=th-dark>{{issue.enteredBy.name}}</th><th width=25% class=th-dark></th></thead><tbody><tr><td colspan=4 class=new_lines>{{issue.notes}}</td></tr></tbody><thead><th>Details</th><th></th><th colspan=2><button class=\"btn btn-primary\" type=button ng-click=vm.addTimeToIssue(k)>Add Time</button></th></thead><tbody ng-repeat=\"(key,add_time) in issue.additional_times\" class=border-bottom-dark ng-class=\"{\'text-success bg-success\':add_time.fixed_issue}\" ng-class-odd=\"\'darker\'\" ng-class-even=\"\'lighter\'\" style=\"cursor: pointer\" ng-click=vm.editIssueTime(k,key)><tr><td>{{add_time.minutes}} Minutes</td><td>{{add_time.enteredBy.name}}</td><td>{{add_time.role.name}}</td><td>{{add_time.resolution.name}}</td></tr><tr><td colspan=4 class=new_lines>{{add_time.notes}}</td></tr><tr><td colspan=2>Used TV: <span ng-if=add_time.used_tv><i class=\"fa fa-check-square\"></i></span><span ng-if=!add_time.used_tv><i class=\"far fa-square\"></i></span></td><td colspan=2>Used Remote Supoort: <span ng-if=add_time.used_remote><i class=\"fa fa-check-square\"></i></span><span ng-if=!add_time.used_remote><i class=\"far fa-square\"></i></span></td></tr></tbody></table></div></div></div><div class=box ng-if=vm.editActive><div ng-if=vm.editTimeObject class=\"box-content border-groove col-sm-6\"><table class=table width=100%><thead><th width=15%>Time Details</th><th><button class=\"btn btn-primary\" type=button ng-click=vm.timeEntryValid(vm.editTimeObject)>Save Time Edit</button></th><th colspan=2><button class=\"btn btn-warning\" type=button ng-click=vm.cancelEdit()>Cancel</button></th></thead><tbody ng-if=vm.editTimeObject><tr><td>Time Type</td><td><ui-select ng-model=vm.editTimeObject.workType><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type in vm.timeTypes | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></td><td>Time Role</td><td><ui-select ng-model=vm.editTimeObject.role><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"role in vm.timeRoles | filter:$select.search\">{{role.name}}</ui-select-choices></ui-select></td></tr><tr><td>Start Time</td><td><input datetime-picker ng-model=vm.editTimeObject.timeStart.pickerFormat class=form-control></td><td>End Time <button class=\"btn btn-info\" type=button ng-click=\"vm.getNow(\'end\',\'edit\')\"><i class=\"fa fa-clock-o\"></i></button></td><td><input datetime-picker ng-model=vm.editTimeObject.timeEnd.pickerFormat class=form-control></td></tr><tr><td>Notes</td><td colspan=3><textarea class=\"msd-elastic: \\n;\" style=width:100% ng-model=vm.editTimeObject.notes></textarea></td></tr></tbody></table></div><div ng-if=vm.editIssueObject class=\"box-content border-groove col-sm-6\"><table class=table width=100%><thead><th width=15%>Issue Details</th><th><button class=\"btn btn-primary\" type=button ng-click=vm.issueEntryValid(vm.editIssueObject)>Save Time Edit</button></th><th colspan=2><button class=\"btn btn-warning\" type=button ng-click=vm.cancelEdit()>Cancel</button></th></thead><tbody ng-if=vm.editIssueObject><tr><td class=table_select_label>Class</td><td colspan=2><ui-select ng-model=vm.editIssueObject.top_level.id ng-change=vm.loadSecondLevel($select.selected.id,true)><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"issue.id as issue in vm.top_level_issues | filter:$select.search\">{{issue.name}}</ui-select-choices></ui-select></td></tr><tr><td class=table_select_label>Issue / Action</td><td colspan=2><ui-select ng-model=vm.editIssueObject.second_level.id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"issue.second_level_id as issue in vm.secondLevelList | filter:$select.search\">{{issue.name}}</ui-select-choices></ui-select></td></tr><tr><td class=table_select_label>Notes</td><td colspan=2><textarea class=\"msd-elastic: \\n;\" style=width:100% ng-model=vm.editIssueObject.notes></textarea></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/tasks/tasks.html","<div class=page-header><div class=row><div class=col-md-9><h1 class=page-title>Tasks and Requests</h1></div><div class=\"col-md-3 text-right\"><button class=\"btn btn-primary\" ng-click=vm.load_task()>Load Task</button> <button class=\"btn btn-success\" ng-click=vm.new()>Create New</button></div></div></div><div class=container-fluid><div class=\"row top5\"><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search For:</label></div><div class=col-sm-2><select class=form-control ng-model=vm.searchFor><option value=created_by/name>Requested By</option><option value=name>Task / Request Title</option><option value=priority/name>Priority</option><option value=type/name>Type</option><option value=owner/name>Current Owner</option></select></div><div class=col-sm-1><label class=\"pull-right top7\" for=\"\">Search:</label></div><div class=col-sm-3><input type=text class=form-control ng-model=vm.searchVal ng-keyup=\"$event.keyCode == 13 ? vm.load_data() : null\" ng-model-options=\"{debounce: 200}\"></div><div class=col-sm-1><button class=\"btn btn-success\" ng-click=vm.load_data()>Search</button></div><div class=col-sm-1><label class=\"pull-right top7\" for=show_amount>Show Rows:</label></div><div class=col-sm-1><input name=show_amount class=form-control type=number ng-model=vm.num_results></div><div class=col-sm-1><button class=\"btn btn-primary\" ng-click=vm.clear_filters()>Reset Filters</button></div></div><table class=\"table table-striped\"><thead><th ng-click=\"vm.sort_by=\'id\'; vm.sort_data()\">Task / Request ID <span ng-show=\"vm.sort_by == \'id\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'id\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th ng-click=\"vm.sort_by=\'notes\'; vm.sort_data()\">Task / Request Title <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'DESC\'\" class=\"fa fa-caret-down\"></span> <span ng-show=\"vm.sort_by == \'notes\' && vm.sort_order == \'ASC\'\" class=\"fa fa-caret-up\"></span></th><th>Current Owner</th><th>Next Action</th><th>Status</th><th>Type</th><th>Priority</th></thead><tbody><tr dir-paginate=\"(key,obj) in vm.data.data | itemsPerPage:vm.num_results\" current-page=vm.currentPage total-items=vm.data.count style=\"cursor: pointer\"><td ng-click=vm.openEdit(key)>{{obj.id}}</td><td ng-click=vm.openEdit(key)>{{obj.name}}</td><td ng-click=vm.openEdit(key)>{{obj.owner.name}}</td><td ng-click=vm.openEdit(key)>{{obj.next_action}}</td><td ng-click=vm.openEdit(key)>{{obj.status.name}}</td><td ng-click=vm.openEdit(key)>{{obj.type.name}}</td><td ng-click=vm.openEdit(key)>{{obj.priority.name}}</td></tr></tbody></table><div class=\"row page-tools\"><div class=col-md-6 style=margin-top:30px>Displaying {{vm.data.data.length}} of {{vm.data.count}} Results</div><div class=col-md-6><dir-pagination-controls class=pull-right style=margin:0 on-page-change=vm.load_data()></dir-pagination-controls></div></div></div>");
$templateCache.put("app/tasks/tasksEcr.html","<div class=page-header><div class=row><div class=col-md-9><h1 class=page-title>Tasks and Requests</h1></div><div class=\"col-md-3 text-right\"><!-- <button class=\"btn btn-primary\" ng-if=\"vm.submissionObj.id\" ng-click=\"vm.back()\">Back</button>\n			<button class=\"btn btn-success\" ng-if=\"!vm.submissionObj.id && !vm.new\" ng-click=\"vm.new=true\">New</button> --></div></div></div><div class=container-fluid><div class=row><div class=col-md-8 ng-if=!vm.expand_comments><!-- Header --><h3 class=\"text-center text-success top20\">TASK / REQUEST FORM</h3><div class=text-right style=\"margin-bottom: 10px\"><div style=\"display: inline-flex; align-items: center; gap: 8px\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.save_new() ng-if=!vm.submissionObj.id>Save</button><label style=\"margin: 0\">REQUEST ID:</label><input type=text class=\"form-control input-sm\" style=\"width:150px; display:inline-block\" ng-model=vm.submissionObj.id disabled><!-- Patch status indicator --><div class=patch-status-box ng-class=\"{\n						\'active\': !vm.isPatchDone(),\n						\'done\': vm.isPatchDone()\n						}\"><span ng-if=!vm.isPatchDone()>&times;</span> <span ng-if=vm.isPatchDone()>&#10003;</span></div></div></div><!-- Product Section --><h4>Product</h4><table class=\"table table-bordered\"><tbody><tr><td>Title (Short Description)</td><td colspan=3><input type=text class=form-control ng-model=vm.submissionObj.name ng-focus=\"vm.originalName = vm.submissionObj.name\" ng-change=\"vm.debouncedPatchTask(\'name\',vm.submissionObj.name, vm.originalName)\" ng-disabled=vm.general_input_disable()></td></tr><tr><td>Product Name</td><td><input type=text class=form-control ng-model=vm.submissionObj.product_name ng-focus=\"vm.originalProductName = vm.submissionObj.product_name\" ng-change=\"vm.debouncedPatchTask(\'product_name\',vm.submissionObj.product_name, vm.originalProductName)\" ng-disabled=vm.general_input_disable()></td><td>Part Number</td><td><input type=text class=form-control ng-model=vm.submissionObj.product_id ng-focus=\"vm.originalProductId = vm.submissionObj.product_id\" ng-change=\"vm.debouncedPatchTask(\'product_id\',vm.submissionObj.product_id, vm.originalProductId)\" ng-disabled=vm.general_input_disable()></td></tr><tr><td>Requested By</td><td ng-if=!vm.submissionObj.id><input type=text class=form-control value={{vm.get_user()}} disabled></td><td ng-if=vm.submissionObj.id><input type=text class=form-control value={{vm.submissionObj.created_by.name}} disabled></td><td>Status</td><td><ui-select ng-model=vm.submissionObj.status.id ng-change=\"vm.patch_task(\'status/id\',vm.submissionObj.status.id)\" ng-disabled=!vm.can_update_status()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"status.id as status in vm.status_options | filter:$select.search\">{{status.name}}</ui-select-choices></ui-select></td></tr><tr><td>Type</td><td><ui-select ng-model=vm.submissionObj.type.id ng-change=\"vm.patch_task(\'type/id\',vm.submissionObj.type.id)\" ng-disabled=vm.general_input_disable()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"type.id as type in vm.types | filter:$select.search\">{{type.name}}</ui-select-choices></ui-select></td><td>Priority</td><td><ui-select ng-model=vm.submissionObj.priority.id ng-change=\"vm.patch_task(\'priority/id\',vm.submissionObj.priority.id)\" ng-disabled=vm.general_input_disable()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"priority.id as priority in vm.priorities | filter:$select.search\">{{priority.name}}</ui-select-choices></ui-select></td></tr><tr><td>Component (Name and part number)</td><td colspan=3><input type=text class=form-control ng-model=vm.submissionObj.component ng-focus=\"vm.originalComponent = vm.submissionObj.component\" ng-change=\"vm.debouncedPatchTask(\'component\',vm.submissionObj.component, vm.originalComponent)\" ng-disabled=vm.general_input_disable()></td></tr><tr><td>Module/Feature</td><td colspan=3><input type=text class=form-control ng-model=vm.submissionObj.module ng-focus=\"vm.originalModule = vm.submissionObj.module\" ng-change=\"vm.debouncedPatchTask(\'module\',vm.submissionObj.module, vm.originalModule)\" ng-disabled=vm.general_input_disable()></td></tr><tr ng-if=\"vm.submissionObj.status.id >=3\"><td>Owns next action</td><td><ui-select ng-model=vm.submissionObj.owner.id ng-change=\"vm.patch_task(\'owner/id\',vm.submissionObj.owner.id)\" ng-disabled=vm.general_input_disable()><ui-select-match>{{$select.selected.user_full_name}} - ({{$select.selected.team.name}})</ui-select-match><ui-select-choices class=ui-select-choices repeat=\"user.user_id as user in vm.users | filter:$select.search\">{{user.user_full_name}} - ({{user.team.name}})</ui-select-choices></ui-select></td><td>Next Action</td><td><input type=text class=form-control ng-model=vm.submissionObj.next_action ng-focus=\"vm.originalNextAction = vm.submissionObj.next_action\" ng-change=\"vm.debouncedPatchTask(\'next_action\',vm.submissionObj.next_action, vm.originalNextAction)\" ng-disabled=vm.general_input_disable()></td></tr></tbody></table><!-- Request Section --><h4>Request</h4><div class=form-group><label>Description of the Requested Change</label><textarea class=form-control rows=3 ng-model=vm.submissionObj.description ng-focus=\"vm.originalDescription = vm.submissionObj.description\" ng-change=\"vm.debouncedPatchTask(\'description\',vm.submissionObj.description, vm.originalDescription)\" ng-disabled=vm.general_input_disable()>\n				</textarea></div><div class=form-group><label>Reason of the Requested Change</label><textarea class=form-control rows=3 ng-model=vm.submissionObj.reason ng-focus=\"vm.originalReason = vm.submissionObj.reason\" ng-change=\"vm.debouncedPatchTask(\'reason\',vm.submissionObj.reason, vm.originalReason)\" ng-disabled=vm.general_input_disable()>\n				</textarea></div><div class=form-group><label>QA Required</label><input type=checkbox ng-model=vm.submissionObj.qa_required ng-change=\"vm.patch_task(\'qa_required\',vm.submissionObj.qa_required)\" ng-disabled=vm.general_input_disable()></div><!-- Impact / Stock --><div class=form-group><label>Impact of Deliverables</label><input type=text class=form-control ng-model=vm.submissionObj.impact_of_deliverables ng-focus=\"vm.originalImpact = vm.submissionObj.impact_of_deliverables\" ng-change=\"vm.debouncedPatchTask(\'impact_of_deliverables\',vm.submissionObj.impact_of_deliverables, vm.originalImpact)\" ng-disabled=vm.general_input_disable()></div><div class=form-group><label>Disposition of Current Stock</label><input type=text class=form-control ng-model=vm.submissionObj.disposition_of_stock ng-focus=\"vm.originalDisposition = vm.submissionObj.disposition_of_stock\" ng-change=\"vm.debouncedPatchTask(\'disposition_of_stock\',vm.submissionObj.disposition_of_stock, vm.originalDisposition)\" ng-disabled=vm.general_input_disable()></div><!-- Cost / Documents --><div class=form-group><label>Cost Considerations</label><input type=text class=form-control ng-model=vm.submissionObj.cost_considerations ng-focus=\"vm.originalConsiderations = vm.submissionObj.cost_considerations\" ng-change=\"vm.debouncedPatchTask(\'cost_considerations\',vm.submissionObj.cost_considerations, vm.originalConsiderations)\" ng-disabled=vm.general_input_disable()></div><!-- <div class=\"form-group\">\n				<label>Included Documents</label>\n				<input type=\"text\" class=\"form-control\" ng-model=\"vm.submissionObj.included_documents\">\n			</div> --><div ng-if=\"vm.submissionObj.id && vm.admin_check() && vm.submissionObj.status.id == 1\" class=container><div class=row><!-- Available Users --><div class=col-sm-6><h4>Available Users</h4><ul dnd-list=vm.availableUsers dnd-drop=vm.onAvailableDrop(item) dnd-inserted=vm.onAvailableDrop(item) class=list-group><li ng-repeat=\"user in vm.availableUsers track by user.user.id\" dnd-draggable=user dnd-effect-allowed=move class=list-group-item>{{user.user.name}} - ({{user.user.team}})</li></ul></div><!-- Approvers --><div class=col-sm-6><h4>Approvers</h4><ul dnd-list=vm.approvers dnd-drop=vm.onApproverDrop(item) dnd-inserted=vm.onApproverDrop(item) class=list-group><li ng-repeat=\"user in vm.approvers track by user.user.id\" dnd-draggable=user dnd-effect-allowed=move class=list-group-item>{{user.user.name}} - ({{user.user.team}})</li></ul></div></div></div><div ng-if=\"(vm.submissionObj.id && vm.admin_check() && vm.submissionObj.status.id == 2) || (vm.submissionObj.id && vm.user_in_approval() && vm.submissionObj.status.id == 2)\" class=container><div class=approver-grid><div class=approver-item ng-repeat=\"user in vm.approvers\"><label>{{user.user.name}}</label><input class=form-control type=checkbox ng-model=user.approved ng-change=\"vm.patch_approval(\'approved\',user.user.id,user.approved)\" ng-disabled=!vm.user_check(user.user.id)> <button class=\"btn btn-danger\" ng-click=vm.onAvailableDrop(user) ng-disabled=\"user.approved || !vm.admin_check()\"><i class=\"fa fa-trash text-danger marg-right\"></i></button></div></div></div></div><!-- Place this on the update page, but not new :)--><div class=col-md-4 ng-if=\"vm.submissionObj.id && !vm.expand_comments\"><h3 class=\"text-center text-success\" style=margin-top:20px>Notes and Audits</h3><div class=col-md-12><button class=\"btn btn-primary bottom7\" ng-click=\"vm.comment_open=true\" ng-if=\"!(vm.comment_open || vm.submissionObj.status.id == 4 || vm.submissionObj.status.id == 5)\">Add Comment</button> <button class=\"btn bottom7 pull-right\" ng-click=\"vm.expand_comment_press(\'y\')\"><i class=\"fa fa-expand\"></i></button><textarea class=form-control rows=3 ng-if=vm.comment_open ng-model=vm.comment>\n				</textarea><button class=\"btn btn-primary\" ng-click=vm.add_comment() ng-if=\"vm.comment_open && vm.comment\">Save Comment</button></div><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"row in vm.audit_data\"><td>{{vm.formatDate(row.date_created)}}</td><td>{{row.action}}</td><td>{{row.changed_by.name}}</td><td ng-bind-html=vm.utils.renderNewlines(row.comment)></td></tr></tbody></table></div><div class=col-md-12 ng-if=\"vm.submissionObj.id && vm.expand_comments\"><h3 class=\"text-center text-success\" style=margin-top:20px>Notes and Audits</h3><div class=col-md-12><button class=\"btn btn-primary bottom7\" ng-click=\"vm.comment_open=true\" ng-if=\"!(vm.comment_open || vm.submissionObj.status.id == 4 || vm.submissionObj.status.id == 5)\">Add Comment</button> <button class=\"btn bottom7 pull-right\" ng-click=\"vm.expand_comment_press(\'n\')\"><i class=\"fa fa-expand\"></i></button><textarea class=form-control rows=3 ng-if=vm.comment_open ng-model=vm.comment>\n				</textarea><button class=\"btn btn-primary\" ng-click=vm.add_comment() ng-if=\"vm.comment_open && vm.comment\">Save Comment</button></div><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"row in vm.audit_data\"><td>{{vm.formatDate(row.date_created)}}</td><td>{{row.action}}</td><td>{{row.changed_by.name}}</td><td ng-bind-html=vm.utils.renderNewlines(row.comment)></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/directiveNavbar/navbar.html","<div id=navigation><div class=container-fluid><a href=# class=\"toggle-mobile hidden-md hidden-lg hidden-sm\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><i class=\"fa fa-bars\"></i> </a><a href=/ id=brand><em>NEW</em> PORTAL</a><!-- Left Main Menu --><ul class=\"main-nav hidden-xs\"><li uib-dropdown ng-repeat=\"topNav in vm.navItems.leftNavigationItems\"><!-- Conditionally apply the dropdown-toggle directive if subnav presented --> <a ng-if=topNav.subNav uib-dropdown-toggle href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span> </a><a ng-if=!topNav.subNav href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span></a><ul ng-if=topNav.subNav uib-dropdown-menu ng-if=topNav.subNav class=dropdown-menu><li ng-repeat=\"item in topNav.subNav\" ng-class=\"{\'dropdown-submenu\': item.flyout}\"><a ng-href=\"{{ item.link }}\">{{item.name}}</a><ul ng-if=item.flyout class=dropdown-menu><li ng-repeat=\"flyoutItem in item.flyout\"><a ng-href=\"{{ flyoutItem.link }}\">{{ flyoutItem.name }}</a></li></ul></li></ul></li></ul><!-- End Left Main Menu --><!-- Right User Menu --><div class=user><ul class=icon-nav><li uib-dropdown=topNav.subNav on-toggle=toggled(open) ng-repeat=\"topNav in vm.navItems.rightNavigationItems\"><a uib-dropdown-toggle=topNav.subNav ng-href=\"{{ topNav.link }}\"><i ng-if=topNav.icon ng-class=topNav.icon></i> <span ng-if=topNav.name>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span></a><ul ng-if=topNav.subNav uib-dropdown-menu class=\"dropdown-menu pull-right theme-settings\"><li ng-repeat=\"item in topNav.subNav\"><a ng-href={{item.link}} ng-click=item.function()>{{item.name}}</a></li></ul></li></ul></div></div><!-- End Right User Menu --><!-- Mobile Navigation --><div class=\"hidden-md hidden-lg hidden-sm\"><div class=\"collapse navbar-collapse\" ng-class=\"!navCollapsed && \'in\'\"><ul class=\"mobile-nav open\"><li uib-dropdown ng-repeat=\"topNav in vm.navItems.leftNavigationItems\"><!-- Conditionally apply the dropdown-toggle directive if subnav presented --> <a ng-if=topNav.subNav uib-dropdown-toggle href=\"{{ topNav.link }}\" ng-click=\"vm.openMobileNav = topNav.subNav\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span> </a><a ng-if=!topNav.subNav href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span></a><ul ng-if=topNav.subNav ng-if=topNav.subNav ng-class=\"{\'open\': vm.openMobileNav == topNav.subNav}\"><li ng-repeat=\"item in topNav.subNav\"><a ng-href=\"{{ item.link }}\">{{item.name}}</a><ul ng-if=item.flyout><li ng-repeat=\"flyoutItem in item.flyout\"><a ng-href=\"{{ flyoutItem.link }}\">{{ flyoutItem.name }}</a></li></ul></li></ul></li></ul><!-- End Left Main Menu --></div></div></div>");}]);